import tt, { defineComponent as At, ref as gn, onMounted as vn } from "vue";
import { SmartComponent as re, Feature as Oe, KeyboardController as yn, MouseController as ur, PointerState as dr, Vec3 as Xe, Geometry as Dt, RequestFullscreenFeatureEVENT as us, RequestFullscreenFeatureFactory as En } from "@imaios-js/im-jsdk";
import Ut from "sha256";
import In from "jszip";
import hr from "vuex";
import Et from "crypto-js";
import mr from "vue-i18n";
import Cn from "ua-parser-js";
function S(s, e, t, i, r, n, a, o) {
  var l = typeof s == "function" ? s.options : s;
  return e && (l.render = e, l.staticRenderFns = t, l._compiled = !0), n && (l._scopeId = "data-v-" + n), {
    exports: s,
    options: l
  };
}
const _n = {
  name: "PinSVG"
};
var Tn = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" } }, [t("path", { attrs: { fill: "currentColor", "fill-rule": "evenodd", d: "M11.98 21.97c.42 0 .75-.34.76-.75v-6.06h5.4c.45 0 .79-.41.71-.86a7.34 7.34 0 0 0-1.56-3.38 64.23 64.23 0 0 1-2.3-2.89V4.6l1.5-.86a.91.91 0 0 0-.45-1.7H7.9a.9.9 0 0 0-.44 1.7l1.53.86v3.44c-.2.27-1.37 1.74-2.3 2.9a7.59 7.59 0 0 0-1.51 3.33c-.09.47.27.9.74.9h5.34l-.01 6.06c0 .41.33.75.74.75Zm5.15-8.31a5.87 5.87 0 0 0-1-1.79c-.83-1-1.7-2.06-2.47-3.12a1.5 1.5 0 0 1-.18-.72V4.6c0-.4.17-.78.44-1.06h-3.88c.28.28.44.66.44 1.06v3.44c0 .33-.1.65-.3.9-.22.3-1.4 1.79-2.32 2.94a6.1 6.1 0 0 0-.98 1.79h10.25Z", "clip-rule": "evenodd" } })]);
}, Sn = [], bn = /* @__PURE__ */ S(
  _n,
  Tn,
  Sn,
  !1,
  null,
  "91c8383b"
);
const wi = bn.exports, nt = "__v-click-outside", fr = typeof window < "u", An = typeof navigator < "u", wn = fr && ("ontouchstart" in window || An && navigator.msMaxTouchPoints > 0), Ln = wn ? ["touchstart", "pointerdown"] : ["mousedown"];
function On(s) {
  const e = typeof s == "function";
  if (!e && typeof s != "object")
    throw new Error("v-click-outside: Binding value must be a function or an object");
  return {
    handler: e ? s : s.handler,
    middleware: s.middleware || ((t) => t),
    events: s.events || Ln,
    isActive: s.isActive !== !1,
    detectIframe: s.detectIframe !== !1,
    capture: !!s.capture
  };
}
function pr({
  event: s,
  handler: e,
  middleware: t
}) {
  t(s) && e(s);
}
function Mn({
  el: s,
  event: e,
  handler: t,
  middleware: i
}) {
  setTimeout(() => {
    const { activeElement: r } = document;
    r && r.tagName === "IFRAME" && !s.contains(r) && pr({
      event: e,
      handler: t,
      middleware: i
    });
  }, 0);
}
function Nn({
  el: s,
  event: e,
  handler: t,
  middleware: i
}) {
  const r = e.path || e.composedPath && e.composedPath();
  (r ? r.indexOf(s) < 0 : !s.contains(e.target)) && pr({
    event: e,
    handler: t,
    middleware: i
  });
}
function gr(s, { value: e }) {
  const {
    events: t,
    handler: i,
    middleware: r,
    isActive: n,
    detectIframe: a,
    capture: o
  } = On(e);
  if (n) {
    if (s[nt] = t.map((l) => ({
      event: l,
      srcTarget: document.documentElement,
      handler: (c) => Nn({
        el: s,
        event: c,
        handler: i,
        middleware: r
      }),
      capture: o
    })), a) {
      const l = {
        event: "blur",
        srcTarget: window,
        handler: (c) => Mn({
          el: s,
          event: c,
          handler: i,
          middleware: r
        }),
        capture: o
      };
      s[nt] = [...s[nt], l];
    }
    s[nt].forEach(({
      event: l,
      srcTarget: c,
      handler: u
    }) => setTimeout(() => {
      s[nt] && c.addEventListener(l, u, o);
    }, 0));
  }
}
function vr(s) {
  (s[nt] || []).forEach(({
    event: t,
    srcTarget: i,
    handler: r,
    capture: n
  }) => i.removeEventListener(t, r, n)), delete s[nt];
}
function Rn(s, { value: e, oldValue: t }) {
  JSON.stringify(e) !== JSON.stringify(t) && (vr(s), gr(s, { value: e }));
}
const xn = {
  bind: gr,
  update: Rn,
  unbind: vr
}, De = fr ? xn : {}, Li = "...", Ve = " ", It = 0.1, Tt = 64, Oi = 5, Dn = "'Helvetica Neue', Helvetica, arial, verdana, 'lucida sans unicode', tahoma, sans-serif", ci = Math.PI / 180, yr = -1, ct = {
  STANDARD: "standard",
  QUIZ: "quiz-index",
  PIN: "pin"
}, he = {
  SCHEMA: 1,
  RX: 2,
  CT: 3,
  IRM: 4,
  RX2: 7,
  XA2: 8,
  PHOTOGRAPHY: 11,
  PHOTOGRAPHY_X2: 13
}, vs = {
  CODES: {
    CENTER: 1,
    END: 2,
    JUSTIFY: 3,
    LEFT: 4,
    RIGHT: 5,
    START: 6
  },
  1: "center",
  2: "end",
  3: "justify",
  4: "left",
  5: "right",
  6: "start"
}, Y = {
  SLICE: "slice",
  OVERLAY: "overlay",
  CROSS_REFERENCES: "cross-reference",
  THUMBNAILS: "thumbnails",
  BOTTOM_PREVIEW_SLICE: "bottom-preview-slice",
  GALLERY_THUMB: "gallery-thumb"
}, Pt = {
  HIGH: 90
}, dt = {
  LOWEST: -1,
  LOW: 50,
  HIGH: 75
}, ys = {
  LOW: 0.5,
  HIGH: 1
}, Pn = 30, me = {
  WHITE: "FFFFFF",
  BLACK: "000000",
  RED: "FF0000",
  IMAIOS: "3DA8FE"
}, Mi = {
  DPX_2: 2,
  DPX_1: 1
}, pe = "contraste_", Ni = {
  name: "anatomie-generale",
  version: 1
}, Er = {
  id: -1,
  name_id: -1,
  series_id: -1,
  imaios_code: pe,
  sort_order: -1
}, Ir = {
  STANDARD: "standard",
  SLOW: "slow"
}, Qe = {
  FORWARD: 1,
  BACKWARD: -1
}, kn = (s) => s, Ri = 0.7, xi = {
  ANDROID: "Android",
  IOS: "iOS"
}, ke = {
  ZOOM: "zoom",
  PAN: "pan",
  SCROLL: "scroll"
}, wt = {
  LEFT_CLICK: 0,
  MIDDLE_CLICK: 1,
  RIGHT_CLICK: 2
}, ts = {
  LEFT: 5,
  RIGHT: 5,
  BOTTOM: 5,
  TOP: 0
}, Hn = 2, ds = {
  width: 22,
  height: 31
}, Fn = "data:image/svg+xml;base64,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", zn = "data:image/svg+xml;base64,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", ss = "'Open Sans', sans-serif", Bn = "#A0A6AB", $n = 5, Un = 25, Vn = 30, Gn = 0.15, jn = "back_forward", fs = "faaeb9be3bd98ed09f606fc16d144eca", Yn = "update-anatomy-user-id", Wn = "update-anatomy-user-access", Ae = {
  full_match: 999,
  word_match: 2,
  name: 20,
  latin_name: 10,
  legacy_eponym: 2,
  synonym: 2,
  acronym: 2,
  patronym: 2,
  fr_anc: 2,
  latin_synonym: 1,
  latin_acronym: 1,
  latin_patronym: 1
}, Me = {
  MAIN: 1,
  DEPRECATED_MAIN: 59,
  DEPRECATED: 60
}, Ge = {
  1: 1,
  2: 2,
  NAV: 4,
  HUMAN_NEUROLOGY: 5
}, Mt = {
  device: "device",
  signature: "s",
  expire: "expires"
}, Di = {
  device: "imagix-device",
  signature: "imagix-sig"
}, Zn = "https://i4.imaios.com", Es = {
  AVIF: "image/avif",
  DEFAULT: "image/jpeg,image/png"
}, kt = {
  FREE: "free",
  PREMIUM: "premium"
}, Xn = "imaios-user-information", Qn = {
  eanatomy: "prd_eanat",
  vetanatomy: "prd_vet"
}, Je = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
}, Q = {
  THEME: "im_viewer-theme",
  OVERLAY: "im_viewer-overlay-opacity",
  LANGUAGE: "im_viewer-language",
  LAST_SITE_ACCESS: "im_viewer-last-site-access",
  CROSS_REFERENCES: "im_viewer-cross-references",
  IMAGE_HIGH_QUALITY: "im_viewer-image-high-quality",
  ORIENTATION: "im_viewer-widget-orientation",
  FONT_SIZE: "im_viewer-font-size",
  PIN_MODE: "im_viewer-pin-mode",
  MENU_OPEN: "im_viewer-menu-open",
  REVERSE_SCROLL: "im_viewer-reverse-scroll",
  LAST_SLICE_SEEN: "im_viewer_last_slice_seen"
}, Pi = [
  he.SCHEMA
], Kn = [
  he.SCHEMA
], Cr = 20, qn = 40 + Cr, Jn = 45 + Cr, ea = 135, at = {
  DARK: "dark",
  LIGHT: "light"
}, ki = {
  WHITE: "#FFFFFF",
  BLACK: "#000000"
}, Is = "NO_MASK", Nt = {
  CLIENT_URL: "IMAIOS_API_CLIENT_URL",
  CLIENT_USERID: "IMAIOS_API_CLIENT_USERID",
  CLIENT_TIMESTAMP: "IMAIOS_API_CLIENT_TIMESTAMP",
  CLIENT_TOKEN: "IMAIOS_API_CLIENT_TOKEN",
  KEY: "IMAIOS_API_KEY"
}, Be = {
  DESKTOP: 1920,
  LAPTOP: 1280,
  LARGE_TABLET: 1024,
  TABLET: 730,
  MOBILE: 480,
  SMALL_MOBILE: 320
}, _r = "data:image/png;base64,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", Hi = "application/json", ta = "https://www.imaios.com", ui = {
  // ERROR CODE: 1-100 -> network error
  // ERROR CODE: 400-499 -> data error
  MODULE: 101,
  THUMBS: 102,
  POINTS: 103,
  SERIES: 104,
  ORIENTATION: 105,
  TRANSLATIONS: 106,
  UI_TRANSLATIONS: 107,
  CONTRAST: 108,
  SLICES: 109,
  ICONS: 110,
  STRUCTURES: 111,
  FILTERS: 112,
  IMAGES: 113,
  STRUCTURE_DETAILS: 114,
  STRUCTURE_DETAILS_GALLERY: 115,
  SERIES_DOESNT_HAVE_SLICES: 404
}, Cs = "en", Fi = {
  ANIMAL: "animal",
  HUMAN: "human"
}, sa = "data:image/jpeg;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
class ia {
  constructor(e = {}) {
    this.name_id = e.name_id, this.sort_order = e.sort_order, this.icon_id = e.icon_id, this.children = e.children, this.layer = e.layer || null, this.category = e.category, this.id = e.id, this.defaultActive = e.active;
  }
}
const zi = (s) => Object.freeze(new ia(s));
class yi {
  constructor(e = {}) {
    this.availables = e.container || {};
  }
}
class ra extends Error {
  constructor(e, t) {
    let i;
    typeof e == "object" ? i = JSON.stringify(e) : i = String(e).toString(), super(`The resource "${i}" is not a valid entry for the collection "${t}".`), this.name = this.constructor.name;
  }
}
class Ei {
  isAvailable = !1;
  constructor() {
    this.isAvailable = Ei.checkIsAvailable();
  }
  // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available/16427747#16427747
  static checkIsAvailable() {
    const e = "test";
    try {
      return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
    } catch {
      return !1;
    }
  }
  add(e, t) {
    if (this.isAvailable) {
      const i = this.get(e);
      i !== null && typeof i == "object" && (t = { ...i, ...t }), localStorage.setItem(e, JSON.stringify(t));
    }
  }
  get(e) {
    if (this.isAvailable)
      try {
        const t = localStorage.getItem(e);
        return JSON.parse(t) ?? null;
      } catch {
        return null;
      }
  }
  remove(e, t = null) {
    if (this.isAvailable)
      if (t !== null) {
        const i = this.get(e);
        typeof i == "object" && i !== null ? (delete i[t], Object.keys(i).length === 0 ? localStorage.removeItem(e) : localStorage.setItem(e, JSON.stringify(i))) : localStorage.removeItem(e);
      } else
        localStorage.removeItem(e);
  }
}
const G = new Ei(), Tr = (s = 0, e = 1, t = "0") => (typeof s != "string" && (s = s.toString(10)), s.length >= e ? s : new Array(e - s.length + 1).join(t) + s), Sr = (s, e = "image/jpg") => {
  const t = self.URL || self.webkitURL || self, i = new Blob([s], { type: e });
  return t.createObjectURL(i);
}, We = (s) => {
  s.charAt(0) === "#" && (s = s.substr(1));
  const e = { r: 0, g: 0, b: 0 }, t = parseInt(s, 16);
  return e.r = t >> 16, e.g = t >> 8 & 255, e.b = t & 255, e;
}, na = (s, e) => {
  const { r: t, g: i, b: r } = We(s);
  return `rgba(${t},${i},${r},${e})`;
}, aa = (s, e = "") => {
  const t = e.split(".");
  let i = s, r = s, n = !0, a = 0;
  for (; a < t.length && n; ) {
    const o = t[a];
    typeof i[o] < "u" ? (r = i, i = i[o]) : n = !1, a++;
  }
  return n === !1 ? null : r[t[a - 1]];
};
function te(s = {}) {
  return {
    alias: s.instanceAlias,
    create(e, t) {
      let i;
      const r = s.parameters;
      Array.isArray(r) ? i = r : typeof r == "object" ? i = { ...e, ...r } : typeof r > "u" ? i = { ...e } : i = r;
      let n = null;
      if (typeof t == "function" && (n = t(s, i, e)), n === null)
        try {
          n = new s.InstanceType(i);
        } catch (o) {
          throw console.error(o), console.log({ ...s }), `Unable to create instance of ${s.instanceAlias}`;
        }
      const a = s.instanceAlias;
      if (a.length > 0) {
        const o = a.split(".");
        let l = e, c = null, u = "";
        o.forEach((m) => {
          typeof l[m] > "u" && (l[m] = {}), c = l, l = l[m], u = m;
        }), c[u] = n;
      }
      return n;
    }
  };
}
function le(s) {
  const e = new re({ name: `wait-until-${s.map((t) => t.name).join("-and-")}` });
  return new Promise((t) => {
    Promise.all(
      s.map((i) => new Promise((r) => {
        e.subscribe(
          i.from,
          i.name,
          r
        );
      }))
    ).then((i) => {
      try {
        e.destroy();
      } catch (r) {
        console.error(r);
      }
      t(i);
    });
  });
}
function oa() {
  return h.getSiteAccess();
}
function ye(s) {
  if (s === null || typeof s > "u")
    return null;
  const e = [
    { base: "AA", letters: "Ꜳ" },
    { base: "aa", letters: "ꜳ" },
    { base: "AE", letters: "ÆǼǢ" },
    { base: "ae", letters: "æǽǣ" },
    { base: "AO", letters: "Ꜵ" },
    { base: "ao", letters: "ꜵ" },
    { base: "AU", letters: "Ꜷ" },
    { base: "au", letters: "ꜷ" },
    { base: "AV", letters: "ꜸꜺ" },
    { base: "av", letters: "ꜹꜻ" },
    { base: "AY", letters: "Ꜽ" },
    { base: "ay", letters: "ꜽ" },
    { base: "db", letters: "ȸ" },
    { base: "DZ", letters: "ǱǄ" },
    { base: "Dz", letters: "ǲǅ" },
    { base: "dz", letters: "ǳǆʣ" },
    { base: "dʑ", letters: "ʥ" },
    { base: "dʒ", letters: "ʤ" },
    { base: "ff", letters: "ﬀ" },
    { base: "fi", letters: "ﬁ" },
    { base: "fl", letters: "ﬂ" },
    { base: "ffi", letters: "ﬃ" },
    { base: "ffl", letters: "ﬄ" },
    { base: "hv", letters: "ƕ" },
    { base: "IJ", letters: "Ĳ" },
    { base: "ij", letters: "ĳ" },
    { base: "LJ", letters: "Ǉ" },
    { base: "lj", letters: "ǈǉ" },
    { base: "lʒ", letters: "ɮ" },
    { base: "NJ", letters: "Ǌ" },
    { base: "Nj", letters: "ǋ" },
    { base: "nj", letters: "ǌ" },
    { base: "OE", letters: "Œ" },
    { base: "oe", letters: "œ" },
    { base: "ᴏᴇ", letters: "ɶ" },
    { base: "ɔe", letters: "ꭢ" },
    { base: "OI", letters: "Ƣ" },
    { base: "oi", letters: "ƣ" },
    { base: "OO", letters: "Ꝏ" },
    { base: "oo", letters: "ꝏ" },
    { base: "OU", letters: "Ȣ" },
    { base: "ou", letters: "ȣ" },
    { base: "qp", letters: "ȹ" },
    { base: "st", letters: "ﬆ" },
    { base: "ſt", letters: "ﬅ" },
    { base: "TZ", letters: "Ꜩ" },
    { base: "tz", letters: "ꜩ" },
    { base: "tɕ", letters: "ʨ" },
    { base: "ts", letters: "ʦ" },
    { base: "tʃ", letters: "ʧ" },
    { base: "ue", letters: "ᵫ" },
    { base: "uo", letters: "ꭣ" },
    { base: "VY", letters: "Ꝡ" },
    { base: "vy", letters: "ꝡ" },
    { base: "ıь", letters: "ꭠ" },
    { base: "ıe", letters: "ꭡ" },
    { base: "ſs", letters: "ẞß" },
    { base: "et", letters: "&" }
  ];
  return typeof s.normalize == "function" ? la(s.normalize("NFD"), e).replace(/[\u0300-\u036f]/g, "") : s;
}
function la(s, e) {
  let t = {};
  for (const { letters: i, base: r } of e)
    for (const n of i)
      t[n] = r;
  return s.replace(/[^\u0000-\u007E]/g, (i) => t[i] || i);
}
function ca(s) {
  if (typeof s != "string" || s.indexOf("=") < 0)
    return {};
  const e = s.split("?");
  let t;
  e.length < 2 ? t = e[0] : t = e[1];
  const i = {};
  return t.split("&").forEach((r) => {
    const n = r.split("=");
    if (n[0].length > 0 && n[1].length > 0)
      try {
        i[n[0]] = JSON.parse(decodeURIComponent(n[1]));
      } catch {
        i[n[0]] = decodeURIComponent(n[1]);
      }
  }), i;
}
function Bi(s, e) {
  let t = !0;
  return Object.keys(s).forEach((r) => {
    const n = s[r];
    e.hasOwnProperty(r) ? typeof n < "u" && Array.isArray(n.$in) ? t = t && n.$in.indexOf(e[r]) >= 0 : typeof n < "u" && Array.isArray(n.$or) ? t = t && n.$or.some((a) => a === e[r]) : typeof e[r] < "u" && e[r] === n ? t = t && !0 : t = !1 : t = !1;
  }), t;
}
function ua(s, e, t) {
  return Math.max(e, Math.min(s, t));
}
function da(s, e, t, i, r, n, a, o) {
  if (typeof n > "u" && (n = 5), typeof n == "number")
    n = { tl: n, tr: n, br: n, bl: n };
  else {
    const l = { tl: 0, tr: 0, br: 0, bl: 0 };
    for (const c in l)
      n[c] = n[c] || l[c];
  }
  s.beginPath(), s.moveTo(e + n.tl, t), s.lineTo(e + i - n.tr, t), s.quadraticCurveTo(e + i, t, e + i, t + n.tr), s.lineTo(e + i, t + r - n.br), s.quadraticCurveTo(e + i, t + r, e + i - n.br, t + r), s.lineTo(e + n.bl, t + r), s.quadraticCurveTo(e, t + r, e, t + r - n.bl), s.lineTo(e, t + n.tl), s.quadraticCurveTo(e, t, e + n.tl, t), s.closePath(), s.fill();
}
function $i(s) {
  return `<strong>${s}</strong>`;
}
async function ha(s) {
  let e = G.get(Xn);
  if (e === null) {
    if (typeof window.imaios.pubsub > "u")
      return console.warn("Can't load user access!"), kt.FREE;
    e = (await window.imaios.pubsub.waitUntil([{
      from: window.imaios.pubsub,
      name: Wn
    }]))[0];
  }
  return e !== null && typeof e?.access[Qn[s]] < "u" ? kt.PREMIUM : kt.FREE;
}
class ht extends Error {
  constructor(e, t) {
    super(`Resource with id "${e}" was not found in "${t}".`), this.name = this.constructor.name;
  }
}
class _s extends Error {
  constructor(e) {
    let t;
    typeof e == "object" ? t = JSON.stringify(e) : t = String(e).toString(), super(`The argument "${t}" is not a valid argument.`), this.name = this.constructor.name;
  }
}
class Vt extends re {
  constructor(e = {}) {
    super(e), typeof e.resources < "u" ? this.data.resources = e.resources : this.data.resources = new yi();
  }
  isAvailable(e) {
    return this.findById(e) !== null;
  }
  addResource(e, t = null) {
    if (typeof e != "object" || e === null || typeof e.id > "u" && t === null)
      throw new ra(e, this.getType());
    t === null && (t = e.id), this.data.resources.availables[t] = e;
  }
  findById(e) {
    if (typeof e != "string" && typeof e != "number" && typeof e == "number" && isNaN(e))
      throw new _s(e);
    return this.data.resources.availables[e] || null;
  }
  updateById(e, t) {
    const i = this.findById(e);
    if (i === null)
      throw new ht(e, this.getType());
    for (const r in t)
      t.hasOwnProperty(r) === !0 && i.hasOwnProperty(r) === !0 && (i[r] = t[r]);
  }
  getResources() {
    return this.data.resources.availables;
  }
  findOne(e = {}) {
    if (typeof e != "object" || e === null || Object.keys(e).length === 0)
      throw new _s(e);
    const t = Object.values(this.getResources());
    let i = null, r = 0;
    for (; i === null && r < t.length; ) {
      const n = t[r];
      Bi(e, n) === !0 ? i = n : r++;
    }
    return i;
  }
  find(e = {}) {
    if (typeof e != "object" || e === null || Object.keys(e).length === 0)
      throw new _s(e);
    return Object.values(this.getResources()).filter((i) => Bi(e, i));
  }
  getType() {
    return "ResourceManager";
  }
}
class br extends Vt {
  constructor(e = {}) {
    super(e), this.data.resources.current_id = /* @__PURE__ */ new Set();
  }
  /**
      * @param {string | number} resource_id
      * @return {boolean}
      */
  isSelected(e) {
    return typeof e == "number" && (e = e.toString(10)), this.data.resources.current_id.has(e);
  }
  getCurrent() {
    return Array.from(this.data.resources.current_id);
  }
  toggle(e) {
    return this.isSelected(e) ? (this.unselect(e), !1) : (this.select(e), !0);
  }
  /**
      * @param {String | number} resource_id
     * @param {boolean} [mute=false] silences the onSelect action
      */
  select(e, t = !1) {
    if (typeof e == "number" && (e = e.toString(10)), this.findById(e) === null)
      throw new ht(e, this.getType());
    this.data.resources.current_id.add(e), t !== !0 && this.onSelect(e);
  }
  onSelect(e) {
  }
  /**
      * @param {String | number} resource_id
     * @param {boolean} [mute=false] silences the onUnselect action
      */
  unselect(e, t = !1) {
    if (typeof e == "number" && (e = e.toString(10)), !this.data.resources.current_id.has(e))
      throw new ht(e, this.getType());
    this.data.resources.current_id.delete(e), t !== !0 && this.onUnselect(e);
  }
  onUnselect(e) {
  }
  selectAll() {
    Object.keys(this.data.resources.availables).forEach((t) => {
      this.select(t, !0);
    });
  }
  unselectAll() {
    this.data.resources.current_id.clear();
  }
  getType() {
    return "SelectableMultiplesResourceManager";
  }
}
class se extends br {
  constructor(e) {
    super({
      /** @type {FilterState} **/
      resources: e.state.filter,
      ...e
    });
  }
  addResource(e, t) {
    super.addResource(e, t), this.publish(se.EVENT.ADDED, t);
  }
  onSelect(e) {
    this.publish(se.EVENT.SELECTED, e);
  }
  onUnselect(e) {
    this.publish(se.EVENT.UNSELECTED, e);
  }
  selectAll() {
    super.selectAll(), this.publish(se.EVENT.SELECTED, se.ALL_FILTERS);
  }
  unselectAll() {
    super.unselectAll(), this.publish(se.EVENT.UNSELECTED, se.ALL_FILTERS);
  }
  parse(e) {
    e.forEach((t) => {
      let i = 1;
      t.children = t.children.map((r) => {
        const n = zi(r);
        return this.addResource(n, n.id), n.defaultActive === 0 && (i = 0), n;
      }), t.children.length > 0 && (t.active = i), this.addResource(zi(t), t.id), t.isChild || this.data.resources.main_id.add(t.id);
    }), this.data.resources.default_id = new Set(this.data.resources.current_id), this.onFilterLoaded(), this.publish(se.EVENT.LOADED, Array.from(this.data.resources.main_id));
  }
  onFilterLoaded() {
    this.applyDefaultSettings();
  }
  applyDefaultSettings() {
    this.unselectAll();
    const e = this.getResources();
    Object.values(e).forEach((t) => {
      this.resetFilter(t);
    });
  }
  resetFilter(e) {
    this.hasRightState(e) || (e.defaultActive === 1 ? this.select(e.id) : this.unselect(e.id)), Array.isArray(e.children) && e.children.forEach((t) => {
      this.resetFilter(t);
    });
  }
  hasRightState(e) {
    const t = this.isSelected(e.id);
    return t && e.defaultActive === 1 || !t && e.defaultActive === 0;
  }
  getType() {
    return "Filter";
  }
}
se.EVENT = {
  ADDED: "filter-added",
  SELECTED: "filter-selected",
  UNSELECTED: "filter-unselected",
  LOADED: "filters-loaded"
};
se.ALL_FILTERS = "all";
class Ue extends Vt {
  constructor(e = {}) {
    super(e), typeof this.data.resources.current_id > "u" && (this.data.resources.current_id = null), typeof this.data.resources.default_id > "u" && (this.data.resources.default_id = null);
  }
  setDefault(e) {
    if (this.isAvailable(e))
      this.data.resources.default_id = e;
    else
      throw new ht(e, this.getType());
  }
  getDefault() {
    return this.data.resources.default_id;
  }
  setCurrent(e) {
    if (this.isAvailable(e))
      this.data.resources.current_id = e;
    else
      throw new ht(e, this.getType());
  }
  getCurrent() {
    return this.data.resources.availables[this.data.resources.current_id] || null;
  }
  getCurrentId() {
    return this.data.resources.current_id;
  }
  hasContent() {
    return this.getCurrent() !== null;
  }
  isCurrent(e) {
    return this.getCurrentId() === e;
  }
  getType() {
    return "SelectableOnePerOneResourceManager";
  }
}
class Ce extends Ue {
  constructor(e) {
    super({
      /** @type {ContrastState} **/
      resources: e.state.contrast,
      ...e
    }), this.lastContrastCode = null;
  }
  addResource(e) {
    super.addResource(e), this.publish(Ce.EVENT.ADDED, e.imaios_code);
  }
  getCurrentCode() {
    const e = this.getCurrent();
    return e !== null ? e.imaios_code : null;
  }
  select(e, t = !0) {
    this.setCurrent(e), t && (this.lastContrastCode = this.getCurrentCode()), this.publish(Ce.EVENT.SELECTED, e);
  }
  setDefault(e) {
    super.setDefault(e), this.publish(Ce.EVENT.SET_DEFAULT);
  }
  getType() {
    return "Contrast";
  }
}
Ce.EVENT = {
  ADDED: "contrast-added",
  SELECTED: "contrast-selected",
  LOADED: "contrasts-loaded",
  SET_DEFAULT: "contrast-set-default"
};
Ce.ALL_CONTRASTS = "all";
const ma = Math.random().toString(36), Ts = {};
class V extends re {
  constructor(e) {
    super(e), this.translationsAdded = [], this.notifier = null, this.languagesLoaded = /* @__PURE__ */ new Set();
  }
  addTranslation(e, t, i, r = V.NAMESPACE.DEFAULT) {
    const n = this.getTranslationKey(e, i, r);
    if (typeof Ts[n] > "u")
      this.languagesLoaded.has(i) || this.languagesLoaded.add(i), Ts[n] = t, this.translationsAdded.push(e), this.notifier === null && (this.notifier = setTimeout(() => {
        this.publish(
          V.EVENT.ADDED,
          i
        ), this.translationsAdded = [], this.notifier = null;
      }, 500));
    else
      throw new Error("Translation collision : " + e);
  }
  getTranslationKey(e, t, i) {
    return Ut(`${ma}-${i}-${e}-${t}`);
  }
  getTranslation(e, t, i = V.NAMESPACE.DEFAULT) {
    const r = this.getTranslationKey(e, t, i), n = Ts[r] || null;
    return n === null ? null : n;
  }
}
V.EVENT = {
  ADDED: "translation-added"
};
V.NAMESPACE = {
  DEFAULT: "default",
  UI: "ui",
  CONTENT: "content"
};
class Re extends Ue {
  constructor(e) {
    super({
      /** @type {LanguageState} **/
      resources: e.state.language,
      ...e
    }), this.temporaryLanguage = null, this.interfaceLanguageId = null;
  }
  setInterfaceLanguage(e) {
    this.interfaceLanguageId = e;
  }
  getCurrentInterfaceLanguage() {
    return this.interfaceLanguageId;
  }
  isAvailable(e) {
    return this.data.resources.availables.has(e);
  }
  addResource(e) {
    this.data.resources.availables.add(e), this.publish(Re.EVENT.ADDED, e);
  }
  setCurrent(e) {
    this.temporaryLanguage = this.getCurrentId(), super.setCurrent(e), this.publish(Re.EVENT.CHANGE, { oldLanguage: this.temporaryLanguage, lang_id: e });
  }
  getCurrent() {
    return this.getCurrentId();
  }
}
Re.EVENT = {
  CHANGE: "language-change",
  ADDED: "language-added",
  LOADED: "language-loaded"
};
class Lt extends Ue {
  constructor(e) {
    super({
      /** @type {InteractionState} **/
      resources: e.state.interaction,
      ...e
    }), this.data.previousInteraction = null, this.data.savePreviousIneraction = !0;
  }
  setCurrent(e, t = !0) {
    const i = this.getCurrentId();
    if (i !== null) {
      if (e === i)
        return;
      const r = this.getCurrent();
      r.isPerforming && r.finish(), this.data.savePreviousIneraction && (this.data.previousInteraction = i), this.data.savePreviousIneraction = t;
    }
    super.setCurrent(e), this.publish(
      Lt.EVENT.CHANGE,
      e
    );
  }
  restorePreviousInteraction() {
    this.setCurrent(this.data.previousInteraction);
  }
}
Lt.EVENT = {
  CHANGE: "interaction-change"
};
class Ze extends Oe {
  constructor() {
    super();
  }
  static getHover() {
    return this.findById(this.data.resources.hover);
  }
  static hasHover() {
    return this.data.resources.hover !== null;
  }
  static factorize(e, t, i) {
    return (r) => t(e, i, r);
  }
  static setHover(e, t, i = {}) {
    const { resource_id: r } = i;
    e.isAvailable(r) && (e.data.resources.hover = r, e.publish(t, i));
  }
  static clearHover(e, t) {
    e.publish(t, e.data.resources.hover), e.data.resources.hover = null;
  }
  init(e, t = {}) {
    const i = t.hoverEvent, r = t.looseHoverEvent;
    e.data.resources.hover = null, e.getHover = Ze.getHover.bind(e), e.hasHover = Ze.hasHover.bind(e), e.setHover = Ze.factorize(e, Ze.setHover, i), e.clearHover = Ze.factorize(e, Ze.clearHover, r);
  }
}
const Ar = (s, e) => {
  const t = new Ze(e);
  return t.init(s, e), t;
};
class Ui extends Error {
  constructor(e) {
    super(`Unable to find structure ${e}.`), this.name = this.constructor.name;
  }
}
const Pe = {
  EANATOMY: "eanatomy",
  VETANATOMY: "vetanatomy"
};
class ae extends Ue {
  constructor(e) {
    super({
      name: "structure-service",
      resources: e.state.structure,
      ...e
    }), this.data.structureIsolated = null, this.injectFeature("manage-hoverable-resources", Ar(this, {
      hoverEvent: ae.EVENT.HOVER,
      looseHoverEvent: ae.EVENT.LOOSE_HOVER
    })), this.taxonIndex = {}, this.rawIdToDedupedIdIndex = {}, this.lastTaxonKey = null, this.structuresWithPoint = /* @__PURE__ */ new Set();
  }
  exists(e) {
    return typeof this.rawIdToDedupedIdIndex[e] < "u";
  }
  addResource(e, t = null) {
    const i = e.getTaxonKey(), r = `${e.id}-${i}`;
    super.addResource(e, r), this.taxonIndex[i] = e.id, Array.isArray(this.rawIdToDedupedIdIndex[e.id]) !== !0 && (this.rawIdToDedupedIdIndex[e.id] = []), this.rawIdToDedupedIdIndex[e.id].push(r);
  }
  findByStructId(e) {
    return this.rawIdToDedupedIdIndex[e].map((t) => this.findById(t));
  }
  addStructureWithAPoint(e) {
    this.structuresWithPoint.add(e);
  }
  findByTaxonKey(e) {
    const t = this.taxonIndex[e];
    if (typeof t > "u")
      throw new Ui(`with taxon_key ${e}`);
    return this.findById(`${t}-${e}`);
  }
  findStructureWithPointByTaxonKey(e) {
    if (typeof this.taxonIndex[e] > "u")
      throw new Ui(`with taxon_key ${e}`);
    return Array.from(this.structuresWithPoint).find((i) => i.getTaxonKey() === e);
  }
  findStructureWithPointByStructId(e) {
    return Array.from(this.structuresWithPoint).find((t) => t.id === e);
  }
  setTranslatorService(e) {
    this.services = {
      translator: e
    };
  }
  isVisible(e) {
    return this.data.resources.hidden.has(e) === !1;
  }
  resetVisibility() {
    this.data.resources.hidden.clear();
  }
  getNbHidden() {
    return this.data.resources.hidden.size;
  }
  isolate(e) {
    this.data.structureIsolated = e;
  }
  hide(e) {
    this.data.resources.hidden.add(e), this.publish(ae.EVENT.VISIBILITY_CHANGE, {
      isVisible: !1,
      nbHidden: this.getNbHidden(),
      structure_id: e
    });
  }
  show(e) {
    this.data.resources.hidden.delete(e), this.publish(ae.EVENT.VISIBILITY_CHANGE, {
      isVisible: !0,
      nbHidden: this.getNbHidden(),
      structure_id: e
    });
  }
  setPriority(e, t) {
    this.publish(ae.EVENT.PRIORITY_CHANGE, { structure_id: e, priority: t });
  }
  getTranslation(e, t = null) {
    let i = this.services.translator.getTranslation(
      e.translation_key,
      V.NAMESPACE.CONTENT,
      t
    );
    return i === null && (i = this.services.translator.getTranslation(
      e.translation_key,
      V.NAMESPACE.UI,
      t
    )), i;
  }
  getParentTranslation(e, t = null) {
    let i = this.services.translator.getTranslation(
      e.parent_translation_key,
      V.NAMESPACE.CONTENT,
      t
    );
    return i === null && (i = this.services.translator.getTranslation(
      e.parent_translation_key,
      V.NAMESPACE.UI,
      t
    )), i;
  }
  setCurrent(e, t = null) {
    super.setCurrent(e), t !== null && this.setLastTaxonKey(t), this.publish(ae.EVENT.SELECTED);
  }
  updateById(e, t) {
    this.rawIdToDedupedIdIndex[e].forEach((i) => {
      try {
        super.updateById(i, t);
      } catch (r) {
        r instanceof ht && console.error(r);
      }
    });
  }
  getLastTaxonKey() {
    return this.lastTaxonKey;
  }
  setLastTaxonKey(e) {
    return this.lastTaxonKey = e;
  }
  getResourcesId(e) {
    const t = e.getTaxonKey();
    return `${e.id}-${t}`;
  }
  /**
   * Compare two taxon and return the taxon with the highest priority
   * @param {string} applicationId
   * @param {Structure} taxonA
   * @param {Structure} taxonB
   * @return {Structure|null}
   */
  getTaxonHigherPriority(e, t, i) {
    if (t.id !== i.id)
      return null;
    if (e === Pe.EANATOMY) {
      if (t.variant_id === Me.MAIN) {
        if (i.variant_id !== Me.MAIN)
          return t;
        const r = this.getTaxonWithHighestPriorityByTA(t, i);
        if (r !== null)
          return r;
      }
      if (i.variant_id === Me.MAIN)
        return i;
      if (t.variant_id === Me.DEPRECATED_MAIN) {
        if (i.variant_id !== Me.DEPRECATED_MAIN)
          return t;
        const r = this.getTaxonWithHighestPriorityByTA(t, i);
        if (r !== null)
          return r;
      }
      if (i.variant_id === Me.DEPRECATED_MAIN)
        return i;
      if (t.variant_id === Me.DEPRECATED) {
        if (i.variant_id !== Me.DEPRECATED)
          return t;
        const r = this.getTaxonWithHighestPriorityByTA(t, i);
        if (r !== null)
          return r;
      }
      return i.variant_id === Me.DEPRECATED ? i : t.taxon_id < i.taxon_id ? t : i;
    } else if (e === Pe.VETANATOMY)
      return t.variant_id === Me.MAIN && t.ta_id === Ge.NAV ? t : i.variant_id === Me.MAIN && i.ta_id === Ge.NAV ? i : t.taxon_id < i.taxon_id ? t : i;
  }
  getTaxonWithHighestPriorityByTA(e, t) {
    return e.ta_id === Ge[2] ? e : t.ta_id === Ge[2] ? t : e.ta_id === Ge[1] ? e : t.ta_id === Ge[1] ? t : e.ta_id === Ge.HUMAN_NEUROLOGY ? e : t.ta_id === Ge.HUMAN_NEUROLOGY ? t : null;
  }
}
ae.EVENT = {
  PRIORITY_CHANGE: "structure-priority-change",
  VISIBILITY_CHANGE: "structure-visibility-change",
  LOOSE_HOVER: "structure-loose-hover",
  HOVER: "structure-hover",
  CLICK: "structure-click",
  SELECTED: "structure-selected"
};
class vt extends Ue {
  constructor(e) {
    super({
      /** @type {SeriesState} **/
      resources: e.state.series,
      settings: e
    }), this.sliceService = e.services.slice, this.seriesIdByCr = {};
  }
  /**
   * @param {Series} series
   * @return {boolean}
   */
  isSchema(e = null) {
    return e === null && (e = this.getCurrent()), e.modality_id === he.SCHEMA;
  }
  setCurrent(e) {
    super.setCurrent(e), this.publish(
      vt.EVENT.SERIES_CHANGE,
      e
    );
  }
  addResource(e) {
    super.addResource(e);
  }
  getSeriesIdByIndex(e) {
    const t = this.getResources(), i = Array.from(Object.values(t)).find((r) => r.sort_order === e) || null;
    return i !== null ? i.id : null;
  }
  getSeriesById(e) {
    const t = this.getResources(), i = Array.from(Object.values(t)).find((r) => r.id === e) || null;
    return i !== null ? i : null;
  }
  updateSeriesAndRemoveSeriesWithNoSlices() {
    const e = super.getResources();
    Object.keys(e).forEach((t) => {
      const i = this.sliceService.getNbSlicesBySeriesId(t);
      e[t].number_of_images = i, i === 0 && delete e[t];
    });
  }
  hasCrossReferences() {
    return Object.values(this.getResources()).some((e) => e.cross_references_titles.length > 1);
  }
}
vt.EVENT = {
  SERIES_CHANGE: "series-change"
};
class B {
  constructor(e) {
    this.imageHelper = e.services["image-helper"];
  }
  /** @param {QUALITY} quality **/
  isQualityAvailable(e) {
  }
  /** @param {QUALITY} qualityRequired **/
  setQuality(e) {
  }
  /** @param {QUALITY} qualityRequired**/
  switchQuality(e) {
  }
  /** @param {Object} selectors */
  getImage(e, t = B.PRIORITY.STANDARD) {
  }
}
B.EVENT = {
  LOADING_START: "image-provider-loading-start",
  LOADING_END: "image-provider-loading-end",
  ASK_SHOW_PROGRESS: "image-provider-show-progress",
  ASK_HIDE_PROGRESS: "image-provider-hide-progress",
  IMAGE_SLICE_HAS_BEEN_LOADED: "image-provider-slice-has-been-loaded"
};
B.PRIORITY = {
  MAX: 50,
  HIGH: 40,
  STANDARD: 20,
  LOW: 10
};
class fa extends Error {
  constructor(e, t = !0) {
    super(`Invalid slice index at "${e}" with ${t ? "relative" : "absolute"} index`), this.name = this.constructor.name;
  }
}
class fe extends Ue {
  constructor(e) {
    super({
      /** @type {SliceState} **/
      resources: e.state.slice,
      ...e
    }), this.totalSlices = 0, this.shoulUpdateSliceIndexFromRelativeIndex = !0, this.slicesIndexFromRelativeIndex = {}, this.nbSlicesBySeries = {};
  }
  /**
   * @param {Slice[]} slices
   */
  updateRelativeIndexWith(e) {
    const t = {};
    e.sort((i, r) => i.sort_order - r.sort_order).forEach((i, r) => {
      t[r + 1] = i.id;
    }), this.setRelativeSliceIndex(t);
  }
  isInRange(e) {
    return e > 0 && e <= this.sizeOfRelativeIndex();
  }
  getRelativeIndexInRange(e) {
    return ua(e, 1, this.sizeOfRelativeIndex());
  }
  addResource(e) {
    super.addResource(e), this.data.resources.index[e.sort_order] = e.id, this.totalSlices++, typeof this.nbSlicesBySeries[e.series_id] > "u" && (this.nbSlicesBySeries[e.series_id] = 0), this.nbSlicesBySeries[e.series_id] += 1;
  }
  /**
   * @param {Object<{key: Number, value: Number}>} index
   */
  setRelativeSliceIndex(e) {
    this.shoulUpdateSliceIndexFromRelativeIndex = !0, this.data.resources.relativeSliceIndex = e, this.publish(fe.EVENT.SLICE_INDEX_CHANGE);
  }
  /** @param {Number} relativeSliceIndex */
  setCurrentRelativeIndex(e) {
    this.data.resources.currentRelativeSliceIndex = e, this.setCurrentSliceByRelativeIndex(e);
  }
  /** @param {Number} relativeSliceIndex */
  setCurrentSliceByRelativeIndex(e) {
    const t = this.data.resources.relativeSliceIndex[e];
    this.setCurrent(t);
  }
  setCurrent(e) {
    super.setCurrent(e), this.publish(fe.EVENT.SLICE_CHANGE, e);
  }
  getIndex() {
    return this.data.resources.index;
  }
  getIdBySliceIndex(e) {
    return this.data.resources.index[e];
  }
  getSliceBySliceIndex(e) {
    return this.findById(this.getIdBySliceIndex(e));
  }
  getCurrentRelativeIndex() {
    return this.data.resources.currentRelativeSliceIndex;
  }
  sizeOfRelativeIndex() {
    return Object.keys(this.data.resources.relativeSliceIndex).length;
  }
  getIdByRelativeIndex(e) {
    return this.data.resources.relativeSliceIndex[e];
  }
  getRelativeIndexById(e, t = null) {
    if (t === null) {
      const i = this.data.resources.relativeSliceIndex;
      for (let r in i)
        if (i.hasOwnProperty(r) && i[r] === e)
          return parseInt(r, 10);
    } else {
      const i = Object.values(this.data.resources.availables).filter((r) => r.series_id === t).findIndex((r) => r.id === e);
      if (i !== -1)
        return i + 1;
    }
    return -1;
  }
  restoreDefaultIndex() {
    this.updateRelativeIndexWith(
      Object.values(this.getResources())
    );
  }
  getSliceByRelativeIndex(e) {
    try {
      const t = this.getIdByRelativeIndex(e);
      return this.findById(t);
    } catch {
      throw new fa(e);
    }
  }
  getIndexById(e) {
    return parseInt(Object.keys(this.data.resources.index).find((t) => this.data.resources.index[t] === e), 10) || 1;
  }
  getSlicesIndexFromRelativeIndex() {
    if (this.shoulUpdateSliceIndexFromRelativeIndex) {
      const e = {}, t = Object.values(this.data.resources.relativeSliceIndex);
      for (let i = 0; i < t.length; i++) {
        const r = this.findById(t[i]);
        e[r.sort_order] = "";
      }
      this.slicesIndexFromRelativeIndex = e, this.shoulUpdateSliceIndexFromRelativeIndex = !1;
    }
    return this.slicesIndexFromRelativeIndex;
  }
  getTotalSlices() {
    return this.totalSlices;
  }
  /**
   * Return the number of slices from the given series
   * @param series_id
   * @return {number}
   */
  getNbSlicesBySeriesId(e) {
    return typeof this.nbSlicesBySeries[e] > "u" ? 0 : this.nbSlicesBySeries[e];
  }
}
fe.EVENT = {
  SLICE_CHANGE: "slice-change",
  SLICE_INDEX_CHANGE: "slice-index-change",
  SLICE_LOADED: "slice-loaded"
};
class ut extends Ue {
  constructor(e) {
    super({
      /** @type {OrientationState} **/
      resources: e.state.orientation,
      context: e
    }), this.provider = e.providers.orientationImage, this.iconBlacklisted = new Set(e.iconBlacklisted || []), this.translationID = {};
  }
  resetCurrent() {
    this.data.resources.current_id = null;
  }
  isIconBlacklisted(e) {
    const t = this.getNameOf(e);
    return this.iconBlacklisted.has(t);
  }
  storeTranslationID(e) {
    this.translationID[e.id] = e.name_id;
  }
  getTranslationID(e) {
    return this.translationID[e];
  }
  getNameOf(e) {
    const t = this.findById(e);
    return t === null ? null : t.iconName;
  }
  getImageKeySettings(e) {
    const t = this.findById(e);
    return t === null ? null : { name: t.iconName, version: t.version };
  }
  refreshOrientation(e) {
    e !== null && !this.isIconBlacklisted(e) ? this.isCurrent(e) === !1 && (this.setCurrent(e), this.provider.getImage(this.getImageKeySettings(e)).then(
      (t) => {
        this.isCurrent(e) && (this.data.resources.currentImageSrc = t.src, this.publish(ut.EVENT.CHANGE, t));
      }
    ).catch(() => {
      this.data.resources.currentImageSrc = "", this.publish(ut.EVENT.CHANGE, null);
    })) : (this.resetCurrent(), this.data.resources.currentImageSrc = "", this.publish(ut.EVENT.CHANGE, null));
  }
}
ut.EVENT = {
  CHANGE: "orientation-change"
};
class pa extends yn {
  isAllowed(e) {
    return this.component.isFocused() && super.isAllowed(e);
  }
}
class $ extends re {
  /**
   * @param {Object} settings
   * @param {Object} settings.state
   * @param {state.pointer} settings.state.pointer
   * @param {Element} settings.target
   * @param {Object} settings.clickSensitivity threshold whose deteremine when two click are doubleClick or not.
   * @param {number} settings.clickSensitivity.min minimum time between two clicks in ms, if several click happen only one will be treated
   * @param {number} settings.clickSensitivity.max maximum delay where two click might be treated as double click
   */
  constructor(e) {
    super({
      name: "pointer-controller",
      ...e
    }), this.target = e.target, this.handlers = {
      pointer: new ur({
        domTarget: this.target,
        onMouseMove: this.onMouseMove.bind(this),
        onMouseDown: this.onPointerDown.bind(this),
        onMouseUp: this.onMouseUp.bind(this),
        onClick: this.onClick.bind(this),
        onDoubleClick: this.onDoubleClick.bind(this),
        onMouseEnter: this.onMouseEnter.bind(this),
        onMouseLeave: this.onMouseLeave.bind(this),
        onMouseWheel: this.onMouseWheel.bind(this),
        onTouchEnd: this.onTouchEnd.bind(this)
      })
    }, this.state = {
      /** @type {state.pointer} **/
      pointer: e.state.pointer || new dr()
    };
    const t = e.clickSensitivity || {};
    this.clickSensitivity = {
      min: t.min || 80,
      max: t.max || 200
    }, this.lastClickTimestamp = Date.now(), this.lastDBClickTimestamp = Date.now(), this.longClickTimer = null;
  }
  updatePointerCoords(e) {
    this.state.pointer.update(e), this.state.pointer.data.lastCoordsOnScreen.x = e.clientX, this.state.pointer.data.lastCoordsOnScreen.y = e.clientY;
  }
  clearLongClickTimer() {
    clearTimeout(this.longClickTimer), this.longClickTimer = null;
  }
  enable() {
    this.data.enabled = !0;
  }
  disable() {
    this.data.enabled = !1;
  }
  isEnabled() {
    return this.data.enabled === !0;
  }
  /** @param {PointerEvent} event */
  onMouseMove(e) {
    this.isEnabled() === !0 && (this.updatePointerCoords(e), this.publish($.EVENT.POINTER_MOVE, e), this.clearLongClickTimer());
  }
  /** @param {PointerEvent} event */
  onPointerDown(e) {
    this.updatePointerCoords(e);
    const t = Date.now();
    t - this.lastClickTimestamp <= this.clickSensitivity.min ? this.lastClickTimestamp = t : (this.state.pointer.isDown = !0, this.lastClickTimestamp = t, this.longClickTimer === null && (this.longClickTimer = setTimeout(() => {
      this.publish($.EVENT.LONG_CLICK, e);
    }, 500)), this.publish($.EVENT.POINTER_DOWN, e));
  }
  /** @param {PointerEvent} event */
  onMouseUp(e) {
    this.updatePointerCoords(e), clearTimeout(this.longClickTimer), this.state.pointer.isDown = !1, this.publish($.EVENT.POINTER_UP, e), e.preventDefault();
  }
  /** @param {PointerEvent} event */
  onMouseEnter(e) {
    this.updatePointerCoords(e), this.publish($.EVENT.POINTER_ENTER, e);
  }
  /** @param {PointerEvent} event */
  onMouseLeave(e) {
    this.state.pointer.isDown && (this.state.pointer.isDown = !1, this.clearLongClickTimer()), this.publish($.EVENT.POINTER_LEAVE, e);
  }
  onMouseWheel(e) {
    this.publish($.EVENT.MOUSE_WHEEL, e);
  }
  /** @param {PointerEvent} event */
  onClick(e) {
  }
  /** @param {PointerEvent} event */
  onDoubleClick(e) {
    const t = Date.now();
    t - this.lastDBClickTimestamp < this.clickSensitivity.min * 2 || (this.lastDBClickTimestamp = t, this.lastClickTimestamp = t, this.publish($.EVENT.DOUBLE_CLICK, e));
  }
  /**
   * @param {MouseEvent} event
   */
  static isRightClick(e) {
    return e.which === 3 || // old Gecko (Firefox), WebKit (Safari/Chrome) & Opera
    e.button === 2;
  }
  onTouchEnd(e) {
    this.publish($.EVENT.TOUCH_END, e);
  }
}
$.EVENT = {
  POINTER_MOVE: "pointer-move",
  POINTER_DOWN: "pointer-down",
  POINTER_UP: "pointer-up",
  POINTER_ENTER: "pointer-enter",
  POINTER_LEAVE: "pointer-leave",
  LONG_CLICK: "long-click",
  DOUBLE_CLICK: "double-click",
  MOUSE_WHEEL: "mouse-wheel",
  TOUCH_END: "touch-end"
};
class L {
  constructor() {
    this.data = {
      [L.ATTRIBUTE.TOOLBAR_HEIGHT]: 0,
      [L.ATTRIBUTE.SERIES_TITLE_HEIGHT]: 0,
      [L.ATTRIBUTE.CROSS_REF_TITLE_HEIGHT]: 0,
      [L.ATTRIBUTE.LINE_INTERVAL_PX]: 0,
      [L.ATTRIBUTE.MAX_FONT_PX]: 0,
      [L.ATTRIBUTE.BASE_MAX_FONT_PX]: 0,
      [L.ATTRIBUTE.MAX_LABEL_LINES]: 0,
      [L.ATTRIBUTE.FONT_FAMILY]: "sans-serif",
      [L.ATTRIBUTE.TEXT_TO_VERTICAL_LINE_PADDING]: 0,
      [L.ATTRIBUTE.VERTICAL_LINE_PADDING]: 0,
      [L.ATTRIBUTE.TEXT_PADDING]: 0,
      [L.ATTRIBUTE.MARGIN]: 0,
      [L.ATTRIBUTE.LABELS_ISOLATE_ALPHA]: "0",
      [L.ATTRIBUTE.LABELS_WEAK_ALPHA]: "0",
      [L.ATTRIBUTE.PIN_WEAK_ALPHA]: 0,
      [L.ATTRIBUTE.LABELS_FULL_ALPHA]: "0",
      [L.ATTRIBUTE.LABELS_EDGE_ALPHA]: "0",
      [L.ATTRIBUTE.LEFT_RIGHT_ALPHA]: "0",
      [L.ATTRIBUTE.MINIMAL_FONT_SIZE_FOR_NAVIGATORS]: 0,
      [L.ATTRIBUTE.POINT_RADIUS]: 0,
      [L.ATTRIBUTE.LABELS_MAX_V_SPACING]: 0,
      [L.ATTRIBUTE.SMALL_HORIZONTAL_LINE_LENGTH]: 0,
      [L.ATTRIBUTE.TEXT_OVERLAYS_HEIGHT_PADDING]: 0,
      [L.ATTRIBUTE.IMAGE_TILE_HEIGHT]: 0,
      [L.ATTRIBUTE.RECENTER_SLIGHT_MARGIN]: 0,
      [L.ATTRIBUTE.RADIANT_OFFSET_ANGLE_FOR_DEGREES]: 0,
      [L.ATTRIBUTE.TOP_IMAGE_POSITION]: 0,
      [L.ATTRIBUTE.RIGHT_IMAGE_POSITION]: 0,
      [L.ATTRIBUTE.DOWN_IMAGE_POSITION]: 0,
      [L.ATTRIBUTE.LEFT_IMAGE_POSITION]: 0,
      [L.ATTRIBUTE.ROTATION_PRESS_ANGLE]: 0,
      [L.ATTRIBUTE.MIN_FONT_PX]: 0,
      [L.ATTRIBUTE.BASE_MIN_FONT_PX]: 0,
      [L.ATTRIBUTE.ORIENTATION_PICTURE_MARGIN_TOP]: 0,
      [L.ATTRIBUTE.ORIENTATION_LOGO]: "",
      [L.ATTRIBUTE.TOOLBAR_N_TITLE_OFFSET]: 0,
      [L.ATTRIBUTE.FONT_SIZE]: 0,
      [L.ATTRIBUTE.TEXT_OVERLAYS_ALIGNMENTS]: "",
      [L.ATTRIBUTE.MAX_LABEL_HEIGHT_WITH_LINES]: 0,
      [L.ATTRIBUTE.MIN_LABEL_HEIGHT_WITH_LINES]: 0,
      [L.ATTRIBUTE.LINE_DIM]: 0,
      [L.ATTRIBUTE.NO_MAX_LINES]: 0,
      [L.ATTRIBUTE.MAX_PIXEL_PER_IMAGE]: 0,
      [L.ATTRIBUTE.FONT_ZOOM_LEVEL]: 1,
      [L.ATTRIBUTE.FONT_ZOOM_MAX]: 5,
      [L.ATTRIBUTE.FONT_ZOOM_MIN]: 1,
      [L.ATTRIBUTE.FONT_ZOOM_STEP]: 0.1,
      [L.ATTRIBUTE.ISOLATE_COLOR_PIN]: "#000000",
      [L.ATTRIBUTE.MIN_MARGIN_LABEL]: 0
    };
  }
}
L.ATTRIBUTE = {
  TOOLBAR_HEIGHT: "TOOLBAR_HEIGHT",
  SERIES_TITLE_HEIGHT: "SERIES_TITLE_HEIGHT",
  CROSS_REF_TITLE_HEIGHT: "CROSS_REF_TITLE_HEIGHT",
  LINE_INTERVAL_PX: "LINE_INTERVAL_PX",
  MAX_FONT_PX: "MAX_FONT_PX",
  BASE_MAX_FONT_PX: "BASE_MAX_FONT_PX",
  MAX_LABEL_LINES: "MAX_LABEL_LINES",
  FONT_FAMILY: "FONT_FAMILY",
  TEXT_TO_VERTICAL_LINE_PADDING: "TEXT_TO_VERTICAL_LINE_PADDING",
  VERTICAL_LINE_PADDING: "VERTICAL_LINE_PADDING",
  TEXT_PADDING: "TEXT_PADDING",
  MARGIN: "MARGIN",
  LABELS_ISOLATE_ALPHA: "LABELS_ISOLATE_ALPHA",
  LABELS_WEAK_ALPHA: "LABELS_WEAK_ALPHA",
  PIN_WEAK_ALPHA: "PIN_WEAK_ALPHA",
  LABELS_FULL_ALPHA: "LABELS_FULL_ALPHA",
  LABELS_EDGE_ALPHA: "LABELS_EDGE_ALPHA",
  LEFT_RIGHT_ALPHA: "LEFT_RIGHT_ALPHA",
  MINIMAL_FONT_SIZE_FOR_NAVIGATORS: "MINIMAL_FONT_SIZE_FOR_NAVIGATORS",
  POINT_RADIUS: "POINT_RADIUS",
  LABELS_MAX_V_SPACING: "LABELS_MAX_V_SPACING",
  SMALL_HORIZONTAL_LINE_LENGTH: "SMALL_HORIZONTAL_LINE_LENGTH",
  TEXT_OVERLAYS_HEIGHT_PADDING: "TEXT_OVERLAYS_HEIGHT_PADDING",
  IMAGE_TILE_HEIGHT: "IMAGE_TILE_HEIGHT",
  RECENTER_SLIGHT_MARGIN: "RECENTER_SLIGHT_MARGIN",
  RADIANT_OFFSET_ANGLE_FOR_DEGREES: "RADIANT_OFFSET_ANGLE_FOR_DEGREES",
  TOP_IMAGE_POSITION: "TOP_IMAGE_POSITION",
  RIGHT_IMAGE_POSITION: "RIGHT_IMAGE_POSITION",
  DOWN_IMAGE_POSITION: "DOWN_IMAGE_POSITION",
  LEFT_IMAGE_POSITION: "LEFT_IMAGE_POSITION",
  ROTATION_PRESS_ANGLE: "ROTATION_PRESS_ANGLE",
  ORIENTATION_PICTURE_MARGIN_TOP: "ORIENTATION_PICTURE_MARGIN_TOP",
  ORIENTATION_LOGO: "ORIENTATION_LOGO",
  TOOLBAR_N_TITLE_OFFSET: "TOOLBAR_N_TITLE_OFFSET",
  TEXT_OVERLAYS_ALIGNMENTS: "TEXT_OVERLAYS_ALIGNMENTS",
  LINE_DIM: "LINE_DIM",
  MAX_LABEL_HEIGHT_WITH_LINES: "MAX_LABEL_HEIGHT_WITH_LINES",
  MIN_LABEL_HEIGHT_WITH_LINES: "MIN_LABEL_HEIGHT_WITH_LINES",
  FONT_SIZE: "FONT_SIZE",
  MIN_FONT_PX: "MIN_FONT_PX",
  BASE_MIN_FONT_PX: "BASE_MIN_FONT_PX",
  FONT_ZOOM_LEVEL: "FONT_ZOOM_LEVEL",
  FONT_ZOOM_MAX: "FONT_ZOOM_MAX",
  FONT_ZOOM_MIN: "FONT_ZOOM_MIN",
  FONT_ZOOM_STEP: "FONT_ZOOM_STEP",
  NO_MAX_LINES: "NO_MAX_LINES",
  MAX_PIXEL_PER_IMAGE: "MAX_PIXEL_PER_IMAGE",
  ISOLATE_COLOR_PIN: "ISOLATE_COLOR_PIN",
  MIN_MARGIN_LABEL: "MIN_MARGIN_LABEL"
};
class H {
  constructor() {
    this.data = {
      [H.ATTRIBUTE.MULTIPLIER]: 1,
      [H.ATTRIBUTE.IMAGE_OFFSET_X]: 0,
      [H.ATTRIBUTE.IMAGE_OFFSET_Y]: 0,
      [H.ATTRIBUTE.VERTICAL_FLIP]: !1,
      [H.ATTRIBUTE.HORIZONTAL_FLIP]: !1,
      [H.ATTRIBUTE.POINT_SELECTION_MODE]: !1,
      [H.ATTRIBUTE.ROTATION_ANGLE]: 0,
      [H.ATTRIBUTE.VIEWZONE_ACTIVE]: !1,
      [H.ATTRIBUTE.WIDTH_AVAILABLE]: 0,
      [H.ATTRIBUTE.LEFT_PADDING]: 0,
      [H.ATTRIBUTE.RIGHT_PADDING]: 0,
      [H.ATTRIBUTE.LEFT_IDEAL_LABEL_SIZE]: 0,
      [H.ATTRIBUTE.RIGHT_IDEAL_LABEL_SIZE]: 0,
      [H.ATTRIBUTE.CONTAINER_ELEMENT]: null,
      [H.ATTRIBUTE.FULLSCREEN_ACTIVE]: !1,
      [H.ATTRIBUTE.MAX_ZOOM]: 0,
      [H.ATTRIBUTE.MIN_ZOOM]: 0,
      [H.ATTRIBUTE.SCALE]: 1,
      [H.ATTRIBUTE.ZOOM_DYNAMIC]: 0,
      [H.ATTRIBUTE.ZOOM_SCALE_DELTA]: 1e-4,
      [H.ATTRIBUTE.INITIAL_MIN_SCALE]: 0,
      [H.ATTRIBUTE.INITIAL_MAX_SCALE]: 0,
      [H.ATTRIBUTE.MIN_SCALE]: 0,
      [H.ATTRIBUTE.MAX_SCALE]: 0,
      [H.ATTRIBUTE.LEFT_RIGHT_THRESHOLD]: 0,
      [H.ATTRIBUTE.USER_ZOOM_PERFORMED]: !1,
      [H.ATTRIBUTE.WIDTH_CONTAINER]: 0,
      [H.ATTRIBUTE.HEIGHT_CONTAINER]: 0
    };
  }
}
H.ATTRIBUTE = {
  MULTIPLIER: "MULTIPLIER",
  IMAGE_OFFSET_X: "IMAGE_OFFSET_X",
  IMAGE_OFFSET_Y: "IMAGE_OFFSET_Y",
  VERTICAL_FLIP: "VERTICAL_FLIP",
  HORIZONTAL_FLIP: "HORIZONTAL_FLIP",
  POINT_SELECTION_MODE: "POINT_SELECTION_MODE",
  ROTATION_ANGLE: "ROTATION_ANGLE",
  VIEWZONE_ACTIVE: "VIEWZONE_ACTIVE",
  LEFT_PADDING: "LEFT_PADDING",
  RIGHT_PADDING: "RIGHT_PADDING",
  LEFT_IDEAL_LABEL_SIZE: "LEFT_IDEAL_LABEL_SIZE",
  RIGHT_IDEAL_LABEL_SIZE: "RIGHT_IDEAL_LABEL_SIZE",
  WIDTH_AVAILABLE: "WIDTH_AVAILABLE",
  WIDTH_CONTAINER: "WIDTH_CONTAINER",
  HEIGHT_CONTAINER: "HEIGHT_CONTAINER",
  CONTAINER_ELEMENT: "CONTAINER_ELEMENT",
  FULLSCREEN_ACTIVE: "FULLSCREEN_ACTIVE",
  // ZOOM Attributes
  MAX_ZOOM: "MAX_ZOOM",
  MIN_ZOOM: "MIN_ZOOM",
  ZOOM_DYNAMIC: "ZOOM_DYNAMIC",
  SCALE: "SCALE",
  ZOOM_SCALE_DELTA: "ZOOM_SCALE_DELTA",
  USER_ZOOM_PERFORMED: "USER_ZOOM_PERFORMED",
  LEFT_RIGHT_THRESHOLD: "LEFT_RIGHT_THRESHOLD",
  // Scale Attribute
  INITIAL_MIN_SCALE: "INITIAL_MIN_SCALE",
  INITIAL_MAX_SCALE: "INITIAL_MAX_SCALE",
  MIN_SCALE: "MIN_SCALE",
  MAX_SCALE: "MAX_SCALE"
};
class Le {
  constructor(e, t, i, r) {
    this.totalHeight = e, this.textValue = t, this.textWidth = i, this.nbLines = r;
  }
  recycle() {
    Le.POOL.AVAIBLE.push(this);
  }
}
Le.POOL = {
  AVAIBLE: [
    new Le(0, 0, 0, 0),
    new Le(0, 0, 0, 0),
    new Le(0, 0, 0, 0)
  ]
};
Le.getOne = function(s, e, t, i) {
  if (Le.POOL.AVAIBLE.length === 0)
    return new Le(s, e, t, i);
  var r = Le.POOL.AVAIBLE.pop();
  return r.totalHeight = s, r.textValue = e, r.textWidth = t, r.nbLines = i, r;
};
class ce {
  constructor(e = {}) {
    this.eventListener = e.eventListener || ce.defaultEventListener, this.isPerforming = !1, this.isInPause = !1, this.requestId = null, this.name = e.name, this.lastEvent = null, this.component = e.component || null, this.enabled = e.enabled || !0, this.animationItem = null;
  }
  setAnimationItem(e) {
    this.animationItem = e;
  }
  disableForTime(e = 0) {
    this.enabled = !1, setTimeout(() => {
      this.enabled = !0;
    }, e);
  }
  /**
   * End sequence of requestAnimationFrame and call onFinish statement of current Interaction
   * @param e Event
   */
  finish(e) {
    (this.isPerforming === !0 || this.isInPause === !0) && (this.isPerforming = !1, this.isInPause = !1, this.requestId = null, this.onFinish(e), this.animationItem.stop());
  }
  /**
   * Override component listener and force it to have the behavior defined by current Interaction. Begin sequence of requestAnimationFrame.
   * @param event
   * @param overrideListener
   */
  start(e, t) {
    this.isPerforming = !0, t === !0 && (this.component.onMouseMove = this.onMouseMove, this.component.onMouseDown = this.onMouseDown, this.component.onMouseUp = this.onMouseUp || ce.avoid, this.component.onClick = this.onClick || ce.avoid, this.component.onMouseEnter = this.onMouseEnter || ce.avoid, this.component.onMouseLeave = this.onMouseLeave || ce.avoid, this.component.onMouseWheel = this.onMouseWheel || ce.avoid, this.component.onTouchStart = this.onTouchStart || ce.avoid, this.component.onTouchMove = this.onTouchMove || ce.avoid, this.component.onTouchEnd = this.onTouchEnd || ce.avoid), this.handlerAnimation = this.onAnimation, this.onStart(e), this.animationItem.start();
  }
  pause() {
    this.handlerAnimation = ce.avoid, this.isPerforming = !1, this.isInPause = !0, this.onPause(), this.animationItem.stop();
  }
  play() {
    this.handlerAnimation = this.onAnimation, this.isPerforming = !0, this.isInPause = !1, this.animationItem.start();
  }
  onMouseMove() {
  }
  onMouseDown() {
  }
  onMouseUp() {
  }
  onClick() {
  }
  onMouseEnter() {
  }
  onMouseLeave() {
  }
  onMouseWheel() {
  }
  onTouchStart() {
  }
  onTouchMove() {
  }
  onTouchEnd() {
  }
  onStart() {
  }
  onFinish() {
  }
  onPause() {
  }
  onPlay() {
  }
  onAnimation() {
  }
}
ce.defaultEventListener = null;
ce.EVENT = {
  START: "interaction-start",
  END: "interaction-end"
};
const X = {
  EVENT: {
    FORCE_FONT_SIZE_AUTO: "label-drawer-force-font-size-auto",
    NEW_RENDERING: "label-drawer-new-rendering",
    UPDATE_COLOR: "label-drawer-update-color",
    CHANGE: "label-drawer-change",
    LABEL_DRAWN: "label-drawer-label-drawn",
    UPDATE_RANGE_FONT_SIZE: "label-drawer-update-range-font-size",
    BEFORE_SET_CANDIDATES: "label-drawer-before-set-candidates",
    CONTEXT_RESET: "label-drawer-context-reset",
    ALL_LABEL_DRAWN: "label-drawer-all-label-drawn",
    BEFORE_DRAW_TEXT: "label-service-before-draw-text",
    BEFORE_GET_LABEL_INFO: "label-service-before-get-label-info"
  }
};
class J {
  constructor(e = {}) {
    const t = typeof e.filter_id == "number" ? e.filter_id.toString(10) : e.filter_id;
    this.id = e.id, this.x = e.x_pixel || e.x, this.y = e.y_pixel || e.y, this.color = e.color, this.filter_id = t, this.priority = e.priority, this.default_priority = e.priority, this.isSelected = e.isSelected || !1, this.slice_id = e.slice_id || null, this.taxon_id = e.taxon_id, this.ta_id = e.ta_id, this.taxon_key = this.getTaxonKey(), this.circleAlpha = "", this.edgeColor = "", this.edgeAlpha = "", this.circleColor = "", this.sizeMultiplier = 1;
  }
  getTaxonKey() {
    return `${this.ta_id}-${this.taxon_id}`;
  }
  setCoords(e, t) {
    return this.x = e, this.y = t, this;
  }
  distance(e) {
    return Math.sqrt(this.distance2(e));
  }
  distance2(e) {
    return (this.x - e.x) * (this.x - e.x) + (this.y - e.y) * (this.y - e.y);
  }
  resetPriority() {
    this.priority = this.default_priority;
  }
  setPriority(e) {
    this.priority = Math.max(-200, Math.min(e, 180));
  }
  copy(e) {
    const t = { ...e };
    for (let i in t)
      this[i] = t[i];
    return this;
  }
  getColor() {
    return "#" + this.color;
  }
}
J.POOL = {
  AVAIBLE: [
    new J(0, 0, 0, 0, 0, 0, 0),
    new J(0, 0, 0, 0, 0, 0, 0),
    new J(0, 0, 0, 0, 0, 0, 0)
  ],
  instances: 3
};
J.getOne = function() {
  return J.POOL.AVAIBLE.length > 0 ? J.POOL.AVAIBLE.pop() : (J.POOL.instances++, new J());
};
J.recycle = function(s) {
  J.POOL.AVAIBLE.push(s);
};
class wr {
  getCoordsPoint(e) {
    return e.services.point.fromCoords(
      e.state.pointer.data.coords.x,
      e.state.pointer.data.coords.y
    );
  }
  getMaxDistance() {
    return 100;
  }
  getPointHover(e) {
    const t = e.services.point, i = e.components.pointsCanvas, r = this.getCoordsPoint(e), { point: n, distance2: a } = t.findNearest({
      point: r,
      transformation: (o) => {
        i.applyLocalTransformationToPoint(o);
      }
    });
    return J.recycle(r), a <= this.getMaxDistance() ? n : null;
  }
  getBoundingBox(e) {
    return {
      top: 0,
      bottom: Math.ceil(e.getHeight()),
      left: Math.ceil(0.2 * e.getWidth()),
      right: Math.ceil(e.getWidth() * 0.8)
    };
  }
  onPointerUp(e, t) {
    const i = e.services.point;
    if (i.hasHover()) {
      const r = i.getHover();
      $.isRightClick(t) === !1 && e.publish(
        q.EVENT.CLICK,
        r
      );
    }
  }
  onUpdatePointStyle(e, t, i) {
    const r = e.services.style.get(L.ATTRIBUTE.LABELS_ISOLATE_ALPHA), n = e.services.style.get(L.ATTRIBUTE.LABELS_FULL_ALPHA), a = e.services.style.get(L.ATTRIBUTE.LABELS_WEAK_ALPHA), o = e.services.series.isSchema(e.services.series.getCurrent());
    i ? (t.circleAlpha = r, t.edgeColor = me.RED, t.edgeAlpha = n, t.circleColor = t.color) : (t.circleAlpha = a, t.edgeColor = o ? t.color : me.BLACK, t.circleColor = o ? me.BLACK : t.color, t.edgeAlpha = a);
  }
}
class q extends Vt {
  constructor(e = {}) {
    super({
      name: e.name || "point-service",
      ...e
    }), this.leftLinkedPointsById = {}, this.rightLinkedPointsById = {}, this.highestPriority = Number.NEGATIVE_INFINITY, this.pointsToDraw = [], this.pointsActives = [], this.pointsVisible = [], this.selectedPoints = [], this.unselectPoints = /* @__PURE__ */ new Set(), this.injectFeature("manage-hoverable-resources", Ar(this, {
      hoverEvent: q.EVENT.HOVER,
      looseHoverEvent: q.EVENT.LOOSE_HOVER
    })), this.pointHelper = new wr(), this.pointsByTaxonKey = {};
  }
  addResource(e, t = null) {
    super.addResource(e, t), typeof this.pointsByTaxonKey[e.taxon_key] > "u" && (this.pointsByTaxonKey[e.taxon_key] = []), this.pointsByTaxonKey[e.taxon_key].push(e);
  }
  findByTaxonKey(e) {
    return typeof this.pointsByTaxonKey[e] < "u" ? this.pointsByTaxonKey[e] : [];
  }
  clearLinks() {
    this.leftLinkedPointsById = {}, this.rightLinkedPointsById = {};
  }
  getVisible() {
    return this.pointsVisible;
  }
  getAllLinked() {
    return {
      ...this.leftLinkedPointsById,
      ...this.rightLinkedPointsById
    };
  }
  link(e, t = "left") {
    t === "left" ? this.linkToLeftSide(e) : this.linkToRightSide(e);
  }
  linkToLeftSide(e) {
    this.leftLinkedPointsById[e.id] = e;
  }
  linkToRightSide(e) {
    this.rightLinkedPointsById[e.id] = e;
  }
  /**
   * @param {Number} point_id
   */
  setDrawable(e) {
    this.pointsToDraw.push(e);
  }
  isLinked(e) {
    return typeof this.leftLinkedPointsById[e] < "u" || typeof this.rightLinkedPointsById[e] < "u";
  }
  /**
   * @param {Point[]} pointsVisible
   */
  setPointsVisible(e) {
    this.pointsVisible = e;
    const t = [].concat(e);
    this.setActives(t), this.publish(q.EVENT.UPDATE_ACTIVE, t);
  }
  getActives() {
    return this.pointsActives;
  }
  setActives(e) {
    this.pointsActives = e;
  }
  setPriority(e, t) {
    this.findById(e).setPriority(t);
  }
  fromCoords(e, t) {
    return J.getOne().setCoords(e, t);
  }
  recycle(e) {
    J.recycle(e);
  }
  getPointsToDraw() {
    return this.pointsToDraw.map((e) => this.findById(e));
  }
  getSelected() {
    return this.selectedPoints;
  }
  clearPointsToDraw() {
    this.pointsToDraw.length = 0;
  }
  distance2(e, t) {
    return e.distance2(t);
  }
  /**
   * @param {Object} settings
   * @param {Point} settings.point
   * @param {Function} settings.selection
   * @param {Function} settings.transformation
   */
  findNearest(e = {}) {
    const t = e.point;
    let i = Number.MAX_VALUE, r = 0, n = null;
    const a = this.getActives(), o = e.selection || ((u) => !0), l = e.transformation || ((u) => u), c = J.getOne();
    return a.forEach((u) => {
      o(u) !== !1 && (c.copy(u), l(c), r = this.distance2(t, c), r < i && (i = r, n = u));
    }), J.recycle(c), {
      point: n,
      distance2: i
    };
  }
  getPointHover(e) {
    return this.pointHelper.getPointHover(e);
  }
  setHighestPriority(e) {
    this.highestPriority = e;
  }
  getHighestPriority() {
    return this.highestPriority;
  }
  distance(e, t) {
    return Math.sqrt(this.distance2(e, t));
  }
  /** @param {Point} point */
  select(e) {
    this.isAvailable(e.id) && (this.selectedPoints.push(e), e.isSelected = !0, this.unselectPoints.delete(e.id), this.publish(q.EVENT.SELECTED, e));
  }
  /** @param {Point} point */
  unselect(e) {
    if (this.isAvailable(e.id)) {
      const t = this.selectedPoints.findIndex((i) => i.id === e.id);
      this.selectedPoints.splice(t, 1), e.isSelected = !1, this.unselectPoints.add(e.id), this.publish(q.EVENT.UNSELECTED, e);
    }
  }
  getNbPointsToDraw() {
    return this.pointsToDraw.length;
  }
  /**
   * @param {Point} point
   * @param {{left:number, right:number, top:number, bottom:number}} box
   * @return {boolean}
   */
  isInBox(e, t) {
    return e.x > t.left && e.x < t.right && e.y > t.top && e.y < t.bottom;
  }
  getTaxonKey(e) {
    const t = this.findById(e);
    return t.ta_id + "-" + t.taxon_id;
  }
  isVisible(e) {
    const t = this.findById(e), i = J.getOne().copy(t);
    this.publish(q.EVENT.CHECK_VISIBILITY, i);
    const r = i.isSelected;
    return J.recycle(i), r;
  }
  /**
   * @param {Point} point
   * @param {Function} transformation
   */
  create({ point: e, transformation: t = kn }) {
    const i = J.getOne().copy(e);
    return t(i), i;
  }
  /**
   * @param {Object} settings
   * @param {Point} settings.point
   * @param {Function} settings.transformation
   */
  getTransformCoordinate(e) {
    const t = this.create(e), i = {
      x: t.x,
      y: t.y
    };
    return this.recycle(t), i;
  }
  /**
   * @param {Object} settings
   * @param {Point} settings.point
   * @param {Function} settings.transformation
   */
  refreshContextualCoords(e) {
    const t = this.getTransformCoordinate(e);
    return e.point.contextual_x = t.x, e.point.contextual_y = t.y, t;
  }
  update(e, t) {
    Object.values(this.data.resources.availables).find((i) => {
      let r = !0;
      return Object.keys(e).forEach((n) => {
        r = r && i.hasOwnProperty(n) && i[n] === e[n];
      }), r;
    }).forEach((i) => {
      Object.keys(t).forEach((r) => {
        i.hasOwnProperty(r) && (i[r] = t[r]);
      });
    });
  }
  setPointSelected(e) {
    this.selectedPoints = e;
  }
  getUnselectedPoints() {
    return this.unselectPoints;
  }
  setPointHelper(e) {
    this.pointHelper !== e && (this.pointHelper = e);
  }
  getCoordsPoint(e) {
    return this.pointHelper.getCoordsPoint(e);
  }
  getMaxDistance() {
    return this.pointHelper.getMaxDistance();
  }
  onPointerUp(e, t) {
    this.pointHelper.onPointerUp(e, t);
  }
  onUpdatePointStyle(e, t, i) {
    this.pointHelper.onUpdatePointStyle(e, t, i);
  }
  isActivePoint(e) {
    const t = this.getActives();
    for (let i = 0; i < t.length; i++)
      if (t[i].id === parseInt(e))
        return !0;
    return !1;
  }
}
q.EVENT = {
  SELECTED: "point-selected",
  UNSELECTED: "point-unselected",
  HOVER: "point-hover",
  LOOSE_HOVER: "point-loose-hover",
  CHECK_VISIBILITY: "point-check-visibility",
  UPDATE_ACTIVE: "point-update-actives",
  CLICK: "point-click",
  RESET_ALL_PRIORITY: "point-reset-all-priority",
  ALL_POINT_DRAWN: "all-point-drawn"
};
class rt {
  constructor(e, t) {
    this.name = e, this.animationsHandlers = t;
  }
  trigger() {
    let e = 0;
    const t = this.animationsHandlers.length;
    for (; e < t; )
      this.animationsHandlers[e].start(), e++;
  }
}
class ga {
  constructor(e = {}) {
    this.tick = this.loop.bind(this);
  }
  loop() {
  }
  prepareNextTick() {
  }
  start() {
    this.prepareNextTick();
  }
}
class Lr extends ga {
  constructor(e = {}) {
    super(e), this.name = e.name, this.isPlaying = !1, this.nextRenderingPulled = !1;
  }
  stop() {
    this.isPlaying = !1;
  }
  start() {
    this.isPlaying = !0, super.start();
  }
  /**
   * Implement the rendering business. This method will be invoked a lot. Optimize it as much as you can !
   * @returns {boolean} loop is still running ?
   */
  loop() {
    return this.nextRenderingPulled = !1, this.prepareNextTick();
  }
  /**
   * Prepare next iteration if needed
   * @returns {boolean} another iteration in rendering loop was planned or not ?
   */
  prepareNextTick() {
    if (this.isPlaying && !this.nextRenderingPulled)
      this.nextRenderingPulled = !0, window.requestAnimationFrame(this.tick);
    else
      return !1;
  }
}
class va extends Lr {
  constructor(e = {}) {
    super({ name: "animation-manager" }), this.animationItem = [];
  }
  loop() {
    let e = 0;
    const t = this.animationItem.length;
    let i = 0;
    for (; e < t; ) {
      const r = this.animationItem[e];
      r.shouldRefresh() && (r.loop(), i++), e++;
    }
    return i === 0 && this.stop(), super.loop();
  }
  add(e) {
    this.animationItem.push(e);
  }
}
class Or extends Lr {
  constructor(e = {}) {
    super(e), this.application = e.application, this.manager = e.manager, this.manager.add(this);
  }
  shouldRefresh() {
    return this.isPlaying;
  }
  loop(e, t) {
    return this.shouldRefresh();
  }
  start() {
    this.isPlaying = !0, this.manager.start();
  }
}
class Ot extends Or {
  constructor(e = {}) {
    super(e), this.counter = 0;
  }
  resetCounter() {
    this.counter = 0;
  }
  shouldRefresh() {
    return this.counter > 0 && super.shouldRefresh();
  }
  loop() {
    return this.resetCounter(), super.loop();
  }
  start() {
    this.counter++, super.start();
  }
}
class ya extends Ot {
  loop() {
    return this.application.clearOverlays(), this.application.redrawSliceMetadata(), this.application.redrawOverlays(), this.application.showMetaCanvas(), super.loop();
  }
}
class Ea extends Ot {
  loop() {
    return this.application.services.image.getCurrent() !== null ? this.application.redrawImageCanvas() : this.application.redrawImageCanvas(this.application.services.image.latestImageThatShouldBeDrawnId), super.loop();
  }
}
class Gt extends Or {
  constructor(e = {}) {
    super(e), this.application = e.application, this.manager = e.manager, this.manager.add(this), this.interaction = null;
  }
  setInteraction(e) {
    this.interaction = e, this.interaction.setAnimationItem(this);
  }
}
class Ia extends Gt {
  constructor(e) {
    super(e), this.setInteraction(this.application.services.interaction.findById("scroll"));
  }
  loop() {
    this.interaction.onAnimation();
  }
}
class Ca extends Ot {
}
class _a extends Ot {
  loop() {
    return this.application.clearOverlays(), this.application.redrawOverlays(), super.loop();
  }
}
class Ta extends Gt {
  constructor(e) {
    super(e), this.setInteraction(this.application.services.interaction.findById("pan"));
  }
  getDelta() {
    const e = this.interaction.services.pointer.getCoords(), t = e.x - this.interaction.lastX, i = e.y - this.interaction.lastY;
    return this.interaction.lastX = e.x, this.interaction.lastY = e.y, {
      x: t,
      y: i
    };
  }
  loop() {
    const e = this.application, t = this.getDelta();
    e.translateCanvas(t.x, t.y), e.animations.redrawFullSlice.trigger();
  }
}
class Sa extends Gt {
  constructor(e) {
    super(e), this.setInteraction(this.application.services.interaction.findById("zoom"));
  }
  loop() {
    const e = this.interaction.getScaleOffset();
    e !== 0 && this.application.zoomOnCoords(this.interaction.zoomFocusPoint.getX(), this.interaction.zoomFocusPoint.getY(), e);
  }
}
class ba extends Ot {
  loop() {
    if (this.application.data.drawingIsAllowed === !0) {
      const e = this.application.services.slice.getCurrentRelativeIndex();
      this.application.moveToSlice(e + Qe.FORWARD);
    }
    return super.loop();
  }
}
class Aa extends Ot {
  loop() {
    if (this.application.data.drawingIsAllowed === !0) {
      const e = this.application.services.slice.getCurrentRelativeIndex();
      this.application.moveToSlice(e + Qe.BACKWARD);
    }
    return super.loop();
  }
}
function wa(s) {
  const e = new va();
  s.data.manager = e, new Ia({ application: s, manager: e }), new Ta({ application: s, manager: e }), new Sa({ application: s, manager: e });
  const t = new Ea({ application: s, manager: e }), i = new ya({ application: s, manager: e }), r = new _a({ application: s, manager: e });
  s.animations.loop = new rt("loop", [new Ca({ application: s, manager: e })]), s.animations.moveToNextSlice = new rt("move-to-next-slice", [
    new ba({ application: s, manager: e })
  ]), s.animations.moveToPreviousSlice = new rt("move-to-previous-slice", [
    new Aa({ application: s, manager: e })
  ]), s.animations.redrawFullSlice = new rt("full-slice", [
    t,
    i
  ]), s.animations.redrawOnlyImage = new rt("only-image", [
    t
  ]), s.animations.redrawOnlyOverlays = new rt("only-overlays", [
    r
  ]), s.animations.redrawOnlySliceMeta = new rt("only-slice", [
    i
  ]);
}
class ne extends Oe {
  constructor(e = {}) {
    super(e);
    const t = {};
    e.subscriber_id && (t._id = e.subscriber_id), this.agent = new re(t);
  }
  bindSubscriptions(e) {
    this.clearSubscriptions(), this.createSubscriptionsFromList(this.agent, this.subscribe(e));
  }
  subscribe(e) {
    return [];
  }
  createSubscriptionsFromList(e, t) {
    t.forEach((i) => {
      let r;
      typeof i.restrict == "function" ? r = (n) => {
        i.restrict(n) && i.action(n);
      } : r = i.action, Array.isArray(i.name) ? i.name.forEach((n) => {
        this.agent.subscribe(
          i.from,
          n,
          r
        );
      }) : this.agent.subscribe(
        i.from,
        i.name,
        r
      );
    });
  }
  clearSubscriptions() {
    const e = Object.values(this.agent.core.subscriptions);
    try {
      e.forEach((t) => {
        t.forEach((i) => {
          i.unsubscribe();
        });
      });
    } catch (t) {
      console.error(t);
    } finally {
      this.agent.core.subscriptions = [];
    }
  }
  init(e) {
    this.bindSubscriptions(e);
  }
  destroy() {
    this.agent.destroy();
  }
}
class Vi extends Error {
  constructor(e) {
    super(`Missing parameter "${e}"`), this.name = this.constructor.name;
  }
}
class di extends Error {
  constructor(e, t) {
    super(`The request "${e}" has failed, error code: ${t}`), this.name = this.constructor.name;
  }
}
class F {
  static apiKey = null;
  static needUserId = !1;
  static baseURL = "";
  static imageBaseURL = Zn;
  static APIUserId = null;
  static timestamp = null;
  static token = null;
  static scholarlyiqId = null;
  static APIClientId = null;
  static addHeader(e, t, i) {
    typeof window.Headers < "u" && e instanceof Headers ? e.append(t, i) : e[t] = i;
  }
  static fetch(e, t = { method: "GET" }) {
    return t.credentials = "same-origin", typeof F.apiKey == "string" && F.apiKey.length > 0 && (typeof t.headers > "u" && (t.headers = typeof window.Headers < "u" ? new Headers() : {}), F.addHeader(t.headers, Nt.CLIENT_URL, h.getClientURL()), F.addHeader(t.headers, Nt.KEY, F.apiKey), F.needUserId && (F.addHeader(t.headers, Nt.CLIENT_USERID, F.APIUserId), F.addHeader(t.headers, Nt.CLIENT_TIMESTAMP, F.expire), F.addHeader(t.headers, Nt.CLIENT_TOKEN, F.token))), imaios.fetch(e, t);
  }
  static async setAPIClientInfo(e, t, i) {
    let r;
    const n = `${F.baseURL}/api/embed-client`;
    try {
      r = await F.fetch(n);
    } catch (o) {
      throw new di(n, o);
    }
    const a = await r.json();
    if (typeof a.scholarlyiq_id < "u" && (F.scholarlyiqId = a.scholarlyiq_id), typeof a.client_id < "u" && (F.APIClientId = a.client_id), a.user_token_required === !0) {
      if (F.needUserId = !0, F.expire = i, F.APIUserId = e, F.token = t, e === null)
        throw new Vi("userId");
      if (i === null)
        throw new Vi("timestamp");
    }
  }
  static async getDataModule(e, t, i) {
    return (await F.fetch(`${F.baseURL}/${i}/api/${t}/module/${e}`)).json();
  }
}
class La extends Error {
  constructor(e, t, i) {
    super(`The request "${e}" can't be parsed, the content-type received is "${t}" but excepted "${i}"`), this.name = this.constructor.name;
  }
}
class st extends re {
  constructor(e = {}) {
    super(e), this.data = e.data;
  }
  getResourceName() {
    return "";
  }
  getResourceSubName() {
    return "";
  }
  async parseResponse(e, t) {
    if (e.headers.get("content-type") !== Hi)
      throw new La(e.url, e.headers.get("content-type"), Hi);
    return e.json();
  }
  async getData(e) {
    let t = null;
    const i = this.getResourcesUrl(e);
    try {
      t = await F.fetch(i);
    } catch {
      throw new di(i, "Unable to fetch");
    }
    if (t.status !== 200)
      throw new di(i, t.status);
    return this.parseResponse(t, e);
  }
  getResourcesUrl({ application_id: e, module_id: t }) {
    const i = this.getResourceSubName();
    let r = `${F.baseURL}/en/api/${e}/${this.getResourceName()}/${t}`;
    return i !== "" && (r += `/${i}`), r;
  }
}
class Mr extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
let Oa = 0;
class bt extends re {
  /**
   * @param {Object} providerSettings
   * @param {Object} providerSettings.resourcesURL
   * @param {Object} providerSettings.state
   * @param {ModuleState} providerSettings.state.module
   * @param {Object} providerSettings.services
   * @param {SliceService} providerSettings.services.slice
   */
  constructor(e = {}) {
    super({
      _id: e._id || `legacy-image-provider-${Oa++}`
    }), this.settings = e, this.zipURL = {}, this.zip = {}, this.isSwitchingQuality = {}, e.resourcesURL && Object.keys(e.resourcesURL).forEach((t) => {
      this.zipURL[t] = e.resourcesURL[t], this.zip[t] = null, this.isSwitchingQuality[t] = !1;
    }), this.imageHelper = e.services["image-helper"], this.zipURL.current = null, this.zip.current = null, this.isLoadingZip = !1, this.state = {
      /** @type {ModuleState} **/
      module: e.state.module
    };
  }
  async getData() {
    return this.settings;
  }
  loadZip(e) {
    return this.isLoadingZip = !0, new Promise((t, i) => {
      this.publish(B.EVENT.LOADING_START, e), F.fetch(e).then((r) => (this.isLoadingZip = !1, r.arrayBuffer())).then((r) => In.loadAsync(r)).then((r) => {
        this.publish(B.EVENT.LOADING_END, e), t(r);
      }).catch((r) => {
        i(new Mr(r.message));
      });
    });
  }
  isQualityAvailable(e) {
    return this.zip[e] !== null;
  }
  setQuality(e) {
    this.zip.current = this.zip[e], this.zipURL.current = this.zipURL[e];
  }
  switchQuality(e) {
    if (!Object.values(Pt).includes(e))
      throw new Error(`Quality is not supported by this module (quality code: ${e})`);
    return new Promise((t, i) => {
      if (this.isLoadingZip === !1)
        if (this.isSwitchingQuality[e] = !0, this.isQualityAvailable(e))
          this.setQuality(e), this.isSwitchingQuality[e] = !1, t(e);
        else {
          const r = this.zipURL[e];
          e === Pt.HIGH && this.publish(B.EVENT.ASK_SHOW_PROGRESS), this.loadZip(r).then((n) => {
            this.zip[e] = n, e === Pt.HIGH && this.publish(B.EVENT.ASK_HIDE_PROGRESS), this.setQuality(e), this.isContentAvailable === !1 && (this.isContentAvailable = !0), this.publish(bt.EVENT.QUALITY_CHANGE), this.isSwitchingQuality[e] = !1, t(e);
          }).catch((n) => i(n));
        }
      else this.isSwitchingQuality[e] ? le([
        { from: this, name: bt.EVENT.QUALITY_CHANGE }
      ]).then(() => {
        t(e);
      }) : i();
    });
  }
  /**
   * @param {string} entry
   */
  getImageFile(e) {
    return new Promise((t) => {
      this.zip.current === null ? le(
        [
          { name: B.EVENT.LOADING_END, from: this }
        ]
      ).then(() => {
        t(this.zip.current.file(e));
      }) : t(this.zip.current.file(e));
    });
  }
  getImage(e = {}, t = B.PRIORITY.STANDARD) {
    return new Promise(async (i) => {
      const r = new Image();
      let n = e.key;
      if (e.image_id) {
        const o = e.image_id.split("-");
        typeof e.slice_id > "u" && (e.slice_id = o[0]), typeof e.code > "u" && (e.code = o[1]);
      }
      typeof n > "u" && (n = this.getImageKey(e));
      const a = await this.getImageFile(n);
      if (a === null)
        return i(null);
      try {
        a.async("arraybuffer").then((o) => {
          r.src = Sr(o);
        }), r.onload = () => {
          i(r);
        };
      } catch {
        console.error("unable to find image", e, n), i("");
      }
    });
  }
  getImageKey(e = {}) {
    return this.imageHelper.getImageKey(e);
  }
}
bt.EVENT = {
  QUALITY_CHANGE: "zip-image-provider-quality-change"
};
class Ma extends st {
  constructor(e) {
    super({
      name: "image-api-provider",
      _id: "image-api-provider"
    }), this.zipProvider = null, this.state = {
      /** @type {ModuleState} **/
      module: e.state.module
    }, this.initialized = !1;
  }
  getResourceName() {
    return "images";
  }
  async getData(e) {
    if (!this.initialized) {
      const t = await super.getData(e);
      this.zipProvider = new bt({
        ...e,
        ...t,
        _id: "legacy-zip-image-provider"
      }), [
        B.EVENT.LOADING_END,
        B.EVENT.ASK_SHOW_PROGRESS,
        B.EVENT.ASK_HIDE_PROGRESS
      ].forEach((i) => {
        this.subscribe(
          this.zipProvider,
          i,
          () => {
            this.publish(i);
          }
        );
      }), this.initialized = !0, this.data = t;
    }
    return this.data;
  }
  switchQuality(e) {
    return this.zipProvider.switchQuality(e);
  }
  getImage(e = {}, t = B.PRIORITY.STANDARD) {
    return this.zipProvider.getImage(e, t);
  }
}
class Na extends ne {
  constructor(e, t) {
    super(t), this.s3provider = e.services.image.providers.image, this.apiProvider = new Ma(e);
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: Nr.EVENT.SWITCH_IMAGE_PROVIDER,
        action: async () => {
          const t = e.services.image, i = t.getQuality();
          let r;
          t.providers.image !== this.apiProvider ? r = this.apiProvider : r = this.s3provider;
          const n = { ...e, module_id: e.state.module.id };
          n.services["image-helper"] = this.s3provider.imageHelper;
          const a = await r.getData(n);
          t.setImageProvider(r), await t.loadImages(a, i), e.redraw();
        }
      }
    ];
  }
}
const Nr = {
  EVENT: {
    SWITCH_IMAGE_PROVIDER: "switch-image-provider"
  }
}, Ra = (s, e) => {
  const t = new Na(s, e);
  return t.init(s), t;
};
class xa {
  getIEVersion() {
    const e = window.navigator.userAgent, t = e.indexOf("MSIE");
    return t > 0 ? parseInt(e.substring(t + 5, e.indexOf(".", t)), 10) : navigator.userAgent.match(/Trident\/7\./) ? 11 : 0;
  }
  isIE() {
    return this.getIEVersion() !== 0;
  }
  isFirefox() {
    return /Firefox\/[0-9.]+/.test(navigator.userAgent);
  }
  isScreenType(e) {
    switch (e) {
      case "xs":
        return window.innerWidth < 576;
      case "sm":
      case "small":
        return window.innerWidth >= 576;
      case "md":
        return window.innerWidth >= 768;
      case "lg":
        return window.innerWidth >= 992;
      case "xl":
        return window.innerWidth >= 1200;
      default:
        return !1;
    }
  }
  /**
   * @deprecated
   * @param fontName
   * @param fontSize
   * @return {number}
   */
  getTextHeightFromDiv(e, t) {
    const i = document.createElement("span");
    i.textContent = "Hg", i.style.fontFamily = e, i.style.fontSize = t;
    const r = document.createElement("div");
    r.blockContent = "Hg", r.style.display = "inline-block", r.style.width = "1px", r.style.height = "0px", r.style.webkitTextSizeAdjust = "none";
    const n = document.createElement("div");
    n.appendChild(i), n.appendChild(r), document.body.appendChild(n);
    const a = {};
    try {
      r.style.verticalAlign = "baseline", a.ascent = r.offsetTop - i.offsetTop, r.style.verticalAlign = "bottom", a.height = r.offsetTop - i.offsetTop, a.descent = a.height - a.ascent;
    } finally {
      n.parentNode.removeChild(n);
    }
    return a.height;
  }
  isMobile() {
    let e = !1;
    const t = navigator.userAgent || navigator.vendor || window.opera;
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t.substr(0, 4))) && (e = !0), e;
  }
  isTablet() {
    let e = !1;
    const t = navigator.userAgent || navigator.vendor || window.opera;
    return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t.substr(0, 4))) && !this.isMobile() && (e = !0), e;
  }
  isMobileOrTablet() {
    return this.isTablet() || this.isMobile();
  }
  isSafariBrowser() {
    const e = navigator.userAgent || navigator.vendor || window.opera;
    return /safari/igm.test(e) && !/chrome/igm.test(e);
  }
  getMobilePlatform() {
    let e = "Unknown OS";
    return navigator.appVersion.includes("iPad") || navigator.appVersion.includes("iPhone") ? e = xi.IOS : navigator.appVersion.includes("Android") && (e = xi.ANDROID), e;
  }
  isLeftClick(e) {
    return window.MouseEvent && e instanceof MouseEvent && e.button === wt.LEFT_CLICK || window.TouchEvent && e instanceof TouchEvent && e.changedTouches.length === 1;
  }
  isMacOS() {
    return typeof navigator.platform < "u" && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || typeof navigator.userAgentData < "u" && /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgentData.platform);
  }
}
const oe = new xa(), ie = {
  RIGHT_MENU: "right_menu",
  MODULE_GALLERY: "module_gallery",
  STRUCTURE_GALLERY: "structure_gallery",
  BOTTOM_GALLERY: "bottom_gallery",
  CROSS_REFERENCES_BUTTON: "cross_references_button",
  RIGHT_CLICK: "right_click",
  SHORTCUTS: "shortcuts",
  SLICE_COUNTER: "slice_counter",
  SCROLL: "scroll",
  ARROW: "arrow",
  CROSS_REFERENCES: "cross_references",
  CROSS_REFERENCES_DRAG: "cross-references_drag",
  SERIES_DROPDOWN: "series_dropdown_menu"
}, Gi = {
  "sna-anatomie": "autonomic-nervous-system-illustrations",
  "cerveau-anatomie": "brain-illustrations",
  cerveau: "axial-brain-mri",
  abdomen: "abdomen-pelvis-ct",
  "coude-arthroscanner": "arthrography-elbow-ct",
  "genou-arthroscanner": "arthrography-knee-ct",
  thorax: "axial-chest-ct",
  "aires-radiotherapie": "body-ct",
  "Head-Neck-CT": "head-neck-ct",
  rocher: "temporal-bone-ct",
  coeur: "coronary-arteries-cta",
  coronarographie: "coronarography",
  "nerfs-craniens-anatomie": "cranial-nerves-illustrations",
  "coeur-illustrations": "heart-illustrations",
  "mi-anatomie": "lower-extremity-illustrations",
  "poumons-illustrations": "lungs-illustrations",
  "brain-tof": "brain-mra",
  cheville: "ankle-hindfoot-mri",
  "Brachial-Plexus-MR": "brachial-plexus-mri",
  brain3dmri: "brain-mri",
  pelvis: "pelvis-mri",
  "hand-mr": "hand-mri",
  face: "face-ct",
  "face-cou-irm": "head-neck-mri",
  knee: "knee-mri",
  lowerlimb: "lowerlimb-mri",
  "Pelvis-Male-MR": "male-pelvis-mri",
  "pelvis-male-illustrations": "male-pelvis-illustrations",
  "mediastin-illustrations": "mediastinum-illustrations",
  shoulder: "shoulder-mri",
  "upper-limb": "upper-limb-mri",
  "membre-inferieur-radiographies": "lower-extremity-radiographs",
  "rachis-radios": "spine-radiographs",
  "ms-radios": "upper-extremity-radiographs",
  "moelle-spinale-anatomie": "spinal-cord-illustrations",
  "rachis-dos-anatomie": "spine-illustrations",
  "paroi-thorax-sein-illustrations": "thoracic-wall-breast-illustrations",
  "ms-anatomie": "upper-extremity-illustrations",
  "pet-ct": "whole-body-pet-ct",
  "lower-limb-arteries": "lower-limb-arteries-3d",
  "Bull-osteology-illustrations": "bull-osteology-illustrations",
  "Dog-Elbow-CT": "dog-elbow-ct"
}, Ii = {
  SET_PLACEMENT_IMAGE_VIEW: "set-placement-image-view"
}, Ke = {
  STRUCTURE_DETAILS: "structure_details",
  STRUCTURE_DETAILS_GALLERY: "structure_details_gallery",
  RIGHT_CLICK: "right_click",
  SEARCH: "search"
}, Rr = "|", xr = [
  {
    name: "reverse-scroll",
    translationKey: "keyboard-panel.reverse-scroll",
    shortcutKey: {
      keys: "i",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.behave("reverseScrolling", ie.SHORTCUTS);
      }
    }
  },
  {
    name: "viewzone",
    translationKey: "keyboard-panel.viewzone",
    shortcutKey: {
      keys: "m",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.toggleViewzone(null, ie.SHORTCUTS), s.preventDefault();
      }
    }
  },
  {
    name: "practice",
    translationKey: "keyboard-panel.practice",
    shortcutKey: {
      keys: "p",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.toggleQuizMode(ie.SHORTCUTS), s.preventDefault();
      }
    }
  },
  {
    name: "toggle-overlays",
    translationKey: "keyboard-panel.toggle-overlays",
    shortcutKey: {
      keys: "o",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        s.preventDefault(), e?.toggleOverlays();
      }
    }
  },
  {
    name: "hide-labels",
    translationKey: "keyboard-panel.hide-labels",
    shortcutKey: {
      keys: "h",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.toggleLabels(), s.preventDefault();
      }
    }
  },
  {
    name: "show-hidden-structures",
    translationKey: "keyboard-panel.show-hidden-structures",
    shortcutKey: {
      keys: "ctrl+h",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        s.preventDefault(), !e.data?.labelCanvasHidden && e.clearAllHiddenStructures();
      }
    }
  },
  {
    name: "show-hidden-cross-references",
    translationKey: "keyboard-panel.show-hidden-cross-references",
    shortcutKey: {
      keys: "c",
      triggerOncePerPression: !0,
      keydown: (s) => {
        h.store.dispatch("menu/cross-references:toggle"), s.preventDefault();
      }
    }
  },
  {
    name: "weightings",
    translationKey: "keyboard-panel.weightings",
    shortcutKey: {
      keys: "w",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.nextContrast(), s.preventDefault();
      }
    }
  },
  {
    name: "scroll",
    translationKey: "keyboard-panel.scroll",
    shortcutKey: {
      keys: "a",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.selectInteraction(ke.SCROLL);
      }
    }
  },
  {
    name: "zoom",
    translationKey: "keyboard-panel.zoom",
    shortcutKey: {
      keys: "z",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.selectInteraction(ke.ZOOM);
      }
    }
  },
  {
    name: "pan",
    translationKey: "keyboard-panel.pan",
    shortcutKey: {
      keys: "e",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.selectInteraction(ke.PAN), s.preventDefault();
      }
    }
  },
  {
    name: "reset",
    translationKey: "keyboard-panel.reset",
    shortcutKey: {
      keys: "r",
      triggerOncePerPression: !0,
      keydown: (s) => {
        h.store.dispatch("anatomy/reset"), s.preventDefault();
      }
    }
  },
  {
    name: "save",
    translationKey: "keyboard-panel.save",
    shortcutKey: {
      keys: "s",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.behave("saveImage"), s.preventDefault();
      }
    }
  },
  {
    name: "fullscreen",
    translationKey: "keyboard-panel.fullscreen",
    shortcutKey: {
      keys: "f",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.behave("toggleFullScreen"), s.preventDefault();
      }
    }
  },
  {
    name: "cine",
    translationKey: "keyboard-panel.cine",
    shortcutKey: {
      keys: " ",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.behave("loop-through-slices"), s.preventDefault();
      },
      specificKey: "space"
    }
  },
  {
    name: "next-image",
    translationKey: "keyboard-panel.next-image",
    shortcutKey: {
      keys: "arrowright|up|right|arrowdown",
      triggerOncePerPression: !0,
      keydown: (s, e) => {
        e.triggerGoToNextSlice(), s.preventDefault(), e.publish("keydown.arrowdown");
      },
      components: [
        {
          type: "vue",
          name: "RightArrowSVG",
          style: "transform: rotate(90deg)"
        },
        {
          type: "vue",
          name: "RightArrowSVG"
        }
      ]
    }
  },
  {
    name: "previous-image",
    translationKey: "keyboard-panel.previous-image",
    shortcutKey: {
      keys: "arrowup|arrowleft|left|down",
      keydown: (s, e) => {
        e.triggerGoToPreviousSlice(), s.preventDefault(), e.publish("keydown.arrowup");
      },
      components: [
        {
          type: "vue",
          name: "LeftArrowSVG"
        },
        {
          type: "vue",
          name: "LeftArrowSVG",
          style: "transform: rotate(-90deg)"
        }
      ]
    }
  }
];
class k extends re {
  /**
   * @param {Object} settings
   * @param {string} settings.containerId
   * @param {ViewerHelper} settings.viewerHelper
   *
   * @param {Object} settings.state
   * @param {ViewerState} settings.state.viewer
   * @param {PointerState} settings.state.pointer
   * @param {ImageState} settings.state.image
   * @param {LanguageState} settings.state.language
   * @param {ContrastState} settings.state.contrast
   * @param {SeriesState} settings.state.series
   *
   * @param {Object} settings.services
   * @param {FilterService} settings.services.filter
   * @param {ContrastService} settings.services.contrast
   * @param {PointService} settings.services.point
   * @param {ImageService} settings.services.image
   * @param {StructureService} settings.services.structure
   * @param {TranslatorService} settings.services.translator
   * @param {SliceService} settings.services.slice
   * @param {SeriesService} settings.services.series
   * @param {LanguageService} settings.services.language
   * @param {InteractionService} settings.services.interaction
   * @param {StyleService} settings.services.style
   * @param {SearchService} settings.services.search
   *
   * @param {Number} settings.defaultLanguageId
   * @param {Number} settings.currentLanguageId
   *
   * @param {PointService} settings.pointService
   * @param {StructureService} settings.structureService
   *
   * @param {Object} settings.components
   * @param {Object} settings.components.viewzone
   *
   * @param {Interaction[]} settings.interactions
   *
   * @param {RoiService} settings.roi
   * @param {DebugService} settings.debug
   *
   */
  constructor(e = {}) {
    const t = e.features;
    delete e.features, super({
      name: "application-core-component",
      _id: "application-core-component",
      ...e,
      features: t
    }), this.components = {}, this.application_id = e.application_id, this.parentContainer_id = e.parentContainer_id, this.modes = {
      scroll: Ir.STANDARD
    }, this.animations = {}, this.data = {}, this.data.custom_id = h.id, this.data.currentColor = "#FFFFFF", this.data.overlaysDrawn = !1, this.data.menuIsPinned = !1, this.data.isDirty = !1, this.data.labelMode = ct.STANDARD, this.labelModeHandler = {
      standard: (i) => this.standardGetLabelText(i)
    }, this.data.drawingIsAllowed = !1, this.data.fontSizeAuto = !0, this.loadUserAccess(), this.providers = {
      iconSource: e.providers.iconSource,
      crImages: e.providers.crImages,
      orientationImage: e.providers.orientationImage,
      imageThumb: e.providers.imageThumb
    }, this.generateComponents(e), this.data.lastSeriesSize = {
      width: 0,
      height: 0
    }, this.data.scrollDirection = Qe.FORWARD, this.pointsWithLabel = /* @__PURE__ */ new Set(), this.data.hasAccess = !1, this.services.language.setInterfaceLanguage(e.interfaceLanguageId), this.data.isFirstRendering = !0, this.subscribeToPointerController(), this.subscribe(
      this.services.interaction,
      Lt.EVENT.CHANGE,
      (i) => {
        this.ui.container.setAttribute("data-interaction", i);
      }
    ), this.subscribe(this, k.EVENT.STATE_HAS_BEEN_INITIALIZED, () => this.onReady()), this.data.hasFocus = !1, this.hideMetaCanvas(), typeof window.IMAIOS_ANATOMY.instances > "u" && (window.IMAIOS_ANATOMY.instances = {}), window.IMAIOS_ANATOMY.instances[this.data.custom_id] = {}, this.exposeFunctionForScrapper();
  }
  /**
   * @deprecated
   * @returns {boolean}
   */
  isCurrentImageAvailable() {
    const e = this.services.image.getCurrent();
    return !(e === null || e.width === 0);
  }
  onSetup(e = {}) {
    this.viewerHelper = e.viewerHelper, this.state = {
      pointer: e.state.pointer,
      // viewer: settings.state.viewer,
      module: e.state.module
    }, this.ui.container = this.viewerHelper.retrieveContainer(e.containerId), this.ui.container.classList.add("application-anatomy-container"), e.width = this.ui.container.offsetWidth, e.height = this.ui.container.offsetHeight, this.services = {
      /** @type {LanguageService}**/
      language: e.services.language,
      /** @type {TranslatorService}**/
      translator: e.services.translator,
      /** @type {FilterService}**/
      filter: e.services.filter,
      /** @type {PointService}**/
      point: e.services.point,
      /** @type {ImageService}**/
      image: e.services.image,
      /** @type {StructureService}**/
      structure: e.services.structure,
      /** @type {SliceService}**/
      slice: e.services.slice,
      /** @type {SeriesService}**/
      series: e.services.series,
      /** @type {OrientationService}**/
      orientation: e.services.orientation,
      /** @type {ContrastService}**/
      contrast: e.services.contrast,
      /** @type {InteractionService}**/
      interaction: e.services.interaction,
      /** @type {ModalityService}**/
      modality: e.services.modality,
      /** @type {StyleService}**/
      style: e.services.style,
      /** @type {LabelService}**/
      label: e.services.label,
      /** @type {StandardLabelsDrawerService}**/
      labelsDrawer: e.services.labelsDrawer,
      /** @type {RenderingContextService}**/
      renderingContext: e.services.renderingContext,
      /** @type {OverlayService}**/
      overlay: e.services.overlay,
      /** @type {TextOverlayService}**/
      textOverlay: e.services.textOverlay,
      /** @type {TransformService}**/
      transform: e.services.transform,
      /** @type {PointerService}**/
      pointer: e.services.pointer,
      /** @type {StandardPointDrawer} **/
      pointDrawer: e.services.pointDrawer,
      imageHelper: e.services["image-helper"],
      icon: e.services.icon,
      /** @type {SearchService} */
      search: e.services.search,
      /** @type {RoiService} */
      roi: e.services.roi,
      /** @type {DebugService} */
      debug: e.services.debug
    }, this.handlers = {
      keyboard: new pa({
        handler: this.getShortcutHandlers(),
        component: this
      }),
      pointer: new $({
        state: e.state,
        target: this.ui.container,
        clickSensitivity: {
          min: 82,
          max: 210
        }
      })
    };
  }
  toggleQuizMode(e) {
    this.publish("toggle-quiz-mode", e);
  }
  getMainsFiltersId() {
    return this.services.filter.data.resources.main_id;
  }
  generateComponents(e = {}) {
    this.viewerHelper.generateComponents(this, e);
  }
  /**
   * @deprecated
   * @returns {boolean}
   */
  areInteractionsEnabled() {
    return this.state.viewer.data.interaction.enabled === !0;
  }
  /**
   * @deprecated
   * @returns {boolean}
   */
  isSlowScrollMode() {
    const e = this.getCurrentSeries().modality_id;
    return e === he.SCHEMA || e === he.RX;
  }
  getCenter() {
    return {
      x: this.components.imageCanvas.getWidth() / 2,
      y: this.components.imageCanvas.getHeight() / 2
    };
  }
  subscribeToPointerController() {
    const e = document.getElementById(this.parentContainer_id);
    e.addEventListener("mouseleave", () => {
      this.data.hasFocus = !1;
    }), e.addEventListener("mouseenter", () => {
      this.data.hasFocus = !0;
    }), this.subscribe(
      this.handlers.pointer,
      $.EVENT.POINTER_MOVE,
      /**
       * @param event
       */
      (i) => {
        if (this.state.pointer.isDown === !0) {
          const n = this.services.interaction.getCurrent();
          n !== null && n.isPerforming && n.onMouseMove(i);
        }
      }
    ), this.subscribe(
      this.handlers.pointer,
      $.EVENT.POINTER_LEAVE,
      (i) => {
        const r = this.services.interaction.getCurrent();
        r !== null && r.isPerforming === !0 && r.onMouseLeave(i);
      }
    ), this.subscribe(
      this.handlers.pointer,
      $.EVENT.POINTER_DOWN,
      /** @param {PointerEvent} event */
      (i) => {
        i.type === "touchstart" && (i.preventDefault(), i.stopImmediatePropagation());
        const n = this.services.interaction.getCurrent();
        n !== null && this.services.point.hasHover() !== !0 && (n.isPerforming === !0 ? n.onMouseDown(i) : this.startInteraction(i));
      }
    );
    const t = (i) => {
      const r = this.services.interaction.getCurrent();
      r !== null && (r.isPerforming === !0 || r.isInPause === !0) && r.onMouseUp(i);
    };
    this.subscribe(
      this.handlers.pointer,
      $.EVENT.TOUCH_END,
      t
    ), this.subscribe(
      this.handlers.pointer,
      $.EVENT.POINTER_UP,
      /** @param {PointerEvent} event */
      t
    );
  }
  startInteraction(e) {
    const t = this.services.interaction.getCurrent();
    t.start(e), this.publish(ce.EVENT.START, t.name);
  }
  destroy() {
    super.destroy(), Object.values(this.components).forEach((e) => {
      e.destroy();
    });
  }
  setLabelDrawer(e) {
    this.services.labelsDrawer !== e && (this.services.labelsDrawer = e, this.publish(X.EVENT.CHANGE));
  }
  setPointDrawer(e) {
    this.services.pointDrawer !== e && (this.services.pointDrawer = e);
  }
  scaleViewZone(e, t) {
    const i = this.components.viewzone, r = i.isEnabled(), { centerX: n, centerY: a } = i.getCoords();
    i.show({
      x: n * e,
      y: a * t
    }), r === !1 && i.focus();
  }
  setScale(e) {
    this.services.renderingContext.setScale(e), this.scaleCanvas(e, e);
  }
  redrawSliceMetadata() {
    this.redrawSlicePoints(), this.redrawLabels();
  }
  allowsDrawing() {
    this.data.drawingIsAllowed = !0;
  }
  drawOnlyLinkedPoint() {
    const e = this.services.point.getAllLinked(), t = Object.keys(e).map((i) => e[i]);
    this.publish(k.EVENT.GET_SELECTED_POINTS, t), this.services.pointDrawer.drawPoints(t, this.components.pointsCanvas);
  }
  redrawSlicePoints() {
    this.components.pointsCanvas.redraw(this), this.publish(q.EVENT.ALL_POINT_DRAWN);
  }
  /**
   * @deprecated
   */
  updateZoomLimit() {
    const e = this.components.pointsCanvas, t = e.getWidth(), i = e.getHeightAvailable(), r = t / i, n = this.services.series.getCurrent(), a = n.canvas_width, o = n.canvas_height, l = a / o;
    let c;
    const u = this.services.renderingContext.get(H.ATTRIBUTE.MULTIPLIER);
    l < r ? c = i / o / u : c = t / a / u, this.services.renderingContext.setScale(c), this.updateScaleLevel(c);
  }
  translateCanvas(e, t) {
    const i = this.components.imageCanvas;
    this.setTransformCanvas(
      i.getScaleX(),
      i.getSkewX(),
      i.getSkewY(),
      i.getScaleY(),
      i.getTx() + e,
      i.getTy() + t
    );
  }
  resetTransformCanvas(e = !0) {
    this.reset(e), this.setTransformCanvas(1, 0, 0, 1, 0, 0);
  }
  setTransformCanvas(e, t, i, r, n, a) {
    this.components.imageCanvas.setTransform(e, t, i, r, n, a), this.components.pointsCanvas.setTransform(e, t, i, r, n, a), this.components.overlaysCanvas.setTransform(e, t, i, r, n, a);
  }
  clearLines() {
    this.components.leftLinesCanvas.clearCanvas(0, 0, this.components.leftLinesCanvas.getWidth(), this.components.leftLinesCanvas.getHeight(), !1), this.components.rightLinesCanvas.clearCanvas(0, 0, this.components.rightLinesCanvas.getWidth(), this.components.rightLinesCanvas.getHeight(), !1);
  }
  getLabelMode() {
    return this.data.labelMode;
  }
  setImageOverlaysOpacity(e) {
    this.services.overlay.setImageOpacity(e);
  }
  getDefaultOverlayOpacity() {
    return this.services.overlay.getDefaultImageOverlayOpacity();
  }
  clearLabelCanvas() {
    const { LEFT_RIGHT_ALPHA: e } = this.services.style.get(), { LEFT_PADDING: t, RIGHT_PADDING: i } = this.services.renderingContext.get(), r = this.services.series.isSchema() ? me.WHITE : me.BLACK;
    this.components.leftLinesCanvas.drawRect(
      0,
      Tt,
      t,
      this.components.pointsCanvas.getHeight(),
      e,
      r
    ), this.components.rightLinesCanvas.drawRect(
      i,
      Tt,
      this.components.pointsCanvas.getWidth() - i,
      this.components.pointsCanvas.getHeight(),
      e,
      r
    );
  }
  /**
   * clear Labels
   */
  clearLabels() {
    this.clearLines(), this.services.label.clear(), this.services.point.getNbPointsToDraw() > 0 && this.clearLabelCanvas(), this.services.labelsDrawer.reset(), this.services.labelsDrawer.updateRangeFontSize();
  }
  /**
   *  compute new labels size and draw them
   */
  redrawLabels() {
    this.clearLabels();
    const { LEFT_RIGHT_THRESHOLD: e } = this.services.renderingContext.get(), t = this.services.labelsDrawer.dispatchPointBySide(
      this.services.point.getVisible(),
      e
    );
    this.drawLabels(t), this.publish(X.EVENT.ALL_LABEL_DRAWN);
  }
  clearOverlays() {
    this.components.overlaysCanvas.clear();
  }
  /**
   * @param {string} filter_id a filter to enable
   * @param {boolean} [mute=false] silences the onUnselect action
   */
  selectFilter(e, t = !1) {
    this.services.filter.select(e, t);
  }
  /**
   * @param {string} filter_id a filter to enable
   * @param {boolean} [mute=false] silences the onUnselect action
   */
  unselectFilter(e, t = !1) {
    this.services.filter.unselect(e, t);
  }
  selectAllFilters() {
    this.services.filter.selectAll();
  }
  unselectAllFilters() {
    this.services.filter.unselectAll();
  }
  getFilters(e) {
    const t = this.services.filter.getResources();
    return Object.keys(t).map((i) => {
      const r = { ...t[i] };
      return r.id = i, r.name = this.services.translator.getTranslation(r.name_id, V.NAMESPACE.UI, e), delete r.name_id, r;
    });
  }
  isFocused() {
    return this.data.hasFocus;
  }
  isFilterSelected(e) {
    return this.services.filter.isSelected(e);
  }
  standardGetLabelText(e) {
    const t = this.services.structure.findByTaxonKey(e);
    return this.services.translator.getTranslation(t.translation_key, V.NAMESPACE.CONTENT);
  }
  recordLabelMode(e, t) {
    this.labelModeHandler[e] = t;
  }
  setLabelMode(e) {
    typeof this.labelModeHandler[e] != "function" && (e = "standard"), this.data.labelMode = e;
  }
  getTextLabelByTaxonKey(e, t = null, i = null) {
    try {
      const r = this.labelModeHandler[this.data.labelMode];
      return r(e, t, i);
    } catch (r) {
      return console.error(r), "<MISSING TRANSLATION>";
    }
  }
  /**
   * @deprecated
   */
  onMouseLeave() {
    this.targetIsViewer = !1;
  }
  zoomOnCoords(e, t, i) {
    const {
      MULTIPLIER: r,
      MIN_SCALE: n,
      MAX_SCALE: a
    } = this.services.renderingContext.get(), o = this.components.imageCanvas.getComputedScaleX(), l = Math.min(Math.max(n, r * o + i), a) / r;
    this.publish(k.EVENT.ZOOM), this.rescale(l / o), this.updateScaleLevel(l);
    const c = i !== 0 ? -l + o : 1, u = e * c, m = t * c;
    this.translateCanvas(u, m), this.animations.redrawOnlySliceMeta.trigger(), this.animations.redrawOnlyImage.trigger(), this.animations.redrawOnlyOverlays.trigger();
  }
  redrawOverlays() {
    this.services.overlay.draw(
      this.components.overlaysCanvas,
      this.services.image,
      this.services.renderingContext,
      this.services.translator
    );
  }
  triggerGoToNextSlice() {
    this.animations.moveToNextSlice.trigger();
  }
  triggerGoToPreviousSlice() {
    this.animations.moveToPreviousSlice.trigger();
  }
  goToNextSlice() {
    if (this.data.drawingIsAllowed === !0) {
      const e = this.services.slice.getCurrentRelativeIndex();
      this.moveToSlice(e + this.data.scrollDirection);
    }
  }
  goToPreviousSlice() {
    if (this.data.drawingIsAllowed === !0) {
      const e = this.services.slice.getCurrentRelativeIndex();
      this.moveToSlice(e - this.data.scrollDirection);
    }
  }
  moveToSlice(e, t = !1, i = null) {
    if (!this.isModeFullSeries() && !this.services.slice.isInRange(e) && !t) {
      const r = {
        isAuthorizedToMove: !0
      };
      if (this.publish(k.EVENT.MOVE_TO_SLICE, r), r.isAuthorizedToMove) {
        const n = this.getSeries().map((l) => l.id), a = this.services.series.getCurrentId(), o = n.findIndex((l) => l === a);
        if (e > this.services.slice.sizeOfRelativeIndex() && o !== n.length - 1)
          this.moveToSeries(n[o + 1], 1, !0);
        else if (e < 1 && o > 0) {
          const l = this.services.series.findById(n[o - 1]);
          this.moveToSeries(l.id, l.number_of_images, !0);
        }
      }
    } else {
      e = this.services.slice.getRelativeIndexInRange(e), this.services.slice.setCurrentRelativeIndex(e), this.publish(k.EVENT.IMAGE_VIEW, {
        sliceIndex: e,
        placement: i
      });
      const r = this.services.slice.getCurrent().series_id;
      r !== this.services.series.getCurrentId() && this.services.series.setCurrent(r), this.loadFrame();
    }
  }
  drawLabels(e) {
    const t = {
      application: this,
      layers: {
        points: this.components.pointsCanvas,
        leftLabels: this.components.leftLinesCanvas,
        rightLabels: this.components.rightLinesCanvas,
        buffer: this.components.fakeImaiosCanvas
      },
      translator: (i, r, n) => this.getTextLabelByTaxonKey(i, r, n)
    };
    this.services.labelsDrawer.precomputeContext({
      ...t,
      candidates: e
    }), this.services.labelsDrawer.draw({
      ...t,
      side: "left",
      candidates: e.left
    }), this.services.labelsDrawer.draw({
      ...t,
      side: "right",
      candidates: e.right
    });
  }
  /**
   * @deprecated
   * @param zoomLevel
   */
  setFontZoomLevel(e) {
    const {
      FONT_ZOOM_MAX: t,
      FONT_ZOOM_MIN: i,
      FONT_ZOOM_LEVEL: r
    } = this.services.style.get();
    e = Math.max(i, Math.min(t, Math.ceil(e * 10) / 10)), e !== r && (this.services.style.update(
      L.ATTRIBUTE.FONT_ZOOM_LEVEL,
      e
    ), this.redrawLabels());
  }
  /**
   * @deprecated
   * @param points
   * @param maxWidth
   * @param fontSize
   * @returns {LabelToDrawInfos}
   */
  getHighestLabelInArray(e, t, i) {
    let r = 0, n = 0, a = 0, o = "", l = 0;
    this.components.fakeImaiosCanvas.setFontSize(i);
    const {
      MAX_LABEL_HEIGHT_WITH_LINES: c,
      NO_MAX_LINES: u
    } = this.services.style.get();
    for (let m = 0; m < e.length; m++) {
      let g;
      try {
        const I = this.services.structure.findByTaxonKey(e[m].taxon_key);
        g = this.services.translator.getTranslation(I.translation_key, V.NAMESPACE.CONTENT);
      } catch (I) {
        console.error(I), g = "";
      }
      const C = this.components.fakeImaiosCanvas.getLabelInfos(g, i, t, u);
      a = C.totalHeight, (a > r || a === r && g.length > n) && (r = a, n = g.length, o = g, l = C.nbLines), C.recycle();
    }
    return r > c && (r = c), Le.getOne(r, o, n, l);
  }
  onReady() {
    const {
      FONT_FAMILY: e,
      MAX_FONT_PX: t,
      MAX_LABEL_LINES: i
    } = this.services.style.get();
    this.services.style.update(
      L.ATTRIBUTE.MAX_LABEL_HEIGHT_WITH_LINES,
      oe.getTextHeightFromDiv(e, `${t}px`) * i
    ), wa(this), window.addEventListener("resize", () => {
      this.onResize();
    }, !1), this.data.lastContainerWidth = this.ui.container.offsetWidth, this.data.lastContainerHeight = this.ui.container.offsetHeight, this.resizeMainZone(), this.publish(k.EVENT.READY);
  }
  onResize() {
    this.data.isDirty || this.reset(), this.resize(), this.animations.redrawFullSlice?.trigger();
  }
  getFilterIcon(e) {
    const t = this.services.filter.findById(e);
    return this.getIcon(t.icon_id);
  }
  getIcon(e) {
    return this.services.icon.getIcon(e);
  }
  enablePointerListener() {
    this.handlers.pointer.enable();
  }
  /**
   * @deprecated
   */
  disablePointerListener() {
    this.handlers.pointer.disable();
  }
  /**
   * @deprecated
   * @return {boolean} true if listener is enabled, or false if it is disabled
   */
  isPointerListenerEnabled() {
    this.handlers.pointer.isEnabled();
  }
  rescale(e) {
    this.scaleCanvas(e, e);
  }
  /**
   * @deprecated
   */
  updateScale() {
    this.updateZoomLimit(), this.publish(k.EVENT.RESCALE);
  }
  /**
   * @param {String} interactionName
   */
  selectInteraction(e) {
    this.services.interaction.setCurrent(e);
  }
  getCurrentInteraction() {
    return this.services.interaction.getCurrentId();
  }
  changeBackgroundColors(e) {
    this.data.currentColor !== e && (this.data.currentColor = e, this.ui.container.style.backgroundColor = `#${e}`);
  }
  selectDisplaySeriesMode(e, t = 1) {
    e === yr ? this.services.slice.restoreDefaultIndex() : this.services.slice.updateRelativeIndexWith(
      this.services.slice.find({ series_id: e })
    ), this.moveToSlice(t);
  }
  hideMetaCanvas() {
    this.components.pointsCanvas.hide(), this.components.leftLinesCanvas.hide(), this.components.rightLinesCanvas.hide(), this.components.overlaysCanvas.hide();
  }
  showMetaCanvas() {
    this.components.pointsCanvas.show(), this.components.leftLinesCanvas.show(), this.components.rightLinesCanvas.show(), this.components.overlaysCanvas.show(), this.publish(k.EVENT.SHOW_META_CANVAS);
  }
  /**
   * @param {Number} relativeSliceIndex
   */
  loadFrame(e = null) {
    typeof e != "number" && (e = this.services.slice.getCurrentRelativeIndex());
    const t = this.services.slice.getIdByRelativeIndex(e), i = this.services.slice.findById(t), r = this.services.image.generateImageId({
      slice_id: t,
      sort_order: i.sort_order,
      code: this.services.contrast.getCurrentCode(),
      quality: this.services.image.getQuality(),
      type: Y.SLICE
    });
    this.services.image.setCurrent(r);
  }
  getContrasts(e) {
    const t = this.services.series.getCurrentId();
    return this.getAvailableContrastsBySeriesId(t, e);
  }
  getAvailableContrastsBySeriesId(e, t = null) {
    const i = this.services.contrast.data.resources.availables, r = Object.keys(i).filter((n) => ({ ...i[n] }).series_id === e).map((n) => {
      const a = { ...i[n] };
      return a.name = this.services.translator.getTranslation(a.name_id, V.NAMESPACE.UI, t), a;
    });
    return r.sort((n, a) => n.sort_order - a.sort_order), r.length === 0 && r.push(i[-1]), r;
  }
  /**
   * @param {string} contrast_id
   * @param setLastContrastCode
   */
  selectContrast(e, t = !0) {
    this.services.contrast.select(e, t);
  }
  isCurrentContrast(e) {
    return this.services.contrast.isCurrent(e);
  }
  nextContrast() {
    const e = this.getContrasts();
    if (e.length > 1) {
      const t = this.services.contrast.getCurrentId(), i = e.findIndex((n) => n.id === t), r = i < e.length - 1 ? i + 1 : 0;
      this.selectContrast(e[r].id);
    }
  }
  selectLanguage(e) {
    const t = this.services.language;
    t.isAvailable(e) && t.getCurrent() !== e && t.setCurrent(e);
  }
  resizeMainZone() {
    const {
      imageCanvas: e,
      pointsCanvas: t,
      overlaysCanvas: i,
      fakeImaiosCanvas: r,
      leftLinesCanvas: n,
      rightLinesCanvas: a,
      viewzone: o
    } = this.components, l = this.ui.container.offsetHeight, c = this.ui.container.offsetWidth, u = c / e.getWidth(), m = l / e.getHeight(), g = this.ui.container.style.marginLeft;
    e.resize(g, c, l), t.resize(g, c, l), r.resize(g, c, l), i.resize(g, c, l), o.resize(g, c, l), this.services.renderingContext.update(H.ATTRIBUTE.WIDTH_CONTAINER, e.getWidth()), this.services.renderingContext.update(H.ATTRIBUTE.HEIGHT_CONTAINER, t.getHeightAvailable());
    const C = window.devicePixelRatio;
    n.resize(g, Math.ceil(c * C), Math.ceil(l * C));
    const I = n.getCanvas().style;
    I.width = `${c}px`, I.height = `${l}px`, n.getCanvasContext().scale(C, C), a.resize(g, Math.ceil(c * C), Math.ceil(l * C));
    const p = a.getCanvas().style;
    p.width = `${c}px`, p.height = `${l}px`, a.getCanvasContext().scale(C, C), this.components.viewzone.isEnabled() === !0 && this.scaleViewZone(u, m);
  }
  reset(e = !0) {
    const t = this.services.renderingContext, {
      HORIZONTAL_FLIP: i,
      VERTICAL_FLIP: r,
      ROTATION_ANGLE: n,
      SCALE: a,
      USER_ZOOM_PERFORMED: o
    } = H.ATTRIBUTE;
    t.update(i, !1), t.update(r, !1), t.update(n, 0), t.update(a, 1), t.update(o, !1), this.resetCanvas(), e && this.animations.redrawFullSlice?.trigger(), this.data.isDirty = !1;
  }
  getPointHovered() {
    return this.services.point.getHover();
  }
  getStructureHovered() {
    return this.services.structure.getHover();
  }
  resize(e = !1) {
    const { imageCanvas: t } = this.components, i = t.getTx(), r = t.getTy(), n = this.ui.container.offsetHeight, a = this.ui.container.offsetWidth, o = a / t.getWidth(), l = n / t.getHeight();
    if (this.translateCanvas(i * o - i, r * l - r), this.services.image.getCurrent() !== null) {
      const { SCALE: c } = this.services.renderingContext.getAll();
      let u;
      const m = this.services.image.getFromCache(this.services.image.getCurrentId());
      m.width < m.height ? u = n / this.data.lastContainerHeight : u = a / this.data.lastContainerWidth, this.setScale(u), this.updateScaleLevel(u * c);
    }
    this.saveCanvas(), this.resizeMainZone(), this.services.renderingContext.updateRenderingContext(), this.data.lastContainerWidth = this.ui.container.offsetWidth, this.data.lastContainerHeight = this.ui.container.offsetHeight, e || this.publish(k.EVENT.RESIZED);
  }
  clearImageCanvas() {
    this.components.imageCanvas.clearCanvas(0, 0, this.components.imageCanvas.getWidth(), this.components.imageCanvas.getHeight(), !0);
  }
  drawImageCanvas(e) {
    this.services.image.draw(
      this.components.imageCanvas,
      this.services.renderingContext,
      e
    );
  }
  redrawImageCanvas(e = null) {
    this.services.image.getCurrent() !== null && (e === null && (e = this.services.image.getCurrentId()), this.clearImageCanvas(), this.scaleAndCenterImage(), this.drawImageCanvas(e), this.data.isFirstRendering && (this.publish(k.EVENT.RENDERING_FIRST_FRAME), this.data.isFirstRendering = !1));
  }
  /**
   * @deprecated
   */
  clearElements() {
    this.components.pointsCanvas.clearCanvas(0, 0, this.components.pointsCanvas.getWidth(), this.components.pointsCanvas.getHeight(), !0), this.components.overlaysCanvas.clearCanvas(0, 0, this.components.overlaysCanvas.getWidth(), this.components.overlaysCanvas.getHeight(), !0);
  }
  scaleCanvas(e, t) {
    this.services.transform.scale(this, {
      x: e,
      y: t
    });
  }
  saveCanvas() {
    this.services.transform.save(this);
  }
  restoreCanvas() {
    this.services.transform.restore(this);
  }
  verticalFlip() {
    this.onUserInteraction(), this.services.transform.verticalFlip(this);
  }
  horizontalFlip() {
    this.onUserInteraction(), this.services.transform.horizontalFlip(this);
  }
  /**
   * @param {Number} degrees angle in degree of central rotation
   */
  rotate(e) {
    this.onUserInteraction(), this.services.transform.rotate(this, e);
  }
  getViewport() {
    const e = this.components.pointsCanvas;
    return {
      width: e.getWidth(),
      height: e.getHeight() - e.paddingTop,
      top: e.paddingTop
    };
  }
  loadRoi(e, t, i, r) {
    const n = this.components.pointsCanvas, a = this.services.series.getCurrent(), { MULTIPLIER: o } = this.services.renderingContext.get(), l = {
      width: a.slices_width * o,
      height: a.slices_height * o
    };
    this.resetTransformCanvas();
    const c = n.getWidth(), u = n.getHeight(), m = this.getViewport(), g = e / t, C = m.width / m.height;
    let I;
    g < C ? I = m.height / t : I = m.width / e, this.translateCanvas(c / 2, (u + m.top) / 2), this.setScale(I), this.updateScaleLevel(I), this.translateCanvas(l.width / 2 * I, l.height / 2 * I), this.translateCanvas((-i - e / 2) * I, (-r - t / 2) * I), this.saveCanvas(), this.data.lastSeriesSize.width = a.slices_width * o, this.data.lastSeriesSize.height = a.slices_height * o;
  }
  scaleAndCenterImage() {
    const e = this.data.lastSeriesSize, t = this.getCurrentSeriesSize();
    if (!this.services.image.haveSameSize(e, t)) {
      this.resetTransformCanvas(!1);
      const i = this.components.pointsCanvas, r = i.getHeightAvailable(), n = i.getWidth(), a = n / r;
      let o, l, c;
      t.width / t.height < a ? (o = r / t.height, l = n / 2, c = t.height / 2 * o) : (o = n / t.width, l = t.width / 2 * o, c = r / 2);
      const m = this.components.imageCanvas.transformCoordinates(l, c + i.paddingTop, !0);
      this.translateCanvas(m.getX(), m.getY()), m.recycle(), this.setScale(o), this.updateScaleLevel(o), this.saveCanvas(), this.data.lastSeriesSize.width = t.width, this.data.lastSeriesSize.height = t.height;
    }
  }
  resetCanvas() {
    this.data.lastSeriesSize.width = 0, this.data.lastSeriesSize.height = 0;
  }
  getCurrentSeriesBackground() {
    const e = this.services.series.getCurrent();
    return e !== null ? e.background_color : me.BLACK;
  }
  getCurrentSeries() {
    const e = { ...this.services.series.getCurrent() };
    return e.name = this.services.translator.getTranslation(e.name_id, V.NAMESPACE.UI), delete e.name_id, e;
  }
  getSeries(e = null) {
    const t = this.services.series.getResources();
    return Object.keys(t).map((i) => {
      const r = { ...t[i] };
      return r.name = this.services.translator.getTranslation(r.name_id, V.NAMESPACE.UI, e), delete r.name_id, r;
    }).sort((i, r) => i.sort_order - r.sort_order);
  }
  getSeriesImage() {
    if (this.services.contrast.getDefault() !== null) {
      const e = this.getSeries();
      return Promise.all(e.map(async (t) => {
        const i = this.getSlicesSeries(t.id), r = this.services.modality.getIndexSlicePreview(t), n = await this.providers.imageThumb.getImage({
          sort_order: i[r].sort_order,
          type: Y.THUMBNAILS
        });
        return {
          id: t.id,
          src: n?.src,
          background_color: t.background_color
        };
      }));
    }
    return Promise.resolve([]);
  }
  getCurrentSlice(e = null) {
    const t = { ...this.services.slice.getCurrent() };
    if (t.title_1 = this.services.translator.getTranslation(t.title_id1, V.NAMESPACE.UI, e), t.title_2 = this.services.translator.getTranslation(t.title_id2, V.NAMESPACE.UI, e), t.orientation_id) {
      const i = this.services.orientation.getTranslationID(t.orientation_id);
      t.orientation = this.services.translator.getTranslation(i, V.NAMESPACE.UI, e);
    } else
      t.orientation = "";
    return t;
  }
  async getCrossReferences(e = null) {
    e === null && (e = this.services.language.getCurrent());
    const t = this.getCurrentSeries(), { cross_references_titles: i } = t;
    if (!Array.isArray(i))
      return Promise.resolve(null);
    i.sort((n, a) => n.sort_order - a.sort_order);
    const r = await Promise.all(i.map(async (n) => {
      const a = await this.providers.crImages.getImage({
        series: t,
        cr_sort_order: n.sort_order,
        type: Y.CROSS_REFERENCES
      }, B.PRIORITY.HIGH);
      return {
        name: this.services.translator.getTranslation(n.name_id, V.NAMESPACE.UI, e),
        name_id: n.name_id,
        destination: n.destination,
        src: a.src,
        imageDimensions: {
          width: a.width,
          height: a.height
        },
        ratio: a.width / a.height,
        sort_order: n.sort_order
      };
    }));
    return {
      series_id: t.id,
      crossReferences: r
    };
  }
  getSeriesHaveSameCR() {
    return Object.keys(this.services.series.seriesIdByCr).length > 0;
  }
  getSeriesIdByCR(e) {
    return this.services.series.seriesIdByCr[e] ?? [];
  }
  getCrossReferencesIndicators() {
    const e = this.getCurrentSlice(), { crossReferencesLines: t } = e;
    return t.sort((i, r) => i.sort_order - r.sort_order);
  }
  getCurrentLanguage() {
    return this.services.language.getCurrent();
  }
  getLanguages() {
    return Array.from(this.services.language.getResources());
  }
  setLanguage(e) {
    typeof e == "string" && (e = parseInt(e)), this.services.language.setCurrent(e);
  }
  getRelativeIndexCurrentSlice() {
    return this.services.slice.getCurrentRelativeIndex();
  }
  getNumberOfSlice() {
    return this.services.slice.sizeOfRelativeIndex();
  }
  isFullscreen() {
    return this.get("isFullScreen");
  }
  getSlices(e = null) {
    const t = this.services.slice.getResources();
    return Object.keys(t).map((i) => {
      const r = { ...t[i] };
      return r.title_1 = this.services.translator.getTranslation(r.title_id1, V.NAMESPACE.UI, e), r.title_2 = this.services.translator.getTranslation(r.title_id2, V.NAMESPACE.UI, e), delete r.title_id1, delete r.title_id2, r;
    });
  }
  getSlicesSeries(e) {
    return this.getSlices().filter((i) => i.series_id === e);
  }
  getRelativeSliceIndexById(e, t = null) {
    return this.services.slice.getRelativeIndexById(e, t);
  }
  getSeriesIdByIndex(e) {
    return this.services.series.getSeriesIdByIndex(e);
  }
  isModeFullSeries() {
    const e = this.services.slice.getTotalSlices(), t = this.getNumberOfSlice();
    return e === t;
  }
  getGalleryThumbnails(e, t) {
    if (this.services.contrast.getCurrent() !== null) {
      const i = this.services.contrast.findById(this.services.contrast.getDefault()).imaios_code, r = this.services.slice.sizeOfRelativeIndex(), n = Math.min(Math.floor(t / e), r);
      let a = 1;
      if (n === 0)
        return [];
      r > n && (a = (r - 1) / (n - 1));
      const o = [];
      for (let l = 0; l <= r && o.length < n; l += a) {
        const c = Math.max(1, Math.min(Math.round(l) + 1, r)), u = this.services.slice.getSliceByRelativeIndex(c);
        o.push(u);
      }
      return Promise.all(o.map((l) => new Promise((c) => {
        this.providers.imageThumb.getImage(
          {
            slice_id: l.id,
            sort_order: l.sort_order,
            code: i,
            quality: this.services.image.getQuality(),
            type: Y.THUMBNAILS
          },
          B.PRIORITY.HIGH
        ).then((u) => {
          c(u?.src);
        });
      })));
    }
    return Promise.resolve([]);
  }
  async getPreviewSlice(e) {
    const t = this.services.contrast.getResources()[this.services.contrast.getDefault()].imaios_code, i = this.services.slice.getSliceByRelativeIndex(e), r = this.services.translator.getTranslation(i.title_id1, V.NAMESPACE.UI), n = this.services.translator.getTranslation(i.title_id2, V.NAMESPACE.UI), a = this.services.series.findById(i.series_id), o = this.services.translator.getTranslation(a.name_id, V.NAMESPACE.UI), l = await this.providers.imageThumb.getImage({
      slice_id: i.id,
      sort_order: i.sort_order,
      code: t,
      type: Y.BOTTOM_PREVIEW_SLICE
    });
    return {
      title_1: r,
      title_2: n,
      titleSeries: o,
      src: l.src,
      relativeIndex: e
    };
  }
  getNumberMaxSlices() {
    return Object.keys(this.services.slice.getResources()).length;
  }
  getSeriesGallery(e = null) {
    if (this.services.contrast.getDefault() !== null) {
      const t = this.services.contrast.getResources()[this.services.contrast.getDefault()].imaios_code, i = this.getSeries(e);
      return Promise.all(i.map(async (r) => {
        const n = this.getSlicesSeries(r.id), a = this.services.modality.getIndexSlicePreview(r), o = await this.services.image.getImage({
          slice_id: n[a].id,
          code: t,
          quality: this.services.image.getQuality(),
          type: Y.GALLERY_THUMB
        });
        return {
          ...r,
          src: o.image?.src
        };
      }));
    }
    return Promise.resolve([]);
  }
  getSlicesGallery(e = null) {
    if (this.services.contrast.getDefault() !== null) {
      const t = this.services.contrast.getResources()[this.services.contrast.getDefault()].imaios_code, i = this.getSlices(e);
      return i.sort((r, n) => r.sort_order - n.sort_order), Promise.all(i.map((r) => new Promise((n) => {
        this.providers.imageThumb.getImage({
          slice_id: r.id,
          sort_order: r.sort_order,
          code: t,
          // quality: this.services.image.getQuality(),
          type: Y.GALLERY_THUMB
        }).then((a) => {
          n({
            ...r,
            src: a.src
          });
        });
      })));
    }
    return Promise.resolve([]);
  }
  async getImageAllSeries() {
    if (this.services.contrast.getDefault() !== null) {
      await this.getSeriesGallery();
      const e = await this.getSeriesImage(), t = [];
      if (e.length >= 4)
        for (let i = 0; i < 4; i++)
          t.push({
            src: e[i].src,
            background_color: e[i].background_color
          });
      else {
        e.forEach((i) => t.push({
          src: i.src,
          background_color: i.background_color
        }));
        for (let i = 0; i < 4 - e.length; i++)
          t.push({
            src: null,
            background_color: e[0].background_color
          });
      }
      return t;
    }
    return [];
  }
  getSliceIndexById(e) {
    return this.services.slice.getIndexById(e);
  }
  resetFilters() {
    this.services.filter.applyDefaultSettings();
  }
  resetContrast() {
    const e = this.services.contrast.getDefault();
    this.selectContrast(e);
  }
  moveToSeries(e, t = 1, i = !0) {
    this.publish(k.EVENT.MOVE_SERIES);
    const r = this.getCurrentSlice();
    if (this.isModeFullSeries() && i === !0) {
      const n = this.services.series.getSeriesById(e);
      n !== "undefined" && this.moveToSlice(n.start_index);
    } else (r.series_id !== e || i !== !0) && this.selectDisplaySeriesMode(e, t);
  }
  getImageQuality() {
    return this.services.image.getQuality();
  }
  toggleImageQuality() {
    const e = this.getImageQuality(), t = h.getHighQuality();
    let i = t;
    t === e && (i = dt.LOW), this.services.image.switchQuality(i);
  }
  updateScaleLevel(e) {
    this.services.renderingContext.setScaleLevel(e);
  }
  hasModuleAccess() {
    return this.data.hasAccess;
  }
  featureHidePointWithoutLabelIsActive() {
    return this.features["hide-point-without-label"].isActive();
  }
  toggleFeatureHidePointWithoutLabel() {
    this.features["hide-point-without-label"].toggleFeature(this);
  }
  searchStructure(e) {
    return this.services.search.searchStructure(e, this.application_id);
  }
  getPointsStructureHovered() {
    const e = this.getStructureHovered();
    return e === null ? [] : this.services.point.getActives().filter((t) => t.taxon_key === e.getTaxonKey());
  }
  async getOneImage() {
    if (this.services.contrast.getDefault() !== null) {
      const e = this.services.contrast.getResources()[this.services.contrast.getDefault()].imaios_code, t = this.getSlices()[0];
      return (await this.services.image.getImage({
        slice_id: t.id,
        code: e,
        quality: this.services.image.getQuality(),
        type: Y.SLICE
      })).image;
    }
    return null;
  }
  inverseScroll(e) {
    this.behave("reverseScrolling", e);
  }
  isScrollInverse() {
    return this.data.scrollDirection === Qe.BACKWARD;
  }
  getCoverImage() {
    return F.baseURL + this.state.module.cover;
  }
  backgroundColor() {
    return `#${this.state.module.background_color}`;
  }
  getMinSizeFont() {
    return this.services.style.get(L.ATTRIBUTE.BASE_MIN_FONT_PX);
  }
  setMinFontSize(e) {
    this.services.style.update(L.ATTRIBUTE.BASE_MIN_FONT_PX, e), this.redrawLabels();
  }
  toggleViewzone(e = null, t = null) {
    this.components.viewzone.toggle(e, t);
  }
  togglePinMode() {
    this.features["pin-mode"].toggle(this);
  }
  getStructureByTaxonKey(e) {
    const t = { ...this.services.structure.findByTaxonKey(e) };
    return t.name = this.services.structure.getTranslation(t, V.NAMESPACE.CONTENT), t.getTaxonKey = () => e, t;
  }
  getStructureById(e, t = null) {
    const i = this.services.structure.findByStructId(e);
    let r = i.find((a) => a.getTaxonKey() === t) || null, n = null;
    if (t !== null && (n = this.services.structure.getTranslation(r), r.name = n), r === null || n === null)
      for (const a of i) {
        const o = this.services.structure.getTranslation(a);
        o !== null && (a.ta_id === Hn || r === null) && (r = {
          ...a,
          name: o
        }, r.getTaxonKey = () => a.getTaxonKey());
      }
    return r;
  }
  getStructureWidthPointsByTaxonKey(e) {
    const t = { ...this.services.structure.findStructureWithPointByTaxonKey(e) };
    return t.name = this.services.structure.getTranslation(t, V.NAMESPACE.CONTENT), t.getTaxonKey = () => e, t;
  }
  getStructureWidthPointsByStructureId(e) {
    const t = { ...this.services.structure.findStructureWithPointByStructId(e) };
    return t.name = this.services.structure.getTranslation(t, V.NAMESPACE.CONTENT), t.getTaxonKey = () => taxon_key, t;
  }
  /**
   * @deprecated
   */
  switchImageProvider() {
    this.publish(Nr.EVENT.SWITCH_IMAGE_PROVIDER);
  }
  isOnlyOneFilterSelected(e) {
    const t = this.services.filter.getCurrent();
    return t.includes(e) && t.length === 1;
  }
  addEventToPublicEvent(e, t = null) {
    const i = this.features["emit-public-event"];
    typeof i < "u" && i.addSubFeature(this, e, t);
  }
  getModuleShortName() {
    return this.state.module.short_name;
  }
  getAlternativeModality() {
    return this.state.module.modality_name;
  }
  otherSeriesHaveMoreThanOneContrast() {
    const e = this.services.series.getResources();
    let t = !1;
    return Object.values(e).forEach((i) => {
      this.getAvailableContrastsBySeriesId(i.id).length > 1 && (t = !0);
    }), t;
  }
  getCurrentContrastCode() {
    return this.services.contrast.getCurrentCode();
  }
  isSliceLoaded(e) {
    const t = this.services.slice.getIdBySliceIndex(e), i = this.services.slice.findById(t), r = this.getAvailableContrastsBySeriesId(i.series_id);
    let n = this.services.contrast.getCurrentCode();
    typeof r.find((o) => o.imaios_code === n) > "u" && (n = r[0].imaios_code);
    const a = this.services.image.generateImageId({
      slice_id: t,
      sort_order: i.sort_order,
      code: n,
      quality: this.services.image.getQuality(),
      type: Y.SLICE
    });
    return this.services.image.hasImageInCache(a);
  }
  getSlicesIndexFromRelativeIndex() {
    return this.services.slice.getSlicesIndexFromRelativeIndex();
  }
  setFontSizeAuto() {
    this.data.fontSizeAuto === !1 && (this.data.fontSizeAuto = !0, this.animations.redrawOnlySliceMeta.trigger(), this.publish(k.EVENT.FONT_SIZE_MODE_UPDATED));
  }
  setFontSizeManual() {
    this.data.fontSizeAuto === !0 && (this.data.fontSizeAuto = !1, this.animations.redrawOnlySliceMeta.trigger(), this.publish(k.EVENT.FONT_SIZE_MODE_UPDATED));
  }
  setFontSize(e) {
    e >= $n && e <= Un && (this.services.style.update(L.ATTRIBUTE.FONT_SIZE, e), this.animations.redrawOnlySliceMeta.trigger(), this.publish(k.EVENT.FONT_SIZE_UPDATED));
  }
  getFontSize() {
    return this.services.style.get(L.ATTRIBUTE.FONT_SIZE);
  }
  isFontSizeAuto() {
    return this.data.fontSizeAuto;
  }
  moduleHasCrossReferences() {
    return this.services.series.hasCrossReferences();
  }
  /**
   * @returns {{width: number, height: number}|null}
   */
  getCurrentSeriesSize() {
    const e = this.services.series.getCurrent();
    if (e === null)
      return null;
    const { MULTIPLIER: t } = this.services.renderingContext.get();
    return {
      width: e.slices_width * t,
      height: e.slices_height * t
    };
  }
  onUserInteraction() {
    this.data.isDirty = !0;
  }
  exposeFunction(e, t) {
    const i = window.IMAIOS_ANATOMY.instances[this.data.custom_id];
    i[e] = t;
  }
  exposeFunctionForScrapper() {
    this.exposeFunction("getCurrentLanguage", () => this.getCurrentLanguage()), this.exposeFunction("setLanguage", (e) => this.setLanguage(e));
  }
  getShortcutHandlers() {
    const e = {};
    return xr.forEach((t) => {
      t.shortcutKey.keys.split(Rr).forEach((i) => {
        e[i] = t.shortcutKey;
      });
    }), e;
  }
  hasSubscriberAccess() {
    return this.data.userAccess === kt.PREMIUM;
  }
  async loadUserAccess() {
    this.data.userAccess = kt.FREE, this.data.userAccess = await ha(this.application_id);
  }
}
k.EVENT = {
  VIEWER_LAUNCH: "viewer-launch",
  READY: "application-ready",
  RESIZED: "application-resized",
  RENDERING_FIRST_FRAME: "application-rendering-first-frame",
  RESCALE: "application-rescale-canvas",
  ZOOM: "application-zoom",
  ERROR: "application-error",
  MOVE_SERIES: "application-mode-series",
  MOVE_TO_SLICE: "application-move-slice",
  MODULE_LOADED: "application-module-loaded",
  MODULE_DATA_LOADED: "application-module-data-loaded",
  SHOW_META_CANVAS: "application-show-meta-canvas",
  GET_SELECTED_POINTS: "application-get-selected-points",
  FONT_SIZE_UPDATED: "application-font-size-updated",
  FONT_SIZE_MODE_UPDATED: "application-font-size-mode-updated",
  STATE_HAS_BEEN_INITIALIZED: "application-state-has-been-initialized",
  IMAGE_VIEW: "application-image-view"
};
const Ci = {
  EVENT: {
    STATUS_CHANGE: "quiz-mode-status-change"
  }
}, Ss = () => {
};
class as {
  constructor(e = {}) {
    this.name = e.name, this.data = {
      isSelected: !1,
      isHover: !1
    }, this.handlers = {
      update: e.update || Ss,
      resize: e.resize || Ss,
      refresh: e.refresh || Ss
    }, this.hooks = {
      transformCoordinatesOnCollisionCheck: e.transformCoordinatesOnCollisionCheck || null
    }, this.visibility = !1, this.sensivity = e.sensitivity || 5, this.setupStyle(e);
  }
  setVisibility(e) {
    this.visibility = e;
  }
  isVisible() {
    return this.visibility;
  }
  setupStyle(e = {}) {
    this.data.style = {
      cursor: {
        hover: "auto"
      }
    }, e.style && e.style.cursor && e.style.cursor.hover && (this.data.style.cursor.hover = e.style.cursor.hover);
  }
  refresh() {
    this.handlers.refresh();
  }
  onMouseOver(e) {
    this.data.isHover = !0, this.refresh();
  }
  onMouseOut(e) {
    this.data.isHover = !1, this.refresh();
  }
  resize(e, t, i) {
    this.handlers.resize(e, t, i);
  }
  update(e) {
    this.handlers.update(this, e);
  }
  onMouseDown(e, t, i) {
    this.data.isSelected = !0;
  }
  onMouseUp(e, t, i) {
    this.data.isSelected = !1;
  }
}
class Da extends re {
  constructor(e = {}) {
    super(e), this.publish("component-created");
  }
  onSetup(e) {
    super.onSetup(e), this.data.color = e.color || "#000000", this.data.coordinates = {}, this.data.resizerSelected = !1;
  }
  setColor(e) {
    this.data.color = e;
  }
  /**
   * @abstract
   * @param parameters
   */
  getCollisionBox(e = {}) {
  }
  /**
   * @abstract
   * @param parameters
   */
  getResizerCollisionBox(e = {}) {
  }
  /**
   * @abstract
   * @param parameters
   */
  checkCollisionWithPointer(e = {}) {
  }
  /**
   * @abstract
   * @param parameters
   */
  checkOriginResizerCollisionWithPointer(e = {}) {
  }
  /**
   * @abstract
   * @param parameters
   */
  setCoords(e = {}) {
  }
  getCoords(e = {}) {
    return this.data.coordinates;
  }
  /**
   * @abstract
   * @param parameters
   */
  drawResizeZone(e = {}) {
  }
  /**
   * @abstract
   * @param parameters
   */
  translate(e) {
  }
  /**
   * @abstract
   * @param coords
   */
  translateByImageCoords(e) {
  }
  resize(e = {}) {
    const t = this.getCoords(e);
    this.data.resizerSelected instanceof as && this.data.resizerSelected.resize(
      e.x,
      e.y,
      t
    );
  }
  onPointerDown(e) {
    this.checkResizerCollisionWithPointer(e).hasCollision && (this.data.resizerSelected = !0);
  }
  findCollisionWithResizer(e = {}) {
    const t = this.checkResizerCollisionWithPointer(e);
    return (t.hasCollision === !0 || this.checkOriginResizerCollisionWithPointer(e)) && t.resizer instanceof as ? t.resizer : null;
  }
  onPointerOver(e) {
    this.resizers.forEach((i) => {
      i.onMouseOut(e);
    });
    const t = this.findCollisionWithResizer(e);
    t instanceof as ? t.onMouseOver(e) : this.setCursor("move");
  }
  onMouseOut(e, t, i) {
    this.setCursor(null), this.resizers.forEach((r) => {
      r.data.isHover === !0 && r.onMouseOut(e, t, i);
    });
  }
  setCursor(e) {
    this.publish("request-change-cursor", e);
  }
  onPointerUp(e, t, i) {
    this.data.resizerSelected = !1;
  }
  onPointerMove(e, t, i) {
    this.data.resizerSelected ? this.resize(e) : this.translate(e);
  }
}
const Pa = 2 * Math.PI;
class je extends as {
  constructor(e = {}) {
    super({
      sensivity: 10,
      ...e
    }), this.data.x = e.x, this.data.y = e.y, this.data.color = e.color || "#FFFFFF", this.data.radius = e.radius || 10;
  }
  setRadius(e) {
    this.data.radius = e;
  }
  /**
   * @param {Number} x
   * @param {Number} y
   */
  setCoords(e = 0, t = 0) {
    this.data.x = e, this.data.y = t;
  }
  checkCollision(e, t) {
    let i = this.data.x, r = this.data.y;
    if (typeof this.hooks.transformCoordinatesOnCollisionCheck == "function") {
      const c = this.hooks.transformCoordinatesOnCollisionCheck({
        x: i,
        y: r
      });
      i = c.x, r = c.y;
    }
    const n = i - e, a = r - t, o = this.data.radius + this.sensivity;
    return o * o - (n * n + a * a) >= 0;
  }
  render(e, t = {}) {
    if (e.globalAlpha = 0.5, e.beginPath(), e.arc(
      this.data.x,
      this.data.y,
      this.data.radius,
      0,
      Pa
    ), e.fill(), e.globalAlpha = 0.9, e.lineWidth = 1, this.data.isSelected === !0) {
      let i = e.strokeStyle;
      e.strokeStyle = "#FF0000", e.stroke(), e.strokeStyle = i;
    } else if (this.data.isHover === !0) {
      let i = e.strokeStyle, r = e.fillStyle;
      e.strokeStyle = "#00FF00", e.fillStyle = "#00FF00", e.stroke(), e.fill(), e.strokeStyle = i, e.fillStyle = r, t.canvas.style.cursor = this.data.style.cursor.hover;
    } else
      e.stroke();
    e.closePath();
  }
}
const ka = {
  generate: (s = {}) => {
    const t = s.color;
    s.component;
    const i = 25, r = 25, n = {
      refresh: () => {
      },
      // transformCoordinatesOnCollisionCheck: (canvasCoords = {x:0, y:0}) => {
      //     // return annotation.series.transformCanvasCoordinateIntoImageCoordinates(canvasCoords);
      // },
      radius: 3,
      color: t
    };
    return [
      new je({
        name: "top-left",
        update: (a, o) => {
          a.setCoords(o.left, o.top);
        },
        style: {
          cursor: {
            hover: "nwse-resize"
          }
        },
        resize: (a, o, l) => {
          const c = l.startX + l.width, u = l.startY + l.height;
          c - a > r && (l.startX = a, l.width = c - l.startX, l.centerX = l.startX + l.width / 2, l.endX = l.centerX + l.width / 2), u - o > i && (l.startY = o, l.height = u - l.startY, l.centerY = l.startY + l.height / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "middle-left",
        style: {
          cursor: {
            hover: "ew-resize"
          }
        },
        update: (a, o) => {
          a.setCoords(o.left, o.middle_y);
        },
        resize: (a, o, l) => {
          const c = l.startX + l.width;
          c - a > r && (l.startX = a, l.width = c - a, l.centerX = l.startX + l.width / 2, l.endX = l.centerX + l.width / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "bottom-left",
        update: (a, o) => {
          a.setCoords(o.left, o.bottom);
        },
        style: {
          cursor: {
            hover: "nesw-resize"
          }
        },
        resize: (a, o, l) => {
          const c = o, u = l.startX + l.width;
          u - a > r && (l.startX = a, l.width = u - a, l.centerX = l.startX + l.width / 2, l.endX = l.centerX + l.width / 2), c - l.startY > i && (l.height = c - l.startY, l.centerY = l.startY + l.height / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "top-middle",
        update: (a, o) => {
          a.setCoords(o.middle_x, o.top);
        },
        style: {
          cursor: {
            hover: "ns-resize"
          }
        },
        resize: (a, o, l) => {
          const c = l.startY + l.height;
          c - o > i && (l.startY = o, l.height = c - o, l.centerY = l.startY + l.height / 2, l.height = Math.abs(l.height), l.endX = l.centerX + l.width / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "bottom-middle",
        update: (a, o) => {
          a.setCoords(o.middle_x, o.bottom);
        },
        style: {
          cursor: {
            hover: "ns-resize"
          }
        },
        resize: (a, o, l) => {
          const c = o;
          c - l.startY > i && (l.height = c - l.startY, l.centerY = l.startY + l.height / 2, l.endX = l.centerX + l.width / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "top-right",
        update: (a, o) => {
          a.setCoords(o.right, o.top);
        },
        style: {
          cursor: {
            hover: "nesw-resize"
          }
        },
        resize: (a, o, l) => {
          const c = a, u = l.startY + l.height;
          c - l.startX > r && (l.width = c - l.startX, l.centerX = l.startX + l.width / 2, l.endX = l.centerX + l.width / 2), u - o > i && (l.startY = o, l.height = u - o, l.centerY = l.startY + l.height / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "middle-right",
        update: (a, o) => {
          a.setCoords(o.right, o.middle_y);
        },
        style: {
          cursor: {
            hover: "ew-resize"
          }
        },
        resize: (a, o, l) => {
          const c = a;
          c - l.startX > r && (l.width = c - l.startX, l.centerX = l.startX + l.width / 2, l.endX = l.centerX + l.width / 2, l.endY = l.centerY + l.height / 2);
        },
        ...n
      }),
      new je({
        name: "bottom-right",
        update: (a, o) => {
          a.setCoords(o.right, o.bottom);
        },
        style: {
          cursor: {
            hover: "nwse-resize"
          }
        },
        resize: (a, o, l) => {
          const c = a, u = o;
          c - l.startX > r && (l.width = c - l.startX, l.centerX = l.startX + l.width / 2, l.endX = c), u - l.startY > i && (l.height = u - l.startY, l.centerY = l.startY + l.height / 2, l.endY = u);
        },
        ...n
      })
    ];
  }
};
class Ha extends Da {
  constructor(e = {}) {
    super(e), this.sensivity = e.sensitivity || 10, this.setCoords({
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0
    });
  }
  onSetup(e) {
    super.onSetup(e), this.resizers = ka.generate({
      radius: 8,
      color: this.color,
      component: this
    });
  }
  updateResizersRadius() {
    const { width: e, height: t } = this.getCoords(), i = Math.min(15, Math.ceil(0.01 * Math.max(e, t, 500)));
    this.resizers.forEach((r) => r.setRadius(i));
  }
  resize(e = {}) {
    super.resize(e), this.updateResizersRadius();
  }
  sanitizeCoords(e) {
    if (e.startX > e.endX) {
      const t = e.endX;
      e.endX = e.startX, e.startX = t;
    }
    if (e.startY > e.endY) {
      const t = e.endY;
      e.endY = e.startY, e.startY = t;
    }
    e.width = e.endX - e.startX, e.centerX = e.startX + e.width / 2, e.height = e.endY - e.startY, e.centerY = e.startY + e.height / 2;
  }
  computeDrawCoords(e = {}) {
    const t = e.coordinates, i = e.scaleX || 1, r = e.scaleY || 1, n = e.offsetX || 0, a = e.offsetY || 0;
    return {
      x: (t.centerX - t.width / 2) / i + n,
      y: (t.centerY - t.height / 2) / r + a,
      width: t.width / i,
      height: t.height / r
    };
  }
  /**
   * @param {Object} parameters
   * @param {Object} parameters.canvas
   */
  draw(e = { canvas: null, coordinates: {} }) {
    const t = e.canvasComponent, i = this.computeDrawCoords({
      coordinates: this.getCoords(e),
      ...e
    });
    this.drawElement(t, i, this.data.color, 1), this.isHover && this.drawResizeZone(e);
  }
  drawElement(e, t, i, r) {
    e.strokeRect(
      t.x,
      t.y,
      t.width,
      t.height,
      r,
      i
    );
  }
  drawResizeZone(e = {}) {
    const t = this.getCoords(e), i = {
      left: t.centerX - t.width / 2,
      middle_x: t.centerX,
      right: t.centerX + t.width / 2,
      top: t.centerY - t.height / 2,
      middle_y: t.centerY,
      bottom: t.centerY + t.height / 2
    }, r = e.canvasComponent, n = r.getCanvasContext();
    n.save(), this.resizers.forEach((a) => {
      a.update(i), a.isVisible() && a.render(n, {
        canvas: r.getCanvas()
      });
    }), n.restore();
  }
  setCoords(e = {}) {
    const t = this.data.coordinates;
    Number.isFinite(e.startX) && (t.startX = e.startX), Number.isFinite(e.startY) && (t.startY = e.startY), Number.isFinite(e.endX) && (t.endX = e.endX), Number.isFinite(e.endY) && (t.endY = e.endY), Number.isFinite(e.centerX) ? t.centerX = e.centerX : t.centerX = (t.endX + t.startX) / 2, Number.isFinite(e.centerY) ? t.centerY = e.centerY : t.centerY = (t.endY + t.startY) / 2, t.width = Math.abs(t.endX - t.startX), t.height = Math.abs(t.endY - t.startY), this.updateResizersRadius();
  }
  /**
   * get a collision box inside img pixel space
   * @param imageIndex id of slice
   * @return {startX: number,
              startY: number,
              endX: number,
              endY: number} the bbox
   */
  getCollisionBox(e) {
    const t = this.getCoords(e);
    if (t === null)
      return null;
    {
      const i = t.centerX, r = t.centerY;
      return {
        startX: i - t.width / 2,
        startY: r - t.height / 2,
        endX: i + t.width / 2,
        endY: r + t.height / 2
      };
    }
  }
  getCoords(e = {}) {
    const t = super.getCoords(e);
    return t !== null && (typeof t.startX != "number" && (t.startX = t.centerX - t.width / 2), typeof t.startY != "number" && (t.startY = t.centerY - t.height / 2)), t;
  }
  translate(e = {}) {
    const t = this.getCoords(e), { x: i, y: r } = e;
    t.centerX && (t.centerX += i), t.centerY && (t.centerY += r), t.endX && (t.endX += i), t.endY && (t.endY += r), t.startX = t.centerX - t.width / 2, t.startY = t.centerY - t.height / 2, this.setCoords(t);
  }
  isVisible(e = {}) {
    return !0;
  }
  checkResizerCollisionWithPointer(e = {}) {
    const t = this.resizers;
    let i = {
      hasCollision: !1,
      distance: Number.POSITIVE_INFINITY,
      resizer: null
    };
    if (this.isVisible(e) !== !0)
      return i;
    const { x: r, y: n } = e;
    for (let a = 0; a < t.length; a++) {
      const o = t[a];
      o.checkCollision(r, n) && (i.distance = 0, i.hasCollision = !0, i.resizer = o);
    }
    return i;
  }
  checkCollisionWithPointer(e = {}) {
    const t = this.getDistanceWithPoint(e);
    return {
      hasCollision: Number.isFinite(t) && t <= this.sensivity || this.isInBox(e),
      distance: t
    };
  }
  isInBox(e = {}) {
    const t = this.getCollisionBox(e);
    if (t === null)
      return !1;
    const { x: i, y: r } = e;
    return t !== null && i >= t.startX && i <= t.endX && r >= t.startY && r <= t.endY;
  }
  getDistanceWithPoint(e = {}) {
    const t = this.getCollisionBox(e);
    if (t === null)
      return !1;
    const { x: i, y: r } = e, n = Xe.getOne(i, r), a = Xe.getOne(t.startX, t.startY), o = Xe.getOne(t.endX, t.startY), l = Xe.getOne(t.startX, t.endY), c = Xe.getOne(t.endX, t.endY), u = Dt.distancePointToEdge2D(n, a, o, 0), m = Dt.distancePointToEdge2D(n, a, l, 0), g = Dt.distancePointToEdge2D(n, o, c, 0), C = Dt.distancePointToEdge2D(n, l, c, 0);
    return a.recycle(), o.recycle(), l.recycle(), c.recycle(), n.recycle(), Math.min(u, m, g, C);
  }
}
class de {
  constructor() {
    this.point = new DOMPoint(), this.isUse = !1;
  }
  static initialize() {
    if (!de.initialized) {
      for (let e = 0; e < de.POOL.initialSize; e++) {
        const t = new de();
        de.POOL.instances.push(t), de.POOL.available.push(t);
      }
      de.initialized = !0;
    }
  }
  static getOne(e = 0, t = 0) {
    let i;
    return de.POOL.available.length > 0 ? i = de.POOL.available.pop() : (i = new de(), de.POOL.instances.push(i)), i.set(e, t), i.isUse = !0, i;
  }
  static getInstance(e = !1) {
    return e ? de.getOne() : new de();
  }
  recycle() {
    this.isUse && (this.isUse = !1, de.POOL.available.push(this));
  }
  getPoint() {
    return this.point;
  }
  setX(e) {
    this.point.x = e;
  }
  setY(e) {
    this.point.y = e;
  }
  getX() {
    return this.point.x;
  }
  getY() {
    return this.point.y;
  }
  set(e, t) {
    this.point.x = e, this.point.y = t;
  }
  matrixTransform(e) {
    return this.point = this.point.matrixTransform(new DOMMatrix([
      e.a,
      e.b,
      e.c,
      e.d,
      e.e,
      e.f
    ])), this;
  }
}
de.initialized = !1;
de.POOL = {
  instances: [],
  available: [],
  initialSize: 2
};
de.initialize();
class hs {
  constructor(e, t, i, r, n, a) {
    this.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.matrix = new DOMMatrix(), this.setTransform(e, t, i, r, n, a);
  }
  setTransformMatrix(e) {
    this.matrix = e;
  }
  getTransformMatrix() {
    return this.matrix;
  }
  scale(e, t) {
    this.matrix = this.matrix.scale(e, t);
  }
  rotate(e) {
    this.matrix = this.matrix.rotate(e * 180 / Math.PI);
  }
  translate(e, t) {
    this.matrix = this.matrix.translate(e, t);
  }
  setTransform(e, t, i, r, n, a) {
    this.matrix.a = e, this.matrix.b = t, this.matrix.c = i, this.matrix.d = r, this.matrix.e = n, this.matrix.f = a;
  }
  transform(e, t, i, r, n, a) {
    const o = new DOMMatrix();
    o.a = e, o.b = t, o.c = i, o.d = r, o.e = n, o.f = a, this.matrix = this.matrix.multiply(o);
  }
  transformCoordinates(e, t, i = !1) {
    const r = de.getInstance(i);
    return r.setX(parseFloat(e)), r.setY(parseFloat(t)), r.matrixTransform(this.matrix.inverse());
  }
  multiply(e) {
    this.matrix.multiply(e);
  }
  getComputedScaleX() {
    return Math.sqrt(this.matrix.a * this.matrix.a + this.matrix.c * this.matrix.c);
  }
  getComputedScaleY() {
    return Math.sqrt(this.matrix.d * this.matrix.d + this.matrix.b * this.matrix.b);
  }
  getTx() {
    return this.matrix.e;
  }
  getTy() {
    return this.matrix.f;
  }
  getScaleX() {
    return this.matrix.a;
  }
  getScaleY() {
    return this.matrix.d;
  }
  getSkewX() {
    return this.matrix.b;
  }
  getSkewY() {
    return this.matrix.c;
  }
  flipX() {
    this.matrix = this.matrix.flipX();
  }
  flipY() {
    this.matrix = this.matrix.flipY();
  }
  getRotationInRadians() {
    const e = this.matrix.a, t = this.matrix.c;
    return Math.atan2(t, e);
  }
  rotatePoint(e, t, i = !1) {
    const r = de.getInstance(i), n = this.getRotationInRadians(), a = Math.cos(n), o = Math.sin(n);
    return r.setX(e * a - t * o), r.setY(e * o + t * a), r;
  }
  static createFrom(e) {
    return new hs(
      e.getScaleX(),
      e.getSkewX(),
      e.getSkewY(),
      e.getScaleY(),
      e.getTx(),
      e.getTy()
    );
  }
}
const ze = {
  SAVE: "saveCanvas",
  RESTORE: "restoreCanvas",
  ROTATE: "rotate",
  SCALE: "scale",
  FLIP_X: "flipX",
  FLIP_Y: "flipY"
}, Fa = -3.484375;
class ue extends re {
  /**
      * @param {Object} settings
      * @param {HTMLElement} settings.container
      * @param {PointerState} settings.pointerState
      * @param {boolean} settings.useController decide if we have to add a dedicated pointer controller to component. True by default.
      */
  constructor(e = {}) {
    super(e), this.ui.canvas = ue.createCanvasElement(e), this.ui.wrapper = this.ui.canvas, this.data.context = ue.setupCanvasContext(this.ui.canvas), this.services = {
      style: aa(e, "services.style")
    }, this.transformMatrix = new hs(1, 0, 0, 1, 0, 0), this.savedTransforms = [], this.baseLineForText = "top", this.data.ellipsisWidth = 0, this.data.spaceWidth = 0, this.data.fontName = e.fontFamily ?? Dn, this.data.fontSize = 0, this.data.disabledBy = /* @__PURE__ */ new Set(), this.data.nbDisablers = 0, this.disable(), this.resize(0, e.width, e.height), this.paddingTop = e.paddingTop || 0, this.paddingBottom = e.paddingBottom || 0, this.pointerState = e.pointerState, e.useController !== !1 && (this.handlers = {
      pointer: new ur({
        domTarget: this.ui.canvas,
        onMouseMove: this.onMouseMove.bind(this),
        onMouseDown: this.onMouseDown.bind(this),
        onMouseUp: this.onMouseUp.bind(this),
        onClick: this.onClick.bind(this),
        onDoubleClick: this.onDoubleClick.bind(this),
        onMouseEnter: this.onMouseEnter.bind(this),
        onMouseLeave: this.onMouseLeave.bind(this),
        onMouseWheel: this.onMouseWheel.bind(this)
      })
    }), e.container instanceof HTMLElement && e.container.appendChild(this.ui.canvas);
  }
  enable(e = "anonymous") {
    this.data.disabledBy.delete(e), this.data.nbDisablers = this.data.disabledBy.size;
  }
  disable(e = "anonymous") {
    this.data.disabledBy.add(e), this.data.nbDisablers = this.data.disabledBy.size;
  }
  isEnabled() {
    return this.data.nbDisablers === 0;
  }
  getHeight() {
    return parseInt(this.ui.canvas.style.height || this.ui.canvas.height);
  }
  /** @param {Number} height */
  setHeight(e) {
    this.ui.canvas.height = Math.floor(e);
  }
  getWidth() {
    return parseInt(this.ui.canvas.style.width || this.ui.canvas.width);
  }
  /** @param {Number} width */
  setWidth(e) {
    this.ui.canvas.width = Math.floor(e);
  }
  setKeyDownHandler(e) {
    document.addEventListener("keydown", e);
  }
  setId(e) {
    this.ui.canvas.setAttribute("id", e);
  }
  getId() {
    this.ui.canvas.getAttribute("id");
  }
  setCss(e, t) {
    document.querySelector(this.ui.canvas)[e] = t;
  }
  getOffset() {
    return {
      left: this.ui.canvas.offsetLeft,
      top: this.ui.canvas.offsetTop
    };
  }
  setTextBaseline(e) {
    this.baseLineForText = e, this.data.context.textBaseline = this.baseLineForText;
  }
  setTextAlign(e) {
    this.data.context.textAlign = e;
  }
  setFontSize(e) {
    this.data.fontSize !== e && (this.data.context.font = `400 ${e}px ${this.getFontFamily()}`, this.updatePrecomputedTextLength());
  }
  updatePrecomputedTextLength() {
    this.ellipsisWidth = this.data.context.measureText(Li).width, this.spaceWidth = this.data.context.measureText(Ve).width;
  }
  setFontFamily(e) {
    this.data.fontName = e;
  }
  setFont(e, t) {
    this.setFontFamily(e), this.setFontSize(t);
  }
  getFontFamily() {
    return this.data.fontName;
  }
  setFillStyle(e) {
    this.data.context.fillStyle = e;
  }
  setStrokeStyle(e) {
    this.data.context.strokeStyle = e;
  }
  beginPath() {
    this.data.context.beginPath();
  }
  moveTo(e, t) {
    this.data.context.moveTo(e, t);
  }
  lineTo(e, t) {
    this.data.context.lineTo(e, t);
  }
  stroke() {
    this.data.context.stroke();
  }
  drawImage(e, t, i, r, n) {
    r && n ? this.data.context.drawImage(e, t, i, r, n) : this.data.context.drawImage(e, t, i);
  }
  getCanvas() {
    return this.ui.canvas;
  }
  fillCircle(e, t, i, r, n) {
    this.data.context.beginPath(), this.data.context.arc(e, t, i, 0, 2 * Math.PI, !1);
    const a = We(n);
    this.data.context.fillStyle = `rgba(${a.r},${a.g},${a.b},${r})`, this.data.context.fill();
  }
  getFillStyle() {
    return this.data.context.fillStyle;
  }
  strokeCircle(e, t, i, r, n, a) {
    this.data.context.beginPath(), this.data.context.arc(e, t, i, 0, 2 * Math.PI, !1);
    const o = We(n);
    this.data.context.lineWidth = a, this.data.context.strokeStyle = `rgba(${o.r},${o.g},${o.b},${r})`, this.data.context.stroke();
  }
  fillEllipsis(e, t, i, r, n, a, o) {
    this.data.context.beginPath(), this.data.context.ellipse(e, t, i, r, n, 0, Math.PI * 2, !1);
    const l = We(o);
    this.data.context.fillStyle = `rgba(${l.r},${l.g},${l.b},${a})`, this.data.context.fill();
  }
  closePath() {
    this.data.context.closePath();
  }
  strokeEllipsis(e, t, i, r, n, a, o, l) {
    this.data.context.beginPath(), this.data.context.ellipse(e, t, Math.abs(i), Math.abs(r), n, 0, Math.PI * 2, !1), this.data.context.lineWidth = l;
    const c = We(o);
    this.data.context.strokeStyle = `rgba(${c.r},${c.g},${c.b},${a})`, this.data.context.stroke();
  }
  drawRect(e, t, i, r, n, a) {
    this.data.context.beginPath(), this.data.context.rect(e, t, i, r);
    const o = We(a);
    this.data.context.fillStyle = `rgba(${o.r},${o.g},${o.b},${n})`, this.data.context.fill();
  }
  strokeRect(e, t, i, r, n, a) {
    if (this.data.context.beginPath(), this.data.context.rect(e, t, i, r), a) {
      const o = We(a);
      this.data.context.strokeStyle = `rgba(${o.r},${o.g},${o.b},${n})`;
    }
    this.data.context.stroke();
  }
  clear() {
    this.clearCanvas(0, 0, this.getWidth(), this.getHeight(), !0);
  }
  getHeightAvailable() {
    return this.getHeight() - this.paddingTop - this.paddingBottom;
  }
  clearCanvas(e, t, i, r, n) {
    n === !0 && (this.saveCanvas(), this.setTransform(1, 0, 0, 1, 0, 0)), this.data.context.clearRect(e, t, i, r), n === !0 && this.restoreCanvas();
  }
  [ze.SAVE]() {
    const e = hs.createFrom(this.getTransformMatrix());
    this.savedTransforms.push(e), this.data.context.save();
  }
  [ze.RESTORE]() {
    this.transformMatrix = this.savedTransforms.pop(), this.data.context.restore();
  }
  resize(e, t, i) {
    const r = this.transformMatrix.getScaleX(), n = this.transformMatrix.getSkewX(), a = this.transformMatrix.getSkewY(), o = this.transformMatrix.getScaleY(), l = this.transformMatrix.getTx(), c = this.transformMatrix.getTy();
    this.setWidth(t), this.setHeight(i), this.ui.canvas.parentNode && (this.ui.canvas.parentNode.style.marginLeft = `${e}px`), this.setTransform(r, n, a, o, l, c), this.data.context.textBaseline = this.baseLineForText;
  }
  getTransformMatrix() {
    return this.transformMatrix;
  }
  [ze.SCALE](e, t) {
    typeof t > "u" && (t = e.y, e = e.x), this.transformMatrix.scale(e, t), this.data.context.scale(e, t);
  }
  [ze.ROTATE](e) {
    this.transformMatrix.rotate(e), this.data.context.rotate(e);
  }
  translate(e, t) {
    this.transformMatrix.translate(e, t), this.data.context.translate(e, t);
  }
  setTransform(e, t, i, r, n, a) {
    const o = Number.isFinite(e) ? e : 0, l = Number.isFinite(t) ? t : 0, c = Number.isFinite(i) ? i : 0, u = Number.isFinite(r) ? r : 0, m = Number.isFinite(n) ? n : 0, g = Number.isFinite(a) ? a : 0;
    this.transformMatrix.setTransform(o, l, c, u, m, g), this.data.context.setTransform(o, l, c, u, m, g);
  }
  transform(e, t, i, r, n, a) {
    this.transformMatrix.transform(e, t, i, r, n, a), this.data.context.transform(e, t, i, r, n, a);
  }
  transformCoordinates(e, t, i = !1) {
    return this.transformMatrix.transformCoordinates(e, t, i);
  }
  getTx() {
    return this.transformMatrix.getTx();
  }
  getTy() {
    return this.transformMatrix.getTy();
  }
  getComputedScaleX(e) {
    return e ? -this.transformMatrix.getComputedScaleX() : this.transformMatrix.getComputedScaleX();
  }
  getComputedScaleY(e) {
    return e ? -this.transformMatrix.getComputedScaleY() : this.transformMatrix.getComputedScaleY();
  }
  getScaleX() {
    return this.transformMatrix.getScaleX();
  }
  getScaleY() {
    return this.transformMatrix.getScaleY();
  }
  getSkewX() {
    return this.transformMatrix.getSkewX();
  }
  getSkewY() {
    return this.transformMatrix.getSkewY();
  }
  [ze.FLIP_X]() {
    this[ze.SCALE](-1, 1);
  }
  [ze.FLIP_Y]() {
    this[ze.SCALE](1, -1);
  }
  measureTextInCanvas(e) {
    return this.data.context.measureText(e).width;
  }
  getCanvasContext() {
    return this.data.context;
  }
  stringEllipsis(e, t, i) {
    let r = this.data.context.measureText(e).width;
    if (r <= t && i !== !0)
      return e;
    {
      let n = e.length;
      for (; r >= t - this.ellipsisWidth && n-- > 0; )
        e = e.substring(0, n), r = this.data.context.measureText(e).width;
      return e + Li;
    }
  }
  getSplitWords(e, t) {
    const i = e.split(Ve);
    if (t === !0) {
      const r = [];
      return i.forEach((n) => {
        const a = n.split("-");
        a.length === 1 ? r.push(n) : r.push(a[0], `-${a[1]}`);
      }), r;
    } else
      return i;
  }
  // berk berk berk !
  drawMultilineText(e) {
    const {
      lineHeight: t,
      width: i,
      underline: r = !1,
      alignment: n = {},
      splitHyphen: a = !1,
      maxLines: o,
      textBaseline: l = "top",
      x: c,
      y: u
    } = e, m = e.text.trim(), g = e.allowCenter !== !1;
    let C, I = Math.ceil(u);
    oe.isSafariBrowser() && (I += Fa), n.horizontal === "right" ? C = Math.ceil(c + i) : C = Math.ceil(c), this.data.context.textBaseline = l;
    const p = this.data.context.measureText(m).width;
    let T = 0, v = !1;
    if (p > i) {
      const d = this.getSplitWords(m, a), f = d.map((w) => this.data.context.measureText(w).width);
      let E = !1, y = 0, _ = 0, x = 0, D = !1;
      for (let w = 0; w < o; w++) {
        let b = f[y];
        for (y++; y < f.length && b < i; )
          b += this.spaceWidth + f[y], y++;
        if (b > i && // Size too long
        y > _ && // At least one word was added
        y > 1 && (y--, b -= this.spaceWidth + f[y]), w === 0 && (x = b), w < o - 1)
          if (b > i) {
            let A = d.slice(_, y).join(Ve);
            A = this.stringEllipsis(A, i, !0), v = !0, b = this.data.context.measureText(A).width, this.data.context.fillText(A, C, I + t * w), D = !0;
          } else
            this.data.context.fillText(d.slice(_, y).join(Ve), C, I + t * w), b += (y - _ - 1) * this.spaceWidth;
        else if (y - _ === 0 && // no word was added
        y < d.length) {
          ++y, E = !0;
          let A = d.slice(_, y).join(Ve);
          A = this.stringEllipsis(A, i, y < f.length), b = this.data.context.measureText(A).width, v = !0, this.data.context.fillText(A, C, I + t * w);
        } else if (y <= d.length) {
          E = !0;
          let A = d.slice(_, y).join(Ve);
          if (
            // a word will not be displayed
            // (with is not max but current word is not last word) => (no place left for next word)
            this.data.context.measureText(A).width <= i && y < f.length
          )
            y++, A = d.slice(_, y).join(Ve), A = this.stringEllipsis(A, i, !0), v = !0, b = this.data.context.measureText(A).width, this.data.context.fillText(A, C, I + t * w);
          else if (b > i) {
            let U = d.slice(_, y).join(Ve);
            U = this.stringEllipsis(U, i, !0), v = !0, b = this.data.context.measureText(U).width, this.data.context.fillText(U, C, I + t * w);
          } else
            b += (y - _ - 1) * this.spaceWidth, this.data.context.fillText(A, C, I + t * w);
        }
        T < b && (T = b), r && this.underline(C, I + 1 + t * (w + 1), Math.ceil(b)), _ = y, D && (w = o);
      }
      return {
        lengthOfFirstLine: (E === !0 ? -1 : 1) * x,
        maxLength: T,
        isTrunk8: v
      };
    } else
      return o > 1 && g && (I = u + o * t / 2), this.data.context.fillText(m, C, I), r && this.underline(C, I + t + 1, p), {
        lengthOfFirstLine: p,
        maxLength: p,
        isTrunk8: !1
      };
  }
  underline(e, t, i) {
    this.data.context.textAlign === "right" && (i *= -1), this.data.context.beginPath(), this.data.context.moveTo(e, t), this.data.context.lineTo(e + i, t), this.data.context.stroke();
  }
  getLabelInfos(e = "", t = 14, i = Number.POSITIVE_INFINITY, r = Number.POSITIVE_INFINITY) {
    this.setFontSize(t);
    const n = this.data.context.measureText(e).width, a = Math.min(this.getNbLine(e, t, this.getFontFamily(), i), r), o = this.services.style.get(L.ATTRIBUTE.LINE_INTERVAL_PX), l = a * (this.data.fontSize + o);
    return Le.getOne(l, e, n, a);
  }
  getNbLine(e, t, i, r) {
    this.setFont(i, t);
    const n = this.getSplitWords(e, !0), a = n.map((u) => this.data.context.measureText(u).width);
    let o = 0, l = 0, c = 0;
    for (let u = 0; u < n.length; u++) {
      let m = a[o];
      for (o++; o < a.length && m < r; )
        m += this.spaceWidth + a[o], o++, u++;
      m > r && // Size too long
      o > l + 1 && (o--, m -= this.spaceWidth + a[o], u--), m > r && (u = n.length), l = o, c++;
    }
    return Math.max(c, 1);
  }
  setContextOpacity(e) {
    this.data.context.globalAlpha = e;
  }
  setCanvasBackground(e) {
    this.ui.canvas.style.backgroundColor = `#${e}`;
  }
  hide() {
    this.ui.canvas.style.display = "none";
  }
  show() {
    this.ui.canvas.style.display = "block";
  }
  static createCanvasElement(e = {}) {
    const t = document.createElement("canvas");
    return t.width = e.width, t.height = e.height, t.classList.add("canvas-component"), t.setAttribute("data-name", e.name), typeof e._id == "string" && t.setAttribute("id", e._id), t;
  }
  /**
      *
      * @param {HTMLCanvasElement} canvas
      * @return {CanvasRenderingContext2D}
      */
  static setupCanvasContext(e) {
    const t = e.getContext("2d");
    return t.shadowOffsetX = 0, t.shadowOffsetY = 0, t.shadowBlur = 0, t.shadowColor = null, t;
  }
  /** @param {PointerEvent} event */
  onMouseMove(e) {
  }
  /** @param {PointerEvent} event */
  onMouseDown(e) {
  }
  /** @param {PointerEvent} event */
  onMouseUp(e) {
  }
  /** @param {PointerEvent} event */
  onClick(e) {
  }
  /** @param {PointerEvent} event */
  onDoubleClick(e) {
  }
  /** @param {PointerEvent} event */
  onMouseEnter(e) {
  }
  /** @param {PointerEvent} event */
  onMouseLeave(e) {
  }
  /** @param {PointerEvent} event */
  onMouseWheel(e) {
  }
}
ue.METHOD = ze;
const bs = {
  width: 128,
  height: 128,
  color: "#048FFD"
};
class qe extends ue {
  constructor(e = {}) {
    super(e);
    const t = e.style;
    this.data.initialWidth = e.width || bs.width, this.data.initialHeight = e.height || bs.height, this.rectangleComponent = new Ha(e), this.rectangleComponent.setCoords({
      startX: 0,
      startY: 0,
      endX: this.data.initialWidth,
      endY: this.data.initialHeight
    }), this.rectangleComponent.resizers.splice(
      this.rectangleComponent.resizers.findIndex((i) => i.name === "top-right"),
      1
    ), this.data.color = e.color || bs.color, this.rectangleComponent.setColor(this.data.color), this.data.parentElement = e.parentElement, this.style = { ...t }, this.services = {
      style: e.services.style,
      point: e.services.point
    }, this.data.resizerSelected = null, this.subscribe(
      this.rectangleComponent,
      "request-change-cursor",
      (i) => {
        this.ui.wrapper.style.cursor = i;
      }
    );
  }
  setHover(e, t, i) {
    const r = this.rectangleComponent.isHover;
    this.rectangleComponent.isHover = e, r !== e && this.draw();
  }
  hasHover() {
    return this.isEnabled() && this.rectangleComponent.isHover === !0;
  }
  findCollisionWithResizer(e, t) {
    return this.rectangleComponent.checkResizerCollisionWithPointer({ x: e, y: t });
  }
  checkIsInsideRectangle(e, t) {
    const i = this.rectangleComponent.checkCollisionWithPointer({ x: e, y: t });
    return i === !0 || i.hasCollision === !0;
  }
  isCloseButtonHover(e, t) {
    const i = this.services.point, r = i.fromCoords(e, t), n = i.isInBox(r, this.getCloseButtonBox());
    return J.recycle(r), n;
  }
  refreshHover(e, t) {
    const i = this.checkIsInsideRectangle(e, t), r = this.isNearToCollisionBox(e, t), n = this.isNearToOneResizer(e, t), a = r || n;
    this.setHover(i || a), this.rectangleComponent.resizers.forEach((o) => {
      o.setVisibility(a);
    }), i ? (this.getFocus(), this.isCloseButtonHover(e, t) ? (this.rectangleComponent.onMouseOut({ x: e, y: t }), this.ui.wrapper.classList.add("viewzone-close-button-hover")) : (this.rectangleComponent.onPointerOver({ x: e, y: t }), this.ui.wrapper.classList.remove("viewzone-close-button-hover")), this.draw()) : a ? this.draw() : this.looseFocus();
  }
  getFocus() {
    this.ui.wrapper.style.pointerEvents = "auto";
  }
  looseFocus() {
    this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.classList.remove("viewzone-close-button-hover");
  }
  selectResizer(e) {
    this.rectangleComponent.data.resizerSelected = e;
  }
  checkHover(e, t) {
    return this.findCollisionWithResizer(e, t).hasCollision || this.checkIsInsideRectangle(e, t);
  }
  hide(e) {
    super.hide(), this.setEnabled(!1, null, e);
  }
  show(e, t) {
    super.show(), this.setEnabled(!0, e, t);
  }
  toggle(e = null, t = null) {
    this.isEnabled() ? this.hide(t) : this.show(e, t);
  }
  setEnabled(e = !0, t = null, i = null) {
    e !== this.isEnabled() && (e ? this.enable() : this.disable(), this.publish(qe.EVENT.STATUS_CHANGE, { status: e, coords: t, placement: i }));
  }
  getBoundingBox() {
    const e = this.rectangleComponent.getCollisionBox();
    return {
      top: Math.floor(e.startY),
      bottom: Math.ceil(e.endY),
      left: Math.ceil(e.startX),
      right: Math.ceil(e.endX)
    };
  }
  reset() {
    const e = this.data.initialWidth / 2, t = this.data.initialHeight / 2, { centerX: i, centerY: r } = this.rectangleComponent.getCoords();
    this.rectangleComponent.setCoords({
      startX: i - e,
      startY: r - t,
      endX: i + e,
      endY: r + t
    });
  }
  center(e, t) {
    const { width: i, height: r } = this.rectangleComponent.getCoords(), n = i / 2, a = r / 2;
    this.rectangleComponent.setCoords({
      startX: e - n,
      startY: t - a,
      endX: e + n,
      endY: t + a
    });
  }
  isNearToCollisionBox(e, t) {
    return this.rectangleComponent.getDistanceWithPoint({ x: e, y: t }) < 25;
  }
  isNearToOneResizer(e, t) {
    const i = this.findCollisionWithResizer(e, t);
    return this.selectResizer(i.resizer), i.resizer !== null && i.distance < 10;
  }
  getCloseButtonBox() {
    const { endX: e, startY: t, width: i, height: r } = this.rectangleComponent.getCoords(), n = Math.max(Math.round(0.05 * Math.min(i, r)), 15);
    return {
      top: Math.ceil(t),
      bottom: Math.ceil(t + n),
      left: Math.ceil(e - n),
      right: Math.ceil(e),
      size: Math.ceil(n)
    };
  }
  draw() {
    this.clear(), this.rectangleComponent.draw({ canvasComponent: this });
    const e = this.getCloseButtonBox(), t = 5;
    this.drawRect(
      e.left,
      e.top,
      e.size,
      e.size,
      1,
      this.data.color
    ), this.saveCanvas(), this.beginPath(), this.setStrokeStyle("#" + me.WHITE), this.moveTo(e.left + t, e.top + t), this.lineTo(e.right - t, e.bottom - t), this.moveTo(e.right - t, e.top + t), this.lineTo(e.left + t, e.bottom - t), this.stroke(), this.closePath(), this.restoreCanvas();
  }
  translate(e, t) {
    this.rectangleComponent.translate({ x: e, y: t }), this.draw(), this.publish(qe.EVENT.MOVE);
  }
  focus() {
    const e = this.ui.container, t = e.getBoundingClientRect(), i = new MouseEvent("mousedown", {
      clientX: t.left,
      clientY: t.top
    });
    e.dispatchEvent(i);
  }
  getContainer() {
    return this.ui.container;
  }
  resizeRectangle(e = { x: 0, y: 0 }) {
    this.rectangleComponent.resize(e), this.publish(qe.EVENT.RESIZE);
  }
  getCoords() {
    return this.rectangleComponent.getCoords();
  }
}
qe.EVENT = {
  MOVE: "viewzone-move",
  CLOSE: "viewzone-close",
  HOVER: "viewzone-hover",
  WHEEL: "viewzone-wheel",
  RESIZE: "viewzone-resize",
  RESIZE_END: "viewzone-resize-end",
  STATUS_CHANGE: "viewzone-status-change",
  HOVER_CHANGE: "viewzone-hover-change"
};
class za extends ce {
  constructor(e = {}) {
    super({
      name: "viewzone-pan",
      ...e
    }), this.services = {
      pointer: e.services.pointer
    }, this.lastX = 0, this.lastY = 0;
  }
  onStart() {
    const e = this.services.pointer.getCoords();
    this.lastX = e.x, this.lastY = e.y;
  }
  getDelta() {
    const e = this.services.pointer.getCoords(), t = e.x - this.lastX, i = e.y - this.lastY;
    return this.lastX = e.x, this.lastY = e.y, {
      x: t,
      y: i
    };
  }
  onAnimation(e) {
    try {
      const t = this.getDelta();
      this.component.translate(t.x, t.y);
    } catch (t) {
      console.error(t);
    }
  }
  onMouseUp(e) {
    this.finish(e);
  }
  onMouseLeave(e) {
    this.finish(e);
  }
}
class Ba extends ce {
  constructor(e = {}) {
    super({
      name: "viewzone-resize",
      ...e
    }), this.services = {
      pointer: e.services.pointer
    }, this.lastX = 0, this.lastY = 0;
  }
  onStart() {
    this.updateLastCoords(this.services.pointer.getCoords());
  }
  updateLastCoords(e) {
    this.lastX = e.x, this.lastY = e.y;
  }
  needsRedraw(e) {
    return e.x !== this.lastX || e.y !== this.lastY;
  }
  onAnimation(e) {
    try {
      const t = this.services.pointer.getCoords();
      this.needsRedraw(t) && (this.component.resizeRectangle(t), this.component.draw(), this.updateLastCoords(t));
    } catch (t) {
      console.error(t);
    }
  }
}
class $a extends Gt {
  constructor(e) {
    super(e), this.setInteraction(this.application.services.interaction.findById("viewzone-pan"));
  }
  loop() {
    this.interaction.onAnimation(), this.application.animations.redrawOnlySliceMeta.trigger();
  }
}
class Ua extends Gt {
  constructor(e) {
    super(e), this.setInteraction(this.application.services.interaction.findById("viewzone-resize"));
  }
  loop() {
    this.interaction.onAnimation(), this.application.animations.redrawOnlySliceMeta.trigger();
  }
}
class Va extends ne {
  constructor() {
    super({
      subscriber_id: "viewzone-feature"
    }), this.vz = null, this.fontSizeBeforeEnalbed = null, this.fontSizeAutoBeforeEnabled = !1;
  }
  subscribe(e) {
    const t = e.handlers.pointer, i = e.services.labelsDrawer;
    return [
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.BEFORE_SET_CANDIDATES,
        action: (r) => {
          if (this.vz.isEnabled()) {
            const n = r.candidates, a = this.vz.getBoundingBox();
            r.candidates = n.filter((o) => {
              const l = e.services.point.refreshContextualCoords({
                transformation: (c) => e.components.pointsCanvas.applyLocalTransformationToPoint(c),
                point: o
              });
              return e.services.point.isInBox(l, a);
            });
          }
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.CHECK_VISIBILITY,
        action: (r) => {
          this.vz.isEnabled() && (r.isSelected = !0);
        }
      },
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.CONTEXT_RESET,
        action: (r) => {
          this.vz.isEnabled() && (r.allPreselectedLabelsShouldBeDrawn = !0);
        }
      },
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      },
      {
        from: this.vz,
        name: qe.EVENT.STATUS_CHANGE,
        action: ({ coords: r, placement: n }) => {
          this.toggleViewzone(e, r, n);
        }
      },
      {
        from: t,
        name: $.EVENT.POINTER_MOVE,
        action: () => this.refreshHover(e)
      },
      {
        from: t,
        name: $.EVENT.POINTER_DOWN,
        action: (r) => this.vzPointerDown(e, r)
      },
      {
        from: t,
        name: [$.EVENT.POINTER_UP, $.EVENT.TOUCH_END],
        action: () => this.clearInteraction(e)
      },
      {
        from: t,
        name: $.EVENT.POINTER_LEAVE,
        action: () => this.clearInteraction(e)
      },
      {
        from: t,
        name: $.EVENT.LONG_CLICK,
        action: (r) => {
          if (r.button === wt.LEFT_CLICK) {
            const n = e.services.pointer.getCoords();
            this.vz.show(n), e.services.interaction.setCurrent(this.vzPanInteraction.name);
            const { x: a, y: o } = e.services.pointer.getCoords();
            this.vz.refreshHover(a, o), this.vzPanInteraction.start();
          }
        }
      },
      {
        from: i,
        name: X.EVENT.FORCE_FONT_SIZE_AUTO,
        action: (r) => {
          this.vz.isEnabled() && (r.forceSizeAuto = !0);
        }
      },
      {
        from: i,
        name: X.EVENT.UPDATE_RANGE_FONT_SIZE,
        action: () => {
          this.vz.isEnabled() && e.services.style.update(L.ATTRIBUTE.MIN_FONT_PX, 1);
        }
      },
      {
        from: e,
        name: k.EVENT.FONT_SIZE_UPDATED,
        action: () => {
          this.vz.isEnabled() && !this.fontSizeAutoBeforeEnabled && (this.fontSizeBeforeEnalbed = e.getFontSize());
        }
      },
      {
        from: e,
        name: k.EVENT.FONT_SIZE_MODE_UPDATED,
        action: () => {
          this.vz.isEnabled() && (this.fontSizeAutoBeforeEnabled = e.data.fontSizeAuto);
        }
      }
    ];
  }
  startViewzone(e, t = null) {
    const { x: i, y: r } = t || e.services.pointer.getCoords();
    this.bindSubscriptions(e), this.vz.reset(), this.vz.center(i, r), this.vz.draw();
  }
  vzPointerDown(e, t) {
    if (t.type.includes("touch") && this.refreshHover(e, !0), this.vz.hasHover()) {
      const { x: i, y: r } = e.services.pointer.getCoords();
      this.vz.isCloseButtonHover(i, r) && this.vz.hide(), this.vz.rectangleComponent.data.resizerSelected !== null ? e.services.interaction.setCurrent(this.vzResizeInteraction.name) : e.services.interaction.setCurrent(this.vzPanInteraction.name), e.startInteraction(t);
    }
  }
  onInit(e) {
    const t = e.components.viewzone;
    this.vz = t, this.vzPanInteraction = new za({
      component: t,
      services: e.services
    }), this.vzResizeInteraction = new Ba({
      component: t,
      services: e.services
    }), e.services.interaction.addResource(this.vzPanInteraction, this.vzPanInteraction.name), e.services.interaction.addResource(this.vzResizeInteraction, this.vzResizeInteraction.name), new $a({ application: e, manager: e.data.manager }), new Ua({ application: e, manager: e.data.manager });
  }
  init(e) {
    le([{
      name: k.EVENT.READY,
      from: e
    }]).then(
      () => {
        this.onInit(e), super.init(e);
      }
    );
  }
  refreshHover(e, t = !1) {
    const { x: i, y: r } = e.services.pointer.getCoords();
    (e.state.pointer.isDown === !1 || t) && this.vz.isEnabled() && this.vz.refreshHover(i, r);
  }
  clearInteraction(e) {
    (e.services.interaction.getCurrentId() === this.vzPanInteraction.name || e.services.interaction.getCurrentId() === this.vzResizeInteraction.name) && e.services.interaction.restorePreviousInteraction();
  }
  toggleViewzone(e, t, i = null) {
    e.publish(_i.EVENT.STATUS_CHANGE, { placement: i });
    let r = this.vz.isEnabled();
    r ? (this.fontSizeAutoBeforeEnabled = e.data.fontSizeAuto, this.fontSizeBeforeEnalbed = e.getFontSize(), this.startViewzone(e, t)) : (this.vz.clear(), Object.values(e.services.point.getResources()).forEach((n) => {
      n.isSelected = !1;
    }), this.fontSizeAutoBeforeEnabled || (e.setFontSize(this.fontSizeBeforeEnalbed), this.fontSizeAutoBeforeEnabled = !1, this.fontSizeBeforeEnalbed = null)), e.services.renderingContext.update(H.ATTRIBUTE.VIEWZONE_ACTIVE, r), e.animations.redrawOnlySliceMeta.trigger();
  }
}
const Ga = (s, e) => {
  const t = new Va(s);
  return t.init(s, e), t;
}, _i = {
  EVENT: {
    STATUS_CHANGE: "viewzone-feature-status-change"
  }
};
class xe extends yi {
  constructor(e = {}) {
    super(e), this.default_id = null, this.current_id = null;
  }
}
class jt extends xe {
  constructor() {
    super({
      // container: new Set()
    }), this.qualities = new xe({
      container: /* @__PURE__ */ new Set()
    }), this.settingsByImageId = {};
  }
}
jt.EVENT = {
  QUALITY_CHANGE: "image-quality-change"
};
const ja = `
<svg x="0px" y="0px" viewBox="0 0 512 512" stroke="#FF0000" stroke-width="5">
<g>
<path d="M437.126,74.939c-99.826-99.826-262.307-99.826-362.133,0C26.637,123.314,0,187.617,0,256.005
			s26.637,132.691,74.993,181.047c49.923,49.923,115.495,74.874,181.066,74.874s131.144-24.951,181.066-74.874
			C536.951,337.226,536.951,174.784,437.126,74.939z M409.08,409.006c-84.375,84.375-221.667,84.375-306.042,0
			c-40.858-40.858-63.37-95.204-63.37-153.001s22.512-112.143,63.37-153.021c84.375-84.375,221.667-84.355,306.042,0
			C493.435,187.359,493.435,324.651,409.08,409.006z"/>
		<path d="M341.525,310.827l-56.151-56.071l56.151-56.071c7.735-7.735,7.735-20.29,0.02-28.046
			c-7.755-7.775-20.31-7.755-28.065-0.02l-56.19,56.111l-56.19-56.111c-7.755-7.735-20.31-7.755-28.065,0.02
			c-7.735,7.755-7.735,20.31,0.02,28.046l56.151,56.071l-56.151,56.071c-7.755,7.735-7.755,20.29-0.02,28.046
			c3.868,3.887,8.965,5.811,14.043,5.811s10.155-1.944,14.023-5.792l56.19-56.111l56.19,56.111
			c3.868,3.868,8.945,5.792,14.023,5.792c5.078,0,10.175-1.944,14.043-5.811C349.28,331.117,349.28,318.562,341.525,310.827z"/>
	
</g>
</svg>
`;
class yt extends ue {
  constructor(e) {
    super({
      name: "anatomy-point-canvas",
      ...e
    }), this.services = {
      point: e.services.point,
      slice: e.services.slice,
      filter: e.services.filter,
      structure: e.services.structure,
      style: e.services.style,
      series: e.services.series,
      renderingContext: e.services.renderingContext
    };
  }
  redraw(e) {
    this.clear(), this.refreshPointsAvailable(), e.services.pointDrawer.drawPoints(
      this.services.point.getPointsToDraw(),
      this
    );
  }
  getBoundingBox() {
    return this.services.point.pointHelper.getBoundingBox(this);
  }
  refreshPointsAvailable() {
    const e = this.services.point;
    e.clearLinks();
    const t = this.services.slice.getCurrent();
    t !== null && (e.clearPointsToDraw(), t.points.forEach((i) => {
      const r = e.findById(i);
      this.services.point.isVisible(r.id) && e.setDrawable(i);
    }));
  }
  updatePointStyle(e, t = !1) {
    const i = this.services.style, r = i.get(L.ATTRIBUTE.LABELS_FULL_ALPHA), n = i.get(L.ATTRIBUTE.LABELS_WEAK_ALPHA), a = this.services.series.isSchema(this.services.series.getCurrent());
    e.circleAlpha = r, e.edgeColor = a && !t ? e.color : me.BLACK, e.circleColor = a && !t ? me.BLACK : e.color, e.edgeAlpha = n, e.sizeMultiplier = 1, this.publish(yt.EVENT.UPDATE_POINT_STYLE, e);
  }
  applyLocalTransformationToPoint(e) {
    const {
      MULTIPLIER: t,
      VERTICAL_FLIP: i,
      HORIZONTAL_FLIP: r,
      IMAGE_OFFSET_X: n,
      IMAGE_OFFSET_Y: a
    } = this.services.renderingContext.get(), o = e.x * t, l = e.y * t;
    e.x = (o + n) * this.getComputedScaleX(i) + this.getTx(), e.y = (l + a) * this.getComputedScaleY(r) + this.getTy(), this.getRotatedCoordinatesOfPoint(e);
  }
  canvasCoordsToImageCoords(e) {
    const {
      MULTIPLIER: t,
      VERTICAL_FLIP: i,
      HORIZONTAL_FLIP: r,
      IMAGE_OFFSET_X: n,
      IMAGE_OFFSET_Y: a
    } = this.services.renderingContext.get();
    this.invertRotation(e);
    let o = (e.x - this.getTx()) / this.getComputedScaleX(i) - n, l = (e.y - this.getTy()) / this.getComputedScaleY(r) - a;
    o /= t, l /= t, e.x = o, e.y = l;
  }
  invertRotation(e) {
    const t = ci * this.services.renderingContext.get(H.ATTRIBUTE.ROTATION_ANGLE);
    if (t !== 0) {
      const i = Math.cos(t), r = Math.sin(t), { x: n, y: a } = e, o = this.getTx(), l = this.getTy();
      e.x = i * (n - o) + r * (a - l) + o, e.y = i * (a - l) - r * (n - o) + l;
    }
  }
  getRotatedCoordinatesOfPoint(e) {
    const t = ci * this.services.renderingContext.get(H.ATTRIBUTE.ROTATION_ANGLE);
    if (t !== 0) {
      const i = Math.cos(t), r = Math.sin(t), { x: n, y: a } = e, o = this.getTx(), l = this.getTy();
      e.x = i * (n - o) - r * (a - l) + o, e.y = i * (a - l) + r * (n - o) + l;
    }
  }
}
yt.EVENT = {
  UPDATE_POINT_STYLE: "update-point-style"
};
const Ya = 10, Wa = 5, is = 30;
class Za extends ne {
  constructor() {
    super({
      subscriber_id: "isolate-structure-feature"
    }), this.closeIcons = [], this.structure_id = null, this.preferredTaxonKey = null, this.taxonKeys = [], this.isolateStructureHasPointForCurrentSlice = !0;
  }
  subscribe(e) {
    const t = e.services.labelsDrawer;
    return [
      {
        from: e,
        name: k.EVENT.MOVE_SERIES,
        action: () => {
          this.cleanIsolate(e);
        }
      },
      {
        from: t,
        name: X.EVENT.BEFORE_GET_LABEL_INFO,
        action: ({ taxon_key: i, context: r }) => {
          this.taxonKeys.includes(i) && (r.textAvailableWidth -= is);
        }
      },
      {
        from: t,
        name: X.EVENT.BEFORE_DRAW_TEXT,
        action: ({ taxon_key: i, context: r, position: n }) => {
          this.taxonKeys.includes(i) && (r.textAvailableWidth -= is, r.side === "left" && (n.x += is));
        }
      },
      {
        from: t,
        name: X.EVENT.UPDATE_COLOR,
        action: (i) => {
          this.updateLabelAlpha(i, e);
        }
      },
      {
        from: t,
        name: X.EVENT.NEW_RENDERING,
        action: () => {
          this.deleteCloseButton();
        }
      },
      {
        from: t,
        name: X.EVENT.LABEL_DRAWN,
        action: (i) => {
          this.taxonKeys.length > 0 && this.taxonKeys.includes(i.taxon_key) && this.drawCloseButton(i, e);
        }
      },
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.CHECK_VISIBILITY,
        action: (i) => {
          this.taxonKeys.includes(i.taxon_key) && (i.isSelected = !0, i.priority = e.services.point.getHighestPriority() - 1e4);
        }
      },
      {
        from: e.components.pointsCanvas,
        name: yt.EVENT.UPDATE_POINT_STYLE,
        action: (i) => {
          this.taxonKeys.length > 0 && e.services.point.onUpdatePointStyle(e, i, this.taxonKeys.includes(i.taxon_key));
        }
      },
      {
        from: e,
        name: k.EVENT.MOVE_TO_SLICE,
        action: (i) => {
          this.taxonKeys.length > 0 && (i.isAuthorizedToMove = !1);
        }
      },
      {
        from: e,
        name: q.EVENT.ALL_POINT_DRAWN,
        action: () => {
          this.taxonKeys.length > 0 && this.checkCurrentSliceHasPointsForIsolatedStructure(e);
        }
      }
    ];
  }
  deleteCloseButton() {
    this.closeIcons.forEach((e) => {
      e.remove();
    }), this.closeIcons = [];
  }
  createCloseButton(e) {
    const t = document.createElement("div");
    return t.innerHTML = ja, t.classList.add("isolate-close-icon"), t.addEventListener("pointerdown", () => e.cleanIsolate()), e.ui.container.appendChild(t), this.closeIcons.push(t), t;
  }
  drawCloseButton(e, t) {
    const i = e.labelComponent, r = this.createCloseButton(t);
    let n, a;
    const { VERTICAL_LINE_PADDING: o } = t.services.style.get();
    a = e.currentYForLabels + Math.floor(e.heightDisplay / 2) + o - e.heightOfOneLine / 2, e.side === "left" ? n = e.textAvailableWidth + is - e.maxLength - Wa - e.heightOfOneLine : n = e.rightThreshold + e.maxLength + Ya + e.heightOfOneLine, a -= e.heightOfOneLine * (this.closeIcons.length - 1);
    const c = r.style;
    c.position = "relative", c.left = n + "px", c.width = e.heightOfOneLine + "px", c.height = e.heightOfOneLine + "px", c.top = a + "px";
    const u = r.children[0].style;
    u.stroke = i.getFillStyle(), u.fill = i.getFillStyle();
  }
  updateLabelAlpha(e, t) {
    if (this.taxonKeys.length > 0 && this.isolateStructureHasPointForCurrentSlice) {
      let i = L.ATTRIBUTE.LABELS_WEAK_ALPHA;
      t.services.point.getActives().filter((n) => this.taxonKeys.includes(n.taxon_key)).map((n) => n.id).includes(e.id) && (i = L.ATTRIBUTE.LABELS_FULL_ALPHA), e.alpha = t.services.style.get(i);
    }
  }
  /**
   * @param {Application} application
   * @param {string} source
   * @param {string} structure_id
   * @param {string|null} preferredTaxonKey
   */
  isolate(e, t, i, r = null) {
    if (this.structure_id !== i) {
      const n = e.services.slice, a = e.services.point, o = e.services.series, l = e.services.structure.findByStructId(i), c = l.map((f) => f.getTaxonKey());
      this.bindSubscriptions(e);
      const u = a.find({ taxon_key: { $in: c } });
      e.services.filter.find({ id: { $in: u.map((f) => parseInt(f.filter_id)) } }).forEach((f) => {
        const E = e.services.overlay;
        f.layer !== null && E.findById(f.layer) !== null && e.services.overlay.select(f.layer);
      }), u.forEach((f) => f.priority = a.getHighestPriority());
      const g = u.map((f) => n.findById(f.slice_id)), C = Array.from(new Set(l.map((f) => f.translation_key))), I = n.find({ title_id1: { $in: C } }), p = n.find({ title_id2: { $in: C } }), v = o.find({ name_id: { $in: C } }).flatMap((f) => n.find({ series_id: f.id })), d = Array.from(/* @__PURE__ */ new Set([...g, ...I, ...p, ...v]));
      n.updateRelativeIndexWith(d), this.redirectToCurrentSlice(e), e.ui.container.parentElement.classList.add("isolate-mode"), this.structure_id = i, this.preferredTaxonKey = r, this.taxonKeys = c, this.checkCurrentSliceHasPointsForIsolatedStructure(e), e.publish(mt.START_ISOLATE, { structure_id: i, preferredTaxonKey: r, source: t });
    }
  }
  checkCurrentSliceHasPointsForIsolatedStructure(e) {
    this.isolateStructureHasPointForCurrentSlice = e.services.point.getActives().some((t) => this.taxonKeys.includes(t.taxon_key));
  }
  redirectToCurrentSlice(e) {
    const t = e.services.slice.getCurrent();
    let i = 1;
    t !== null && (i = e.services.slice.getRelativeIndexById(t.id)), i < 1 && (i = 1), e.moveToSlice(i);
  }
  cleanIsolate(e) {
    this.clearSubscriptions(), e.services.slice.restoreDefaultIndex(), this.redirectToCurrentSlice(e), this.deleteCloseButton(), this.structure_id = null, this.taxonKeys = [], this.preferredTaxonKey = null, e.services.overlay.refreshSelected(e.services.filter), e.ui.container.parentElement.classList.remove("isolate-mode"), e.publish(mt.CLEAN_ISOLATE);
  }
  init(e) {
    e.isolateStructure = (t, i, r = null) => {
      if (e.services.structure.findByStructId(i) !== null)
        this.isolate(e, t, i, r);
      else
        throw new ht(i, "structure");
    }, e.cleanIsolate = () => this.cleanIsolate(e), e.getIsolatedStructureID = () => this.structure_id, e.getPreferredTaxonKeyForIsolatedStructure = () => this.preferredTaxonKey, le([
      { name: k.EVENT.READY, from: e }
    ]).then(() => {
      super.init(e);
    });
  }
}
const mt = {
  CLEAN_ISOLATE: "clean-isolate",
  START_ISOLATE: "start-isolate"
}, Xa = (s, e) => {
  const t = new Za(s);
  return t.init(s, e), t;
};
class Dr extends re {
  constructor(e = {}) {
    super({
      _id: e._id || "pin-mode-drawer-service"
    }), this.loadIcons();
  }
  async loadIcons() {
    this.pinImageBorder = await this.createImage(zn), this.imageWidth = this.pinImageBorder.width, this.imageHeight = this.pinImageBorder.height, this.pinImageFull = await this.createImage(Fn), this.fakeCanvas = document.createElement("canvas"), this.fakeCanvas.width = this.imageWidth, this.fakeCanvas.height = this.imageHeight;
  }
  drawPoints(e, t) {
    const { HORIZONTAL_FLIP: i } = t.services.renderingContext.get(), r = [...e];
    let n = t.getBoundingBox();
    const a = r.slice(0);
    let o = 0;
    const l = t.services.point;
    i ? r.sort((u, m) => m.y - u.y) : r.sort((u, m) => u.y - m.y), r.forEach((u) => {
      const m = l.refreshContextualCoords({
        transformation: (I) => t.applyLocalTransformationToPoint(I),
        point: u
      }), { x: g, y: C } = m;
      if (l.isVisible(u.id))
        if (t.updatePointStyle(u, !0), l.isInBox(m, n))
          this.drawOnePoint(u, t), a[o++] = u;
        else {
          const { RECENTER_SLIGHT_MARGIN: I } = t.services.style.get();
          if (t.needToHandleIsolateOffset === !0) {
            t.needToHandleIsolateOffset = !1;
            let p = 0, T = 0;
            u < n.left ? p = n.left - g + I : g > n.right && (p = n.right - g - I), C < n.top ? T = n.top - C + I : C > n.bottom && (T = n.bottom - C - I), (p !== 0 || T !== 0) && t.translateCanvas(p, T);
          }
        }
    }), a.length = o;
    const c = n.left + (n.right - n.left) * 0.5;
    t.services.renderingContext.update(H.ATTRIBUTE.LEFT_RIGHT_THRESHOLD, c), t.services.point.setPointsVisible(a);
  }
  /**
   * Draw pin point
   * @param {Point} point
   * @param pointCanvas
   */
  drawOnePoint(e, t) {
    const {
      MULTIPLIER: i,
      IMAGE_OFFSET_X: r,
      IMAGE_OFFSET_Y: n,
      HORIZONTAL_FLIP: a,
      VERTICAL_FLIP: o,
      SCALE: l,
      ROTATION_ANGLE: c
    } = t.services.renderingContext.get();
    this.drawPin(
      e.x * i + r,
      e.y * i + n,
      this.imageWidth / l,
      this.imageHeight / l,
      t,
      e,
      a,
      o,
      c % 360
    );
  }
  drawPin(e, t, i, r, n, a, o, l, c) {
    i *= a.sizeMultiplier, r *= a.sizeMultiplier;
    const u = this.fakeCanvas.getContext("2d");
    u.setTransform(1, 0, 0, 1, 0, 0), u.clearRect(0, 0, this.fakeCanvas.width, this.fakeCanvas.height), u.globalAlpha = a.circleAlpha;
    let m = { x: 0, y: 0 };
    (c !== 0 || o) && (l && (c = -c), o && (c === 0 || Math.abs(c) === 180) && (c += 180), u.translate(this.pinImageFull.naturalWidth / 2, this.pinImageFull.naturalHeight / 2), u.rotate(-c * Math.PI / 180), m.x -= this.pinImageFull.naturalWidth / 2, m.y -= this.pinImageFull.naturalHeight / 2), u.drawImage(this.pinImageFull, m.x, m.y, this.pinImageFull.naturalWidth, this.pinImageFull.naturalHeight), u.globalCompositeOperation = "source-atop", u.beginPath(), u.arc(
      this.pinImageFull.naturalWidth / 2 + m.x,
      this.pinImageFull.naturalHeight / 2 + m.y,
      r * 4,
      // Scale by 4 for when we zoom
      0,
      Math.PI * 2,
      !1
    ), u.closePath();
    const g = We(a.circleColor);
    u.fillStyle = `rgb(${g.r}, ${g.g}, ${g.b})`, u.fill(), u.globalCompositeOperation = "source-over", u.drawImage(this.pinImageBorder, m.x, m.y, this.pinImageBorder.naturalWidth, this.pinImageBorder.naturalHeight), u.globalAlpha = 1, e -= i / 2, t -= r, c < 0 && (c += 360), c > 0 && c < 180 ? (e -= i / 2, t += r / 2) : c >= 180 && c < 270 ? t += r : c >= 270 && c < 360 && (e += i / 2, t += r / 2), n.drawImage(this.fakeCanvas, e, t, i, r);
  }
  createImage(e) {
    return new Promise((t, i) => {
      let r = new Image();
      r.onload = () => t(r), r.onerror = i, r.src = e;
    });
  }
}
const Qa = "hidden", Ka = -5;
class qa extends re {
  constructor(e, t = {}) {
    super(t), this.wrapperComponents = {}, this.application = e, this.allowPointer = !0;
  }
  deleteWrapper(e, t) {
    const i = t.dataset.pointId;
    this.application.ui.container.removeChild(t), this.wrapperComponents[e].wrappers = this.wrapperComponents[e].wrappers.filter((r) => r.dataset.pointId !== i), this.wrapperComponents[e].texts = this.wrapperComponents[e].texts.filter((r) => r.dataset.pointId !== i), this.wrapperComponents[e].icons = this.wrapperComponents[e].icons.filter((r) => r.dataset.pointId !== i);
  }
  delete(e) {
    this.wrapperComponents[e].wrappers.forEach((t) => {
      this.application.ui.container.removeChild(t);
    }), delete this.wrapperComponents[e];
  }
  toggleDisplay(e, t, i) {
    if (typeof this.wrapperComponents[e] < "u")
      this.delete(e);
    else {
      this.generateElement(e);
      const r = this.wrapperComponents[e].wrappers;
      this.setText(e, t), i().then((n) => this.setImage(e, n)), r.forEach((n) => this.application.ui.container.appendChild(n));
    }
  }
  existOnCoords(e, t) {
    for (const i in this.wrapperComponents)
      for (const r in i.wrappers) {
        const n = r.getBoundingClientRect();
        if (n.left < e && n.right > e && n.top < t && n.bottom > t)
          return !0;
      }
    return !1;
  }
  onPointerDown(e) {
    e.preventDefault();
  }
  onPointerUp(e, t) {
    if (oe.isLeftClick(e)) {
      const i = this.application.services.point.findById(t), r = this.application.services.structure.findByTaxonKey(i.getTaxonKey());
      this.application.services.structure.publish(
        ae.EVENT.CLICK,
        {
          structure: r,
          point: i
        }
      );
    }
  }
  createElement(e) {
    const t = document.createElement("div");
    t.dataset.pointId = e, t.addEventListener("pointerup", (a) => this.onPointerUp(a, e)), t.addEventListener("pointerdown", (a) => this.onPointerDown(a)), t.classList.add("structure-title-component-pin");
    const i = document.createElement("img");
    i.dataset.pointId = e;
    const r = document.createElement("span");
    r.dataset.pointId = e, t.appendChild(i), t.appendChild(r);
    const n = { ...this.application.services.point.findById(e) };
    return this.application.components.pointsCanvas.applyLocalTransformationToPoint(n), this.setPosition(
      t,
      n.x,
      n.y - ds.height * n.sizeMultiplier
    ), {
      wrapper: t,
      text: r,
      icon: i
    };
  }
  generateElement(e) {
    const t = this.application.services.point.getActives().filter((a) => a.taxon_key === e).map((a) => a.id), i = [], r = [], n = [];
    t.forEach((a) => {
      const {
        wrapper: o,
        text: l,
        icon: c
      } = this.createElement(a);
      i.push(o), r.push(l), n.push(c);
    }), this.wrapperComponents[e] = {
      wrappers: i,
      texts: r,
      icons: n,
      hidden: !1
    };
  }
  setText(e, t) {
    typeof this.wrapperComponents[e] < "u" && (this.wrapperComponents[e].texts.forEach((i) => i.textContent = t), this.wrapperComponents[e].text = t);
  }
  setImage(e, t) {
    typeof this.wrapperComponents[e] < "u" && (this.wrapperComponents[e].icons.forEach((i) => i.src = t), this.wrapperComponents[e].icon = t);
  }
  update(e) {
    if (this.wrapperComponents[e] !== "undefined") {
      const t = this.wrapperComponents[e], i = this.application.services.point.getActives().filter((n) => n.taxon_key === e), r = i.filter((n) => typeof t.wrappers.find((a) => a.dataset.pointId === n.id.toString()) > "u");
      t.wrappers.forEach((n) => {
        const a = i.find((o) => o.id.toString() === n.dataset.pointId);
        if (typeof a < "u") {
          const o = J.getOne().setCoords(a.x, a.y);
          this.application.components.pointsCanvas.applyLocalTransformationToPoint(o), this.setPosition(n, o.x, o.y - ds.height * a.sizeMultiplier), J.recycle(o);
        } else
          this.deleteWrapper(e, n);
      }), r.forEach((n) => {
        const {
          wrapper: a,
          text: o,
          icon: l
        } = this.createElement(n.id);
        o.textContent = t.text, l.src = t.icon, t.wrappers.push(a), t.texts.push(o), t.icons.push(l), this.application.ui.container.appendChild(a);
      });
    }
  }
  setPosition(e, t, i) {
    const r = this.application.ui.container.getBoundingClientRect();
    e.style.left = `${r.left + t}px`, e.style.top = `${r.top + (i + Ka)}px`;
  }
  clear() {
    Object.keys(this.wrapperComponents).forEach((e) => {
      this.delete(e);
    });
  }
  clearExcept(e) {
    Object.keys(this.wrapperComponents).forEach((t) => {
      e.includes(t) || this.delete(t);
    });
  }
  allowPointerEvents() {
    this.allowPointer || (Object.values(this.wrapperComponents).forEach((e) => {
      e.wrappers.forEach((t) => t.style.pointerEvents = "");
    }), this.allowPointer = !0);
  }
  disallowPointerEvents() {
    this.allowPointer && (Object.values(this.wrapperComponents).forEach((e) => {
      e.wrappers.forEach((t) => t.style.pointerEvents = "none");
    }), this.allowPointer = !1);
  }
  toggleHiddenClass(e) {
    this.wrapperComponents[e].wrappers.forEach((t) => {
      t.classList.toggle(Qa);
    });
  }
}
const Ja = 2;
class eo {
  constructor(e) {
    this.application = e, this.structureTitlePinComponent = null;
  }
  onPointerUp(e, t) {
    const i = this.getStructureTitlePinComponent();
    if (e.services.point.hasHover() && $.isRightClick(t) === !1) {
      const r = e.services.point.getHover(), n = e.getTextLabelByTaxonKey(r.taxon_key, r.id), a = e.services.structure.findByTaxonKey(r.taxon_key);
      i.toggleDisplay(
        a.getTaxonKey(),
        n,
        () => e.getIcon(a.icon_id)
      ), e.animations.redrawOnlySliceMeta.trigger();
    }
  }
  getSizePin(e) {
    const { MULTIPLIER: t, SCALE: i } = this.application.services.renderingContext.get();
    return {
      width: ds.width / (i * t) * e.sizeMultiplier,
      height: ds.height / (i * t) * e.sizeMultiplier
    };
  }
  getBoundingBox(e) {
    return {
      top: 0,
      bottom: Math.ceil(e.getHeight()),
      left: 0,
      right: Math.ceil(e.getWidth())
    };
  }
  getPointBoundingBox(e) {
    const t = this.getSizePin(e);
    return {
      top: Math.ceil(e.y - t.height),
      bottom: e.y,
      left: Math.ceil(e.x - t.width * 0.5),
      right: Math.ceil(e.x + t.width * 0.5) - Ja
    };
  }
  pointIsInBBox(e, t) {
    return e.x >= t.left && e.x <= t.right && e.y <= t.bottom && e.y >= t.top;
  }
  getCoordsPoint(e) {
    return e.services.point.fromCoords(
      e.state.pointer.data.coords.x,
      e.state.pointer.data.coords.y
    );
  }
  getPointHover(e) {
    const t = e.services.point, i = e.components.pointsCanvas, r = this.getCoordsPoint(e);
    i.canvasCoordsToImageCoords(r);
    const n = t.getActives();
    let a = null;
    for (let o = 0; o < n.length; o++) {
      const l = n[o], c = this.getPointBoundingBox(l);
      this.pointIsInBBox(r, c) && (a = l);
    }
    return J.recycle(r), a;
  }
  clear() {
    this.clearExcept([]);
  }
  isOnDetail(e) {
    return this.structureTitlePinComponent.existOnCoords(e.x, e.y);
  }
  clearExcept(e) {
    this.getStructureTitlePinComponent().clearExcept(e), this.application.animations.redrawOnlySliceMeta.trigger();
  }
  onAllPointDrawn() {
    const e = this.getStructureTitlePinComponent();
    Object.keys(e.wrapperComponents).forEach((t) => {
      e.update(t);
    });
  }
  onUpdatePointStyle(e, t, i = !1) {
    i ? (t.circleAlpha = e.services.style.get(L.ATTRIBUTE.LABELS_ISOLATE_ALPHA), t.circleColor = e.services.style.get(L.ATTRIBUTE.ISOLATE_COLOR_PIN)) : t.circleAlpha = e.services.style.get(L.ATTRIBUTE.PIN_WEAK_ALPHA);
  }
  updatePointSizeMultiplier(e) {
    const t = this.getStructureTitlePinComponent();
    e.sizeMultiplier = typeof t.wrapperComponents[e.taxon_key] < "u" ? 1.3 : 1;
  }
  getStructureTitlePinComponent() {
    return this.structureTitlePinComponent === null && (this.structureTitlePinComponent = new qa(this.application)), this.structureTitlePinComponent;
  }
  disallowPointerEvents() {
    this.getStructureTitlePinComponent().disallowPointerEvents();
  }
  allowPointerEvents() {
    this.getStructureTitlePinComponent().allowPointerEvents();
  }
  isolate(e) {
    const t = this.getStructureTitlePinComponent();
    e.forEach((i) => {
      if (typeof t.wrapperComponents[i] > "u") {
        const r = this.application.getTextLabelByTaxonKey(i), n = this.application.services.structure.findByTaxonKey(i);
        t.toggleDisplay(
          i,
          r,
          () => this.application.getIcon(n.icon_id)
        );
      }
    }), this.clearExcept(e);
  }
  toggleStructureTitlePinComponent() {
    const e = this.getStructureTitlePinComponent();
    Object.keys(e.wrapperComponents).forEach((t) => {
      e.toggleHiddenClass(t);
    });
  }
}
class it extends ne {
  init(e) {
    le([{
      name: k.EVENT.READY,
      from: e
    }]).then(
      () => {
        super.init(e), this.onInit(e);
      }
    );
  }
  onInit(e) {
  }
}
const Ti = {
  TOGGLE: "toggle_label_notification"
}, zt = {
  EVENT: {
    STATUS_CHANGE: "pin-mode-feature-status-change"
  }
};
class to extends it {
  constructor(e) {
    super({
      ...e,
      subscriber_id: "pin-mode-feature"
    }), this.standardPointDrawer = e.services.pointDrawer, this.pointDrawer = new Dr({
      ...e,
      drawer_id: "pin-mode-drawer"
    }), this.pointHelper = e.services.point.pointHelper, this.pinHelper = new eo(e), this.pointerHasMoveWhenWasDown = !1, this.taxonKeys = [];
  }
  disable(e) {
    e.publish(zt.EVENT.STATUS_CHANGE), super.disable(), e.setPointDrawer(this.standardPointDrawer), e.services.point.setPointHelper(this.pointHelper), this.pinHelper.structureTitlePinComponent.clear(), e.components.leftLinesCanvas.show(), e.components.rightLinesCanvas.show();
  }
  enable(e) {
    e.publish(zt.EVENT.STATUS_CHANGE), super.enable(), e.setPointDrawer(this.pointDrawer), e.services.point.setPointHelper(this.pinHelper), e.components.leftLinesCanvas.hide(), e.components.rightLinesCanvas.hide();
  }
  toggle(e) {
    this.isEnabled() ? this.disable(e) : this.enable(e), e.animations.redrawOnlySliceMeta.trigger();
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: k.EVENT.SHOW_META_CANVAS,
        action: () => {
          this.isEnabled() && (e.components.leftLinesCanvas.hide(), e.components.rightLinesCanvas.hide());
        }
      },
      {
        // Remove all labels
        from: e.services.labelsDrawer,
        name: X.EVENT.BEFORE_SET_CANDIDATES,
        action: (t) => {
          this.isEnabled() && (t.candidates = []);
        }
      },
      {
        from: e,
        name: [Ci.EVENT.STATUS_CHANGE, _i.EVENT.STATUS_CHANGE],
        action: () => {
          this.isEnabled() && this.disable(e);
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_MOVE,
        action: () => {
          e.state.pointer.isDown && (this.pointerHasMoveWhenWasDown = !0, this.isEnabled() && this.pinHelper.disallowPointerEvents());
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_DOWN,
        action: (t) => {
          this.isEnabled() && !this.pinHelper.isOnDetail(t) && this.pinHelper.disallowPointerEvents();
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_UP,
        action: (t) => {
          this.isEnabled() && this.pinHelper.allowPointerEvents(), this.isEnabled() && !e.services.point.hasHover() && !this.pointerHasMoveWhenWasDown && !$.isRightClick(t) && !this.pinHelper.isOnDetail(t) && this.pinHelper.clearExcept(this.taxonKeys), this.pointerHasMoveWhenWasDown = !1;
        }
      },
      {
        from: e,
        name: q.EVENT.ALL_POINT_DRAWN,
        action: () => {
          this.isEnabled() && this.pinHelper.onAllPointDrawn();
        }
      },
      {
        from: e.components.pointsCanvas,
        name: yt.EVENT.UPDATE_POINT_STYLE,
        action: (t) => {
          this.isEnabled() && this.pinHelper.updatePointSizeMultiplier(t);
        }
      },
      {
        from: e,
        name: mt.START_ISOLATE,
        action: ({ structure_id: t }) => {
          if (this.isEnabled()) {
            const i = e.services.structure.findByStructId(t);
            this.taxonKeys = i.map((r) => r.getTaxonKey()), this.pinHelper.isolate(this.taxonKeys);
          }
        }
      },
      {
        from: e,
        name: mt.CLEAN_ISOLATE,
        action: () => {
          this.isEnabled() && (this.taxonKeys = []);
        }
      },
      {
        from: e,
        name: k.EVENT.GET_SELECTED_POINTS,
        action: (t) => {
          this.isEnabled() && e.services.point.getActives().forEach((r) => t.push(r));
        }
      },
      {
        from: e,
        name: Ti.toggle,
        action: () => {
          this.isEnabled() && this.pinHelper.toggleStructureTitlePinComponent();
        }
      }
    ];
  }
}
const so = (s, e) => {
  const t = new to(s);
  return t.init(s, e), t;
};
class io extends Oe {
  init(e) {
    e.setBehavior("reverseScrolling", (t) => {
      e.data.scrollDirection === Qe.FORWARD ? e.data.scrollDirection = Qe.BACKWARD : e.data.scrollDirection = Qe.FORWARD, e.publish(Pr.EVENT.STATUS_CHANGE, { isReverse: e.data.scrollDirection === Qe.FORWARD, placement: t });
    });
  }
}
const Pr = {
  EVENT: {
    STATUS_CHANGE: "reverse-scroll-status-change"
  }
}, ro = (s, e) => {
  const t = new io(e);
  return t.init(s, e), t;
}, _t = {
  LOADED: "share-link-context-loaded",
  PAN_ZOOM_LOADED: "share-link-pan-zoom-context-loaded",
  POINTS_LOADED: "share-link-points-context-loaded"
};
class no extends ne {
  constructor(e) {
    super({
      ...e,
      subscriber_id: "hide-point-feature"
    }), this.hidePointsWithoutLabel = !1;
  }
  toggleFeature(e) {
    this.hidePointsWithoutLabel ? this.setInactive(e) : this.setActive(e);
  }
  clear(e) {
    e.pointsWithLabel.clear();
  }
  whitelist(e, t) {
    e.pointsWithLabel.add(t);
  }
  isActive() {
    return this.hidePointsWithoutLabel;
  }
  setActive(e) {
    this.hidePointsWithoutLabel = !0, e.animations.redrawOnlySliceMeta.trigger();
  }
  setInactive(e) {
    this.hidePointsWithoutLabel = !1, e.animations.redrawOnlySliceMeta.trigger();
  }
  drawWhitelistedPoints(e) {
    if (this.hidePointsWithoutLabel) {
      const t = e.components.pointsCanvas;
      t.clear(), e.pointsWithLabel.forEach((i) => {
        const r = e.services.point.findById(i);
        e.services.pointDrawer.drawOnePoint(r, t);
      }), e.publish(kr.END_DRAW_POINTS_WITHOUT_LABEL);
    }
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      },
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.LABEL_DRAWN,
        action: ({ point: t }) => {
          this.whitelist(e, t.id);
        }
      },
      {
        from: e,
        name: X.EVENT.ALL_LABEL_DRAWN,
        action: () => {
          this.drawWhitelistedPoints(e);
        }
      },
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.NEW_RENDERING,
        action: () => {
          this.clear(e);
        }
      },
      {
        from: e,
        name: zt.EVENT.STATUS_CHANGE,
        action: () => {
          this.isActive() && this.toggleFeature(e);
        }
      }
    ];
  }
}
const kr = {
  END_DRAW_POINTS_WITHOUT_LABEL: "hide-point-without-label-end-draw"
}, ao = (s, e) => {
  const t = new no(e);
  return t.init(s, e), t;
}, Hr = {
  getSeriesTitle(s, e) {
    return s === null || s.title_1 === null && s.title_2 === null ? e !== null ? `${e?.name} ${s.sort_order - e.start_index + 1}` : "" : s.title_1 === null ? s.title_2 : s.title_2 === null ? s.title_1 : `${s.title_1} - ${s.title_2}`;
  }
}, As = 18, Rt = 19, ji = 10, Yi = 5, oo = 10, lo = 5, Wi = 15, Ht = {
  GENERATE_WATERMARK: "generate-watermark",
  CLEAR_WATERMARK: "clear-watermark",
  TAKE_SCREENSHOT: "take-screenshot"
};
class Se extends it {
  constructor() {
    super();
  }
  onInit(e) {
    e.setBehavior("saveImage", ({ displaySeriesTitle: i = !0 } = {}) => {
      Se.saveImage(e, i);
    }), e.setBehavior("download-image", ({ name: i = null, displaySeriesTitle: r = !0 } = {}) => {
      const n = document.createElement("a");
      n.download = `${i !== null ? i : Se.getSeriesTitle(e)}.jpg`, n.href = Se.generateScreenshotUrl(e, r), n.click();
    });
    let t;
    e.setBehavior("generate-watermark", () => {
      const i = e.ui.container, r = i.offsetWidth, n = i.offsetHeight;
      t = Se.generateWatermarkCanvas(e, r, n), t.style.zIndex = 26, t.style.position = "absolute", i.appendChild(t), e.publish(Ht.GENERATE_WATERMARK);
    }), e.setBehavior("remove-watermark", () => {
      t.remove(), e.emit(Ht.CLEAR_WATERMARK);
    }), this.exposeFunctionsForScrapper(e);
  }
  static saveImage(e, t) {
    e.publish(Ht.TAKE_SCREENSHOT);
    const i = Se.generateScreenshotUrl(e, t), r = new Image();
    r.src = i;
    const n = window.open();
    n.document.write(r.outerHTML), n.document.body.style.margin = 0, e.animations.redrawOnlySliceMeta.trigger();
  }
  static generateScreenshotUrl(e, t = !0) {
    const {
      pointsCanvas: i,
      imageCanvas: r,
      overlaysCanvas: n,
      leftLinesCanvas: a,
      rightLinesCanvas: o
    } = e.components, l = r.getWidth(), c = r.getHeight(), u = document.createElement("canvas"), m = u.getContext("2d");
    return u.width = l, u.height = c, i.clear(), e.drawOnlyLinkedPoint(), m.fillStyle = e.services.series.isSchema() ? `#${me.WHITE}` : `${me.BLACK}`, m.fillRect(0, 0, l, c), m.drawImage(r.getCanvas(), 0, 0, l, c), m.drawImage(n.getCanvas(), 0, 0, l, c), m.drawImage(i.getCanvas(), 0, 0, l, c), m.drawImage(a.getCanvas(), 0, 0, l, c), m.drawImage(o.getCanvas(), 0, 0, l, c), m.drawImage(
      Se.generateWatermarkCanvas(e, l, c),
      0,
      0
    ), t && m.drawImage(Se.generateTitle(e, l, c), 0, 0), u.toDataURL("image/jpeg");
  }
  static generateWatermarkCanvas(e, t, i) {
    const r = document.createElement("canvas"), n = r.getContext("2d");
    r.height = i, r.width = t, n.save(), n.translate(t - 65, i), n.rotate(-90 * Math.PI / 180), n.font = `bold 10px ${ss}`, n.fillStyle = Bn;
    const a = e.application_id === Pe.EANATOMY ? "e-Anatomy" : "vet-Anatomy";
    n.fillText(a, 20, 40), n.font = `7px ${ss}`;
    const o = `© Copyright IMAIOS ${(/* @__PURE__ */ new Date()).getFullYear()}`;
    return n.fillText(o, 20, 50), r;
  }
  static getSeriesTitle(e) {
    return Hr.getSeriesTitle(e.getCurrentSlice(), e.getCurrentSeries());
  }
  static getOrientation(e) {
    const t = e.getCurrentSlice();
    return t.orientation !== "" ? `(${t.orientation})` : null;
  }
  static getColors(e) {
    const t = document.getElementById(e.parentContainer_id), i = getComputedStyle(t.firstElementChild);
    return {
      fontColor: i.getPropertyValue("--color"),
      backgroundColor: i.getPropertyValue("--background")
    };
  }
  static generateTitle(e, t, i) {
    const r = Se.getSeriesTitle(e), n = Se.getOrientation(e), { fontColor: a, backgroundColor: o } = Se.getColors(e), l = document.createElement("canvas"), c = l.getContext("2d");
    l.height = i, l.width = t, c.font = `bold ${Rt}px ${ss}`;
    const u = c.measureText(r + n).width, m = c.measureText(n).width;
    c.fillStyle = o;
    const g = (t - u) / 2;
    return da(
      c,
      g - ji,
      As - Yi,
      u + ji * 2 + Wi / 2,
      Rt + Yi * 2 + lo,
      oo
    ), c.fillStyle = a, c.fillText(r, g, Rt + As), n !== null && (c.font = `normal ${Rt}px ${ss}`, c.fillText(n, (t + u) / 2 - m + Wi, Rt + As)), l;
  }
  exposeFunctionsForScrapper(e) {
    e.exposeFunction("generateScreenshotUrl", (t = !0) => Se.generateScreenshotUrl(e, t));
  }
}
const co = (s) => {
  const e = new Se();
  return e.init(s), e;
}, St = {
  BLACKLIST: "blacklist-structure",
  CLEAR_BLACKLIST: "clear-blacklist"
}, ms = {
  BLACKLIST_POINT: "blacklist-point-event",
  WHITELIST_POINT: "whitelist-point-event"
}, Fr = {
  TOGGLE: "toggle-overlays-notification"
}, z = {
  application: {
    READY: k.EVENT.READY,
    RESIZED: k.EVENT.RESIZED,
    ERROR: k.EVENT.ERROR,
    RENDERING_FIRST_FRAME: k.EVENT.RENDERING_FIRST_FRAME,
    MODULE_DATA_LOADED: k.EVENT.MODULE_DATA_LOADED,
    FONT_SIZE_UPDATED: k.EVENT.FONT_SIZE_UPDATED
  },
  filter: {
    ADDED: se.EVENT.ADDED,
    LOADED: se.EVENT.LOADED,
    SELECTED: se.EVENT.SELECTED,
    UNSELECTED: se.EVENT.UNSELECTED
  },
  contrast: {
    ADDED: Ce.EVENT.ADDED,
    LOADED: Ce.EVENT.LOADED,
    SELECTED: Ce.EVENT.SELECTED,
    SET_DEFAULT: Ce.EVENT.SET_DEFAULT
  },
  translator: {
    ADDED: V.EVENT.ADDED
  },
  language: {
    CHANGE: Re.EVENT.CHANGE,
    ADDED: Re.EVENT.ADDED,
    LOADED: Re.EVENT.LOADED
  },
  interaction: {
    CHANGE: Lt.EVENT.CHANGE
  },
  orientation: {
    CHANGE: ut.EVENT.CHANGE
  },
  image: {
    LOADING_START: B.EVENT.LOADING_START,
    LOADING_END: B.EVENT.LOADING_END,
    ASK_SHOW_PROGRESS: B.EVENT.ASK_SHOW_PROGRESS,
    ASK_HIDE_PROGRESS: B.EVENT.ASK_HIDE_PROGRESS,
    QUALITY_CHANGE: jt.EVENT.QUALITY_CHANGE,
    IMAGE_SLICE_HAS_BEEN_LOADED: B.EVENT.IMAGE_SLICE_HAS_BEEN_LOADED,
    STOP_LOADING_IMAGES: "stop-loading-images"
  },
  structure: {
    CLICK: ae.EVENT.CLICK,
    SELECTED: ae.EVENT.SELECTED,
    FILTER: "filter-structure"
  },
  series: {
    CHANGE: vt.EVENT.SERIES_CHANGE,
    SELECT_SERIES: "select-series"
  },
  slice: {
    CHANGE: fe.EVENT.SLICE_CHANGE,
    SLICE_INDEX_CHANGE: fe.EVENT.SLICE_INDEX_CHANGE,
    LOADED: fe.EVENT.SLICE_LOADED
  },
  quiz: {
    CHANGE: Ci.EVENT.STATUS_CHANGE
  },
  viewzone: {
    CHANGE: _i.EVENT.STATUS_CHANGE
  },
  ui: {
    CLOSE_MENU: "close-menu",
    SETTINGS: {
      RESET: "reset-settings",
      DISPLAY_SHORTCUTS: "display-shortcuts",
      CHANGE_THEME: "change-theme"
    },
    THEME: {
      SWITCH: "switch-theme"
    },
    VIEWER: {
      MOUNTED: "anatomy-viewer-mounted",
      SEARCH: "viewer-search-click",
      ORIENTATION: "orientation-status-change",
      MIN_FONT_UPDATE: "update-min-font-size",
      CONTRAST: "contrast-click",
      CROSS_REFERENCES: "cross-references-panel-status-change",
      HAS_BEEN_RESIZED: "ui-viewer-has-been-resized",
      MENU_INITIALIZED: "ui-menu-has-been-initialized",
      CROSS_REFERENCES_INITIALIZED: "ui-cr-has-been-initialized",
      OVERLAY_OPACITY_CHANGED: "ui-menu-overlay-opacity-changed",
      MENU_STATE_CHANGED: "ui-menu-state-change"
    },
    PANEL_STRUCTURE: {
      OPEN: "structure-panel-open",
      ISOLATE: "structure-panel-option-isolate",
      HIDE: "structure-panel-option-hide",
      SELECT: "structure-panel-option-isolate",
      CLICK_HIERARCHY: "structure-panel-click-hierarchy",
      CLICK_GALLERY: "structure-panel-click-gallery",
      CLICK_IMAGE_STRUCTURE_GALLERY: "click-image-structure-gallery"
    },
    MODULE_GALLERY: {
      CLICK_IMAGE: "click-image-gallery"
    },
    BOTTOM_GALLERY: {
      CLICK_IMAGE: "bottom-gallery-click_image"
    }
  },
  featureIsolate: {
    CLEAN_ISOLATE: mt.CLEAN_ISOLATE,
    START_ISOLATE: mt.START_ISOLATE
  },
  pinMode: {
    CHANGE: zt.EVENT.STATUS_CHANGE
  },
  reverseScroll: {
    STATUS_CHANGE: Pr.EVENT.STATUS_CHANGE
  },
  shareLink: {
    LOADED: _t.LOADED
  },
  hidePointsWithoutLabelFeature: {
    END_DRAW_POINTS_WITHOUT_LABEL: kr.END_DRAW_POINTS_WITHOUT_LABEL
  },
  fullscreenFeature: {
    ON_FULLSCREEN: us.ON_FULLSCREEN,
    ON_EXIT_FULLSCREEN: us.ON_EXIT_FULLSCREEN
  },
  saveImageFeature: {
    GENERATE_WATERMARK: Ht.GENERATE_WATERMARK,
    CLEAR_WATERMARK: Ht.CLEAR_WATERMARK
  },
  blacklistFeature: {
    BLACKLIST_STRUCTURE: St.BLACKLIST,
    CLEAR_BLACKLIST_STRUCTURE: St.CLEAR_BLACKLIST,
    BLACKLIST_POINT: ms.BLACKLIST_POINT,
    WHITELIST_POINT: ms.WHITELIST_POINT
  },
  errors: {
    VUE_ERROR: "vue-error",
    CORE_ERROR: "core-error",
    STRUCTURE_PANEL: "structure-panel",
    STRUCTURE_PANEL_GALLERY: "structure-panel-gallery"
  },
  pointerHandler: {
    UP: $.EVENT.POINTER_UP,
    DOWN: $.EVENT.POINTER_DOWN,
    MOVE: $.EVENT.POINTER_MOVE
  },
  gallery: {
    IN_THIS_MODULE: {
      CLICK_IMAGE: "click-image-in-this-module"
    },
    IN_OTHER_MODULE: {
      CLICK_IMAGE: "click-image-in-other-module"
    }
  },
  labels: {
    TOGGLE: Ti.TOGGLE
  },
  overlays: {
    TOGGLE: Fr.TOGGLE
  }
}, Z = {
  la: 1,
  en: 2,
  fr: 3,
  de: 4,
  es: 5,
  cn: 6,
  jp: 7,
  it: 8,
  br: 9,
  ru: 10,
  ar: 12,
  pl: 15,
  ko: 17
};
var ws = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uo(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function ho(s) {
  if (Object.prototype.hasOwnProperty.call(s, "__esModule")) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(s, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[i];
      }
    });
  }), t;
}
var os = { exports: {} };
function mo(s) {
  throw new Error('Could not dynamically require "' + s + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ls = { exports: {} };
const fo = {}, po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fo
}, Symbol.toStringTag, { value: "Module" })), go = /* @__PURE__ */ ho(po);
var vo = ls.exports, Zi;
function yo() {
  return Zi || (Zi = 1, function(s, e) {
    (function(t, i) {
      s.exports = i();
    })(vo, function() {
      var t = t || function(i, r) {
        var n;
        if (typeof window < "u" && window.crypto && (n = window.crypto), typeof self < "u" && self.crypto && (n = self.crypto), typeof globalThis < "u" && globalThis.crypto && (n = globalThis.crypto), !n && typeof window < "u" && window.msCrypto && (n = window.msCrypto), !n && typeof ws < "u" && ws.crypto && (n = ws.crypto), !n && typeof mo == "function")
          try {
            n = go;
          } catch {
          }
        var a = function() {
          if (n) {
            if (typeof n.getRandomValues == "function")
              try {
                return n.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof n.randomBytes == "function")
              try {
                return n.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, o = Object.create || /* @__PURE__ */ function() {
          function d() {
          }
          return function(f) {
            var E;
            return d.prototype = f, E = new d(), d.prototype = null, E;
          };
        }(), l = {}, c = l.lib = {}, u = c.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(d) {
              var f = o(this);
              return d && f.mixIn(d), (!f.hasOwnProperty("init") || this.init === f.init) && (f.init = function() {
                f.$super.init.apply(this, arguments);
              }), f.init.prototype = f, f.$super = this, f;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var d = this.extend();
              return d.init.apply(d, arguments), d;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(d) {
              for (var f in d)
                d.hasOwnProperty(f) && (this[f] = d[f]);
              d.hasOwnProperty("toString") && (this.toString = d.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), m = c.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(d, f) {
            d = this.words = d || [], f != r ? this.sigBytes = f : this.sigBytes = d.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(d) {
            return (d || C).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(d) {
            var f = this.words, E = d.words, y = this.sigBytes, _ = d.sigBytes;
            if (this.clamp(), y % 4)
              for (var x = 0; x < _; x++) {
                var D = E[x >>> 2] >>> 24 - x % 4 * 8 & 255;
                f[y + x >>> 2] |= D << 24 - (y + x) % 4 * 8;
              }
            else
              for (var w = 0; w < _; w += 4)
                f[y + w >>> 2] = E[w >>> 2];
            return this.sigBytes += _, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var d = this.words, f = this.sigBytes;
            d[f >>> 2] &= 4294967295 << 32 - f % 4 * 8, d.length = i.ceil(f / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var d = u.clone.call(this);
            return d.words = this.words.slice(0), d;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(d) {
            for (var f = [], E = 0; E < d; E += 4)
              f.push(a());
            return new m.init(f, d);
          }
        }), g = l.enc = {}, C = g.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(d) {
            for (var f = d.words, E = d.sigBytes, y = [], _ = 0; _ < E; _++) {
              var x = f[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              y.push((x >>> 4).toString(16)), y.push((x & 15).toString(16));
            }
            return y.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(d) {
            for (var f = d.length, E = [], y = 0; y < f; y += 2)
              E[y >>> 3] |= parseInt(d.substr(y, 2), 16) << 24 - y % 8 * 4;
            return new m.init(E, f / 2);
          }
        }, I = g.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(d) {
            for (var f = d.words, E = d.sigBytes, y = [], _ = 0; _ < E; _++) {
              var x = f[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
              y.push(String.fromCharCode(x));
            }
            return y.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(d) {
            for (var f = d.length, E = [], y = 0; y < f; y++)
              E[y >>> 2] |= (d.charCodeAt(y) & 255) << 24 - y % 4 * 8;
            return new m.init(E, f);
          }
        }, p = g.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(d) {
            try {
              return decodeURIComponent(escape(I.stringify(d)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(d) {
            return I.parse(unescape(encodeURIComponent(d)));
          }
        }, T = c.BufferedBlockAlgorithm = u.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new m.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(d) {
            typeof d == "string" && (d = p.parse(d)), this._data.concat(d), this._nDataBytes += d.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(d) {
            var f, E = this._data, y = E.words, _ = E.sigBytes, x = this.blockSize, D = x * 4, w = _ / D;
            d ? w = i.ceil(w) : w = i.max((w | 0) - this._minBufferSize, 0);
            var b = w * x, A = i.min(b * 4, _);
            if (b) {
              for (var U = 0; U < b; U += x)
                this._doProcessBlock(y, U);
              f = y.splice(0, b), E.sigBytes -= A;
            }
            return new m.init(f, A);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var d = u.clone.call(this);
            return d._data = this._data.clone(), d;
          },
          _minBufferSize: 0
        });
        c.Hasher = T.extend({
          /**
           * Configuration options.
           */
          cfg: u.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(d) {
            this.cfg = this.cfg.extend(d), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            T.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(d) {
            return this._append(d), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(d) {
            d && this._append(d);
            var f = this._doFinalize();
            return f;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(d) {
            return function(f, E) {
              return new d.init(E).finalize(f);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(d) {
            return function(f, E) {
              return new v.HMAC.init(d, E).finalize(f);
            };
          }
        });
        var v = l.algo = {};
        return l;
      }(Math);
      return t;
    });
  }(ls)), ls.exports;
}
var Eo = os.exports, Xi;
function Io() {
  return Xi || (Xi = 1, function(s, e) {
    (function(t, i) {
      s.exports = i(yo());
    })(Eo, function(t) {
      return function(i) {
        var r = t, n = r.lib, a = n.WordArray, o = n.Hasher, l = r.algo, c = [];
        (function() {
          for (var p = 0; p < 64; p++)
            c[p] = i.abs(i.sin(p + 1)) * 4294967296 | 0;
        })();
        var u = l.MD5 = o.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(p, T) {
            for (var v = 0; v < 16; v++) {
              var d = T + v, f = p[d];
              p[d] = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360;
            }
            var E = this._hash.words, y = p[T + 0], _ = p[T + 1], x = p[T + 2], D = p[T + 3], w = p[T + 4], b = p[T + 5], A = p[T + 6], U = p[T + 7], W = p[T + 8], ee = p[T + 9], Ee = p[T + 10], be = p[T + 11], Te = p[T + 12], qt = p[T + 13], Jt = p[T + 14], es = p[T + 15], O = E[0], M = E[1], N = E[2], R = E[3];
            O = m(O, M, N, R, y, 7, c[0]), R = m(R, O, M, N, _, 12, c[1]), N = m(N, R, O, M, x, 17, c[2]), M = m(M, N, R, O, D, 22, c[3]), O = m(O, M, N, R, w, 7, c[4]), R = m(R, O, M, N, b, 12, c[5]), N = m(N, R, O, M, A, 17, c[6]), M = m(M, N, R, O, U, 22, c[7]), O = m(O, M, N, R, W, 7, c[8]), R = m(R, O, M, N, ee, 12, c[9]), N = m(N, R, O, M, Ee, 17, c[10]), M = m(M, N, R, O, be, 22, c[11]), O = m(O, M, N, R, Te, 7, c[12]), R = m(R, O, M, N, qt, 12, c[13]), N = m(N, R, O, M, Jt, 17, c[14]), M = m(M, N, R, O, es, 22, c[15]), O = g(O, M, N, R, _, 5, c[16]), R = g(R, O, M, N, A, 9, c[17]), N = g(N, R, O, M, be, 14, c[18]), M = g(M, N, R, O, y, 20, c[19]), O = g(O, M, N, R, b, 5, c[20]), R = g(R, O, M, N, Ee, 9, c[21]), N = g(N, R, O, M, es, 14, c[22]), M = g(M, N, R, O, w, 20, c[23]), O = g(O, M, N, R, ee, 5, c[24]), R = g(R, O, M, N, Jt, 9, c[25]), N = g(N, R, O, M, D, 14, c[26]), M = g(M, N, R, O, W, 20, c[27]), O = g(O, M, N, R, qt, 5, c[28]), R = g(R, O, M, N, x, 9, c[29]), N = g(N, R, O, M, U, 14, c[30]), M = g(M, N, R, O, Te, 20, c[31]), O = C(O, M, N, R, b, 4, c[32]), R = C(R, O, M, N, W, 11, c[33]), N = C(N, R, O, M, be, 16, c[34]), M = C(M, N, R, O, Jt, 23, c[35]), O = C(O, M, N, R, _, 4, c[36]), R = C(R, O, M, N, w, 11, c[37]), N = C(N, R, O, M, U, 16, c[38]), M = C(M, N, R, O, Ee, 23, c[39]), O = C(O, M, N, R, qt, 4, c[40]), R = C(R, O, M, N, y, 11, c[41]), N = C(N, R, O, M, D, 16, c[42]), M = C(M, N, R, O, A, 23, c[43]), O = C(O, M, N, R, ee, 4, c[44]), R = C(R, O, M, N, Te, 11, c[45]), N = C(N, R, O, M, es, 16, c[46]), M = C(M, N, R, O, x, 23, c[47]), O = I(O, M, N, R, y, 6, c[48]), R = I(R, O, M, N, U, 10, c[49]), N = I(N, R, O, M, Jt, 15, c[50]), M = I(M, N, R, O, b, 21, c[51]), O = I(O, M, N, R, Te, 6, c[52]), R = I(R, O, M, N, D, 10, c[53]), N = I(N, R, O, M, Ee, 15, c[54]), M = I(M, N, R, O, _, 21, c[55]), O = I(O, M, N, R, W, 6, c[56]), R = I(R, O, M, N, es, 10, c[57]), N = I(N, R, O, M, A, 15, c[58]), M = I(M, N, R, O, qt, 21, c[59]), O = I(O, M, N, R, w, 6, c[60]), R = I(R, O, M, N, be, 10, c[61]), N = I(N, R, O, M, x, 15, c[62]), M = I(M, N, R, O, ee, 21, c[63]), E[0] = E[0] + O | 0, E[1] = E[1] + M | 0, E[2] = E[2] + N | 0, E[3] = E[3] + R | 0;
          },
          _doFinalize: function() {
            var p = this._data, T = p.words, v = this._nDataBytes * 8, d = p.sigBytes * 8;
            T[d >>> 5] |= 128 << 24 - d % 32;
            var f = i.floor(v / 4294967296), E = v;
            T[(d + 64 >>> 9 << 4) + 15] = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, T[(d + 64 >>> 9 << 4) + 14] = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, p.sigBytes = (T.length + 1) * 4, this._process();
            for (var y = this._hash, _ = y.words, x = 0; x < 4; x++) {
              var D = _[x];
              _[x] = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360;
            }
            return y;
          },
          clone: function() {
            var p = o.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        function m(p, T, v, d, f, E, y) {
          var _ = p + (T & v | ~T & d) + f + y;
          return (_ << E | _ >>> 32 - E) + T;
        }
        function g(p, T, v, d, f, E, y) {
          var _ = p + (T & d | v & ~d) + f + y;
          return (_ << E | _ >>> 32 - E) + T;
        }
        function C(p, T, v, d, f, E, y) {
          var _ = p + (T ^ v ^ d) + f + y;
          return (_ << E | _ >>> 32 - E) + T;
        }
        function I(p, T, v, d, f, E, y) {
          var _ = p + (v ^ (T | ~d)) + f + y;
          return (_ << E | _ >>> 32 - E) + T;
        }
        r.MD5 = o._createHelper(u), r.HmacMD5 = o._createHmacHelper(u);
      }(Math), t.MD5;
    });
  }(os)), os.exports;
}
var Co = Io();
const _o = /* @__PURE__ */ uo(Co);
var cs = { exports: {} }, To = cs.exports, Qi;
function So() {
  return Qi || (Qi = 1, function(s, e) {
    (function(t, i) {
      s.exports = i();
    })(To, function() {
      return function() {
        var t = { 412: function(a, o, l) {
          function c(g, C) {
            for (var I = 0; I < C.length; I++) {
              var p = C[I];
              p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(g, p.key, p);
            }
          }
          Object.defineProperty(o, "t", { value: !0 });
          var u = l(775), m = function() {
            function g() {
              (function(p, T) {
                if (!(p instanceof T)) throw new TypeError("Cannot call a class as a function");
              })(this, g);
            }
            var C, I;
            return C = g, I = [{ key: "set", value: function(p, T, v) {
              for (var d, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", E = p.split(f), y = v, _ = v, x = 0; x < E.length; x++) {
                var D = E[x];
                if (D.length === 0) throw new u.default('"'.concat(p, '" is not a valid property path.'));
                y[D] === void 0 && (y[D] = {}), _ = y, y = y[D], d = D;
              }
              return _[d] = T, v;
            } }, { key: "get", value: function(p, T) {
              for (var v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".", d = p.split(v), f = T, E = 0; E < d.length; E++) {
                var y = d[E];
                if (y.length === 0) throw new u.default('"'.concat(p, '" is not a valid property path.'));
                if (f[y] === void 0) return null;
                f = f[y];
              }
              return f;
            } }], I && c(C.prototype, I), g;
          }();
          o.default = m;
        }, 775: function(a, o) {
          function l(T) {
            return l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
              return typeof v;
            } : function(v) {
              return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
            }, l(T);
          }
          function c(T, v) {
            if (v && (l(v) === "object" || typeof v == "function")) return v;
            if (v !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return function(d) {
              if (d === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return d;
            }(T);
          }
          function u(T) {
            var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return u = function(d) {
              if (d === null || (f = d, Function.toString.call(f).indexOf("[native code]") === -1)) return d;
              var f;
              if (typeof d != "function") throw new TypeError("Super expression must either be null or a function");
              if (v !== void 0) {
                if (v.has(d)) return v.get(d);
                v.set(d, E);
              }
              function E() {
                return m(d, arguments, I(this).constructor);
              }
              return E.prototype = Object.create(d.prototype, { constructor: { value: E, enumerable: !1, writable: !0, configurable: !0 } }), C(E, d);
            }, u(T);
          }
          function m(T, v, d) {
            return m = g() ? Reflect.construct : function(f, E, y) {
              var _ = [null];
              _.push.apply(_, E);
              var x = new (Function.bind.apply(f, _))();
              return y && C(x, y.prototype), x;
            }, m.apply(null, arguments);
          }
          function g() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function C(T, v) {
            return C = Object.setPrototypeOf || function(d, f) {
              return d.__proto__ = f, d;
            }, C(T, v);
          }
          function I(T) {
            return I = Object.setPrototypeOf ? Object.getPrototypeOf : function(v) {
              return v.__proto__ || Object.getPrototypeOf(v);
            }, I(T);
          }
          Object.defineProperty(o, "t", { value: !0 });
          var p = function(T) {
            (function(y, _) {
              if (typeof _ != "function" && _ !== null) throw new TypeError("Super expression must either be null or a function");
              y.prototype = Object.create(_ && _.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), _ && C(y, _);
            })(E, T);
            var v, d, f = (v = E, d = g(), function() {
              var y, _ = I(v);
              if (d) {
                var x = I(this).constructor;
                y = Reflect.construct(_, arguments, x);
              } else y = _.apply(this, arguments);
              return c(this, y);
            });
            function E(y) {
              var _;
              return function(x, D) {
                if (!(x instanceof D)) throw new TypeError("Cannot call a class as a function");
              }(this, E), (_ = f.call(this, y)).name = "InvalidParameterException", _;
            }
            return E;
          }(u(Error));
          o.default = p;
        }, 524: function(a, o, l) {
          function c(w) {
            return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
              return typeof b;
            } : function(b) {
              return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
            }, c(w);
          }
          function u(w, b) {
            if (!(w instanceof b)) throw new TypeError("Cannot call a class as a function");
          }
          function m(w, b) {
            if (typeof b != "function" && b !== null) throw new TypeError("Super expression must either be null or a function");
            w.prototype = Object.create(b && b.prototype, { constructor: { value: w, writable: !0, configurable: !0 } }), b && d(w, b);
          }
          function g(w) {
            var b = v();
            return function() {
              var A, U = f(w);
              if (b) {
                var W = f(this).constructor;
                A = Reflect.construct(U, arguments, W);
              } else A = U.apply(this, arguments);
              return C(this, A);
            };
          }
          function C(w, b) {
            if (b && (c(b) === "object" || typeof b == "function")) return b;
            if (b !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return I(w);
          }
          function I(w) {
            if (w === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return w;
          }
          function p(w) {
            var b = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return p = function(A) {
              if (A === null || (U = A, Function.toString.call(U).indexOf("[native code]") === -1)) return A;
              var U;
              if (typeof A != "function") throw new TypeError("Super expression must either be null or a function");
              if (b !== void 0) {
                if (b.has(A)) return b.get(A);
                b.set(A, W);
              }
              function W() {
                return T(A, arguments, f(this).constructor);
              }
              return W.prototype = Object.create(A.prototype, { constructor: { value: W, enumerable: !1, writable: !0, configurable: !0 } }), d(W, A);
            }, p(w);
          }
          function T(w, b, A) {
            return T = v() ? Reflect.construct : function(U, W, ee) {
              var Ee = [null];
              Ee.push.apply(Ee, W);
              var be = new (Function.bind.apply(U, Ee))();
              return ee && d(be, ee.prototype), be;
            }, T.apply(null, arguments);
          }
          function v() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function d(w, b) {
            return d = Object.setPrototypeOf || function(A, U) {
              return A.__proto__ = U, A;
            }, d(w, b);
          }
          function f(w) {
            return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(b) {
              return b.__proto__ || Object.getPrototypeOf(b);
            }, f(w);
          }
          Object.defineProperty(o, "t", { value: !0 }), o.SubscriptionNotFoundException = o.SubscriptionAlreadyExistsException = o.InvalidArgumentException = o.DomainException = void 0;
          var E = function(w) {
            m(A, w);
            var b = g(A);
            function A() {
              return u(this, A), b.apply(this, arguments);
            }
            return A;
          }(p(Error));
          o.DomainException = E;
          var y = l(552), _ = function(w) {
            m(A, w);
            var b = g(A);
            function A(U) {
              var W;
              return u(this, A), (W = b.call(this, U)).name = W.constructor.name, (0, y.captureStackTrace)(I(W), W.constructor), W;
            }
            return A;
          }(E);
          o.InvalidArgumentException = _;
          var x = function(w) {
            m(A, w);
            var b = g(A);
            function A(U, W) {
              var ee;
              return u(this, A), (ee = b.call(this, 'Unable to add subscription "'.concat(U, '" to component "').concat(W, '" because it already manage a subscription with same id.'))).name = ee.constructor.name, (0, y.captureStackTrace)(I(ee), ee.constructor), ee;
            }
            return A;
          }(E);
          o.SubscriptionAlreadyExistsException = x;
          var D = function(w) {
            m(A, w);
            var b = g(A);
            function A(U, W) {
              var ee;
              return u(this, A), (ee = b.call(this, 'Unable to find subscription with id "'.concat(U, '" in component "').concat(W, '".'))).name = ee.constructor.name, (0, y.captureStackTrace)(I(ee), ee.constructor), ee;
            }
            return A;
          }(E);
          o.SubscriptionNotFoundException = D;
        }, 413: function(a, o) {
          Object.defineProperty(o, "t", { value: !0 }), o.generateId = void 0;
          var l = /* @__PURE__ */ new Map();
          o.generateId = function(c) {
            var u, m = (u = l.get(c)) !== null && u !== void 0 ? u : 0;
            return l.set(c, m + 1), "".concat(c, "_").concat(m);
          };
        }, 552: function(a, o) {
          Object.defineProperty(o, "t", { value: !0 }), o.captureStackTrace = void 0, o.captureStackTrace = function(l, c) {
            typeof Error.captureStackTrace == "function" && Error.captureStackTrace(l, c);
          };
        }, 322: function(a, o, l) {
          Object.defineProperty(o, "t", { value: !0 }), o.subscribeFromObject = void 0;
          var c = new (l(412)).default();
          o.subscribeFromObject = function(u, m, g) {
            Object.values(g).forEach(function(C) {
              var I = u[C.action];
              if (typeof I == "function") {
                var p = I.bind(u);
                u.subscribe(m, C.notification, function(T) {
                  var v = {};
                  if (C.mapAttributes !== void 0) {
                    var d = C.mapAttributes;
                    Object.keys(d).forEach(function(f) {
                      var E, y = (E = d[f]) !== null && E !== void 0 ? E : "";
                      v[f] = c.get(y, T);
                    }), p(v);
                  } else p(T);
                });
              }
            });
          };
        }, 537: function(a, o, l) {
          Object.defineProperty(o, "t", { value: !0 }), o.HIGH_PRIORITY = o.DEFAULT_PRIORITY = o.LOW_PRIORITY = o.ROLE = o.findSubscriptionByRoleAndComponentId = void 0;
          var c = l(524);
          o.findSubscriptionByRoleAndComponentId = function(u, m, g) {
            if (m !== o.ROLE.PUBLISHER_ID && m !== o.ROLE.SUBSCRIBER_ID) throw new c.InvalidArgumentException('Invalid argument given for "role" in "findSubscriptionByRoleAndComponentId". Values expected are "publisher_id" or "subscriber_id" but "'.concat(m, '" was given.'));
            return u.getSubscriptions().filter(function(C) {
              return (m === o.ROLE.PUBLISHER_ID ? C.publisher_id : C.subscriber_id) === g;
            });
          }, o.ROLE = { PUBLISHER_ID: "publisher_id", SUBSCRIBER_ID: "subscriber_id" }, o.LOW_PRIORITY = -100, o.DEFAULT_PRIORITY = 0, o.HIGH_PRIORITY = 100;
        }, 986: function(a, o, l) {
          function c(p, T) {
            for (var v = 0; v < T.length; v++) {
              var d = T[v];
              d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(p, d.key, d);
            }
          }
          Object.defineProperty(o, "t", { value: !0 });
          var u = l(829), m = l(757), g = l(537), C = l(524), I = function() {
            function p(d) {
              (function(f, E) {
                if (!(f instanceof E)) throw new TypeError("Cannot call a class as a function");
              })(this, p), this.proxies = /* @__PURE__ */ new Map(), this.removedSelfSubscription = /* @__PURE__ */ new Set(), this.id = d, this.publisher = new u.default(d), this.subscriber = new m.default(d);
            }
            var T, v;
            return T = p, v = [{ key: "hasSubscription", value: function(d) {
              return this.subscriber.hasSubscription(d) || this.publisher.hasSubscription(d);
            } }, { key: "addSubscriber", value: function(d, f) {
              this.publisher.addSubscriber(d, f);
            } }, { key: "removeSubscriber", value: function(d) {
              this.publisher.removeSubscriber(d);
            } }, { key: "getNbSubscriptionsAsPublisher", value: function() {
              return this.publisher.getNbSubscriptions();
            } }, { key: "getNbSubscriptionsAsSubscriber", value: function() {
              return this.subscriber.getNbSubscriptions();
            } }, { key: "publish", value: function(d, f) {
              this.publisher.publish(d, f);
            } }, { key: "getId", value: function() {
              return this.id;
            } }, { key: "subscribe", value: function(d, f, E, y) {
              return this.subscriber.subscribe.apply(this, [d, f, E, y]);
            } }, { key: "getNbSubscriptions", value: function() {
              return this.subscriber.getNbSubscriptions();
            } }, { key: "removeSubscription", value: function(d) {
              this.subscriber.removeSubscription(d);
            } }, { key: "addSubscription", value: function(d, f) {
              this.subscriber.addSubscription(d, f);
            } }, { key: "waitUntil", value: function(d) {
              return this.subscriber.waitUntil(d);
            } }, { key: "destroy", value: function() {
              this.publisher.destroy(), this.subscriber.destroy();
            } }, { key: "is", value: function(d) {
              return this.id === d;
            } }, { key: "findSubscriptionById", value: function(d) {
              return this.subscriber.findSubscriptionById(d) || this.publisher.findSubscriptionById(d);
            } }, { key: "findSubscriptionsByNotificationAndPublisherId", value: function(d, f) {
              return this.subscriber.findSubscriptionsByNotificationAndPublisherId(d, f);
            } }, { key: "findSubscriptionsByNotification", value: function(d) {
              return this.subscriber.findSubscriptionsByNotification(d).concat(this.publisher.findSubscriptionsByNotification(d));
            } }, { key: "getSubscriptions", value: function() {
              return this.subscriber.getSubscriptions().concat(this.publisher.getSubscriptions());
            } }, { key: "unsubscribeFromNotification", value: function(d) {
              this.subscriber.unsubscribeFromNotification(d);
            } }, { key: "unsubscribeFromPublisherId", value: function(d) {
              this.subscriber.unsubscribeFromPublisherId(d);
            } }, { key: "unsubscribeFromSubscriptionId", value: function(d) {
              this.subscriber.unsubscribeFromSubscriptionId(d);
            } }, { key: "continuePublicationOnException", value: function() {
              this.publisher.continuePublicationOnException();
            } }, { key: "findSubscriptionByPublisherId", value: function(d) {
              var f = this.subscriber.findSubscriptionByPublisherId(d).concat((0, g.findSubscriptionByRoleAndComponentId)(this.publisher, g.ROLE.PUBLISHER_ID, d));
              return d === this.getId() ? Array.from(new Set(f)) : f;
            } }, { key: "findSubscriptionsByNotificationAndSubscriberId", value: function(d, f) {
              return this.publisher.findSubscriptionsByNotificationAndSubscriberId(d, f);
            } }, { key: "findSubscriptionBySubscriberId", value: function(d) {
              var f = this.publisher.findSubscriptionBySubscriberId(d).concat((0, g.findSubscriptionByRoleAndComponentId)(this.subscriber, g.ROLE.SUBSCRIBER_ID, d));
              return d === this.getId() ? Array.from(new Set(f)) : f;
            } }, { key: "stopPublicationOnException", value: function() {
              this.publisher.stopPublicationOnException();
            } }, { key: "clearSubscription", value: function(d) {
              if (this.removedSelfSubscription.has(d)) this.removedSelfSubscription.delete(d);
              else {
                var f = this.findSubscriptionById(d);
                if (f === null) throw new C.SubscriptionNotFoundException(d, this.getId());
                f?.subscriber_id === this.subscriber.getId() && this.subscriber.clearSubscription(d), f?.publisher_id === this.publisher.getId() && this.publisher.clearSubscription(d), f?.publisher_id === f?.subscriber_id && this.removedSelfSubscription.add(d);
              }
            } }, { key: "addProxy", value: function(d, f) {
              var E = this, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(D) {
                return D;
              }, _ = this.getPublisherProxies(d.getId()), x = this.subscribe(d, f, function(D) {
                E.publish(f, y(D));
              });
              return _.add(x.id), this.proxies.set(d.getId(), _), this;
            } }, { key: "getPublisherProxies", value: function(d) {
              var f;
              return (f = this.proxies.get(d)) !== null && f !== void 0 ? f : /* @__PURE__ */ new Set();
            } }, { key: "removeProxy", value: function(d, f) {
              var E = this, y = this.findSubscriptionsByNotificationAndPublisherId(f, d.getId()), _ = this.getPublisherProxies(d.getId());
              return y.filter(function(x) {
                return _.has(x.id);
              }).forEach(function(x) {
                E.unsubscribeFromSubscriptionId(x.id), _.delete(x.id);
              }), this;
            } }], v && c(T.prototype, v), p;
          }();
          o.default = I;
        }, 829: function(a, o, l) {
          function c(f) {
            return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
              return typeof E;
            } : function(E) {
              return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
            }, c(f);
          }
          function u(f, E) {
            if (!(f instanceof E)) throw new TypeError("Cannot call a class as a function");
          }
          function m(f, E) {
            for (var y = 0; y < E.length; y++) {
              var _ = E[y];
              _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(f, _.key, _);
            }
          }
          function g(f, E) {
            return g = Object.setPrototypeOf || function(y, _) {
              return y.__proto__ = _, y;
            }, g(f, E);
          }
          function C(f) {
            var E = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }();
            return function() {
              var y, _ = p(f);
              if (E) {
                var x = p(this).constructor;
                y = Reflect.construct(_, arguments, x);
              } else y = _.apply(this, arguments);
              return I(this, y);
            };
          }
          function I(f, E) {
            if (E && (c(E) === "object" || typeof E == "function")) return E;
            if (E !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return function(y) {
              if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return y;
            }(f);
          }
          function p(f) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(E) {
              return E.__proto__ || Object.getPrototypeOf(E);
            }, p(f);
          }
          Object.defineProperty(o, "t", { value: !0 });
          var T = l(657), v = l(537), d = function(f) {
            (function(D, w) {
              if (typeof w != "function" && w !== null) throw new TypeError("Super expression must either be null or a function");
              D.prototype = Object.create(w && w.prototype, { constructor: { value: D, writable: !0, configurable: !0 } }), w && g(D, w);
            })(x, f);
            var E, y, _ = C(x);
            function x() {
              var D;
              return u(this, x), (D = _.apply(this, arguments)).shouldIStopPublicationOnException = !1, D;
            }
            return E = x, (y = [{ key: "stopPublicationOnException", value: function() {
              this.shouldIStopPublicationOnException = !0;
            } }, { key: "continuePublicationOnException", value: function() {
              this.shouldIStopPublicationOnException = !1;
            } }, { key: "publish", value: function(D, w) {
              var b = this, A = this.notificationsCollection[D];
              Array.isArray(A) && A.slice(0).forEach(function(U) {
                try {
                  U.handler(w);
                } catch (W) {
                  if (b.shouldIStopPublicationOnException) throw W;
                }
              });
            } }, { key: "findSubscriptionBySubscriberId", value: function(D) {
              return (0, v.findSubscriptionByRoleAndComponentId)(this, v.ROLE.SUBSCRIBER_ID, D);
            } }, { key: "findSubscriptionsByNotificationAndSubscriberId", value: function(D, w) {
              return this.findSubscriptionsByNotification(D).filter(function(b) {
                return b.subscriber_id === w;
              });
            } }, { key: "addSubscriber", value: function(D, w) {
              this.addSubscription(D, w);
            } }, { key: "removeSubscriber", value: function(D) {
              this.findSubscriptionBySubscriberId(D).forEach(function(w) {
                return w.unsubscribe();
              });
            } }]) && m(E.prototype, y), x;
          }(T.default);
          o.default = d;
        }, 757: function(a, o, l) {
          function c(y) {
            return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
              return typeof _;
            } : function(_) {
              return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
            }, c(y);
          }
          function u(y, _) {
            if (!(y instanceof _)) throw new TypeError("Cannot call a class as a function");
          }
          function m(y, _) {
            for (var x = 0; x < _.length; x++) {
              var D = _[x];
              D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(y, D.key, D);
            }
          }
          function g(y, _) {
            return g = Object.setPrototypeOf || function(x, D) {
              return x.__proto__ = D, x;
            }, g(y, _);
          }
          function C(y) {
            var _ = function() {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), !0;
              } catch {
                return !1;
              }
            }();
            return function() {
              var x, D = p(y);
              if (_) {
                var w = p(this).constructor;
                x = Reflect.construct(D, arguments, w);
              } else x = D.apply(this, arguments);
              return I(this, x);
            };
          }
          function I(y, _) {
            if (_ && (c(_) === "object" || typeof _ == "function")) return _;
            if (_ !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return function(x) {
              if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return x;
            }(y);
          }
          function p(y) {
            return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(_) {
              return _.__proto__ || Object.getPrototypeOf(_);
            }, p(y);
          }
          Object.defineProperty(o, "t", { value: !0 });
          var T = l(657), v = l(537), d = l(524), f = l(413), E = function(y) {
            (function(b, A) {
              if (typeof A != "function" && A !== null) throw new TypeError("Super expression must either be null or a function");
              b.prototype = Object.create(A && A.prototype, { constructor: { value: b, writable: !0, configurable: !0 } }), A && g(b, A);
            })(w, y);
            var _, x, D = C(w);
            function w() {
              return u(this, w), D.apply(this, arguments);
            }
            return _ = w, x = [{ key: "unsubscribeFromSubscriptionId", value: function(b) {
              var A = this.findSubscriptionById(b);
              if (A === null) throw new d.SubscriptionNotFoundException(b, this.getId());
              A.unsubscribe();
            } }, { key: "findSubscriptionByPublisherId", value: function(b) {
              return (0, v.findSubscriptionByRoleAndComponentId)(this, v.ROLE.PUBLISHER_ID, b);
            } }, { key: "unsubscribeFromPublisherId", value: function(b) {
              this.findSubscriptionByPublisherId(b).map(function(A) {
                return A.unsubscribe;
              }).forEach(function(A) {
                A();
              });
            } }, { key: "unsubscribeFromNotification", value: function(b) {
              this.findSubscriptionsByNotification(b).map(function(A) {
                return A.unsubscribe;
              }).forEach(function(A) {
                A();
              });
            } }, { key: "subscribe", value: function(b, A, U) {
              var W = this, ee = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : v.DEFAULT_PRIORITY, Ee = this.getNbSubscriptions(), be = "sub_".concat(this.getId(), "_to_").concat(b.getId(), "_salt_").concat(Ee);
              if (isNaN(ee) || typeof ee != "number") throw new d.InvalidArgumentException('Unable to create a subscription with priority "'.concat(ee, '" (typed as "').concat(c(ee), '"). Number value is expected.'));
              var Te = { id: be, subscriber_id: this.getId(), publisher_id: b.getId(), unsubscribe: function() {
                b.clearSubscription(be), W.clearSubscription(be);
              }, priority: ee, handler: U };
              return this.addSubscription(A, Te), b.addSubscriber(A, Te), Te;
            } }, { key: "getNbSubscriptions", value: function() {
              return this.nbSubscriptionRecorded;
            } }, { key: "removeSubscription", value: function(b) {
              this.clearSubscription(b);
            } }, { key: "waitUntil", value: function(b) {
              var A = new w((0, f.generateId)("wait-until-".concat(b.map(function(U) {
                return U.name;
              }).join("-and-"), "-salt")));
              return new Promise(function(U) {
                Promise.all(b.map(function(W) {
                  return new Promise(function(ee) {
                    A.subscribe(W.from, W.name, function(Ee) {
                      ee(Ee);
                    });
                  });
                })).then(function(W) {
                  A.destroy(), U(W);
                });
              });
            } }, { key: "findSubscriptionsByNotificationAndPublisherId", value: function(b, A) {
              return this.findSubscriptionsByNotification(b).filter(function(U) {
                return U.publisher_id === A;
              });
            } }], x && m(_.prototype, x), w;
          }(T.default);
          o.default = E;
        }, 657: function(a, o, l) {
          function c(I) {
            return function(p) {
              if (Array.isArray(p)) return u(p);
            }(I) || function(p) {
              if (typeof Symbol < "u" && p[Symbol.iterator] != null || p["@@iterator"] != null) return Array.from(p);
            }(I) || function(p, T) {
              if (p) {
                if (typeof p == "string") return u(p, T);
                var v = Object.prototype.toString.call(p).slice(8, -1);
                if (v === "Object" && p.constructor && (v = p.constructor.name), v === "Map" || v === "Set") return Array.from(p);
                if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return u(p, T);
              }
            }(I) || function() {
              throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }();
          }
          function u(I, p) {
            (p == null || p > I.length) && (p = I.length);
            for (var T = 0, v = new Array(p); T < p; T++) v[T] = I[T];
            return v;
          }
          function m(I, p) {
            for (var T = 0; T < p.length; T++) {
              var v = p[T];
              v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(I, v.key, v);
            }
          }
          Object.defineProperty(o, "t", { value: !0 });
          var g = l(524), C = function() {
            function I(v) {
              (function(d, f) {
                if (!(d instanceof f)) throw new TypeError("Cannot call a class as a function");
              })(this, I), this.subscriptionsList = {}, this.notificationsCollection = {}, this.nbSubscriptionRecorded = 0, this.id = v;
            }
            var p, T;
            return p = I, (T = [{ key: "getSubscriptions", value: function() {
              return [].concat.apply([], Object.values(this.notificationsCollection));
            } }, { key: "getNbSubscriptions", value: function() {
              return this.nbSubscriptionRecorded;
            } }, { key: "hasSubscription", value: function(v) {
              return this.subscriptionsList[v] !== void 0;
            } }, { key: "recordSubscription", value: function(v, d) {
              this.subscriptionsList[v] = d;
            } }, { key: "findSubscriptionIndexById", value: function(v) {
              var d = this.subscriptionsList[v], f = { index: -1, notification: d ?? "" };
              if (d === void 0) return f;
              var E = this.notificationsCollection[d];
              return Array.isArray(E) && (f.index = E.findIndex(function(y) {
                return y.id === v;
              })), f;
            } }, { key: "findSubscriptionById", value: function(v) {
              var d = this.findSubscriptionIndexById(v);
              return d.index < 0 ? null : this.notificationsCollection[d.notification][d.index];
            } }, { key: "findSubscriptionsByNotification", value: function(v) {
              return this.notificationsCollection[v] || [];
            } }, { key: "clearSubscription", value: function(v) {
              var d = this.findSubscriptionIndexById(v);
              if (d.index < 0) throw new g.SubscriptionNotFoundException(v, this.getId());
              var f = this.notificationsCollection[d.notification].splice(d.index, 1)[0];
              typeof f.handler == "function" && delete f.handler, delete this.subscriptionsList[v], this.nbSubscriptionRecorded--, this.notificationsCollection[d.notification].length === 0 && delete this.notificationsCollection[d.notification];
            } }, { key: "addSubscription", value: function(v, d) {
              if (Array.isArray(this.notificationsCollection[v]) !== !0 && (this.notificationsCollection[v] = []), this.hasSubscription(d.id)) throw new g.SubscriptionAlreadyExistsException(d.id, this.getId());
              this.notificationsCollection[v].push(d), this.notificationsCollection[v].sort(function(f, E) {
                return E.priority - f.priority;
              }), this.recordSubscription(d.id, v), this.nbSubscriptionRecorded++;
            } }, { key: "getId", value: function() {
              return this.id;
            } }, { key: "is", value: function(v) {
              return v === this.getId();
            } }, { key: "destroy", value: function() {
              Object.values(this.notificationsCollection).forEach(function(v) {
                c(v).forEach(function(d) {
                  d.unsubscribe();
                });
              });
            } }]) && m(p.prototype, T), I;
          }();
          o.default = C;
        } }, i = {};
        function r(a) {
          var o = i[a];
          if (o !== void 0) return o.exports;
          var l = i[a] = { exports: {} };
          return t[a](l, l.exports, r), l.exports;
        }
        var n = {};
        return function() {
          var a = n;
          Object.defineProperty(a, "t", { value: !0 }), a.SubscriptionNotFoundException = a.SubscriptionAlreadyExistsException = a.InvalidArgumentException = a.SubscriberHelper = a.PublisherSubscriber = a.Subscriber = a.Publisher = void 0;
          var o = r(829);
          Object.defineProperty(a, "Publisher", { enumerable: !0, get: function() {
            return o.default;
          } });
          var l = r(757);
          Object.defineProperty(a, "Subscriber", { enumerable: !0, get: function() {
            return l.default;
          } });
          var c = r(986);
          Object.defineProperty(a, "PublisherSubscriber", { enumerable: !0, get: function() {
            return c.default;
          } }), a.SubscriberHelper = r(322);
          var u = r(524);
          Object.defineProperty(a, "InvalidArgumentException", { enumerable: !0, get: function() {
            return u.InvalidArgumentException;
          } }), Object.defineProperty(a, "SubscriptionAlreadyExistsException", { enumerable: !0, get: function() {
            return u.SubscriptionAlreadyExistsException;
          } }), Object.defineProperty(a, "SubscriptionNotFoundException", { enumerable: !0, get: function() {
            return u.SubscriptionNotFoundException;
          } });
        }(), n;
      }();
    });
  }(cs)), cs.exports;
}
var bo = So();
const Ls = new re(), zr = {
  USER_ID_UPDATED: "user_id_updated"
}, h = {
  url: {
    login: null,
    subscribe: null,
    applicationHomepage: null
  },
  errorHandler: null,
  user_id: null,
  id: null,
  store: null,
  siteAccess: null,
  viewerContainer: {
    width: null,
    height: null,
    marginLeft: 0
  },
  defaultLanguageId: null,
  languagesAllowed: [],
  key: null,
  keyIV: null,
  pubSub: new bo.PublisherSubscriber("anatomy-helper"),
  isEmbedded: !1,
  setUserId(s) {
    this.user_id = s, this.pubSub.publish(zr.USER_ID_UPDATED, s);
  },
  getHostname() {
    return location.hostname;
  },
  getClientURL() {
    return imaios.get("client_url") || location.href.split("?")[0];
  },
  onBeforeMount(s) {
    Object.keys(s).forEach((e) => {
      if (typeof s[e] == "function")
        document.addEventListener(e, s[e]);
      else if (typeof s[e] < "u" && typeof s[e].target == "object") {
        const t = s[e];
        t.target.addEventListener(t.event, t.hook);
      }
    });
  },
  onBeforeUnmount(s) {
    for (const e in s)
      if (typeof s[e] == "function")
        document.removeEventListener(e, s[e]);
      else if (typeof s[e] < "u" && typeof s[e].target == "object") {
        const t = s[e];
        t.target.removeEventListener(t.event, t.hook);
      }
  },
  /**
      * Create an object Hook
      * @param event {String}
      * @param callback {function}
      * @param target {object}
      * @returns {{hook, event, target: null}}
      */
  createHook(s, e, t = null) {
    let i;
    return t === null ? i = e : i = {
      target: t,
      event: s,
      hook: e
    }, i;
  },
  createHooks(s) {
    const e = {};
    for (const t of s)
      if (Array.isArray(t.on))
        for (const i of t.on) {
          const r = this.getEventName(i, t.target);
          e[r] = this.createHook(r, t.do, t.target);
        }
      else {
        const i = this.getEventName(t.on, t.target);
        e[i] = this.createHook(i, t.do, t.target);
      }
    return e;
  },
  getEventName(s, e = null) {
    return e !== window ? `${this.id}-${s}` : s;
  },
  getFirstChildElementByTag(s, e) {
    let t = null;
    return Array.from(s.children).forEach((i) => {
      i.nodeName === e.toUpperCase() && t === null && (t = i);
    }), t;
  },
  debounce(s, e) {
    let t = null;
    return (...i) => {
      const r = () => s(...i);
      clearTimeout(t), t = setTimeout(r, e);
    };
  },
  throttle(s, e) {
    let t = !1;
    return (...i) => {
      t || (s(...i), t = !0, setTimeout(() => {
        t = !1;
      }, e));
    };
  },
  switchTheme(s) {
    const e = G.get(Q.THEME) || {};
    let t = at.DARK;
    this.isDarkMode() && (t = at.LIGHT), e[s] = t, G.add(Q.THEME, e), this.setTheme(t, s);
  },
  setThemeByModality(s, e) {
    let t = at.DARK;
    return Pi.includes(s) && (t = at.LIGHT), this.setTheme(t, e), t;
  },
  setTheme(s, e) {
    const i = (G.get(Q.THEME) || {})[e] || s;
    document.getElementById(this.store.getters["anatomy/getParentContainerId"]).setAttribute("data-theme", i), this.emit(z.ui.THEME.SWITCH, { theme: i });
  },
  isDarkMode() {
    return oe.getIEVersion() !== 0 ? !0 : document.getElementById(this.store.getters["anatomy/getParentContainerId"]).getAttribute("data-theme") === at.DARK;
  },
  getCSSVariable(s) {
    const e = document.getElementById(this.store.getters["anatomy/getParentContainerId"]);
    return getComputedStyle(e).getPropertyValue(s);
  },
  emit(s, e = null) {
    Ls.emit(this.getEventName(s), { detail: e });
  },
  getSiteAccess() {
    if (this.siteAccess !== null)
      return this.siteAccess;
    if (typeof window.location.pathname != "string")
      return Cs;
    try {
      const s = window.location.pathname.split("/")[1];
      if (s.length === 2 && Object.keys(Z).includes(s))
        return s;
    } catch {
      return Cs;
    }
    return Cs;
  },
  transformSiteAccessToLocal(s) {
    switch (s) {
      case "cn":
        return "zh";
      case "br":
        return "pt";
      case "jp":
        return "ja";
      default:
        return s;
    }
  },
  transformLocalToSiteAccess(s) {
    switch (s) {
      case "zh":
        return "cn";
      case "pt":
        return "br";
      case "ja":
        return "jp";
      default:
        return s;
    }
  },
  toDataURL(s) {
    return new Promise((e) => {
      const t = new Image();
      t.crossOrigin = "Anonymous", t.onload = function() {
        const i = document.createElement("CANVAS"), r = i.getContext("2d");
        i.height = this.naturalHeight, i.width = this.naturalWidth, r.drawImage(this, 0, 0), e(i.toDataURL());
      }, t.src = s, (t.complete || t.complete === void 0) && (t.src = sa, t.src = s);
    });
  },
  isHiddenByOverflow(s) {
    const e = s.parentElement, t = e.scrollTop, i = e.offsetHeight, r = s.offsetHeight, n = Array.from(e.children).findIndex((o) => o.innerText === s.innerText);
    let a = 0;
    for (let o = 0; o < n; o++)
      a += e.children[o].offsetHeight;
    return {
      isHidden: a < t || a + r > t + i,
      y: a
    };
  },
  getBackgroundColor(s) {
    let e = ki.BLACK;
    return Pi.includes(s) && (e = ki.WHITE), e;
  },
  getSizeMargin() {
    return this.isDesktopScreen() ? 10 : 15;
  },
  getSizeActionButtons() {
    return ea + this.getSizeMargin();
  },
  getSizeMenu() {
    return this.store.getters["menu/menu-width"];
  },
  getSizeMenuButton() {
    return this.isDesktopScreen() ? qn : Jn;
  },
  isDesktopScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.DESKTOP;
  },
  isLaptopScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.LAPTOP;
  },
  isLargeTabletScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.LARGE_TABLET;
  },
  isTabletScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.TABLET;
  },
  isMobileScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.MOBILE;
  },
  isSmallMobileScreen() {
    return this.store.getters["viewer/viewer-width"] <= Be.SMALL_MOBILE;
  },
  breakPointCrossReferences() {
    return this.store.getters["viewer/viewer-width"] >= 768 && this.store.getters["viewer/viewer-height"] >= 457;
  },
  isEmbed() {
    return this.isEmbedded;
  },
  getWidthElement(s) {
    const e = window.getComputedStyle(s), t = s.offsetWidth, i = parseFloat(e.marginLeft) + parseFloat(e.marginRight);
    return t + i;
  },
  forceRedrawSafari(s) {
    s.style.display = "none", s.offsetHeight, s.style.display = "";
  },
  isIMAIOSDomain() {
    return /^.*\.?imaios\.com$/.test(this.getHostname());
  },
  transformSiteAccessToStructureLanguage(s) {
    return s === "de" ? Z.la : this.getAllowedLanguage(Z[s]);
  },
  getAllowedLanguage(s) {
    return this.languagesAllowed.length > 0 && !this.languagesAllowed.includes(s) ? this.defaultLanguageId : s;
  },
  isZipMode() {
    return typeof this.store.getters["anatomy/application"].services.image.providers.image.zipProvider < "u";
  },
  getHighQuality() {
    return this.isZipMode() ? Pt.HIGH : dt.HIGH;
  },
  getHeightElementWithMargin(s) {
    const e = getComputedStyle(s);
    return Math.round(parseFloat(e.height) + parseFloat(e.marginTop) + parseFloat(e.marginBottom));
  },
  getUserId() {
    return this.user_id ?? window.IM_userID ?? fs;
  },
  sendApplicationError(s, e) {
    this.errorHandler?.sendApplicationError(s, e);
  },
  sendVueError(s) {
    this.errorHandler?.sendVueError(s);
  },
  sendCoreError(s) {
    this.errorHandler?.sendCoreError(s);
  },
  getErrorCode(s) {
    return s = s.toUpperCase().replaceAll("-", "_"), typeof ui[s] < "u" ? ui[s] : s;
  },
  stopLoadingImage() {
    window.stop !== void 0 ? (window.stop(), Ls.emit(z.image.STOP_LOADING_IMAGES)) : document.execCommand !== void 0 && (document.execCommand("Stop", !1), Ls.emit(z.image.STOP_LOADING_IMAGES));
  },
  md5(s) {
    return _o(s).toString();
  }
}, Ao = {
  name: "MenuSVG"
};
var wo = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M3 6.01562C3 5.60141 3.33579 5.26562 3.75 5.26562H20.25C20.6642 5.26562 21 5.60141 21 6.01562C21 6.42984 20.6642 6.76562 20.25 6.76562H3.75C3.33579 6.76562 3 6.42984 3 6.01562Z", fill: "currentColor" } }), t("path", { attrs: { d: "M3 18.0156C3 17.6014 3.33579 17.2656 3.75 17.2656H20.25C20.6642 17.2656 21 17.6014 21 18.0156C21 18.4298 20.6642 18.7656 20.25 18.7656H3.75C3.33579 18.7656 3 18.4298 3 18.0156Z", fill: "currentColor" } }), t("path", { attrs: { d: "M3.75 11.2656C3.33579 11.2656 3 11.6014 3 12.0156C3 12.4298 3.33579 12.7656 3.75 12.7656H20.25C20.6642 12.7656 21 12.4298 21 12.0156C21 11.6014 20.6642 11.2656 20.25 11.2656H3.75Z", fill: "currentColor" } })]);
}, Lo = [], Oo = /* @__PURE__ */ S(
  Ao,
  wo,
  Lo,
  !1,
  null,
  "40aabcb1"
);
const Br = Oo.exports, Mo = {
  name: "CrossSVG"
};
var No = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M12 4a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2h-6v6a1 1 0 1 1-2 0v-6H5a1 1 0 1 1 0-2h6V5a1 1 0 0 1 1-1z", fill: "currentColor" } })]);
}, Ro = [], xo = /* @__PURE__ */ S(
  Mo,
  No,
  Ro,
  !1,
  null,
  null
);
const Ki = xo.exports, Do = {
  name: "ShowSVG"
};
var Po = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.0156 5C6.4626 5 3.38748 9.40511 2.35342 11.2263C2.078 11.7114 2.078 12.2886 2.35342 12.7737C3.38748 14.5949 6.4626 19 12.0156 19C17.5752 19 20.6313 14.5844 21.6536 12.7672C21.9246 12.2856 21.9246 11.7144 21.6536 11.2328C20.6313 9.41558 17.5752 5 12.0156 5ZM3.65782 11.9669C4.64455 10.2291 7.33388 6.5 12.0156 6.5C16.7004 6.5 19.3712 10.235 20.3463 11.9683C20.3564 11.9861 20.3568 11.9963 20.3568 12C20.3568 12.0037 20.3564 12.0139 20.3463 12.0317C19.3712 13.765 16.7004 17.5 12.0156 17.5C7.33388 17.5 4.64455 13.7709 3.65782 12.0331C3.64743 12.0148 3.64685 12.0042 3.64685 12C3.64685 11.9958 3.64743 11.9852 3.65782 11.9669Z", fill: "black" } })]);
}, ko = [], Ho = /* @__PURE__ */ S(
  Do,
  Po,
  ko,
  !1,
  null,
  null
);
const hi = Ho.exports, Fo = {
  name: "HideSVG"
};
var zo = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 6.49998C7.31826 6.49998 4.62892 10.2291 3.64219 11.9669C3.6318 11.9852 3.63123 11.9958 3.63123 12C3.63123 12.0041 3.6318 12.0147 3.64219 12.033C4.62892 13.7709 7.31826 17.5 12 17.5C16.6847 17.5 19.3556 13.765 20.3307 12.0317C20.3407 12.0138 20.3412 12.0037 20.3412 12C20.3412 11.9963 20.3407 11.9861 20.3307 11.9682C19.3556 10.235 16.6847 6.49998 12 6.49998ZM2.33779 11.2263C3.37185 9.40509 6.44697 4.99998 12 4.99998C17.5596 4.99998 20.6157 9.41556 21.638 11.2328C21.9089 11.7144 21.9089 12.2856 21.638 12.7672C20.6157 14.5844 17.5596 19 12 19C6.44697 19 3.37185 14.5949 2.33779 12.7737C2.06237 12.2886 2.06237 11.7114 2.33779 11.2263Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 14C13.1045 14 14 13.1045 14 12C14 10.8954 13.1045 9.99998 12 9.99998C10.8954 9.99998 9.99997 10.8954 9.99997 12C9.99997 13.1045 10.8954 14 12 14ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.49998 12 8.49998C10.067 8.49998 8.49997 10.067 8.49997 12C8.49997 13.933 10.067 15.5 12 15.5Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20.7865 3.21875C21.0794 3.51165 21.0794 3.98652 20.7865 4.27941L4.2855 20.7804C3.99261 21.0733 3.51773 21.0733 3.22484 20.7804C2.93195 20.4875 2.93195 20.0126 3.22484 19.7197L19.7258 3.21875C20.0187 2.92586 20.4936 2.92586 20.7865 3.21875Z", fill: "black" } })]);
}, Bo = [], $o = /* @__PURE__ */ S(
  Fo,
  zo,
  Bo,
  !1,
  null,
  null
);
const mi = $o.exports, Uo = {
  name: "ArrowRightSubMenuSVG"
};
var Vo = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { width: "6", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M0.749897 1.02904C0.457942 1.32099 0.457684 1.79426 0.74932 2.08653L3.65644 5L0.74932 7.91346C0.457684 8.20573 0.457942 8.679 0.749897 8.97096C1.04208 9.26314 1.51579 9.26314 1.80797 8.97096L4.71827 6.06066C5.21828 5.56066 5.46828 5.31066 5.46828 5C5.46828 4.68934 5.21828 4.43934 4.71828 3.93934L1.80797 1.02904C1.51579 0.736856 1.04208 0.736856 0.749897 1.02904Z", fill: "currentColor" } })]);
}, Go = [], jo = /* @__PURE__ */ S(
  Uo,
  Vo,
  Go,
  !1,
  null,
  null
);
const fi = jo.exports, Yo = {
  __name: "option-list",
  props: {
    displayed: {
      type: Boolean,
      required: !0
    }
  },
  setup(s) {
    return { __sfc: !0 };
  }
};
var Wo = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.displayed ? t("ul", { staticClass: "option-list" }, [e._t("default")], 2) : e._e();
}, Zo = [], Xo = /* @__PURE__ */ S(
  Yo,
  Wo,
  Zo,
  !1,
  null,
  null
);
const $r = Xo.exports, Qo = /* @__PURE__ */ At({
  __name: "option-item",
  props: {
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  setup(s) {
    return { __sfc: !0 };
  }
});
var Ko = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("li", { staticClass: "option-item", class: { "option-disabled": e.disabled } }, [e._t("default")], 2);
}, qo = [], Jo = /* @__PURE__ */ S(
  Qo,
  Ko,
  qo,
  !1,
  null,
  "0736a233"
);
const Si = Jo.exports, el = {
  name: "IconButton",
  props: {
    icon: Object,
    isPressed: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
var tl = function() {
  var e = this, t = e._self._c;
  return t("button", { staticClass: "icon-button", attrs: { "aria-pressed": e.isPressed }, on: { click: e.handleClick } }, [t(e.icon, { tag: "component", staticClass: "icon" })], 1);
}, sl = [], il = /* @__PURE__ */ S(
  el,
  tl,
  sl,
  !1,
  null,
  "58f423d8"
);
const Ur = il.exports, rl = {
  props: {
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isActive: {
      type: Boolean,
      required: !0,
      default: !1
    },
    numberActive: {
      type: Number,
      require: !1,
      default: null
    }
  },
  emits: ["click"],
  methods: {
    handleClick() {
      this.disabled || this.$emit("click");
    }
  }
};
var nl = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "toggle", on: { click: e.handleClick } }, [t("span", { staticClass: "toggle-item", class: { selected: e.isActive, "toggle-number": e.numberActive }, attrs: { "aria-disabled": e.disabled } }, [e.numberActive ? t("span", { staticClass: "toggle-counter" }, [e._v(e._s(e.numberActive))]) : e._e()])]);
}, al = [], ol = /* @__PURE__ */ S(
  rl,
  nl,
  al,
  !1,
  null,
  "28d96265"
);
const ps = ol.exports, Yt = {
  methods: {
    getShortcutKeyByName(s) {
      return this.$store.getters["shortcut/getShortcutKeyByName"](s);
    }
  }
};
let Os = {};
const ll = {
  name: "FilterSection",
  directives: { ClickOutside: De },
  components: {
    IconButton: Ur,
    Toggle: ps,
    OptionItem: Si,
    OptionList: $r,
    HideSVG: mi,
    ShowSVG: hi,
    CrossSVG: Ki,
    ArrowRightSubMenuSVG: fi
  },
  mixins: [Yt],
  props: {
    isVisible: Boolean
  },
  data() {
    return {
      filtersIcons: {},
      filterOpen: null,
      haveAtLeastOnStructureHidden: !1,
      structureDisplayed: !0,
      overlaysDisplayed: !0,
      displayDropdown: !1
    };
  },
  computed: {
    buttonDisplayHiddenStructureDisabled() {
      return !this.structureDisplayed || !this.haveAtLeastOnStructureHidden;
    },
    showHideIcon() {
      return this.structureDisplayed ? hi : mi;
    },
    shortcutDrawStructures() {
      return this.getShortcutKeyByName("hide-labels");
    },
    shortcutShowHiddenStructure() {
      return this.getShortcutKeyByName("show-hidden-structures");
    },
    shortcutToggleOverlays() {
      return this.getShortcutKeyByName("toggle-overlays");
    },
    showMoreOption() {
      return Ki;
    },
    showFilterDetail() {
      return fi;
    }
  },
  watch: {
    isVisible() {
      this.isVisible === !1 && (this.filterOpen = null);
    }
  },
  created() {
    const { ui: s, filter: e, blacklistFeature: t, labels: i, overlays: r } = z;
    Os = h.createHooks([
      {
        on: s.SETTINGS.RESET,
        do: () => this.reset()
      },
      {
        on: e.SELECTED,
        do: () => this.$forceUpdate()
      },
      {
        on: e.UNSELECTED,
        do: () => this.$forceUpdate()
      },
      {
        on: s.CLOSE_MENU,
        do: () => this.resetFilterSelected()
      },
      {
        on: [
          t.BLACKLIST_STRUCTURE,
          t.CLEAR_BLACKLIST_STRUCTURE,
          t.BLACKLIST_POINT,
          t.WHITELIST_POINT
        ],
        do: this.checkingThereAreHiddenStructuresOrPoints
      },
      {
        on: i.TOGGLE,
        do: () => {
          this.structureDisplayed = !this.structureDisplayed;
        }
      },
      {
        on: r.TOGGLE,
        do: () => {
          this.overlaysDisplayed = !this.overlaysDisplayed;
        }
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Os);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Os);
  },
  methods: {
    getFiltersIcons(s) {
      s.forEach((e) => {
        typeof this.filtersIcons[e.icon_id] < "u" || (this.filtersIcons[e.icon_id] = _r, this.getFilterIcon(e.id).then((i) => {
          i !== "" && (this.filtersIcons[e.icon_id] = i, e.icon = i, this.$forceUpdate());
        })), e.icon = this.filtersIcons[e.icon_id], this.getFiltersIcons(e.children);
      });
    },
    filters() {
      const s = this.$store.getters["anatomy/filters"];
      return this.getFiltersIcons(s), s;
    },
    toggleFilter(s) {
      this.$store.dispatch("anatomy/toggleFilter", s), this.$forceUpdate();
    },
    toggleAllFilters(s = null) {
      s !== null ? this.$store.dispatch("anatomy/filter:toggleAllChild", s) : this.$store.dispatch("anatomy/toggleAllFilters"), this.$forceUpdate();
    },
    getFilterIcon(s) {
      return this.$store.getters["anatomy/getFilterIcon"](s);
    },
    isSelectedFilter(s, e = null) {
      return e !== null && s === -1 ? e.children.every(
        (t) => this.$store.getters["anatomy/isFilterSelected"](t.id)
      ) : this.$store.getters["anatomy/isFilterSelected"](s);
    },
    toggleOpenFilterChild(s) {
      this.filterOpen === s ? this.filterOpen = null : this.filterOpen = s;
    },
    numberOfChildrenSelected(s) {
      return s.children.filter((e) => this.isSelectedFilter(e.id)).length;
    },
    currentOpenChildrenFilter(s) {
      return this.filterOpen === s;
    },
    closeCurrentChildrenFilter(s) {
      if (this.filterOpen === s) return !1;
    },
    reset() {
      this.$store.dispatch("anatomy/filter:reset"), this.$forceUpdate();
    },
    resetFilterSelected() {
      this.filterOpen && this.toggleOpenFilterChild(this.filterOpen);
    },
    clearHiddenStructures() {
      this.haveAtLeastOnStructureHidden && (this.$store.dispatch("anatomy/structure:clear"), this.closeDropdown());
    },
    checkingThereAreHiddenStructuresOrPoints() {
      this.haveAtLeastOnStructureHidden = this.$store.getters["anatomy/haveBlacklistedStructures"]() || this.$store.getters["anatomy/haveHiddenPoints"]();
    },
    toggleDrawStructures() {
      this.closeDropdown(), this.$store.getters["anatomy/application"]?.toggleLabels();
    },
    toggleOverlay() {
      this.closeDropdown(), this.$store.getters["anatomy/application"]?.toggleOverlays();
    },
    toggleDropdown() {
      this.displayDropdown = !this.displayDropdown;
    },
    closeDropdown() {
      this.displayDropdown = !1;
    },
    toggleNumberActive(s, e) {
      return !s || s === e ? null : s;
    }
  }
};
var cl = function() {
  var e = this, t = e._self._c;
  return t("div", [t("div", { staticClass: "title-section" }, [t("span", [e._v(e._s(e.$t("menu.filter.section-title")))]), t("div", { staticClass: "dropdown-structures" }, [t("icon-button", { staticClass: "dropdown-button", attrs: { icon: e.showHideIcon }, nativeOn: { click: function(i) {
    return e.toggleDrawStructures.apply(null, arguments);
  } } }), t("icon-button", { staticClass: "dropdown-button", attrs: { icon: e.showMoreOption }, nativeOn: { click: function(i) {
    return e.toggleDropdown.apply(null, arguments);
  } } }), t("option-list", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.closeDropdown, expression: "closeDropdown" }], attrs: { displayed: e.displayDropdown } }, [t("option-item", { nativeOn: { click: function(i) {
    return e.toggleDrawStructures.apply(null, arguments);
  } } }, [t("span", [e._v(e._s(e.structureDisplayed ? e.$t("menu.filter.hide-all-structures") : e.$t("menu.filter.show-all-structures")))]), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutDrawStructures))])]), t("option-item", { attrs: { disabled: e.buttonDisplayHiddenStructureDisabled }, nativeOn: { click: function(i) {
    return e.clearHiddenStructures.apply(null, arguments);
  } } }, [t("span", [e._v(e._s(e.$t("menu.filter.show-hidden-structures")))]), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutShowHiddenStructure))])]), t("option-item", { nativeOn: { click: function(i) {
    return e.toggleOverlay.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.overlaysDisplayed ? e.$t("menu.filter.hide-all-overlays") : e.$t("menu.filter.show-all-overlays")) + " "), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutToggleOverlays))])])], 1)], 1)]), t("ul", [t("li", { key: -1, staticClass: "list-li" }, [t("div", { staticClass: "filter-title" }, [t("span", [e._v(" " + e._s(e.$t("menu.filter.select-all")) + " ")]), t("toggle", { attrs: { "is-active": e.isSelectedFilter(-1) }, on: { click: function(i) {
    return e.toggleAllFilters();
  } } })], 1)]), e._l(e.filters(), function(i) {
    return t("li", { key: i.id, staticClass: "list-li" }, [t("div", { staticClass: "filter-title" }, [t("span", [t("img", { staticClass: "filter-icon", attrs: { src: i.icon, alt: "", height: "25", width: "25" } }), t("span", [e._v(e._s(i.name))])]), t("div", { staticClass: "filter-item-toggle-container" }, [i.children.length === 0 ? [t("toggle", { attrs: { "is-active": e.isSelectedFilter(i.id) }, on: { click: function(r) {
      return e.toggleFilter(i.id);
    } } })] : i.children.length > 0 ? [t("icon-button", { staticClass: "toggle-icon", class: { open: e.currentOpenChildrenFilter(i.id) }, attrs: { icon: e.showFilterDetail }, nativeOn: { click: function(r) {
      return e.toggleOpenFilterChild(i.id);
    } } }), i.children.length > 0 ? t("toggle", { attrs: { "is-active": !!e.numberOfChildrenSelected(i), "number-active": e.toggleNumberActive(
      e.numberOfChildrenSelected(i),
      i.children.length
    ) }, on: { click: function(r) {
      return e.toggleAllFilters(i);
    } } }) : e._e()] : e._e()], 2)]), i.children.length > 0 ? t("div", { staticClass: "filter-content-expandable", attrs: { "aria-expanded": e.currentOpenChildrenFilter(i.id) } }, [t("div", [t("ul", { staticClass: "list-filter-children" }, e._l(i.children, function(r) {
      return t("li", { key: r.id, staticClass: "filter-children-item" }, [t("span", [t("img", { staticClass: "filter-icon", attrs: { src: r.icon, alt: "", height: "25", width: "25" } }), t("span", [e._v(e._s(r.name))])]), t("toggle", { attrs: { "is-active": e.isSelectedFilter(r.id) }, on: { click: function(n) {
        return e.toggleFilter(r.id);
      } } })], 1);
    }), 0)])]) : e._e()]);
  })], 2)]);
}, ul = [], dl = /* @__PURE__ */ S(
  ll,
  cl,
  ul,
  !1,
  null,
  "d0245e4a"
);
const hl = dl.exports, ml = {
  name: "RotationRightSVG"
};
var fl = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.5059 4.18993C14.7908 3.05903 12.7511 2.52412 10.7018 2.66779C8.65245 2.81146 6.70738 3.62572 5.16686 4.98486C3.62634 6.344 2.57604 8.17244 2.17811 10.1879C1.78017 12.2034 2.05673 14.2938 2.96509 16.1364C3.87345 17.9791 5.36309 19.4715 7.20405 20.3833C9.04501 21.295 11.1349 21.5755 13.1511 21.1813C15.1673 20.7871 16.9977 19.7402 18.3597 18.2022C18.6343 17.8921 18.6055 17.4181 18.2954 17.1435C17.9853 16.8689 17.5113 16.8976 17.2367 17.2077C16.0931 18.4991 14.5562 19.3782 12.8633 19.7092C11.1704 20.0401 9.41556 19.8047 7.86978 19.0391C6.324 18.2735 5.07321 17.0204 4.31049 15.4732C3.54778 13.926 3.31557 12.1708 3.6497 10.4785C3.98383 8.78615 4.86572 7.25088 6.15923 6.10967C7.45275 4.96845 9.08595 4.28476 10.8067 4.16412C12.5275 4.04349 14.2401 4.49263 15.6802 5.4422C17.1202 6.39178 18.2077 7.78898 18.7747 9.41812C18.9109 9.80931 19.3384 10.0161 19.7295 9.87993C20.1207 9.74378 20.3275 9.31628 20.1914 8.92508C19.5161 6.98485 18.221 5.32084 16.5059 4.18993Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M21.5568 5.88671C21.1814 5.71156 20.7351 5.87387 20.56 6.24923L19.3296 8.8862L16.6926 7.65578C16.3172 7.48063 15.871 7.64294 15.6958 8.0183C15.5207 8.39367 15.683 8.83994 16.0583 9.01509L19.3749 10.5626C19.5552 10.6467 19.7615 10.6558 19.9484 10.5878C20.1354 10.5198 20.2876 10.3804 20.3717 10.2001L21.9193 6.88349C22.0944 6.50813 21.9321 6.06185 21.5568 5.88671Z", fill: "black" } })]);
}, pl = [], gl = /* @__PURE__ */ S(
  ml,
  fl,
  pl,
  !1,
  null,
  "f8fefaa9"
);
const Vr = gl.exports, vl = {
  name: "RotationLeftSVG"
};
var yl = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.48465 4.18993C9.19973 3.05903 11.2394 2.52412 13.2887 2.66779C15.3381 2.81146 17.2832 3.62572 18.8237 4.98486C20.3642 6.344 21.4145 8.17244 21.8124 10.1879C22.2104 12.2034 21.9338 14.2938 21.0254 16.1364C20.1171 17.9791 18.6274 19.4715 16.7865 20.3833C14.9455 21.295 12.8556 21.5755 10.8394 21.1813C8.82323 20.7871 6.99284 19.7402 5.63085 18.2022C5.35624 17.8921 5.385 17.4181 5.6951 17.1435C6.0052 16.8689 6.4792 16.8976 6.75382 17.2077C7.89743 18.4991 9.43433 19.3782 11.1273 19.7092C12.8202 20.0401 14.575 19.8047 16.1208 19.0391C17.6665 18.2735 18.9173 17.0204 19.68 15.4732C20.4428 13.926 20.675 12.1708 20.3408 10.4785C20.0067 8.78615 19.1248 7.25088 17.8313 6.10967C16.5378 4.96845 14.9046 4.28476 13.1838 4.16412C11.4631 4.04349 9.75046 4.49263 8.31038 5.4422C6.87029 6.39178 5.78281 7.78898 5.21583 9.41812C5.07968 9.80931 4.65219 10.0161 4.26099 9.87993C3.86979 9.74378 3.66303 9.31628 3.79917 8.92508C4.47442 6.98485 5.76956 5.32084 7.48465 4.18993Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.43378 5.88671C2.80914 5.71156 3.25542 5.87387 3.43056 6.24923L4.66098 8.8862L7.29795 7.65578C7.67331 7.48063 8.11959 7.64294 8.29473 8.0183C8.46988 8.39367 8.30757 8.83994 7.93221 9.01509L4.61559 10.5626C4.43533 10.6467 4.22905 10.6558 4.04211 10.5878C3.85518 10.5198 3.70291 10.3804 3.6188 10.2001L2.07126 6.88349C1.89611 6.50813 2.05842 6.06185 2.43378 5.88671Z", fill: "black" } })]);
}, El = [], Il = /* @__PURE__ */ S(
  vl,
  yl,
  El,
  !1,
  null,
  "5d3932ce"
);
const Gr = Il.exports, Cl = {
  name: "VerticalFlipSVG"
};
var _l = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M12.7537 3.49634C12.7537 3.2202 12.5298 2.99634 12.2537 2.99634H11.7537C11.4775 2.99634 11.2537 3.2202 11.2537 3.49634V3.99634C11.2537 4.27248 11.4775 4.49634 11.7537 4.49634H12.2537C12.5298 4.49634 12.7537 4.27248 12.7537 3.99634V3.49634Z", fill: "black" } }), t("path", { attrs: { d: "M12.2537 5.74756C12.5298 5.74756 12.7537 5.97142 12.7537 6.24756V6.74756C12.7537 7.0237 12.5298 7.24756 12.2537 7.24756H11.7537C11.4775 7.24756 11.2537 7.0237 11.2537 6.74756V6.24756C11.2537 5.97142 11.4775 5.74756 11.7537 5.74756H12.2537Z", fill: "black" } }), t("path", { attrs: { "clip-rule": "evenodd", d: "M14.7721 11.3933C14.5761 11.5342 14.4599 11.7608 14.4599 12.0023C14.4599 12.2437 14.5761 12.4704 14.7721 12.6113L20.8153 16.9547C21.0438 17.1189 21.3449 17.1415 21.5953 17.0131C21.8456 16.8847 22.0031 16.6271 22.0031 16.3457V7.65882C22.0031 7.37748 21.8456 7.1198 21.5953 6.99144C21.3449 6.86307 21.0438 6.8856 20.8153 7.0498L14.7721 11.3933ZM16.4949 12.0023L20.5031 9.12149V14.8831L16.4949 12.0023Z", fill: "black", "fill-rule": "evenodd" } }), t("path", { attrs: { "clip-rule": "evenodd", d: "M1.99402 16.3457C1.99402 16.6271 2.15147 16.8847 2.40181 17.0131C2.65216 17.1415 2.95329 17.1189 3.18174 16.9547L9.22494 12.6113C9.421 12.4704 9.53722 12.2437 9.53722 12.0023C9.53722 11.7608 9.421 11.5342 9.22494 11.3933L3.18174 7.0498C2.95329 6.8856 2.65216 6.86307 2.40181 6.99144C2.15147 7.11981 1.99402 7.37748 1.99402 7.65882L1.99402 16.3457ZM7.50216 12.0023L3.49402 14.8831L3.49402 9.12149L7.50216 12.0023Z", fill: "black", "fill-rule": "evenodd" } }), t("path", { attrs: { d: "M12.7537 11.75C12.7537 11.4739 12.5298 11.25 12.2537 11.25H11.7537C11.4775 11.25 11.2537 11.4739 11.2537 11.75V12.25C11.2537 12.5261 11.4775 12.75 11.7537 12.75H12.2537C12.5298 12.75 12.7537 12.5261 12.7537 12.25V11.75Z", fill: "black" } }), t("path", { attrs: { d: "M12.2537 14.0012C12.5298 14.0012 12.7537 14.2251 12.7537 14.5012V15.0012C12.7537 15.2774 12.5298 15.5012 12.2537 15.5012H11.7537C11.4775 15.5012 11.2537 15.2774 11.2537 15.0012V14.5012C11.2537 14.2251 11.4775 14.0012 11.7537 14.0012H12.2537Z", fill: "black" } }), t("path", { attrs: { d: "M12.7537 17.2524C12.7537 16.9763 12.5298 16.7524 12.2537 16.7524H11.7537C11.4775 16.7524 11.2537 16.9763 11.2537 17.2524V17.7524C11.2537 18.0286 11.4775 18.2524 11.7537 18.2524H12.2537C12.5298 18.2524 12.7537 18.0286 12.7537 17.7524V17.2524Z", fill: "black" } }), t("path", { attrs: { d: "M12.2537 19.5037C12.5298 19.5037 12.7537 19.7275 12.7537 20.0037V20.5037C12.7537 20.7798 12.5298 21.0037 12.2537 21.0037H11.7537C11.4775 21.0037 11.2537 20.7798 11.2537 20.5037V20.0037C11.2537 19.7275 11.4775 19.5037 11.7537 19.5037H12.2537Z", fill: "black" } }), t("path", { attrs: { d: "M12.7537 8.99878C12.7537 8.72264 12.5298 8.49878 12.2537 8.49878H11.7537C11.4775 8.49878 11.2537 8.72264 11.2537 8.99878V9.49878C11.2537 9.77492 11.4775 9.99878 11.7537 9.99878H12.2537C12.5298 9.99878 12.7537 9.77492 12.7537 9.49878V8.99878Z", fill: "black" } })]);
}, Tl = [], Sl = /* @__PURE__ */ S(
  Cl,
  _l,
  Tl,
  !1,
  null,
  "2f14d9c2"
);
const jr = Sl.exports, bl = {
  name: "HorizontalFlipSVG"
};
var Al = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.65656 1.99924C7.37522 1.99924 7.11755 2.15669 6.98918 2.40703C6.86081 2.65738 6.88335 2.95851 7.04754 3.18696L11.391 9.23016C11.5319 9.42621 11.7586 9.54244 12 9.54244C12.2414 9.54244 12.4681 9.42621 12.609 9.23016L16.9525 3.18696C17.1167 2.95851 17.1392 2.65738 17.0109 2.40703C16.8825 2.15669 16.6248 1.99924 16.3435 1.99924H7.65656ZM12 7.50738L9.11923 3.49924H14.8808L12 7.50738ZM12.609 14.7774C12.4681 14.5813 12.2414 14.4651 12 14.4651C11.7586 14.4651 11.5319 14.5813 11.391 14.7774L7.04754 20.8206C6.88335 21.049 6.86081 21.3501 6.98918 21.6005C7.11755 21.8508 7.37522 22.0083 7.65656 22.0083H16.3435C16.6248 22.0083 16.8825 21.8508 17.0109 21.6005C17.1392 21.3501 17.1167 21.049 16.9525 20.8206L12.609 14.7774ZM12 16.5001L14.8808 20.5083H9.11923L12 16.5001ZM11.7537 11.25C11.4775 11.25 11.2537 11.4739 11.2537 11.75V12.25C11.2537 12.5261 11.4775 12.75 11.7537 12.75H12.2537C12.5298 12.75 12.7537 12.5261 12.7537 12.25V11.75C12.7537 11.4739 12.5298 11.25 12.2537 11.25H11.7537ZM14.0049 11.75C14.0049 11.4739 14.2287 11.25 14.5049 11.25H15.0049C15.281 11.25 15.5049 11.4739 15.5049 11.75V12.25C15.5049 12.5261 15.281 12.75 15.0049 12.75H14.5049C14.2287 12.75 14.0049 12.5261 14.0049 12.25V11.75ZM17.2561 11.25C16.98 11.25 16.7561 11.4739 16.7561 11.75V12.25C16.7561 12.5261 16.98 12.75 17.2561 12.75H17.7561C18.0322 12.75 18.2561 12.5261 18.2561 12.25V11.75C18.2561 11.4739 18.0322 11.25 17.7561 11.25H17.2561ZM19.5073 11.75C19.5073 11.4739 19.7312 11.25 20.0073 11.25H20.5073C20.7835 11.25 21.0073 11.4739 21.0073 11.75V12.25C21.0073 12.5261 20.7835 12.75 20.5073 12.75H20.0073C19.7312 12.75 19.5073 12.5261 19.5073 12.25V11.75ZM9.00244 11.25C8.7263 11.25 8.50244 11.4739 8.50244 11.75V12.25C8.50244 12.5261 8.7263 12.75 9.00244 12.75H9.50244C9.77858 12.75 10.0024 12.5261 10.0024 12.25V11.75C10.0024 11.4739 9.77858 11.25 9.50244 11.25H9.00244ZM5.75122 11.75C5.75122 11.4739 5.97508 11.25 6.25122 11.25H6.75122C7.02736 11.25 7.25122 11.4739 7.25122 11.75V12.25C7.25122 12.5261 7.02736 12.75 6.75122 12.75H6.25122C5.97508 12.75 5.75122 12.5261 5.75122 12.25V11.75ZM3.5 11.25C3.22386 11.25 3 11.4739 3 11.75V12.25C3 12.5261 3.22386 12.75 3.5 12.75H4C4.27614 12.75 4.5 12.5261 4.5 12.25V11.75C4.5 11.4739 4.27614 11.25 4 11.25H3.5Z", fill: "black" } })]);
}, wl = [], Ll = /* @__PURE__ */ S(
  bl,
  Al,
  wl,
  !1,
  null,
  "50b92b2a"
);
const Yr = Ll.exports, Ol = {
  name: "ResetSVG"
};
var Ml = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "clip-rule": "evenodd", d: "M15.0669 10.1603C15.356 10.457 15.3497 10.9319 15.053 11.2209L10.0323 16.1113C9.73557 16.4003 9.26073 16.3941 8.97172 16.0974C8.6827 15.8007 8.68894 15.3258 8.98566 15.0368L14.0064 10.1464C14.3031 9.85737 14.7779 9.86361 15.0669 10.1603Z", fill: "white", "fill-rule": "evenodd" } }), t("path", { attrs: { "clip-rule": "evenodd", d: "M8.97172 10.1603C9.26073 9.86361 9.73557 9.85737 10.0323 10.1464L15.053 15.0368C15.3497 15.3258 15.356 15.8007 15.0669 16.0974C14.7779 16.3941 14.3031 16.4003 14.0064 16.1113L8.98566 11.2209C8.68894 10.9319 8.6827 10.457 8.97172 10.1603Z", fill: "white", "fill-rule": "evenodd" } }), t("path", { attrs: { "clip-rule": "evenodd", d: "M3.53574 4.99486C3.53574 4.58064 3.87153 4.24486 4.28574 4.24486H12.0193C13.8115 4.24486 15.565 4.76217 17.0585 5.73357C18.5522 6.7051 19.7197 8.0881 20.4106 9.71015C21.1016 11.3324 21.2838 13.119 20.9333 14.8433C20.5828 16.5674 19.7161 18.1489 18.4458 19.3891C17.1757 20.6291 15.5592 21.4724 13.8014 21.8156C12.0438 22.1587 10.221 21.9868 8.56246 21.321C6.90381 20.6551 5.48184 19.5239 4.4784 18.0676C3.4748 16.6109 2.93563 14.8951 2.93146 13.1369C2.93048 12.7227 3.26546 12.3861 3.67968 12.3851C4.09389 12.3841 4.43047 12.7191 4.43146 13.1333C4.43491 14.5861 4.88023 16.007 5.71361 17.2165C6.54715 18.4263 7.73223 19.3713 9.12133 19.929C10.5106 20.4867 12.0395 20.6312 13.514 20.3434C14.9885 20.0555 16.3397 19.3489 17.3979 18.3158C18.4559 17.2829 19.1736 15.9701 19.4634 14.5445C19.7532 13.1189 19.6029 11.6415 19.0306 10.298C18.4582 8.95419 17.4884 7.8026 16.2406 6.99099C14.9926 6.17924 13.5236 5.74486 12.0193 5.74486H4.28574C3.87153 5.74486 3.53574 5.40907 3.53574 4.99486Z", fill: "white", "fill-rule": "evenodd" } }), t("path", { attrs: { "clip-rule": "evenodd", d: "M6.74835 2.23923C7.03737 2.53595 7.03113 3.01078 6.73441 3.2998L4.98417 5.00462L6.73478 6.71219C7.0313 7.00141 7.03721 7.47625 6.74799 7.77277C6.45876 8.06928 5.98393 8.0752 5.68741 7.78597L3.38598 5.54114C3.24121 5.39992 3.1596 5.20622 3.15967 5.00398C3.15974 4.80174 3.24148 4.6081 3.38636 4.46699L5.68778 2.22529C5.9845 1.93627 6.45933 1.94251 6.74835 2.23923Z", fill: "white", "fill-rule": "evenodd" } })]);
}, Nl = [], Rl = /* @__PURE__ */ S(
  Ol,
  Ml,
  Nl,
  !1,
  null,
  "5c249b2f"
);
const Wr = Rl.exports;
let Ms = {};
const xl = {
  name: "transformation-section",
  components: {
    ResetSVG: Wr,
    HorizontalFlipSVG: Yr,
    VerticalFlipSVG: jr,
    RotationLeftSVG: Gr,
    RotationRightSVG: Vr
  },
  data() {
    return {
      showOptionLanguage: !1,
      orientationVertical: Je.VERTICAL,
      orientationHorizontal: Je.HORIZONTAL
    };
  },
  methods: {
    rotate(s) {
      this.$store.dispatch("anatomy/image:rotate", s);
    },
    flipImage(s) {
      this.$store.dispatch("anatomy/image:flip", s);
    },
    resetImage() {
      this.$store.dispatch("anatomy/image:reset");
    },
    reset() {
      this.resetImage();
    }
  },
  created() {
    const { ui: s } = z;
    Ms = h.createHooks([
      { on: s.SETTINGS.RESET, do: () => this.reset() }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Ms);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Ms);
  }
};
var Dl = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "have-separator padding-bottom" }, [t("span", { staticClass: "title-section" }, [e._v(" " + e._s(e.$t("menu.transformation.section-title")) + " ")]), t("div", { staticClass: "button-container" }, [t("div", { staticClass: "container-icon-transformation" }, [t("RotationLeftSVG", { staticClass: "icon-transformation", attrs: { title: e.$t("context-menu.rotate-left") }, nativeOn: { click: function(i) {
    return e.rotate(-90);
  } } }), t("RotationRightSVG", { staticClass: "icon-transformation", attrs: { title: e.$t("context-menu.rotate-right") }, nativeOn: { click: function(i) {
    return e.rotate(90);
  } } }), t("VerticalFlipSVG", { staticClass: "icon-transformation", attrs: { title: e.$t("context-menu.flip-horizontal") }, nativeOn: { click: function(i) {
    return e.flipImage(e.orientationVertical);
  } } }), t("HorizontalFlipSVG", { staticClass: "icon-transformation", attrs: { title: e.$t("context-menu.flip-vertical") }, nativeOn: { click: function(i) {
    return e.flipImage(e.orientationHorizontal);
  } } }), t("ResetSVG", { staticClass: "icon-transformation", attrs: { title: `${e.$t("keyboard-panel.reset")} (R)` }, nativeOn: { click: function(i) {
    return e.resetImage.apply(null, arguments);
  } } })], 1)])]);
}, Pl = [], kl = /* @__PURE__ */ S(
  xl,
  Dl,
  Pl,
  !1,
  null,
  null
);
const Hl = kl.exports;
function Fl(s) {
  switch (s) {
    case he.CT:
      return "contrast.window";
    case he.IRM:
      return "contrast.weightings";
    default:
      return "contrast.default";
  }
}
let Ns = {};
const Rs = {
  NO_BORDER_RIGHT: "no-border-right",
  COLUMN_3: "column-3",
  COLUMN_2: "column-2"
}, xt = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right"
}, zl = {
  name: "contrast-section",
  computed: {
    contrastNameForCurrentSeries() {
      const s = this.$store.getters["anatomy/currentSeries"] || null;
      return this.$t(Fl(s !== null ? s.modality_id : 0));
    },
    contrasts() {
      return this.$store.getters["anatomy/contrasts"];
    }
  },
  methods: {
    getColumnClass() {
      const s = this.contrasts.length;
      return s % 2 === 0 && s % 3 !== 0 ? Rs.COLUMN_2 : Rs.COLUMN_3;
    },
    selectContrast(s) {
      this.$store.dispatch("anatomy/contrast:select", s), this.$forceUpdate();
    },
    overrideSiblingSelected(s, e) {
      const t = this.contrasts.length;
      return t > 1 && (s < t - 1 ? this.isSelectedContrast(this.contrasts[s + 1].id) : !1) && (e === "left" || e === "center") ? Rs.NO_BORDER_RIGHT : "";
    },
    isSelectedContrast(s) {
      return this.$store.getters["anatomy/isCurrentContrast"](s);
    },
    getClassContrast(s) {
      const e = this.contrasts.length;
      if (s += 1, e > 1)
        if (e % 2 === 0 && e % 3 !== 0) {
          if (s % 2 === 0)
            return xt.RIGHT;
          if (s % 2 === 1)
            return xt.LEFT;
        } else {
          if (s === 1 || s % 3 === 1 && e > s)
            return xt.LEFT;
          if (s % 3 === 0 || e === 2 || s === e && e % 3 === 2)
            return xt.RIGHT;
          if (s % 3 === 2 && e > s)
            return xt.CENTER;
        }
      return "";
    },
    reset() {
      this.$store.dispatch("anatomy/contrast:reset");
    }
  },
  created() {
    const { ui: s } = z;
    Ns = h.createHooks([
      { on: s.SETTINGS.RESET, do: () => this.reset() }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Ns);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Ns);
  }
};
var Bl = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "have-separator padding-bottom" }, [t("span", { staticClass: "title-section" }, [e._v(e._s(e.contrastNameForCurrentSeries))]), e.contrasts.length > 1 ? t("div", { staticClass: "button-container" }, e._l(e.contrasts, function(i, r) {
    return t("button", { key: i.id, staticClass: "button-contrast", class: [{ current: e.isSelectedContrast(i.id) }, e.getClassContrast(r), e.overrideSiblingSelected(r, e.getClassContrast(r)), e.getColumnClass()], attrs: { title: i.name }, on: { click: function(n) {
      return e.selectContrast(i.id);
    } } }, [t("span", { staticClass: "ellipsis" }, [e._v(e._s(i.name))])]);
  }), 0) : e._e(), e.contrasts.length === 1 ? t("div", { staticClass: "no-contrast" }, [t("span", { staticClass: "no-contrast-text" }, [e._v(e._s(e.$t("menu.contrast.no_contrast_for_this_series")))])]) : e._e()]);
}, $l = [], Ul = /* @__PURE__ */ S(
  zl,
  Bl,
  $l,
  !1,
  null,
  "020ab3b5"
);
const Vl = Ul.exports, Gl = {
  name: "SelectedSVG"
};
var jl = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "9", viewBox: "0 0 12 9", fill: "none" } }, [t("path", { attrs: { d: "M1 3.33527C2.50729 4.84255 4.85965 7.19492 4.85965 7.19492L11 1.05457", stroke: "#3DA8FE", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
}, Yl = [], Wl = /* @__PURE__ */ S(
  Gl,
  jl,
  Yl,
  !1,
  null,
  "7cde1e9d"
);
const Zl = Wl.exports;
let xs = {};
const Xl = {
  name: "series-section",
  data() {
    return {
      minLimitSeries: 4,
      limitSeries: 4,
      seriesLength: 0,
      imagesSeriesLoaded: {},
      imagesAllSeriesLoaded: []
    };
  },
  components: { SelectedSVG: Zl },
  computed: {
    series() {
      const s = this.$store.getters["anatomy/listSeries"], e = this.$store.getters["anatomy/listSeriesImage"], t = Object.values(s.concat(e).reduce((i, r) => (i[r.id] = Object.assign(i[r.id] || {}, r), i), {}));
      return this.seriesLength = t.length, this.needUpLimitSeries(), this.limitSeries ? t.slice(0, this.limitSeries) : t;
    },
    displayMoreText() {
      return this.limitSeries < this.seriesLength;
    },
    displayLessText() {
      return this.limitSeries > this.minLimitSeries;
    },
    imagesAllSeries() {
      return this.$store.getters["anatomy/imageAllSeries"];
    },
    displayAllSeries() {
      return this.imagesAllSeries.length > 0 && this.imagesAllSeries.filter((s) => s.src !== null).length === this.imagesAllSeriesLoaded.length;
    },
    isPhone() {
      return h.isMobileScreen();
    }
  },
  methods: {
    needUpLimitSeries() {
      this.seriesLength !== 0 && this.seriesLength - this.minLimitSeries <= 3 && (this.limitSeries = this.seriesLength, this.minLimitSeries = this.seriesLength);
    },
    nextSeriesIsSelected(s) {
      return s < this.series.length - 1 ? this.isSelected(this.series[s + 1].id) : !1;
    },
    isSelected(s) {
      const e = this.$store.getters["anatomy/isModeFullSeries"] || this.$store.getters["anatomy/getIsolateStructureId"]() !== null, t = this.$store.getters["anatomy/currentSeries"];
      return e && s === -1 || !e && t.id === s;
    },
    select(s) {
      this.$store.dispatch("anatomy/slice:notification", ie.RIGHT_MENU), this.$store.dispatch("anatomy/series:set", { seriesIndex: s, relativeSliceIndex: 1, keepMode: !1, placement: ie.RIGHT_MENU });
    },
    upLimitSeries() {
      this.limitSeries = this.seriesLength;
    },
    downLimitSeries() {
      this.limitSeries = this.minLimitSeries;
    },
    reset() {
      const s = this.$store.getters["anatomy/indexCurrentSlice"];
      this.$store.dispatch("anatomy/series:set", {
        seriesIndex: -1,
        relativeSliceIndex: s,
        keepMode: !1
      });
    },
    onImageLoaded(s) {
      s !== -1 ? this.$set(this.imagesSeriesLoaded, s.id, !0) : this.$set(this.imagesAllSeriesLoaded, this.imagesAllSeriesLoaded.length, !0);
    }
  },
  created() {
    const { ui: s, language: e, translator: t, application: i, featureIsolate: r } = z;
    xs = h.createHooks([
      { on: s.SETTINGS.RESET, do: () => this.reset() },
      { on: i.READY, do: () => this.$store.dispatch("anatomy/list-series:update-images") },
      { on: e.CHANGE, do: () => this.$store.dispatch("anatomy/list-series:update") },
      { on: t.ADDED, do: () => this.$store.dispatch("anatomy/list-series:update") },
      { on: [r.START_ISOLATE, r.CLEAN_ISOLATE], do: () => this.$forceUpdate() }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(xs);
  },
  beforeDestroy() {
    h.onBeforeUnmount(xs);
  }
};
var Ql = function() {
  var e = this, t = e._self._c;
  return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isPhone, expression: "isPhone" }] }, [t("span", { staticClass: "title-section" }, [e._v(e._s(e.$t("menu.series.section-title")))]), t("ul", [t("li", { staticClass: "list-li series", class: { selected: e.isSelected(-1), "hide-border": e.nextSeriesIsSelected(-1) }, on: { click: function(i) {
    return e.select(-1);
  } } }, [t("div", { staticClass: "list-item-series" }, [t("div", { staticClass: "images-all-series" }, [e._l(e.imagesAllSeries, function(i) {
    return [i.src !== null ? t("img", { directives: [{ name: "show", rawName: "v-show", value: e.displayAllSeries, expression: "displayAllSeries" }], staticClass: "picture", style: { "background-color": `#${i.background_color}` }, attrs: { src: i.src, alt: e.$t("gallery.all-series"), width: "15", height: "15" }, on: { load: function(r) {
      return e.onImageLoaded(-1);
    } } }) : e._e(), i.src === null && e.displayAllSeries ? t("span", { staticClass: "picture", style: { "background-color": `#${i.background_color}` } }) : e._e()];
  }), e.displayAllSeries ? e._e() : t("div", { staticClass: "image-series-placeholder" }, [e._m(0)])], 2), t("p", [e._v(e._s(e.$t("menu.series.all")))])])]), e._l(e.series, function(i, r) {
    return t("li", { key: i.id + "-menu", staticClass: "list-li series", class: { selected: e.isSelected(i.id), "hide-border": e.nextSeriesIsSelected(r) }, on: { click: function(n) {
      return e.select(r + 1);
    } } }, [t("div", { staticClass: "list-item-series" }, [t("img", { directives: [{ name: "show", rawName: "v-show", value: e.imagesSeriesLoaded[i.id], expression: "imagesSeriesLoaded[serie.id]" }], attrs: { src: i.src, alt: i.name, width: "32", height: "32" }, on: { load: function(n) {
      return e.onImageLoaded(i);
    } } }), e.imagesSeriesLoaded[i.id] ? e._e() : t("div", { staticClass: "image-series-placeholder" }, [e._m(1, !0)]), t("p", [e._v(e._s(i.name))])])]);
  }), e.displayMoreText ? t("li", { staticClass: "list-li series btn-entry no-hover", on: { click: e.upLimitSeries } }, [t("div", { staticClass: "list-show" }, [t("div", { staticClass: "list-show-more" }, [t("p", [e._v(e._s(e.$t("menu.series.more")))])])])]) : e._e(), e.displayLessText ? t("li", { staticClass: "list-li series btn-entry no-hover", on: { click: e.downLimitSeries } }, [t("div", { staticClass: "list-show" }, [t("div", { staticClass: "list-show-less" }, [t("p", [e._v(e._s(e.$t("menu.series.less")))])])])]) : e._e()], 2)]);
}, Kl = [function() {
  var s = this, e = s._self._c;
  return e("div", { staticClass: "load-wrapper" }, [e("div", { staticClass: "activity" })]);
}, function() {
  var s = this, e = s._self._c;
  return e("div", { staticClass: "load-wrapper" }, [e("div", { staticClass: "activity" })]);
}], ql = /* @__PURE__ */ S(
  Xl,
  Ql,
  Kl,
  !1,
  null,
  "9be755ee"
);
const Jl = ql.exports;
let Ds = [];
const ec = {
  name: "Slider",
  computed: {
    notIE() {
      return oe.getIEVersion() === 0;
    }
  },
  props: {
    min: {
      default: 0
    },
    max: {
      default: 1
    },
    step: {
      default: 0.1
    },
    defaultValue: {
      default: 1
    },
    onInput: Function
  },
  methods: {
    updateInput() {
      if (this.notIE) {
        const s = h.getCSSVariable("--color-background-toggle-slider-selected"), e = h.getCSSVariable("--color-background-toggle-slider"), t = this.$refs.input, i = (t.value - t.min) / (t.max - t.min) * 100;
        t.style.background = `linear-gradient(to right, ${s} 0%, ${s} ${i}%, ${e} ${i}%, ${e} 100%)`, this.onInput(t.value);
      }
    },
    changeValue() {
      this.notIE || this.onInput(this.$refs.input.value);
    }
  },
  mounted() {
    this.$refs.input.value = this.$props.defaultValue, this.updateInput();
  },
  created() {
    const { ui: s } = z;
    Ds = h.createHooks([
      { on: s.THEME.SWITCH, do: () => this.updateInput() }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Ds);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Ds);
  }
};
var tc = function() {
  var e = this, t = e._self._c;
  return t("input", { ref: "input", class: { "custom-input-range": e.notIE }, attrs: { type: "range", min: e.min, max: e.max, step: e.step }, on: { input: e.updateInput, change: e.changeValue } });
}, sc = [], ic = /* @__PURE__ */ S(
  ec,
  tc,
  sc,
  !1,
  null,
  null
);
const Zr = ic.exports, rc = {
  name: "DarkIconSVG"
};
var nc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M18.5624 6.96854C17.9314 6.26521 18.3452 4.5069 17.6315 4.5069H17.6231C16.9094 4.5069 17.3231 6.26521 16.6922 6.96854C16.0613 7.67187 14.2409 7.19609 14.2409 7.88907C14.2409 8.58206 15.9889 8.18902 16.6922 8.83029C17.2891 9.37457 17.0232 11.2713 17.6231 11.2713H17.6315C18.2314 11.2713 17.9654 9.37457 18.5624 8.83029C19.2657 8.18902 21.0137 8.58206 21.0137 7.88907C21.0137 7.19609 19.1933 7.67187 18.5624 6.96854Z", fill: "black" } }), t("path", { attrs: { d: "M12.7642 4.11205C12.4764 3.79119 12.6651 2.98904 12.3396 2.98904H12.3357C12.0102 2.98904 12.1989 3.79119 11.9111 4.11205C11.6232 4.43291 10.7928 4.21586 10.7928 4.532C10.7928 4.84814 11.5902 4.66884 11.9111 4.96139C12.1834 5.20969 12.0621 6.07496 12.3357 6.07496H12.3396C12.6132 6.07496 12.4919 5.20969 12.7642 4.96139C13.0851 4.66884 13.8825 4.84814 13.8825 4.532C13.8825 4.21586 13.0521 4.43291 12.7642 4.11205Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.074 2.8336C12.1476 2.77102 12.2383 2.73904 12.3357 2.73904H12.3396C12.437 2.73904 12.5277 2.77102 12.6013 2.8336C12.6695 2.89152 12.7095 2.96396 12.7344 3.0253C12.7817 3.14168 12.8003 3.28615 12.8142 3.39982C12.8163 3.41691 12.8183 3.43375 12.8203 3.45033C12.8333 3.55778 12.8449 3.65474 12.8658 3.74481C12.89 3.84946 12.92 3.91125 12.9503 3.94511C12.9737 3.97118 13.0229 4.00139 13.1213 4.0261C13.217 4.05014 13.3262 4.0615 13.4504 4.07443L13.4648 4.07593C13.5762 4.08751 13.718 4.10226 13.8316 4.14244C13.8925 4.16397 13.9677 4.20001 14.0291 4.26583C14.0968 4.3384 14.1325 4.43104 14.1325 4.532C14.1325 4.62987 14.0996 4.72015 14.0367 4.7928C13.9788 4.85967 13.9069 4.89877 13.8465 4.92313C13.7318 4.96949 13.5888 4.98873 13.4761 5.00344C13.4619 5.00528 13.448 5.00709 13.4342 5.00886C13.3245 5.02303 13.2253 5.03583 13.1336 5.0582C13.0299 5.08354 12.9675 5.11438 12.9327 5.14613C12.9195 5.15813 12.8912 5.19999 12.8629 5.30504C12.8379 5.39801 12.8216 5.50474 12.8034 5.62374C12.8021 5.63215 12.8008 5.64063 12.7995 5.64917C12.7816 5.76633 12.7594 5.90911 12.7176 6.02243C12.6806 6.12271 12.5796 6.32496 12.3396 6.32496H12.3357C12.0957 6.32496 11.9947 6.12271 11.9577 6.02243C11.9159 5.90911 11.8937 5.76633 11.8758 5.64917C11.8745 5.64063 11.8732 5.63215 11.8719 5.62373C11.8537 5.50473 11.8374 5.39801 11.8124 5.30504C11.7841 5.19999 11.7558 5.15813 11.7426 5.14613C11.7078 5.11438 11.6454 5.08354 11.5417 5.0582C11.45 5.03583 11.3508 5.02303 11.2411 5.00887C11.2273 5.00709 11.2134 5.00528 11.1992 5.00344C11.0865 4.98873 10.9435 4.96949 10.8288 4.92313C10.7684 4.89877 10.6965 4.85967 10.6386 4.7928C10.5757 4.72015 10.5428 4.62987 10.5428 4.532C10.5428 4.43104 10.5785 4.3384 10.6462 4.26583C10.7076 4.20001 10.7828 4.16397 10.8437 4.14244C10.9573 4.10226 11.0991 4.08751 11.2105 4.07593C11.2131 4.07566 11.2156 4.0754 11.2181 4.07514L11.2249 4.07443C11.3491 4.0615 11.4583 4.05014 11.554 4.0261C11.6525 4.00139 11.7016 3.97118 11.725 3.94511C11.7553 3.91125 11.7853 3.84946 11.8095 3.74481C11.8304 3.65474 11.842 3.55778 11.855 3.45034C11.857 3.43375 11.859 3.41692 11.8611 3.39982C11.875 3.28615 11.8936 3.14168 11.9409 3.0253C11.9658 2.96396 12.0058 2.89152 12.074 2.8336ZM12.2966 3.85763C12.2651 3.99362 12.2107 4.15243 12.0972 4.27899C11.9766 4.41336 11.814 4.47634 11.6758 4.51105C11.623 4.52431 11.5686 4.5346 11.515 4.54293C11.5634 4.55116 11.6125 4.5608 11.6603 4.57247C11.7963 4.60567 11.9539 4.66213 12.0795 4.77665C12.2025 4.88879 12.2611 5.04821 12.2952 5.17523C12.3123 5.23866 12.326 5.30554 12.3377 5.37098C12.3493 5.30554 12.363 5.23866 12.3801 5.17523C12.4142 5.04821 12.4728 4.88879 12.5958 4.77665C12.7214 4.66213 12.8791 4.60567 13.015 4.57247C13.0628 4.5608 13.1119 4.55116 13.1603 4.54293C13.1067 4.5346 13.0523 4.52431 12.9995 4.51105C12.8613 4.47634 12.6987 4.41336 12.5781 4.27899C12.4646 4.15243 12.4102 3.99362 12.3787 3.85763C12.3606 3.77948 12.3478 3.69777 12.3377 3.62104C12.3275 3.69777 12.3147 3.77948 12.2966 3.85763Z", fill: "black" } }), t("path", { attrs: { d: "M14.469 11.2723C14.1812 10.9514 14.3699 10.1493 14.0444 10.1493H14.0405C13.7149 10.1493 13.9037 10.9514 13.6158 11.2723C13.328 11.5932 12.4975 11.3761 12.4975 11.6923C12.4975 12.0084 13.295 11.8291 13.6158 12.1216C13.8882 12.3699 13.7668 13.2352 14.0405 13.2352H14.0444C14.318 13.2352 14.1967 12.3699 14.469 12.1216C14.7899 11.8291 15.5873 12.0084 15.5873 11.6923C15.5873 11.3761 14.7568 11.5932 14.469 11.2723Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.7787 9.99385C13.8524 9.93126 13.9431 9.89929 14.0405 9.89929H14.0444C14.1418 9.89929 14.2324 9.93126 14.3061 9.99385C14.3743 10.0518 14.4143 10.1242 14.4392 10.1855C14.4865 10.3019 14.505 10.4464 14.519 10.5601C14.5211 10.5772 14.5231 10.594 14.5251 10.6106C14.538 10.718 14.5497 10.815 14.5706 10.9051C14.5948 11.0097 14.6247 11.0715 14.6551 11.1054C14.6785 11.1314 14.7276 11.1616 14.8261 11.1863C14.9218 11.2104 15.0309 11.2217 15.1552 11.2347L15.1695 11.2362C15.2809 11.2478 15.4228 11.2625 15.5364 11.3027C15.5973 11.3242 15.6725 11.3603 15.7339 11.4261C15.8016 11.4986 15.8373 11.5913 15.8373 11.6923C15.8373 11.7901 15.8043 11.8804 15.7415 11.9531C15.6836 12.0199 15.6117 12.059 15.5513 12.0834C15.4365 12.1297 15.2935 12.149 15.1808 12.1637C15.1667 12.1655 15.1528 12.1673 15.139 12.1691C15.0292 12.1833 14.93 12.1961 14.8384 12.2184C14.7346 12.2438 14.6723 12.2746 14.6375 12.3064C14.6243 12.3184 14.5959 12.3602 14.5677 12.4653C14.5427 12.5583 14.5264 12.665 14.5082 12.784C14.5069 12.7924 14.5056 12.8009 14.5043 12.8094C14.4863 12.9266 14.4642 13.0694 14.4224 13.1827C14.3854 13.283 14.2844 13.4852 14.0444 13.4852H14.0405C13.8005 13.4852 13.6994 13.283 13.6624 13.1827C13.6206 13.0694 13.5985 12.9266 13.5805 12.8094C13.5792 12.8009 13.5779 12.7924 13.5767 12.784C13.5585 12.665 13.5422 12.5583 13.5172 12.4653C13.4889 12.3602 13.4606 12.3184 13.4474 12.3064C13.4126 12.2746 13.3502 12.2438 13.2464 12.2184C13.1548 12.1961 13.0556 12.1833 12.9459 12.1691C12.9321 12.1673 12.9181 12.1655 12.904 12.1637C12.7913 12.149 12.6483 12.1297 12.5335 12.0834C12.4732 12.059 12.4012 12.0199 12.3434 11.9531C12.2805 11.8804 12.2475 11.7901 12.2475 11.6923C12.2475 11.5913 12.2833 11.4986 12.351 11.4261C12.4124 11.3603 12.4876 11.3242 12.5485 11.3027C12.6621 11.2625 12.8039 11.2478 12.9153 11.2362C12.9179 11.2359 12.9204 11.2356 12.9229 11.2354L12.9297 11.2347C13.0539 11.2217 13.163 11.2104 13.2588 11.1863C13.3572 11.1616 13.4064 11.1314 13.4297 11.1054C13.4601 11.0715 13.49 11.0097 13.5143 10.9051C13.5351 10.815 13.5468 10.718 13.5597 10.6106C13.5617 10.594 13.5638 10.5772 13.5659 10.5601C13.5798 10.4464 13.5984 10.3019 13.6456 10.1855C13.6706 10.1242 13.7105 10.0518 13.7787 9.99385ZM14.0014 11.0179C13.9699 11.1539 13.9155 11.3127 13.8019 11.4392C13.6814 11.5736 13.5188 11.6366 13.3806 11.6713C13.3277 11.6846 13.2733 11.6949 13.2198 11.7032C13.2682 11.7114 13.3172 11.721 13.365 11.7327C13.501 11.7659 13.6587 11.8224 13.7843 11.9369C13.9073 12.049 13.9659 12.2085 14 12.3355C14.0171 12.3989 14.0308 12.4658 14.0424 12.5312C14.0541 12.4658 14.0678 12.3989 14.0848 12.3355C14.119 12.2085 14.1776 12.049 14.3006 11.9369C14.4262 11.8224 14.5838 11.7659 14.7198 11.7327C14.7676 11.721 14.8167 11.7114 14.8651 11.7032C14.8115 11.6949 14.7571 11.6846 14.7043 11.6713C14.5661 11.6366 14.4035 11.5736 14.2829 11.4392C14.1694 11.3127 14.115 11.1539 14.0835 11.0179C14.0654 10.9397 14.0526 10.858 14.0424 10.7813C14.0322 10.858 14.0195 10.9397 14.0014 11.0179Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.03457 5.39307C8.04154 5.40793 8.0474 5.42473 8.0511 5.44275C8.0586 5.47933 8.05518 5.50991 8.04548 5.53492C6.97123 8.30558 6.95829 12.0973 9.78697 14.4787C12.442 16.7206 15.9117 16.6688 18.5039 15.5821C18.5291 15.5716 18.5638 15.566 18.608 15.5736C18.6411 15.5792 18.6718 15.5911 18.6966 15.6053C16.2992 19.9601 10.7962 20.6536 7.29092 17.8061L7.2897 17.8052C3.40204 14.6605 3.47643 8.22448 8.03457 5.39307ZM9.13521 4.36119C9.50625 4.7848 9.68871 5.44612 9.44404 6.07717C8.49227 8.53194 8.61179 11.5289 10.7534 13.3315L10.7543 13.3323C12.8682 15.1175 15.7024 15.1301 17.924 14.1988C18.5496 13.9365 19.2198 14.1006 19.6592 14.4509C20.1171 14.8159 20.4492 15.5133 20.0591 16.2396C17.2027 21.5579 10.5419 22.3791 6.34575 18.9709C1.68282 15.1985 1.75137 7.43809 7.3408 4.05901C8.03642 3.63847 8.74609 3.91696 9.13521 4.36119Z", fill: "black" } })]);
}, ac = [], oc = /* @__PURE__ */ S(
  rc,
  nc,
  ac,
  !1,
  null,
  "1512abe7"
);
const lc = oc.exports, cc = {
  name: "OrientationSVG"
};
var uc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.97927 2.99615C5.39349 2.99615 5.72927 3.33194 5.72927 3.74615V16.9779C5.72927 17.6682 6.28892 18.2279 6.97927 18.2279H20.2537C20.6679 18.2279 21.0037 18.5637 21.0037 18.9779C21.0037 19.3921 20.6679 19.7279 20.2537 19.7279H6.97927C5.46049 19.7279 4.22927 18.4966 4.22927 16.9779V3.74615C4.22927 3.33194 4.56506 2.99615 4.97927 2.99615Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.7684 5.58814C7.47168 5.87715 6.99684 5.87091 6.70783 5.57419L5.003 3.82395L3.29544 5.57457C3.00621 5.87108 2.53137 5.87699 2.23486 5.58777C1.93834 5.29854 1.93243 4.82371 2.22165 4.52719L4.46649 2.22576C4.6077 2.08099 4.8014 1.99938 5.00364 1.99945C5.20588 1.99952 5.39952 2.08126 5.54064 2.22614L7.78234 4.52757C8.07136 4.82428 8.06511 5.29912 7.7684 5.58814Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.4151 21.7685C18.1261 21.4718 18.1324 20.9969 18.4291 20.7079L20.1793 19.0031L18.4287 17.2955C18.1322 17.0063 18.1263 16.5315 18.4155 16.235C18.7047 15.9384 19.1796 15.9325 19.4761 16.2218L21.7775 18.4666C21.9223 18.6078 22.0039 18.8015 22.0038 19.0037C22.0037 19.206 21.922 19.3996 21.7771 19.5407L19.4757 21.7824C19.179 22.0715 18.7041 22.0652 18.4151 21.7685Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.7791 11.1119C16.3649 11.1065 16.0336 10.7663 16.039 10.3521L16.0711 7.90905L13.6258 7.93949C13.2116 7.94464 12.8717 7.61306 12.8665 7.19888C12.8614 6.7847 13.193 6.44476 13.6071 6.4396L16.8218 6.39958C17.0241 6.39707 17.2187 6.47633 17.3617 6.61938C17.5046 6.76244 17.5838 6.95716 17.5811 7.15939L17.5389 10.3719C17.5334 10.786 17.1932 11.1174 16.7791 11.1119Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.7514 7.23565C17.0441 7.52878 17.0437 8.00366 16.7506 8.29631L6.5259 18.5045C6.23277 18.7972 5.7579 18.7968 5.46524 18.5036C5.17258 18.2105 5.17297 17.7356 5.4661 17.443L15.6908 7.2348C15.9839 6.94214 16.4588 6.94252 16.7514 7.23565Z", fill: "black" } })]);
}, dc = [], hc = /* @__PURE__ */ S(
  cc,
  uc,
  dc,
  !1,
  null,
  "5bfcb725"
);
const mc = hc.exports, fc = {
  name: "Cross-referencesSVG"
};
var pc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.4613 2.63892C7.6373 2.49624 7.86838 2.44078 8.08997 2.48802L14.4448 3.8428C14.8005 3.91864 15.0506 4.2388 15.0379 4.60232L14.4759 20.8045C14.4651 21.1164 14.2621 21.3891 13.9664 21.489C13.6707 21.5889 13.344 21.4952 13.1462 21.2537L8.59773 15.7014C8.33524 15.381 8.38221 14.9084 8.70263 14.646C9.02306 14.3835 9.4956 14.4304 9.75809 14.7509L13.0458 18.7642L13.517 5.17873L8.68514 4.14861L8.69334 9.08451C8.69403 9.49872 8.3588 9.83507 7.94459 9.83576C7.53037 9.83644 7.19403 9.50122 7.19334 9.087L7.1836 3.22278C7.18322 2.99621 7.28529 2.7816 7.4613 2.63892Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.6155 8.62478C13.7983 8.25309 14.2478 8.09997 14.6195 8.28278L21.5883 11.7103C21.8751 11.8514 22.041 12.1587 22.0016 12.4759C21.9622 12.7931 21.7261 13.0504 21.4134 13.1169L6.16322 16.3626C5.84679 16.4299 5.52284 16.2867 5.35959 16.0074L2.10097 10.4324C1.97525 10.2173 1.96454 9.95379 2.07241 9.7292C2.18027 9.50462 2.39262 9.34826 2.6391 9.31192L7.64237 8.57443C8.05216 8.51403 8.43332 8.79726 8.49373 9.20704C8.55413 9.61683 8.2709 9.99799 7.86111 10.0584L3.95625 10.634L6.3811 14.7826L18.9831 12.1006L13.9575 9.62879C13.5858 9.44598 13.4327 8.99647 13.6155 8.62478Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.34976 8.82873C7.60294 8.5009 8.07394 8.44037 8.40177 8.69355L14.4219 13.3427C14.7498 13.5959 14.8103 14.0669 14.5571 14.3947C14.304 14.7225 13.833 14.7831 13.5051 14.5299L7.48495 9.88074C7.15711 9.62757 7.09659 9.15657 7.34976 8.82873Z", fill: "black" } })]);
}, gc = [], vc = /* @__PURE__ */ S(
  fc,
  pc,
  gc,
  !1,
  null,
  "859aa041"
);
const yc = vc.exports, Ec = {
  name: "ScreenshotSVG"
};
var Ic = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.75 2.06207C3.23122 2.06207 2 3.29329 2 4.81207V7.68707C2 8.10129 2.33579 8.43707 2.75 8.43707C3.16421 8.43707 3.5 8.10129 3.5 7.68707V4.81207C3.5 4.12172 4.05964 3.56207 4.75 3.56207H7.625C8.03921 3.56207 8.375 3.22629 8.375 2.81207C8.375 2.39786 8.03921 2.06207 7.625 2.06207H4.75ZM19.1875 2.06207C20.7063 2.06207 21.9375 3.29329 21.9375 4.81207V7.68707C21.9375 8.10129 21.6017 8.43707 21.1875 8.43707C20.7733 8.43707 20.4375 8.10129 20.4375 7.68707V4.81207C20.4375 4.12172 19.8779 3.56207 19.1875 3.56207H16.3125C15.8983 3.56207 15.5625 3.22629 15.5625 2.81207C15.5625 2.39786 15.8983 2.06207 16.3125 2.06207H19.1875ZM2 19.2496C2 20.7684 3.23122 21.9996 4.75 21.9996H7.625C8.03921 21.9996 8.375 21.6638 8.375 21.2496C8.375 20.8354 8.03921 20.4996 7.625 20.4996H4.75C4.05964 20.4996 3.5 19.9399 3.5 19.2496V16.3746C3.5 15.9604 3.16421 15.6246 2.75 15.6246C2.33579 15.6246 2 15.9604 2 16.3746V19.2496ZM19.1875 21.9996C20.7063 21.9996 21.9375 20.7684 21.9375 19.2496V16.3746C21.9375 15.9604 21.6017 15.6246 21.1875 15.6246C20.7733 15.6246 20.4375 15.9604 20.4375 16.3746V19.2496C20.4375 19.9399 19.8779 20.4996 19.1875 20.4996H16.3125C15.8983 20.4996 15.5625 20.8354 15.5625 21.2496C15.5625 21.6638 15.8983 21.9996 16.3125 21.9996H19.1875Z", fill: "#3DA8FE" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.85938 9.64801C5.85938 9.09573 6.30709 8.64801 6.85938 8.64801H8.77914C8.91064 8.64801 9.03685 8.59621 9.13042 8.50382L10.2274 7.42077C10.4146 7.23599 10.667 7.13239 10.93 7.13239H12H13.1013C13.3642 7.13239 13.6167 7.23599 13.8038 7.42077L14.9008 8.50382C14.9944 8.59621 15.1206 8.64801 15.2521 8.64801H17.1406C17.6929 8.64801 18.1406 9.09573 18.1406 9.64801V15.8668C18.1406 16.419 17.6929 16.8668 17.1406 16.8668H6.85938C6.30709 16.8668 5.85938 16.419 5.85938 15.8668V9.64801ZM14.25 13.1246C14.25 14.3672 13.2426 15.3746 12 15.3746C10.7574 15.3746 9.75 14.3672 9.75 13.1246C9.75 11.8819 10.7574 10.8746 12 10.8746C13.2426 10.8746 14.25 11.8819 14.25 13.1246ZM7.625 11.2496C8.03921 11.2496 8.375 10.9138 8.375 10.4996C8.375 10.0854 8.03921 9.74957 7.625 9.74957C7.21079 9.74957 6.875 10.0854 6.875 10.4996C6.875 10.9138 7.21079 11.2496 7.625 11.2496Z", fill: "#3DA8FE" } })]);
}, Cc = [], _c = /* @__PURE__ */ S(
  Ec,
  Ic,
  Cc,
  !1,
  null,
  "d874ee14"
);
const Tc = _c.exports;
let Ps = {};
const Sc = {
  name: "display-section",
  components: {
    ScreenshotSVG: Tc,
    CrossReferencesSVG: yc,
    // HidePointLabelSVG,
    // HQSVG,
    OrientationSVG: mc,
    Slider: Zr,
    DarkIconSVG: lc,
    Toggle: ps
  },
  data() {
    return {
      isDarkMode: !1,
      canWriteInLocalStorage: !1
    };
  },
  mixins: [Yt],
  computed: {
    canDisplayCrossRefButton() {
      return this.$store.getters["menu/canDisplayCrossRefButton"];
    },
    isHighQuality() {
      return this.$store.getters["anatomy/imageQuality"] === h.getHighQuality();
    },
    widgetOrientationIsOpen() {
      return this.$store.getters["orientation-context-menu/widgetVisibility"];
    },
    notIE() {
      return oe.getIEVersion() === 0;
    },
    featuresHidePointWithoutLabel() {
      return this.$store.getters["anatomy/featureHidePointWithoutLabelIsActive"];
    },
    viewZoneEnabled() {
      return this.$store.getters["anatomy/viewZoneEnabled"];
    },
    pinModeEnabled() {
      return this.$store.getters["anatomy/pinModeEnabled"];
    },
    crossReferencesPanelIsOpen() {
      return this.$store.getters["menu/displayCrossReferencesPanel"].display;
    },
    getShortcutScreenshot() {
      return this.getShortcutKeyByName("save");
    }
  },
  methods: {
    toggleQuizMode() {
      this.$store.dispatch("anatomy/quiz:toggle");
    },
    toggleOrientationWidgetOrientation() {
      this.widgetOrientationIsOpen ? this.$store.dispatch("orientation-context-menu/perform:close") : this.$store.dispatch("orientation-context-menu/perform:open");
    },
    switchTheme() {
      this.notIE && (h.switchTheme(this.$store.getters["anatomy/moduleName"]), this.$store.dispatch(
        "anatomy/theme-switch-notification",
        h.isDarkMode()
      ), this.isDarkMode = h.isDarkMode());
    },
    switchQuality() {
      G.add(Q.IMAGE_HIGH_QUALITY, !this.isHighQuality), this.$store.dispatch("anatomy/image:toggleQuality");
    },
    toggleHidePointWithoutLabel() {
      this.$store.dispatch("anatomy/hide-point-feature:toggle");
    },
    refreshImageOverlayOpacity() {
      const s = this.$store.getters["anatomy/moduleName"], e = {
        input: this.$refs.slider.$refs.input,
        updateInput: () => this.$refs.slider.updateInput()
      };
      if (s !== null) {
        const t = G.get(Q.OVERLAY);
        e.input.value = t?.[s] ?? this.$store.getters["anatomy/getDefaultOverlayOpacity"], this.canWriteInLocalStorage = !0;
      } else
        e.input.value = this.$store.getters["anatomy/getDefaultOverlayOpacity"];
      e.updateInput();
    },
    refreshImageQuality() {
      this.$store.dispatch("anatomy/image:quality-refresh");
    },
    updateOpacityOverlay(s) {
      const e = this.$store.getters["anatomy/moduleName"];
      if (e !== null && this.canWriteInLocalStorage) {
        const t = {};
        t[e] = parseFloat(s), G.add(Q.OVERLAY, t);
      }
      this.$store.dispatch("anatomy/overlay:set-opacity", s);
    },
    reset() {
      G.remove(Q.THEME);
      const s = this.$store.getters["anatomy/currentSeries"]?.modality_id || null;
      this.isDarkMode = h.setThemeByModality(s) === "dark";
      const e = this.$store.getters["anatomy/moduleName"];
      G.remove(Q.OVERLAY, e), this.refreshImageOverlayOpacity(), G.remove(Q.IMAGE_HIGH_QUALITY), this.isHighQuality || this.switchQuality(), G.remove(Q.ORIENTATION), this.widgetOrientationIsOpen || this.toggleOrientationWidgetOrientation();
    },
    checkOrientation() {
      (G.get(Q.ORIENTATION) ?? !0) !== this.widgetOrientationIsOpen && this.toggleOrientationWidgetOrientation();
    },
    init() {
      this.refreshImageOverlayOpacity(), this.checkOrientation();
    },
    toggleCrossReferencesPanel() {
      this.$store.dispatch("menu/cross-references:toggle").then(
        () => this.$store.dispatch(
          "menu/cross-references:notification",
          ie.RIGHT_MENU
        )
      );
    },
    saveScreenshot() {
      this.$store.dispatch("anatomy/saveImage");
    }
  },
  created() {
    const { application: s, series: e, image: t, ui: i } = z;
    Ps = h.createHooks([
      {
        on: e.CHANGE,
        do: () => {
          this.isDarkMode = h.isDarkMode();
        }
      },
      { on: s.READY, do: () => this.init() },
      { on: i.SETTINGS.RESET, do: () => this.reset() },
      { on: t.QUALITY_CHANGE, do: () => this.refreshImageQuality() }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Ps);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Ps);
  }
};
var bc = function() {
  var e = this, t = e._self._c;
  return t("div", [t("span", { staticClass: "title-section" }, [e._v(" " + e._s(e.$t("menu.display.section-title")) + " ")]), t("ul", [t("li", { staticClass: "list-li" }, [t("div", { staticClass: "list-item" }, [t("span", [t("OrientationSVG"), e._v(" " + e._s(e.$t("menu.display.orientation")) + " ")], 1), t("toggle", { attrs: { "is-active": e.widgetOrientationIsOpen }, on: { click: e.toggleOrientationWidgetOrientation } })], 1)]), e.canDisplayCrossRefButton ? t("li", { staticClass: "list-li" }, [t("div", { staticClass: "list-item" }, [t("span", [t("CrossReferencesSVG"), e._v(" " + e._s(e.$t("menu.display.cross-references")) + " ")], 1), t("toggle", { attrs: { "is-active": e.crossReferencesPanelIsOpen }, on: { click: e.toggleCrossReferencesPanel } })], 1)]) : e._e(), t("li", { staticClass: "list-li", class: { "not-available": !e.notIE }, attrs: { title: e.notIE ? "" : e.$t("ie.not-available") } }, [t("div", { staticClass: "list-item" }, [t("span", [t("DarkIconSVG", { staticClass: "not-colored" }), e._v(" " + e._s(e.$t("menu.display.dark-mode")) + " ")], 1), t("toggle", { attrs: { "is-active": e.isDarkMode }, on: { click: e.switchTheme } })], 1)]), t("li", { staticClass: "list-li" }, [t("div", { staticClass: "list-li-content setting-opacity" }, [t("p", [e._v(e._s(e.$t("menu.display.overlays-opacity")))]), t("Slider", { ref: "slider", staticClass: "slider", attrs: { "on-input": (i) => this.updateOpacityOverlay(i) } })], 1)]), t("li", { staticClass: "list-li list-li-screenshot", on: { click: function(i) {
    return e.saveScreenshot();
  } } }, [t("div", { staticClass: "screenshot-button-content" }, [t("div", { staticClass: "text-icon-screenshot" }, [t("ScreenshotSVG"), t("p", [e._v(e._s(e.$t("menu.display.screenshot")))])], 1), t("span", { staticClass: "shortcut" }, [e._v(e._s(e.getShortcutScreenshot))])])])])]);
}, Ac = [], wc = /* @__PURE__ */ S(
  Sc,
  bc,
  Ac,
  !1,
  null,
  "090b2dfd"
);
const Lc = wc.exports, Oc = {
  name: "ArrowSubMenuSVG"
};
var Mc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "14", height: "17", viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M4.99961 3.11108C4.61034 3.50036 4.61 4.13139 4.99884 4.52108L8.875 8.4057L4.99884 12.2903C4.61 12.68 4.61034 13.311 4.99961 13.7003C5.38919 14.0899 6.02081 14.0899 6.41038 13.7003L10.2908 9.81991C10.9575 9.15325 11.2908 8.81991 11.2908 8.4057C11.2908 7.99149 10.9575 7.65815 10.2908 6.99149L6.41038 3.11108C6.02081 2.72151 5.38919 2.72151 4.99961 3.11108Z", fill: "white" } })]);
}, Nc = [], Rc = /* @__PURE__ */ S(
  Oc,
  Mc,
  Nc,
  !1,
  null,
  "d252aa71"
);
const Wt = Rc.exports;
let ks = {};
const xc = {
  name: "LanguageSection",
  components: {
    ArrowSubMenuSVG: Wt
    // LanguageSVG
  },
  directives: { ClickOutside: De },
  data() {
    return {
      showOptionLanguage: !1
    };
  },
  computed: {
    languages() {
      return this.$store.getters["anatomy/languages"];
    },
    currentLanguage() {
      return this.$store.getters["anatomy/currentLanguage"];
    }
  },
  created() {
    const {
      application: s,
      ui: e,
      language: t
    } = z;
    ks = h.createHooks([
      {
        on: s.READY,
        do: () => this.loadCurrentLanguage()
      },
      {
        on: e.SETTINGS.RESET,
        do: () => this.reset()
      },
      {
        on: t.CHANGE,
        do: () => this.$store.dispatch("anatomy/language:update-current")
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(ks);
  },
  beforeUnmount() {
    h.onBeforeUnmount(ks);
  },
  methods: {
    toggleLanguages() {
      this.showOptionLanguage = !this.showOptionLanguage;
    },
    setLanguage(s, e = !0) {
      this.showOptionLanguage = !1, e && G.add(Q.LANGUAGE, s), this.$store.dispatch("anatomy/language:set", s);
    },
    closeOptionLanguage() {
      this.showOptionLanguage = !1;
    },
    reset() {
      G.remove(Q.LANGUAGE), this.setLanguage(h.transformSiteAccessToStructureLanguage(h.getSiteAccess()), !1);
    },
    loadCurrentLanguage() {
      const s = G.get(Q.LANGUAGE), e = G.get(Q.LAST_SITE_ACCESS);
      s !== null && (e === h.getSiteAccess() ? this.setLanguage(s) : this.reset()), G.add(Q.LAST_SITE_ACCESS, h.getSiteAccess());
    }
  }
};
var Dc = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "have-separator padding-bottom" }, [t("span", { staticClass: "title-section" }, [e._v(" " + e._s(e.$t("menu.language.section-title")) + " ")]), t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.closeOptionLanguage, expression: "closeOptionLanguage" }], staticClass: "language-container" }, [t("div", { staticClass: "input-container", on: { click: e.toggleLanguages } }, [t("p", { staticClass: "anatomy-menu-language" }, [e._v(" " + e._s(e.currentLanguage) + " ")]), t("ArrowSubMenuSVG")], 1), t("div", { staticClass: "options-languages-container", class: { show: e.showOptionLanguage } }, [t("ul", { staticClass: "options-languages" }, e._l(e.languages, function(i) {
    return t("li", { key: i.id, staticClass: "option", on: { click: function(r) {
      return e.setLanguage(i.id);
    } } }, [e._v(" " + e._s(i.name) + " ")]);
  }), 0)])])]);
}, Pc = [], kc = /* @__PURE__ */ S(
  xc,
  Dc,
  Pc,
  !1,
  null,
  "3a63add7"
);
const Hc = kc.exports;
let Hs = {};
const Fc = {
  name: "AdvancedSettingsSection",
  components: { Toggle: ps },
  data: () => ({
    isURLCopied: !1
  }),
  computed: {
    isScrollInverse() {
      return this.$store.getters["anatomy/isScrollInverse"];
    },
    isNotMobile() {
      return !oe.isMobileOrTablet();
    },
    shareLabel() {
      return this.isURLCopied ? this.$t("menu.advanced-settings.share.copied") : this.$t("menu.advanced-settings.share.label");
    }
  },
  created() {
    const { reverseScroll: s, application: e, ui: t } = z;
    Hs = h.createHooks([
      {
        on: s.STATUS_CHANGE,
        do: () => this.$store.dispatch("anatomy/application:reverse-scroll-update")
      },
      {
        on: e.READY,
        do: () => this.init()
      },
      {
        on: t.SETTINGS.RESET,
        do: () => this.onReset()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Hs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Hs);
  },
  methods: {
    onReset() {
      G.remove(Q.REVERSE_SCROLL), this.isScrollInverse && this.$store.dispatch("anatomy/inverse-scroll:toggle");
    },
    resetSettings() {
      this.$store.dispatch("anatomy/reset");
    },
    inverseScrollToggle() {
      G.add(Q.REVERSE_SCROLL, !this.isScrollInverse), this.$store.dispatch("anatomy/inverse-scroll:toggle");
    },
    displayShortcuts() {
      this.$store.dispatch("menu/shortcut-panel:display");
    },
    init() {
      G.get(
        Q.REVERSE_SCROLL
      ) && !this.isScrollInverse && this.inverseScrollToggle();
    },
    async share() {
      let s = "link copied";
      const e = this.$store.getters["anatomy/getShareLink"]();
      try {
        await navigator.clipboard.writeText(e);
      } catch (t) {
        t.name === "NotAllowedError" ? (s = `here is your share link: ${e}`, this.$store.dispatch("dialog-popup/display", {
          title: "share",
          message: s
        })) : h.sendVueError(t);
      } finally {
        this.isURLCopied = !0, setTimeout(() => this.isURLCopied = !1, 2e3);
      }
    }
  }
};
var zc = function() {
  var e = this, t = e._self._c;
  return t("div", [t("span", { staticClass: "title-section margin-bottom" }, [e._v(" " + e._s(e.$t("menu.advanced-settings.section-title")) + " ")]), t("ul", [t("li", { staticClass: "list-li", attrs: { title: `${e.$t("keyboard-panel.reverse-scroll")} (I)` } }, [t("div", { staticClass: "list-li-content setting-reverseScroll" }, [t("p", [e._v(e._s(e.$t("menu.advanced-settings.reverseScroll-settings")))]), t("toggle", { attrs: { "is-active": e.isScrollInverse }, on: { click: e.inverseScrollToggle } })], 1)]), e.isNotMobile ? t("li", { staticClass: "list-li have-hover", on: { click: e.displayShortcuts } }, [t("div", { staticClass: "list-li-content" }, [t("p", [e._v(e._s(e.$t("menu.advanced-settings.shortcuts-panel")))])])]) : e._e(), t("li", { staticClass: "list-li have-hover", on: { click: e.resetSettings } }, [t("div", { staticClass: "list-li-content" }, [t("p", [e._v(e._s(e.$t("menu.advanced-settings.reset-settings")))])])]), t("li", { staticClass: "list-li have-hover", on: { click: e.share } }, [t("div", { staticClass: "list-li-content" }, [t("p", [e._v(e._s(e.shareLabel))])])])])]);
}, Bc = [], $c = /* @__PURE__ */ S(
  Fc,
  zc,
  Bc,
  !1,
  null,
  "8179d6e5"
);
const Uc = $c.exports, Vc = {
  name: "QuizSVG"
};
var Gc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M11.1054 11.8143V11.4624C11.1005 11.1864 11.1675 10.9139 11.2999 10.6717C11.484 10.387 11.7233 10.1421 12.0037 9.95137C12.2527 9.79465 12.475 9.59897 12.6619 9.37179C12.7648 9.22973 12.8199 9.05867 12.8193 8.88329C12.8277 8.78961 12.8111 8.69537 12.7711 8.61025C12.731 8.52512 12.6691 8.45219 12.5916 8.39892C12.4016 8.28224 12.1808 8.22594 11.9582 8.23747C11.3851 8.27332 10.8289 8.44503 10.3353 8.73839L9.81372 7.69515C10.4962 7.29693 11.2715 7.0856 12.0617 7.08245C12.6209 7.05917 13.171 7.23033 13.6183 7.56681C13.8027 7.71608 13.9505 7.90565 14.0502 8.12095C14.15 8.33625 14.1991 8.57155 14.1937 8.80877C14.1921 9.11527 14.1077 9.41564 13.9494 9.67814C13.7018 10.0142 13.3945 10.3019 13.0428 10.5268C12.8367 10.6751 12.6503 10.849 12.4881 11.0443C12.4008 11.1826 12.3589 11.3447 12.368 11.508V11.7895L11.1054 11.8143ZM10.9563 13.4371C10.9482 13.327 10.9632 13.2163 11.0003 13.1122C11.0373 13.0082 11.0957 12.913 11.1716 12.8327C11.2574 12.7635 11.3561 12.7121 11.4621 12.6815C11.568 12.6509 11.6789 12.6418 11.7884 12.6547C11.8992 12.6463 12.0106 12.6603 12.1158 12.6959C12.2211 12.7315 12.3181 12.7878 12.4011 12.8617C12.5413 13.0287 12.6181 13.2398 12.6181 13.4578C12.6181 13.6759 12.5413 13.887 12.4011 14.054C12.3193 14.1288 12.2232 14.1864 12.1187 14.2234C12.0142 14.2603 11.9033 14.2759 11.7926 14.2692C11.6815 14.2771 11.57 14.2624 11.4647 14.2261C11.3594 14.1898 11.2626 14.1327 11.1799 14.0581C11.0994 13.9773 11.0376 13.8798 10.999 13.7725C10.9604 13.6652 10.9458 13.5507 10.9563 13.4371Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.4644 7.76389C13.0639 7.46393 12.5721 7.31142 12.0721 7.33223L12.0627 7.33262C11.3946 7.33529 10.7378 7.49535 10.145 7.79874L10.4429 8.39446C10.9093 8.15934 11.4194 8.02069 11.9426 7.98796L11.9452 7.98779C12.2184 7.97364 12.4894 8.04274 12.7224 8.18591L12.7333 8.1926C12.8474 8.27099 12.9384 8.37861 12.9973 8.50389C13.0545 8.62554 13.0792 8.75983 13.0692 8.89373C13.0677 9.1181 12.9961 9.33651 12.8644 9.5184L12.8599 9.52468L12.855 9.53067C12.652 9.7773 12.4109 9.98992 12.1408 10.1605C11.8922 10.3303 11.6795 10.5475 11.515 10.7996C11.4062 11.0017 11.3512 11.2284 11.3553 11.458L11.3554 11.4624L11.3554 11.5593L12.118 11.5443V11.5145C12.1076 11.3018 12.163 11.0911 12.2766 10.9109L12.2853 10.8971L12.2957 10.8846C12.4715 10.6729 12.6735 10.4845 12.8968 10.3239L12.9079 10.3159C13.2305 10.1096 13.513 9.8467 13.7411 9.53935C13.8724 9.31774 13.9423 9.06513 13.9437 8.80744L13.9437 8.80311C13.9482 8.60408 13.9071 8.40668 13.8234 8.22605C13.7403 8.04674 13.6175 7.8887 13.4644 7.76389ZM12.056 6.83247C12.6714 6.80796 13.2763 6.99676 13.7685 7.36703L13.7756 7.37235C13.9898 7.54566 14.1613 7.76588 14.2771 8.01585C14.3926 8.26516 14.4496 8.53757 14.4437 8.81227C14.4414 9.16305 14.3447 9.50675 14.1635 9.80721L14.1576 9.81711L14.1507 9.82642C13.8863 10.1853 13.5585 10.4928 13.1835 10.7336C13.0014 10.8652 12.8362 11.0187 12.6916 11.1906C12.6375 11.282 12.6117 11.3876 12.6176 11.494L12.6184 11.508L12.618 12.0346L10.8554 12.0693V11.4646C10.8501 11.1459 10.9277 10.8314 11.0806 10.5518L11.085 10.5437L11.09 10.536C11.2923 10.2232 11.5551 9.95413 11.8631 9.74466L11.8705 9.73965C12.0945 9.59865 12.2948 9.42309 12.4637 9.21929C12.5327 9.1213 12.5697 9.00419 12.5693 8.88418L12.5692 8.87248L12.5703 8.86083C12.5747 8.81134 12.5659 8.76157 12.5448 8.7166C12.5245 8.67338 12.4935 8.63611 12.4547 8.6083C12.3096 8.52079 12.1417 8.47856 11.9724 8.48707C11.4394 8.52064 10.9221 8.68044 10.4631 8.95329L10.232 9.09067L9.4853 7.59733L9.68772 7.47922C10.4068 7.05964 11.2236 6.83661 12.056 6.83247ZM11.7592 12.903C11.6828 12.894 11.6053 12.9003 11.5314 12.9217C11.4628 12.9415 11.3986 12.9737 11.3419 13.0168C11.2954 13.0692 11.2593 13.13 11.2358 13.1961C11.2104 13.2675 11.2001 13.3433 11.2057 13.4188L10.9563 13.4371L11.2053 13.4602C11.1981 13.5373 11.208 13.615 11.2342 13.6878C11.2597 13.7586 11.3 13.8231 11.3524 13.877C11.409 13.9268 11.4748 13.9652 11.5462 13.9898C11.6196 14.0151 11.6975 14.0253 11.775 14.0199L11.7913 14.0187L11.8077 14.0197C11.8849 14.0244 11.9623 14.0135 12.0353 13.9877C12.1031 13.9637 12.1659 13.9272 12.2202 13.8803C12.3159 13.7604 12.3681 13.6115 12.3681 13.4578C12.3681 13.3047 12.3163 13.1563 12.2213 13.0367C12.1665 12.9909 12.1036 12.9556 12.0358 12.9328C11.9623 12.9079 11.8846 12.8981 11.8073 12.904L11.7832 12.9058L11.7592 12.903ZM10.7057 13.4348C10.6983 13.2968 10.7183 13.1587 10.7648 13.0284C10.8135 12.8916 10.8902 12.7664 10.99 12.6609L11.0015 12.6487L11.0146 12.6382C11.1263 12.548 11.2548 12.4811 11.3927 12.4413C11.5229 12.4037 11.6589 12.3911 11.7937 12.4039C11.9299 12.3966 12.0664 12.4153 12.1958 12.4591C12.3329 12.5054 12.4592 12.5788 12.5673 12.6749L12.5809 12.687L12.5926 12.701C12.7706 12.913 12.8681 13.181 12.8681 13.4578C12.8681 13.7347 12.7706 14.0026 12.5926 14.2147L12.582 14.2274L12.5698 14.2385C12.4632 14.3359 12.3382 14.4109 12.2021 14.459C12.0711 14.5054 11.9325 14.5259 11.7938 14.5197C11.6546 14.5273 11.5152 14.5079 11.3833 14.4625C11.2462 14.4152 11.1201 14.3409 11.0124 14.2437L11.0025 14.2348C10.8962 14.128 10.8148 13.9989 10.7638 13.8572C10.7151 13.7219 10.6953 13.578 10.7057 13.4348Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.2139 16.9052C18.3834 16.9055 18.5513 16.8723 18.708 16.8076C18.8647 16.7429 19.0071 16.648 19.127 16.5282C19.2469 16.4085 19.3421 16.2662 19.407 16.1096C19.4719 15.9531 19.5054 15.7852 19.5054 15.6157V5.7929C19.5054 5.6234 19.4719 5.45556 19.407 5.29898C19.3421 5.14241 19.2469 5.00017 19.127 4.8804C19.0071 4.76063 18.8647 4.66569 18.708 4.601C18.5513 4.5363 18.3834 4.50314 18.2139 4.50339L18.2117 4.50339L5.79363 4.50339C5.62413 4.50314 5.45624 4.5363 5.29957 4.601C5.14289 4.66569 5.00051 4.76063 4.88057 4.8804C4.76062 5.00017 4.66546 5.14241 4.60054 5.29898C4.53561 5.45556 4.5022 5.6234 4.5022 5.79291V15.6157C4.5022 15.7852 4.53561 15.9531 4.60054 16.1096C4.66546 16.2662 4.76062 16.4085 4.88057 16.5282C5.00051 16.648 5.14289 16.7429 5.29957 16.8076C5.45624 16.8723 5.62413 16.9055 5.79363 16.9052L5.79586 16.9052L8.14011 16.9052C8.96853 16.9052 9.64011 17.5768 9.64011 18.4052V18.6783L12.0519 17.1405C12.2929 16.9868 12.5726 16.9052 12.8584 16.9052H18.2139ZM8.90892 20.9235C8.57608 21.1357 8.14011 20.8966 8.14011 20.5019V18.4052H5.79586C5.42919 18.4058 5.06601 18.334 4.72709 18.1941C4.38817 18.0541 4.08016 17.8488 3.82069 17.5897C3.56122 17.3306 3.35538 17.0229 3.21493 16.6842C3.07449 16.3455 3.0022 15.9824 3.0022 15.6157V5.79291C3.0022 5.42623 3.07449 5.06316 3.21493 4.72445C3.35538 4.38573 3.56122 4.07804 3.82069 3.81895C4.08016 3.55987 4.38817 3.35448 4.72709 3.21454C5.06601 3.0746 5.42919 3.00284 5.79586 3.00339H18.2117C18.5784 3.00284 18.9416 3.0746 19.2805 3.21454C19.6194 3.35448 19.9274 3.55987 20.1869 3.81895C20.4463 4.07804 20.6522 4.38573 20.7926 4.72445C20.9331 5.06316 21.0054 5.42623 21.0054 5.79291V15.6157C21.0054 15.9824 20.9331 16.3455 20.7926 16.6842C20.6522 17.0229 20.4463 17.3306 20.1869 17.5897C19.9274 17.8488 19.6194 18.0541 19.2805 18.1941C18.9416 18.334 18.5784 18.4058 18.2117 18.4052H12.8584L8.90892 20.9235Z", fill: "black" } })]);
}, jc = [], Yc = /* @__PURE__ */ S(
  Vc,
  Gc,
  jc,
  !1,
  null,
  "2d2ae991"
);
const Wc = Yc.exports, Zc = {
  name: "ViewZoneSVG"
};
var Xc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.1011 13.0624C15.3711 12.7482 15.8446 12.7124 16.1587 12.9824L21.7474 17.7848C22.0615 18.0548 22.0973 18.5283 21.8274 18.8424C21.5574 19.1566 21.0839 19.1924 20.7697 18.9225L15.1811 14.12C14.867 13.8501 14.8312 13.3765 15.1011 13.0624Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.61828 2.03882C9.01664 1.92531 9.43159 2.15623 9.5451 2.55459L11.0951 7.99424C11.2086 8.3926 10.9777 8.80754 10.5793 8.92105C10.181 9.03456 9.76601 8.80365 9.6525 8.40529L8.10252 2.96564C7.98901 2.56728 8.21992 2.15233 8.61828 2.03882Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.98343 16.7361C1.90415 16.3295 2.16946 15.9357 2.57602 15.8564L8.67755 14.6666C9.08411 14.5874 9.47795 14.8527 9.55723 15.2592C9.6365 15.6658 9.37119 16.0596 8.96463 16.1389L2.8631 17.3287C2.45655 17.4079 2.0627 17.1426 1.98343 16.7361Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.94033 18.4689L17.9403 18.4689C18.2165 18.4689 18.4403 18.2451 18.4403 17.9689L18.4403 5.96893C18.4403 5.69278 18.2165 5.46893 17.9403 5.46893L5.94033 5.46892C5.66419 5.46892 5.44033 5.69278 5.44033 5.96892L5.44033 17.9689C5.44033 18.2451 5.66418 18.4689 5.94033 18.4689ZM17.9403 19.9689L5.94033 19.9689C4.83576 19.9689 3.94033 19.0735 3.94033 17.9689L3.94033 5.96892C3.94033 4.86435 4.83576 3.96892 5.94033 3.96892L17.9403 3.96893C19.0449 3.96893 19.9403 4.86436 19.9403 5.96893L19.9403 17.9689C19.9403 19.0735 19.0449 19.9689 17.9403 19.9689Z", fill: "black" } }), t("path", { attrs: { d: "M10.3608 9.6821C11.2332 9.6821 11.9403 8.97513 11.9403 8.10305C11.9403 7.23097 11.2332 6.52401 10.3608 6.52401C9.48845 6.52401 8.78127 7.23097 8.78127 8.10305C8.78127 8.97513 9.48845 9.6821 10.3608 9.6821Z", fill: "black" } }), t("path", { attrs: { d: "M15.6715 15.127C16.5438 15.127 17.251 14.4201 17.251 13.548C17.251 12.6759 16.5438 11.9689 15.6715 11.9689C14.7991 11.9689 14.0919 12.6759 14.0919 13.548C14.0919 14.4201 14.7991 15.127 15.6715 15.127Z", fill: "black" } }), t("path", { attrs: { d: "M8.82467 16.9173C9.69703 16.9173 10.4042 16.2103 10.4042 15.3382C10.4042 14.4661 9.69703 13.7592 8.82467 13.7592C7.95232 13.7592 7.24514 14.4661 7.24514 15.3382C7.24514 16.2103 7.95232 16.9173 8.82467 16.9173Z", fill: "black" } })]);
}, Qc = [], Kc = /* @__PURE__ */ S(
  Zc,
  Xc,
  Qc,
  !1,
  null,
  "131a7097"
);
const Xr = Kc.exports, qc = {
  name: "PinModeSVG"
};
var Jc = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5.66904C10.067 5.66904 8.5 7.23605 8.5 9.16904C8.5 11.102 10.067 12.669 12 12.669C13.933 12.669 15.5 11.102 15.5 9.16904C15.5 7.23605 13.933 5.66904 12 5.66904ZM10 9.16904C10 8.06448 10.8954 7.16904 12 7.16904C13.1046 7.16904 14 8.06448 14 9.16904C14 10.2736 13.1046 11.169 12 11.169C10.8954 11.169 10 10.2736 10 9.16904Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.9823 1.92237C10.9288 1.92157 9.88791 2.15056 8.93311 2.59334C7.97869 3.03595 7.13342 3.68147 6.45731 4.48464C5.36481 5.77432 4.77006 7.40891 4.78084 9.09558V9.29169L4.78113 9.30195C4.81076 10.3843 5.05567 11.45 5.50161 12.4378C6.11223 13.8034 7.06674 14.9807 7.94001 16.0579C8.13551 16.299 8.32697 16.5352 8.50956 16.7673L8.52276 16.7841L8.5369 16.8001C9.50316 17.894 10.2146 19.1852 10.6212 20.5818C10.6393 20.6442 10.6554 20.7051 10.6712 20.7647C10.7444 21.0418 10.81 21.2903 11.039 21.5175C11.2948 21.7715 11.5158 21.9157 11.9949 21.9157C12.2502 21.9157 12.6798 21.8298 12.9728 21.5175C13.208 21.2669 13.3074 20.9124 13.3416 20.7903C13.346 20.7747 13.3493 20.7629 13.3517 20.7556C13.3736 20.6886 13.4064 20.5818 13.4064 20.5818C13.7274 18.9595 14.7707 17.6763 15.7838 16.4302C15.8659 16.3293 15.9477 16.2286 16.0289 16.1281C16.0983 16.0422 16.1744 15.9507 16.2515 15.8581C16.3454 15.7453 16.4407 15.6308 16.5271 15.5224C17.8554 13.8562 19.1613 11.9788 19.2191 9.29758L19.2193 9.2895V9.09378C19.2216 7.93985 18.942 6.80272 18.4049 5.77998C17.9653 4.94299 17.3631 4.20109 16.6336 3.59691C15.9046 2.99318 15.0627 2.53885 14.1566 2.25985C13.454 2.03968 12.722 1.92592 11.9853 1.92237L11.9823 1.92237ZM4.78084 9.09558V9.09311L4.78086 9.09818L4.78084 9.09558ZM9.56417 3.95414C10.3201 3.60356 11.1447 3.42195 11.9796 3.42236C12.5667 3.42535 13.1499 3.51618 13.7096 3.69173L13.7136 3.69294C14.4324 3.91404 15.0996 4.27414 15.6768 4.75218C16.2541 5.23021 16.7298 5.81667 17.077 6.47753C17.5009 7.28483 17.7212 8.18175 17.7193 9.09151L17.7193 9.09311V9.27311C17.6706 11.4171 16.6118 12.9794 15.3085 14.6143C15.16 14.8005 15.0073 14.9886 14.8525 15.1793C13.7406 16.5488 12.5208 18.0513 11.9949 19.9424C11.5194 18.4244 10.7295 17.0212 9.67542 15.8232C9.4675 15.5592 9.26035 15.303 9.05675 15.0512C8.19282 13.9827 7.39294 12.9934 6.87045 11.8243L6.86923 11.8216C6.50613 11.0178 6.30626 10.151 6.28084 9.27088L6.28086 9.09311L6.28083 9.08804C6.27184 7.75989 6.73999 6.47123 7.60252 5.4534L7.60419 5.45142C8.13872 4.8162 8.80775 4.30492 9.56417 3.95414Z", fill: "black" } })]);
}, eu = [], tu = /* @__PURE__ */ S(
  qc,
  Jc,
  eu,
  !1,
  null,
  "52277189"
);
const su = tu.exports, qi = 150;
let Fs = {};
const iu = {
  name: "LegendSection",
  components: {
    PinModeSVG: su,
    ViewZoneSVG: Xr,
    QuizSVG: Wc,
    Slider: Zr,
    Toggle: ps
  },
  data() {
    return {
      defaultMinSize: 0,
      lastMinSize: null,
      isFontAuto: !0,
      mouseDownInterval: null,
      buttonMoreIsPressed: !1,
      buttonLessIsPressed: !1,
      timeoutChangeFontSize: null
    };
  },
  computed: {
    isQuizMode() {
      return this.$store.getters["anatomy/isQuizMode"];
    },
    viewZoneEnabled() {
      return this.$store.getters["anatomy/viewZoneEnabled"];
    },
    isPinMode() {
      return this.$store.getters["anatomy/pinModeEnabled"];
    },
    currentFontSize() {
      return this.$store.getters["anatomy/getFontSize"];
    }
  },
  created() {
    const { quiz: s, viewzone: e, ui: t, application: i, pinMode: r } = z;
    Fs = h.createHooks([
      {
        on: i.READY,
        do: () => this.init()
      },
      {
        on: s.CHANGE,
        do: () => this.$store.dispatch("anatomy/quiz:refreshState")
      },
      {
        on: e.CHANGE,
        do: () => this.$store.dispatch("anatomy/viewZone:refreshState")
      },
      {
        on: r.CHANGE,
        do: () => this.$store.dispatch("anatomy/pin:refreshState")
      },
      {
        on: t.SETTINGS.RESET,
        do: () => this.reset()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Fs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Fs);
  },
  methods: {
    setFontToManual() {
      this.isFontAuto && (this.isFontAuto = !1, this.$store.dispatch("anatomy/font-size:manual"), this.$store.dispatch("anatomy/font-size:update"));
    },
    setFontAuto() {
      this.isFontAuto || (this.isFontAuto = !0, this.$store.dispatch("anatomy/font-size:auto"));
    },
    upFontSize() {
      this.buttonMoreIsPressed = !0, this.setFontSize(!0), this.mouseDownInterval = setInterval(
        () => this.setFontSize(!0),
        qi
      ), document.addEventListener("mouseup", this.mouseUp);
    },
    downFontSize() {
      this.buttonLessIsPressed = !0, this.setFontSize(), this.mouseDownInterval = setInterval(
        () => this.setFontSize(),
        qi
      ), document.addEventListener("mouseup", this.mouseUp);
    },
    mouseUp() {
      this.buttonLessIsPressed = !1, this.buttonMoreIsPressed = !1, clearInterval(this.mouseDownInterval), document.removeEventListener("mouseup", this.mouseUp);
    },
    setFontSize(s = !1) {
      const e = this.currentFontSize;
      this.$store.dispatch(
        "anatomy/font-size:set",
        s === !0 ? e + 1 : e - 1
      ), this.timeoutChangeFontSize !== null && clearTimeout(this.timeoutChangeFontSize), this.timeoutChangeFontSize = setTimeout(() => {
        this.$store.dispatch("anatomy/font-size:notification", e);
      }, 1e3);
    },
    toggleQuizMode() {
      this.isPinMode || this.$store.dispatch("anatomy/quiz:toggle");
    },
    toggleViewZone() {
      this.isPinMode || (this.$store.getters["anatomy/featureHidePointWithoutLabelIsActive"] && this.$store.dispatch("anatomy/hide-point-feature:toggle"), this.$store.dispatch(
        "anatomy/viewZone:centered-toggle",
        ie.RIGHT_MENU
      ));
    },
    togglePinMode() {
      this.isQuizMode && this.toggleQuizMode(), this.viewZoneEnabled && this.toggleViewZone(), G.add(Q.PIN_MODE, !this.isPinMode), this.$store.dispatch("anatomy/pin:toggle");
    },
    init() {
      G.remove(Q.FONT_SIZE), (G.get(Q.PIN_MODE) || !1) !== this.isPinMode && this.togglePinMode();
    },
    reset() {
      this.isQuizMode && this.toggleQuizMode(), this.viewZoneEnabled && this.toggleViewZone(), this.isPinMode && this.togglePinMode(), this.isFontAuto || this.setFontAuto(), G.remove(Q.PIN_MODE);
    }
  }
};
var ru = function() {
  var e = this, t = e._self._c;
  return t("div", [t("span", { staticClass: "title-section" }, [e._v(" " + e._s(e.$t("menu.legend.section-title")) + " ")]), t("ul", [t("li", { staticClass: "list-li", attrs: { title: `${e.$t("keyboard-panel.practice")} (P)` } }, [t("div", { staticClass: "list-item" }, [t("span", [t("QuizSVG"), e._v(" " + e._s(e.$t("menu.legend.practice")) + " ")], 1), t("toggle", { attrs: { "is-active": e.isQuizMode, disabled: e.isPinMode }, on: { click: e.toggleQuizMode } })], 1)]), t("li", { staticClass: "list-li", attrs: { title: e.$t("menu.legend.pins") } }, [t("div", { staticClass: "list-item" }, [t("span", [t("PinModeSVG"), e._v(" " + e._s(e.$t("menu.legend.pins")) + " ")], 1), t("toggle", { attrs: { "is-active": e.isPinMode }, on: { click: e.togglePinMode } })], 1)]), t("li", { staticClass: "list-li", attrs: { title: `${e.$t("keyboard-panel.viewzone")} (M)` } }, [t("div", { staticClass: "list-item" }, [t("span", [t("ViewZoneSVG"), e._v(" " + e._s(e.$t("menu.legend.viewzone")) + " ")], 1), t("toggle", { attrs: { "is-active": e.viewZoneEnabled, disabled: e.isPinMode }, on: { click: e.toggleViewZone } })], 1)]), t("li", { staticClass: "list-li" }, [t("div", { staticClass: "list-li-content setting-font" }, [t("div", { staticClass: "setting-font-label-container" }, [t("p", [e._v(e._s(e.$t("menu.legend.font-size")))]), t("div", { staticClass: "button-font-mode-container" }, [t("button", { staticClass: "button-font-mode left", class: { "selected-button": e.isFontAuto }, on: { click: e.setFontAuto } }, [e._v(" Auto ")]), t("button", { staticClass: "button-font-mode right", class: { "selected-button": !e.isFontAuto }, on: { click: e.setFontToManual } }, [e._m(0)])])]), e.isFontAuto ? e._e() : t("div", { staticClass: "manual-font-button-container" }, [t("button", { staticClass: "button-change-font left button-less", class: { pressed: e.buttonLessIsPressed }, on: { mousedown: e.downFontSize } }, [e._v(" A ")]), t("span", { staticClass: "button-change-font center" }, [e._v(e._s(e.currentFontSize))]), t("button", { staticClass: "button-change-font right button-more", class: { pressed: e.buttonMoreIsPressed }, on: { mousedown: e.upFontSize } }, [e._v(" A ")])])])])])]);
}, nu = [function() {
  var s = this, e = s._self._c;
  return e("div", { staticClass: "letters-container" }, [e("span", { staticClass: "small-letter" }, [s._v("A")]), e("span", [s._v("A")])]);
}], au = /* @__PURE__ */ S(
  iu,
  ru,
  nu,
  !1,
  null,
  "3605f942"
);
const ou = au.exports, lu = {
  name: "SingleArrowSVG"
};
var cu = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M15.5355 20.6621C15.8284 20.955 16.3033 20.955 16.5962 20.6621C16.8891 20.3692 16.8891 19.8943 16.5962 19.6014C16.5962 19.6014 11.6674 14.6787 8.99175 12.003L16.5962 4.39861C16.8891 4.10571 16.8891 3.63084 16.5962 3.33795C16.3033 3.04506 15.8284 3.04506 15.5355 3.33795L7.4038 11.4697C7.11091 11.7626 7.11091 12.2374 7.4038 12.5303L15.5355 20.6621Z", fill: "black" } })]);
}, uu = [], du = /* @__PURE__ */ S(
  lu,
  cu,
  uu,
  !1,
  null,
  "4d7b28e5"
);
const Qr = du.exports, hu = {
  name: "CloseSVG"
};
var mu = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24" } }, [t("path", { attrs: { "fill-rule": "evenodd", d: "M19.8 5.3a.7.7 0 0 0-1-1L12 11 5.3 4.3a.8.8 0 0 0-1 1l6.6 6.7-6.7 6.7a.8.8 0 0 0 1.1 1l6.7-6.6 6.7 6.7a.7.7 0 1 0 1-1L13.2 12l6.7-6.7Z", "clip-rule": "evenodd" } })]);
}, fu = [], pu = /* @__PURE__ */ S(
  hu,
  mu,
  fu,
  !1,
  null,
  "d07bdb9d"
);
const $e = pu.exports, gu = {
  name: "Pin-pinnedSVG"
};
var vu = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24" } }, [t("path", { attrs: { fill: "currentColor", d: "M18.15 15.13h-5.38l-.02 6.06a.75.75 0 0 1-1.5 0l.02-6.07H5.93a.76.76 0 0 1-.75-.9 7.59 7.59 0 0 1 1.53-3.32C7.63 9.74 8.8 8.27 9 8V4.56L7.46 3.7A.9.9 0 0 1 7.91 2h8.15a.91.91 0 0 1 .45 1.7L15 4.56V8c.12.21 1.33 1.7 2.3 2.89.8.97 1.35 2.14 1.57 3.38a.73.73 0 0 1-.72.86Z" } })]);
}, yu = [], Eu = /* @__PURE__ */ S(
  gu,
  vu,
  yu,
  !1,
  null,
  "e64bc23d"
);
const Ji = Eu.exports;
let zs = {};
const Iu = {
  name: "Menu",
  components: {
    IconButton: Ur,
    CloseSVG: $e,
    LegendSection: ou,
    AdvancedSettingsSection: Uc,
    LanguageSection: Hc,
    DisplaySection: Lc,
    SeriesSection: Jl,
    ContrastSection: Vl,
    TransformationSection: Hl,
    FilterSection: hl,
    MenuSVG: Br,
    PinSVG: wi,
    SingleArrowSVG: Qr,
    PinPinnedSVG: Ji
  },
  directives: { ClickOutside: De },
  inject: ["container"],
  data: () => ({
    wasPinnedBeforeResized: !1,
    waitEventClickOutside: !1,
    orientationVertical: Je.VERTICAL,
    orientationHorizontal: Je.HORIZONTAL,
    oldSize: null
  }),
  computed: {
    pinIcon() {
      return this.isMenuPinned ? Ji : wi;
    },
    CloseSVG() {
      return $e;
    },
    isReady() {
      return this.$store.state.anatomy.isReady;
    },
    otherSeriesHaveContrast() {
      return this.$store.getters["anatomy/otherSeriesHaveMoreThanOneContrast"];
    },
    contrasts() {
      return this.$store.getters["anatomy/contrasts"];
    },
    displaySeries() {
      return this.$store.getters["anatomy/listSeries"].length > 1;
    },
    isMobileScreen() {
      return h.isMobileScreen();
    },
    isDesktopScreen() {
      return h.isDesktopScreen();
    },
    isLargeTabletScreen() {
      return h.isLargeTabletScreen();
    },
    isMenuPinned() {
      return this.$store.state.menu.menuIsPinned;
    },
    isMenuOpen() {
      return this.$store.state.menu.menuIsOpen;
    }
  },
  created() {
    const { application: s, ui: e } = z;
    zs = h.createHooks([
      {
        on: "resize",
        do: () => this.resize(),
        target: window
      },
      {
        on: s.READY,
        do: () => this.initialize()
      },
      {
        on: s.RESIZED,
        do: () => this.resize()
      },
      {
        on: e.SETTINGS.RESET,
        do: () => {
          G.remove(Q.MENU_OPEN), this.isMenuOpen || this.toggleMenu();
        }
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(zs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(zs);
  },
  methods: {
    /**
     * @param [override] {boolean}
     */
    toggleMenu(s = null) {
      this.$store.dispatch("menu/menu:toggle", s);
    },
    closeUnpinnedMenu() {
      !this.waitEventClickOutside && this.isMenuOpen && !this.isMenuPinned && this.toggleMenu();
    },
    /**
     *
     * @param [saveInStorage=true] save the pin state to localstorage
     * @param [override] force a value for the pin state (toggle the current one if absent)
     */
    togglePin(s = !0, e) {
      this.$store.dispatch("menu/menu-pin:toggle", e), s && G.add(Q.MENU_OPEN, this.isMenuPinned);
    },
    initialize() {
      (G.get(Q.MENU_OPEN) ?? !0) && (this.isLargeTabletScreen ? this.wasPinnedBeforeResized = !0 : (this.togglePin(!1, !0), this.toggleMenu())), this.$store.dispatch("anatomy/send-notification", z.ui.VIEWER.MENU_INITIALIZED);
    },
    resize() {
      this.isLargeTabletScreen && this.isMenuPinned && (this.togglePin(!1, !1), this.toggleMenu(!1), this.wasPinnedBeforeResized = !0), !this.isLargeTabletScreen && this.wasPinnedBeforeResized && (this.wasPinnedBeforeResized = !1, this.$nextTick(() => {
        this.toggleMenu(!0), this.togglePin(!1, !0);
      }));
    }
  }
};
var Cu = function() {
  var e = this, t = e._self._c;
  return t("nav", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.closeUnpinnedMenu, expression: "closeUnpinnedMenu" }], ref: "menu", staticClass: "navigation menu-viewer", class: {
    pinned: e.isMenuPinned,
    "box-shadow-menu": e.isMenuOpen,
    "small-screen": e.isMobileScreen,
    "large-tablet-screen": e.isLargeTabletScreen,
    "desktop-screen": e.isDesktopScreen,
    hide: !e.isMenuOpen,
    show: e.isMenuOpen
  } }, [t("div", { staticClass: "menu-title" }, [t("span", { staticClass: "title" }, [e._v(e._s(e.$t("menu.main.section-title")))]), e.isLargeTabletScreen ? e._e() : t("IconButton", { staticClass: "secondary", attrs: { icon: e.pinIcon, "is-pressed": e.isMenuPinned }, on: { click: function(i) {
    return e.togglePin(!0);
  } } }), t("IconButton", { attrs: { icon: e.CloseSVG }, on: { click: function(i) {
    return e.toggleMenu(!1);
  } } })], 1), e.isReady ? t("ul", { staticClass: "menu-content" }, [e.contrasts !== null && (e.contrasts.length > 1 || e.otherSeriesHaveContrast) ? t("li", [t("contrast-section")], 1) : e._e(), t("li", [t("filter-section", { attrs: { "is-visible": e.isMenuOpen } })], 1), t("li", [t("transformation-section")], 1), t("li", { directives: [{ name: "show", rawName: "v-show", value: e.displaySeries, expression: "displaySeries" }] }, [t("series-section")], 1), t("li", [t("legend-section")], 1), t("li", [t("display-section", { ref: "display-section" })], 1), t("li", { staticClass: "have-separator" }, [t("language-section")], 1), t("li", [t("advanced-settings-section")], 1)]) : e._e()]);
}, _u = [], Tu = /* @__PURE__ */ S(
  Iu,
  Cu,
  _u,
  !1,
  null,
  null
);
const Su = Tu.exports, bu = {
  name: "ToggleDisplayCRSVG"
};
var Au = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16" } }, [t("path", { attrs: { d: "M13.3 5a1 1 0 0 0-1.4 0L8 8.9 4.1 5a1 1 0 0 0-1.4 1.4l3.9 3.9c.7.7 1 1 1.4 1 .4 0 .7-.3 1.4-1l3.9-3.9c.4-.4.4-1 0-1.4Z" } })]);
}, wu = [], Lu = /* @__PURE__ */ S(
  bu,
  Au,
  wu,
  !1,
  null,
  "a06b9acd"
);
const Kr = Lu.exports, rs = {
  drawCrossReferencesIndicator(s, e, t, i) {
    this.resetCrossReferencesIndicator(s, e, t);
    const r = t.getContext("2d");
    r.clearRect(0, 0, t.width, t.height), r.beginPath(), r.strokeStyle = h.getCSSVariable("--color-imaios") || `#${me.IMAIOS}`, r.lineWidth = Math.max(Math.abs(e.naturalWidth / e.clientWidth), 2), i.path === null ? (r.moveTo(i.pt1x, i.pt1y), r.lineTo(i.pt2x, i.pt2y)) : i.path.forEach((n) => {
      switch (n.type) {
        case 1:
          r.moveTo(n.pts[0], n.pts[1]);
          break;
        case 2:
          r.lineTo(n.pts[0], n.pts[1]);
          break;
        case 3:
          r.quadraticCurveTo(n.pts[0], n.pts[1], n.pts[2], n.pts[3]);
          break;
        case 6:
          r.bezierCurveTo(
            n.pts[0],
            n.pts[1],
            n.pts[2],
            n.pts[3],
            n.pts[4],
            n.pts[5]
          );
          break;
      }
    }), r.stroke();
  },
  resetCrossReferencesIndicator(s, e, t) {
    const i = t.getContext("2d");
    t.style.width = `${e.clientWidth}px`, t.style.height = `${e.clientHeight}px`, i.clearRect(0, 0, t.width, t.height);
  }
}, Ou = {
  name: "LoaderCube",
  props: ["messageLabel"]
};
var Mu = function() {
  var e = this, t = e._self._c;
  return t("div", [t("p", { staticClass: "loader-message" }, [e._v(e._s(e.messageLabel))]), e._m(0)]);
}, Nu = [function() {
  var s = this, e = s._self._c;
  return e("div", { staticClass: "loader-cube" }, [e("span", { attrs: { id: "box" } }), e("span", { attrs: { id: "shadow" } })]);
}], Ru = /* @__PURE__ */ S(
  Ou,
  Mu,
  Nu,
  !1,
  null,
  "141d1fae"
);
const bi = Ru.exports;
let Bs = {};
const xu = 20, Du = 10, Pu = 200, ku = 0.12, Hu = 0.2, Fu = 10, zu = {
  name: "CrossReferences",
  components: {
    ToggleDisplayCRSVG: Kr,
    LoaderCube: bi
  },
  inject: ["viewer"],
  data() {
    return {
      isDragging: !1,
      currentCR: null,
      currentCRNameId: null,
      isFirstRendering: !0,
      hasBeenMove: !1,
      hasBeenAlreadyMove: !1,
      isOpen: !1,
      hoveredCR: null,
      isLoading: !1,
      hasBeenLoad: !1,
      timeoutLoading: null
    };
  },
  computed: {
    crossReferences() {
      return this.$store.getters["cross-references/cross-references"];
    },
    displayCR() {
      return this.$store.getters["menu/displayCrossReferencesPanel"];
    },
    isDesktopScreen() {
      return h.isDesktopScreen();
    },
    crossRefExists() {
      return this.$store.getters["anatomy/crossRefExists"];
    },
    templateRows() {
      return `repeat(auto-fit, calc(${100 / this.crossReferences.length}% - 40px))`;
    }
  },
  watch: {
    displayCR(s) {
      s.display && !this.isOpen ? this.open(s.saveState) : !s.display && this.isOpen && this.close(s.saveState);
    }
  },
  created() {
    const {
      series: s,
      slice: e,
      language: t,
      ui: i,
      application: r
    } = z;
    Bs = h.createHooks([
      {
        on: r.RESIZED,
        do: () => {
          !this.isFirstRendering && this.crossRefExists && this.updateContainer();
        }
      },
      {
        on: "resize",
        do: () => {
          !this.isFirstRendering && this.crossRefExists && this.updateContainer();
        },
        target: window
      },
      {
        on: s.CHANGE,
        do: () => {
          this.$store.getters["anatomy/series:have-same-cr"]() || (this.timeoutLoading !== null && clearTimeout(this.timeoutLoading), this.hasBeenLoad = !1, this.timeoutLoading = setTimeout(() => {
            this.crossRefExists && !this.hasBeenLoad && (this.isLoading = !0);
          }, 100)), this.$store.dispatch("cross-references/cross-references:get").then(() => {
            this.hasBeenLoad = !0, this.isLoading = !1, this.$store.dispatch("cross-references/cross-references:draw-indicators"), this.isFirstRendering = !1, typeof this.$refs.crossRefs < "u" && this.initializeCrossReferences(this.$store.getters["menu/structurePanelIsOpen"]);
          });
        }
      },
      {
        on: t.CHANGE,
        do: () => this.$store.dispatch("cross-references/cross-references:get")
      },
      {
        on: e.CHANGE,
        do: () => {
          !this.isFirstRendering && this.crossRefExists && (this.$store.dispatch("cross-references/cross-references:draw-indicators"), this.drawCrossRefLine());
        }
      },
      {
        on: i.THEME.SWITCH,
        do: () => {
          !this.isFirstRendering && this.crossRefExists && this.drawCrossRefLine();
        }
      },
      {
        on: i.SETTINGS.RESET,
        do: () => {
          G.remove(Q.CROSS_REFERENCES), this.initializeCrossReferences();
        }
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Bs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Bs);
  },
  methods: {
    getMaxHeightImage() {
      const s = this.$refs["crossRef-container-list"];
      return s !== null ? `${s.clientHeight / this.crossReferences.length - xu * this.crossReferences.length}px` : "100%";
    },
    setSizeImage() {
      const s = this.crossReferences, e = this.getMaxHeightImage(), t = this.getMaxWidth();
      this.$refs.crossRefs.forEach((i, r) => {
        const n = h.getFirstChildElementByTag(i, "img"), a = h.getFirstChildElementByTag(i, "canvas");
        n.style.maxHeight = e, n.style.maxWidth = `${t}px`;
        const o = s[r].ratio, l = parseFloat(n.style.maxHeight), c = t / l;
        if (n.width = a.width, n.height = a.height, Math.abs(c - o) < 0.05)
          n.style.width = t, n.style.height = l;
        else {
          let u = t, m = u / o;
          m < l && Math.abs(u / m - o) < 0.05 ? (n.style.width = `${u}px`, n.style.height = `${m}px`) : (m = l, u = m * o, u < t && Math.abs(u / m - o) < 0.05 && (n.style.width = `${u}px`, n.style.height = `${m}px`));
        }
      });
    },
    updateContainer() {
      this.setSizeImage(), this.drawCrossRefLine();
    },
    getMaxWidth() {
      const e = this.viewer.value.parentNode.offsetWidth;
      return Math.round(
        Math.min(
          Math.max(
            Pu,
            e * ku
          ),
          e * Hu
        )
      ) - Du;
    },
    open() {
      this.isOpen = !0, this.updateContainer(), G.add(Q.CROSS_REFERENCES, !0);
    },
    close(s = !0) {
      this.isOpen = !1, s && G.add(Q.CROSS_REFERENCES, !1);
    },
    initializeCrossReferences(s = !1) {
      const e = this.$store.getters["anatomy/currentSeries"];
      if (e !== null && typeof e.cross_references_titles < "u" && e.cross_references_titles.length > 0 && h.breakPointCrossReferences()) {
        const t = G.get(Q.CROSS_REFERENCES) ?? !0;
        s !== !0 && (t && !this.isOpen || !t && this.isOpen) && this.$store.dispatch("menu/cross-references:toggle");
      }
      this.$store.dispatch("menu/cross-references-button:authorize-to-display", this.crossRefExists), this.$store.dispatch("anatomy/send-notification", z.ui.VIEWER.CROSS_REFERENCES_INITIALIZED);
    },
    drawCrossRefLine() {
      const s = this.$store.getters["cross-references/cross-references-indicators"];
      this.$nextTick().then(() => {
        s.length > 0 ? this.$refs.crossRefs.forEach((e) => {
          const t = h.getFirstChildElementByTag(e, "canvas"), i = h.getFirstChildElementByTag(e, "img"), r = s.find((n) => n.sort_order === parseInt(t.dataset.index)) || null;
          r !== null ? i.width === 0 ? i.onload = () => {
            rs.drawCrossReferencesIndicator(e, i, t, r);
          } : rs.drawCrossReferencesIndicator(e, i, t, r) : rs.resetCrossReferencesIndicator(e, i, t);
        }) : this.$refs.crossRefs.forEach((e) => {
          const t = h.getFirstChildElementByTag(e, "canvas"), i = h.getFirstChildElementByTag(e, "img");
          rs.resetCrossReferencesIndicator(e, i, t);
        });
      });
    },
    goToSeries(s) {
      s !== 0 && this.$store.dispatch("anatomy/series:set", {
        seriesIndex: s,
        keepMode: !0
      });
    },
    mousemove(s, e) {
      const t = parseInt(s.target.dataset.index), i = s.target.getBoundingClientRect(), r = {
        x: s.x - i.left,
        y: s.y - i.top
      }, n = this.$store.getters["anatomy/slices"], a = this.$store.getters["anatomy/currentSeries"];
      n.filter((u) => u.series_id === a.id).sort((u, m) => u.sort_order - m.sort_order);
      const l = this.$store.getters["anatomy/currentSlice"], c = e.sort_order - 1;
      if (l.crossReferencesLines.length > 0 && typeof l.crossReferencesLines[c] < "u" && (l.crossReferencesLines[c].path === null || l.crossReferencesLines[c].path.length === 2)) {
        const u = l.crossReferencesLines.find((m) => m.sort_order === t);
        this.isValidCRLine(u) && this.getDistanceIndicator(u, r, s) <= Fu ? this.hoveredCR = e.name : this.hoveredCR = null;
      }
    },
    getDistanceIndicator(s, e, t) {
      const i = Xe.getOne(e.x, e.y), r = Xe.getOne(), n = Xe.getOne();
      this.crLineHaveValidPath(s) && (r.set(
        s.path[0].pts[0] / t.target.width * t.target.clientWidth,
        s.path[0].pts[1] / t.target.height * t.target.clientHeight
      ), n.set(
        s.path[1].pts[0] / t.target.width * t.target.clientWidth,
        s.path[1].pts[1] / t.target.height * t.target.clientHeight
      ));
      const a = Dt.distancePointToLine2D(i, r, n);
      return i.recycle(), r.recycle(), n.recycle(), a;
    },
    mousedown(s, e) {
      s.preventDefault(), this.currentCR = s.target.id, this.currentCRNameId = s.target.dataset.name_id, this.hoveredCR === e.name ? (this.isDragging = !0, this.indicatorDrag(s), document.onmouseup = this.endIndicatorDrag, document.addEventListener("mousemove", this.indicatorDrag)) : document.onmouseup = (t) => {
        t.target.id === this.currentCR && (this.$store.dispatch("anatomy/slice:notification", ie.CROSS_REFERENCES), this.goToSeries(e.destination)), this.endIndicatorDrag();
      };
    },
    endIndicatorDrag() {
      this.isDragging = !1, this.currentCR = null, document.removeEventListener("mousemove", this.indicatorDrag), document.onmouseup = () => {
      };
    },
    indicatorDrag(s) {
      if (this.isDragging && s.target.id === this.currentCR) {
        s.preventDefault();
        const e = s.target.getBoundingClientRect(), t = {
          x: s.x - e.left,
          y: s.y - e.top
        }, i = parseInt(s.target.dataset.index);
        let r = this.$store.getters["anatomy/slices"];
        const n = this.$store.getters["anatomy/currentSeries"];
        if (!this.$store.getters["anatomy/series:have-same-cr"]())
          r = r.filter((u) => u.series_id === n.id);
        else {
          const u = this.$store.getters["anatomy/series:get-list-series-with-same-cr"](this.currentCRNameId);
          r = r.filter((m) => u.includes(m.series_id));
        }
        r.sort((u, m) => u.sort_order - m.sort_order);
        const a = this.$store.getters["anatomy/relativeSliceIndexById"](r[r.length - 1].id);
        let o = 1 / 0, l, c = this.$store.getters["anatomy/currentSlice"].id;
        r.forEach((u) => {
          const m = u.crossReferencesLines.find((g) => g.sort_order === i);
          if (m.path === null || m.path.length === 2) {
            const g = this.getDistanceIndicator(m, t, s);
            g < o && (o = g, c = u.id);
          }
        }), l = this.$store.getters["anatomy/relativeSliceIndexById"](c), l = Math.max(
          1,
          Math.min(
            l,
            a
          )
        ), this.$store.dispatch("anatomy/slice:set", {
          sliceIndex: l,
          placement: ie.CROSS_REFERENCES_DRAG
        });
      }
    },
    isValidCRLine(s) {
      return this.crLineHaveValidPath(s);
    },
    crLineHaveValidPath(s) {
      return typeof s < "u" && typeof s.path < "u" && s.path.length >= 2 && s.path.every((e) => e.pts.length >= 2);
    }
  }
};
var Bu = function() {
  var e = this, t = e._self._c;
  return t("Transition", { attrs: { name: "slide-left" } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isOpen, expression: "isOpen" }], ref: "crossRef-container", staticClass: "cross-references-container" }, [t("div", { ref: "crossRef-container-list", staticClass: "cross-ref-container-list", style: {
    "grid-template-rows": e.templateRows
  } }, [e._l(e.crossReferences, function(i) {
    return t("div", { key: i.sort_order, ref: "crossRefs", refInFor: !0, staticClass: "cross-ref" }, [t("p", { directives: [{ name: "show", rawName: "v-show", value: !e.isLoading, expression: "!isLoading" }], staticClass: "cross-references-title", class: { link: i.destination !== 0, "desktop-screen": e.isDesktopScreen }, on: { click: function(r) {
      return e.goToSeries(i.destination);
    } } }, [e._v(" " + e._s(i.name) + " ")]), t("canvas", { directives: [{ name: "show", rawName: "v-show", value: !e.isLoading, expression: "!isLoading" }], staticClass: "line", class: { dragging: e.isDragging, link: i.destination !== 0, drag: e.hoveredCR === i.name }, attrs: { id: i.name, "data-index": i.sort_order, "data-name_id": i.name_id, height: i.imageDimensions.height, width: i.imageDimensions.width }, on: { mousedown: (r) => e.mousedown(r, i), mousemove: (r) => e.mousemove(r, i) } }), t("img", { class: { "image-hidden": e.isLoading }, attrs: { alt: i.name, src: i.src } })]);
  }), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isLoading, expression: "isLoading" }], staticClass: "loader" }, [t("LoaderCube", { attrs: { "message-label": e.$t("loader.loading") } })], 1)], 2)])]);
}, $u = [], Uu = /* @__PURE__ */ S(
  zu,
  Bu,
  $u,
  !1,
  null,
  null
);
const Vu = Uu.exports, Gu = {
  name: "GallerySVG"
};
var ju = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V9C4.5 9.27614 4.72386 9.5 5 9.5H9C9.27614 9.5 9.5 9.27614 9.5 9V5C9.5 4.72386 9.27614 4.5 9 4.5ZM5 3C3.89543 3 3 3.89543 3 5V9C3 10.1046 3.89543 11 5 11H9C10.1046 11 11 10.1046 11 9V5C11 3.89543 10.1046 3 9 3H5Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V9C14.5 9.27614 14.7239 9.5 15 9.5H19C19.2761 9.5 19.5 9.27614 19.5 9V5C19.5 4.72386 19.2761 4.5 19 4.5ZM15 3C13.8954 3 13 3.89543 13 5V9C13 10.1046 13.8954 11 15 11H19C20.1046 11 21 10.1046 21 9V5C21 3.89543 20.1046 3 19 3H15Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19 14.5H15C14.7239 14.5 14.5 14.7239 14.5 15V19C14.5 19.2761 14.7239 19.5 15 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V15C19.5 14.7239 19.2761 14.5 19 14.5ZM15 13C13.8954 13 13 13.8954 13 15V19C13 20.1046 13.8954 21 15 21H19C20.1046 21 21 20.1046 21 19V15C21 13.8954 20.1046 13 19 13H15Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 14.5H5C4.72386 14.5 4.5 14.7239 4.5 15V19C4.5 19.2761 4.72386 19.5 5 19.5H9C9.27614 19.5 9.5 19.2761 9.5 19V15C9.5 14.7239 9.27614 14.5 9 14.5ZM5 13C3.89543 13 3 13.8954 3 15V19C3 20.1046 3.89543 21 5 21H9C10.1046 21 11 20.1046 11 19V15C11 13.8954 10.1046 13 9 13H5Z", fill: "black" } })]);
}, Yu = [], Wu = /* @__PURE__ */ S(
  Gu,
  ju,
  Yu,
  !1,
  null,
  "12a2b9f5"
);
const qr = Wu.exports;
let $s = {};
const Zu = {
  name: "GalleryLeft",
  components: {
    SingleArrowSVG: Qr,
    GallerySVG: qr,
    CloseSVG: $e
  },
  data() {
    return {
      isReady: !1,
      hasBeenInitialized: !1,
      seriesSelected: [],
      seriesOpen: !1
    };
  },
  computed: {
    mainTitle() {
      return this.seriesOpen ? this.seriesSelected.length === this.series.length ? this.$t("gallery.all-series") : this.seriesSelected[0].name : this.$store.getters["anatomy/getModuleShortName"]();
    },
    secondaryTitle() {
      if (this.seriesOpen)
        return this.seriesSelected.length === this.series.length ? this.$t("gallery.n-image-s", { count: this.numberMaxSlices }) : this.$t("gallery.n-image-s", { count: this.seriesSelected[0].number_of_images });
      if (!this.hideTitleSlice)
        return `(${this.$store.getters["anatomy/getAlternativeModality"]()})`;
    },
    galleryIsOpen() {
      const s = this.$store.getters["menu/galleryLeftIsOpen"];
      return s && this.openGallery(), s;
    },
    series() {
      return this.$store.getters["anatomy/seriesGallery"];
    },
    imagesAllSeries() {
      return this.$store.getters["anatomy/imageAllSeries"];
    },
    numberMaxSlices() {
      return this.$store.getters["anatomy/numberMaxSlices"];
    },
    slices() {
      return this.$store.getters["anatomy/slicesGallery"].filter((e) => {
        if (this.seriesSelected.map((t) => t.id).includes(e.series_id))
          return e;
      });
    },
    hideTitleSlice() {
      return this.series.length > 1 ? !Kn.includes(this.series[0].modality_id) : !0;
    },
    currentSeries() {
      let s = {
        name: "",
        number_of_images: 0
      };
      return this.seriesSelected.length === this.series.length ? (s.name = this.$t("gallery.all-series"), s.number_of_images = this.numberMaxSlices) : this.seriesSelected.length > 0 && (s = this.seriesSelected[0]), s;
    },
    isTabletScreen() {
      return h.isTabletScreen();
    }
  },
  created() {
    const { application: s } = z;
    $s = h.createHooks([
      {
        on: s.RESIZED,
        do: () => this.setPositionAndSizeOfGallery()
      },
      {
        on: "resize",
        do: () => this.setPositionAndSizeOfGallery(),
        target: window
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount($s);
  },
  beforeUnmount() {
    h.onBeforeUnmount($s);
  },
  methods: {
    back() {
      this.seriesOpen || this.hideGallery(), this.seriesOpen = !1;
    },
    openGallery() {
      this.hasBeenInitialized || Promise.all([
        this.$store.dispatch("anatomy/gallery:series-update"),
        this.$store.dispatch("anatomy/gallery:slice-update")
      ]).then(() => {
        this.hasBeenInitialized = !0, this.seriesSelected = [...this.series];
      }), this.setPositionAndSizeOfGallery();
    },
    hideGallery() {
      this.$store.dispatch("menu/gallery-left:hide"), this.seriesOpen = !1;
    },
    setPositionAndSizeOfGallery() {
      const s = this.$refs["gallery-overlay"];
      s.style.width = `${this.$store.getters["viewer/viewer-width"]}px`, s.style.height = `${this.$store.getters["viewer/viewer-height"]}px`;
    },
    isSelected(s) {
      return this.series.length === 1 ? !0 : s === yr ? this.seriesSelected.length === this.series.length : this.seriesSelected.length !== this.series.length && this.seriesSelected.findIndex((e) => e.id === s) !== -1;
    },
    selectAllSeries() {
      this.seriesSelected = [...this.series], this.seriesOpen = !0;
    },
    selectSeries(s) {
      this.seriesSelected = this.series.filter((e) => e.id === s), this.seriesOpen = !0;
    },
    moveToSlice(s) {
      let e = -1;
      const t = this.slices.findIndex((r) => s.id === r.id) + 1, i = !1;
      this.seriesSelected.length !== this.series.length && (e = this.series.find((n) => n.id === s.series_id).sort_order), this.$store.dispatch("anatomy/gallery:click-image", s.sort_order), this.$store.dispatch("anatomy/series:set", {
        seriesIndex: e,
        relativeSliceIndex: t,
        keepMode: i,
        placement: ie.MODULE_GALLERY
      }), this.hideGallery();
    },
    getTitle(s) {
      return s === null || s.title_1 === null ? "" : s.title_2 === null ? s.title_1 : s.title_2;
    },
    slicesFromSeries(s) {
      return this.slices.filter((e) => e.series_id === s);
    }
  }
};
var Xu = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "gallery-overlay", staticClass: "gallery-overlay box-shadow", class: { "gallery-hidden": !e.galleryIsOpen, "tablet-screen": e.isTabletScreen } }, [e.galleryIsOpen ? t("div", { staticClass: "gallery-container" }, [t("div", { staticClass: "gallery-header" }, [t("div", { staticClass: "back-button", on: { click: function(i) {
    return e.back();
  } } }, [t("SingleArrowSVG")], 1), t("div", { staticClass: "gallery-header-title" }, [t("p", { staticClass: "gallery-header-main" }, [e._v(" " + e._s(e.mainTitle) + " ")]), t("span", { staticClass: "gallery-header-secondary" }, [e._v(e._s(e.secondaryTitle))])])]), t("div", { staticClass: "gallery-list-series", class: { "hide-mobile": e.seriesOpen } }, [t("p", { staticClass: "gallery-series-title" }, [e._v(" " + e._s(e.$t("gallery.series")) + " ")]), e.series.length > 1 ? t("div", { staticClass: "gallery-item-series", class: { selected: e.isSelected(-1) }, on: { click: e.selectAllSeries } }, [t("div", { staticClass: "img-container" }, [e._l(e.imagesAllSeries, function(i) {
    return [i.src !== null ? [t("img", { staticClass: "picture", style: { "background-color": `#${i.background_color}` }, attrs: { src: i.src, alt: e.$t("gallery.all-series") } })] : e._e(), i.src === null ? [t("span", { staticClass: "picture", style: { "background-color": `#${i.background_color}` } })] : e._e()];
  })], 2), t("p", { staticClass: "gallery-nb-images" }, [t("span", { staticClass: "ellipsis" }, [e._v(e._s(e.$t("gallery.all-series")))]), t("span", { staticClass: "number-of-images" }, [e._v(e._s(e.$t("gallery.n-image-s", { count: e.numberMaxSlices })))])])]) : e._e(), e._l(e.series, function(i) {
    return t("div", { key: i.id, staticClass: "gallery-item-series", class: { selected: e.isSelected(i.id) }, attrs: { title: i.name }, on: { click: function(r) {
      return e.selectSeries(i.id);
    } } }, [t("img", { style: { "background-color": `#${i.background_color}` }, attrs: { src: i.src, alt: i.name } }), t("p", { staticClass: "gallery-nb-images" }, [t("span", { staticClass: "ellipsis-2-lines" }, [e._v(e._s(i.name))]), t("span", { staticClass: "number-of-images" }, [e._v(e._s(e.$t("gallery.n-image-s", { count: i.number_of_images })))])])]);
  })], 2), t("div", { staticClass: "gallery-list-slices", class: { "display-mobile": e.seriesOpen } }, [t("div", { staticClass: "gallery-list-slices-header", class: { "hide-mobile": e.seriesOpen } }, [t("p", { staticClass: "gallery-list-slices-title" }, [e._v(" " + e._s(e.currentSeries.name) + " "), t("span", [e._v("- " + e._s(e.$t("gallery.n-image-s", { count: e.currentSeries.number_of_images })))])]), t("button", { staticClass: "button-close-gallery", on: { click: e.hideGallery } }, [t("CloseSVG")], 1)]), t("div", { staticClass: "slice-series" }, [e._l(e.series, function(i) {
    return e._l(e.slicesFromSeries(i.id), function(r) {
      return t("div", { key: r.id, staticClass: "gallery-item-slice", attrs: { title: e.getTitle(r) }, on: { click: function(n) {
        return e.moveToSlice(r);
      } } }, [t("img", { style: { "background-color": `#${i.background_color}` }, attrs: { src: r.src, alt: e.getTitle(r) } }), t("p", { staticClass: "ellipsis-2-lines", class: { "title-hidden": e.hideTitleSlice } }, [e._v(" " + e._s(e.getTitle(r)) + " ")])]);
    });
  })], 2)])]) : e._e()]);
}, Qu = [], Ku = /* @__PURE__ */ S(
  Zu,
  Xu,
  Qu,
  !1,
  null,
  "524055c4"
);
const qu = Ku.exports, Ju = {
  name: "tree-structureSVG"
};
var ed = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("g", [t("path", { attrs: { id: "Vector", "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.5 5C10.5 6.39788 9.54392 7.57245 8.25 7.90549L8.25 11.0641C8.25084 11.2014 8.36245 11.3125 8.5 11.3125H13.572C13.8713 9.97128 15.0686 8.96875 16.5 8.96875C18.1569 8.96875 19.5 10.3119 19.5 11.9688C19.5 13.6256 18.1569 14.9688 16.5 14.9688C15.1361 14.9688 13.9848 14.0586 13.6203 12.8125H8.5C8.41512 12.8125 8.33165 12.8065 8.25 12.7948L8.25 17.9844C8.25 18.1224 8.36193 18.2344 8.5 18.2344H13.6027C13.9465 16.9563 15.1134 16.0156 16.5 16.0156C18.1569 16.0156 19.5 17.3588 19.5 19.0156C19.5 20.6725 18.1569 22.0156 16.5 22.0156C15.0909 22.0156 13.9087 21.0441 13.5866 19.7344H8.5C7.53351 19.7344 6.75 18.9509 6.75 17.9844L6.75 11.0666L6.75 11.0625V7.90549C5.45608 7.57245 4.5 6.39788 4.5 5C4.5 3.34315 5.84315 2 7.5 2C9.15685 2 10.5 3.34315 10.5 5ZM7.5 6.5C8.32843 6.5 9 5.82843 9 5C9 4.17157 8.32843 3.5 7.5 3.5C6.67157 3.5 6 4.17157 6 5C6 5.82843 6.67157 6.5 7.5 6.5ZM16.5 20.5156C17.3284 20.5156 18 19.8441 18 19.0156C18 18.1872 17.3284 17.5156 16.5 17.5156C15.6716 17.5156 15 18.1872 15 19.0156C15 19.8441 15.6716 20.5156 16.5 20.5156ZM18 11.9688C18 12.7972 17.3284 13.4688 16.5 13.4688C15.6716 13.4688 15 12.7972 15 11.9688C15 11.1403 15.6716 10.4688 16.5 10.4688C17.3284 10.4688 18 11.1403 18 11.9688Z", fill: "black" } })])]);
}, td = [], sd = /* @__PURE__ */ S(
  Ju,
  ed,
  td,
  !1,
  null,
  "dde6ec60"
);
const id = sd.exports, rd = {
  name: "ScrollSVG"
};
var nd = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { id: "scroll", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M16.4609 9.99219L20.25 11.9858L11.9986 16.7571L3.75 11.9858L7.40625 9.99219M16.5391 14.3906L20.25 16.4643L11.9986 21.2356L3.75 16.4643L7.55469 14.3906M11.9986 12.2729L3.75 7.50449L11.9986 2.7332L20.25 7.50449L11.9986 12.2729Z", stroke: "black", "stroke-width": "1.5", "stroke-miterlimit": "10", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
}, ad = [], od = /* @__PURE__ */ S(
  rd,
  nd,
  ad,
  !1,
  null,
  "534e0b4c"
);
const Jr = od.exports, ld = {
  name: "PanSVG"
};
var cd = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { id: "pan", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M12.0126 3.04693C12.2117 3.04693 12.4025 3.12603 12.5432 3.26681L15.1488 5.87444C15.4416 6.16745 15.4414 6.64233 15.1484 6.9351C14.8554 7.22788 14.3805 7.2277 14.0877 6.93469L12.7626 5.60859V11.2303H18.394L17.0675 9.90278C16.7748 9.60977 16.775 9.1349 17.068 8.84212C17.361 8.54934 17.8358 8.54952 18.1286 8.84253L20.7342 11.4502C21.0268 11.743 21.0268 12.2176 20.7342 12.5104L18.1286 15.118C17.8358 15.4111 17.361 15.4112 17.068 15.1185C16.775 14.8257 16.7748 14.3508 17.0675 14.0578L18.394 12.7303H12.7626V18.3914L14.0877 17.0653C14.3805 16.7723 14.8554 16.7721 15.1484 17.0649C15.4414 17.3577 15.4416 17.8326 15.1488 18.1256L12.5432 20.7332C12.4025 20.874 12.2117 20.9531 12.0126 20.9531C11.8136 20.9531 11.6228 20.874 11.4821 20.7332L8.87651 18.1256C8.58373 17.8326 8.58391 17.3577 8.87692 17.0649C9.16993 16.7721 9.6448 16.7723 9.93758 17.0653L11.2626 18.3914V12.7303H5.60659L6.93307 14.0578C7.22585 14.3508 7.22566 14.8257 6.93266 15.1185C6.63965 15.4112 6.16477 15.4111 5.872 15.118L3.2664 12.5104C2.97378 12.2176 2.97378 11.743 3.2664 11.4502L5.872 8.84253C6.16477 8.54952 6.63965 8.54934 6.93266 8.84212C7.22566 9.1349 7.22585 9.60977 6.93307 9.90278L5.6066 11.2303H11.2626V5.6086L9.93758 6.93469C9.6448 7.2277 9.16993 7.22788 8.87692 6.9351C8.58391 6.64233 8.58373 6.16745 8.87651 5.87444L11.4821 3.26681C11.6228 3.12603 11.8136 3.04693 12.0126 3.04693Z", fill: "black" } })]);
}, ud = [], dd = /* @__PURE__ */ S(
  ld,
  cd,
  ud,
  !1,
  null,
  "9e990296"
);
const en = dd.exports, hd = {
  name: "ZoomSVG"
};
var md = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { id: "zoom", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.0312 17.5C14.6211 17.5 17.5313 14.5899 17.5313 11C17.5313 7.41015 14.6211 4.5 11.0312 4.5C7.4414 4.5 4.53125 7.41015 4.53125 11C4.53125 14.5899 7.4414 17.5 11.0312 17.5ZM17.1644 16.1369C18.3296 14.7471 19.0312 12.9555 19.0312 11C19.0312 6.58172 15.4495 3 11.0312 3C6.61297 3 3.03125 6.58172 3.03125 11C3.03125 15.4183 6.61297 19 11.0312 19C12.9539 19 14.7181 18.3218 16.0977 17.1915L19.7203 20.814C20.0132 21.1069 20.488 21.1069 20.7809 20.814C21.0738 20.5211 21.0738 20.0463 20.7809 19.7534L17.1644 16.1369ZM10.2344 13.75C10.2344 14.1642 10.5702 14.5 10.9844 14.5C11.3986 14.5 11.7344 14.1642 11.7344 13.75V11.75H13.7812C14.1955 11.75 14.5312 11.4142 14.5312 11C14.5312 10.5858 14.1955 10.25 13.7812 10.25H11.7344V8.25C11.7344 7.83579 11.3986 7.5 10.9844 7.5C10.5702 7.5 10.2344 7.83579 10.2344 8.25V10.25H8.28125C7.86704 10.25 7.53125 10.5858 7.53125 11C7.53125 11.4142 7.86704 11.75 8.28125 11.75H10.2344V13.75Z", fill: "black" } })]);
}, fd = [], pd = /* @__PURE__ */ S(
  hd,
  md,
  fd,
  !1,
  null,
  "5161e964"
);
const tn = pd.exports, gd = {};
var vd = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.7071 8.90625C12.8908 8.90625 13.0398 9.05522 13.0398 9.23897V10.0247C13.0398 10.1639 13.1273 10.2868 13.2536 10.3451C13.4207 10.4223 13.5795 10.5143 13.7283 10.6197C13.842 10.7001 13.9922 10.7145 14.1128 10.6449L14.7938 10.2517C14.953 10.1598 15.1564 10.2143 15.2483 10.3735L15.9554 11.5981C16.0472 11.7572 15.9927 11.9607 15.8336 12.0526L15.1525 12.4458C15.0321 12.5153 14.9694 12.6523 14.982 12.7908C14.9902 12.8812 14.9944 12.9728 14.9944 13.0653C14.9944 13.1579 14.9902 13.2494 14.982 13.3398C14.9694 13.4783 15.0321 13.6153 15.1525 13.6848L15.8336 14.078C15.9927 14.1699 16.0472 14.3734 15.9554 14.5325L15.2483 15.7572C15.1564 15.9163 14.953 15.9708 14.7938 15.8789L14.1128 15.4858C13.9922 15.4161 13.842 15.4305 13.7283 15.511C13.5796 15.6163 13.4208 15.7084 13.2536 15.7856C13.1273 15.8439 13.0398 15.9668 13.0398 16.1059V16.8916C13.0398 17.0754 12.8908 17.2244 12.7071 17.2244H11.293C11.1092 17.2244 10.9603 17.0754 10.9603 16.8916V16.1061C10.9603 15.9669 10.8728 15.844 10.7464 15.7857C10.5792 15.7085 10.4204 15.6164 10.2715 15.511C10.1579 15.4305 10.0077 15.4162 9.88705 15.4858L9.20618 15.8789C9.04704 15.9708 8.84355 15.9163 8.75167 15.7571L8.04463 14.5325C7.95275 14.3734 8.00728 14.1699 8.16642 14.078L8.84727 13.6849C8.9677 13.6154 9.03039 13.4784 9.0178 13.3399C9.00958 13.2495 9.00538 13.1579 9.00538 13.0653C9.00538 12.9727 9.00958 12.8811 9.01781 12.7907C9.0304 12.6522 8.96771 12.5152 8.84727 12.4457L8.16642 12.0526C8.00728 11.9607 7.95276 11.7572 8.04464 11.5981L8.75167 10.3735C8.84355 10.2143 9.04704 10.1598 9.20618 10.2517L9.8871 10.6448C10.0077 10.7144 10.1579 10.7001 10.2716 10.6196C10.4204 10.5143 10.5792 10.4222 10.7464 10.345C10.8728 10.2867 10.9603 10.1638 10.9603 10.0246V9.23897C10.9603 9.05522 11.1092 8.90625 11.293 8.90625H12.7071ZM12 14.345C12.7067 14.345 13.2797 13.7721 13.2797 13.0653C13.2797 12.3586 12.7067 11.7856 12 11.7856C11.2932 11.7856 10.7203 12.3586 10.7203 13.0653C10.7203 13.7721 11.2932 14.345 12 14.345Z", fill: "black" } }), t("path", { attrs: { d: "M17.127 5.72103C15.6336 4.74963 13.8801 4.23232 12.0879 4.23232H5.83271L6.80295 3.28726C7.09967 2.99824 7.10591 2.52341 6.81689 2.22669C6.52788 1.92997 6.05304 1.92373 5.75633 2.21274L3.4549 4.45445C3.31002 4.59556 3.22828 4.7892 3.22821 4.99144C3.22814 5.19368 3.30975 5.38738 3.45452 5.52859L5.75595 7.77343C6.05247 8.06265 6.5273 8.05674 6.81653 7.76022C7.10575 7.46371 7.09984 6.98887 6.80333 6.69965L5.83271 5.73232H12.0879C13.5922 5.73232 15.0612 6.1667 16.3092 6.97845C17.557 7.79006 18.5268 8.94164 19.0992 10.2854C19.6714 11.629 19.8217 13.1064 19.5319 14.5319C19.2421 15.9576 18.5245 17.2703 17.4665 18.3033C16.4083 19.3364 15.0571 20.043 13.5826 20.3308C12.108 20.6187 10.5791 20.4742 9.18987 19.9164C7.80077 19.3587 6.61569 18.4138 5.78215 17.204C4.94878 15.9944 4.50345 14.5736 4.5 13.1208C4.49901 12.7066 4.16243 12.3716 3.74822 12.3726C3.33401 12.3736 2.99902 12.7101 3 13.1244C3.00418 14.8825 3.54334 16.5984 4.54695 18.055C5.55038 19.5114 6.97235 20.6425 8.631 21.3084C10.2895 21.9743 12.1123 22.1461 13.87 21.803C15.6277 21.4599 17.2443 20.6165 18.5143 19.3766C19.7846 18.1364 20.6514 16.5549 21.0019 14.8307C21.3524 13.1064 21.1702 11.3199 20.4792 9.69761C19.7883 8.07556 18.6207 6.69256 17.127 5.72103Z", fill: "black" } })]);
}, yd = [], Ed = /* @__PURE__ */ S(
  gd,
  vd,
  yd,
  !1,
  null,
  "d8ebc872"
);
const Id = Ed.exports, Cd = {
  components: {
    // Use lazy loading
    ScrollSVG: Jr,
    PanSVG: en,
    ZoomSVG: tn,
    HideSVG: mi,
    ShowSVG: hi,
    RotationLeftSVG: Gr,
    RotationRightSVG: Vr,
    HorizontalFlipSVG: Yr,
    VerticalFlipSVG: jr,
    ResetSVG: Wr,
    ViewZoneSVG: Xr,
    ResetSettingsSVG: Id,
    "tree-structureSVG": id,
    ArrowRightSubMenuSVG: fi,
    OptionItem: Si
  },
  mixins: [Yt],
  props: {
    option: {
      /** @type {ContextMenuOption} */
      type: Object,
      required: !0
    },
    mousePositionOnShow: {
      type: Object,
      required: !0
    }
  },
  emits: ["option-clicked"],
  data: () => ({
    src: ""
  }),
  computed: {
    imageAlt() {
      return this.$t(this.option.translationKey, {
        param: this.option.translationParam
      });
    },
    itemText() {
      return this.$t(this.option.translationKey, {
        param: this.option.translationParam
      });
    },
    shortcutKey() {
      return this.getShortcutKeyByName(this.option.shortcutName);
    },
    haveShortcut() {
      return this.shortcutKey !== null;
    }
  },
  created() {
    if (this.option.type !== "divider") {
      if (typeof this.option.promiseSrc == "function")
        return this.option.promiseSrc().then((s) => this.src = s);
      this.src = this.option.iconSrc;
    }
  },
  methods: {
    onImageLoaded() {
      this.$set(this.option, "isLoaded", !0);
    },
    optionClicked() {
      this.option.disabled || this.option.subMenu || this.$emit("option-clicked", this.option);
    }
  }
};
var _d = function() {
  var e = this, t = e._self._c;
  return t("option-item", { staticClass: "imaios-context-menu-item", class: [
    e.option.class,
    e.option.type === "divider" ? "imaios-context-menu-item__divider" : ""
  ], attrs: { "data-action-id": e.option.id, disabled: e.option.disabled }, nativeOn: { click: function(i) {
    return e.optionClicked();
  } } }, [e.option.iconType === "img" ? [e.src ? t("img", { directives: [{ name: "show", rawName: "v-show", value: e.option?.isLoaded, expression: "option?.isLoaded" }], staticClass: "imaios-context-menu-item-icon", attrs: { "data-type": "img", src: e.src, alt: e.imageAlt }, on: { load: function(i) {
    return e.onImageLoaded();
  } } }) : e._e(), t("div", { directives: [{ name: "show", rawName: "v-show", value: !e.option?.isLoaded, expression: "!option?.isLoaded" }], staticClass: "imaios-context-menu-item-icon-placeholder" }, [t("div", { staticClass: "load-wrapper" }, [t("div", { staticClass: "activity" })])])] : e._e(), e.option.iconType === "font" ? t("span", { staticClass: "imaios-context-menu-item-icon", attrs: { "data-type": "font" } }, [e._v(e._s(e.src))]) : e._e(), e.option.iconType === "svg" ? t(e.src, { tag: "component", staticClass: "imaios-context-menu-item-icon", attrs: { "data-type": "svg" } }) : e._e(), t("div", { staticClass: "imaios-context-menu-item-text-container" }, [t("span", { staticClass: "imaios-context-menu-item-text" }, [e._v(e._s(e.itemText))]), e.haveShortcut ? t("span", { staticClass: "imaios-context-menu-item-shortcut" }, [e._v(" " + e._s(e.shortcutKey) + " ")]) : e._e(), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.option.subMenu, expression: "option.subMenu" }] }, [t("span", { staticClass: "imaios-context-menu-item-shortcut" }, [t("ArrowRightSubMenuSVG")], 1), t("div", { staticClass: "imaios-context-menu-item-sub-menu" }, [e._t("default")], 2)])])], 2);
}, Td = [], Sd = /* @__PURE__ */ S(
  Cd,
  _d,
  Td,
  !1,
  null,
  null
);
const bd = Sd.exports;
let Us = {};
const Ad = {
  name: "SubMenu",
  components: {
    OptionList: $r,
    OptionItem: Si
  },
  mixins: [Yt],
  data() {
    return {
      haveAtLeastOnStructureHidden: null,
      structureDisplayed: null,
      overlaysDisplayed: null,
      crossReference: null
    };
  },
  computed: {
    canDisplayCrossRefButton() {
      return this.$store.getters["menu/canDisplayCrossRefButton"];
    },
    buttonDisplayHiddenStructureDisabled() {
      return !this.structureDisplayed || !this.haveAtLeastOnStructureHidden;
    },
    shortcutDrawStructures() {
      return this.getShortcutKeyByName("hide-labels");
    },
    shortcutShowHiddenStructure() {
      return this.getShortcutKeyByName("show-hidden-structures");
    },
    shortcutToggleOverlays() {
      return this.getShortcutKeyByName("toggle-overlays");
    },
    shortcutToggleCrossReference() {
      return this.getShortcutKeyByName("show-hidden-cross-references");
    }
  },
  created() {
    const {
      blacklistFeature: s,
      labels: e,
      overlays: t
    } = z;
    Us = h.createHooks([
      {
        on: [
          s.BLACKLIST_STRUCTURE,
          s.CLEAR_BLACKLIST_STRUCTURE,
          s.BLACKLIST_POINT,
          s.WHITELIST_POINT
        ],
        do: this.checkingThereAreHiddenStructuresOrPoints
      },
      {
        on: e.TOGGLE,
        do: () => {
          this.structureDisplayed = !this.structureDisplayed;
        }
      },
      {
        on: t.TOGGLE,
        do: () => {
          this.overlaysDisplayed = !this.overlaysDisplayed;
        }
      }
    ]);
  },
  mounted() {
    this.checkingThereAreHiddenStructuresOrPoints(), this.checkingIfHiddenAllStructures(), this.checkingIfCrossReferenceOn(), this.checkingIfHiddenOverlays();
  },
  beforeMount() {
    h.onBeforeMount(Us);
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    h.onBeforeUnmount(Us);
  },
  methods: {
    checkingIfHiddenOverlays() {
      this.overlaysDisplayed = !this.$store.getters["anatomy/application"]?.data?.overlaysCanvasIsHidden;
    },
    checkingIfCrossReferenceOn() {
      this.crossReference = this.$store.getters["menu/activeLeftPanel"] === "cross-references";
    },
    checkingIfHiddenAllStructures() {
      this.structureDisplayed = !this.$store.getters["anatomy/application"]?.data?.labelCanvasHidden;
    },
    checkingThereAreHiddenStructuresOrPoints() {
      this.haveAtLeastOnStructureHidden = this.$store.getters["anatomy/haveBlacklistedStructures"]() || this.$store.getters["anatomy/haveHiddenPoints"]();
    },
    toggleDrawStructures() {
      this.$store.getters["anatomy/application"]?.toggleLabels();
    },
    clearHiddenStructures() {
      this.haveAtLeastOnStructureHidden && this.$store.dispatch("anatomy/structure:clear");
    },
    toggleOverlay() {
      this.$store.getters["anatomy/application"]?.toggleOverlays();
    },
    toggleCrossReferencesPanel() {
      this.$store.dispatch("menu/cross-references:toggle").then(() => this.$store.dispatch(
        "menu/cross-references:notification",
        ie.RIGHT_MENU
      ));
    }
  }
};
var wd = function() {
  var e = this, t = e._self._c;
  return t("option-list", { attrs: { displayed: "" } }, [t("option-item", { nativeOn: { click: function(i) {
    return e.toggleDrawStructures.apply(null, arguments);
  } } }, [t("span", [e._v(e._s(e.structureDisplayed ? e.$t("menu.filter.hide-all-structures") : e.$t("menu.filter.show-all-structures")))]), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutDrawStructures))])]), t("option-item", { attrs: { disabled: e.buttonDisplayHiddenStructureDisabled }, nativeOn: { click: function(i) {
    return e.clearHiddenStructures.apply(null, arguments);
  } } }, [t("span", [e._v(e._s(e.$t("menu.filter.show-hidden-structures")))]), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutShowHiddenStructure))])]), t("option-item", { nativeOn: { click: function(i) {
    return e.toggleOverlay.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.overlaysDisplayed ? e.$t("menu.filter.hide-all-overlays") : e.$t("menu.filter.show-all-overlays")) + " "), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutToggleOverlays))])]), e.canDisplayCrossRefButton ? t("option-item", { nativeOn: { click: function(i) {
    return e.toggleCrossReferencesPanel.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.crossReference ? e.$t("context-menu.hide-cross-reference") : e.$t("context-menu.show-cross-reference")) + " "), t("span", { staticClass: "shortcut-key" }, [e._v(e._s(e.shortcutToggleCrossReference))])]) : e._e()], 1);
}, Ld = [], Od = /* @__PURE__ */ S(
  Ad,
  wd,
  Ld,
  !1,
  null,
  null
);
const Md = Od.exports, er = 0, Nd = {
  name: "context-menu.component",
  directives: { ClickOutside: De },
  components: {
    SubMenu: Md,
    ContextMenuItem: bd
  },
  mixins: [Yt],
  props: {
    elementId: {
      type: String,
      required: !0
    },
    storeHandler: {
      type: String,
      required: !0
    }
  },
  emits: ["option-clicked"],
  data() {
    return {
      item: null,
      mousePositionOnShow: null
    };
  },
  computed: {
    isVisible() {
      return this.$store.getters[`${this.storeHandler}/visibility`];
    },
    options() {
      return this.$store.getters[`${this.storeHandler}/options`];
    }
  },
  mounted() {
    document.body.addEventListener("keyup", this.onEscKeyRelease);
  },
  beforeUnmount() {
    document.removeEventListener("keyup", this.onEscKeyRelease);
  },
  updated() {
    this.$nextTick(() => {
      const s = this.$refs["context-menu-layout"], e = this.$store.getters["viewer/viewer-left"] + this.$store.getters["viewer/container-margin-left"], t = {
        x: this.mousePositionOnShow.x + e,
        y: this.mousePositionOnShow.y
      };
      s.offsetWidth + t.x >= this.$store.getters["viewer/container-width"] + e ? s.style.left = `${t.x - s.offsetWidth + er}px` : s.style.left = `${t.x - er}px`, s.offsetHeight + t.y >= this.$store.getters["viewer/viewer-height"] ? s.style.top = `${t.y - s.offsetHeight + this.$store.getters["viewer/viewer-top"]}px` : s.style.top = `${t.y}px`, s.style.visibility = "";
    });
  },
  methods: {
    show(s) {
      const e = this.$refs["context-menu-layout"];
      e.style.visibility = "hidden", e.classList.add("imaios-context-menu-content--active"), this.mousePositionOnShow = {
        x: s.clientX - (this.$store.getters["viewer/viewer-left"] + this.$store.getters["viewer/container-margin-left"]),
        y: s.clientY - this.$store.getters["viewer/viewer-top"]
      }, this.$store.dispatch(`${this.storeHandler}/open`);
    },
    hide() {
      const s = document.getElementById(this.elementId);
      s && s.classList.remove("imaios-context-menu-content--active"), this.$store.dispatch(`${this.storeHandler}/close`);
    },
    onClickOutside() {
      this.hide();
    },
    optionClicked(s) {
      this.hide(), s.parameter === "mousePosition" && (s.parameter = this.mousePositionOnShow);
      try {
        this.$store.dispatch(
          `${this.storeHandler}/perform:${s.id}`,
          s.parameter
        );
      } catch (e) {
        console.error(e);
      } finally {
        this.$emit("option-clicked", {
          item: this.item,
          option: s
        });
      }
    },
    onEscKeyRelease(s) {
      s.keyCode === 27 && this.hide();
    }
  }
};
var Rd = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "context-menu-layout", staticClass: "imaios-context-menu-layout", attrs: { id: e.elementId }, on: { contextmenu: function(i) {
    i.preventDefault();
  } } }, [t("ul", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.onClickOutside, expression: "onClickOutside" }], ref: "context-menu-list", staticClass: "imaios-context-menu-content" }, e._l(e.options, function(i) {
    return t("context-menu-item", { key: i.uuid, attrs: { option: i, "mouse-position-on-show": e.mousePositionOnShow }, on: { "option-clicked": e.optionClicked } }, [t("sub-menu")], 1);
  }), 1)]);
}, xd = [], Dd = /* @__PURE__ */ S(
  Nd,
  Rd,
  xd,
  !1,
  null,
  null
);
const sn = Dd.exports;
let Vs = {};
const Pd = {
  name: "movable",
  data() {
    return {
      hasBeenMoved: !1,
      isDragging: !1,
      isOver: !1,
      normalizedX: 0,
      normalizedY: 0,
      x: 0,
      y: 0,
      moveHandler: null,
      positions: {
        clientX: void 0,
        clientY: void 0,
        movementX: 0,
        movementY: 0
      }
    };
  },
  props: {
    initialPosition: {
      type: Object,
      default: {}
    },
    onResize: {
      type: Function
    }
  },
  inject: ["container"],
  methods: {
    mouseover() {
      this.isOver = !0;
    },
    mouseleave() {
      this.isOver = !1, this.isDragging && setTimeout(() => {
        this.isOver && this.isDragging || this.stopDragging();
      }, 300);
    },
    getContainerBBox() {
      return this.container.value.getBoundingClientRect();
    },
    getBBox() {
      return this.$refs.wrapper.getBoundingClientRect();
    },
    refreshPosition() {
      const s = this.getContainerBBox(), e = this.getBBox();
      this.x = Math.min(Math.max(s.x, this.x), s.x + s.width - e.width), this.y = Math.min(Math.max(0, this.y), s.height - e.height), this.$refs.wrapper.style.left = this.x + "px", e.height > 0 && (this.$refs.wrapper.style.top = this.y + "px"), delete this.$refs.wrapper.style.bottom, this.normalizedX = this.x / s.width, this.normalizedY = this.y / s.height;
    },
    updateCoords(s) {
      this.isDragging && (this.positions.movementX = this.positions.clientX - s.clientX, this.positions.movementY = this.positions.clientY - s.clientY, this.positions.clientX = s.clientX, this.positions.clientY = s.clientY, this.x -= this.positions.movementX, this.y -= this.positions.movementY, this.refreshPosition());
    },
    startDragging(s) {
      this.hasBeenMoved = !0, this.isDragging = !0, this.positions.clientX = s.clientX, this.positions.clientY = s.clientY, document.addEventListener("mousemove", this.moveHandler);
    },
    stopDragging() {
      this.isDragging = !1, document.removeEventListener("mousemove", this.moveHandler);
    },
    resize() {
      const s = this.getContainerBBox();
      this.x = this.normalizedX * s.width, this.y = this.normalizedY * s.height, this.$props.onResize && this.$props.onResize(), this.refreshPosition();
    },
    setInitialPosition() {
      const s = this.getBBox();
      this.x = s.x, this.y = s.y - this.getContainerBBox().top, this.$props.initialPosition.top && (this.y = this.$props.initialPosition.top), this.$props.initialPosition.left && (this.x = this.$props.initialPosition.left), this.refreshPosition();
    }
  },
  beforeMount() {
    h.onBeforeMount(Vs);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Vs);
  },
  mounted() {
    this.moveHandler = this.updateCoords.bind(this);
  },
  created() {
    const { application: s } = z;
    Vs = h.createHooks([
      { on: s.RESIZED, do: () => this.resize() },
      { on: s.READY, do: () => this.setInitialPosition() }
    ]);
  }
};
var kd = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "wrapper", staticClass: "imaios-movable-wrapper", class: { grabbing: e.isDragging }, attrs: { draggable: "true" }, on: { mousedown: e.startDragging, touchstart: e.startDragging, touchend: e.stopDragging, mouseup: e.stopDragging, mouseleave: function(i) {
    return i.preventDefault(), e.mouseleave.apply(null, arguments);
  }, mouseover: e.mouseover } }, [e._t("default")], 2);
}, Hd = [], Fd = /* @__PURE__ */ S(
  Pd,
  kd,
  Hd,
  !1,
  null,
  null
);
const zd = Fd.exports;
let Gs = {};
const Bd = 0.03, tr = 15, $d = {
  name: "OrientationPicture",
  components: {
    movable: zd,
    ContextMenu: sn
  },
  data() {
    return {
      initialPosition: {
        left: 0,
        top: 0
      }
    };
  },
  computed: {
    style() {
      const s = this.$store.getters["anatomy/rotation"], e = this.$store.getters["anatomy/flipX"] ? -1 : 1, t = this.$store.getters["anatomy/flipY"] ? -1 : 1;
      return {
        transform: `rotate(${s}deg) scale(${e}, ${t})`
      };
    },
    isVisible() {
      return this.$store.getters["orientation-context-menu/widgetVisibility"];
    },
    src() {
      return this.$store.getters["anatomy/orientation-image"];
    },
    orientation() {
      return this.$store.getters["anatomy/currentSlice"].orientation;
    },
    getSize() {
      return window.screen.width * Bd;
    }
  },
  created() {
    const { application: s } = z;
    Gs = h.createHooks([
      {
        on: s.READY,
        do: () => this.setInitialPosition()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Gs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Gs);
  },
  methods: {
    openContextMenu(s) {
      this.$refs["orientation-context-menu"].show(s);
    },
    close() {
      this.$store.dispatch("orientation-context-menu/perform:close");
    },
    setInitialPosition() {
      const s = this.$store.getters["viewer/container-margin-left"];
      this.initialPosition.left = s + this.$store.getters["anatomy/getPaddingRightLabel"]() - this.getSize, this.initialPosition.top = this.$store.getters["viewer/container-height"] - (this.getSize + tr);
    },
    updatePosition() {
      if (this.$refs.movable.hasBeenMoved === !1) {
        const s = this.$store.getters["viewer/container-margin-left"], e = this.$store.getters["viewer/container-height"], t = this.$refs.movable.getBBox();
        let i = this.getSize, r = this.getSize;
        t.width > 0 && t.height > 0 && (r = t.height, i = t.width), this.$refs.movable.x = s + this.$store.getters["anatomy/getPaddingRightLabel"]() - i, this.$refs.movable.y = e - (r + tr);
      }
    }
  }
};
var Ud = function() {
  var e = this, t = e._self._c;
  return t("div", [t("context-menu", { ref: "orientation-context-menu", attrs: { "element-id": "orientation-context-menu", "store-handler": "orientation-context-menu" } }), t("movable", { directives: [{ name: "show", rawName: "v-show", value: e.src.length > 0 && e.isVisible, expression: "src.length > 0 && isVisible" }], ref: "movable", staticClass: "anatomy-orientation-wrapper", attrs: { "initial-position": e.initialPosition, "on-resize": e.updatePosition }, on: { contextmenu: function(i) {
    return i.preventDefault(), e.openContextMenu(i);
  } } }, [e.src.length > 0 && e.isVisible ? t("div", [t("span", { staticClass: "button-close-orientation", on: { click: e.close } }, [e._v("❌")]), t("div", { staticClass: "anatomy-orientation-picture-container", attrs: { title: e.orientation } }, [t("img", { staticClass: "anatomy-orientation-picture", style: e.style, attrs: { src: e.src, width: "75", height: "75", alt: e.orientation } })])]) : e._e()])], 1);
}, Vd = [], Gd = /* @__PURE__ */ S(
  $d,
  Ud,
  Vd,
  !1,
  null,
  "bb59c370"
);
const jd = Gd.exports;
let js = {};
const Yd = {
  name: "PremiumBanner",
  components: { CloseSVG: $e },
  data() {
    return {
      userHideBanner: !1,
      showPremiumAccountIsRequired: !1
    };
  },
  created() {
    const { application: s } = z;
    js = h.createHooks([
      {
        on: s.READY,
        do: () => this.checkPremiumAccountIsRequired()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(js);
  },
  beforeUnmount() {
    h.onBeforeUnmount(js);
  },
  methods: {
    hideBanner() {
      this.showPremiumAccountIsRequired = !1;
    },
    redirectToSubscribe() {
      this.$store.dispatch("anatomy/redirect:to", h.url.subscribe);
    },
    checkPremiumAccountIsRequired() {
      this.showPremiumAccountIsRequired = !this.$store.getters["anatomy/hasModuleAccess"]();
    }
  }
};
var Wd = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "premium-banner", staticClass: "premiumBanner", class: { "show-banner": e.showPremiumAccountIsRequired } }, [t("button", { staticClass: "button-close-banner", on: { click: e.hideBanner } }, [t("CloseSVG")], 1), t("div", { staticClass: "label-premium-container" }, [t("p", { staticClass: "label-premium-text" }, [e._v(" " + e._s(e.$t("premium-banner.label-required-premium")) + " ")]), t("button", { staticClass: "premium-banner-subscribe-button", on: { click: e.redirectToSubscribe } }, [e._v(" " + e._s(e.$t("premium-banner.subscribe")) + " ")])])]);
}, Zd = [], Xd = /* @__PURE__ */ S(
  Yd,
  Wd,
  Zd,
  !1,
  null,
  "e596f864"
);
const Qd = Xd.exports, Kd = {
  name: "FeaturePremium",
  components: { CloseSVG: $e },
  directives: { ClickOutside: De },
  computed: {
    displayComponent() {
      return this.$store.getters["menu/displayFeaturePremium"];
    },
    setSmallFontSizeClass() {
      return this.$store.getters["viewer/container-width"] <= Be.MOBILE;
    },
    userIsConnected() {
      return h.getUserId() !== fs;
    }
  },
  methods: {
    hide() {
      this.$store.dispatch("menu/feature-premium:hide");
    },
    redirectToSubscribe() {
      this.$store.dispatch("anatomy/redirect:to", h.url.subscribe);
    },
    redirectToSignup() {
      this.$store.dispatch("anatomy/redirect:to", h.url.login);
    }
  }
};
var qd = function() {
  var e = this, t = e._self._c;
  return e.displayComponent ? t("div", { staticClass: "feature-premium-overlay" }, [t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.hide, expression: "hide" }], staticClass: "feature-premium-container box-shadow" }, [t("div", { staticClass: "feature-premium-title" }, [t("CloseSVG", { nativeOn: { click: function(i) {
    return e.hide.apply(null, arguments);
  } } }), t("p", { staticClass: "text", class: { "small-font-size": e.setSmallFontSizeClass } }, [e._v(" " + e._s(e.$t("premium.text")) + " ")])], 1), t("div", { staticClass: "button-container" }, [e.userIsConnected ? e._e() : t("button", { staticClass: "button-connect", on: { click: e.redirectToSignup } }, [e._v(" " + e._s(e.$t("premium.button.connect")) + " ")]), t("button", { staticClass: "button-subscribe", on: { click: e.redirectToSubscribe } }, [e._v(" " + e._s(e.$t("premium.button.subscribe")) + " ")])])])]) : e._e();
}, Jd = [], eh = /* @__PURE__ */ S(
  Kd,
  qd,
  Jd,
  !1,
  null,
  null
);
const th = eh.exports, sh = {
  name: "LeftArrowSVG"
};
var ih = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M12.633 3.33794C12.3401 3.04505 11.8652 3.04505 11.5723 3.33794C11.2794 3.63084 11.2794 4.10571 11.5723 4.3986L18.4237 11.25H3.75003C3.33582 11.25 3.00003 11.5858 3.00003 12C3.00003 12.4142 3.33582 12.75 3.75003 12.75H18.4237L11.5723 19.6014C11.2794 19.8943 11.2794 20.3692 11.5723 20.6621C11.8652 20.9549 12.3401 20.9549 12.633 20.6621L20.7647 12.5303C21.0576 12.2374 21.0576 11.7626 20.7647 11.4697L12.633 3.33794Z", fill: "black" } })]);
}, rh = [], nh = /* @__PURE__ */ S(
  sh,
  ih,
  rh,
  !1,
  null,
  "a41c8e1d"
);
const rn = nh.exports, ah = {
  name: "RightArrowSVG"
};
var oh = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M12.633 3.33794C12.3401 3.04505 11.8652 3.04505 11.5723 3.33794C11.2794 3.63084 11.2794 4.10571 11.5723 4.3986L18.4237 11.25H3.75003C3.33582 11.25 3.00003 11.5858 3.00003 12C3.00003 12.4142 3.33582 12.75 3.75003 12.75H18.4237L11.5723 19.6014C11.2794 19.8943 11.2794 20.3692 11.5723 20.6621C11.8652 20.9549 12.3401 20.9549 12.633 20.6621L20.7647 12.5303C21.0576 12.2374 21.0576 11.7626 20.7647 11.4697L12.633 3.33794Z", fill: "black" } })]);
}, lh = [], ch = /* @__PURE__ */ S(
  ah,
  oh,
  lh,
  !1,
  null,
  "8c35831a"
);
const nn = ch.exports, uh = {
  name: "ShortcutItem",
  components: {
    LeftArrowSVG: rn,
    RightArrowSVG: nn
  },
  props: {
    item: {
      component: {
        style: {
          type: String,
          required: !1
        },
        name: {
          required: !1
        },
        required: !1
      },
      name: {
        type: String,
        required: !0
      },
      key: {
        type: String,
        required: !1
      }
    }
  },
  computed: {
    componentExist() {
      return typeof this.item.component < "u";
    }
  }
};
var dh = function() {
  var e = this, t = e._self._c;
  return t("li", { staticClass: "item-list-shortcuts" }, [t("div", { staticClass: "name" }, [e._v(" " + e._s(e.$t(e.item.translationKey)) + " ")]), t("div", { staticClass: "key" }, [e.componentExist && e.item.component.type === "vue" ? t(e.item.component.name, { tag: "component", style: e.item.component.style }) : [e._v(" " + e._s(e.item.key) + " ")], e.componentExist && e.item.component.type === "img" ? t("img", { attrs: { alt: e.$t(e.item.name), src: e.item.component.name } }) : e._e(), e.componentExist && e.item.component.type === "html" ? t("div", { domProps: { innerHTML: e._s(e.item.component.name) } }) : e._e()], 2)]);
}, hh = [], mh = /* @__PURE__ */ S(
  uh,
  dh,
  hh,
  !1,
  null,
  "96460f12"
);
const fh = mh.exports, ph = 882, gh = {
  name: "ShortcutsPanel",
  components: { ShortcutItem: fh },
  directives: { ClickOutside: De },
  data() {
    return {
      keyPressed: []
    };
  },
  computed: {
    display() {
      return this.$store.getters["menu/shortcutPanelIsOpen"];
    },
    shortcuts() {
      return this.$store.getters["shortcut/shortcutsList"];
    },
    isLargeTabletScreen() {
      return h.isLargeTabletScreen();
    },
    haveSmallHeight() {
      return this.$store.getters["viewer/viewer-height"] <= ph;
    }
  },
  methods: {
    // Use this method to avoid duplicate key
    getKey(s) {
      let e = `${s.name}_`;
      return typeof s.key < "u" ? e += s.key : typeof s.component < "u" && (e += `${s.component.name}_${s.component.style}`), e;
    },
    displayModal() {
      this.$store.dispatch("menu/shortcut-panel:display");
    },
    hideModal() {
      this.$store.dispatch("menu/shortcut-panel:hide");
    }
  }
};
var vh = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "modal-keyboard", class: { display: e.display, "large-tablet-screen": e.isLargeTabletScreen, "small-height": e.haveSmallHeight } }, [e.display ? t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.hideModal, expression: "hideModal" }], staticClass: "modal-keyboard-container box-shadow" }, [t("p", { staticClass: "title" }, [e._v(" " + e._s(e.$t("keyboard-panel.title")) + " ")]), t("ul", { staticClass: "list-shortcuts" }, e._l(e.shortcuts, function(i) {
    return t("shortcut-item", { key: e.getKey(i), attrs: { item: i } });
  }), 1)]) : e._e()]);
}, yh = [], Eh = /* @__PURE__ */ S(
  gh,
  vh,
  yh,
  !1,
  null,
  null
);
const Ih = Eh.exports, Ch = {
  name: "MoreSVG"
};
var _h = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { d: "M14 19C14 20.1 13.1 21 12 21C10.9 21 10 20.1 10 19C10 17.9 10.9 17 12 17C13.1 17 14 17.9 14 19ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3Z", fill: "black" } })]);
}, Th = [], Sh = /* @__PURE__ */ S(
  Ch,
  _h,
  Th,
  !1,
  null,
  "4ee9c0ca"
);
const bh = Sh.exports, Ah = {
  name: "IsolateSVG"
};
var wh = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.7344 21.0129H17.2941C19.3652 21.0129 21.0441 19.3339 21.0441 17.2629V14.4816H19.5441V17.2629C19.5441 18.5055 18.5368 19.5129 17.2941 19.5129H14.7344V21.0129ZM21.0441 6.6875V9.48163H19.5441V6.6875C19.5441 5.44486 18.5368 4.4375 17.2941 4.4375H14.7344V2.9375H17.2941C19.3652 2.9375 21.0441 4.61643 21.0441 6.6875ZM9.73438 4.4375H6.71875C5.47611 4.4375 4.46875 5.44486 4.46875 6.6875V9.48163H2.96875V6.6875C2.96875 4.61643 4.64768 2.9375 6.71875 2.9375H9.73438V4.4375ZM2.96875 14.4816H4.46875V17.2629C4.46875 18.5055 5.47611 19.5129 6.71875 19.5129H9.73437V21.0129H6.71875C4.64768 21.0129 2.96875 19.3339 2.96875 17.2629V14.4816ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", fill: "black" } })]);
}, Lh = [], Oh = /* @__PURE__ */ S(
  Ah,
  wh,
  Lh,
  !1,
  null,
  "60044a1c"
);
const Mh = Oh.exports, Nh = {
  name: "HideStructureSVG"
};
var Rh = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 6.49999C7.31826 6.49999 4.62892 10.2291 3.64219 11.9669C3.6318 11.9852 3.63123 11.9958 3.63123 12C3.63123 12.0041 3.6318 12.0148 3.64219 12.0331C4.62892 13.7709 7.31826 17.5 12 17.5C16.6847 17.5 19.3556 13.765 20.3307 12.0317C20.3407 12.0138 20.3412 12.0037 20.3412 12C20.3412 11.9963 20.3407 11.9861 20.3307 11.9683C19.3556 10.235 16.6847 6.49999 12 6.49999ZM2.33779 11.2263C3.37185 9.4051 6.44697 4.99999 12 4.99999C17.5596 4.99999 20.6157 9.41558 21.638 11.2328C21.9089 11.7144 21.9089 12.2856 21.638 12.7672C20.6157 14.5844 17.5596 19 12 19C6.44697 19 3.37185 14.5949 2.33779 12.7737C2.06237 12.2886 2.06237 11.7114 2.33779 11.2263Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 14C13.1045 14 14 13.1046 14 12C14 10.8954 13.1045 9.99999 12 9.99999C10.8954 9.99999 9.99997 10.8954 9.99997 12C9.99997 13.1046 10.8954 14 12 14ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.49999 12 8.49999C10.067 8.49999 8.49997 10.067 8.49997 12C8.49997 13.933 10.067 15.5 12 15.5Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20.7865 3.21877C21.0794 3.51166 21.0794 3.98654 20.7865 4.27943L4.2855 20.7804C3.99261 21.0733 3.51773 21.0733 3.22484 20.7804C2.93195 20.4875 2.93195 20.0126 3.22484 19.7197L19.7258 3.21877C20.0187 2.92588 20.4936 2.92588 20.7865 3.21877Z", fill: "black" } })]);
}, xh = [], Dh = /* @__PURE__ */ S(
  Nh,
  Rh,
  xh,
  !1,
  null,
  "cf1ab773"
);
const Ph = Dh.exports, kh = {
  name: "SelectSVG"
};
var Hh = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10 2H14V3.5H10V2ZM19 3.5H17V2H19C20.1046 2 21 2.89543 21 4V5.78131H19.5V4C19.5 3.72386 19.2761 3.5 19 3.5ZM19.5 8.78131L21 8.78131V12.875H19.5V8.78131ZM4.5 4V5.78131L3 5.78131V4C3 2.89543 3.89543 2 5 2H7L7 3.5H5C4.72386 3.5 4.5 3.72386 4.5 4ZM4.5 8.78131H3V12.875H4.5V8.78131ZM3 15.875H4.5V17.875C4.5 18.1511 4.72386 18.375 5 18.375H5.25V19.875H5C3.89543 19.875 3 18.9796 3 17.875V15.875ZM19.5 15.875H21V17.875C21 18.8069 20.3626 19.59 19.5 19.812V17.875V17.4375V15.875ZM11.0441 6.69063C11.0485 6.6014 11.1222 6.53131 11.2115 6.53131C11.3013 6.53131 11.3751 6.60214 11.3789 6.69189L11.642 13.0104C11.6529 13.2735 11.801 13.5115 12.0322 13.6376C12.2633 13.7637 12.5437 13.7593 12.7708 13.6261L13.4265 13.2415C13.7335 13.0614 14.1028 13.0207 14.4417 13.1297L16.5969 13.8229C17.1406 13.9978 17.4825 14.5092 17.4361 15.0552C17.3401 16.1851 17.178 17.7434 16.9333 19.0938C16.7847 19.9135 16.0321 20.5013 15.0757 20.5013H11.9025C11.245 20.5013 10.6204 20.2137 10.193 19.7141L6.52198 15.4238C6.47884 15.3734 6.45514 15.3092 6.45514 15.2429C6.45514 15.0471 6.65206 14.9125 6.83452 14.9836L9.59435 16.0598C9.81907 16.1474 10.0722 16.1216 10.2747 15.9905C10.4771 15.8593 10.6041 15.6388 10.6159 15.3979L11.0441 6.69063ZM11.2115 5.03131C10.3224 5.03131 9.58963 5.7289 9.54595 6.61694L9.16889 14.2839L7.37946 13.5861C6.2135 13.1315 4.95514 13.9914 4.95514 15.2429C4.95514 15.6669 5.10661 16.0769 5.38225 16.399L9.05323 20.6893C9.76568 21.522 10.8067 22.0013 11.9025 22.0013H15.0757C16.6305 22.0013 18.11 21.0126 18.4092 19.3613C18.6666 17.9412 18.8334 16.3277 18.9307 15.1822C19.0382 13.917 18.2428 12.7766 17.0562 12.3949L14.901 11.7017C14.3056 11.5102 13.6675 11.5287 13.0906 11.7458L12.8776 6.62949C12.8404 5.73628 12.1055 5.03131 11.2115 5.03131Z", fill: "black" } })]);
}, Fh = [], zh = /* @__PURE__ */ S(
  kh,
  Hh,
  Fh,
  !1,
  null,
  "9fd39725"
);
const Bh = zh.exports, $h = {
  name: "ShowStructureSVG"
};
var Uh = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.0156 5C6.4626 5 3.38748 9.40511 2.35342 11.2263C2.078 11.7114 2.078 12.2886 2.35342 12.7737C3.38748 14.5949 6.4626 19 12.0156 19C17.5752 19 20.6313 14.5844 21.6536 12.7672C21.9246 12.2856 21.9246 11.7144 21.6536 11.2328C20.6313 9.41558 17.5752 5 12.0156 5ZM3.65782 11.9669C4.64455 10.2291 7.33388 6.5 12.0156 6.5C16.7004 6.5 19.3712 10.235 20.3463 11.9683C20.3564 11.9861 20.3568 11.9963 20.3568 12C20.3568 12.0037 20.3564 12.0139 20.3463 12.0317C19.3712 13.765 16.7004 17.5 12.0156 17.5C7.33388 17.5 4.64455 13.7709 3.65782 12.0331C3.64743 12.0148 3.64685 12.0042 3.64685 12C3.64685 11.9958 3.64743 11.9852 3.65782 11.9669Z", fill: "black" } })]);
}, Vh = [], Gh = /* @__PURE__ */ S(
  $h,
  Uh,
  Vh,
  !1,
  null,
  "54479e47"
);
const jh = Gh.exports, Yh = 5, Wh = 120, Zh = {
  name: "StructureInThisModulePreview",
  components: { ArrowSubMenuSVG: Wt },
  data() {
    return {
      nbLoadedImages: 0,
      galleryTranslate: 0,
      galleryDragLastPosition: 0,
      deltaFromMove: 0,
      galleryOffsetWidth: 0,
      galleryScrollLeft: 0,
      galleryScrollWidth: 0
    };
  },
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    structuresLocations() {
      return this.$store.state["structure-in-this-module-gallery"].structuresLocations;
    },
    moduleName() {
      return this.$store.state["structure-in-this-module-gallery"].moduleName;
    },
    previewImages() {
      return this.$store.getters["structure-in-this-module-gallery/previewImages"];
    },
    currentModule() {
      return this.$store.getters["anatomy/module_id"];
    },
    canMoveToLeft() {
      return !this.galleryIsAtStart && this.galleryIsAuthorizedToMove;
    },
    canMoveToRight() {
      return !this.galleryIsAtEnd && this.galleryIsAuthorizedToMove;
    },
    canSeeMoreImages() {
      return this.$store.getters["structure-in-this-module-gallery/canSeeMoreImages"];
    },
    galleryIsAtStart() {
      return this.galleryScrollLeft === 0;
    },
    galleryIsAtEnd() {
      return this.galleryScrollLeft + this.galleryOffsetWidth >= this.galleryScrollWidth;
    },
    galleryIsAuthorizedToMove() {
      return this.galleryScrollWidth > this.galleryOffsetWidth;
    }
  },
  watch: {
    async "structureDetails.structureId"() {
      this.reset();
    }
  },
  methods: {
    isolateStructure(s) {
      h.emit(
        z.gallery.IN_THIS_MODULE.CLICK_IMAGE,
        {
          sliceIndex: s,
          structureId: this.structureDetails.structureId
        }
      );
    },
    async seeMore() {
      await this.$store.dispatch("structure-in-this-module-gallery/startLoading"), await this.$store.dispatch("structure-in-this-module-gallery/openGallery"), await this.$store.dispatch("structure-in-this-module-gallery/fillStructuresLocations", {
        structureId: this.structureDetails.structureId,
        imaiosCode: this.currentModule
      }), await this.$store.dispatch("structure-in-this-module-gallery/stopLoading");
    },
    scrollGallery(s = !1) {
      const e = s ? -1 : 1;
      this.scrollGalleryTo(e * Wh);
    },
    scrollGalleryTo(s, e = !0) {
      if (!this.galleryIsAuthorizedToMove)
        return;
      this.$refs["structure-gallery"]?.scrollBy({
        left: s,
        behavior: e ? "smooth" : "auto"
      });
    },
    updateGalleryPosition() {
      const s = this.$refs["structure-gallery"];
      typeof s > "u" || (this.galleryScrollLeft = s.scrollLeft);
    },
    pointerDown(s) {
      if (!this.galleryIsAuthorizedToMove || oe.isIE())
        return;
      this.deltaFromMove = 0;
      const e = this.$refs["structure-gallery"];
      typeof e < "u" && (e.style.transition = "none"), this.galleryDragLastPosition = s.screenX, document.addEventListener("pointermove", this.pointerMove), document.addEventListener("pointerup", this.pointerUp);
    },
    clickStructureLocation(s) {
      Math.abs(this.deltaFromMove) > Yh || (this.$store.dispatch("anatomy/send-notification", {
        notification: z.ui.PANEL_STRUCTURE.CLICK_GALLERY,
        args: { isCurrentModule: !0 }
      }), this.isolateStructure(s.index));
    },
    pointerMove(s) {
      if (!this.galleryIsAuthorizedToMove)
        return;
      const e = this.galleryDragLastPosition - s.screenX;
      this.deltaFromMove += e, this.scrollGalleryTo(e, !1), this.galleryDragLastPosition = s.screenX;
    },
    pointerUp() {
      document.removeEventListener("pointermove", this.pointerMove), document.removeEventListener("pointerup", this.pointerUp);
      const s = this.$refs["structure-gallery"];
      typeof s < "u" && (s.style.transition = "");
    },
    imageLoaded() {
      this.nbLoadedImages++, this.nbLoadedImages === this.previewImages.length && (this.$store.dispatch("structure-in-this-module-gallery/setPreviewImagesLoaded", !0), this.checkGalleryIsAuthorizedToMove());
    },
    checkGalleryIsAuthorizedToMove() {
      this.$nextTick(() => {
        const s = this.$refs["structure-gallery"];
        typeof s > "u" || (this.galleryOffsetWidth = s.offsetWidth, this.galleryScrollWidth = s.scrollWidth);
      });
    },
    reset() {
      this.scrollGalleryTo(0), this.galleryDragLastPosition = 0, this.nbLoadedImages = 0, this.galleryOffsetWidth = 0, this.galleryScrollLeft = 0, this.galleryScrollWidth = 0;
    },
    structureItemKey(s) {
      return `${this.structureDetails.taId}-${this.structureDetails.taxonId}-${s}`;
    },
    hasBlackBackground(s) {
      return s.background === "000000";
    }
  }
};
var Xh = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "container", staticClass: "structure-gallery" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(" " + e._s(e.$t("anatomical-parts.gallery.in-this-module")) + " ")]), e.galleryIsAuthorizedToMove ? t("button", { ref: "button-see-more", staticClass: "button-see", on: { click: e.seeMore } }, [e._v(" " + e._s(e.$t("anatomical-parts.see-more")) + " ")]) : e._e(), t("div", { staticClass: "structure-gallery-container" }, [t("span", { directives: [{ name: "show", rawName: "v-show", value: e.canMoveToLeft, expression: "canMoveToLeft" }], staticClass: "structure-gallery-arrow structure-gallery-arrow-left select-none", on: { click: function(i) {
    return e.scrollGallery(!0);
  } } }, [t("ArrowSubMenuSVG")], 1), t("span", { directives: [{ name: "show", rawName: "v-show", value: e.canMoveToRight, expression: "canMoveToRight" }], staticClass: "structure-gallery-arrow structure-gallery-arrow-right select-none", on: { click: function(i) {
    return e.scrollGallery(!1);
  } } }, [t("ArrowSubMenuSVG")], 1), t("div", { ref: "structure-gallery", staticClass: "structure-gallery-list", on: { pointerdown: e.pointerDown, scroll: e.updateGalleryPosition } }, [e._l(e.previewImages, function(i, r) {
    return t("div", { key: e.structureItemKey(r), staticClass: "structure-gallery-item select-none", class: {
      "white-background": !e.hasBlackBackground(i),
      "black-background": e.hasBlackBackground(i)
    }, on: { pointerup: function(n) {
      return e.clickStructureLocation(i);
    } } }, [t("img", { staticClass: "structure-gallery-item-image", attrs: { src: i.url, alt: i.module_name, draggable: "false" }, on: { load: e.imageLoaded, error: e.imageLoaded } })]);
  }), e.canSeeMoreImages ? t("div", { staticClass: "structure-gallery-item see-more-card", on: { click: e.seeMore } }, [t("p", [e._v(e._s(e.$t("anatomical-parts.see-more")))])]) : e._e()], 2)])]);
}, Qh = [], Kh = /* @__PURE__ */ S(
  Zh,
  Xh,
  Qh,
  !1,
  null,
  "a6e10125"
);
const Ys = Kh.exports;
function qh(s, e = `${s} table`) {
  const t = document.querySelector(s);
  function i(a) {
    return a.offsetWidth > t.offsetWidth || a.clientWidth < a.scrollWidth;
  }
  let r, n;
  document.querySelectorAll(e).forEach((a) => {
    function o(u) {
      u.preventDefault();
      const m = u.pageX - a.offsetLeft - r;
      a.scrollLeft = n - m;
    }
    function l(u) {
      r = u.pageX - a.offsetLeft, n = a.scrollLeft, a.style.setProperty("cursor", "grabbing"), a.addEventListener("mousemove", o);
    }
    function c() {
      a.style.setProperty("cursor", "grab"), a.removeEventListener("mousemove", o);
    }
    i(a) && (a.style.display = "block", a.style.overflowX = "auto", a.style.cursor = "grab"), a.addEventListener("mousedown", l), a.addEventListener("mouseup", c), a.addEventListener("mouseleave", c);
  });
}
const Jh = 150, e1 = {
  name: "StructureDefinition",
  components: {
    ArrowSubMenuSVG: Wt
  },
  data() {
    return {
      isDefinitionTruncated: !1
    };
  },
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    definitionExist() {
      return this.structureDetails.description.content !== null && this.structureDetails.description.content !== "";
    },
    canShowSeeMoreButton() {
      return this.isDefinitionTruncated === !0 && this.definitionExist;
    }
  },
  watch: {
    "structureDetails.structureId"() {
      this.truncateDescription();
    }
  },
  mounted() {
    this.truncateDescription(), qh(".structure-definition-html", ".table-wrapper");
  },
  methods: {
    showMore() {
      this.isDefinitionTruncated = !1;
    },
    truncateDescription() {
      this.$nextTick(() => {
        const s = this.$refs.definition;
        if (typeof s > "u")
          return !1;
        this.isDefinitionTruncated = s.clientHeight >= Jh;
      });
    }
  }
};
var t1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "structure-definition hr-after" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(" " + e._s(e.$t("anatomical-parts.description.title")) + " ")]), t("div", { staticClass: "structure-definition-html-container" }, [e.definitionExist ? [t("div", { ref: "definition", staticClass: "structure-definition-html", class: { "truncate-definition": e.isDefinitionTruncated }, domProps: { innerHTML: e._s(e.structureDetails.description.content) } }), e.isDefinitionTruncated ? e._e() : t("div", { staticClass: "structure-definition-html structure-definition-source", domProps: { innerHTML: e._s(e.structureDetails.description.sources) } })] : [t("p", { staticClass: "structure-definition-no-definition" }, [e._v(" " + e._s(e.$t("anatomical-parts.description.no-description")) + " ")])]], 2), e.canShowSeeMoreButton ? t("button", { ref: "button-see-more", staticClass: "structure-button-see", on: { click: e.showMore } }, [t("span", { staticClass: "structure-button-see-title" }, [e._v(e._s(e.$t("anatomical-parts.see-more")))]), t("ArrowSubMenuSVG")], 1) : e._e()]);
}, s1 = [], i1 = /* @__PURE__ */ S(
  e1,
  t1,
  s1,
  !1,
  null,
  "f429c4a4"
);
const r1 = i1.exports, n1 = 8, a1 = 2, o1 = {
  name: "StructureHierarchy",
  components: { ArrowSubMenuSVG: Wt },
  data() {
    return {
      indexHierarchyOpen: 0,
      hierarchyTruncate: [!1, !1, !1],
      displayButtonTruncateHierarchy: [!1, !1, !1]
    };
  },
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    structureId() {
      return this.$store.state["structure-details"].structureId;
    },
    structureTaId() {
      return this.$store.state["structure-details"].taId;
    },
    hierarchyList() {
      return Object.keys(this.structureDetails.hierarchy).map((s) => parseInt(s));
    }
  },
  watch: {
    structureId() {
      this.reset(), this.$nextTick(() => {
        this.truncateHierarchy();
      });
    }
  },
  mounted() {
    this.selectHierarchyToOpen();
  },
  methods: {
    isHierarchyOpen(s) {
      return s === this.indexHierarchyOpen;
    },
    hasChildren(s) {
      return this.structureDetails.hierarchy[s].children.length > 0;
    },
    shouldDisplayUnrollButton(s) {
      return this.displayButtonTruncateHierarchy[s] && this.hierarchyTruncate[s];
    },
    shouldDisplayRollupButton(s) {
      return this.displayButtonTruncateHierarchy[s] && !this.hierarchyTruncate[s];
    },
    toggleHierarchy(s) {
      if (this.indexHierarchyOpen === s) {
        this.indexHierarchyOpen = -1;
        return;
      }
      this.indexHierarchyOpen = s;
    },
    hierarchyClick(s, e = null, t = null) {
      (e === null || e < this.structureDetails.hierarchy[t].ancestors.length - 1) && (this.$store.dispatch("anatomy/send-notification", z.ui.PANEL_STRUCTURE.CLICK_HIERARCHY), this.$emit("hierarchy-click", { structure_id: s.struct_id }));
    },
    truncateHierarchy(s = null) {
      const e = this.$refs["hierarchy-list"];
      typeof e < "u" && Array.isArray(e) && (s === null ? e.forEach((t, i) => this.truncateTAHierarchy(i)) : this.truncateTAHierarchy(s));
    },
    truncateTAHierarchy(s) {
      const e = this.$refs["hierarchy-list"];
      typeof e < "u" && Array.isArray(e) && (e[s].childElementCount - a1 > n1 ? (this.$set(this.displayButtonTruncateHierarchy, s, !0), this.$set(this.hierarchyTruncate, s, !0)) : (this.$set(this.displayButtonTruncateHierarchy, s, !1), this.$set(this.hierarchyTruncate, s, !1)));
    },
    removeTruncateHierarchy(s) {
      this.$set(this.hierarchyTruncate, s, !1);
    },
    selectHierarchyToOpen() {
      const s = this.hierarchyList.indexOf(this.structureTaId);
      s !== -1 ? this.indexHierarchyOpen = s : this.indexHierarchyOpen = 0;
    },
    reset() {
      this.selectHierarchyToOpen();
      for (let s = 0; s < this.hierarchyTruncate.length; s++)
        this.$set(this.hierarchyTruncate, s, !1);
      for (let s = 0; s < this.displayButtonTruncateHierarchy.length; s++)
        this.$set(this.displayButtonTruncateHierarchy, s, !1);
    }
  }
};
var l1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "structure-hierarchy hr-after" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(" " + e._s(e.$t("anatomical-parts.hierarchy.title")) + " ")]), e._l(e.hierarchyList, function(i, r) {
    return [t("div", { staticClass: "structure-hierarchy-card", class: { "structure-hierarchy-open": e.isHierarchyOpen(r) } }, [t("div", { staticClass: "structure-hierarchy-card-header", on: { click: function(n) {
      return e.toggleHierarchy(r);
    } } }, [t("p", { staticClass: "structure-hierarchy-subtitle" }, [e._v(" " + e._s(e.$t(`anatomical-parts.hierarchy.${e.structureDetails.application}.${i}`)) + " ")]), t("div", { staticClass: "structure-hierarchy-icon-container" }, [t("ArrowSubMenuSVG", { staticClass: "structure-hierarchy-icon" })], 1)]), t("transition", { attrs: { name: "fade" } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isHierarchyOpen(r), expression: "isHierarchyOpen(indexTa)" }], staticClass: "structure-hierarchy-card-body" }, [t("div", { staticClass: "structure-hierarchy-ancestor-container" }, e._l(e.structureDetails.hierarchy[i].ancestors, function(n, a) {
      return t("span", { key: `${n.ta_id}-${n.taxon_id}`, staticClass: "structure-hierarchy-ancestor", on: { click: function(o) {
        return e.hierarchyClick(n, a, i);
      } } }, [t("span", { staticClass: "structure-hierarchy-ancestor-label" }, [e._v(e._s(n.label))]), a < e.structureDetails.hierarchy[i].ancestors.length - 1 ? t("span", { staticClass: "structure-hierarchy-ancestor-chevron" }, [e._v(" > ")]) : e._e()]);
    }), 0), t("div", { staticClass: "structure-hierarchy-children-container" }, [t("p", { staticClass: "structure-hierarchy-children-title" }, [e._v(" " + e._s(e.$t("anatomical-parts.hierarchy.underlying.title")) + " ")]), e.hasChildren(i) ? [t("div", { ref: "hierarchy-list", refInFor: !0, staticClass: "structure-hierarchy-children-list", class: { "hierarchy-truncate": e.hierarchyTruncate[r] } }, e._l(e.structureDetails.hierarchy[i].children, function(n) {
      return t("div", { staticClass: "structure-hierarchy-children" }, [t("span", { staticClass: "structure-hierarchy-children-label", on: { click: function(a) {
        return e.hierarchyClick(n);
      } } }, [e._v(e._s(n.label))])]);
    }), 0), e.shouldDisplayUnrollButton(r) ? t("button", { staticClass: "structure-button-see", on: { click: function(n) {
      return e.removeTruncateHierarchy(r);
    } } }, [t("span", { staticClass: "structure-button-see-title" }, [e._v(e._s(e.$t("anatomical-parts.see-more")))]), t("ArrowSubMenuSVG")], 1) : e._e(), e.shouldDisplayRollupButton(r) ? t("button", { staticClass: "structure-button-see", on: { click: function(n) {
      return e.truncateHierarchy(r);
    } } }, [t("span", { staticClass: "structure-button-see-title" }, [e._v(e._s(e.$t("anatomical-parts.see-less")))]), t("ArrowSubMenuSVG", { staticStyle: { rotate: "180deg" } })], 1) : e._e()] : t("p", { staticClass: "structure-hierarchy-no-children" }, [e._v(" " + e._s(e.$t("anatomical-parts.hierarchy.underlying.none")) + " ")])], 2)])])], 1)];
  })], 2);
}, c1 = [], u1 = /* @__PURE__ */ S(
  o1,
  l1,
  c1,
  !1,
  null,
  "b8c32565"
);
const d1 = u1.exports, h1 = {
  name: "StructureRelatedTerms",
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    currentStructureLanguage() {
      return this.$store.getters["anatomy/currentLanguageId"]();
    },
    isLanguageFrench() {
      return this.currentStructureLanguage === Z.fr;
    },
    hasLatinSynonym() {
      return this.structureDetails.latinSynonym !== null;
    },
    hasSynonym() {
      return this.structureDetails.synonym !== null;
    },
    hasFrAnc() {
      return this.isLanguageFrench && this.structureDetails.frAnc !== null;
    },
    hasLatinEponym() {
      return this.structureDetails.latinEponym !== null;
    },
    hasEponym() {
      return this.structureDetails.eponym !== null;
    },
    hasAcronym() {
      return this.structureDetails.acronym !== null;
    },
    hasRelatedTerms() {
      return this.structureDetails.relatedTerms != null;
    },
    hasAnyRelatedTerms() {
      return this.hasLatinSynonym || this.hasSynonym || this.hasFrAnc || this.hasLatinEponym || this.hasEponym || this.hasAcronym || this.hasRelatedTerms;
    }
  }
};
var m1 = function() {
  var e = this, t = e._self._c;
  return e.hasAnyRelatedTerms ? t("div", { staticClass: "related-terms-container hr-after" }, [e.hasLatinSynonym ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.latin-synonym")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.latinSynonym))])]) : e._e(), e.hasSynonym ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.synonym")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.synonym))])]) : e._e(), e.hasFrAnc ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.old_fr_nomenclature")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.frAnc))])]) : e._e(), e.hasLatinEponym ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.latin-eponym")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.latinEponym))])]) : e._e(), e.hasEponym ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.eponym")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.eponym))])]) : e._e(), e.hasAcronym ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.acronym")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.acronym))])]) : e._e(), e.hasRelatedTerms ? t("div", { staticClass: "related-terms" }, [t("span", [e._v(e._s(e.$t("anatomical-parts.related-terms.related-term")))]), t("span", { staticClass: "related-terms-value" }, [e._v(e._s(e.structureDetails.relatedTerms))])]) : e._e()]) : e._e();
}, f1 = [], p1 = /* @__PURE__ */ S(
  h1,
  m1,
  f1,
  !1,
  null,
  "e7805940"
);
const g1 = p1.exports, v1 = {
  name: "StructureTaCompare",
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    compareApplication() {
      return this.$store.getters["anatomy/application_id"] === Pe.EANATOMY ? Fi.ANIMAL : Fi.HUMAN;
    }
  },
  methods: {
    compareTA(s, e) {
      h.isEmbed() && (s.preventDefault(), s.stopImmediatePropagation(), s.stopPropagation(), this.$store.dispatch("dialog-popup/display", {
        title: this.$t("dialog.external-link-title"),
        message: this.$t("dialog.external-link-description", {
          url: (F.baseURL !== "" ? F.baseURL : ta) + e
        }),
        displayCancelButton: !0,
        confirmCallback: () => window.open(F.baseURL + e, "_blank")
      }));
    }
  }
};
var y1 = function() {
  var e = this, t = e._self._c;
  return e.structureDetails.appLinks !== null ? t("div", { staticClass: "structure-compare hr-after" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(" " + e._s(e.$t(`anatomical-parts.compare.${e.compareApplication}`)) + " ")]), t("div", { staticClass: "structure-details-section" }, e._l(e.structureDetails.appLinks, function(i) {
    return t("a", { staticClass: "structure-details-compare-label", attrs: { href: i.url, target: "_blank" }, on: { auxclick: (r) => e.compareTA(r, i.url), click: (r) => e.compareTA(r, i.url) } }, [e._v(e._s(i.label))]);
  }), 0)]) : e._e();
}, E1 = [], I1 = /* @__PURE__ */ S(
  v1,
  y1,
  E1,
  !1,
  null,
  "796e86db"
);
const C1 = I1.exports, _1 = {
  name: "structure-translation",
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    }
  }
};
var T1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "structure-translation" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(e._s(e.$t("anatomical-parts.translation.title")))]), t("img", { staticClass: "structure-details-translation-picture", attrs: { src: e.structureDetails.translationPicture, alt: e.$t("anatomical-parts.translation.title") } })]);
}, S1 = [], b1 = /* @__PURE__ */ S(
  _1,
  T1,
  S1,
  !1,
  null,
  "971bdea9"
);
const A1 = b1.exports, Ws = 6, w1 = {
  name: "StructureInOtherModulePreview",
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    structuresLocations() {
      return this.structureDetails.structuresLocations;
    },
    structuresNotInCurrentModule() {
      return this.structuresLocations.filter((s) => s.imaios_code !== this.currentModule);
    },
    currentModule() {
      return this.$store.getters["anatomy/module_id"];
    },
    uniqueModules() {
      return this.structuresNotInCurrentModule.reduce((s, e) => (s.has(e.imaios_code) || s.add(e.imaios_code), s), /* @__PURE__ */ new Set());
    },
    previewImages() {
      const s = [], e = /* @__PURE__ */ new Set();
      for (const t of this.structuresNotInCurrentModule)
        if (e.has(t.imaios_code) || (s.push(t), e.add(t.imaios_code)), s.length === Ws)
          break;
      return s.length === Ws && this.canShowMore && s.pop(), s;
    },
    canShowMore() {
      return this.uniqueModules.size > Ws;
    }
  },
  methods: {
    seeMore() {
      this.$store.dispatch("structure-in-other-modules-gallery/displayInOtherModuleGallery");
    },
    structureItemKey(s) {
      return `${this.structureDetails.taId}-${this.structureDetails.taxonId}-${s}`;
    },
    hasBlackBackground(s) {
      return s.background === "000000";
    }
  }
};
var L1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "structure-gallery hr-after" }, [t("p", { staticClass: "structure-details-section-title" }, [e._v(" " + e._s(e.$t("anatomical-parts.gallery.in-other-modules")) + " ")]), t("div", { staticClass: "structure-gallery-container" }, [e._l(e.previewImages, function(i, r) {
    return t("div", { key: e.structureItemKey(r), staticClass: "structure-gallery-item select-none", class: {
      "white-background": !e.hasBlackBackground(i),
      "black-background": e.hasBlackBackground(i)
    } }, [t("a", { staticClass: "structure-gallery-item-link", attrs: { href: i.link, target: "_blank" } }, [t("img", { staticClass: "structure-gallery-item-image", attrs: { alt: i.moduleName, src: i.url, draggable: "false" } })])]);
  }), e.canShowMore ? t("div", { staticClass: "structure-gallery-item select-none see-more-card", on: { click: e.seeMore } }, [t("p", [e._v(e._s(e.$t("anatomical-parts.see-more")))])]) : e._e()], 2)]);
}, O1 = [], M1 = /* @__PURE__ */ S(
  w1,
  L1,
  O1,
  !1,
  null,
  "5ad8d2e0"
);
const sr = M1.exports;
let Zs = {};
const N1 = {
  name: "StructureDetails",
  components: {
    StructureInOtherModulePreview: sr,
    StructureInThisModulePreview: Ys,
    StructureInThisModuleGallery: Ys,
    StructureInOtherModule: sr,
    StructureTranslation: A1,
    StructureTaCompare: C1,
    StructureRelatedTerms: g1,
    StructureHierarchy: d1,
    StructureDefinition: r1,
    InThisModuleGallery: Ys,
    ArrowSubMenuSVG: Wt
  },
  data() {
    return {
      displayDefaultStructureIcon: !1,
      defaultStructureIconSrc: _r
    };
  },
  computed: {
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    structuresLocations() {
      return this.structureDetails.structuresLocations;
    },
    currentModule() {
      return this.$store.getters["anatomy/module_id"];
    },
    isStructureDetailsLoaded() {
      return this.$store.getters["structure-details/isLoaded"];
    },
    hasInThisModuleImages() {
      return this.$store.getters["structure-in-this-module-gallery/nbImages"] > 0;
    },
    hasInOtherModulesImages() {
      return this.structuresLocations.some((s) => s.imaios_code !== this.currentModule);
    }
  },
  watch: {
    async "structureDetails.structureId"() {
      await this.fillStructuresLocations();
    }
  },
  created() {
    const { ui: s } = z;
    Zs = h.createHooks([
      {
        on: s.THEME.SWITCH,
        do: ({ detail: { theme: e } }) => this.refreshTranslationImage(e)
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Zs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Zs);
  },
  methods: {
    refreshTranslationImage(s) {
      if (this.structureDetails !== null) {
        let e = this.structureDetails.translationPicture.substring(0, this.structureDetails.translationPicture.length - 1);
        e += (s === at.DARK ? 1 : 0).toString(), this.structureDetails.translationPicture = e;
      }
    },
    hierarchyClick(s) {
      this.$emit("hierarchy-click", s);
    },
    async fillStructuresLocations(s = !0) {
      await this.$store.dispatch("structure-in-this-module-gallery/fillStructuresLocations", {
        structureId: this.structureDetails.structureId,
        imaiosCode: this.currentModule,
        limited: s
      });
    }
  }
};
var R1 = function() {
  var e = this, t = e._self._c;
  return e.isStructureDetailsLoaded ? t("div", { staticClass: "structure-details" }, [t("div", { staticClass: "structure-card-container" }, [t("p", { staticClass: "structure-name" }, [t("a", { staticClass: "structure-page-link", attrs: { href: e.structureDetails.structurePageLink, target: "_blank" } }, [e._v(e._s(e.structureDetails.label.current))])]), t("div", { staticClass: "structure-card-subtitle" }, [t("img", { directives: [{ name: "show", rawName: "v-show", value: !e.displayDefaultStructureIcon, expression: "!displayDefaultStructureIcon" }], staticClass: "structure-card-icon", attrs: { src: e.structureDetails.icon, alt: "structure-icon" }, on: { error: function(i) {
    e.displayDefaultStructureIcon = !0;
  } } }), e.displayDefaultStructureIcon ? t("img", { staticClass: "structure-card-icon", attrs: { src: e.defaultStructureIconSrc, alt: "structure-icon" } }) : e._e(), t("p", { staticClass: "structure-card-subtitle-latin" }, [e._v(" " + e._s(e.structureDetails.label.latin) + " ")])])]), t("hr", { staticClass: "hr-line" }), t("structure-definition"), t("structure-related-terms"), e.hasInThisModuleImages ? t("structure-in-this-module-preview") : e._e(), e.hasInOtherModulesImages ? t("structure-in-other-module-preview") : e._e(), t("structure-hierarchy", { on: { "hierarchy-click": e.hierarchyClick } }), t("structure-ta-compare"), t("structure-translation")], 1) : e._e();
}, x1 = [], D1 = /* @__PURE__ */ S(
  N1,
  R1,
  x1,
  !1,
  null,
  "fb4aa797"
);
const P1 = D1.exports, k1 = {
  name: "GalleryFilters",
  props: {
    structuresLocations: {
      type: Array,
      required: !0
    }
  },
  computed: {
    numberOfSeries() {
      return this.structuresLocations.filter((s) => s.series_name !== "").length;
    },
    hasMultipleSeries() {
      return this.numberOfSeries > 1;
    },
    totalSlices() {
      return this.$store.getters["structure-in-this-module-gallery/nbImages"];
    },
    selectedSeries() {
      return this.$store.state["structure-in-this-module-gallery"].selectedSeries;
    }
  },
  methods: {
    clickOnFilter(s) {
      this.$store.dispatch("structure-in-this-module-gallery/selectSeries", s);
    },
    isSelectedSeries(s) {
      return this.selectedSeries === s;
    }
  }
};
var H1 = function() {
  var e = this, t = e._self._c;
  return e.hasMultipleSeries ? t("div", { staticClass: "structure-details-gallery-chips-container" }, [t("button", { staticClass: "structure-chips", class: { selected: e.isSelectedSeries(-1) }, on: { click: function(i) {
    return e.clickOnFilter(-1);
  } } }, [t("span", { staticClass: "series-name" }, [e._v(" " + e._s(e.$t("anatomical-parts.gallery.all"))), t("span", { staticClass: "nb-images" }, [e._v("(" + e._s(e.totalSlices) + ")")])])]), e._l(e.structuresLocations, function(i) {
    return t("button", { key: i.series_id, staticClass: "structure-chips", class: { selected: e.isSelectedSeries(i.series_id) }, on: { click: function(r) {
      return e.clickOnFilter(i.series_id);
    } } }, [t("span", { staticClass: "series-name" }, [e._v(" " + e._s(i.series_name) + " "), t("span", { staticClass: "nb-images" }, [e._v("(" + e._s(i.nb_images) + ")")])])]);
  })], 2) : e._e();
}, F1 = [], z1 = /* @__PURE__ */ S(
  k1,
  H1,
  F1,
  !1,
  null,
  "6b629d31"
);
const an = z1.exports, B1 = {
  name: "gallery-image",
  props: {
    background: {
      type: String,
      required: !0
    },
    url: {
      type: String,
      required: !0
    },
    alt: {
      type: String,
      required: !1
    }
  }
};
var $1 = function() {
  var e = this, t = e._self._c;
  return t("figure", { directives: [{ name: "lazy-load-image", rawName: "v-lazy-load-image" }], staticClass: "structure-details-gallery-image__wrapper", style: {
    background: `#${e.background}`
  } }, [t("div", { staticClass: "structure-details-gallery-image__loader" }), t("img", { staticClass: "structure-details-gallery-image__item", attrs: { "data-url": e.url, alt: e.alt } })]);
}, U1 = [], V1 = /* @__PURE__ */ S(
  B1,
  $1,
  U1,
  !1,
  null,
  "ee24ec43"
);
const on = V1.exports, G1 = {
  name: "GalleryTopBar",
  components: { CloseSVG: $e },
  props: {
    title: {
      type: String,
      required: !0
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
var j1 = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "structure-details-gallery-top-bar" }, [t("p", [e._v(e._s(e.title))]), t("button", { on: { click: e.close } }, [t("CloseSVG")], 1)]);
}, Y1 = [], W1 = /* @__PURE__ */ S(
  G1,
  j1,
  Y1,
  !1,
  null,
  "d4e22f16"
);
const ln = W1.exports, Z1 = {
  name: "structure-in-this-module-gallery",
  components: { GalleryTopBar: ln, GalleryImage: on, GalleryFilters: an, CloseSVG: $e },
  computed: {
    structuresLocations() {
      return this.$store.state["structure-in-this-module-gallery"].structuresLocations;
    },
    selectedSeries() {
      return this.$store.state["structure-in-this-module-gallery"].selectedSeries;
    },
    structureId() {
      return this.$store.state["structure-details"].structureId;
    },
    hasStructureLocations() {
      return this.structuresLocations.length > 0;
    }
  },
  methods: {
    clickButtonClose() {
      this.$store.dispatch("structure-in-this-module-gallery/closeGallery");
    },
    isSeriesSelected(s) {
      return this.selectedSeries === -1 || this.selectedSeries === s;
    },
    isolateStructure(s) {
      h.emit(
        z.gallery.IN_THIS_MODULE.CLICK_IMAGE,
        { sliceIndex: s, structureId: this.structureId }
      );
    }
  }
};
var X1 = function() {
  var e = this, t = e._self._c;
  return e.hasStructureLocations ? t("div", { staticClass: "structure-details-gallery" }, [t("gallery-top-bar", { attrs: { title: e.$t("anatomical-parts.gallery.in-this-module") }, on: { close: e.clickButtonClose } }), t("gallery-filters", { attrs: { "structures-locations": e.structuresLocations } }), t("div", { staticClass: "structure-details-gallery-list-images" }, [e._l(e.structuresLocations, function(i) {
    return e._l(i.slices, function(r) {
      return t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isSeriesSelected(i.series_id), expression: "isSeriesSelected(structuresLocation.series_id)" }], key: r.url, staticClass: "structure-details-gallery-image-container", on: { click: function(n) {
        return e.isolateStructure(r.index);
      } } }, [t("gallery-image", { attrs: { background: i.background, url: r.url } })], 1);
    });
  })], 2)], 1) : e._e();
}, Q1 = [], K1 = /* @__PURE__ */ S(
  Z1,
  X1,
  Q1,
  !1,
  null,
  "1c38150d"
);
const q1 = K1.exports, J1 = {
  name: "structure-in-other-module-gallery",
  components: { GalleryTopBar: ln, GalleryImage: on, GalleryFilters: an, CloseSVG: $e },
  computed: {
    modulesExcludingCurrent() {
      return this.$store.getters["structure-in-other-modules-gallery/getModulesExcludingCurrent"];
    },
    hasStructureLocations() {
      return this.modulesExcludingCurrent.length > 0;
    }
  },
  methods: {
    clickButtonClose() {
      this.$store.dispatch("structure-in-other-modules-gallery/closeGallery");
    }
  }
};
var em = function() {
  var e = this, t = e._self._c;
  return e.hasStructureLocations ? t("div", { staticClass: "structure-details-gallery" }, [t("gallery-top-bar", { attrs: { title: e.$t("anatomical-parts.gallery.in-other-modules") }, on: { close: e.clickButtonClose } }), t("div", { staticClass: "structure-details-gallery-list-images" }, e._l(e.modulesExcludingCurrent, function({ id: i, background: r, url: n, link: a }) {
    return t("div", { key: i, staticClass: "structure-details-gallery-image-container" }, [t("a", { staticClass: "structure-details-gallery-image-link", attrs: { href: a, target: "_blank" } }, [t("gallery-image", { attrs: { background: r, url: n } })], 1)]);
  }), 0)], 1) : e._e();
}, tm = [], sm = /* @__PURE__ */ S(
  J1,
  em,
  tm,
  !1,
  null,
  "f17fee46"
);
const im = sm.exports;
let Xs = {};
const rm = {
  name: "PanelStructure",
  components: {
    StructureInOtherModuleGallery: im,
    StructureInThisModuleGallery: q1,
    StructureDetails: P1,
    LoaderCube: bi,
    CloseSVG: $e,
    SelectSVG: Bh,
    HideStructureSVG: Ph,
    ShowStructureSVG: jh,
    IsolateSVG: Mh,
    MoreSVG: bh
  },
  directives: { ClickOutside: De },
  inject: ["container", "viewer"],
  data() {
    return {
      isOpen: !1,
      isStructureLoading: !0,
      url: "",
      isPinned: !1,
      optionIsActive: !1,
      structure: null,
      filter_id: null,
      crossReferencesPanelWasOpen: !1,
      urlGallery: "",
      structurePanelIsScrolled: !1,
      oldSize: null,
      structureDetailsGallery: null,
      stopLoadingAfterRequest: !1
    };
  },
  computed: {
    isGalleryLoading() {
      return this.$store.state["structure-in-this-module-gallery"].isLoading;
    },
    displayGallery() {
      return this.$store.state["structure-in-this-module-gallery"].display;
    },
    displayInOtherModuleGallery() {
      return this.$store.state["structure-in-other-modules-gallery"].display;
    },
    structureName() {
      return this.structure?.name || "";
    },
    filterName() {
      return this.$store.getters["anatomy/filterById"](this.filter_id).name || "";
    },
    isLargeTabletScreen() {
      return h.isLargeTabletScreen() && !this.isTabletScreen;
    },
    isTabletScreen() {
      return h.isTabletScreen();
    },
    structureDetails() {
      return this.$store.state["structure-details"];
    },
    inThisModuleImagesLoaded() {
      return this.$store.getters["structure-in-this-module-gallery/allPreviewImagesLoaded"];
    },
    showPanelLoader() {
      return this.isStructureLoading || !this.inThisModuleImagesLoaded;
    },
    shouldTogglePinPanel() {
      return this.isOpen && !this.isPinned && !this.isTabletScreen;
    },
    shouldUnpinPanel() {
      return this.isPinned && this.isTabletScreen;
    }
  },
  created() {
    const {
      structure: s,
      ui: e,
      language: t,
      gallery: i
    } = z;
    Xs = h.createHooks([
      {
        on: e.VIEWER.HAS_BEEN_RESIZED,
        do: () => this.resize()
      },
      {
        on: s.CLICK,
        do: (r) => {
          if (this.$store.getters["anatomy/hasModuleAccess"]() === !0) {
            const n = {
              isAuthorizedToOpen: !0,
              point_id: r.detail.point.id
            };
            this.$store.dispatch("anatomy/application:panel-structure-open", n), n.isAuthorizedToOpen && ((this.structure === null || this.structure.ta_id !== r.detail.structure.ta_id || this.structure.taxon_id !== r.detail.structure.taxon_id) && (this.filter_id = r.detail.point.filter_id, this.structure = r.detail.structure, this.fillStructure()), this.isOpen || this.open());
          } else
            this.$store.dispatch("menu/feature-premium:display");
        }
      },
      {
        on: t.CHANGE,
        do: () => this.refreshPanelState()
      },
      {
        on: i.IN_THIS_MODULE.CLICK_IMAGE,
        do: ({ detail: { sliceIndex: r } }) => this.isolateStructure(r)
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Xs);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Xs), this.close();
  },
  methods: {
    getSizePanel() {
      return this.$refs["panel-structure"].offsetWidth;
    },
    onStructurePanelScroll() {
      this.structurePanelIsScrolled = this.$refs.panel?.scrollTop !== 0;
    },
    textFilter() {
      return this.filterIsSelect() ? this.$t("panel-structure.list-actions.unselect") : this.$t("panel-structure.list-actions.select");
    },
    textIsolate() {
      return this.isIsolate() ? this.$t("panel-structure.list-actions.cancel_isolate") : this.$t("panel-structure.list-actions.isolate");
    },
    textBlacklistStructure() {
      return this.structureIsBlackListed() ? this.$t("panel-structure.list-actions.display") : this.$t("panel-structure.list-actions.hide");
    },
    filterIsSelect() {
      return this.$store.getters["anatomy/isOnlyOneFilterSelected"](this.filter_id);
    },
    structureIsBlackListed() {
      return this.$store.getters["anatomy/isBlacklistedStructure"](this.structure.id);
    },
    isIsolate() {
      return this.$store.getters["anatomy/getIsolateStructureId"]() === this.structure.id;
    },
    open() {
      this.$store.dispatch("menu/structure-panel:toggle", this.structure.getTaxonKey()), this.$store.getters["menu/displayCrossReferencesPanel"].display && (this.crossReferencesPanelWasOpen = !0, this.$store.dispatch("menu/cross-references:toggle", !1)), this.isOpen = !0, this.togglePinPanel();
    },
    close() {
      this.$store.dispatch("menu/structure-panel:toggle"), this.crossReferencesPanelWasOpen && !this.$store.getters["menu/displayCrossReferencesPanel"].display && this.$store.dispatch("menu/cross-references:toggle"), this.isOpen = !1, this.$store.dispatch("structure-in-this-module-gallery/closeGallery"), this.$store.dispatch("structure-in-other-modules-gallery/closeGallery"), this.togglePinPanel();
    },
    togglePinPanel() {
      if (this.isTabletScreen && !this.isPinned)
        return;
      this.isPinned = !this.isPinned;
      let s = this.$store.getters["viewer/viewer-offset-size"], e = this.$store.getters["viewer/container-margin-left"];
      const t = this.getSizePanel();
      this.isPinned ? (s += t, e += t, this.oldSize = t) : (s -= this.oldSize, e -= this.oldSize), this.$store.dispatch("viewer/viewer:set-offset-size", s), this.$store.dispatch("viewer/container:set-margin", { marginLeft: e }), this.$store.dispatch("viewer/container:set-size", {
        width: this.$store.getters["viewer/container-width"] + (this.isPinned ? -t : this.oldSize)
      });
    },
    clickOption() {
      this.optionIsActive = !this.optionIsActive;
    },
    closeOption() {
      this.optionIsActive = !1;
    },
    toggleFilter() {
      this.filterIsSelect() ? this.$store.dispatch("core-context-menu/perform:blur-filter") : (this.$store.dispatch("core-context-menu/perform:focus-filter", {
        filter_id: this.filter_id,
        taxonKey: this.structure.getTaxonKey(),
        source: Ke.STRUCTURE_DETAILS
      }), this.$store.dispatch("anatomy/send-notification", z.ui.PANEL_STRUCTURE.SELECT)), this.$forceUpdate();
    },
    clickIsolate() {
      this.isIsolate() ? this.$store.dispatch("core-context-menu/perform:clear-isolate-structure") : (this.$store.dispatch("core-context-menu/perform:isolate-structure", {
        structure_id: this.structure.id,
        preferredTaxonKey: this.structure.getTaxonKey(),
        source: Ke.STRUCTURE_DETAILS
      }), this.$store.dispatch("anatomy/send-notification", z.ui.PANEL_STRUCTURE.ISOLATE)), this.$forceUpdate();
    },
    toggleBlacklistStructure() {
      this.structureIsBlackListed() ? this.$store.dispatch("anatomy/structure:whitelist", this.structure.id) : (this.$store.dispatch("anatomy/structure:blacklist", {
        structure_id: this.structure.id,
        source: Ke.STRUCTURE_DETAILS
      }), this.$store.dispatch("anatomy/send-notification", z.ui.PANEL_STRUCTURE.HIDE)), this.$forceUpdate();
    },
    updateGalleryContainerStyle() {
      const s = this.$refs["in-this-module-gallery-container"].style, e = this.$refs["in-other-modules-gallery-container"].style;
      if (this.isTabletScreen)
        s.width = "", s.marginLeft = "", e.width = "", e.marginLeft = "";
      else {
        const t = this.$store.getters["viewer/viewer-width"] - this.$store.getters["viewer/container-margin-left"];
        s.width = `${t}px`, s.marginLeft = `${this.getSizePanel()}px`, e.width = `${t}px`, e.marginLeft = `${this.getSizePanel()}px`;
      }
    },
    togglePinPanelIfNeeded() {
      (this.shouldTogglePinPanel || this.shouldUnpinPanel) && this.$nextTick(this.togglePinPanel);
    },
    resize() {
      this.togglePinPanelIfNeeded(), this.updateGalleryContainerStyle();
    },
    startStructureLoading() {
      const s = this.$refs.panel ?? null;
      s !== null && (oe.isIE() ? s.scrollTop = 0 : s.scrollTo(0, 0)), this.isStructureLoading = !0;
    },
    stopStructureLoading() {
      this.isStructureLoading = !1;
    },
    refreshPanelState() {
      this.stopLoadingAfterRequest = !0, this.fillStructure();
    },
    fillStructure(s = null) {
      this.structure !== null && s === null && (s = this.structure.id), s !== null && (this.startStructureLoading(), this.$store.dispatch("structure-details/fill-structure", s).then(() => this.stopStructureLoading()).catch((e) => {
        console.log(e), this.structure = null, this.close(), h.sendCoreError(e), this.$store.dispatch("dialog-popup/display", {
          title: this.$t("error.title"),
          message: this.$t("error.commons", { errorCode: ui.STRUCTURE_DETAILS })
        });
      }));
    },
    hierarchyClick({ structure_id: s }) {
      try {
        this.structure = this.$store.getters["anatomy/structureWithPointsByStructureId"](s);
      } catch {
        this.structure = null;
      }
      this.fillStructure(s);
    },
    isolateStructure(s) {
      this.$store.dispatch("structure-in-this-module-gallery/closeGallery"), this.$store.dispatch("structure-in-other-modules-gallery/closeGallery"), this.$store.dispatch("core-context-menu/perform:clear-isolate-structure"), this.$store.dispatch("anatomy/slice:set", { sliceIndex: s }), this.$store.dispatch("core-context-menu/perform:isolate-structure", {
        structure_id: this.structureDetails.structureId,
        source: Ke.STRUCTURE_DETAILS_GALLERY
      });
    }
  }
};
var nm = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "panel-structure", staticClass: "panel-structure", class: { open: e.isOpen, pinned: e.isPinned, "tablet-screen": e.isTabletScreen, "large-tablet-screen": e.isLargeTabletScreen } }, [t("div", { ref: "panel", staticClass: "panel-container", class: { "no-scroll": e.showPanelLoader }, on: { scroll: e.onStructurePanelScroll } }, [t("div", { ref: "button-container", staticClass: "button-container", class: { fixed: e.structurePanelIsScrolled } }, [e.structure !== null ? t("button", { staticClass: "button-panel-more", class: { active: e.optionIsActive, fixed: e.structurePanelIsScrolled }, on: { click: e.clickOption } }, [t("MoreSVG")], 1) : e._e(), t("button", { staticClass: "button-panel-close", class: { fixed: e.structurePanelIsScrolled }, on: { click: e.close } }, [t("CloseSVG")], 1), e.optionIsActive ? t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.closeOption, expression: "closeOption" }], staticClass: "option-context-menu" }, [t("p", { staticClass: "title-option ellipsis", attrs: { title: e.structureName } }, [e._v(" " + e._s(e.structureName) + " ")]), t("ul", { staticClass: "list-actions" }, [t("li", { staticClass: "action-item", on: { click: e.clickIsolate } }, [t("IsolateSVG"), t("span", { staticClass: "text" }, [e._v(e._s(e.textIsolate()))])], 1), t("li", { staticClass: "action-item", on: { click: e.toggleBlacklistStructure } }, [e.structureIsBlackListed() ? t("ShowStructureSVG") : e._e(), e.structureIsBlackListed() ? e._e() : t("HideStructureSVG"), t("span", { staticClass: "text" }, [e._v(e._s(e.textBlacklistStructure()))])], 1)]), t("hr", { staticClass: "separator" }), t("p", { staticClass: "title-option ellipsis", attrs: { title: e.filterName } }, [e._v(" " + e._s(e.filterName) + " ")]), t("ul", { staticClass: "list-actions" }, [t("li", { staticClass: "action-item", on: { click: e.toggleFilter } }, [t("SelectSVG"), t("span", { staticClass: "text" }, [e._v(e._s(e.textFilter()))])], 1)])]) : e._e()]), e.showPanelLoader ? t("div", { staticClass: "loader" }, [t("LoaderCube", { staticStyle: { "margin-top": "50%" } })], 1) : e._e(), t("structure-details", { on: { "hierarchy-click": e.hierarchyClick } })], 1), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.displayGallery, expression: "displayGallery" }], ref: "in-this-module-gallery-container", staticClass: "gallery-container" }, [e.isGalleryLoading ? t("div", { staticClass: "loader" }, [t("LoaderCube", { staticStyle: { "margin-top": "50%" } })], 1) : e._e(), t("structure-in-this-module-gallery")], 1), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.displayInOtherModuleGallery, expression: "displayInOtherModuleGallery" }], ref: "in-other-modules-gallery-container", staticClass: "gallery-container" }, [t("structure-in-other-module-gallery")], 1)]);
}, am = [], om = /* @__PURE__ */ S(
  rm,
  nm,
  am,
  !1,
  null,
  "96de2d73"
);
const lm = om.exports, cm = {
  name: "ToolButton",
  props: {
    icon: Object,
    isPressed: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    shortcut: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  computed: {
    shortcutText() {
      return this.shortcut ? ` (${this.shortcut})` : "";
    },
    buttonTitle() {
      return `${this.title}${this.shortcutText}`;
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
var um = function() {
  var e = this, t = e._self._c;
  return t("button", { staticClass: "tool-button", attrs: { "aria-pressed": e.isPressed, title: e.buttonTitle }, on: { click: e.handleClick } }, [t(e.icon, { tag: "component", staticClass: "icon" })], 1);
}, dm = [], hm = /* @__PURE__ */ S(
  cm,
  um,
  dm,
  !1,
  null,
  "fa0ff38a"
);
const mm = hm.exports, fm = {
  name: "MenuToggle",
  components: {
    ToolButton: mm
  },
  computed: {
    MenuSVG() {
      return Br;
    }
  },
  methods: {
    toggleMenu() {
      this.$store.dispatch("menu/menu:toggle");
    }
  }
};
var pm = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "menu-toggle" }, [t("ToolButton", { attrs: { icon: e.MenuSVG }, on: { click: e.toggleMenu } })], 1);
}, gm = [], vm = /* @__PURE__ */ S(
  fm,
  pm,
  gm,
  !1,
  null,
  "c286025c"
);
const ym = vm.exports;
let Qs = {};
const Em = {
  name: "CounterSlice",
  components: { RightArrowSVG: nn, LeftArrowSVG: rn },
  inject: ["container"],
  data() {
    return {
      inputIsHidden: !0,
      mousedownID: -1,
      timeoutMouseDown: -1,
      keydownSinceFocus: !1
    };
  },
  computed: {
    indexOfCurrentSlice() {
      return this.$store.getters["anatomy/indexCurrentSlice"];
    },
    numberOfSlices() {
      return this.$store.getters["anatomy/numberOfSlices"];
    },
    isMobileOrTablet() {
      return oe.isMobileOrTablet();
    },
    isDesktopScreen() {
      return h.isDesktopScreen();
    }
  },
  watch: {
    indexOfCurrentSlice: function() {
      h.forceRedrawSafari(this.$refs["text-number-slice"]);
    }
  },
  methods: {
    showInput() {
      this.isMobileOrTablet || (this.inputIsHidden = !1, this.$refs.inputNumberSlice.value = this.indexOfCurrentSlice + "/" + this.numberOfSlices, this.$refs.inputNumberSlice.selectionEnd = this.indexOfCurrentSlice.toString().length, this.$refs.inputNumberSlice.focus());
    },
    hideInput() {
      this.inputIsHidden = !0;
    },
    changeSlice(s = !0) {
      if (!this.inputIsHidden) {
        const e = this.parseInputValue();
        !/\D+/gm.test(e) && this.indexOfCurrentSlice !== parseInt(e) && this.$store.dispatch("anatomy/slice:set", { sliceIndex: parseInt(e), placement: ie.SLICE_COUNTER }), s && this.hideInput();
      }
    },
    earnFocus(s) {
      this.keydownSinceFocus = !1, s.target.select();
    },
    debounceChangeSlice() {
      this.changeSlice(!1);
      const s = this.$refs.inputNumberSlice, e = /\D/gm;
      e.test(s.value.replace("/", "")) && (s.value = s.value.replace(e, "")), s.value.includes("/" + this.numberOfSlices) || (s.value.includes("/") ? this.setInputValue(this.parseInputValue()) : this.keydownSinceFocus ? this.setInputValue(s.value.substring(0, s.value.indexOf(this.numberOfSlices))) : (this.setInputValue(s.value), this.keydownSinceFocus = !0)), this.parseInputValue() > this.numberOfSlices ? this.setInputValue(this.numberOfSlices) : this.parseInputValue() < 1 && this.setInputValue(1), s.selectionEnd = this.parseInputValue().length;
    },
    keyDownChangeSlice(s) {
      s.key === "Enter" && this.changeSlice();
    },
    goToNextSlice() {
      this.$store.dispatch("anatomy/slice:next");
    },
    eventClick(s = !1) {
      s ? this.goToPreviousSlice() : this.goToNextSlice();
    },
    goToPreviousSlice() {
      this.$store.dispatch("anatomy/slice:previous");
    },
    mouseDownSlice(s = !1) {
      this.timeoutMouseDown === -1 && this.mousedownID === -1 && (this.timeoutMouseDown = setTimeout(() => {
        this.mousedownID = setInterval(() => {
          this.eventClick(s);
        }, 50);
      }, 200));
    },
    mouseUp() {
      this.mousedownID !== -1 && (clearInterval(this.mousedownID), this.mousedownID = -1), clearTimeout(this.timeoutMouseDown), this.timeoutMouseDown = -1;
    },
    parseInputValue() {
      return this.$refs.inputNumberSlice.value.split("/")[0];
    },
    setInputValue(s) {
      this.$refs.inputNumberSlice.value = s + "/" + this.numberOfSlices;
    }
  },
  created() {
    Qs = h.createHooks([
      { on: "mouseup", do: () => this.mouseUp(), target: window },
      { on: "touchend", do: () => this.mouseUp(), target: window }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Qs);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Qs);
  }
};
var Im = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "counterContainer", staticClass: "counterContainer", class: { "desktop-screen": e.isDesktopScreen } }, [t("div", { staticClass: "icon", class: { "select-none": e.isMobileOrTablet }, on: { click: e.goToPreviousSlice, mousedown: function(i) {
    return e.mouseDownSlice(!0);
  }, touchstart: function(i) {
    return e.mouseDownSlice(!0);
  } } }, [t("LeftArrowSVG")], 1), t("p", { ref: "text-number-slice", staticClass: "number-of-slices", class: { isHidden: !e.inputIsHidden, "select-none": e.isMobileOrTablet }, on: { click: e.showInput } }, [e._v(" " + e._s(e.indexOfCurrentSlice) + "/" + e._s(e.numberOfSlices) + " ")]), t("input", { ref: "inputNumberSlice", staticClass: "input-slice", class: { isHidden: e.inputIsHidden }, attrs: { type: "text" }, on: { focusout: function(i) {
    return e.changeSlice(!0);
  }, focus: e.earnFocus, input: e.debounceChangeSlice, keydown: e.keyDownChangeSlice } }), t("div", { staticClass: "icon", class: { "select-none": e.isMobileOrTablet }, on: { click: e.goToNextSlice, mousedown: function(i) {
    return e.mouseDownSlice(!1);
  }, touchstart: function(i) {
    return e.mouseDownSlice(!1);
  } } }, [t("RightArrowSVG", { ref: "right-arrow" })], 1)]);
}, Cm = [], _m = /* @__PURE__ */ S(
  Em,
  Im,
  Cm,
  !1,
  null,
  "e69920f0"
);
const Tm = _m.exports, Sm = {
  name: "FullscreenSVG"
};
var bm = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.5 3.75C14.5 3.33579 14.8358 3 15.25 3H18.25C19.7688 3 21 4.23122 21 5.75V8.74939C21 9.16361 20.6642 9.49939 20.25 9.49939C19.8358 9.49939 19.5 9.16361 19.5 8.74939V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5H15.25C14.8358 4.5 14.5 4.16421 14.5 3.75Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V8.75C4.5 9.16421 4.16421 9.5 3.75 9.5C3.33579 9.5 3 9.16421 3 8.75V5.75C3 4.23122 4.23122 3 5.75 3H8.75061C9.16482 3 9.50061 3.33579 9.50061 3.75C9.50061 4.16421 9.16482 4.5 8.75061 4.5H5.75Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.5 20.2812C14.5 20.6955 14.8358 21.0312 15.25 21.0312H18.25C19.7688 21.0312 21 19.8 21 18.2812V15.2819C21 14.8676 20.6642 14.5319 20.25 14.5319C19.8358 14.5319 19.5 14.8676 19.5 15.2819V18.2812C19.5 18.9716 18.9404 19.5312 18.25 19.5312H15.25C14.8358 19.5312 14.5 19.867 14.5 20.2812Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.75 19.5312C5.05964 19.5312 4.5 18.9716 4.5 18.2812V15.2812C4.5 14.867 4.16421 14.5312 3.75 14.5312C3.33579 14.5312 3 14.867 3 15.2812V18.2812C3 19.8 4.23122 21.0312 5.75 21.0312H8.75061C9.16482 21.0312 9.50061 20.6955 9.50061 20.2812C9.50061 19.867 9.16482 19.5312 8.75061 19.5312H5.75Z", fill: "black" } })]);
}, Am = [], wm = /* @__PURE__ */ S(
  Sm,
  bm,
  Am,
  !1,
  null,
  "76c5ebe4"
);
const Lm = wm.exports, Om = {
  name: "FullscreenExitSVG"
};
var Mm = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M21 8.74939C21 9.16361 20.6642 9.49939 20.25 9.49939H17.25C15.7312 9.49939 14.5 8.26818 14.5 6.74939V3.75C14.5 3.33579 14.8358 3 15.25 3C15.6642 3 16 3.33579 16 3.75V6.74939C16 7.43975 16.5596 7.99939 17.25 7.99939H20.25C20.6642 7.99939 21 8.33518 21 8.74939Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.75061 8C7.44096 8 8.00061 7.44036 8.00061 6.75V3.75C8.00061 3.33579 8.33639 3 8.75061 3C9.16482 3 9.50061 3.33579 9.50061 3.75V6.75C9.50061 8.26879 8.26939 9.5 6.75061 9.5H3.75C3.33579 9.5 3 9.16422 3 8.75C3 8.33579 3.33579 8 3.75 8H6.75061Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M21 15.2819C21 14.8677 20.6642 14.5319 20.25 14.5319H17.25C15.7312 14.5319 14.5 15.7631 14.5 17.2819V20.2813C14.5 20.6955 14.8358 21.0313 15.25 21.0313C15.6642 21.0313 16 20.6955 16 20.2813V17.2819C16 16.5915 16.5596 16.0319 17.25 16.0319H20.25C20.6642 16.0319 21 15.6961 21 15.2819Z", fill: "black" } }), t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.75061 16.0313C7.44096 16.0313 8.00061 16.5909 8.00061 17.2813V20.2813C8.00061 20.6955 8.33639 21.0313 8.75061 21.0313C9.16482 21.0313 9.50061 20.6955 9.50061 20.2813V17.2813C9.50061 15.7625 8.26939 14.5313 6.75061 14.5313H3.75C3.33579 14.5313 3 14.867 3 15.2813C3 15.6955 3.33579 16.0313 3.75 16.0313H6.75061Z", fill: "black" } })]);
}, Nm = [], Rm = /* @__PURE__ */ S(
  Om,
  Mm,
  Nm,
  !1,
  null,
  "3d4e35b5"
);
const xm = Rm.exports;
let Ks = {};
const Dm = {
  name: "FullscreenButton",
  data() {
    return {
      fullscreen: !1
    };
  },
  components: { FullscreenExitSVG: xm, FullscreenSVG: Lm },
  computed: {
    isDesktopScreen() {
      return h.isDesktopScreen();
    }
  },
  methods: {
    toggleFullscreen() {
      this.$store.dispatch("anatomy/viewer:toggleFullscreen");
    }
  },
  created() {
    const { application: s } = z;
    Ks = h.createHooks([
      { on: s.RESIZED, do: async () => this.fullscreen = await this.$store.dispatch("anatomy/fullscreen:get") }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(Ks);
  },
  beforeDestroy() {
    h.onBeforeUnmount(Ks);
  }
};
var Pm = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "buttonContainer", staticClass: "button-container-screen", class: { "desktop-screen": e.isDesktopScreen } }, [t("button", { staticClass: "button-fullscreen", attrs: { title: `${e.$t("keyboard-panel.fullscreen")} (F)` }, on: { click: e.toggleFullscreen } }, [e.fullscreen ? e._e() : t("FullscreenSVG"), e.fullscreen ? t("FullscreenExitSVG") : e._e()], 1)]);
}, km = [], Hm = /* @__PURE__ */ S(
  Dm,
  Pm,
  km,
  !1,
  null,
  "3728b6a8"
);
const Fm = Hm.exports;
let qs = {};
const zm = {
  name: "image-progress-bar",
  props: {
    halfSizeThumbnail: 0
  },
  data() {
    return {
      currentDisplayedIndex: [],
      isLoading: !0,
      lastContrastCode: null
    };
  },
  computed: {
    images() {
      return this.$store.state.image.images;
    },
    isReady() {
      return this.$store.state.anatomy.isReady;
    },
    isZipMode() {
      return h.isZipMode();
    },
    isDisplayed() {
      return (s) => typeof this.currentDisplayedIndex[s] < "u";
    },
    numberOfSlices() {
      return this.$store.getters["anatomy/numberOfSlices"];
    }
  },
  methods: {
    checkIsLoading() {
      let s = !1;
      for (let e = 0; e < this.images.size; e++)
        typeof this.currentDisplayedIndex[e] < "u" && this.images.get(e) === !1 && (s = !0);
      this.isLoading = s;
    },
    updateSizeProgressBar(s) {
      this.$nextTick(() => {
        if (typeof this.$refs["progress-bar"] < "u") {
          const e = this.$refs["progress-bar"].children;
          s !== 0 && e.length > 0 && (e[0].style.minWidth = s + "px", e[this.numberOfSlices - 1].style.minWidth = s + "px");
        }
      });
    },
    redraw() {
      this.checkIsLoading(), this.$forceUpdate();
    }
  },
  created() {
    let e = null;
    const t = h.throttle(() => {
      this.redraw(), clearTimeout(e), e = setTimeout(() => {
        this.redraw();
      }, 600);
    }, 500), { application: i, slice: r, image: n, contrast: a } = z, o = h.debounce(() => this.updateSizeProgressBar(), 300);
    qs = h.createHooks([
      { on: "resize", do: o, target: window },
      { on: i.READY, do: () => this.$store.dispatch("image/set-images", this.numberOfSlices) },
      {
        on: r.SLICE_INDEX_CHANGE,
        do: () => {
          this.currentDisplayedIndex = this.$store.getters["anatomy/getSlicesIndexFromRelativeIndex"]();
        }
      },
      {
        on: n.IMAGE_SLICE_HAS_BEEN_LOADED,
        do: (l) => {
          this.images.set(l.detail - 1, !0), t();
        }
      },
      {
        on: a.SELECTED,
        do: () => {
          const l = this.$store.getters["anatomy/contrast:get-current-code"]();
          this.lastContrastCode !== l && this.$store.dispatch("image/image:clear-all"), this.lastContrastCode = l;
        }
      },
      { on: n.QUALITY_CHANGE, do: () => this.$store.dispatch("image/image:clear-all") }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(qs);
  },
  beforeDestroy() {
    h.onBeforeUnmount(qs);
  }
};
var Bm = function() {
  var e = this, t = e._self._c;
  return e.isReady && !e.isZipMode && e.isLoading ? t("div", { ref: "progress-bar", staticClass: "slice-progress-bar" }, e._l(e.images, function([i, r]) {
    return t("span", { key: i + 1, class: { loaded: r, hidden: !e.isDisplayed(i + 1) }, attrs: { "data-index": i + 1 } });
  }), 0) : e._e();
}, $m = [], Um = /* @__PURE__ */ S(
  zm,
  Bm,
  $m,
  !1,
  null,
  "6688e1d5"
);
const Vm = Um.exports, Gm = 43, jm = 4;
let Js = {};
const Ym = {
  name: "GalleryBottom",
  components: { ImageProgressBar: Vm },
  data() {
    return {
      displayPreview: !1,
      hideThumbnails: !1,
      mouseDown: !1,
      widthThumb: 0
    };
  },
  computed: {
    thumbnails() {
      return this.$store.getters["anatomy/getGalleryThumbnails"];
    },
    currentIndexSlice() {
      return this.$store.getters["anatomy/indexCurrentSlice"];
    },
    numberOfSlices() {
      return this.$store.getters["anatomy/numberOfSlices"];
    },
    previewThumbnail() {
      return this.$store.getters["anatomy/getPreviewThumbnail"];
    },
    notMobileOrTablet() {
      return !oe.isMobileOrTablet();
    },
    isSmallMobileScreen() {
      return h.isSmallMobileScreen();
    }
  },
  created() {
    const {
      application: s,
      slice: e,
      featureIsolate: t
    } = z, i = () => {
      this.refreshThumbnails(), this.updateIndicator(), this.$refs["progress-bar"].updateSizeProgressBar(this.getHalfSizeThumbnail());
    }, r = h.debounce(() => i(), 300);
    Js = h.createHooks([
      {
        on: "resize",
        do: r,
        target: window
      },
      {
        on: s.READY,
        do: i
      },
      {
        on: e.SLICE_INDEX_CHANGE,
        do: i
      },
      {
        on: e.CHANGE,
        do: () => this.updateIndicator()
      },
      {
        on: t.START_ISOLATE,
        do: () => this.updateIndicator()
      }
    ]);
  },
  updated() {
    this.updateIndicator();
  },
  beforeMount() {
    h.onBeforeMount(Js);
  },
  beforeUnmount() {
    h.onBeforeUnmount(Js);
  },
  methods: {
    refreshThumbnails() {
      const s = this.$refs["gallery-container"];
      this.$store.dispatch("anatomy/image:get-one").then(async (e) => {
        if (e !== null) {
          this.widthThumb = Math.round(e.width / e.height * Gm);
          const t = this.widthThumb + jm;
          typeof s < "u" && (this.hideThumbnails = !0, this.$nextTick(async () => {
            this.hideThumbnails = !1;
            const i = s.offsetWidth;
            i > t && await this.$store.dispatch("anatomy/thumbnails:refresh", {
              sizeThumbs: t,
              sizeAvailable: i
            });
          }));
        }
      });
    },
    updateIndicator() {
      const s = this.$refs["gallery-indicator"];
      if (typeof s < "u" && this.numberOfSlices > 0 && this.currentIndexSlice > 0) {
        const e = this.getIndicatorPosition(this.currentIndexSlice);
        s.style.marginLeft = `${e}px`;
      }
    },
    getHalfSizeThumbnail() {
      const e = this.$refs["thumbnails-container"].children[0];
      if (typeof e < "u") {
        const t = getComputedStyle(e);
        return (e.offsetWidth + parseInt(t.marginLeft) + parseInt(t.marginRight)) / 2;
      }
      return 0;
    },
    getIndicatorPosition(s) {
      const e = this.$refs["gallery-indicator"], t = this.$refs["thumbnails-container"];
      if (typeof e < "u" && typeof t < "u" && this.numberOfSlices > 0 && this.currentIndexSlice > 0 && t.childElementCount > 0) {
        const i = this.getHalfSizeThumbnail();
        if (t.childElementCount < this.numberOfSlices) {
          const r = t.clientWidth, n = r / t.childElementCount;
          return (r - n) / (this.numberOfSlices - 1) * (s - 1) + n / 2;
        } else
          return Math.round(t.offsetWidth / this.numberOfSlices) * s - (e.clientWidth * 0.5 + i);
      }
      return -1;
    },
    setWidthThumb() {
      const s = this.$refs["thumbnails-container"], e = Math.max(Math.ceil(s.offsetWidth) / 15, 100);
      typeof this.$refs["preview-thumb"] < "u" && (this.$refs["preview-thumb"].style.width = `${e}px`);
    },
    displaySliceHover(s) {
      this.displayPreview = !0, document.onmousemove = (e) => requestAnimationFrame(() => this.handleMouseMove(e)), document.onmouseup = (e) => this.mouseUpMoveToSlice(e), s.target.onmouseleave = (e) => this.hideSliceHover(e), this.setWidthThumb(), requestAnimationFrame(() => this.refreshPreviewThumb(s));
    },
    getPositionX(s) {
      const e = this.$refs["thumbnails-container"];
      return s.x - e.getBoundingClientRect().left;
    },
    refreshPreviewThumb(s) {
      const e = this.$refs["thumbnails-container"], t = this.$refs["preview-thumb"];
      if (typeof t > "u" || typeof e > "u")
        return;
      let i = this.getPositionX(s);
      (i < 0 || i > e.offsetWidth) && (i = Math.max(0, Math.min(i, e.offsetWidth)));
      const r = this.getSliceIndex(s);
      this.$store.dispatch("anatomy/thumbnails:preview", r), t.style.marginLeft = `${i}px`;
    },
    getSliceIndex(s) {
      const e = this.$refs["thumbnails-container"], t = this.getPositionX(s), i = this.getHalfSizeThumbnail();
      return Math.max(1, Math.min(Math.round(t / (e.offsetWidth - i) * this.numberOfSlices), this.numberOfSlices));
    },
    hideSliceHover(s) {
      s.target !== null && (s.target.onmouseleave = null), s.relatedTarget !== null && (s.relatedTarget.onmouseleave = null), this.isAuthorizedToMove(s.relatedTarget) ? s.target.onmouseleave = (e) => {
        this.hideSliceHover(e);
      } : this.displayPreview = !1;
    },
    isAuthorizedToMove(s) {
      return s !== null && typeof s.classList.contains == "function" && s.classList.contains("isAuthorizedToMove");
    },
    moveToSlice(s) {
      s !== null && (this.$store.dispatch("anatomy/gallery-bottom:image-click", s), this.$store.dispatch("anatomy/slice:set", { sliceIndex: s }));
    },
    mouseDownMoveToSlice() {
      this.mouseDown = !0, document.onmouseup = this.mouseUpMoveToSlice;
    },
    handleMouseMove(s) {
      this.mouseDown && this.moveToSlice(this.getSliceIndex(s)), this.displayPreview && this.refreshPreviewThumb(s);
    },
    mouseUpMoveToSlice(s) {
      const e = this.$store.getters["anatomy/currentSlice"], t = this.$store.getters["anatomy/relativeSliceIndexById"](e.id), i = this.getSliceIndex(s);
      this.displayPreview && this.mouseDown && t !== i && this.moveToSlice(i), document.onmouseup = null, this.mouseDown = !1;
    }
  }
};
var Wm = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "gallery-container", staticClass: "gallery-container", class: { hidden: e.isSmallMobileScreen } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: !e.hideThumbnails, expression: "!hideThumbnails" }], staticClass: "center" }, [t("svg", { ref: "gallery-indicator", staticClass: "gallery-indicator isAuthorizedToMove", attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1.03 25.02" } }, [t("line", { staticClass: "isAuthorizedToMove", staticStyle: { fill: "none", stroke: "#048ffd", "stroke-linecap": "square", "stroke-miterlimit": "10" }, attrs: { x1: "0.51", y1: "0.52", x2: "0.51", y2: "24.52" } })]), e.notMobileOrTablet ? t("div", { ref: "preview-thumb", staticClass: "preview-thumb isAuthorizedToMove", class: { "preview-thumb-hidden": !e.previewThumbnail.src || !e.displayPreview }, attrs: { title: `${e.previewThumbnail.title_1} - ${e.previewThumbnail.title_2} (${e.previewThumbnail.titleSeries})` }, on: { mouseenter: e.displaySliceHover, mousedown: e.mouseDownMoveToSlice } }, [t("p", { staticClass: "preview-thumb-title ellipsis-2-lines" }, [e._v(" " + e._s(e.previewThumbnail.title_1) + " - " + e._s(e.previewThumbnail.title_2) + " "), t("span", { staticClass: "title-series" }, [e._v("(" + e._s(e.previewThumbnail.titleSeries) + ")")])]), t("img", { staticClass: "preview-thumb-img", attrs: { src: e.previewThumbnail.src } })]) : e._e(), t("div", { ref: "thumbnails-container", staticClass: "thumbnails-container isAuthorizedToMove", on: { mouseenter: e.displaySliceHover, mousedown: e.mouseDownMoveToSlice } }, [e._l(e.thumbnails, function(i) {
    return t("div", { key: i, staticClass: "thumbnail", style: { width: e.widthThumb + "px" } }, [t("img", { staticClass: "thumbnail-img", attrs: { src: i, height: "43", width: e.widthThumb, alt: "" }, on: { load: e.updateIndicator } })]);
  }), t("image-progress-bar", { ref: "progress-bar" })], 2)])]);
}, Zm = [], Xm = /* @__PURE__ */ S(
  Ym,
  Wm,
  Zm,
  !1,
  null,
  "c6e135d3"
);
const Qm = Xm.exports, Km = {
  name: "GalleryLeftButton",
  components: { GallerySVG: qr },
  methods: {
    openGallery() {
      this.$store.dispatch("menu/gallery-left:show");
    }
  }
};
var qm = function() {
  var e = this, t = e._self._c;
  return t("button", { staticClass: "button-open-gallery", on: { click: e.openGallery } }, [t("GallerySVG", { staticClass: "gallery-left-icon" })], 1);
}, Jm = [], ef = /* @__PURE__ */ S(
  Km,
  qm,
  Jm,
  !1,
  null,
  "33769660"
);
const tf = ef.exports, sf = "data:image/png;base64,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", rf = "data:image/png;base64,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", nf = {
  name: "Gallery",
  components: {
    CounterSlice: Tm,
    FullscreenButton: Fm,
    GalleryBottom: Qm,
    GalleryLeftButton: tf
  },
  computed: {
    isSmallMobileScreen() {
      return h.isSmallMobileScreen();
    },
    haveApplicationUrl() {
      return h.url.applicationHomepage !== null && h.url.applicationHomepage.length > 0;
    },
    isVet() {
      return this.$store.getters["anatomy/application_id"] === Pe.VETANATOMY;
    },
    applicationIcon() {
      return this.isVet ? sf : rf;
    },
    applicationName() {
      return this.isVet ? this.$t("commons.vet-anatomy") : this.$t("commons.e-anatomy");
    }
  },
  methods: {
    goToApplicationHomepage() {
      const s = h.url.applicationHomepage;
      this.haveApplicationUrl && (h.isEmbed() ? this.$store.dispatch("dialog-popup/display", {
        title: this.$t("dialog.external-link-title"),
        message: this.$t("dialog.external-link-description"),
        displayCancelButton: !0,
        confirmCallback: () => window.open(`${F.baseURL}/${h.getSiteAccess()}/${s}`, "_blank")
      }) : this.$store.dispatch("anatomy/redirect:to", s));
    }
  }
};
var af = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "toolbar-bottom", staticClass: "gallery", class: { mobile: e.isSmallMobileScreen } }, [t("div", { staticClass: "application-icon-container" }, [t("img", { staticClass: "application-icon", class: { clickable: e.haveApplicationUrl }, attrs: { src: e.applicationIcon, alt: e.applicationName, title: e.applicationName }, on: { click: e.goToApplicationHomepage } })]), t("GalleryBottom"), t("div", { ref: "wrapper", staticClass: "wrapper" }, [t("div", { staticClass: "flex-content" }, [t("GalleryLeftButton"), t("CounterSlice"), t("FullscreenButton")], 1)])], 1);
}, of = [], lf = /* @__PURE__ */ S(
  nf,
  af,
  of,
  !1,
  null,
  null
);
const cf = lf.exports;
let ei = {};
const uf = {
  name: "SeriesTitle",
  data() {
    return {
      title: "",
      orientation: ""
    };
  },
  computed: {
    hasOrientation() {
      return this.orientation !== null && this.orientation.length > 0;
    }
  },
  created() {
    const {
      slice: s,
      series: e,
      language: t,
      translator: i
    } = z;
    ei = h.createHooks([
      {
        on: s.CHANGE,
        do: () => this.refreshTitle()
      },
      {
        on: e.CHANGE,
        do: () => this.refreshTitle()
      },
      {
        on: i.ADDED,
        do: () => this.refreshTitle()
      },
      {
        on: t.CHANGE,
        do: () => this.refreshTitle()
      },
      {
        on: t.LOADED,
        do: () => this.refreshTitle()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(ei);
  },
  beforeUnmount() {
    h.onBeforeUnmount(ei);
  },
  methods: {
    refreshTitle() {
      const s = this.$store.getters["anatomy/currentSlice"], e = this.$store.getters["anatomy/currentSeries"];
      this.title = this.getTitle(s, e), this.orientation = s.orientation;
    },
    getTitle(s, e) {
      return Hr.getSeriesTitle(s, e);
    }
  }
};
var df = function() {
  var e = this, t = e._self._c;
  return t("p", { staticClass: "title-series-background", attrs: { title: e.title } }, [t("span", { staticClass: "ellipsis" }, [e._v(e._s(e.title))]), e.hasOrientation ? t("span", { staticClass: "title-series ellipsis" }, [e._v(" (" + e._s(e.orientation) + ") ")]) : e._e()]);
}, hf = [], mf = /* @__PURE__ */ S(
  uf,
  df,
  hf,
  !1,
  null,
  "79f4c7be"
);
const ff = mf.exports, pf = {
  name: "HandleSVG"
};
var gf = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6.17 41.45" } }, [t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "1", x2: "6.17", y2: "1" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "6.63", x2: "6.17", y2: "6.63" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "12.26", x2: "6.17", y2: "12.26" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "17.89", x2: "6.17", y2: "17.89" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "23.52", x2: "6.17", y2: "23.52" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "29.15", x2: "6.17", y2: "29.15" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "34.77", x2: "6.17", y2: "34.77" } }), t("line", { staticStyle: { fill: "none", "stroke-miterlimit": "10", "stroke-width": "2px" }, attrs: { y1: "40.4", x2: "6.17", y2: "40.4" } })]);
}, vf = [], yf = /* @__PURE__ */ S(
  pf,
  gf,
  vf,
  !1,
  null,
  "8348814c"
);
const Ef = yf.exports;
let ti = {};
const Ye = 8, If = {
  name: "Draggable",
  components: { HandleSVG: Ef },
  inject: ["container"],
  props: {
    handleColor: {
      type: String,
      default() {
        return "#fff";
      }
    },
    positionLeft: {
      type: Number
    },
    positionTop: {
      type: Number
    }
  },
  data() {
    return {
      positions: {
        clientX: void 0,
        clientY: void 0,
        movementX: 0,
        movementY: 0
      },
      isDrag: !1,
      init: !0,
      hasBeenDrag: !1,
      ratioPositions: {
        left: null,
        top: null
      }
    };
  },
  created() {
    const { ui: s } = z;
    ti = h.createHooks([
      {
        on: s.SETTINGS.RESET,
        do: () => this.reset()
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(ti);
  },
  beforeUnmount() {
    h.onBeforeUnmount(ti);
  },
  updated() {
    (this.ratioPositions.left == null || this.ratioPositions.top == null) && this.setRationPositions(), this.init && (this.init = !1, this.updatePosition());
  },
  methods: {
    isNotDraggable() {
      const s = oe.isMobileOrTablet() || h.isLargeTabletScreen();
      return s && this.resetPosition(), s;
    },
    dragMouseDown(s) {
      this.isDrag = !0, s.preventDefault(), this.positions.clientX = s.clientX, this.positions.clientY = s.clientY, document.addEventListener("mousemove", this.elementDrag), document.addEventListener("mouseup", this.closeDragElement);
    },
    elementDrag(s) {
      this.hasBeenDrag = !0, s.preventDefault();
      const e = this.container.value, t = parseFloat(e.style.marginLeft) || 0, i = this.$refs.draggableContainer;
      let { offsetLeft: r } = i;
      this.positions.movementX = this.positions.clientX - s.clientX, this.positions.movementY = this.positions.clientY - s.clientY, this.positions.clientX = s.clientX, this.positions.clientY = s.clientY, r -= t, i.offsetTop - this.positions.movementY >= Ye && i.offsetLeft - this.positions.movementX >= Ye && i.offsetLeft - this.positions.movementX - t >= 0 && e.offsetWidth - Ye >= r - this.positions.movementX + i.offsetWidth && e.offsetHeight - Ye >= i.offsetTop - this.positions.movementY + i.offsetHeight && (this.$refs.draggableContainer.style.top = `${i.offsetTop - this.positions.movementY}px`, this.$refs.draggableContainer.style.left = `${i.offsetLeft - this.positions.movementX}px`), this.setRationPositions();
    },
    setRationPositions() {
      const s = this.container.value;
      this.ratioPositions.top = this.$refs.draggableContainer.offsetTop / s.offsetHeight, this.ratioPositions.left = this.$refs.draggableContainer.offsetLeft / s.offsetWidth;
    },
    closeDragElement() {
      this.isDrag = !1, document.removeEventListener("mousemove", this.elementDrag), document.removeEventListener("mouseup", this.closeDragElement);
    },
    updatePosition(s = null) {
      const e = this.container.value;
      let t, i;
      this.hasBeenDrag ? (t = Math.min(
        Math.max(this.ratioPositions.top * e.offsetHeight, Ye),
        e.offsetHeight - Ye - this.$refs.draggableContainer.offsetHeight
      ), i = Math.min(
        Math.max(this.ratioPositions.left * e.offsetWidth, Ye + e.offsetLeft),
        e.offsetLeft + e.offsetWidth - Ye - this.$refs.draggableContainer.offsetWidth
      )) : (s !== null ? i = s : i = this.$props.positionLeft, t = this.$props.positionTop), this.$refs.draggableContainer.style.top = `${t}px`, this.$refs.draggableContainer.style.left = `${i}px`;
    },
    resetPosition() {
      typeof this.$refs.draggableContainer < "u" && (this.$refs.draggableContainer.style.top = `${this.$props.positionTop}px`, this.$refs.draggableContainer.style.left = `${this.$props.positionLeft}px`), this.hasBeenDrag = !1;
    },
    reset() {
      this.resetPosition();
    },
    setStyle(s) {
      const e = this.$refs.draggableContainer;
      Object.keys(s).forEach((t) => {
        e.style[t] = s[t];
      });
    },
    getProperty(s) {
      return this.$refs.draggableContainer[s];
    }
  }
};
var Cf = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "draggableContainer", staticClass: "draggable-container", class: { hasBeenDrag: e.hasBeenDrag, mobile: e.isNotDraggable() } }, [e.isNotDraggable() ? e._e() : t("span", { staticClass: "drag-handle", class: { isGrabbed: e.isDrag }, on: { dblclick: e.resetPosition, mousedown: e.dragMouseDown } }, [t("HandleSVG")], 1), e._t("default")], 2);
}, _f = [], Tf = /* @__PURE__ */ S(
  If,
  Cf,
  _f,
  !1,
  null,
  null
);
const Sf = Tf.exports, bf = {
  name: "ActionButtons",
  components: {
    Draggable: Sf,
    ScrollSVG: Jr,
    PanSVG: en,
    ZoomSVG: tn
  },
  data() {
    return {
      savedOffset: 0,
      offsetLeft: 0,
      menuIsPinned: !1,
      INTERACTION: ke
    };
  },
  computed: {
    isDesktopScreen() {
      return h.isDesktopScreen();
    }
  },
  methods: {
    isSelected(s) {
      return this.$store.getters["action/currentInteraction"] === s;
    },
    changeInteraction(s) {
      this.$store.dispatch("action/interaction:change", s);
    }
  }
};
var Af = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "actionButtons", staticClass: "actionButtons box-shadow", class: { "desktop-screen": e.isDesktopScreen } }, [t("button", { staticClass: "button", class: { selected: e.isSelected(e.INTERACTION.SCROLL) }, attrs: { title: `${e.$t("keyboard-panel.scroll")} (A)` }, on: { click: function(i) {
    return e.changeInteraction(e.INTERACTION.SCROLL);
  } } }, [t("ScrollSVG", { staticClass: "svg" })], 1), t("button", { staticClass: "button", class: { selected: e.isSelected(e.INTERACTION.PAN) }, attrs: { title: `${e.$t("keyboard-panel.pan")} (E)` }, on: { click: function(i) {
    return e.changeInteraction(e.INTERACTION.PAN);
  } } }, [t("PanSVG", { staticClass: "svg" })], 1), t("button", { staticClass: "button", class: { selected: e.isSelected(e.INTERACTION.ZOOM) }, attrs: { title: `${e.$t("keyboard-panel.zoom")} (Z)` }, on: { click: function(i) {
    return e.changeInteraction(e.INTERACTION.ZOOM);
  } } }, [t("ZoomSVG", { staticClass: "svg" })], 1)]);
}, wf = [], Lf = /* @__PURE__ */ S(
  bf,
  Af,
  wf,
  !1,
  null,
  null
);
const Of = Lf.exports, Mf = {
  name: "CrossRefToggle",
  components: { ToggleDisplayCRSVG: Kr },
  computed: {
    showButton() {
      return !h.isMobileScreen() && this.$store.getters["anatomy/crossRefExists"] && (this.$store.state.menu.displayCrossReferencesPanel.display || !this.$store.state.menu.structurePanelIsOpen);
    },
    hideCrossRef() {
      return !this.$store.getters["menu/displayCrossReferencesPanel"].display;
    }
  },
  methods: {
    async togglePanel() {
      await this.$store.dispatch("menu/cross-references:toggle"), await this.$store.dispatch("menu/cross-references:notification", ie.CROSS_REFERENCES_BUTTON);
    }
  }
};
var Nf = function() {
  var e = this, t = e._self._c;
  return t("button", { directives: [{ name: "show", rawName: "v-show", value: e.showButton, expression: "showButton" }], ref: "crossRef-btn", staticClass: "button-toggleDisplay-crossRef", class: {
    "hide-crossRef": e.hideCrossRef
  }, on: { click: function(i) {
    return e.togglePanel();
  } } }, [t("ToggleDisplayCRSVG")], 1);
}, Rf = [], xf = /* @__PURE__ */ S(
  Mf,
  Nf,
  Rf,
  !1,
  null,
  "36864b70"
);
const Df = xf.exports, Pf = {
  name: "CheckSVG"
};
var kf = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" } }, [t("path", { attrs: { stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "1.5", d: "M4 10.9 10 17l10-10" } })]);
}, Hf = [], Ff = /* @__PURE__ */ S(
  Pf,
  kf,
  Hf,
  !1,
  null,
  null
);
const cn = Ff.exports, zf = At({
  name: "SeriesQuickSelectOption",
  components: {
    CheckIcon: cn
  },
  props: {
    series: {
      required: !0,
      type: Object
    },
    isSelected: {
      required: !0,
      type: Boolean
    },
    uuid: {
      required: !0,
      type: String
    }
  },
  methods: {
    select() {
      this.$emit("select", this.series.id);
    }
  }
});
var Bf = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { ref: "option", staticClass: "series-quick-select-option", class: { "is-selected": e.isSelected }, attrs: { id: `${e.uuid}_${e.series.id}`, "aria-label": e.$t("gallery.series"), role: "option", tabindex: "0" }, on: { click: e.select, keydown: [function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : e.select.apply(null, arguments);
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "space", 32, i.key, [" ", "Spacebar"]) ? null : e.select.apply(null, arguments);
  }] } }, [t("img", { staticClass: "image", attrs: { src: e.series.src, alt: e.series.name } }), t("span", { staticClass: "series-quick-select-option__name" }, [e._v(e._s(e.series.name))]), t("CheckIcon", { staticClass: "icon series-quick-select-option__selected-icon" })], 1);
}, $f = [], Uf = /* @__PURE__ */ S(
  zf,
  Bf,
  $f,
  !1,
  null,
  null
);
const Vf = Uf.exports, Gf = At({
  name: "SeriesQuickSelectAllOption",
  data() {
    return {
      numberOfLoadedImages: 0
    };
  },
  computed: {
    imagesAllSeries() {
      return this.$store.getters["anatomy/imageAllSeries"];
    },
    sourcedSeries() {
      return this.imagesAllSeries.filter((s) => s.src !== null);
    },
    displayAllSeries() {
      return this.imagesAllSeries.length > 0 && this.sourcedSeries.length && this.numberOfLoadedImages > 0;
    }
  },
  methods: {
    onImageLoaded() {
      this.numberOfLoadedImages++;
    }
  }
});
var jf = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "series-quick-select-option__all-series" }, [e._l(e.sourcedSeries, function(i) {
    return t("img", { directives: [{ name: "show", rawName: "v-show", value: e.displayAllSeries, expression: "displayAllSeries" }], staticClass: "series-quick-select-option__all-series__image", style: { "background-color": `#${i.background_color}` }, attrs: { src: i.src, alt: e.$t("gallery.all-series") }, on: { load: e.onImageLoaded } });
  }), e.displayAllSeries ? e._e() : t("div", { staticClass: "series-quick-select-option__all-series__placeholder" }, [e._m(0)])], 2);
}, Yf = [function() {
  var s = this, e = s._self._c;
  return s._self._setupProxy, e("div", { staticClass: "load-wrapper" }, [e("div", { staticClass: "activity" })]);
}], Wf = /* @__PURE__ */ S(
  Gf,
  jf,
  Yf,
  !1,
  null,
  null
);
const un = Wf.exports, Zf = At({
  name: "SeriesQuickSelectAllOption",
  components: { CheckIcon: cn, SeriesQuickSelectAllImages: un },
  props: {
    isSelected: {
      required: !0,
      type: Boolean
    }
  },
  emits: ["select"],
  methods: {
    select() {
      this.$emit("select");
    }
  }
});
var Xf = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "series-quick-select-option", class: { "is-selected": e.isSelected }, attrs: { "aria-label": e.$t("gallery.series"), role: "option", tabindex: "0" }, on: { click: e.select, keydown: [function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : e.select.apply(null, arguments);
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "space", 32, i.key, [" ", "Spacebar"]) ? null : e.select.apply(null, arguments);
  }] } }, [t("series-quick-select-all-images"), t("span", { staticClass: "series-quick-select-option__name" }, [e._v(e._s(e.$t("menu.series.all")))]), t("CheckIcon", { staticClass: "icon series-quick-select-option__selected-icon" })], 1);
}, Qf = [], Kf = /* @__PURE__ */ S(
  Zf,
  Xf,
  Qf,
  !1,
  null,
  null
);
const qf = Kf.exports, Jf = {
  name: "ArrowBottomSVG"
};
var ep = function() {
  var e = this, t = e._self._c;
  return t("svg", { attrs: { width: "12", height: "12", viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" } }, [t("g", { attrs: { id: "Stroke-16px/ArrowBottom" } }, [t("path", { attrs: { id: "Vector", d: "M9.97096 3.74965C9.67901 3.4577 9.20574 3.45744 8.91346 3.74908L6 6.65619L3.08654 3.74908C2.79426 3.45744 2.32099 3.4577 2.02904 3.74965C1.73686 4.04183 1.73686 4.51555 2.02904 4.80773L4.58579 7.36448C5.25245 8.03115 5.58579 8.36448 6 8.36448C6.41421 8.36448 6.74755 8.03114 7.41421 7.36448L9.97096 4.80773C10.2631 4.51555 10.2631 4.04183 9.97096 3.74965Z", fill: "currentColor" } })])]);
}, tp = [], sp = /* @__PURE__ */ S(
  Jf,
  ep,
  tp,
  !1,
  null,
  null
);
const ip = sp.exports, rp = At({
  name: "SeriesQuickSelect",
  components: {
    SeriesQuickSelectOption: Vf,
    SeriesQuickSelectAllOption: qf,
    ArrowBottomSVG: ip,
    SeriesQuickSelectAllImages: un
  },
  directives: { ClickOutside: De },
  data() {
    return {
      isOpen: !1,
      uuid: crypto.randomUUID()
    };
  },
  computed: {
    isFullSeries() {
      return this.$store.getters["anatomy/isModeFullSeries"] || this.$store.getters["anatomy/getIsolateStructureId"]() !== null;
    },
    seriesList() {
      return this.$store.getters["anatomy/seriesAndImagesList"];
    },
    currentSeries() {
      const s = this.$store.getters["anatomy/currentSeries"];
      return this.seriesList.find((e) => e.id === s.id) || null;
    },
    hasOptions() {
      return this.seriesList.length > 1;
    },
    output() {
      return this.isFullSeries ? this.$t("menu.series.all") : this.currentSeries.name;
    }
  },
  watch: {
    isOpen: [{
      handler: "watchIsOpen"
    }]
  },
  mounted() {
    this.uuid = crypto.randomUUID();
  },
  methods: {
    clickOutside(s) {
      s.composedPath().includes(this.$el) || (this.isOpen = !1);
    },
    toggleListBox() {
      if (this.isOpen) {
        this.isOpen = !1;
        return;
      }
      this.isOpen = !0, this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById(`${this.uuid}_${this.currentSeries?.id}`)?.focus();
        }, 100);
      });
    },
    onSelect(s) {
      this.$store.dispatch("anatomy/slice:notification", ie.RIGHT_MENU), this.$store.dispatch("anatomy/series:set", {
        seriesIndex: s,
        relativeSliceIndex: 1,
        keepMode: !1,
        placement: ie.SERIES_DROPDOWN
      }), this.isOpen = !1, this.$el.focus();
    },
    getOptionsList() {
      return this.$refs.listBox ? Array.from(this.$refs.listBox.querySelectorAll("[tabindex]")) : [];
    },
    focusOption(s) {
      if (!this.isOpen && s > 0) {
        this.isOpen = !0;
        return;
      }
      const e = this.getOptionsList(), i = e.indexOf(document.activeElement) + s;
      i === -1 && (this.isOpen = !1, this.$refs.combobox.focus()), i >= 0 && e[i % e.length]?.focus();
    },
    watchIsOpen(s) {
      s && this.$nextTick(() => {
        this.$refs.allSeriesOption.$el.focus();
      });
    },
    isSelected(s) {
      const e = this.$store.getters["anatomy/isModeFullSeries"] || this.$store.getters["anatomy/getIsolateStructureId"]() !== null, t = this.$store.getters["anatomy/currentSeries"];
      return e && s === -1 || !e && t.id === s;
    }
  }
});
var np = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { directives: [{ name: "show", rawName: "v-show", value: e.hasOptions, expression: "hasOptions" }, { name: "click-outside", rawName: "v-click-outside", value: e.clickOutside, expression: "clickOutside" }], staticClass: "series-quick-select__wrapper", on: { keydown: [function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "up", 38, i.key, ["Up", "ArrowUp"]) ? null : (i.stopPropagation(), i.preventDefault(), e.focusOption(-1));
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "down", 40, i.key, ["Down", "ArrowDown"]) ? null : (i.stopPropagation(), i.preventDefault(), e.focusOption(1));
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "left", 37, i.key, ["Left", "ArrowLeft"]) || "button" in i && i.button !== 0 ? null : (i.stopPropagation(), i.preventDefault(), e.focusOption(-1));
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "right", 39, i.key, ["Right", "ArrowRight"]) || "button" in i && i.button !== 2 ? null : (i.stopPropagation(), i.preventDefault(), e.focusOption(1));
  }, function(i) {
    i.stopPropagation();
  }], contextmenu: function(i) {
    i.stopPropagation();
  }, "!mousewheel": function(i) {
    i.stopPropagation();
  }, "!DOMMouseScroll": function(i) {
    i.stopPropagation();
  } } }, [t("output", { ref: "combobox", staticClass: "series-quick-select__output", attrs: { role: "combobox", "aria-expanded": e.isOpen, "aria-controls": "list_box", tabindex: "0" }, on: { click: e.toggleListBox, keydown: [function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "space", 32, i.key, [" ", "Spacebar"]) ? null : e.toggleListBox.apply(null, arguments);
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : e.toggleListBox.apply(null, arguments);
  }] } }, [e.isFullSeries ? t("SeriesQuickSelectAllImages") : t("img", { staticClass: "image", attrs: { src: e.currentSeries.src, alt: e.currentSeries.name } }), t("span", [e._v(e._s(e.output))]), t("ArrowBottomSVG", { staticClass: "icon" })], 1), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.isOpen, expression: "isOpen" }], ref: "listBox", staticClass: "series-quick-select__dropdown", attrs: { id: "list_box", role: "listBox", "aria-label": "select", "aria-activedescendant": e.currentSeries?.id }, on: { mousedown: function(i) {
    i.stopPropagation();
  }, mouseup: function(i) {
    i.stopPropagation();
  } } }, [t("div", { staticClass: "series-quick-select__scrollbox" }, [t("SeriesQuickSelectAllOption", { ref: "allSeriesOption", attrs: { "is-selected": e.isSelected(-1) }, on: { select: function(i) {
    return e.onSelect(-1);
  } } }), e._l(e.seriesList, function(i, r) {
    return t("SeriesQuickSelectOption", { key: i.id, ref: "individualSeriesOptions", refInFor: !0, attrs: { series: i, "is-selected": e.isSelected(i.id), uuid: e.uuid }, on: { select: function(n) {
      return e.onSelect(r + 1);
    } } });
  })], 2)])]);
}, ap = [], op = /* @__PURE__ */ S(
  rp,
  np,
  ap,
  !1,
  null,
  null
);
const lp = op.exports, pi = -1, cp = {
  name: "suggestions",
  inheritAttributes: !0,
  directives: { ClickOutside: De },
  props: {
    options: {
      type: Object,
      default: {}
    },
    onInputChange: {
      type: Function,
      required: !0
    },
    onItemSelected: {
      type: Function
    },
    value: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      extendedOptions: Object.assign({}, {
        debounce: 200,
        placeholder: "",
        inputClass: "input"
      }, this.options),
      query: this.value,
      lastSetQuery: null,
      lastQuerySearched: null,
      items: [],
      activeItemIndex: -1,
      showItems: !1
    };
  },
  computed: {
    show() {
      const s = this.items.length > 0 && this.showItems;
      return this.$emit("show", s), s;
    }
  },
  beforeMount() {
    this.extendedOptions.debounce !== 0 && (this.start = Date.now(), this.onQueryChanged = h.debounce(this.onQueryChanged, this.extendedOptions.debounce));
  },
  watch: {
    query: function(s) {
      s === this.lastSetQuery && s !== "" || (this.onQueryChanged(s), this.$emit("input", s));
    },
    value: function(s) {
      this.setInputQuery(s);
    }
  },
  methods: {
    onItemSelectedDefault(s) {
      typeof s == "string" && (this.$emit("input", s), this.setInputQuery(s), this.hideItems());
    },
    hideItems() {
      this.showItems = !1, this.blurInput();
    },
    setInputQuery(s) {
      this.lastSetQuery = s, this.query = s;
    },
    onKeyDown(s) {
      switch (this.$emit("keyDown", s.keyCode), s.keyCode) {
        case 40:
          this.highlightItem("down"), s.preventDefault();
          break;
        case 38:
          this.highlightItem("up"), s.preventDefault();
          break;
        case 13:
          this.selectItem(), s.preventDefault();
          break;
        case 27:
          this.showItems = !1, s.preventDefault();
          break;
        default:
          return !0;
      }
    },
    selectItem(s) {
      let e = null;
      if (typeof s > "u") {
        if (this.activeItemIndex === -1)
          return;
        e = this.items[this.activeItemIndex];
      } else
        e = this.items[s];
      !e || e.id === pi || (this.onItemSelected ? this.onItemSelected(e) : this.onItemSelectedDefault(e), this.hideItems());
    },
    highlightItem(s) {
      if (this.items.length === 0)
        return;
      let e = this.items.findIndex((n, a) => a === this.activeItemIndex);
      e === -1 ? s === "down" ? e = 0 : e = this.items.length - 1 : s === "down" ? (e++, e === this.items.length && (e = 0)) : (e--, e < 0 && (e = this.items.length - 1));
      const t = this.$refs.items.children[e], { isHidden: i, y: r } = h.isHiddenByOverflow(t);
      i && this.$refs.items.scrollTo({
        top: r,
        left: 0,
        behavior: "smooth"
      }), this.activeItemIndex = e;
    },
    setItems(s) {
      s.length === 0 && s.push({
        id: pi,
        name: this.$t("commons.no-results")
      }), this.items = s, this.activeItemIndex = -1, this.showItems = !0;
    },
    onQueryChanged(s) {
      if (s.length >= 1) {
        const e = this.onInputChange(s);
        if (typeof e > "u" || typeof e == "boolean" || e === null)
          return;
        this.items = [], e instanceof Array ? this.setItems(e) : typeof e.then == "function" && e.then((t) => {
          this.setItems(t);
        });
      } else
        this.items = [];
      this.lastQuerySearched = s;
    },
    blurInput() {
      this.$refs.input.blur();
    },
    focusInput() {
      this.$refs.input.focus();
    },
    clearItems() {
      this.items = [], this.activeItemIndex = -1;
    },
    onFocusInput() {
      this.lastQuerySearched !== null && ye(this.lastQuerySearched.toLowerCase()) !== ye(this.query.toLowerCase()) && (this.clearItems(), this.onQueryChanged(this.query)), this.showItems = !0;
    }
  }
};
var up = function() {
  var e = this, t = e._self._c;
  return t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.hideItems, expression: "hideItems" }], staticClass: "v-suggestions" }, [t("input", e._b({ directives: [{ name: "model", rawName: "v-model", value: e.query, expression: "query" }], ref: "input", class: e.extendedOptions.inputClass, attrs: { type: "text", autocomplete: "off", placeholder: e.extendedOptions.placeholder }, domProps: { value: e.query }, on: { keydown: e.onKeyDown, focus: e.onFocusInput, input: function(i) {
    i.target.composing || (e.query = i.target.value);
  } } }, "input", e.$attrs, !1)), t("div", { staticClass: "suggestions" }, [t("ul", { directives: [{ name: "show", rawName: "v-show", value: e.show, expression: "show" }], ref: "items", staticClass: "items" }, e._l(e.items, function(i, r) {
    return t("li", { key: r, staticClass: "item", class: { "is-active": r === e.activeItemIndex }, on: { click: function(n) {
      return n.preventDefault(), e.selectItem(r);
    } } }, [e._t("item", function() {
      return [e._v(" " + e._s(i) + " ")];
    }, { item: i })], 2);
  }), 0)])]);
}, dp = [], hp = /* @__PURE__ */ S(
  cp,
  up,
  dp,
  !1,
  null,
  "3e4e878a"
);
const mp = hp.exports, fp = {
  name: "SearchSVG"
};
var pp = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.0977 17.1915C14.7181 18.3218 12.9539 19 11.0312 19C6.61297 19 3.03125 15.4183 3.03125 11C3.03125 6.58172 6.61297 3 11.0312 3C15.4495 3 19.0312 6.58172 19.0312 11C19.0312 12.9555 18.3296 14.7471 17.1644 16.1369L20.7809 19.7534C21.0738 20.0463 21.0738 20.5211 20.7809 20.814C20.488 21.1069 20.0132 21.1069 19.7203 20.814L16.0977 17.1915ZM17.5313 11C17.5313 14.5899 14.6211 17.5 11.0312 17.5C7.4414 17.5 4.53125 14.5899 4.53125 11C4.53125 7.41015 7.4414 4.5 11.0312 4.5C14.6211 4.5 17.5313 7.41015 17.5313 11Z", fill: "black" } })]);
}, gp = [], vp = /* @__PURE__ */ S(
  fp,
  pp,
  gp,
  !1,
  null,
  "d62a812a"
);
const yp = vp.exports, Ep = {};
var Ip = function() {
  var e = this, t = e._self._c;
  return t("svg", { staticClass: "svg", attrs: { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [t("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.69133 3.29289C4.08185 2.90237 4.71502 2.90237 5.10554 3.29289L8.39844 6.58579L11.6913 3.29289C12.0819 2.90237 12.715 2.90237 13.1055 3.29289C13.4961 3.68342 13.4961 4.31658 13.1055 4.70711L9.81265 8L13.1055 11.2929C13.4961 11.6834 13.4961 12.3166 13.1055 12.7071C12.715 13.0976 12.0819 13.0976 11.6913 12.7071L8.39844 9.41421L5.10554 12.7071C4.71502 13.0976 4.08185 13.0976 3.69133 12.7071C3.30081 12.3166 3.30081 11.6834 3.69133 11.2929L6.98422 8L3.69133 4.70711C3.30081 4.31658 3.30081 3.68342 3.69133 3.29289Z", fill: "#D9D9D9" } })]);
}, Cp = [], _p = /* @__PURE__ */ S(
  Ep,
  Ip,
  Cp,
  !1,
  null,
  "28479e41"
);
const Tp = _p.exports;
let si = {};
const Sp = {
  name: "Search",
  components: {
    CloseSearchSVG: Tp,
    suggestions: mp,
    SearchSVG: yp
  },
  directives: { ClickOutside: De },
  inject: ["container"],
  data() {
    return {
      searchQuery: "",
      selectedSearchItem: null,
      options: {
        placeholder: this.$t("search.placeholder")
      },
      canSearch: !1,
      suggestionIsOpen: !1,
      isOpen: !1,
      isIsolate: !1,
      NO_RESULT_ID: pi
    };
  },
  computed: {
    structureLanguageIsNotLatin() {
      return this.$store.getters["anatomy/currentLanguageId"]() !== Z.la;
    },
    searchQueryIsEmpty() {
      return this.searchQuery === "";
    },
    displayButtonClose() {
      return !this.searchQueryIsEmpty || this.isIsolate;
    },
    isSmallSearch() {
      const s = this.$store.getters["viewer/viewer-width"];
      return Be.MOBILE <= s && s <= Be.LAPTOP;
    }
  },
  created() {
    const {
      featureIsolate: s,
      language: e,
      translator: t
    } = z;
    si = h.createHooks([
      {
        on: s.CLEAN_ISOLATE,
        do: () => this.clear()
      },
      {
        on: s.START_ISOLATE,
        do: (i) => this.startSearch(i.detail)
      },
      {
        on: [e.CHANGE, t.ADDED],
        do: () => {
          this.selectedSearchItem === null ? this.clear() : this.startSearch({
            structure_id: this.selectedSearchItem.id,
            preferredTaxonKey: this.selectedSearchItem.getTaxonKey()
          });
        }
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(si);
  },
  beforeUnmount() {
    h.onBeforeUnmount(si);
  },
  methods: {
    eventShowSuggestion(s) {
      this.suggestionIsOpen = s;
    },
    onInputChange(s) {
      if (this.canSearch) {
        if (this.selectedSearchItem = null, s = s.trim(), s.length === 0)
          return null;
        const e = this.$store.getters["anatomy/searchStructure"](s);
        return this.loadStructureIcons(e), e;
      }
      return null;
    },
    clickSearch() {
      this.isOpen === !1 && (this.isOpen = !0, this.$nextTick(() => this.$refs.suggestions.focusInput()));
    },
    onSearchItemSelected(s) {
      if (this.canSearch && (this.selectedSearchItem === null || s.id !== this.selectedSearchItem.id)) {
        const e = this.searchQuery;
        this.searchQuery = s.name, this.selectedSearchItem = s, this.$store.dispatch("core-context-menu/perform:isolate-structure", {
          structure_id: s.id,
          preferredTaxonKey: s.getTaxonKey(),
          source: Ke.SEARCH
        }), this.$store.dispatch("anatomy/application:search-click", { searchText: e });
      }
    },
    resetIsolate() {
      this.$store.dispatch("core-context-menu/perform:clear-isolate-structure");
    },
    clear() {
      this.selectedSearchItem = null, this.searchQuery = "", this.isOpen = !1, this.isIsolate = !1;
    },
    close() {
      this.searchQueryIsEmpty && !this.isIsolate && (this.isOpen = !1, this.$refs?.suggestions.blurInput());
    },
    canUserSearch() {
      this.$store.getters["anatomy/hasSubscriberAccess"]() ? (this.canSearch = !0, this.isOpen = !0) : this.$store.dispatch("menu/feature-premium:display");
    },
    startSearch({ structure_id: s, preferredTaxonKey: e }) {
      const t = this.$store.getters["anatomy/structureById"](s, e);
      this.searchQuery = t.name, this.selectedSearchItem = t, this.isOpen = !0, this.isIsolate = !0;
    },
    focusoutSearch() {
      this.isOpen && this.searchQueryIsEmpty && (this.isOpen = !1);
    },
    getStructureIcon(s) {
      return this.$store.getters["anatomy/getStructureIcon"](s);
    },
    highlightQuery(s) {
      if (this.searchQueryIsEmpty || s === null || typeof s > "u")
        return s;
      const e = this.searchQuery.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), t = [
        ...ye(s).matchAll(new RegExp(ye(e), "gi"))
      ], i = $i(this.searchQuery).length - this.searchQuery.length;
      return t.forEach((r, n) => {
        const a = i * n, o = r.index + a;
        s = s.substring(0, o) + $i(s.substring(o, o + this.searchQuery.length)) + s.substring(o + this.searchQuery.length);
      }), s;
    },
    textIsNotEmpty(s) {
      return s !== "";
    },
    loadStructureIcons(s) {
      s.forEach((e) => {
        this.getStructureIcon(e).then((t) => this.$set(e, "iconSrc", t));
      });
    }
  }
};
var bp = function() {
  var e = this, t = e._self._c;
  return t("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: e.close, expression: "close" }], ref: "search-container", staticClass: "search-container box-shadow", class: {
    "small-search": e.isSmallSearch,
    open: e.isOpen
  } }, [t("SearchSVG", { staticClass: "search-svg", nativeOn: { click: function(i) {
    return e.clickSearch.apply(null, arguments);
  } } }), t("suggestions", { ref: "suggestions", attrs: { options: e.options, "on-input-change": e.onInputChange, "on-item-selected": e.onSearchItemSelected }, on: { show: e.eventShowSuggestion }, nativeOn: { focusin: function(i) {
    return e.canUserSearch.apply(null, arguments);
  }, focusout: function(i) {
    return e.focusoutSearch.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "item", fn: function(i) {
    return [i.item.id !== e.NO_RESULT_ID ? t("div", { staticClass: "single-item", attrs: { title: i.item.name } }, [i.item.iconSrc ? t("img", { attrs: { src: i.item.iconSrc, alt: i.item.name } }) : e._e(), t("div", { staticClass: "suggestion-structure-item" }, [t("span", { staticClass: "suggestion-structure-name", domProps: { innerHTML: e._s(e.highlightQuery(i.item.name)) } }), e.textIsNotEmpty(i.item.latin_name) && e.structureLanguageIsNotLatin ? t("span", { staticClass: "suggestion-structure-latin-name", domProps: { innerHTML: e._s(e.highlightQuery(i.item.latin_name)) } }) : e._e(), e.textIsNotEmpty(i.item.associated_terms) ? t("span", { staticClass: "suggestion-structure-associated_terms", domProps: { innerHTML: e._s(e.highlightQuery(i.item.associated_terms)) } }) : e._e()])]) : t("div", { staticClass: "single-item" }, [t("span", { staticClass: "suggestion-structure-name" }, [e._v(e._s(i.item.name))])])];
  } }]), model: { value: e.searchQuery, callback: function(i) {
    e.searchQuery = i;
  }, expression: "searchQuery" } }), e.displayButtonClose ? t("CloseSearchSVG", { staticClass: "close-svg", nativeOn: { click: function(i) {
    return e.resetIsolate.apply(null, arguments);
  } } }) : e._e()], 1);
}, Ap = [], wp = /* @__PURE__ */ S(
  Sp,
  bp,
  Ap,
  !1,
  null,
  null
);
const Lp = wp.exports, Op = {
  __name: "proxy-banner",
  setup(s) {
    async function e() {
      if (!h.isIMAIOSDomain() && typeof window.imageTestProxyUrl < "u")
        try {
          await fetch(window.imageTestProxyUrl);
        } catch (r) {
          if (r.message === "Failed to fetch")
            return !0;
        }
      return !1;
    }
    const t = gn(!1), i = window.ezProxyLink ?? "";
    return vn(async () => {
      t.value = await e();
    }), { __sfc: !0, checkIfUseProxy: e, proxyDetected: t, link: i };
  }
};
var Mp = function() {
  var e = this, t = e._self._c, i = e._self._setupProxy;
  return i.proxyDetected ? t("div", { staticClass: "proxy-banner" }, [t("div", { staticClass: "proxy-banner-text" }, [t("p", { domProps: { innerHTML: e._s(e.$t("proxy-banner.update-config", { link: i.link })) } })])]) : e._e();
}, Np = [], Rp = /* @__PURE__ */ S(
  Op,
  Mp,
  Np,
  !1,
  null,
  "53416aed"
);
const xp = Rp.exports, Dp = '"Open Sans", sans-serif', Pp = "--body-font-family", ir = {
  labelFontFamilyDefault: Dp,
  labelFontFamilyPropertyName: Pp
};
let ii = {};
const kp = {
  name: "AnatomyViewer",
  components: {
    ProxyBanner: xp,
    Search: Lp,
    SeriesQuickSelect: lp,
    CrossRefToggle: Df,
    ActionButtons: Of,
    SeriesTitle: ff,
    Gallery: cf,
    MenuToggle: ym,
    PanelStructure: lm,
    ShortcutsPanel: Ih,
    FeaturePremium: th,
    PremiumBanner: Qd,
    OrientationPicture: jd,
    GalleryLeft: qu,
    CrossReferences: Vu,
    ViewerMenu: Su,
    ContextMenu: sn
  },
  provide() {
    const s = {};
    Object.defineProperty(s, "value", {
      enumerable: !0,
      get: () => this.$refs.container
    });
    const e = {};
    return Object.defineProperty(e, "value", {
      enumerable: !0,
      get: () => this.$refs.viewer
    }), {
      container: s,
      viewer: e
    };
  },
  data() {
    return {
      menuRef: {},
      crossRef: {},
      refViewer: null,
      pointerHasMoveWhenWasDown: !1,
      pointerIsDown: !1,
      initialized: !1,
      obs: null,
      enableFakeResize: !1,
      topBarBackground: at.DARK
    };
  },
  computed: {
    application_id() {
      return `${this.$store.getters["anatomy/getParentContainerId"]}-anatomy-container`;
    },
    contextMenu_id() {
      return `${this.$store.getters["anatomy/getParentContainerId"]}-anatomy-context-menu`;
    },
    isLargeTabletScreen() {
      return h.isLargeTabletScreen();
    },
    rightPanelWidth() {
      return this.$store.state.menu.menuIsOpen && this.$store.state.menu.menuIsPinned ? "350px" : "0px";
    },
    structurePanelWidth() {
      return this.$store.state.menu.structurePanelIsOpen ? "410px" : "0";
    },
    crossRefPanelWidth() {
      return this.$store.state.menu.displayCrossReferencesPanel.display ? "min(max(200px, 12%), 20%)" : "0";
    },
    isPhone() {
      return h.isMobileScreen();
    },
    isTablet() {
      return h.isLaptopScreen();
    },
    isRightPanelPinned() {
      return this.$store.state.menu.menuIsPinned && this.$store.state.menu.menuIsOpen;
    },
    hideSeriesSelector() {
      return this.$store.getters["anatomy/seriesAndImagesList"].length <= 1;
    }
  },
  mounted() {
    this.$store.dispatch("anatomy/create", {
      container_id: this.application_id,
      parentContainer_id: this.$store.getters["anatomy/getParentContainerId"],
      fontFamily: getComputedStyle(document.body).getPropertyValue(ir.labelFontFamilyPropertyName) || ir.labelFontFamilyDefault
    }), this.$store.dispatch("viewer/viewer:set-size", {
      width: this.$refs.viewer.offsetWidth,
      height: this.$refs.viewer.offsetHeight
    }), this.$store.dispatch("viewer/viewer:set-top", this.$refs.viewer.getBoundingClientRect().top), this.$store.dispatch("viewer/viewer:set-left", this.$refs.viewer.getBoundingClientRect().left), this.$store.dispatch("viewer/container:set-size", {
      width: this.$refs.container.offsetWidth,
      height: this.$refs.container.offsetHeight
    }), this.$store.dispatch("shortcut/refresh-shortcuts");
    const { ui: s } = z;
    h.emit(s.VIEWER.MOUNTED), this.$nextTick(() => {
      this.initialized = !0;
    });
  },
  created() {
    const {
      series: s,
      application: e,
      ui: t,
      pointerHandler: i
    } = z;
    ii = h.createHooks([
      {
        on: e.RESIZED,
        do: () => {
          this.$store.dispatch("viewer/viewer:set-size", {
            width: this.$refs.viewer.offsetWidth,
            height: this.$refs.viewer.offsetHeight
          }), this.$store.dispatch("viewer/viewer:set-top", this.$refs.viewer.getBoundingClientRect().top), this.$store.dispatch("viewer/viewer:set-left", this.$refs.viewer.getBoundingClientRect().left), this.$store.dispatch("viewer/container:set-size", {
            width: this.$refs.container.offsetWidth,
            height: this.$refs.container.offsetHeight
          }), h.emit(t.VIEWER.HAS_BEEN_RESIZED);
        }
      },
      {
        on: s.CHANGE,
        do: () => this.checkTheme()
      },
      {
        on: i.DOWN,
        do: () => this.pointerIsDown = !0
      },
      {
        on: i.MOVE,
        do: () => {
          this.pointerIsDown && (this.pointerHasMoveWhenWasDown = !0);
        }
      },
      {
        on: i.UP,
        do: (r) => {
          (r.detail.button === wt.RIGHT_CLICK && !this.pointerHasMoveWhenWasDown || oe.isMacOS() && r.detail.ctrlKey) && this.openContextMenu(r.detail), this.pointerIsDown = !1, this.pointerHasMoveWhenWasDown = !1;
        }
      }
    ]);
  },
  beforeMount() {
    h.onBeforeMount(ii);
  },
  beforeUnmount() {
    h.onBeforeUnmount(ii);
  },
  methods: {
    openContextMenu(s) {
      this.$refs["anatomy-context-menu"].show(s);
    },
    checkTheme() {
      const s = this.$store.getters["anatomy/currentSeries"], e = this.$store.getters["anatomy/moduleName"];
      this.topBarBackground = h.setThemeByModality(s.modality_id, e);
      const t = h.getBackgroundColor(s.modality_id);
      this.$refs.viewer.style.backgroundColor = t, this.$refs["parent-container"].style.borderColor = t;
    },
    resizeViewer(s) {
      s.target === this.$refs.viewer && s.propertyName === "grid-template-columns" && this.$store.dispatch("anatomy/viewer:resize");
    }
  }
};
var Hp = function() {
  var e = this, t = e._self._c;
  return t("div", { ref: "viewer", staticClass: "viewer", class: [{
    transitions: e.initialized,
    phone: e.isPhone,
    tablet: e.isTablet,
    "right-pinned": e.isRightPanelPinned,
    "no-select": e.hideSeriesSelector
  }, e.topBarBackground], style: {
    "--menu-outer-width": e.rightPanelWidth,
    "--structure-width": e.structurePanelWidth,
    "--crossref-width": e.crossRefPanelWidth
  }, on: { transitionend: e.resizeViewer } }, [t("section", { ref: "parent-container", staticClass: "parent-container viewer-zone", class: { "large-tablet-screen": e.isLargeTabletScreen } }, [t("div", { ref: "container", staticClass: "container-viewer", attrs: { id: e.application_id } }), t("orientation-picture")], 1), t("shortcuts-panel"), t("feature-premium"), t("context-menu", { ref: "anatomy-context-menu", attrs: { "element-id": e.contextMenu_id, "store-handler": "core-context-menu" } }), t("panel-structure", { staticClass: "left-panel" }), t("CrossReferences", { ref: "crossReferences", staticClass: "left-panel" }), t("GalleryLeft"), t("PremiumBanner", { ref: "premiumBanner", class: { "premium-banner": !e.isRightPanelPinned, "premium-banner-pinned": e.isRightPanelPinned } }), t("proxy-banner", { staticClass: "proxy-banner" }), t("div", { staticClass: "background", attrs: { "aria-hidden": "true" } }), t("SeriesTitle", { staticClass: "series-title topbar" }), t("CrossRefToggle", { staticClass: "crossref-toggle topbar" }), t("Search", { staticClass: "search topbar" }), e.isPhone ? e._e() : t("SeriesQuickSelect", { staticClass: "series-quick-select topbar" }), t("ActionButtons", { staticClass: "action-buttons topbar" }), t("MenuToggle", { staticClass: "menu-button topbar" }), t("ViewerMenu", { ref: "menu", staticClass: "menu" }), t("Gallery")], 1);
}, Fp = [], zp = /* @__PURE__ */ S(
  kp,
  Hp,
  Fp,
  !1,
  null,
  null
);
const Bp = zp.exports, $p = {
  name: "BannerIE",
  computed: {
    isIE() {
      return oe.getIEVersion() !== 0;
    }
  }
};
var Up = function() {
  var e = this, t = e._self._c;
  return e.isIE ? t("div", { staticClass: "banner-container-ie" }, [t("div", { staticClass: "ie-icon" }, [t("svg", { staticClass: "svg-icon", attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 45 44", width: "45", height: "44" } }, [t("path", { attrs: { d: "M 41.9943 13.1676 C 44.0511 8.23147 44.1882 4.11806 41.7201 1.65001 C 38.9778 -1.09044 32.3964 -0.269582 25.4054 3.02115 H 24.5827 C 19.6466 3.02115 14.8495 4.80545 11.2845 7.95724 C 8.26804 10.6995 6.07422 14.2645 5.11442 18.2408 C 5.79999 17.4181 9.63917 12.8933 14.0268 10.4253 C 14.1639 10.4253 15.2608 9.73972 15.2608 9.73972 C 15.1237 9.73972 13.067 11.7964 12.6557 12.2078 C 3.05772 22.08 -2.56212 37.0235 1.82552 41.4093 C 4.70308 44.2887 9.9134 43.6031 15.9464 40.3124 C 18.5516 41.5464 21.431 42.0949 24.5827 42.0949 C 28.6961 42.0949 32.5353 40.998 35.8261 38.8042 C 39.2521 36.6103 41.7201 33.1843 43.2302 29.208 H 32.5353 C 31.1642 31.8132 28.0106 33.5957 24.7199 33.5957 C 20.058 33.5957 16.2188 29.7565 16.0835 25.3689 V 24.9575 H 44.0511 V 24.5462 C 44.0511 23.8606 44.1882 23.0379 44.1882 22.4913 C 44.1882 19.2006 43.3655 16.0469 41.9943 13.1676 V 13.1676 Z M 4.84019 40.5885 C 2.64638 38.3946 3.33377 34.146 5.9371 29.0727 C 7.17113 32.5006 9.22783 35.5171 11.833 37.7109 C 12.6557 38.3965 13.6155 39.082 14.5753 39.6305 C 10.1876 41.9596 6.62267 42.3728 4.84019 40.5885 V 40.5885 Z M 32.9467 19.7508 H 16.2206 V 19.6137 C 16.4949 15.3632 20.4693 11.6611 25.1312 11.6611 C 29.5188 11.6611 33.0838 15.089 33.358 19.6137 V 19.7508 H 32.9467 Z M 41.3088 12.0725 C 40.4861 10.7013 39.3892 9.33021 38.1552 8.2333 C 36.2433 6.45558 34.0094 5.05943 31.5737 4.11988 C 35.9613 2.06501 39.6634 1.79078 41.583 3.71037 C 43.0913 5.49285 42.9541 8.50752 41.3088 12.0725 C 41.3088 12.2096 41.3088 12.2096 41.3088 12.0725 C 41.3088 12.2096 41.3088 12.2096 41.3088 12.0725 V 12.0725 Z" } })])]), t("div", { staticClass: "banner-text-container" }, [t("p", { domProps: { innerHTML: e._s(e.$t("ie.banner.features-not-available")) } }), t("p", { domProps: { innerHTML: e._s(e.$t("ie.banner.upgrade-full-message")) } })])]) : e._e();
}, Vp = [], Gp = /* @__PURE__ */ S(
  $p,
  Up,
  Vp,
  !1,
  null,
  "646aa318"
);
const jp = Gp.exports, Yp = At({
  name: "favorites-dialog-popup",
  data() {
    return {
      title: "",
      description: ""
    };
  },
  computed: {
    showError() {
      return this.$store.getters["dialog-popup/display-input-error"];
    }
  }
});
var Wp = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("input", { directives: [{ name: "model", rawName: "v-model", value: e.title, expression: "title" }], staticClass: "input", attrs: { type: "text" }, domProps: { value: e.title }, on: { input: function(i) {
    i.target.composing || (e.title = i.target.value);
  } } }), t("textarea", { directives: [{ name: "model", rawName: "v-model", value: e.description, expression: "description" }], staticClass: "input", attrs: { type: "text", cols: "10", rows: "5" }, domProps: { value: e.description }, on: { input: function(i) {
    i.target.composing || (e.description = i.target.value);
  } } }), e.showError ? t("p", { staticClass: "error-message" }, [e._v(" " + e._s(e.$t("dialog.input.error")) + " ")]) : e._e()]);
}, Zp = [], Xp = /* @__PURE__ */ S(
  Yp,
  Wp,
  Zp,
  !1,
  null,
  "8f630e2d"
);
const Qp = Xp.exports, Kp = {
  name: "DialogPopup",
  components: { FavoritesDialogPopup: Qp },
  computed: {
    title() {
      return this.$store.getters["dialog-popup/title"];
    },
    message() {
      return this.$store.getters["dialog-popup/message"];
    },
    display() {
      return this.$store.getters["dialog-popup/display-dialog"];
    },
    displayCancelButton() {
      return this.$store.getters["dialog-popup/display-cancel-button"];
    },
    displayInput() {
      return this.$store.getters["dialog-popup/display-input"];
    },
    inputValue() {
      return this.$store.getters["dialog-popup/input"];
    }
  },
  methods: {
    cancel() {
      this.$store.dispatch("dialog-popup/cancel");
    },
    confirm() {
      if (this.displayInput && this.inputValue !== "") {
        this.$store.dispatch("dialog-popup/displayError");
        return;
      }
      this.$store.dispatch("dialog-popup/confirm");
    }
  }
};
var qp = function() {
  var e = this, t = e._self._c;
  return e.display ? t("div", { staticClass: "dialog-popup-background" }, [t("div", { staticClass: "dialog-popup-container" }, [t("div", { staticClass: "title" }, [e._v(" " + e._s(e.title) + " ")]), t("div", { staticClass: "message" }, [e._v(" " + e._s(e.message) + " ")]), e.displayInput ? t("favorites-dialog-popup") : e._e(), t("div", { staticClass: "button-container" }, [t("button", { staticClass: "button button-confirm", on: { click: e.confirm } }, [e._v(" " + e._s(e.$t("dialog.ok")) + " ")]), e.displayCancelButton ? t("button", { staticClass: "button button-cancel", on: { click: e.cancel } }, [e._v(" " + e._s(e.$t("dialog.cancel")) + " ")]) : e._e()])], 1)]) : e._e();
}, Jp = [], eg = /* @__PURE__ */ S(
  Kp,
  qp,
  Jp,
  !1,
  null,
  "31bd4208"
);
const rr = eg.exports;
let ri = {};
const tg = {
  components: {
    DialogPopup: rr,
    ErrorPopup: rr,
    BannerIE: jp,
    AnatomyViewer: Bp,
    LoaderCube: bi
  },
  props: ["id", "application", "moduleId", "title", "language"],
  data() {
    return {
      isFirstWSError: !0
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    loadingMessage() {
      return this.$store.state.loadingMessage || this.$t("loader.loading");
    },
    coverImageModule() {
      return this.$store.getters["anatomy/coverImage"] || null;
    },
    getBackgroundColor() {
      return this.$store.getters["anatomy/backgroundColor"] || "#8c8c8c";
    }
  },
  created() {
    const s = this.$store, {
      filter: e,
      contrast: t,
      translator: i,
      interaction: r,
      series: n,
      language: a,
      slice: o,
      application: l
    } = z;
    s.dispatch("anatomy/set-parent-id", this.id);
    const c = this.language || h.getSiteAccess();
    this.$i18n.locale = h.transformSiteAccessToLocal(c), s.dispatch("anatomy/application:set-interface-language", Z[c]), this.$store.dispatch("anatomy/application:initialize", {
      application: this.application,
      moduleId: this.moduleId,
      language: c
    }), ri = h.createHooks([
      {
        on: l.ERROR,
        do: (u) => {
          const m = h.getErrorCode(u.detail.from);
          h.sendApplicationError(u.detail.error, m), this.isLoading && this.isFirstWSError ? (this.isFirstWSError = !1, s.dispatch("dialog-popup/display", {
            title: this.$t("error.title"),
            message: this.$t("error.commons", { errorCode: m }),
            displayCancelButton: !1
          })) : this.isLoading || s.dispatch("dialog-popup/display", {
            title: this.$t("error.title"),
            message: this.$t("error.commons", { errorCode: m }),
            displayCancelButton: !1
          });
        }
      },
      {
        on: l.MODULE_DATA_LOADED,
        do: (u) => {
          s.dispatch("anatomy/application:set-background-color"), s.dispatch("anatomy/application:set-cover-image"), s.dispatch("anatomy/application:set-module-name", u.detail.moduleName);
        }
      },
      {
        on: l.READY,
        do: () => s.commit("stopLoading")
      },
      {
        on: [l.FONT_SIZE_UPDATED, l.RENDERING_FIRST_FRAME],
        do: () => s.dispatch("anatomy/font-size:update")
      },
      {
        on: e.LOADED,
        do: () => s.dispatch("anatomy/filter:update")
      },
      {
        on: t.LOADED,
        do: () => {
          s.dispatch("anatomy/contrast:update-other-series-have-more-than-one-contrast"), s.dispatch("anatomy/contrast:update");
        }
      },
      {
        on: i.ADDED,
        do: () => {
          s.dispatch("anatomy/slice:update"), s.dispatch("anatomy/series:update"), s.dispatch("anatomy/filter:update"), s.dispatch("anatomy/contrast:update");
        }
      },
      {
        on: r.CHANGE,
        do: () => s.dispatch("action/interaction:update")
      },
      {
        on: n.CHANGE,
        do: () => {
          s.dispatch("anatomy/series:update"), s.dispatch("anatomy/contrast:update");
        }
      },
      {
        on: a.LOADED,
        do: () => {
          s.dispatch("anatomy/language:get"), s.dispatch("anatomy/slice:update"), s.dispatch("anatomy/series:update"), s.dispatch("anatomy/contrast:update"), s.dispatch("anatomy/filter:update");
        }
      },
      {
        on: a.CHANGE,
        do: () => {
          s.dispatch("anatomy/language:get"), s.dispatch("anatomy/slice:update"), s.dispatch("anatomy/series:update"), s.dispatch("anatomy/filter:update"), s.dispatch("anatomy/contrast:update");
        }
      },
      {
        on: o.CHANGE,
        do: () => s.dispatch("anatomy/slice:update")
      },
      {
        on: o.SLICE_INDEX_CHANGE,
        do: () => {
          s.dispatch("anatomy/slice:updateRelativeIndex"), s.dispatch("anatomy/application:update-mode-series");
        }
      },
      {
        on: t.SELECTED,
        do: () => s.dispatch("anatomy/contrast:update")
      }
    ]);
  },
  mounted() {
    this.$store.commit("startLoading", this.title);
  },
  beforeMount() {
    h.onBeforeMount(ri);
  },
  beforeUnmount() {
    h.onBeforeUnmount(ri);
  }
};
var sg = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "imaios-app-container", attrs: { id: e.id } }, [t("BannerIE"), t("AnatomyViewer"), t("dialog-popup"), e.isLoading ? t("div", { staticClass: "loader-container", style: { background: e.getBackgroundColor } }, [t("LoaderCube", { staticClass: "loader", attrs: { "message-label": e.loadingMessage } }), t("img", { staticClass: "image-cover", class: { loading: e.coverImageModule === null }, attrs: { src: e.coverImageModule, alt: e.moduleId } })], 1) : e._e()], 1);
}, ig = [], rg = /* @__PURE__ */ S(
  tg,
  sg,
  ig,
  !1,
  null,
  null
);
const ng = rg.exports;
class dn extends Error {
  constructor(e) {
    super(`Unable to find Element with selector "${e}".`), this.name = this.constructor.name;
  }
}
class ag extends Error {
  constructor(e) {
    super(e), this.name = this.constructor.name;
  }
}
const og = (s, e) => {
  const t = e.pointerState, i = {
    width: e.width,
    height: e.height,
    pointerState: t,
    container: s.container,
    // do not create dedicated controller. Viewer component will dispatch each event to our components.
    useController: !1,
    ...e
  };
  s.components = {
    imageCanvas: new ue({
      name: "image-canvas",
      _id: "anatomy-canvas",
      ...i
    }),
    overlaysCanvas: new ue({
      name: "overlays-canvas",
      ...i
    }),
    pointsCanvas: new yt({
      ...i,
      paddingTop: Tt
    }),
    fakeImaiosCanvas: new ue({
      name: "fake-canvas",
      ...i
    }),
    leftLinesCanvas: new ue({
      name: "left-lines-canvas",
      paddingTop: Tt,
      paddingBottom: Oi,
      ...i
    }),
    rightLinesCanvas: new ue({
      name: "right-lines-canvas",
      paddingTop: Tt,
      paddingBottom: Oi,
      ...i
    })
  }, s.components.viewzone = new qe({
    name: "view-zone-canvas",
    ...i
  }), Object.values(s.components).forEach((r) => {
    s.ui.container.appendChild(r.ui.wrapper);
  });
};
class lg {
  /** @param {string | null} containerId **/
  retrieveContainer(e = null) {
    if (e === null)
      throw new ag();
    const t = document.getElementById(e);
    if (t === null)
      throw new dn(e);
    return t;
  }
  generateComponents(e, t) {
    og(e, t);
  }
}
const ge = {
  TOOLBAR_HEIGHT: 32,
  SERIES_TITLE_HEIGHT: 25,
  CROSS_REF_TITLE_HEIGHT: 18,
  LINE_INTERVAL_PX: 2,
  MAX_FONT_PX: 20,
  BASE_MAX_FONT_PX: 20,
  MAX_LABEL_LINES: 2,
  FONT_FAMILY: "'Helvetica Neue', Helvetica, arial, verdana, 'lucida sans unicode', tahoma, sans-serif",
  TEXT_TO_VERTICAL_LINE_PADDING: 7,
  VERTICAL_LINE_PADDING: 4,
  TEXT_PADDING: 4,
  // Padding from vertical bar (ex: -| Cranium)
  MARGIN: 10,
  LABELS_ISOLATE_ALPHA: "1.5",
  LABELS_WEAK_ALPHA: "0.4",
  LABELS_FULL_ALPHA: "1.0",
  LABELS_EDGE_ALPHA: "0.3",
  PIN_WEAK_ALPHA: 0.4,
  LEFT_RIGHT_ALPHA: "0.5",
  ISOLATE_COLOR_PIN: "#FF9000",
  MINIMAL_FONT_SIZE_FOR_NAVIGATORS: 80,
  POINT_RADIUS: 2,
  LABELS_MAX_V_SPACING: 1,
  SMALL_HORIZONTAL_LINE_LENGTH: 15,
  TEXT_OVERLAYS_HEIGHT_PADDING: 1,
  IMAGE_TILE_HEIGHT: 18,
  RECENTER_SLIGHT_MARGIN: 10,
  RADIANT_OFFSET_ANGLE_FOR_DEGREES: 90,
  TOP_IMAGE_POSITION: 90,
  RIGHT_IMAGE_POSITION: 360,
  DOWN_IMAGE_POSITION: 270,
  LEFT_IMAGE_POSITION: 180,
  ROTATION_PRESS_ANGLE: 90,
  MIN_FONT_PX: 12,
  BASE_MIN_FONT_PX: 12,
  NO_MAX_LINES: 20,
  MAX_PIXEL_PER_IMAGE: 20,
  ORIENTATION_PICTURE_MARGIN_TOP: 10,
  ORIENTATION_LOGO: "/extension/imdesign/design/ezwebin/images/flechesbleues.png",
  MIN_MARGIN_LABEL: 4
};
ge.MAX_LABEL_HEIGHT_WITH_LINES = ge.MAX_FONT_PX * ge.MAX_LABEL_LINES + (ge.MAX_LABEL_LINES - 1) * ge.LINE_INTERVAL_PX;
ge.MIN_LABEL_HEIGHT_WITH_LINES = ge.MIN_FONT_PX * ge.MAX_LABEL_LINES + (ge.MAX_LABEL_LINES - 1) * ge.LINE_INTERVAL_PX;
ge.LINE_DIM = ge.SMALL_HORIZONTAL_LINE_LENGTH + ge.TEXT_TO_VERTICAL_LINE_PADDING;
ge.TOOLBAR_N_TITLE_OFFSET = ge.TOOLBAR_HEIGHT + ge.SERIES_TITLE_HEIGHT - 8;
class cg {
  /**
   * @param {string} application_id
   */
  constructor(e) {
    const t = window.hasAccess;
    Object.defineProperty(this, "hasSubscriberAccess", {
      value: function() {
        return typeof t == "object" && t[e] || !1;
      },
      configurable: !1,
      writable: !1,
      enumerable: !1
    }), Object.defineProperty(this, "checkAccess", {
      value: () => this.hasEmbedAccess() || this.isModuleFree() || this.hasSubscriberAcces(),
      configurable: !1,
      writable: !1,
      enumerable: !1
    });
  }
  hasEmbedAccess() {
    return typeof window.embedAccess === !0;
  }
  isModuleFree() {
    return typeof window.moduleIsPremium !== !0;
  }
}
class ug extends se {
  constructor(e) {
    super({
      /** @type {FilterState} **/
      resources: e.state.filter,
      ...e
    }), this.storageName = null, this.filtersBeforeIsolation = [];
  }
  /**
      * @param {string} storageName
      */
  setStorageName(e = "") {
    this.storageName = `im_filters-${e}`;
  }
  // @todo add try/catch and custom error if content loaded in local storage is not a valid JSON
  // @todo add try/catch and custom error if storageName is not valid (not a string or '')
  onFilterLoaded() {
    if (G.isAvailable)
      try {
        const e = localStorage.getItem(this.storageName);
        if (e === null)
          super.onFilterLoaded();
        else {
          let t;
          e ? t = JSON.parse(e) : t = Array.from(this.data.resources.default_id), Array.isArray(t) ? (this.unselectAll(), t.forEach((i) => {
            this.findById(i) !== null && this.select(i);
          }), t.length !== 0 && this.getCurrent().length === 0 && super.onFilterLoaded()) : super.onFilterLoaded();
        }
      } catch (e) {
        console.error(e), super.onFilterLoaded();
      }
    else
      super.onFilterLoaded();
  }
  save() {
    G.isAvailable && localStorage.setItem(this.storageName, JSON.stringify(Array.from(this.data.resources.current_id)));
  }
  onSelect(e) {
    this.save(), super.onSelect(e);
  }
  onUnselect(e) {
    this.save(), super.onUnselect(e);
  }
  selectAll() {
    super.selectAll(), this.save();
  }
  unselectAll() {
    super.unselectAll(), this.save();
  }
  updateFiltersBeforeIsolation() {
    this.filtersBeforeIsolation = super.getCurrent();
  }
  /**
   *
   * @param {string[]} filter_ids a list of filters to enable
   * @param {boolean} [mute=false] silences the onSelect action
   */
  focus(e, t = !1) {
    this.updateFiltersBeforeIsolation(), super.unselectAll(), e.forEach((i) => {
      super.select(i, t);
    });
  }
  /**
   *
   * @param {boolean} [mute=false] silences the onUnselect action
   */
  blur(e = !1) {
    super.unselectAll(), this.filtersBeforeIsolation.forEach((t) => {
      super.select(t, e);
    });
  }
}
class Zt extends ce {
  constructor(e = {}) {
    super({
      name: e.name || Zt.interactionName,
      ...e
    }), this.lastY = 0;
  }
  onStart() {
    const e = this.component, { MAX_PIXEL_PER_IMAGE: t } = e.services.style.get(), i = e.services.slice.sizeOfRelativeIndex(), r = e.services.series.getCurrent();
    this.pxPerImg = r.slices_height / i, this.pxPerImg = Math.min(Math.max(this.pxPerImg * 3, 1), t), this.totalDistanceAccumulated = 0;
    const n = e.services.pointer.getCoords();
    this.lastY = n.y, e.publish(Ii.SET_PLACEMENT_IMAGE_VIEW, { placement: ie.SCROLL });
  }
  getDelta() {
    const t = this.component.services.pointer.getCoords(), i = t.y - this.lastY;
    return this.lastY = t.y, i;
  }
  onAnimation(e) {
    const t = this.component, i = this.getDelta();
    this.totalDistanceAccumulated += i;
    const r = Math.abs(this.totalDistanceAccumulated), n = (t.modes.scroll === Ir.SLOW ? 3 : 1) * this.pxPerImg, a = t.services.slice;
    if (r > n) {
      const o = a.getCurrentRelativeIndex() + t.data.scrollDirection * Math.round(this.totalDistanceAccumulated / n);
      this.totalDistanceAccumulated = 0, o !== a.getCurrentRelativeIndex() && t.moveToSlice(o);
    }
  }
  onMouseLeave(e) {
    this.finish(e);
  }
  onMouseUp(e) {
    this.finish(e);
  }
}
Zt.interactionName = ke.SCROLL;
class ft extends ce {
  constructor(e = {}) {
    super({
      name: e.name || ft.interactionName,
      ...e
    }), this.services = {
      renderingContext: e.services.renderingContext,
      pointer: e.services.pointer
    }, this.lastX = 0, this.lastY = 0;
  }
  onStart() {
    this.component.onUserInteraction(), this.component.clearOverlays();
    const e = this.services.pointer.getCoords();
    this.lastX = e.x, this.lastY = e.y;
  }
  onFinish(e) {
    this.component.animations.redrawOnlyOverlays.trigger();
  }
  onMouseUp(e) {
    this.finish(e);
  }
  onMouseLeave(e) {
    this.finish(e);
  }
}
ft.interactionName = ke.PAN;
class pt extends ce {
  constructor(e = {}) {
    super({ name: e.name || pt.interactionName, ...e }), this.application = e.component, this.services = {
      renderingContext: e.services.renderingContext,
      pointer: e.services.pointer
    }, this.lastX = 0, this.lastY = 0, this.zoomFocusPoint = { x: 0, y: 0 }, this.scaleOffset = 0;
  }
  onStart(e) {
    this.component.onUserInteraction(), this.component.clearOverlays();
    const t = this.services.pointer.getCoords();
    this.zoomFocusPoint = this.application.components.pointsCanvas.transformCoordinates(t.x, t.y, !0), this.lastX = t.x, this.lastY = t.y, this.services.renderingContext.update(H.ATTRIBUTE.USER_ZOOM_PERFORMED, !0);
  }
  getDelta() {
    const e = this.services.pointer.getCoords(), t = Math.round(e.y - this.lastY);
    return this.lastY = e.y, -t;
  }
  onMouseMove(e) {
    this.scaleOffset = this.getDelta() / Vn;
  }
  getScaleOffset() {
    const e = this.scaleOffset;
    return this.scaleOffset = 0, e;
  }
  onFinish() {
    this.component.animations.redrawOnlyOverlays.trigger(), this.zoomFocusPoint.recycle();
  }
  onMouseUp(e) {
    this.finish(e);
  }
  onMouseLeave(e) {
    this.finish(e);
  }
}
pt.interactionName = ke.ZOOM;
const dg = [
  Zt,
  ft,
  pt
];
class He extends Ue {
  /**
   * @param {Object} settings
   * @param {ImageState} settings.state.image
   * @param {string[]} settings.iconsBlackListed
   * @param {Object} settings.providers
   * @param {IconProviderInterface} settings.providers.icon
   * @param {ImageProviderInterface} settings.providers.image
   */
  constructor(e) {
    super({
      /** @type {ImageState} **/
      resources: e.state.image,
      ...e
    }), this.data.isContentAvailable = !1, this.data.lastImageRendered = null, this.data.lastImageRenderedWasAskedAt = Date.now(), this.latestImageThatShouldBeDrawnId = null, this.providers = {
      icon: e.providers.icon,
      image: e.providers.image,
      sliceThumb: e.providers.imageThumb,
      cr: e.providers.crImages
    }, this.services = {
      imageCache: e.services.imageCache,
      imageSettingsStorage: e.services.imageSettingsStorage,
      imageHelper: e.services["image-helper"],
      series: e.services.series,
      renderingContext: e.services.renderingContext
    }, this.pendingRequest = {}, this.isAFallbackImage = {}, le([
      { name: B.EVENT.LOADING_END, from: this.providers.image }
    ]).then(() => {
      this.publish(He.EVENT.CONTENT_AVAILABLE);
    });
  }
  /**
   * @override in order to allow current_id = resource_id even when resource is not available yet
   * @param resource_id
   */
  setCurrent(e) {
    this.data.resources.current_id = e, this.publish(He.EVENT.IMAGE_CHANGE, e);
  }
  setLastImageRendered(e) {
    this.data.lastImageRendered = e;
  }
  getLastImageRendered() {
    return this.data.lastImageRendered;
  }
  /** @return {QUALITY} **/
  getDefaultQuality() {
    return this.data.resources.qualities.default;
  }
  /** @param {QUALITY} qualityRequired */
  setDefaultQuality(e) {
    try {
      if (e === dt.LOWEST && (e = this.getLowestQuality()), this.isQualityAvailable(e))
        this.data.resources.qualities.default = e;
      else
        throw `Quality ${e} is not available yet`;
    } catch (t) {
      console.error(t);
    }
  }
  isQualityAvailable(e) {
    try {
      return this.data.resources.qualities.availables.has(e);
    } catch (t) {
      return console.error(t), !1;
    }
  }
  setQuality(e) {
    this.data.resources.qualities.current_id = e, this.publish(jt.EVENT.QUALITY_CHANGE);
  }
  /**
   * @return {Number}
   */
  getQuality() {
    return this.data.resources.qualities.current_id;
  }
  getLowestQuality() {
    if (this.data.resources.qualities.availables.size > 0)
      return Math.min(...Array.from(this.data.resources.qualities.availables));
    throw "No quality found";
  }
  /**
   * @param {QUALITY} qualityRequired
   * @return {Promise<any>}
   */
  async switchQuality(e) {
    try {
      e === dt.LOWEST && (e = this.getLowestQuality()), await Promise.all([
        this.providers.cr.switchQuality(e),
        this.providers.image.switchQuality(e)
      ]), this.setQuality(e);
    } catch (t) {
      console.log(t);
    }
  }
  storeImageSettings(e, t = {}) {
    typeof t.sort_order > "u" && this.services.imageHelper.addSliceOrder(t), this.services.imageSettingsStorage.set(e, t);
  }
  getImageSettings(e) {
    return this.services.imageSettingsStorage.get(e);
  }
  generateImageId(e = {}) {
    let t;
    return e.type === Y.SLICE ? t = Object.values({
      type: e.type,
      sort_order: e.sort_order,
      code: e.code,
      quality: e.quality
    }).join("-") : t = Object.values(e).join("-"), e.dedupedImageId = `${e.code}#images-${e.sort_order}`, e.image_id = t, e.latestRenderingAskedAt = Date.now(), this.storeImageSettings(t, e), t;
  }
  getFromCache(e) {
    return this.services.imageCache.get(e);
  }
  async loadFallbackImage(e = null) {
    const t = e || this.getCurrentId(), i = this.getImageSettings(t), r = await this.providers.sliceThumb.getImage(i);
    return !this.hasImageInCache(t) && i.type === Y.SLICE && this.cacheImage(t, r), r;
  }
  /** @param {Object} settings
   * @param priority
   */
  async getImage(e = {}, t = B.PRIORITY.STANDARD) {
    return new Promise(async (i) => {
      if (typeof e.quality > "u" && (e.quality = this.getQuality()), typeof e.image_id > "u" && typeof e.sort_order > "u") {
        if (typeof e.slice_id > "u")
          throw new Error("missing slice_id");
        this.services.imageHelper.addSliceOrder(e);
      }
      const r = e.image_id || this.generateImageId(e);
      if (e.image_id) {
        const n = this.getImageSettings(r);
        n.latestRenderingAskedAt = Date.now(), this.storeImageSettings(r, n);
      }
      this.hasImageInCache(r) && this.isAFallbackImage[r] === !1 ? i({
        image_id: r,
        image: this.getFromCache(r)
      }) : (this.publish("missing-image-in-cache", r), typeof this.pendingRequest[r] > "u" ? (this.pendingRequest[r] = !0, this.providers.image.getImage({
        ...this.getImageSettings(r),
        ...e,
        image_id: r
      }, t).then(async (n) => {
        const a = n === null || n === "", o = e.type === Y.OVERLAY;
        a && (o ? n = null : n = await this.loadFallbackImage(r)), this.cacheImage(r, n), this.isAFallbackImage[r] = !1, i({ image_id: r, image: n });
      })) : setTimeout(
        () => {
          this.getImage(e, t).then(i);
        },
        100
      ));
    });
  }
  /** @param {QUALITY} quality */
  addQuality(e) {
    this.data.resources.qualities.availables.add(e);
  }
  hasImageInCache(e) {
    return this.services.imageCache.has(e);
  }
  canBeRendered(e) {
    return this.hasImageInCache(e) && this.isAFallbackImage[e] === !1;
  }
  addResource(e, t = null) {
    t === null && (t = e.id), this.data.resources.availables[t] = e;
  }
  cacheImage(e, t) {
    return this.addResource(t, e), this.services.imageCache.set(e, t);
  }
  haveSameSize(e, t) {
    return e.width === t.width && e.height === t.height;
  }
  draw(e, t, i) {
    const r = this.getFromCache(i), n = this.services.series.getCurrent(), { MULTIPLIER: a } = this.services.renderingContext.getAll(), o = n.slices_width * a, l = n.slices_height * a, c = -o / 2, u = -l / 2;
    t.update(H.ATTRIBUTE.IMAGE_OFFSET_X, c), t.update(H.ATTRIBUTE.IMAGE_OFFSET_Y, u), e.data.context.drawImage(r, 0, 0, r.width, r.height, c, u, o, l), this.setLastImageRendered(r);
  }
  /**
   * Current image is set when we store image in cache
   * @returns {*}
   */
  getCurrent() {
    return super.getCurrent();
  }
  setImageProvider(e) {
    this.providers.image !== e && (this.providers.image = e, this.providers.cr.setImageProvider(e));
  }
  async loadImages(e, t = null) {
    Array.isArray(e.qualitiesAvailable) && e.qualitiesAvailable.forEach((i) => {
      this.addQuality(
        /** @type {QUALITY} */
        i
      );
    }), this.setDefaultQuality(typeof e.defaultQuality < "u" ? e.defaultQuality : h.getHighQuality()), t === null && (t = this.getDefaultQuality()), await Promise.all([
      this.providers.image.switchQuality(t),
      this.providers.cr.switchQuality(t)
    ]), this.setQuality(t);
  }
  getType() {
    return "Image";
  }
}
He.EVENT = {
  CONTENT_AVAILABLE: "image-content-available",
  LOADING_START: "image-loading-start",
  LOADING_PROGRESS: "image-loading-progress",
  LOADING_END: "image-loading-end",
  IMAGE_CHANGE: "image-change",
  IMAGE_AVAILABLE: "image-available",
  CURRENT_IMAGE_SIZE_CHANGE: "current-image-size-change"
};
class hg {
  constructor(e) {
    this.services = {
      structure: e.services.structure
    };
  }
  searchStructure(e, t) {
    e = ye(e.toLowerCase());
    const i = this.services.structure, r = Object.values(
      Object.values(i.getResources()).reduce((n, a) => {
        a.name = i.getTranslation(a), a.latin_name = i.getTranslation(a, Z.la);
        const o = this.matchStructure(a, e);
        if (o.hasMatched) {
          const l = {
            ...a,
            getTaxonKey: a.getTaxonKey,
            score: o.score,
            associated_terms: o.matchingProperties.reduce((u, m) => (u.length > 0 ? u += `; ${a[m]}` : u += a[m], u), ""),
            latin_name: o.latin_matching ? a.latin_name : ""
          }, c = n[l.id] ?? null;
          c !== null ? i.getTaxonHigherPriority(t, a, c) === a && (n[l.id] = l) : n[l.id] = l;
        }
        return n;
      }, {})
    ).sort((n, a) => n.name - a.name).sort((n, a) => n.name.length - a.name.length).sort((n, a) => a.score - n.score);
    return this.addParentNameIfDuplicate(r), r;
  }
  addParentNameIfDuplicate(e) {
    e.forEach((t, i) => {
      const r = e.filter((n, a) => n.name === t.name && a !== i);
      if (r.length > 0) {
        const n = this.services.structure.getParentTranslation(t);
        n !== null && (t.name += ` - (${n})`), r.forEach((a) => {
          const o = this.services.structure.getParentTranslation(a);
          o !== null && (a.name += ` - (${o})`);
        });
      }
    });
  }
  /**
   * @param {Structure} structure
   * @param {string} query
   * @return {matchedStructure}
   */
  matchStructure(e, t) {
    const i = {
      hasMatched: !1,
      // At least one property matches the query
      matchingProperties: [],
      // List of related_terms that match the query
      score: 0,
      // Search score
      latin_matching: !1
      // If latin match query, display it in search input
    };
    return ye(e.name?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.score = this.calcScore(t, e.name, Ae.name), i) : ye(e.latin_name?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.latin_matching = !0, i.score = this.calcScore(t, e.latin_name, Ae.latin_name), i) : ye(e.legacy_eponym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("legacy_eponym"), i.score = this.calcScore(t, e.legacy_eponym, Ae.legacy_eponym), i) : ye(e.synonym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("synonym"), i.score = this.calcScore(t, e.synonym, Ae.synonym), i) : ye(e.acronym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("acronym"), i.score = this.calcScore(t, e.acronym, Ae.acronym), i) : ye(e.patronym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("patronym"), i.score = this.calcScore(t, e.patronym, Ae.patronym), i) : ye(e.fr_anc?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("fr_anc"), i.score = this.calcScore(t, e.fr_anc, Ae.fr_anc), i) : ye(e.latin_synonym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("latin_synonym"), i.score = this.calcScore(t, e.latin_synonym, Ae.latin_synonym), i) : ye(e.latin_acronym?.toLowerCase())?.includes(t) ? (i.hasMatched = !0, i.matchingProperties.push("latin_acronym"), i.score = this.calcScore(t, e.latin_acronym, Ae.latin_acronym), i) : (ye(e.latin_patronym?.toLowerCase())?.includes(t) && (i.hasMatched = !0, i.matchingProperties.push("latin_patronym"), i.score = this.calcScore(t, e.latin_patronym, Ae.latin_patronym)), i);
  }
  calcScore(e, t, i) {
    let r = !1, n = ye(t)?.toLowerCase();
    if (n === e)
      return Ae.full_match;
    const a = n?.toLowerCase().split(";").filter((c) => c.length > 0), o = e.split(" ");
    a.forEach((c) => {
      o.some((u) => u === c) && (r = !0);
    });
    let l;
    return r ? l = i * Ae.word_match : l = i, l;
  }
}
class mg extends xe {
  constructor() {
    super(), this.availables = /* @__PURE__ */ new Set();
  }
}
class fg extends V {
  constructor(e) {
    super(e), this.services = {
      language: e.services.language
    };
  }
  getTranslation(e, t = V.NAMESPACE.DEFAULT, i = null) {
    const r = i || this.services.language.getCurrent();
    let n = super.getTranslation(e, r, t);
    return n !== null ? n : (r !== null && !this.languagesLoaded.has(r.toString()) && this.services.language.temporaryLanguage !== null && (n = super.getTranslation(e, this.services.language.temporaryLanguage, t)), n === null ? super.getTranslation(e, this.services.language.getDefault(), t) : n);
  }
}
class pg extends xe {
  constructor() {
    super();
  }
}
class gg extends xe {
  constructor() {
    super();
  }
}
class vg extends xe {
  constructor() {
    super(), this.currentImageSrc = "";
  }
}
class yg extends xe {
  constructor() {
    super(), this.index = {}, this.currentRelativeSliceIndex = 0, this.relativeSliceIndex = {};
  }
}
class Eg {
  constructor() {
    this.cover = null, this.id = null, this.name = null, this.name_translation = null, this.nbImages = null, this.background_color = null, this.version = null, this.short_name = null, this.modality_name = null, this.isFree = null;
  }
  set(e) {
    this.cover = e.cover, this.id = e.id, this.name = e.name, this.name_translation = e.nameTranslation, this.nbImages = e.nbImages, this.background_color = e.backgroundColor, this.version = e.version, this.short_name = e.shortName, this.modality_name = e.modalityName, this.isFree = e.isFree ?? null;
  }
}
class Ig extends xe {
  constructor() {
    super(), this.current_id = /* @__PURE__ */ new Set(), this.default_id = /* @__PURE__ */ new Set(), this.main_id = /* @__PURE__ */ new Set();
  }
}
class Cg extends xe {
  constructor() {
    super();
  }
}
class hn {
  constructor(e = {}) {
    this.state = e.state;
  }
  update(e, t) {
    this.state.data.hasOwnProperty(e) ? this.state.data[e] = t : (console.log(`warning : ${e} is not a valid property`), console.trace());
  }
  get(e = null) {
    return e === null ? this.getAll() : this.state.data[e];
  }
  getAll() {
    return this.state.data;
  }
}
class _g extends hn {
  constructor(e = {}) {
    super({
      /** @type {StyleState} **/
      state: e.state.style
    });
  }
}
class Tg extends xe {
  constructor() {
    super();
  }
}
class Sg extends Ue {
  constructor(e) {
    super({
      /** @type {ModalityState} **/
      resources: e.state.slice,
      ...e
    });
  }
  is2XOverSampling(e) {
    return e === he.SCHEMA || e === he.RX2 || e === he.XA2 || e === he.PHOTOGRAPHY_X2;
  }
  useFirstSliceAsPreview(e) {
    return e === he.SCHEMA || e === he.RX2 || e === he.XA2 || e === he.PHOTOGRAPHY_X2;
  }
  isHighQuality(e) {
    return e === he.SCHEMA || e === he.PHOTOGRAPHY || e === he.PHOTOGRAPHY_X2;
  }
  getIndexSlicePreview(e) {
    return this.useFirstSliceAsPreview(e.modality_id) ? 0 : Math.max(Math.min(Math.round(e.number_of_images / 2), e.number_of_images - 1), 0);
  }
}
class bg extends hn {
  constructor(e = {}) {
    super({
      /** @type {RenderingContextState} **/
      state: e.state.renderingContext
    }), this.services = {
      style: e.services.style
    };
  }
  setScale(e, t = null) {
    t === null && (t = e), this.setMinScale(e), this.setMaxScale(t);
  }
  leavePointSelectionMode() {
    this.get(H.ATTRIBUTE.POINT_SELECTION_MODE) === !0 && this.update(H.ATTRIBUTE.POINT_SELECTION_MODE, !1);
  }
  usePointSelectionMode() {
    this.get(H.ATTRIBUTE.POINT_SELECTION_MODE) === !1 && this.update(H.ATTRIBUTE.POINT_SELECTION_MODE, !0);
  }
  setContainer(e) {
    this.update(H.ATTRIBUTE.CONTAINER_ELEMENT, e);
  }
  updateRenderingContext() {
    const { CONTAINER_ELEMENT: e, LEFT_PADDING: t, RIGHT_PADDING: i, WIDTH_AVAILABLE: r } = H.ATTRIBUTE, n = this.services.style.get(L.ATTRIBUTE.LINE_DIM), a = this.get(e);
    if (!a)
      return;
    const o = 0.2 * a.offsetWidth, l = o - n, c = a.offsetWidth - l - n;
    this.update(t, o), this.update(i, c), this.update(r, l);
  }
  setZoomSettings(e) {
    const {
      MIN_ZOOM: t,
      MAX_ZOOM: i,
      ZOOM_DYNAMIC: r,
      INITIAL_MIN_SCALE: n,
      INITIAL_MAX_SCALE: a,
      MIN_SCALE: o,
      MAX_SCALE: l
    } = H.ATTRIBUTE;
    this.update(
      t,
      Math.max(e.min, 0)
    ), this.update(
      i,
      Math.max(e.max, e.min)
    ), this.update(
      r,
      this.get(i) - this.get(t)
    ), this.update(n, this.get(t) - It), this.update(a, this.get(i) + It), this.update(o, this.get(n)), this.update(l, this.get(a));
  }
  /**
   * @param {Number} scale
   */
  setMinScale(e) {
    this.update(
      H.ATTRIBUTE.MIN_SCALE,
      Math.min(
        Math.abs(e - It),
        this.get(H.ATTRIBUTE.MIN_ZOOM) - It
      )
    );
  }
  /**
   * @param {Number} scale
   */
  setMaxScale(e) {
    this.update(
      H.ATTRIBUTE.MAX_SCALE,
      Math.max(
        Math.abs(e + It),
        this.get(H.ATTRIBUTE.MAX_ZOOM) + It
      )
    );
  }
  setScaleLevel(e) {
    this.update(
      H.ATTRIBUTE.SCALE,
      e
    );
  }
}
class Ag {
  constructor() {
    this.resources = [], this.rightIndex = /* @__PURE__ */ new Set(), this.leftIndex = /* @__PURE__ */ new Set();
  }
}
class _e {
  constructor(e, t, i, r, n, a) {
    ++_e.instance, this.labelX = e, this.labelY = t, this.labelWidth = i, this.labelHeight = r, this.taxon_key = n, this.point_id = a;
  }
}
_e.POOL = {
  AVAIBLE: [
    new _e(0, 0, 0, 0, 0),
    new _e(0, 0, 0, 0, 0),
    new _e(0, 0, 0, 0, 0)
  ]
};
_e.getOne = function(s, e, t, i, r, n) {
  if (_e.POOL.AVAIBLE.length > 0) {
    const a = _e.POOL.AVAIBLE.pop();
    return a.labelX = s, a.labelY = e, a.labelWidth = t, a.labelHeight = i, a.taxon_key = r, a.point_id = n, a;
  } else
    return new _e(s, e, t, i, r, n);
};
_e.recycle = function(s) {
  _e.POOL.AVAIBLE.push(s);
};
class gi {
  constructor(e = {}) {
    this.color = e.color || "", this.alpha = e.alpha || "1", this.underline = !1;
  }
  setColor(e) {
    this.color = e;
  }
  setAlpha(e) {
    this.alpha = e;
  }
  setColorOf(e) {
    this.setColor(e.color), this.setAlpha(e.alpha);
  }
  static areColorEquals(e, t) {
    return e.color === t.color && e.alpha === t.alpha;
  }
  load(e = {}) {
    for (const t in e)
      this.hasOwnProperty(t) && (this[t] = e[t]);
  }
}
class et extends re {
  constructor(e = {}) {
    super({
      name: e.name || "point-service",
      ...e
    }), this.state = {
      label: e.state.label
    }, this.additionnalStyle = {
      // taxon_key: { property: value }
    };
  }
  clear() {
    const e = this.state.label;
    e.resources.forEach((t) => {
      _e.recycle(t);
    }), e.resources.length = 0, e.rightIndex.clear(), e.leftIndex.clear();
  }
  //@optimize octree for reduce complexity ?
  /**
   *
   * @param x
   * @param y
   * @param options
   * @return {LabelZone}
   */
  findByCoords(e, t, i = {}) {
    let r;
    if (i.left && i.right)
      r = this.state.label.resources.find((n) => e + ts.LEFT >= n.labelX && e - ts.RIGHT <= n.labelX + n.labelWidth && t + ts.TOP >= n.labelY && t - ts.BOTTOM <= n.labelY + n.labelHeight);
    else {
      let n = null;
      if (e >= i.right)
        n = this.state.label.rightIndex;
      else if (e <= i.left)
        n = this.state.label.leftIndex;
      else
        return null;
      r = n.find((a) => {
        const o = this.state.label.resources[a];
        return e >= o.labelX && e <= o.labelX + o.labelWidth && t >= o.labelY && t <= o.labelY + o.labelHeight;
      });
    }
    return typeof r > "u" ? null : r;
  }
  // use pool ?
  record(e, t, i, r, n, a, o = null) {
    const l = _e.getOne(e, t, i, r, n, a), c = this.state.label.resources.push(l);
    o === et.LEFT_INDEX ? this.state.label.leftIndex.add(c - 1) : o === et.RIGHT_INDEX && this.state.label.rightIndex.add(c - 1);
  }
  getLabelStyle(e) {
    const t = new gi({
      color: e.color || me.BLACK
    });
    return t.load(this.additionnalStyle["" + e.id]), t.id = e.id, t;
  }
  setStyle(e, t, i) {
    typeof this.additionnalStyle[e] > "u" && (this.additionnalStyle[e] = {}), this.additionnalStyle[e][t] = i;
  }
  getDisplayedLabels() {
    return this.state.label.resources;
  }
}
et.RIGHT_INDEX = 0;
et.LEFT_INDEX = 1;
class wg extends yi {
  constructor(e = {}) {
    super(e), this.hidden = /* @__PURE__ */ new Set(), this.hover = null;
  }
}
class Lg {
  /**
   * @param {Object} settings
   * @param {Object} settings.state
   * @param {PointerState} settings.state.pointer
   */
  constructor(e) {
    this.state = e.state.pointer;
  }
  getDelta() {
    return this.state.data.delta;
  }
  getCoords() {
    return this.state.data.coords;
  }
  clearDelta() {
    this.state.data.delta.x = 0, this.state.data.delta.y = 0;
  }
}
class gt extends re {
  constructor(e = {}) {
    super({
      name: "transform-service",
      container: e
    }), this.services = {
      renderingContext: e.services.renderingContext
    };
  }
  toggleVerticalFlipContext() {
    this.toggleFlipContext(H.ATTRIBUTE.VERTICAL_FLIP);
  }
  toggleHorizontalFlipContext() {
    this.toggleFlipContext(H.ATTRIBUTE.HORIZONTAL_FLIP);
  }
  toggleFlipContext(e) {
    const t = this.services.renderingContext.get(e);
    this.services.renderingContext.update(e, !t), this.publish(gt.EVENT.FLIP);
  }
  verticalFlip(e) {
    this.applyFlip(e, ue.METHOD.FLIP_X), this.toggleVerticalFlipContext();
  }
  horizontalFlip(e) {
    this.applyFlip(e, ue.METHOD.FLIP_Y), this.toggleHorizontalFlipContext();
  }
  scale(e, t) {
    this.apply(e, ue.METHOD.SCALE, t);
  }
  apply(e, t, i) {
    const { imageCanvas: r, pointsCanvas: n, overlaysCanvas: a } = e.components;
    try {
      r[t](i), n[t](i), a[t](i);
    } catch (o) {
      console.error(o), console.log(`method ${t} is not available`);
    }
  }
  applyFlip(e, t) {
    Math.abs(e.services.renderingContext.get(H.ATTRIBUTE.ROTATION_ANGLE)) % 180 >= 90 && (t === ue.METHOD.FLIP_X ? t = ue.METHOD.FLIP_Y : t = ue.METHOD.FLIP_X, this.toggleVerticalFlipContext(), this.toggleHorizontalFlipContext()), this.apply(e, t);
  }
  restore(e) {
    this.apply(e, ue.METHOD.RESTORE);
  }
  save(e) {
    this.apply(e, ue.METHOD.SAVE);
  }
  rotate(e, t) {
    const i = e.services.renderingContext, r = i.get(H.ATTRIBUTE.HORIZONTAL_FLIP), n = i.get(H.ATTRIBUTE.VERTICAL_FLIP), o = (r && !n || !r && n ? -1 : 1) * t * ci;
    this.apply(e, ue.METHOD.ROTATE, o);
    let l = e.services.renderingContext.get(H.ATTRIBUTE.ROTATION_ANGLE);
    l += t, e.services.renderingContext.update(H.ATTRIBUTE.ROTATION_ANGLE, l), e.data.overlaysDrawn = !1, this.publish(gt.EVENT.ROTATE);
  }
}
gt.EVENT = {
  FLIP: "on-flip",
  ROTATE: "on-rotate"
};
class Xt extends br {
  constructor(e) {
    super({
      /** @type {OverlayState} **/
      resources: e.state.overlay,
      settings: e
    }), this.services = {
      textOverlay: e.services.textOverlay,
      slice: e.services.slice,
      series: e.services.series,
      /** @type {StyleService} **/
      style: e.services.style
    }, this.data.overlaysCurrentlyDrawn = 0, this.data.lastRenderingKey = null, this.data.imageOpacity = Ri;
  }
  addResource(e, t = null) {
    t === null && (t = e.layer), super.addResource(e, t);
  }
  getDefaultImageOverlayOpacity() {
    return Ri;
  }
  getOpacity() {
    return parseFloat(this.data.imageOpacity);
  }
  setImageOpacity(e) {
    this.data.imageOpacity = e, this.publish(Xt.EVENT.IMAGE_OPACITY_CHANGE, { opacity: e });
  }
  refreshSelected(e) {
    const t = e.getCurrent();
    this.unselectAll(), this.isAvailable(Is) && this.select(Is), t.forEach((i) => {
      const r = e.findById(i);
      typeof r.layer == "string" && r.layer.split(",").forEach((n) => {
        this.isAvailable(n) && this.select(n);
      });
    });
  }
  /**
   * @param {CanvasComponent} component
   * @param {ImageService} imageService
   * @param {RenderingContextService} renderingContextService
   * @param {TranslatorService} translatorService
   */
  draw(e, t, i, r) {
    const n = this.getCurrent();
    e.isEnabled() !== !0 || n.length === 0 || (this.data.overlaysCurrentlyDrawn > 0 && (this.data.overlaysCurrentlyDrawn = 0, e.clear()), this.drawImageOverlays(e, t, i, n), this.drawTextOverlays(
      e,
      i,
      r
    ));
  }
  getValidOverlays(e) {
    return this.getCurrent().filter((i) => this.existOverlay(i, this.services.slice.findById(e)));
  }
  drawImageOverlays(e, t, i, r) {
    const n = this.services.slice.getCurrentId(), a = `${n}-${r.join("#")}-${Math.random() * 100}`;
    this.data.lastRenderingKey = a;
    const o = this.getValidOverlays(n);
    Promise.all(o.map((l) => t.getImage({
      slice_id: n,
      format: "png",
      type: Y.OVERLAY,
      code: l
    }), B.PRIORITY.HIGH)).then((l) => {
      if (this.data.lastRenderingKey === a) {
        const { IMAGE_OFFSET_X: c, IMAGE_OFFSET_Y: u, MULTIPLIER: m } = i.get(), g = t.getLastImageRendered(), C = this.services.series.getCurrent().slices_width;
        e.setContextOpacity(this.data.imageOpacity), g !== null && l.forEach((I) => {
          if (I.image !== null) {
            const p = C * m / I.image.width;
            e.drawImage(
              I.image,
              c,
              u,
              I.image.width * p,
              I.image.height * p
            );
          }
        }), e.setContextOpacity(1), this.data.overlaysCurrentlyDrawn += o.length;
      }
    });
  }
  drawTextOverlays(e, t, i) {
    const r = this.services.slice.getCurrent(), n = this.services.textOverlay.find({ layer: { $in: [...this.getCurrent(), Is] }, slice_id: r.id }), { IMAGE_OFFSET_X: a, IMAGE_OFFSET_Y: o, MULTIPLIER: l } = t.get();
    n.forEach((c) => {
      const u = i.getTranslation(c.name_id, V.NAMESPACE.UI);
      if (u !== null) {
        const m = c.fontSize * l, g = c.y * l;
        let C;
        c.align_id === vs.CODES.CENTER ? C = c.x * l + c.width * l / 2 : c.align_id === vs.CODES.RIGHT ? C = c.x * l + c.width * l : C = c.x * l, e.setTextAlign(vs[c.align_id]), e.setFillStyle("#" + c.color);
        const I = this.services.style.get(L.ATTRIBUTE.FONT_FAMILY);
        e.setFont(I, m, "px");
        const p = c.height;
        let T = p;
        e.getNbLine(u, m, I, c.width * l) > 1 && (T = Math.round(p / 2)), e.drawMultilineText({
          text: u,
          x: C + a + 2 * l,
          y: g + o + T,
          width: c.width * l,
          lineHeight: p,
          maxLines: 2,
          splitHyphen: !0,
          allowCenter: !1,
          textBaseline: "middle"
        });
      }
    }), this.data.overlaysCurrentlyDrawn += n.length;
  }
  existOverlay(e, t) {
    let i = !1;
    const r = this.findById(e);
    return r !== null && r.range !== null && r.range.split(",").map((a) => {
      const o = a.split("-");
      return { min: o[0], max: o[1] };
    }).forEach((a) => {
      t.sort_order >= a.min && t.sort_order <= a.max && (i = !0);
    }), i;
  }
  getType() {
    return "Overlay";
  }
}
Xt.EVENT = {
  IMAGE_OPACITY_CHANGE: "overlays-image-opacity-change"
};
class Og extends xe {
  constructor() {
    super(), this.current_id = /* @__PURE__ */ new Set(), this.default_id = /* @__PURE__ */ new Set();
  }
}
let Mg = 0;
class mn extends re {
  constructor(e = {}) {
    super({
      _id: e.drawer_id || "standard-label-drawer_" + ++Mg
    }), this.services = {
      style: e.services.style,
      structure: e.services.structure,
      translator: e.services.translator,
      renderingContext: e.services.renderingContext,
      label: e.services.label,
      point: e.services.point
    }, this.context = {
      idealLabelHeight: 0,
      heightAvailable: 0,
      heightRequired: 0,
      candidates: [],
      filteredPoints: [],
      interline: 0,
      side: null,
      currentYForLabels: 0,
      textAvailableWidth: 0,
      labelsInfo: {},
      taxon_key: null,
      labelComponent: null,
      maxLength: 0,
      allPreselectedLabelsShouldBeDrawn: !1
    }, this.data.translationLength = {}, this.index = 1;
  }
  reset() {
    this.publish(X.EVENT.NEW_RENDERING), this.index = 1;
  }
  onResetContext(e) {
    e.heightRequired = 0, e.heightAvailable = 0, e.idealLabelHeight = 0, e.candidates = [], e.filteredPoints = [], e.side = null, e.interline = 0, e.currentYForLabels = 0, e.textAvailableWidth = 0, e.labelsInfo = {}, e.taxon_key = null, e.labelComponent = null, e.maxLength = 0, e.allPreselectedLabelsShouldBeDrawn = !1;
  }
  resetContext(e) {
    this.onResetContext(e), this.publish(X.EVENT.CONTEXT_RESET, e);
  }
  computeInterline(e) {
    e.interline = 10;
  }
  dispatchPointBySide(e, t) {
    const i = e.length, r = new Array(i), n = new Array(i);
    let a = 0, o = 0;
    return e.forEach((l) => {
      l.contextual_x < t ? (r[a] = l, a++) : (n[o] = l, o++);
    }), r.length = a, n.length = o, { left: r, right: n };
  }
  initComponent(e, t) {
    const i = this.getFontSize(), r = e.side === "left" ? "right" : "start";
    e.labelComponent = e.side === "left" ? t.layers.leftLabels : t.layers.rightLabels, e.labelComponent.setTextAlign(r), e.labelComponent.setFontSize(i), t.layers.buffer.setTextAlign(r), t.layers.buffer.setFontSize(i);
  }
  updateRangeFontSize() {
    const { BASE_MIN_FONT_PX: e, BASE_MAX_FONT_PX: t, FONT_ZOOM_LEVEL: i } = this.services.style.get();
    this.services.style.update(L.ATTRIBUTE.MIN_FONT_PX, Math.ceil(e * i)), this.services.style.update(L.ATTRIBUTE.MAX_FONT_PX, Math.ceil(t * i)), this.publish(X.EVENT.UPDATE_RANGE_FONT_SIZE);
  }
  computeSpaceAvailable(e) {
    this.computeWidthAvailable(e, e.labelComponent), this.computeHeightAvailable(e.labelComponent);
  }
  draw(e = {}) {
    if (this.resetContext(this.context), e.candidates.length !== 0)
      return this.context.candidates = this.updateCandidates(e.candidates), this.setSide(e.side), this.initComponent(this.context, e), this.computeSpaceAvailable(this.context), this.filterPointsByPriority(this.context, e), this.computeIdealLabelHeight(this.context), this.updateDrawingData(this.context, e), this.computeVerticalCoordsOfFirstLabel(this.context, e.layers.points), this.computeLabelsInfo(this.context, e), this.drawLabels(this.context, e), this.context;
  }
  computeWidthAvailable(e, t) {
    const {
      TEXT_PADDING: i,
      SMALL_HORIZONTAL_LINE_LENGTH: r,
      LINE_DIM: n,
      MARGIN: a
    } = this.services.style.get(), o = Math.ceil(t.getWidth() * 0.2) - a;
    e.textAvailableWidth = o - (i + r), e.leftBorderForText = o, e.rightBorderForText = t.getWidth() - e.textAvailableWidth - n, e.rightThreshold = Math.ceil(t.getWidth() * 0.8), e.leftThreshold = Math.ceil(t.getWidth() * 0.2);
  }
  updateCandidates(e) {
    const t = { candidates: e };
    return this.publish(X.EVENT.BEFORE_SET_CANDIDATES, t), t.candidates;
  }
  setSide(e) {
    this.context.side = e;
  }
  computeHeightAvailable(e) {
    const t = this.services.style.get(L.ATTRIBUTE.VERTICAL_LINE_PADDING);
    let i = e.getHeightAvailable() - t;
    return this.context.heightAvailable = i, i;
  }
  getBestHeightByNbLines(e, t, i) {
    const { MAX_LABEL_HEIGHT_WITH_LINES: r, FONT_SIZE: n, MIN_MARGIN_LABEL: a } = this.services.style.get();
    return Math.max(Math.min(
      (i.getHeightAvailable() - t * n) / e,
      r
    ), a);
  }
  computeDrawingData(e, t, i, r, n, a) {
    let o = 0, l = 0, c;
    const u = {};
    return e.forEach((m) => {
      const g = this.getLabelInfo(n, m, a, r);
      u[m.id] = g, o += g.nbLines * i, l += g.nbLines;
    }), c = this.getBestHeightByNbLines(e.length, l, n), o + c > n.getHeightAvailable() && (c = n.getHeightAvailable() - o), {
      totalSizeRequired: o + c * (e.length - 1),
      nbLines: l,
      paddingInterline: c
    };
  }
  computeLossyDrawingData(e, t, i, r, n, a) {
    let o = 0, l = 0, c = 0, u = 0, m = e.length, g, C;
    const I = {};
    for (; o + u < t && l < m; )
      g = e[l], C = this.getLabelInfo(n, g, a, r), I[g.id] = C, o += C.nbLines * i, c += C.nbLines, u = this.getBestHeightByNbLines(l, c, n), ++l;
    for (e.length = l, u = this.getBestHeightByNbLines(e.length, c, n); l > 1 && o + u * (e.length - 1) > t; )
      try {
        let p = e[l - 1];
        o -= I[p.id].nbLines * i, c -= I[p.id].nbLines, I[p.id].recycle(), delete I[p.id], --l, e.length = l;
      } catch (p) {
        console.error(p);
      }
    return u = this.getBestHeightByNbLines(e.length, c, n), {
      // Multiply padding interline by number of points
      totalSizeRequired: o + u * (e.length - 1),
      nbLines: c,
      paddingInterline: u
    };
  }
  getLabelInfo(e, t, i, r) {
    const { MAX_LABEL_LINES: n } = this.services.style.get(), a = { textAvailableWidth: r };
    return this.publish(X.EVENT.BEFORE_GET_LABEL_INFO, {
      taxon_key: t.taxon_key,
      context: a
    }), e.getLabelInfos(
      i(t.taxon_key, t.id),
      this.services.style.get(L.ATTRIBUTE.FONT_SIZE),
      a.textAvailableWidth,
      n
    );
  }
  filterPointsByPriority(e, t) {
    this.context.allPreselectedLabelsShouldBeDrawn !== !0 ? e.candidates.forEach((i) => {
      i.priority < 100 && e.filteredPoints.push(i);
    }) : e.filteredPoints = e.candidates.slice(0), e.filteredPoints.sort(function(i, r) {
      return i.priority - r.priority;
    });
  }
  computeIdealLabelHeight(e) {
    const t = this.services.style.get(L.ATTRIBUTE.MAX_LABEL_HEIGHT_WITH_LINES), i = e.filteredPoints.length;
    let r = Math.min(
      Math.floor(e.labelComponent.getHeightAvailable() / i),
      t
    );
    r *= e.heightAvailable / r / (i * 2), e.idealLabelHeight = Math.floor(r);
  }
  getVerticalThresholds(e, t) {
    let i = 0;
    const { MULTIPLIER: r, IMAGE_OFFSET_Y: n, VERTICAL_FLIP: a } = this.services.renderingContext.get();
    e.filteredPoints.forEach((g) => {
      let C = g.y * r + n;
      i += C * t.getComputedScaleY(a) + t.getTy();
    });
    const l = i / e.filteredPoints.length;
    let c, u, m = Tt;
    return c = l - e.heightRequired / 2, u = e.heightAvailable - e.heightRequired, c > u && (c = u), c + e.heightRequired / 2 > e.heightAvailable && (c -= e.heightAvailable - c + e.heightRequired / 2), c < m && (c = m), {
      start: c,
      max: u,
      min: m,
      center: l
    };
  }
  computeVerticalCoordsOfFirstLabel(e, t) {
    const i = this.getVerticalThresholds(e, t);
    return this.context.currentYForLabels = i.start, i;
  }
  updateDrawingData(e, t) {
    const { FONT_SIZE: i } = this.services.style.get();
    let r;
    if (e.filteredPoints.length === 0) {
      e.heightRequired = 0, e.interline = 0;
      return;
    }
    this.context.allPreselectedLabelsShouldBeDrawn === !0 ? r = this.computeDrawingData(
      e.filteredPoints,
      e.heightAvailable,
      i,
      e.textAvailableWidth,
      e.labelComponent,
      t.translator
    ) : r = this.computeLossyDrawingData(
      e.filteredPoints,
      e.heightAvailable,
      i,
      e.textAvailableWidth,
      e.labelComponent,
      t.translator
    ), e.heightRequired = r.totalSizeRequired, e.interline = r.paddingInterline;
  }
  updateColorIfNeeded(e, t, i) {
    if (this.publish(X.EVENT.UPDATE_COLOR, i), gi.areColorEquals(t, i) !== !0) {
      const r = na(i.color, i.alpha);
      e.setFillStyle(r), e.setStrokeStyle(r), t.setColorOf(i);
    }
  }
  drawLine(e, t, i, r) {
    const {
      SMALL_HORIZONTAL_LINE_LENGTH: n,
      VERTICAL_LINE_PADDING: a
    } = this.services.style.get(), o = r.side === "left" ? r.leftThreshold : r.rightThreshold, l = r.side === "left" ? -n : n, c = o, u = c + l, m = r.currentYForLabels + a, g = m + r.heightOfOneLine * i.nbLines, C = r.currentYForLabels + Math.floor(r.heightDisplay / 2) + a;
    e.beginPath();
    const I = e.getCanvasContext();
    I.lineWidth = 1.5, e.moveTo(u, m), e.lineTo(u, g), e.moveTo(u, C), e.lineTo(c, C), e.lineTo(t.x, t.y), e.stroke();
  }
  computeLabelsInfo(e, t) {
    e.filteredPoints.forEach((i, r) => {
      const n = e.side === "left" ? t.layers.leftLabels : t.layers.rightLabels;
      e.labelsInfo[i.id] = this.getLabelInfo(n, i, t.translator, e.textAvailableWidth);
    });
  }
  getSideLayer(e, t) {
    return e.side === "left" ? t.layers.leftLabels : t.layers.rightLabels;
  }
  getTextX(e) {
    if (e.side === "left") {
      const { MARGIN: t } = this.services.style.get();
      return t;
    } else {
      const { SMALL_HORIZONTAL_LINE_LENGTH: t, TEXT_PADDING: i } = this.services.style.get();
      return e.rightThreshold + t + i;
    }
  }
  computeLabelHeight(e, t) {
    const { FONT_SIZE: i } = this.services.style.get();
    e.heightOfOneLine = i, e.heightDisplay = t.nbLines * e.heightOfOneLine;
  }
  getLabelAlignement(e, t) {
    return {
      horizontal: t ? "right" : "left",
      vertical: !1 ? "alphabetic" : "bottom"
    };
  }
  labelMarginTop(e) {
  }
  drawLabels(e, t) {
    const i = e.filteredPoints, r = e.filteredPoints.length, n = e.side === "left", a = e.textAvailableWidth;
    for (let o = 0; o < r; o++) {
      e.textAvailableWidth = a;
      let l = 0, c = i.length, u = J.getOne().copy(i[0]);
      t.layers.points.applyLocalTransformationToPoint(u);
      let m = u.x, g = u.y;
      J.recycle(u, e.currentYForLabels);
      let C = e.side === "left" ? m - e.leftBorderForText : m - e.rightBorderForText, p = (g - e.currentYForLabels - e.idealLabelHeight / 2) / C;
      const T = new gi({
        color: "#000000",
        alpha: 0
      });
      for (let A = 1; A < c; A++) {
        let U = J.getOne().copy(i[A]);
        t.layers.points.applyLocalTransformationToPoint(U);
        let W = U.x, ee = U.y;
        J.recycle(U);
        const Ee = n ? W - e.leftBorderForText : W - e.rightBorderForText, Te = (ee - e.currentYForLabels - e.idealLabelHeight / 2) / Ee;
        n ? Te < p && (p = Te, l = A) : Te > p && (p = Te, l = A);
      }
      const v = J.getOne().copy(i[l]);
      this.context.taxon_key = v.taxon_key;
      const d = i[l];
      t.layers.points.applyLocalTransformationToPoint(v), i.splice(l, 1);
      const f = t.translator(v.taxon_key, v.id, this.index);
      this.index++;
      const E = e.labelsInfo[v.id];
      this.computeLabelHeight(e, E), this.labelMarginTop(e, E);
      const { VERTICAL_LINE_PADDING: y } = this.services.style.get(), _ = this.services.label.getLabelStyle(v), x = this.getSideLayer(e, t);
      this.updateColorIfNeeded(x, T, _), this.drawLine(x, v, E, e);
      const D = {
        x: this.getTextX(e),
        y: Math.ceil(e.currentYForLabels + y)
      };
      this.publish(X.EVENT.BEFORE_DRAW_TEXT, {
        taxon_key: v.taxon_key,
        context: e,
        position: D
      });
      const w = x.drawMultilineText({
        text: f,
        x: D.x,
        y: D.y,
        width: e.textAvailableWidth,
        lineHeight: e.heightOfOneLine,
        maxLines: E.nbLines,
        underline: _.underline,
        alignment: this.getLabelAlignement(v.taxon_key, e.side === "left")
      });
      e.maxLength = w.maxLength;
      const b = this.services.structure.findByTaxonKey(v.taxon_key);
      this.services.structure.updateById(b.id, {
        isTrunk8: w.isTrunk8,
        color: _.color
      }), w.lengthOfFirstLine < 0 && (w.lengthOfFirstLine *= -1), this.services.label.record(
        e.side === "left" ? e.textAvailableWidth - w.maxLength + D.x : D.x,
        e.currentYForLabels,
        w.maxLength,
        e.heightDisplay,
        v.taxon_key,
        v.id,
        e.side === "left" ? et.LEFT_INDEX : et.RIGHT_INDEX
      ), this.services.point.link(d, e.side), this.publish(X.EVENT.LABEL_DRAWN, { ...e, point: v }), E.recycle(), this.labelMarginBottom(e), J.recycle(v);
    }
  }
  getTranslationLength(e, t, i) {
    const r = `${e}-${t}`;
    if (this.data.translationLength[r])
      return this.data.translationLength[r];
    {
      const n = this.services.translator.getTranslation(e, V.NAMESPACE.CONTENT), a = i.layers.buffer.getLabelInfos(n, t);
      return this.data.translationLength[r] = a.textWidth, a.recycle(), a.textWidth;
    }
  }
  getLabelHeight(e, t, i, r, n = 2) {
    const { MIN_MARGIN_LABEL: a } = this.services.style.get(), o = this.getTranslationLength(e, t, r);
    return this.getLabelNbLine(o, i, n) * t + a;
  }
  getLabelWidth(e, t, i, r, n = 2) {
    const { MIN_MARGIN_LABEL: a } = this.services.style.get(), o = this.getTranslationLength(e, t, r), l = this.getLabelNbLine(o, i, n);
    return Math.round(o / l + a);
  }
  getLabelNbLine(e, t, i = 2) {
    let r = 1;
    return e > t.textAvailableWidth && (r = e - e % t.textAvailableWidth / t.textAvailableWidth, e / t.textAvailableWidth > this.getAuthorizedOverflow(t) && r++), Math.min(r, i);
  }
  labelMarginBottom(e) {
    e.currentYForLabels += e.heightDisplay + e.interline;
  }
  findBestFontSize(e, t) {
    const { MIN_FONT_PX: i } = this.services.style.get(), r = this.getBestFontSizeCandidates(e, t.candidates.left, t), n = this.getBestFontSizeCandidates(e, t.candidates.right, t);
    return Math.floor(Math.max(Math.min(r, n), i));
  }
  setFontSize(e) {
    this.services.style.update(L.ATTRIBUTE.FONT_SIZE, e);
  }
  getFontSize() {
    return this.services.style.get(L.ATTRIBUTE.FONT_SIZE);
  }
  getAuthorizedOverflow(e) {
    return e.textAvailableWidth * Gn;
  }
  getBestFontSizeCandidates(e, t, i) {
    const {
      MAX_FONT_PX: r,
      MIN_FONT_PX: n,
      VERTICAL_LINE_PADDING: a
    } = this.services.style.get();
    let o, l = !1;
    const c = i.layers.buffer;
    let u = r;
    const m = this.getAuthorizedOverflow(e);
    for (; !l && u >= n; ) {
      let g = 0, C = 0;
      o = 0, c.setFontSize(u), t.forEach((I) => {
        const p = this.services.structure.findByTaxonKey(I.taxon_key);
        o += this.getLabelHeight(p.translation_key, u, e, i);
        const T = this.getLabelWidth(p.translation_key, u, e, i);
        g = T > g ? T : g, T > e.textAvailableWidth && C++;
      }), o <= i.layers.leftLabels.getHeightAvailable() - a && (g - m < e.textAvailableWidth || C <= t.length * 0.25) ? l = !0 : u--;
    }
    return u;
  }
  precomputeContext(e) {
    const t = {};
    this.resetContext(t), this.computeWidthAvailable(t, e.layers.points), e.candidates.left = this.updateCandidates(e.candidates.left), e.candidates.right = this.updateCandidates(e.candidates.right);
    const i = {
      forceSizeAuto: !1
    };
    this.publish(X.EVENT.FORCE_FONT_SIZE_AUTO, i), (e.application.data.fontSizeAuto || i.forceSizeAuto) && this.setFontSize(
      this.findBestFontSize(t, e)
    );
  }
}
class j {
  constructor(e) {
    this.data = e;
  }
  static recordFactory(e, t, i) {
    return {
      alias: e,
      generate(r, n) {
        te({
          instanceAlias: e,
          parameters: r.get(i),
          InstanceType: r.get(t) || t
        }).create(r.getContent(), n);
      }
    };
  }
  set(e, t) {
    this.data[e] = t;
  }
  get(e) {
    return this.data[e];
  }
  getContent() {
    return this.data;
  }
  addFactory(e, t, i, r = {}) {
    Array.isArray(this.data.factories) || (this.data.factories = []);
    const n = j.recordFactory(e, t, i);
    if (typeof r.insertBefore < "u") {
      let a = this.data.factories.findIndex((o) => o.alias === r.insertBefore);
      a >= 0 ? this.data.factories.splice(a, 0, n) : this.data.factories.push(n);
    } else
      this.data.factories.push(n);
  }
  startFactories(e) {
    this.data.factories.forEach((t) => {
      typeof t.generate == "function" ? t.generate(this, e) : t.create(this.getContent(), e);
    }), delete this.data.factories;
  }
}
class Ng extends B {
  constructor(e) {
    super(e), this.application_id = null;
  }
  setApplicationId(e) {
    this.application_id = e;
  }
  getApplicationId() {
    return this.application_id;
  }
  /**
   *  @param {Object} selectors
   *  @param priority
   *  @param {string} selectors.name
   *  @return {Promise<Image>}
   */
  getImage(e, t = B.PRIORITY.STANDARD) {
    return new Promise((i, r) => {
      const n = new Image();
      n.onload = () => {
        i(n);
      }, n.onerror = () => {
        r();
      }, this.imageHelper.requestImage(`${F.imageBaseURL}/web/images/${this.getApplicationId()}/orientations/v${e.version}/${e.name}.png?w=75&fit=clip`).then((a) => n.src = a);
    });
  }
}
class Rg extends re {
  constructor(e = {}) {
    super({
      _id: e._id || "standard-point-drawer"
    });
  }
  drawPoints(e, t) {
    let i = t.getBoundingBox();
    const r = e.slice(0);
    let n = 0;
    const a = t.services.point;
    e.forEach((l) => {
      const c = a.refreshContextualCoords({
        transformation: (g) => t.applyLocalTransformationToPoint(g),
        point: l
      }), { x: u, y: m } = c;
      if (a.isVisible(l.id))
        if (t.updatePointStyle(l), a.isInBox(c, i))
          this.drawOnePoint(l, t), r[n++] = l;
        else {
          const { RECENTER_SLIGHT_MARGIN: g } = t.services.style.get();
          if (t.needToHandleIsolateOffset === !0) {
            t.needToHandleIsolateOffset = !1;
            let C = 0, I = 0;
            l < i.left ? C = i.left - u + g : u > i.right && (C = i.right - u - g), m < i.top ? I = i.top - m + g : m > i.bottom && (I = i.bottom - m - g), (C !== 0 || I !== 0) && t.translateCanvas(C, I);
          }
        }
    }), r.length = n;
    const o = i.left + (i.right - i.left) * 0.5;
    t.services.renderingContext.update(H.ATTRIBUTE.LEFT_RIGHT_THRESHOLD, o), t.services.point.setPointsVisible(r);
  }
  /**
   * @param {Point} point
   * @param pointCanvas
   */
  drawOnePoint(e, t) {
    const {
      MULTIPLIER: i,
      IMAGE_OFFSET_X: r,
      IMAGE_OFFSET_Y: n,
      VERTICAL_FLIP: a
    } = t.services.renderingContext.get(), o = e.x * i + r, l = e.y * i + n, c = t.services.style.get(L.ATTRIBUTE.POINT_RADIUS), u = t.getComputedScaleX(a);
    t.strokeCircle(o, l, Math.abs((c + 1) / u), e.edgeAlpha, e.edgeColor, Math.abs(1 / u)), t.fillCircle(o, l, Math.abs(c / u), e.circleAlpha, e.circleColor);
  }
}
class vi {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  has(e) {
    return this.data.has(e);
  }
  get(e) {
    return this.data.get(e);
  }
  set(e, t) {
    this.data.set(e, t);
  }
  filter(e) {
    return new Map([...this.data].filter(e));
  }
}
class xg extends bt {
  constructor(e = {}) {
    super(e), this.state = {
      /** @type {ModuleState} **/
      module: e.state.module
    }, this.zip.default = null, this.typeImageDefaultContrast = [Y.THUMBNAILS, Y.BOTTOM_PREVIEW_SLICE], this.loadedZip = {}, this.cacheThumb = new vi();
  }
  /**
   * Warning : this method is Overwritten by viewer data when all hash are precalculted
   * @param {Number} sort_order
   */
  getImageKey({ sort_order: e }) {
    try {
      const t = Tr(e, "4"), i = `${this.state.module.name}#thumb#images-${t}.jpg`;
      return Ut(i);
    } catch (t) {
      return console.error(t), null;
    }
  }
  async setZipSrc(e = pe) {
    if (typeof this.loadedZip[e] < "u") {
      this.zip[0] = this.loadedZip[e], this.setQuality(0), this.isContentAvailable = !0, this.isSwitchingQuality = !1;
      return;
    }
    await this.loadZip(this.zipUrl[e]).then(async (t) => {
      this.zip[0] = t, this.loadedZip[e] = t, this.setQuality(0), this.isContentAvailable = !0, this.isSwitchingQuality = !1, e === pe && (this.zip.default = t), await this.preloadZip(e);
    });
  }
  getImage(e = {}, t = B.PRIORITY.STANDARD) {
    const i = e.code || pe;
    return this.typeImageDefaultContrast.includes(e.type) ? new Promise(async (r) => {
      const n = new Image();
      let a = e.key;
      if (typeof a > "u" && (a = this.getImageKey(e)), this.hasInCache(a, i))
        r(this.getFromCache(a, i));
      else {
        const o = await this.getDefaultImageFile(a);
        if (o === null)
          return r(null);
        try {
          o.async("arraybuffer").then((l) => {
            n.src = Sr(l);
          }), n.onload = () => {
            r(n);
          };
        } catch {
          console.error("unable to find image", e, a), r("");
        }
      }
    }) : new Promise(async (r) => {
      const n = this.getImageKey(e);
      if (this.hasInCache(n, i))
        r(this.getFromCache(n, i));
      else {
        const a = await super.getImage(e, t);
        this.cacheThumb.has(i) && this.addToCache(n, a, i), r(a);
      }
    });
  }
  getDefaultImageFile(e) {
    return new Promise((t) => {
      this.zip.default === null ? le([
        { name: B.EVENT.LOADING_END, from: this }
      ]).then(() => {
        t(this.zip.default.file(e));
      }) : t(this.zip.default.file(e));
    });
  }
  addToCache(e, t, i = pe) {
    let r;
    this.cacheThumb.has(i) ? r = this.cacheThumb.get(i) : r = /* @__PURE__ */ new Map(), r.has(e) || r.set(e, t), this.cacheThumb.set(i, r);
  }
  getFromCache(e, t = pe) {
    if (this.cacheThumb.has(t)) {
      const i = this.cacheThumb.get(t);
      if (i.has(e))
        return i.get(e);
    }
    return null;
  }
  hasInCache(e, t = pe) {
    return this.cacheThumb.has(t) && this.cacheThumb.get(t).has(e);
  }
  async preloadZip(e = pe) {
    this.cacheThumb.has(e) || (this.cacheThumb.set(e, /* @__PURE__ */ new Map()), await Promise.all(Object.keys(this.zip.current.files).map((t, i) => new Promise((r) => {
      this.getImage({ sort_order: i, type: Y.SLICE }).then(r);
    }))));
  }
  async loadZipUrls(e, t) {
    const i = `${F.baseURL}/api/${e}/images/${t.id}/thumbs/${t.version}`;
    await F.fetch(i).then((r) => r.json()).then((r) => {
      this.zipUrl = r;
    }).catch((r) => {
      throw new Mr(r.message);
    });
  }
}
class Qt {
  listToObject(e) {
    const t = e[0], i = e[1], r = [];
    let n = 0;
    for (; n < i.length; ) {
      let a = {};
      t.forEach((o, l) => {
        a[o] = i[n + l];
      }), n += t.length, r.push(a);
    }
    return r;
  }
  async parseEncrypted(e, t, i) {
    const { encryptedContent: r, notEncryptedContent: n } = t, { crypted: a, notCrypted: o } = e, l = await i.run(r), c = [];
    let u = 0, m = 0;
    for (; u < l.length; ) {
      let g = {};
      o.forEach((C, I) => {
        g[C] = n[m + I];
      }), a.forEach((C, I) => {
        g[C] = l[u + I];
      }), c.push(g), u += a.length, m += o.length;
    }
    return c;
  }
}
class Bt {
}
Bt.EVENT = {
  CONTENT_AVAILABLE: "content-available"
};
class Ai extends st {
  constructor(e = {}) {
    super(e), this.languagesLoaded = /* @__PURE__ */ new Set(), this.decipher = null;
  }
  getDecipher(e = {}) {
    return typeof e.services < "u" && e.services !== null && typeof e.services.decipher < "u" ? e.services.decipher : this.decipher;
  }
  getResourcesUrl({
    application_id: e,
    module_id: t,
    lang_id: i
  }) {
    const r = this.getResourceSubName();
    let n = `${F.baseURL}/en/api/${e}/${this.getResourceName()}/${t}/lang/${i}`;
    return r !== "" && (n += `/${r}`), n;
  }
  async loadContent(e) {
    if (this.languagesLoaded.has(e.lang_id) !== !0) {
      const t = await this.loadLanguage(e);
      this.publish(Bt.EVENT.CONTENT_AVAILABLE, t);
    }
    e.services.language.temporaryLanguage = null;
  }
  initializeLanguageAutoload(e) {
    this.subscribe(
      e.services.language,
      Re.EVENT.CHANGE,
      async ({ lang_id: t }) => {
        await this.loadContent({
          ...e,
          lang_id: t
        });
      }
    );
  }
  async parseResponse(e, t = {
    services,
    lang_id
  }) {
    const { lang_id: i } = t, r = this.getDecipher(t), n = await super.parseResponse(e, t);
    if (n.granted !== !0)
      return n;
    const o = await new Qt().parseEncrypted(
      n.data[0],
      {
        encryptedContent: n.data[1],
        notEncryptedContent: n.data[2]
      },
      r
    ), l = {};
    return o.forEach((c) => {
      typeof c.lang_id > "u" && (c.lang_id = i), Array.isArray(l[c.lang_id]) === !1 && (l[c.lang_id] = []), l[c.lang_id].push(c);
    }), l;
  }
  async loadLanguage(e) {
    const t = super.getData(e);
    return this.languagesLoaded.add(e.lang_id), t;
  }
  async getDataForDefaultLanguage(e) {
    return this.loadLanguage({
      ...e,
      lang_id: e.defaultLanguageId
    });
  }
  async getDataForCurrentLanguage(e) {
    return this.loadLanguage({
      ...e,
      lang_id: e.currentLanguageId
    });
  }
  initialize(e) {
    this.decipher = e.services.decipher, this.initializeLanguageAutoload(e);
  }
  async getData(e) {
    this.initialize(e);
    const t = [];
    t.push(this.getDataForDefaultLanguage(e)), (e.defaultLanguageId !== e.currentLanguageId || e.defaultLanguageId !== e.interfaceLanguageId) && t.push(this.getDataForCurrentLanguage(e));
    const i = await Promise.all(t);
    let r = {};
    i.forEach((n) => {
      r = {
        ...r,
        ...n
      };
    }), this.publish(Bt.EVENT.CONTENT_AVAILABLE, r);
  }
}
class Dg extends Ai {
  getResourceName() {
    return "ui-translation";
  }
  async getDataForCurrentLanguage(e) {
    return await this.loadLanguage({ ...e, lang_id: e.interfaceLanguageId });
  }
}
class Fe extends st {
  async parseResponse(e, t) {
    const i = await super.parseResponse(e, t);
    return new Qt().listToObject(i);
  }
}
class fn {
  constructor(e = {}) {
    this.imaios_code = e.imaios_code || null, this.layer = e.layer || null, this.range = e.range || null;
  }
}
class Pg extends Fe {
  getResourceName() {
    return "overlay";
  }
  async parseResponse(e, t) {
    const i = await super.parseResponse(e), r = [];
    return i.forEach((n) => {
      r.push(new fn(n));
    }), r;
  }
}
class kg extends Vt {
  constructor() {
    super();
  }
}
class Hg {
  constructor(e = {}) {
    this.id = e.id || null, this.align_id = e.align_id || null, this.color = e.color || null, this.height = e.h || null, this.width = e.w || null, this.name_id = e.name_id || null, this.slice_id = e.slice_id || null, this.layer = e.layer || null, this.x = e.x || null, this.y = e.y || null, this.fontSize = e.font_size || null;
  }
}
class Fg extends Fe {
  getResourceName() {
    return "text-overlay";
  }
  async parseResponse(e, t) {
    const i = await super.parseResponse(e), r = [];
    return i.forEach((n) => {
      const a = new Hg(n);
      r.push(a);
    }), r;
  }
}
class zg extends Vt {
  constructor(e) {
    super(e), this.providers = {
      iconSource: e.providers.iconSource
    };
  }
  addResource(e, t = null) {
    super.addResource(e, t);
  }
  /**
   *
   * @param id
   * @return {Promise<string>}
   */
  getIcon(e) {
    const t = this.findById(e);
    let i = { name: Ni.name, version: Ni.version };
    return t !== null && (i = { name: t.name, version: t.version }), this.providers.iconSource.getImage(i);
  }
  getType() {
    return "Icon";
  }
}
class Bg extends st {
  getResourceName() {
    return "point";
  }
  async parseResponse(e, t) {
    const { decipher: i } = t.services, r = await e.json();
    return new Qt().parseEncrypted(
      r[0],
      {
        encryptedContent: r[1],
        notEncryptedContent: r[2]
      },
      i
    );
  }
}
class $g extends st {
  getResourceName() {
    return "module";
  }
  getResourcesUrl({ application_id: e, moduleName: t }) {
    const i = this.getResourceSubName(), r = Z[oa()];
    let n = `${F.baseURL}/en/api/${e}/${this.getResourceName()}/${t}/lang/${r}`;
    return i !== "" && (n += `/${i}`), n;
  }
}
class Ug extends Fe {
  getResourceName() {
    return "contrast";
  }
  async getData(e) {
    const t = await super.getData(e);
    return t.length > 0 ? t : [{ ...Er }];
  }
}
class Vg extends st {
  getResourceName() {
    return "orientation";
  }
  async parseResponse(e, t) {
    const i = await super.parseResponse(e, t), r = new Qt(), n = i.icons[0].indexOf("id");
    return n >= 0 && (i.icons[0][n] = "id"), {
      iconsNameByOrientationId: r.listToObject(i.icons),
      translationIdByOrientationId: r.listToObject(i.data)
    };
  }
}
class Gg extends Ai {
  getResourceName() {
    return "translation";
  }
}
class jg {
  constructor(e) {
    this.instances = new Array(e);
    for (let t = 0; t < e; t++)
      this.instances.push(new Image());
  }
  getOne() {
    return this.instances.pop() || null;
  }
  allowNewConnexion() {
    this.instances.push(new Image());
  }
}
class Yg extends re {
  /**
   * @param {{services: {imagePriorityHeuristic}, prioritiesAvailables: Number[]}} settings
   */
  constructor(e = {}) {
    super(e), this.queue = {}, this.priorityAvailables = [], this.nbItems = 0, this.services = {
      imagePriorityHeuristic: e.services.imagePriorityHeuristic,
      slice: e.services.slice,
      series: e.services.series
    }, this.shouldIRefreshPriorities = !1, Array.isArray(e.prioritiesAvailables) && this.addPriorities(e.prioritiesAvailables), this.subscribe(
      e.services.slice,
      fe.EVENT.SLICE_CHANGE,
      () => {
        this.shouldIRefreshPriorities = !0;
      }
    );
  }
  /**
   * @param {{src: string, type: string, slice_id:string}} imageRequest
   * @param priority
   */
  push(e, t) {
    this.isPriorityAvailable(t) || this.addPriorities([t]), this.queue[t].push(e), this.nbItems++;
  }
  /**
   * @returns {null | Object} return the image loading request with higher priority
   */
  pop() {
    this.shouldIRefreshPriorities === !0 && (this.refreshPriorities(), this.shouldIRefreshPriorities = !1);
    let e = 0;
    const t = this.priorityAvailables.length;
    let i = null;
    for (; e < t && i === null; ) {
      const r = this.priorityAvailables[e];
      this.queue[r].length > 0 && (i = this.queue[r].pop()), e++;
    }
    return i !== null && this.nbItems--, i;
  }
  isPriorityAvailable(e) {
    return this.priorityAvailables.indexOf(e) > 0;
  }
  addPriorities(e = []) {
    e.forEach((t) => {
      this.isPriorityAvailable(t) || (Array.isArray(this.queue[t]) || (this.queue[t] = []), this.priorityAvailables.push(t));
    }), this.priorityAvailables.sort((t, i) => i - t);
  }
  refreshPriorities() {
    const e = {
      [B.PRIORITY.MAX]: [],
      [B.PRIORITY.HIGH]: [],
      [B.PRIORITY.STANDARD]: []
    };
    this.priorityAvailables.forEach((r) => {
      Array.isArray(e[r]) || (e[r] = []);
    });
    const t = this.services.slice.getCurrentId(), i = this.services.series.getCurrentId();
    Object.keys(this.queue).forEach((r) => {
      const n = parseInt(r, 10);
      this.queue[r].forEach((o) => {
        let l = n;
        if (o.type === Y.SLICE || o.type === Y.OVERLAY)
          if (o.slice_id === t)
            l = B.PRIORITY.MAX;
          else if (typeof o.slice_id < "u") {
            const c = this.services.slice.findById(o.slice_id);
            c === null && (console.log("slice is null"), console.table(o)), c.series_id === i ? l = B.PRIORITY.HIGH : l > B.PRIORITY.STANDARD && (l = B.PRIORITY.STANDARD);
          } else
            l > B.PRIORITY.STANDARD && (l = B.PRIORITY.STANDARD);
        e[l].push(o);
      });
    }), this.setQueue(e);
  }
  setQueue(e) {
    this.queue = e, this.addPriorities(Object.keys(e).map((t) => parseInt(t, 10)));
  }
  isEmpty() {
    return this.nbItems <= 0;
  }
}
const Wg = 1e3;
class Zg extends re {
  constructor(e = {}) {
    super(e), this.connexionPool = new jg(4), this.queue = new Yg(e), this.imageHelper = e.services["image-helper"], this.loadingImage = /* @__PURE__ */ new Set(), this.lastTimeStopLoadingImageNotification = null, document.addEventListener(z.image.STOP_LOADING_IMAGES, () => {
      this.lastTimeStopLoadingImageNotification = Date.now();
    });
  }
  getImage(e, t = B.PRIORITY.STANDARD) {
    const i = this.connexionPool.getOne();
    return i === null ? this.delayLoading(e, t) : this.load(i, e);
  }
  delayLoading(e, t) {
    return new Promise((i) => {
      e.resolve = i, this.queue.push(e, t);
    });
  }
  load(e, t) {
    return new Promise((i) => {
      this.loadingImage.add(e), e.crossOrigin = "Anonymous", e.onload = () => {
        const r = document.createElement("CANVAS"), n = r.getContext("2d");
        r.height = e.naturalHeight, r.width = e.naturalWidth, n.drawImage(e, 0, 0), this.loadNextImage(), this.publish(B.EVENT.ASK_HIDE_PROGRESS, t.image_id), this.publish(B.EVENT.LOADING_END, t.image_id), this.loadingImage.delete(e), i(e);
      }, e.onerror = () => {
        this.lastTimeStopLoadingImageNotification !== null && Date.now() - this.lastTimeStopLoadingImageNotification <= Wg ? this.imageHelper.requestImage(t.src).then((r) => e.src = r) : (this.loadNextImage(), this.loadingImage.delete(e), i(null));
      }, this.imageHelper.requestImage(t.src).then((r) => e.src = r);
    });
  }
  loadNextImage() {
    this.connexionPool.allowNewConnexion(), this.startNewRequestFromQueue();
  }
  startNewRequestFromQueue() {
    const e = this.connexionPool.getOne();
    if (e === null)
      return;
    if (this.queue.isEmpty()) {
      this.connexionPool.allowNewConnexion();
      return;
    }
    const t = this.queue.pop();
    t !== null && this.load(e, t).then((i) => {
      typeof t.resolve == "function" && t.resolve(i);
    });
  }
}
class Xg extends st {
  constructor(e) {
    super(e), this.imageHelper = e.services["image-helper"], this.imageQueueProvider = new Zg(e), this.state = {
      /** @type {ModuleState} **/
      module: e.state.module
    }, this.services = {
      slice: e.services.slice,
      series: e.services.series,
      renderingContext: e.services.renderingContext,
      imageCache: e.services.imageCache,
      imageSettingsStorage: e.services.imageSettingsStorage,
      modality: e.services.modality
    }, this.application_id = null, this.initialized = !1;
  }
  /**
   * @param {string} application_id
   */
  setApplicationId(e) {
    this.application_id = e;
  }
  getApplicationId() {
    return this.application_id;
  }
  getResourceName() {
    return "images";
  }
  getSliceHeight(e) {
    return this.services.series.findById(e.series_id).slices_height;
  }
  getSliceWidth(e) {
    return this.services.series.findById(e.series_id).slices_width;
  }
  /**
   * @param {Slice} slice
   * @param {number|null} width
   * @param {number|null} height
   * @returns {{name: string, value: number}}
   */
  restrictBySliceSize(e, t = null, i = null) {
    const r = [480, 740, 920];
    t === null && (t = this.getSliceWidth(e)), i === null && (i = this.getSliceHeight(e));
    let n, a;
    i < t ? (n = "h", a = i) : (n = "w", a = t);
    const o = r[0], l = Math.max(r[r.length - 1], a);
    let c = 0;
    for (; c < r.length && a > r[c]; )
      ++c;
    if (c > 0) {
      const u = r[c] - a < a - r[c - 1] ? c : c - 1;
      a = r[u];
    }
    return {
      name: n,
      value: Math.max(Math.min(a, l), o)
    };
  }
  forgeImageSrc(e, t) {
    const i = new URLSearchParams();
    let r = null;
    if (t.slice_id && (r = this.services.slice.findById(t.slice_id)), r === null && t.sort_order && (r = this.services.slice.findOne({ sort_order: t.sort_order })), r !== null) {
      const n = this.getSliceHeight(r), a = this.getSliceWidth(r);
      if (t.type === Y.SLICE || t.type === Y.OVERLAY) {
        let o = this.restrictBySliceSize(r, a, n);
        const l = t.quality || 0;
        let c = Math.max(Math.min(l, h.getHighQuality()), dt.LOWEST);
        const m = this.services.series.findById(r.series_id).modality_id ?? -1;
        this.services.modality.isHighQuality(m) && (c = h.getHighQuality(), o = null), i.set("q", (t.type === Y.SLICE ? c : Pn).toString(10)), o !== null && (i.set(o?.name, o?.value), i.set("fit", "clip"));
      } else (t.type === Y.THUMBNAILS || t.type === Y.GALLERY_THUMB) && t.width && (i.set("w", t.width), i.set("fit", "clip"));
      t.type === Y.OVERLAY && i.set("fm", "png");
    }
    return `${F.imageBaseURL}/web/images/${this.getApplicationId()}/modules/${this.state.module.name}/images/v${this.state.module.version}/${e}?${i.toString()}`;
  }
  /**
   * Search same image with different type. If an image with different type was found in cache, and type is known as an "upscaled version", return this image
   * @param {{ dedupedImageId: string, type: string }} settings
   */
  searchUpscaledImage(e) {
    if (
      // slice should be de bigger image type
      e.type === Y.SLICE || // no alternative for overlays
      e.type === Y.OVERLAY || // feature not available for CR
      e.type === Y.CROSS_REFERENCES
    )
      return null;
    const t = this.services.imageSettingsStorage.filter((r) => r.dedupedImageId === e.dedupedImageId && this.services.imageCache.has(r.image_id));
    let i = e;
    return t.forEach((r) => {
      // slice is better than everything
      (r.type === Y.SLICE || i.type === Y.THUMBNAILS || i.type === Y.BOTTOM_PREVIEW_SLICE && r.type === Y.GALLERY_THUMB) && (i = r);
    }), this.services.imageCache.get(i.image_id) || null;
  }
  fillSettings(e) {
    if (e.image_id) {
      const t = e.image_id.split("-");
      if (typeof e.slice_id > "u")
        if (typeof e.sort_order == "number") {
          e.sort_order === 0 && (e.sort_order = 1);
          const i = this.services.slice.findOne({ sort_order: e.sort_order });
          if (i === null) {
            console.table(e), console.log(new Error().stack);
            return;
          }
          e.slice_id = i.id;
        } else
          e.slice_id = t[0];
      typeof e.code > "u" && (e.code = t[1]);
    }
  }
  getImage(e = {}, t = B.PRIORITY.STANDARD) {
    return new Promise((i) => {
      let r = e.key;
      this.fillSettings(e);
      const n = this.searchUpscaledImage(e);
      if (n !== null)
        return i(n);
      typeof r > "u" && (r = this.imageHelper.getImageKey(e)), this.imageQueueProvider.getImage({
        ...e,
        src: this.forgeImageSrc(r, e)
      }, t).then((a) => {
        this.publish(B.EVENT.LOADING_END, r), this.publish(B.EVENT.ASK_HIDE_PROGRESS, r), e.type === Y.SLICE && this.publish(B.EVENT.IMAGE_SLICE_HAS_BEEN_LOADED, e.sort_order), i(a === null ? "" : a);
      });
    });
  }
  async getData(e) {
    if (!this.initialized) {
      const t = await super.getData(e);
      this.initialized = !0, this.data = t;
    }
    return this.data;
  }
  switchQuality(e) {
  }
}
class Qg extends Fe {
  getResourceName() {
    return "cross-references";
  }
  getResourceSubName() {
    return "title";
  }
}
class Kt {
  constructor(e = {}) {
    this.id = e.id, this.name_id = e.name_id, this.sort_order = e.sort_order || 0, this.number_of_images = e.number_of_images || 0, this.background_color = e.background_color || "000000", this.full_search = e.full_search || "no", this.canvas_width = e.canvas_width, this.canvas_height = e.canvas_height, this.modality_id = e.modality_id, this.start_index = e.start_index, this.end_index = e.end_index, this.cross_references_titles = e.cross_references_titles || [], this.contrasts = [], this.slices_width = e.slices_width, this.slices_height = e.slices_height, ++Kt.count;
  }
  addCrossRefTitleToSeries(e) {
    this.cross_references_titles.push(e);
  }
}
Kt.count = 0;
class Kg extends Fe {
  getResourceName() {
    return "series";
  }
  async getData(e) {
    const t = new Qg(), [i, r] = await Promise.all([
      super.getData(e),
      t.getData(e)
    ]), n = {};
    return i.forEach((a) => {
      const o = new Kt(a);
      n[o.id] = o;
    }), r.forEach((a) => {
      n[a.series_id].addCrossRefTitleToSeries(a);
    }), Object.values(n);
  }
}
class qg extends Fe {
  getResourceName() {
    return "cross-references";
  }
  async getData(e) {
    const t = await super.getData(e);
    return t.length > 0 && t.forEach((i) => {
      i.path = JSON.parse(i.path[0]);
    }), t;
  }
}
class Jg {
  constructor(e = {}) {
    this.crossReferencesLines = e.crossReferencesLines || [], this.id = e.id || null, this.sort_order = e.sort_order || null, this.title_id1 = e.title_id1 || null, this.title_id2 = e.title_id2 || null, this.left = e.left || null, this.right = e.right || null, this.series_id = e.series_id || null, this.textOverlaysByLayer = e.textOverlaysByLayer || {}, this.orientation_id = e.orientation_id || null, this.orientation_icon_id = e.orientation_icon_id || null, this.points = [];
  }
  addCrossReference(e) {
    this.crossReferencesLines.push(e);
  }
}
class e2 extends Fe {
  getResourceName() {
    return "slice";
  }
  async getData(e) {
    const t = new qg(), [i, r] = await Promise.all([
      super.getData(e),
      t.getData(e)
    ]), n = {};
    return i.forEach((a) => {
      const o = new Jg(a);
      n[o.id] = o;
    }), r.forEach((a) => {
      n[a.slice_id].addCrossReference(a);
    }), Object.values(n);
  }
}
class t2 {
  constructor(e = {}) {
    this.id = e.id || null, this.name = e.name || null, this.version = e.version || 1;
  }
}
class s2 extends Fe {
  getResourceName() {
    return "icon";
  }
  async parseResponse(e, t) {
    const i = await super.parseResponse(e), r = [];
    return i.forEach(
      (n) => r.push(new t2(n))
    ), r;
  }
}
class i2 {
  constructor(e = {}) {
    this.id = e.id, this.taxon_id = e.taxon_id, this.ta_id = e.ta_id, this.translation_key = e.translation_key, this.icon_id = e.icon_id, this.isTrunk8 = e.isTrunk8 || !1, this.variant_id = e.variant_id, this.legacy_eponym = e.legacy_eponym || null, this.synonym = e.synonym || null, this.acronym = e.acronym || null, this.patronym = e.patronym || null, this.fr_anc = e.fr_anc || null, this.latin_synonym = e.latin_synonym || null, this.latin_acronym = e.latin_acronym || null, this.latin_patronym = e.latin_patronym || null, this.parent_translation_key = e.parent_translation_key || null, this.name = null, this.latin_name = null;
  }
  getTaxonKey() {
    return `${this.ta_id}-${this.taxon_id}`;
  }
}
class r2 extends Ai {
  getResourceName() {
    return "structure";
  }
  getResourceSubName() {
    return "related-terms";
  }
  getResourcesUrl({
    application_id: e,
    module_id: t,
    lang_id: i
  }) {
    return `${F.baseURL}/en/api/${e}/${this.getResourceName()}/${t}/${this.getResourceSubName()}/lang/${i}`;
  }
  async getData(e) {
    if (this.initialize(e), e.defaultLanguageId !== e.currentLanguageId || e.defaultLanguageId !== e.interfaceLanguageId)
      return await this.getDataForCurrentLanguage(e);
  }
  async parseResponse(e, t) {
    const i = this.getDecipher(t), r = await st.prototype.parseResponse(e, t);
    if (r.granted !== !0)
      return r;
    const a = await new Qt().parseEncrypted(
      r.data[0],
      {
        encryptedContent: r.data[1],
        notEncryptedContent: r.data[2]
      },
      i
    );
    return Object.values(a).reduce((o, l) => (o[`${l.ta_id}-${l.taxon_id}`] = l, o), {});
  }
}
class n2 extends Fe {
  getResourceName() {
    return "structure";
  }
  async getData(e) {
    const t = new r2(e), [i, r] = await Promise.all([
      super.getData(e),
      t.getData(e)
    ]);
    return i.map((n) => {
      const a = r[`${n.ta_id}-${n.taxon_id}`] ?? {};
      return new i2({
        id: n.struct_id,
        ...n,
        ...a
      });
    });
  }
}
class a2 extends Fe {
  getResourceName() {
    return "filter";
  }
  async getData(e) {
    const t = await super.getData(e), i = {};
    return t.forEach((r) => {
      i[r.id] = r, r.children = [];
    }), t.forEach((r) => {
      const n = r.parents, a = i[n];
      a && (r.isChild = !0, a.children.push(r));
    }), t;
  }
}
class o2 extends Error {
  constructor(e, t) {
    super(`Unable to load image with key "${e}", type of image is "${t}"`), this.name = this.constructor.name;
  }
}
class l2 {
  constructor(e = {}) {
    this.imageProvider = e.providers.image, this.imageHelper = e.services["image-helper"], this.imageInCache = {};
  }
  getImageKey(e = 0, t = 0, i = "jpg") {
    try {
      const n = `${this.imageProvider.state.module.name}#crossref-${e}-${t}.${i}`;
      return Ut(n);
    } catch (r) {
      return console.error(r), null;
    }
  }
  async getImage(e = {}, t = B.PRIORITY.STANDARD) {
    const { series: i, cr_sort_order: r } = e, n = e.format || "jpg", a = this.getImageKey(i.sort_order, r, n);
    if (typeof this.imageInCache[a] < "u")
      return this.imageInCache[a];
    let o = await this.imageProvider.getImage(
      {
        type: Y.CROSS_REFERENCES,
        ...e,
        key: a
      },
      B.PRIORITY.HIGH
    );
    if (o === null)
      throw new o2(a, "Cross-reference");
    return o !== "" && (o = this.imageHelper.asLocalImage(o), this.imageInCache[a] = o), o;
  }
  async switchQuality(e) {
    return this.imageProvider.switchQuality(e);
  }
  setImageProvider(e) {
    this.imageProvider !== e && (this.imageProvider = e);
  }
}
class c2 extends B {
  constructor(e) {
    super(e), this.application_id = null, this.imageHelper = e.services["image-helper"];
  }
  /**
   * @param {string} application_id
   */
  setApplicationId(e) {
    this.application_id = e;
  }
  getApplicationId() {
    return this.application_id;
  }
  /** @param {QUALITY} quality **/
  isQualityAvailable(e) {
  }
  /** @param {QUALITY} qualityRequired **/
  setQuality(e) {
  }
  /** @param {QUALITY} qualityRequired**/
  switchQuality(e) {
  }
  /** @param {Object} selectors
   * @param priority
   * @return {Promise<string>}
   */
  getImage({ name: e, version: t }, i = B.PRIORITY.STANDARD) {
    return this.imageHelper.requestImage(`${F.imageBaseURL}/web/images/${this.getApplicationId()}/icons/v${t}/${e}.png?w=25&h=25`);
  }
}
class u2 {
  constructor(e) {
    this.state = {
      /** @type {ModuleState} **/
      module: e.state.module
    }, this.services = {
      /** @type {SliceService} **/
      slice: e.services.slice
    }, this.imagixApiProvider = e.providers.imagixApiProvider;
  }
  /**
   * Warning : this method is Overwritten by viewer data when all hash are precalculated
   * @param {Object} settings
   * @param {Number} settings.slice_id
   * @param {Number} settings.sort_order
   * @param {string} settings.code
   * @param {string} settings.format
   */
  getImageKey(e = {}) {
    const t = e.code, i = e.format || "jpg";
    typeof e.sort_order > "u" && this.addSliceOrder(e);
    try {
      const r = this.state.module.name, n = Tr(e.sort_order, "4"), a = `${r}#${t}#images-${n}.${i}`;
      return Ut(a);
    } catch (r) {
      return console.error(r), null;
    }
  }
  addSliceOrder(e = {}, t = null) {
    return t === null && typeof e.slice_id < "u" && (t = this.services.slice.findById(e.slice_id)), e.sort_order = t === null ? 1 : t.sort_order, e;
  }
  asLocalImage(e) {
    const t = document.createElement("canvas"), i = t.getContext("2d");
    t.width = e.width, t.height = e.height, i.drawImage(e, 0, 0);
    const r = new Image(e.width, e.height);
    return r.src = t.toDataURL("image/jpeg"), r;
  }
  requestImage(e) {
    return this.imagixApiProvider.buildValidUrl(e);
  }
}
class d2 {
  decrypt(e) {
    const t = Et.enc.Base64.parse(h.keyIV), i = Et.enc.Utf8.parse(Et.MD5(h.key).toString().substr(0, 16).toLocaleUpperCase()), r = { iv: t, padding: Et.pad.ZeroPadding }, n = Et.AES.decrypt(String(e), i, r);
    return JSON.parse(n.toString(Et.enc.Utf8));
  }
}
class h2 {
  constructor(e) {
    this.callback = e;
  }
  async run(e) {
    return await this.callback(e);
  }
}
class Ne {
  static generateId() {
    return `w_${Math.random().toString(36).substr(2, 9)}`;
  }
  static getDeviceId() {
    if (Ne.deviceId !== null)
      return Ne.deviceId;
    if (typeof window.siq < "u") {
      const t = window.siq.getDeviceId();
      return Ne.deviceId = t, t;
    }
    let e = G.get("im_device_id");
    return e || (e = Ne.generateId(), G.add("im_device_id", e)), Ne.deviceId = e, e;
  }
}
Ne.deviceId = null;
const nr = "signature_not_initiated", m2 = 31;
class $t {
  constructor() {
    this.signature = nr, this.expire = this.getExpire(), this.imageEncodingSupported = null, this.agent = new re({ _id: "imagix-api-provider" }), this.initialize();
  }
  initialize() {
    this.initializeSignature(), this.getBestImageFormatSupported().then((e) => this.imageEncodingSupported = e);
  }
  /**
      * Expire every 31 days from the start of the current month
      * @return {number}
      */
  getExpire() {
    const e = /* @__PURE__ */ new Date(), t = e.getFullYear(), i = e.getMonth(), r = new Date(t, i, 1);
    return r.setHours(0, 0, 0, 0), r.setHours(24 * m2), r.getTime();
  }
  /**
      * Add default parameters and sort query parameters
      * @param url
      * @return {Promise<string>}
      */
  async buildValidUrl(e) {
    const t = new URL(e);
    return this.imageEncodingSupported !== Es.DEFAULT && t.searchParams.delete("fm"), t.searchParams.set(Mt.device, Ne.getDeviceId()), t.searchParams.sort(), this.signature === nr && await le([{
      from: this.agent,
      name: $t.EVENT.SIGNATURE_INITIALIZED
    }]), this.signature !== null && (t.searchParams.set(Mt.expire, this.expire), t.searchParams.set(Mt.signature, this.getSignedUrl(t.toString(), this.signature, this.expire))), t.toString();
  }
  getBestImageFormatSupported() {
    return new Promise((e, t) => {
      const i = new Image();
      i.onload = e, i.onerror = t, i.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
    }).then(() => Es.AVIF).catch(() => Es.DEFAULT);
  }
  initializeSignature() {
    const e = new Headers();
    e.set(Di.device, Ne.getDeviceId()), fetch("/api/imagix/sig", {
      method: "POST",
      headers: e,
      body: JSON.stringify({ device_id: Ne.getDeviceId() })
    }).then((t) => t.json()).then((t) => {
      this.agent.publish($t.EVENT.SIGNATURE_INITIALIZED), this.signature = t[Di.signature];
    }).catch((t) => {
      this.signature = null, console.error(t), h.sendCoreError(t);
    });
  }
  buildHeaders() {
    const e = new Headers();
    return this.imageEncodingSupported !== null && e.set("Accept", this.imageEncodingSupported), e;
  }
  getSignedUrl(e, t, i) {
    return h.md5(t + this.getUrlToSign(e, i));
  }
  /**
      *
      * @param {string} url
      * @param {string} expire
      * @return {string} Url to sign
      */
  getUrlToSign(e, t) {
    const i = new URL(e);
    return i.searchParams.delete(Mt.signature), i.searchParams.set(Mt.expire, t), i.searchParams.sort(), i.toString().replace(i.origin, "");
  }
}
$t.EVENT = {
  SIGNATURE_INITIALIZED: "signature-initialized"
};
class f2 extends re {
  constructor(e) {
    super(e), this.application = null, this.services = {
      /** @type {SeriesService} **/
      series: e.services.series,
      /** @type {renderingContext} **/
      renderingContext: e.services.renderingContext
    };
  }
  setApplication(e) {
    this.application = e;
  }
  getCurrentSeriesSize() {
    const e = this.services.series.getCurrent();
    if (e === null)
      return null;
    const { MULTIPLIER: t } = this.services.renderingContext.get();
    return {
      width: e.slices_width * t,
      height: e.slices_height * t
    };
  }
  getPointCanvas() {
    const e = this.application.components.pointsCanvas, t = e.getComputedScaleX(), i = e.getComputedScaleY(), r = e.getTx(), n = e.getTy();
    return {
      pointsCanvas: e,
      scaleX: t,
      scaleY: i,
      translateX: r,
      translateY: n
    };
  }
  getImageCorners() {
    const e = this.getCurrentSeriesSize();
    if (e === null)
      return null;
    const {
      pointsCanvas: t,
      scaleX: i,
      scaleY: r,
      translateX: n,
      translateY: a
    } = this.getPointCanvas(), o = {
      x: e.width / 2,
      y: e.height / 2
    }, l = [
      t.transformMatrix.rotatePoint(-o.x, -o.y),
      t.transformMatrix.rotatePoint(o.x, -o.y),
      t.transformMatrix.rotatePoint(o.x, o.y),
      t.transformMatrix.rotatePoint(-o.x, o.y)
    ];
    return l.forEach((c) => {
      c.setX(c.getX() * i + n), c.setY(c.getY() * r + a);
    }), l;
  }
  getImageBorders(e) {
    const t = Math.min(e[0].getX(), e[1].getX(), e[2].getX(), e[3].getX()), i = Math.max(e[0].getX(), e[1].getX(), e[2].getX(), e[3].getX()), r = Math.min(e[0].getY(), e[1].getY(), e[2].getY(), e[3].getY()), n = Math.max(e[0].getY(), e[1].getY(), e[2].getY(), e[3].getY());
    return {
      top: r,
      left: t,
      right: i,
      bottom: n
    };
  }
  getVisibleImageBorder(e, t) {
    const {
      pointsCanvas: i,
      scaleX: r,
      scaleY: n
    } = this.getPointCanvas(), a = {
      x: Math.max(t.left, 0),
      y: Math.max(t.top, i.paddingTop)
    };
    return {
      x: a.x,
      y: a.y,
      width: (Math.min(t.right, i.getWidth()) - a.x) / r,
      height: (Math.min(t.bottom, i.getHeightAvailable() + i.paddingTop) - a.y) / n
    };
  }
  getRoi() {
    const e = this.getImageCorners();
    if (e === null)
      return null;
    const t = this.application.components.pointsCanvas, { SCALE: i } = this.services.renderingContext.get(), r = this.getImageBorders(e), n = this.getVisibleImageBorder(e, r), a = r.left > 0 ? 0 : Math.abs(r.left / i), o = r.top - t.paddingTop > 0 ? 0 : Math.abs(r.top - t.paddingTop) / i;
    return {
      x: Math.round(a),
      y: Math.round(o),
      w: Math.round(n.width),
      h: Math.round(n.height)
    };
  }
}
class p2 extends re {
  constructor(e) {
    super(e), this.application = null, this.services = {
      /** @type {RoiService} **/
      roi: e.services.roi
    };
  }
  setApplication(e) {
    this.application = e;
  }
  draw() {
    const e = this.services.roi.getImageCorners();
    if (e === null)
      return;
    const t = this.services.roi.getImageBorders(e), i = this.services.roi.getVisibleImageBorder(e, t), { pointsCanvas: r } = this.services.roi.getPointCanvas(), n = this.application.components.imageCanvas.getCanvasContext();
    n.save(), n.resetTransform(), this.drawImageBorder(n, t), this.drawTopLeftCorner(n, i), this.drawVisibleRect(n, i), this.drawInformationPoint(n, r, i, t), this.drawCanvasCenter(n), this.drawRoiCenter(n, i), this.drawImageCenter(n, t), n.restore();
  }
  drawImageBorder(e, t) {
    e.strokeStyle = "red", e.lineWidth = 6, e.strokeRect(
      t.left,
      t.top,
      t.right - t.left,
      t.bottom - t.top
    );
  }
  drawTopLeftCorner(e, t) {
    e.fillStyle = "blue";
    const i = 6;
    e.fillRect(
      t.x - i / 2,
      t.y - i / 2,
      i,
      i
    );
  }
  drawVisibleRect(e, t) {
    const { scaleX: i, scaleY: r } = this.services.roi.getPointCanvas();
    e.strokeStyle = "green", e.lineWidth = 3, e.strokeRect(
      t.x,
      t.y,
      t.width * i,
      t.height * r
    );
  }
  drawInformationPoint(e, t, i, r) {
    const n = this.application.services.roi.getRoi(), { scaleX: a, scaleY: o } = this.services.roi.getPointCanvas();
    e.font = "bold 16px sans-serif", e.fillStyle = "rgba(0, 0, 0, .8)";
    const l = t.getHeight() - 200, c = t.getWidth() - 175;
    e.fillRect(c, l, 165, 190), e.fillStyle = "#fff", e.fillText(`X: ${n.x.toFixed(2)}`, c + 10, l + 20), e.fillText(`Y: ${n.y.toFixed(2)}`, c + 10, l + 40), e.fillText(`W: ${n.w.toFixed(2)}`, c + 10, l + 60), e.fillText(`H: ${n.h.toFixed(2)}`, c + 10, l + 80), e.fillText(`ScaleX: ${a.toFixed(2)}`, c + 10, l + 100), e.fillText(`ScaleY: ${o.toFixed(2)}`, c + 10, l + 120), e.fillText(`left: ${r.left.toFixed(2)}`, c + 10, l + 140), e.fillText(`top: ${r.top.toFixed(2)}`, c + 10, l + 160);
  }
  drawCenterCross(e, t, i = 20, r = "#000") {
    e.beginPath(), e.strokeStyle = r, e.moveTo(t.x, t.y - i / 2), e.lineTo(t.x, t.y + i / 2), e.moveTo(t.x - i / 2, t.y), e.lineTo(t.x + i / 2, t.y), e.stroke(), e.closePath();
  }
  drawCanvasCenter(e) {
    const {
      width: t,
      height: i,
      top: r
    } = this.application.getViewport();
    this.drawCenterCross(e, {
      x: t / 2,
      y: i / 2 + r
    });
  }
  drawRoiCenter(e, t) {
    const { scaleX: i, scaleY: r } = this.services.roi.getPointCanvas();
    this.drawCenterCross(e, {
      x: t.x + t.width * i / 2,
      y: t.y + t.height * r / 2
    }, 20, "green");
  }
  drawImageCenter(e, t) {
    const i = this.application.services.series.getCurrent(), { MULTIPLIER: r } = this.application.services.renderingContext.get(), {
      scaleX: n,
      scaleY: a
    } = this.services.roi.getPointCanvas(), o = {
      width: i.slices_width * r,
      height: i.slices_height * r
    };
    this.drawCenterCross(e, {
      x: t.left + o.width * n / 2,
      y: t.top + o.height * a / 2
    }, 20, "red");
  }
}
const gs = new j({
  interactions: dg,
  // states and helpers
  "state.label.instance": Ag,
  "state.structure.instance": wg,
  "state.image.instance": jt,
  "state.pointer.instance": dr,
  "state.language.instance": mg,
  "state.contrast.instance": pg,
  "state.series.instance": gg,
  "state.orientation.instance": vg,
  "state.slice.instance": yg,
  "state.style.instance": L,
  "state.module.instance": Eg,
  "state.interaction.instance": Cg,
  "state.modality.instance": Tg,
  "state.renderingContext.instance": H,
  "state.filter.instance": Ig,
  "state.overlay.instance": Og,
  viewerHelper: new lg(),
  "image.provider.instance": Xg,
  "image.provider.parameters": {},
  "image-thumb.provider.instance": xg,
  "image-thumb.provider.parameters": {},
  "points.provider.instance": Bg,
  "points.provider.parameters": { data: {} },
  "module.provider.instance": $g,
  "module.provider.parameters": {},
  "structures.provider.instance": n2,
  "structures.provider.parameters": {},
  "series.provider.instance": Kg,
  "series.provider.parameters": {},
  "contrasts.provider.instance": Ug,
  "contrasts.provider.parameters": {},
  "filters.provider.instance": a2,
  "filters.provider.parameters": {},
  "slices.provider.instance": e2,
  "slices.provider.parameters": {},
  "translations.provider.instance": Gg,
  "translations.provider.parameters": {},
  "ui-translations.provider.instance": Dg,
  "ui-translations.provider.parameters": {},
  "icons.provider.instance": s2,
  "icons.provider.parameters": {},
  "crImages.provider.instance": l2,
  "crImages.provider.parameters": {},
  "iconSource.provider.instance": c2,
  "iconSource.provider.parameters": {
    _id: "legacy-icon-zip-provider"
  },
  "orientation.provider.instance": Vg,
  "orientation.provider.parameters": {
    data: {
      iconsNameByOrientationId: {},
      translationIdByOrientationId: {}
    }
  },
  "orientationImage.provider.instance": Ng,
  "overlays.provider.instance": Pg,
  "overlays.provider.parameters": {},
  "textOverlays.provider.instance": Fg,
  "textOverlays.provider.parameters": {},
  "imagix.provider.instance": $t,
  "imagix.provider.parameters": {},
  factories: [
    j.recordFactory("state.module", "state.module.instance"),
    j.recordFactory("state.label", "state.label.instance"),
    j.recordFactory("state.structure", "state.structure.instance"),
    // Container.recordFactory('state.viewer', 'state.viewer.instance'),
    j.recordFactory("state.image", "state.image.instance"),
    j.recordFactory("state.pointer", "state.pointer.instance"),
    j.recordFactory("state.language", "state.language.instance"),
    j.recordFactory("state.contrast", "state.contrast.instance"),
    j.recordFactory("state.series", "state.series.instance"),
    j.recordFactory("state.orientation", "state.orientation.instance"),
    j.recordFactory("state.slice", "state.slice.instance"),
    j.recordFactory("state.style", "state.style.instance"),
    j.recordFactory("state.interaction", "state.interaction.instance"),
    j.recordFactory("stat.modality", "state.modality.instance"),
    j.recordFactory("state.renderingContext", "state.renderingContext.instance"),
    j.recordFactory("state.filter", "state.filter.instance"),
    j.recordFactory("state.overlay", "state.overlay.instance"),
    j.recordFactory("providers.imagixApiProvider", "imagix.provider.instance", "imagix.provider.parameters"),
    j.recordFactory("providers.module", "module.provider.instance", "module.provider.parameters"),
    j.recordFactory("providers.points", "points.provider.instance", "points.provider.parameters"),
    j.recordFactory("providers.structures", "structures.provider.instance", "structures.provider.parameters"),
    j.recordFactory("providers.series", "series.provider.instance", "series.provider.parameters"),
    j.recordFactory("providers.orientation", "orientation.provider.instance", "orientation.provider.parameters"),
    j.recordFactory("providers.contrasts", "contrasts.provider.instance", "contrasts.provider.parameters"),
    j.recordFactory("providers.filters", "filters.provider.instance", "filters.provider.parameters"),
    j.recordFactory("providers.slices", "slices.provider.instance", "slices.provider.parameters"),
    j.recordFactory("providers.translations", "translations.provider.instance", "translations.provider.parameters"),
    j.recordFactory("providers.ui-translations", "ui-translations.provider.instance", "ui-translations.provider.parameters"),
    j.recordFactory("providers.icon", "icons.provider.instance", "icons.provider.parameters"),
    j.recordFactory("providers.overlays", "overlays.provider.instance", "overlays.provider.parameters"),
    j.recordFactory("providers.textOverlays", "textOverlays.provider.instance", "textOverlays.provider.parameters"),
    te({
      InstanceType: _g,
      instanceAlias: "services.style"
    }),
    te({
      InstanceType: et,
      instanceAlias: "services.label"
    }),
    te({
      InstanceType: Lg,
      instanceAlias: "services.pointer"
    }),
    te({
      InstanceType: bg,
      instanceAlias: "services.renderingContext"
    }),
    te({
      InstanceType: fe,
      instanceAlias: "services.slice"
    }),
    te({
      InstanceType: Sg,
      instanceAlias: "services.modality"
    }),
    te({
      InstanceType: vt,
      instanceAlias: "services.series"
    }),
    te({
      InstanceType: gt,
      instanceAlias: "services.transform"
    }),
    te({
      InstanceType: kg,
      instanceAlias: "services.textOverlay"
    }),
    te({
      InstanceType: Xt,
      instanceAlias: "services.overlay"
    }),
    j.recordFactory("providers.image", "image.provider.instance", "image.provider.parameters"),
    j.recordFactory("providers.imageThumb", "image-thumb.provider.instance", "image-thumb.provider.parameters"),
    j.recordFactory("providers.iconSource", "iconSource.provider.instance", "iconSource.provider.parameters"),
    j.recordFactory("providers.orientationImage", "orientationImage.provider.instance"),
    j.recordFactory("providers.crImages", "crImages.provider.instance", "crImages.provider.parameters"),
    te({
      InstanceType: Re,
      instanceAlias: "services.language"
    }),
    te({
      InstanceType: Ce,
      instanceAlias: "services.contrast"
    }),
    te({
      InstanceType: ug,
      instanceAlias: "services.filter"
    }),
    te({
      InstanceType: He,
      instanceAlias: "services.image"
    }),
    te({
      InstanceType: fg,
      instanceAlias: "services.translator"
    }),
    te({
      InstanceType: ae,
      instanceAlias: "services.structure"
    }),
    te({
      InstanceType: ut,
      instanceAlias: "services.orientation"
    }),
    te({
      InstanceType: zg,
      instanceAlias: "services.icon"
    }),
    te({
      InstanceType: hg,
      instanceAlias: "services.search"
    }),
    te({
      InstanceType: Lt,
      instanceAlias: "services.interaction"
    }),
    te({
      InstanceType: mn,
      instanceAlias: "services.labelsDrawer"
    }),
    te({
      InstanceType: Rg,
      instanceAlias: "services.pointDrawer"
    }),
    te({
      InstanceType: wr,
      instanceAlias: "services.pointHelper"
    }),
    te({
      InstanceType: f2,
      instanceAlias: "services.roi"
    }),
    te({
      InstanceType: p2,
      instanceAlias: "services.debug"
    })
  ],
  accessResolverFactory: {
    create(s) {
      return new cg(s);
    }
  },
  // Services
  services: {
    point: new q(),
    imageCache: new vi(),
    imageSettingsStorage: new vi()
  },
  clickSensitivity: 10,
  iconPrefixInFolder: "eanatomycategoriesicons",
  defaultCategoryIcon: "anatomie-generale.png",
  iconBlacklisted: [
    "TODO",
    "3D"
  ],
  zoom: {
    min: 1,
    max: 5
  },
  providers: {},
  style: ge
});
gs.addFactory("services.image-helper", u2, {}, {
  insertBefore: "providers.image"
});
const g2 = (() => {
  const s = new d2();
  return new h2(
    async (e) => s.decrypt(e)
  );
})();
gs.data.services.decipher = g2;
function v2(s, e) {
  e.forEach((t) => {
    let i;
    typeof t.restrict == "function" ? i = (r) => {
      t.restrict(r) && t.action(r);
    } : i = t.action, s.subscribe(
      t.from,
      t.name,
      i
    );
  });
}
function y2(s) {
  return {
    redraw() {
      s.animations.redrawFullSlice.trigger();
    },
    redrawOverlays() {
      s.redrawOverlays();
    },
    updateStructurePriority(e) {
      s.services.point.update(
        { structure_id: e.structure_id },
        { priority: e.priority }
      );
    }
  };
}
const E2 = {
  recordCoreSubscriptions(s) {
    const e = s.services.transform, t = s.services.overlay, i = y2(s);
    v2(s, [
      { from: e, name: gt.EVENT.FLIP, action: i.redraw },
      { from: e, name: gt.EVENT.ROTATE, action: i.redraw },
      { from: t, name: Xt.EVENT.IMAGE_OPACITY_CHANGE, action: i.redrawOverlays }
    ]);
  }
};
class I2 extends Error {
  constructor(e) {
    super(`Unknown application: ${e}.`), this.name = this.constructor.name;
  }
}
const C2 = {
  loadModule: [],
  loadThumbs: ["loadModule"],
  loadPoints: ["loadModule", "loadStructures"],
  loadSeries: ["loadModule"],
  loadOrientation: ["loadModule"],
  loadTranslations: ["loadModule"],
  loadUITranslations: ["loadModule"],
  loadContrasts: ["loadModule", "loadSeries"],
  loadSlices: ["loadModule"],
  loadIcons: ["loadModule"],
  loadStructures: ["loadModule"],
  loadFilters: ["loadIcons", "loadModule"],
  loadTextOverlays: ["loadModule"],
  loadOverlays: ["loadModule", "loadTextOverlays"]
};
class _2 extends Error {
  constructor(e) {
    super(`The series with id "${e}" doesn't have any slices!`), this.name = this.constructor.name;
  }
}
class T2 extends ne {
  subscribe(e) {
    return [
      {
        from: e.services.language,
        name: Re.EVENT.CHANGE,
        action: (t) => {
          e.redrawOverlays(), e.redrawLabels();
        }
      },
      {
        from: e.services.translator,
        name: V.EVENT.ADDED,
        action: (t) => {
          parseInt(t) === e.getCurrentLanguage() && (e.redrawOverlays(), e.redrawLabels());
        }
      }
    ];
  }
}
const S2 = (s, e) => {
  const t = new T2(e);
  return t.init(s, e), t;
};
class b2 extends Oe {
  constructor() {
    super();
  }
  redraw(e) {
    e.services.overlay.refreshSelected(e.services.filter), e.animations.redrawOnlySliceMeta.trigger();
  }
  init(e) {
    const t = e.services.filter;
    le([{
      name: se.EVENT.LOADED,
      from: t
    }]).then(
      () => {
        [
          se.EVENT.SELECTED,
          se.EVENT.UNSELECTED
        ].forEach((i) => {
          e.subscribe(
            t,
            i,
            () => {
              this.redraw(e);
            }
          );
        });
      }
    );
  }
}
const A2 = (s, e) => {
  const t = new b2(e);
  return t.init(s, e), t;
};
class w2 extends ne {
  constructor(e) {
    super(e), this.hoverPointId = null, this.eventClickStartWithLabelHover = !1;
  }
  checkLabelHover(e) {
    const t = e.state.pointer, i = e.services.structure, r = e.services.label, { LEFT_PADDING: n, RIGHT_PADDING: a } = e.services.renderingContext.get(), o = r.findByCoords(
      t.data.coords.x,
      t.data.coords.y,
      {
        left: n,
        right: a
      }
    );
    if (o !== null && o.point_id !== this.hoverPointId) {
      i.hasHover() === !0 && i.clearHover();
      const l = i.findByTaxonKey(o.taxon_key);
      l && i.setHover({
        resource_id: e.services.structure.getResourcesId(l),
        taxon_key: o.taxon_key,
        point_id: o.point_id
      });
    } else i.hasHover() === !0 && o === null && i.clearHover();
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_DOWN,
        action: () => {
          e.services.structure.hasHover() && (this.eventClickStartWithLabelHover = !0);
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_LEAVE,
        action: () => {
          e.services.structure.clearHover();
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_MOVE,
        action: () => {
          e.state.pointer.isDown ? this.eventClickStartWithLabelHover && (this.checkLabelHover(e), e.services.structure.hasHover() || (e.services.structure.clearHover(), e.services.interaction.getCurrent().start(), this.eventClickStartWithLabelHover = !1)) : this.checkLabelHover(e);
        }
      },
      {
        from: e.services.structure,
        name: ae.EVENT.HOVER,
        action: ({ resource_id: t, taxon_key: i, point_id: r }) => {
          e.services.structure.findById(t) !== null && (e.services.structure.setCurrent(t, i), this.hoverPointId = r), e.ui.container.classList.add("label-hover"), e.services.label.setStyle(r, "underline", !0), e.animations.redrawOnlySliceMeta.trigger();
        }
      },
      {
        from: e.services.structure,
        name: ae.EVENT.LOOSE_HOVER,
        action: (t) => {
          e.ui.container.classList.remove("label-hover"), e.services.label.setStyle(this.hoverPointId, "underline", !1), this.hoverPointId = null, e.animations.redrawOnlySliceMeta.trigger();
        }
      },
      {
        from: e.handlers.pointer,
        name: [$.EVENT.POINTER_UP, $.EVENT.TOUCH_END],
        action: (t) => {
          const i = oe.isMobileOrTablet();
          if (i && this.checkLabelHover(e), e.services.structure.hasHover() === !0 && (i || oe.isLeftClick(t))) {
            const r = e.services.structure.getHover(), n = e.services.point.findById(this.hoverPointId);
            e.services.structure.publish(
              ae.EVENT.CLICK,
              { structure: r, point: n }
            );
          }
          setTimeout(() => {
            i && e.services.structure.clearHover();
          }, 150);
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.TOUCH_END,
        action: () => {
          if (oe.isSafariBrowser()) {
            if (this.checkLabelHover(e), e.services.structure.hasHover() === !0) {
              const t = e.services.structure.getHover(), i = e.services.point.findById(this.hoverPointId);
              e.services.structure.publish(
                ae.EVENT.CLICK,
                { structure: t, point: i }
              );
            }
            setTimeout(() => {
              e.services.structure.clearHover();
            }, 150);
          }
        }
      }
    ];
  }
}
const L2 = (s, e) => {
  const t = new w2(e);
  return t.init(s, e), t;
};
class O2 extends ne {
  constructor(e) {
    super(e), this.eventClickStartWithPointHover = !1;
  }
  checkPointHover(e) {
    const t = e.services.point, i = e.services.point.getPointHover(e), r = t.hasHover();
    i !== null && (!r || r && t.getHover().id !== i.id) ? t.setHover({ resource_id: i.id }) : r && i === null && t.clearHover();
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_DOWN,
        action: () => {
          e.services.point.hasHover() && (this.eventClickStartWithPointHover = !0);
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_MOVE,
        /** @param {PointerEvent} pointer */
        action: (t) => {
          e.state.pointer.isDown === !1 ? this.checkPointHover(e) : this.eventClickStartWithPointHover && (this.checkPointHover(e), e.services.point.hasHover() || (e.services.point.clearHover(), e.services.interaction.getCurrent().start(), this.eventClickStartWithPointHover = !1));
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.HOVER,
        action: ({ resource_id: t }) => {
          const i = e.services.point.findById(t);
          e.services.structure.setLastTaxonKey(i.taxon_key), e.ui.container.classList.add("point-hover");
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.LOOSE_HOVER,
        action: (t) => {
          e.ui.container.classList.remove("point-hover");
        }
      },
      {
        from: e.handlers.pointer,
        name: [$.EVENT.POINTER_UP, $.EVENT.TOUCH_END],
        action: (t) => {
          oe.isMobileOrTablet() && this.checkPointHover(e), e.services.point.onPointerUp(e, t);
        }
      }
    ];
  }
}
const M2 = (s, e) => {
  const t = new O2(e);
  return t.init(s, e), t;
};
class N2 extends Oe {
  constructor() {
    super();
  }
  init(e, t) {
    Object.keys(z).forEach((i) => {
      const r = z[i];
      let n = e.services[i];
      typeof n > "u" && i.includes("Handler") && (n = e.handlers[i.replace("Handler", "")]), this.addSubscriberForEvents(r, n, e, t);
    });
  }
  addSubscriberForEvents(e, t, i, r) {
    Object.keys(e).forEach((n) => {
      if (typeof e[n] == "object")
        this.addSubscriberForEvents(e[n], t, i, r);
      else {
        const a = e[n];
        (a === B.EVENT.LOADING_END || a === B.EVENT.LOADING_START || a === B.EVENT.ASK_HIDE_PROGRESS || a === B.EVENT.ASK_SHOW_PROGRESS || a === B.EVENT.IMAGE_SLICE_HAS_BEEN_LOADED) && (t = r.providers.image), typeof t > "u" && (t = i), i.subscribe(
          t,
          a,
          (o) => {
            i.emit(`${h.id}-${a}`, { detail: o });
          }
        );
      }
    });
  }
  addSubFeature(e, t, i = null) {
    i === null && (i = e), e.subscribe(
      i,
      t,
      (r) => {
        e.emit(t, { detail: r });
      }
    );
  }
}
const R2 = (s, e) => {
  const t = new N2(e);
  return t.init(s, e), t;
};
class x2 extends Oe {
  constructor(e) {
    super(), e.data.labelCanvasHidden = !1;
  }
  toggle() {
    const {
      pointsCanvas: e,
      leftLinesCanvas: t,
      rightLinesCanvas: i
    } = this.application.components;
    e.getCanvas().classList.toggle("toggle-label-feature-hidden"), t.getCanvas().classList.toggle("toggle-label-feature-hidden"), i.getCanvas().classList.toggle("toggle-label-feature-hidden"), this.application.data.labelCanvasHidden = !this.application.data.labelCanvasHidden;
  }
  init(e) {
    this.application = e, e.toggleLabels = () => {
      this.toggle(), e.publish(Ti.TOGGLE, this.application.data.labelCanvasHidden);
    };
  }
}
const D2 = (s, e) => {
  const t = new x2(s);
  return t.init(s, e), t;
};
class P2 extends Oe {
  constructor() {
    super();
  }
  init(e) {
    const t = e.services.contrast;
    [
      Ce.EVENT.SELECTED
    ].forEach((i) => {
      e.subscribe(
        t,
        i,
        (r) => {
          const n = t.findById(r)?.imaios_code;
          e.services.image.providers.sliceThumb.setZipSrc(n).then(() => {
            e.loadFrame();
          }).catch((a) => {
            console.error(a);
          });
        }
      );
    });
  }
}
const k2 = (s, e) => {
  const t = new P2(e);
  return t.init(s, e), t;
}, H2 = 15, F2 = 15, ar = 5;
class z2 extends re {
  constructor(e = {}) {
    super({
      ...e,
      component: {}
    }), this.data.disabledBy = /* @__PURE__ */ new Set(), this.data.nbDisablers = 0, this.generateElement(), this.disable();
  }
  enable(e = "anonymous") {
    this.data.disabledBy.delete(e), this.data.nbDisablers = this.data.disabledBy.size;
  }
  disable(e = "anonymous") {
    this.data.disabledBy.add(e), this.data.nbDisablers = this.data.disabledBy.size, this.hide();
  }
  isEnabled() {
    return this.data.nbDisablers === 0;
  }
  /**
   * @param {HTMLElement} wrapper
   */
  show(e = this.ui.wrapper) {
    this.isEnabled() && super.show(e);
  }
  /**
   * @param {HTMLElement} wrapper
   */
  hide(e = this.ui.wrapper) {
    super.hide(e);
  }
  generateElement() {
    const e = document.createElement("div");
    e.classList.add("structure-title-component");
    const t = document.createElement("img"), i = document.createElement("span");
    e.appendChild(t), e.appendChild(i), this.ui.wrapper = e, this.ui.text = i, this.ui.icon = t;
  }
  setText(e) {
    this.ui.text.textContent = e;
  }
  setImage(e) {
    this.ui.icon.src = e;
  }
  setPosition(e, t) {
    const i = this.ui.wrapper?.parentElement ?? null;
    let r = H2;
    if (i !== null) {
      const n = i.getBoundingClientRect(), a = this.ui.wrapper.getBoundingClientRect(), o = t + a.height, l = n.top + n.height;
      o + r >= l - ar && (r = l - (o + ar));
    }
    this.ui.wrapper.style.left = `${e + F2}px`, this.ui.wrapper.style.top = `${t + r}px`;
  }
  setFontColor(e) {
    this.ui.wrapper.style.color = `#${e}`;
  }
}
class Ie extends ne {
  static updateComponentPosition(e) {
    const t = e.components["structure-title"];
    if (typeof t < "u" && t.isEnabled()) {
      const i = e.state.pointer.data.lastCoordsOnScreen;
      t.setPosition(i.x, i.y);
    }
  }
  static showComponentWhenATruncatedLabelIsHover(e) {
    const t = e.services.structure;
    e.subscribe(
      t,
      ae.EVENT.HOVER,
      async ({ taxon_key: i, point_id: r }) => {
        if (!oe.isMobileOrTablet()) {
          const n = t.findByTaxonKey(i);
          n.isTrunk8 === !0 && await Ie.renderComponent(e, n, r);
        }
      }
    ), e.subscribe(
      t,
      ae.EVENT.LOOSE_HOVER,
      () => {
        e.components["structure-title"].hide();
      }
    ), e.subscribe(t, ae.EVENT.CLICK, () => {
      h.getWidthElement(e.ui.container) <= 730 && e.components["structure-title"].hide();
    });
  }
  static renderComponent(e, t, i) {
    const r = e.components["structure-title"];
    r.setText(e.getTextLabelByTaxonKey(t.getTaxonKey(), i)), r.setFontColor(t.color !== me.BLACK ? t.color : me.WHITE), Ie.refreshIcon(e, t.icon_id), Ie.updateComponentPosition(e), e.publish("structure-title-render", {
      structure_id: t.id,
      point_id: i
    }), r.show();
  }
  static refreshIcon(e, t) {
    if (e.get(Ie.ATTRIBUTE.LAST_ICON_ID) !== t) {
      e.store(Ie.ATTRIBUTE.LAST_ICON_ID, t);
      const i = e.components["structure-title"];
      i.setImage(""), t === e.get(Ie.ATTRIBUTE.LAST_ICON_ID) && e.getIcon(t).then((r) => i.setImage(r));
    }
  }
  static showComponentWhenAPointIsHover(e) {
    const t = e.services.point;
    e.subscribe(
      t,
      q.EVENT.HOVER,
      async ({ resource_id: i }) => {
        if (!oe.isMobileOrTablet()) {
          const r = t.findById(i), n = e.services.structure.findByTaxonKey(r.taxon_key);
          await Ie.renderComponent(e, n, r.id);
        }
      }
    ), e.subscribe(
      t,
      q.EVENT.LOOSE_HOVER,
      () => {
        e.components["structure-title"].hide();
      }
    );
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: k.EVENT.READY,
        action: () => {
          const t = new z2(e);
          e.components["structure-title"] = t, e.ui.container.appendChild(t.ui.wrapper), t.enable();
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_MOVE,
        action: () => {
          Ie.updateComponentPosition(e);
        }
      }
    ];
  }
  init(e) {
    super.init(e), e.store(Ie.ATTRIBUTE.LAST_ICON_ID, null), Ie.showComponentWhenATruncatedLabelIsHover(e), Ie.showComponentWhenAPointIsHover(e);
  }
}
Ie.ATTRIBUTE = {
  LAST_ICON_ID: "structure-title-feature.state.last-structure-icon"
};
const B2 = (s, e) => {
  const t = new Ie(e);
  return t.init(s, e), t;
};
class $2 extends mn {
  resetContext(e) {
    super.resetContext(e), e.allPreselectedLabelsShouldBeDrawn = !0;
  }
  filterPointsByPriority(e) {
    e.filteredPoints = e.candidates.slice(0), e.filteredPoints.sort(function(t, i) {
      return t.priority - i.priority;
    });
  }
  updateCandidates(e) {
    return super.updateCandidates(e).filter((i) => i.isSelected);
  }
  updateRangeFontSize() {
    this.services.style.update(L.ATTRIBUTE.MIN_FONT_PX, 1), this.publish(X.EVENT.UPDATE_RANGE_FONT_SIZE);
  }
}
class U2 extends ne {
  constructor(e) {
    super({
      subscriber_id: "point-selection-feature"
    }), this.standardLabelDrawer = e.services.labelsDrawer, this.labelsDrawer = new $2({
      ...e,
      drawer_id: "point-selection-label-drawer"
    });
  }
  subscribe(e) {
    const t = () => {
      this.isSelectionMode(e) && (e.services.renderingContext.leavePointSelectionMode(), e.setLabelDrawer(this.standardLabelDrawer));
    };
    return [
      { from: e.services.filter, name: se.EVENT.SELECTED, action: t },
      { from: e.services.filter, name: se.EVENT.UNSELECTED, action: t },
      { from: e.services.slice, name: fe.EVENT.SLICE_CHANGE, action: t },
      { from: e, name: "keydown.arrowup", action: t },
      { from: e, name: "keydown.arrowdown", action: t },
      {
        from: e.handlers.pointer,
        name: $.EVENT.MOUSE_WHEEL,
        action: t
      },
      {
        from: e.components.viewzone,
        name: qe.EVENT.STATUS_CHANGE,
        action: t
      },
      // Uncomment this if we want to enter in selection mode
      // Selection mode: reduce size of font to display all labels
      // { from: application, name: PointService.EVENT.CLICK, action: () => this.enterSelectionMode(application) },
      {
        from: e,
        name: ce.EVENT.START,
        action: t,
        restrict: (i) => [
          ft.interactionName,
          pt.interactionName
        ].includes(i)
      }
    ];
  }
  isSelectionMode(e) {
    return e.services.renderingContext.get(
      H.ATTRIBUTE.POINT_SELECTION_MODE
    );
  }
  enterSelectionMode(e) {
    this.isSelectionMode(e) !== !0 && (e.services.renderingContext.usePointSelectionMode(), e.setLabelDrawer(this.labelsDrawer));
  }
}
const V2 = (s, e) => new U2(s), Ct = "quiz-mode";
class G2 extends Oe {
  constructor() {
    super(), this.agent = new re({
      subscriber_id: "quiz-mode-feature"
    }), this.pointsFound = {}, this.lastLabelMode = null, this.lastFindedPoint = null;
  }
  createSubscriptionsFromList(e, t) {
    t.forEach((i) => {
      let r;
      typeof i.restrict == "function" ? r = (n) => {
        i.restrict(n) && i.action(n);
      } : r = i.action, e.subscribe(
        i.from,
        i.name,
        r
      );
    });
  }
  getColor(e) {
    return e.services.series.isSchema() ? me.BLACK : me.WHITE;
  }
  updateLabelColor(e, t) {
    e.color = this.getColor(t);
  }
  updatePointColor(e, t) {
    e.circleColor = this.getColor(t);
  }
  bindSubscriptions(e) {
    this.clearSubscriptions(e), this.createSubscriptionsFromList(this.agent, [
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.UPDATE_COLOR,
        action: (t) => {
          this.updateLabelColor(t, e);
        }
      },
      {
        // todo throw an exception when subscribe to undefined object
        from: e.components.pointsCanvas,
        name: yt.EVENT.UPDATE_POINT_STYLE,
        action: (t) => {
          this.updatePointColor(t, e);
        }
      },
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      },
      {
        from: e.services.structure,
        name: ae.EVENT.HOVER,
        action: ({ point_id: t }) => {
          oe.isMobileOrTablet() && this.pointsFound[t] !== !0 && (this.lastFindedPoint = {
            time: Date.now(),
            point_id: t
          }), this.pointsFound[t] !== !0 && (this.pointsFound[t] = !0, e.animations.redrawOnlySliceMeta.trigger());
        }
      },
      {
        from: e,
        name: z.ui.PANEL_STRUCTURE.OPEN,
        action: (t) => {
          (this.pointsFound[t.point_id] !== !0 || this.lastFindedPoint !== null && this.lastFindedPoint.point_id === t.point_id && Date.now() - this.lastFindedPoint.time < 50) && (t.isAuthorizedToOpen = !1);
        }
      },
      {
        from: e.services.slice,
        name: fe.EVENT.SLICE_CHANGE,
        action: () => {
          this.pointsFound = {};
        }
      },
      {
        from: e,
        name: "structure-title-render",
        action: ({ point_id: t }) => {
          this.pointsFound[t] === !0 ? e.components["structure-title"].enable(Ct) : e.components["structure-title"].disable(Ct);
        }
      },
      {
        from: e,
        name: mt.START_ISOLATE,
        action: () => {
          this.endQuizMode(e);
        }
      }
    ]);
  }
  startQuizMode(e) {
    this.bindSubscriptions(e), e.hasFeature("structure-title") && e.components["structure-title"].disable(Ct), this.lastLabelMode = e.getLabelMode(), e.setLabelMode(ct.QUIZ), e.components.overlaysCanvas.disable(Ct), e.animations.redrawOnlySliceMeta.trigger();
  }
  clearSubscriptions(e) {
    Object.values(this.agent.core.subscriptions).forEach((i) => {
      i.forEach((r) => r.unsubscribe());
    }), this.subscribeToToggle(e);
  }
  subscribeToToggle(e) {
    this.agent.subscribe(
      e,
      "toggle-quiz-mode",
      (t) => {
        e.publish(Ci.EVENT.STATUS_CHANGE, { placement: t }), e.getLabelMode() === ct.QUIZ ? this.endQuizMode(e) : this.startQuizMode(e);
      }
    );
  }
  endQuizMode(e) {
    this.pointsFound = {}, this.clearSubscriptions(e), e.setLabelMode(this.lastLabelMode), e.components.overlaysCanvas.enable(Ct), e.animations.redrawOnlySliceMeta.trigger(), e.hasFeature("structure-title") && e.components["structure-title"].enable(Ct);
  }
  init(e) {
    this.subscribeToToggle(e), e.recordLabelMode(ct.QUIZ, (t, i, r = null) => this.pointsFound[i] === !0 ? e.standardGetLabelText(t) : r === null ? "?" : String(r));
  }
}
const j2 = (s, e) => {
  const t = new G2(s);
  return s.subscribe(
    s,
    k.EVENT.READY,
    () => {
      t.init(s, e);
    }
  ), t;
};
class Y2 extends Oe {
  constructor() {
    super();
  }
  init(e) {
    const t = e.services.point, i = e.services.filter;
    e.subscribe(
      t,
      q.EVENT.CHECK_VISIBILITY,
      (r) => {
        r.isSelected = i.isSelected(r.filter_id);
      }
    );
  }
}
const W2 = (s, e) => {
  const t = new Y2(e);
  return t.init(s, e), t;
};
class Z2 extends Oe {
  constructor() {
    super(), this.data = {
      blacklist: /* @__PURE__ */ new Set()
    };
  }
  blacklist(e) {
    this.data.blacklist.add(e);
  }
  whitelist(e) {
    this.data.blacklist.delete(e);
  }
  isBlacklisted(e) {
    return this.data.blacklist.has(e);
  }
  init(e) {
    e.blacklist = (t, i) => {
      this.blacklist(t), e.animations.redrawOnlySliceMeta.trigger(), e.publish(St.BLACKLIST, {
        structure_id: t,
        source: i
      });
    }, e.whitelist = (t) => {
      this.whitelist(t), e.animations.redrawOnlySliceMeta.trigger(), e.publish(St.CLEAR_BLACKLIST);
    }, e.isBlacklisted = (t) => this.isBlacklisted(t), e.haveBlacklistedStructures = () => this.data.blacklist.size > 0, e.clearAllHiddenStructures = () => {
      this.data.blacklist.forEach((t) => this.whitelist(t)), e.animations.redrawOnlySliceMeta.trigger(), e.publish(St.CLEAR_BLACKLIST);
    }, e.subscribe(
      e.services.point,
      q.EVENT.CHECK_VISIBILITY,
      (t) => {
        const i = e.services.structure.findByTaxonKey(t.taxon_key);
        this.isBlacklisted(i.id) && (t.isSelected = !1);
      }
    ), e.subscribe(e, z.ui.SETTINGS.RESET, e.clearAllHiddenStructures);
  }
}
const X2 = (s, e) => {
  const t = new Z2(s);
  return t.init(s, e), t;
};
class Q2 extends ne {
  constructor(e) {
    super({
      subscriber_id: "increase-text-opacity-feature"
    });
  }
  subscribe(e) {
    return [
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.UPDATE_COLOR,
        action: (t) => {
          e.services.series.isSchema() && (t.color = me.BLACK);
        }
      },
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      }
    ];
  }
}
const K2 = (s, e) => {
  const t = new Q2(s);
  return t.init(s, e), t;
};
class q2 extends it {
  subscribe(e) {
    const t = e.services.slice, i = e.services.orientation;
    return [
      {
        from: t,
        name: fe.EVENT.SLICE_CHANGE,
        action: () => {
          const r = t.getCurrent();
          i.refreshOrientation(r.orientation_icon_id);
        }
      }
    ];
  }
}
const J2 = (s, e) => {
  const t = new q2(s);
  return t.init(s, e), t;
};
class ev extends ne {
  subscribe(e) {
    return [
      {
        from: e.services.series,
        name: vt.EVENT.SERIES_CHANGE,
        action: () => {
          const t = e.services.series.getCurrent();
          e.changeBackgroundColors(t.background_color);
          let i = e.services.contrast.getCurrentCode();
          if (i !== e.services.contrast.lastContrastCode && (i = e.services.contrast.lastContrastCode), i !== null) {
            const r = e.getContrasts();
            let n = r.find((a) => a.imaios_code === i);
            typeof n > "u" && (n = r[0]), e.selectContrast(n.id, !1);
          }
        }
      }
    ];
  }
}
const tv = (s, e) => {
  const t = new ev(s);
  return t.init(s, e), t;
};
class sv extends ne {
  resetPoints(e) {
    e.publish(q.EVENT.RESET_ALL_PRIORITY);
  }
  subscribe(e) {
    return [
      {
        from: e.services.filter,
        name: se.EVENT.UNSELECTED,
        action: () => this.resetPoints(e)
      }
    ];
  }
  init(e) {
    le([{
      from: e.services.filter,
      name: se.EVENT.LOADED
    }]).then(() => {
      this.bindSubscriptions(e);
    });
  }
}
const iv = (s, e) => {
  const t = new sv(e);
  return t.init(s, e), t;
};
class Ft extends Oe {
  init(e) {
    e.setBehavior("getContext", () => this.getContext(e));
  }
  getContext(e) {
    const {
      ROTATION_ANGLE: t,
      HORIZONTAL_FLIP: i,
      VERTICAL_FLIP: r
    } = e.services.renderingContext.get(), n = e.services.image.getCurrent();
    return {
      slice: e.services.slice.getCurrentRelativeIndex(),
      series: e.getCurrentSeries().id,
      "mode-full-series": e.isModeFullSeries(),
      filters: this.getFiltersContext(e),
      contrast: e.services.contrast.getCurrentCode(),
      pan: this.getPanContext(e),
      zoom: this.getZoomContext(e),
      canvasSize: this.getCanvasSizeContext(e),
      "label-mode": this.getLabelMode(e),
      language: e.getCurrentLanguage(),
      interfaceLanguage: e.services.language.getCurrentInterfaceLanguage(),
      fontSize: e.isFontSizeAuto() ? null : e.getFontSize(),
      points: this.getPointContext(e),
      rotation: t % 360,
      isolatedStructure: e.getIsolatedStructureID(),
      flip: {
        horizontal: i,
        vertical: r
      },
      imageSize: {
        width: n.width,
        height: n.height
      },
      interface: {
        menu_open: this.getMenuIsOpen(),
        cr_open: this.getCrossReferenceIsOpen(),
        overlay_opacity: e.services.overlay.getOpacity(),
        orientation: h.store.getters["orientation-context-menu/widgetVisibility"],
        details_open: this.getDetailsOpen()
      }
    };
  }
  getDetailsOpen() {
    const e = h.store.getters["menu/structurePanelActiveTaxonKey"];
    if (e !== null) {
      const t = e.split("-"), i = {};
      return i[t[0]] = t[1], i;
    }
    return null;
  }
  getLabelMode(e) {
    return e.services.pointDrawer instanceof Dr ? ct.PIN : e.data.labelMode;
  }
  getPointContext(e) {
    return [...e.pointsWithLabel].join(",");
  }
  getFiltersContext(e) {
    return e.services.filter.getCurrent().map((t) => e.services.filter.findById(t).category).filter((t) => t !== "").join(",");
  }
  getPanContext(e) {
    const t = e.components.imageCanvas;
    return [
      Ft.parseNumber(2 * (t.getTx() / t.getWidth() - 0.5)),
      Ft.parseNumber(2 * (t.getTy() / t.getHeight() - 0.5))
    ];
  }
  getZoomContext(e) {
    const { SCALE: t, MULTIPLIER: i } = e.services.renderingContext.get();
    return Ft.parseNumber(t * i);
  }
  getCanvasSizeContext(e) {
    const t = e.ui.container;
    return {
      width: t.offsetWidth,
      height: t.offsetHeight
    };
  }
  static parseNumber(e) {
    return Math.round(e * 1e3) / 1e3;
  }
  getMenuIsOpen() {
    return h.store.getters["menu/menuIsOpen"];
  }
  getCrossReferenceIsOpen() {
    return h.store.getters["menu/displayCrossReferencesPanel"].display;
  }
}
const rv = (s, e) => {
  const t = new Ft(e);
  return t.init(s, e), t;
};
class nv extends Oe {
  init(e) {
    e.setBehavior("promptContext", () => {
      this.promptContext(e);
    });
  }
  promptContext(e) {
    if (typeof e.behaviours.getContext == "function") {
      const t = e.behaviours.getContext();
      t.url = window.location.href, console.log(JSON.stringify(t, null, 4));
    }
  }
}
const av = (s, e) => {
  const t = new nv(e);
  return t.init(s, e), t;
}, ve = {
  UP: 0,
  DOWN: 1,
  LEFT: 2,
  RIGHT: 3,
  UP_MIRRORED: 4,
  DOWN_MIRRORED: 5,
  LEFT_MIRRORED: 6,
  RIGHT_MIRRORED: 7
}, ov = (s) => Object.keys(s).reduce(
  (e, t) => Object.assign(e, { [s[t]]: (e[s[t]] || []).concat(t) }),
  {}
), ni = (s) => decodeURIComponent(atob(s)), ai = (s) => btoa(encodeURIComponent(s));
class lv extends ne {
  /**
   * @param {Application} application
   */
  constructor(e) {
    super(), this.application = e, this.timeoutLoadPoints = null;
  }
  getShareLink(e) {
    if (typeof e.behaviours.getContext == "function") {
      const t = this.parseContext(e.behaviours.getContext(e));
      let i = "";
      return Object.keys(t).forEach((r, n) => {
        n !== 0 && (i += "&"), i += `${r}=${t[r]}`;
      }), `${window.location.origin + window.location.pathname}?${i}`;
    }
  }
  /* eslint-disable id-length */
  parseContext(e) {
    const t = {}, i = this.application.services.roi.getRoi();
    i !== null && (t.x = i.x, t.y = i.y, t.w = i.w, t.h = i.h), t.mic = this.application.state.module.name, t.afi = e.slice, t.cic = encodeURIComponent(e.contrast), t.o = this.getOrientation(e), t.f = ai(e.filters), t.is = e.isolatedStructure, t.t = ai(JSON.stringify(this.getDisplayedLabelsStructure())), t.i = ai(encodeURIComponent(JSON.stringify(this.getInterfaceStatus(e)))), t.lm = this.getLabelMode(e);
    const r = ov(Z);
    return t.l = r[e.language], t.il = r[e.interfaceLanguage], e.fontSize !== null && (t.fs = e.fontSize), t.series = e.series, t["mode-full-series"] = e["mode-full-series"], t;
  }
  /* eslint-enable id-length */
  getInterfaceStatus(e) {
    const t = {
      mo: e.interface.menu_open,
      co: e.interface.cr_open,
      oo: e.interface.orientation,
      oop: e.interface.overlay_opacity
    };
    return e.interface.details_open !== null && (t.do = e.interface.details_open), t;
  }
  getLabelMode(e) {
    const t = {
      STANDARD: 1,
      PIN: 2,
      TEACHER: 3
      // Quiz mode
    };
    switch (e["label-mode"]) {
      case ct.PIN:
        return t.PIN;
      case ct.QUIZ:
        return t.TEACHER;
      default:
        return t.STANDARD;
    }
  }
  isUpOrientation(e) {
    return e.rotation === 0 && !e.flip.horizontal && !e.flip.vertical || e.rotation === 180 && e.flip.horizontal && e.flip.vertical;
  }
  isUpMirroredOrientation(e) {
    return e.rotation === 0 && e.flip.horizontal && !e.flip.vertical || e.rotation === 180 && !e.flip.horizontal && e.flip.vertical;
  }
  isRightOrientation(e) {
    return e.rotation === 90 && !e.flip.horizontal && !e.flip.vertical || e.rotation === 270 && e.flip.horizontal && e.flip.vertical;
  }
  isRightMirroredOrientation(e) {
    return e.rotation === 90 && !e.flip.horizontal && e.flip.vertical || e.rotation === 270 && e.flip.horizontal && !e.flip.vertical;
  }
  isDownOrientation(e) {
    return e.rotation === 180 && !e.flip.horizontal && !e.flip.vertical || e.rotation === 0 && e.flip.horizontal && e.flip.vertical;
  }
  isDownMirroredOrientation(e) {
    return e.rotation === 180 && e.flip.horizontal && !e.flip.vertical || e.rotation === 0 && !e.flip.horizontal && e.flip.vertical;
  }
  isLeftOrientation(e) {
    return e.rotation === 270 && !e.flip.horizontal && !e.flip.vertical || e.rotation === 90 && e.flip.horizontal && e.flip.vertical;
  }
  isLeftMirroredOrientation(e) {
    return e.rotation === 270 && !e.flip.horizontal && e.flip.vertical || e.rotation === 90 && e.flip.horizontal && !e.flip.vertical;
  }
  getOrientation(e) {
    return this.isUpOrientation(e) ? ve.UP : this.isUpMirroredOrientation(e) ? ve.UP_MIRRORED : this.isRightOrientation(e) ? ve.RIGHT : this.isRightMirroredOrientation(e) ? ve.RIGHT_MIRRORED : this.isDownOrientation(e) ? ve.DOWN : this.isDownMirroredOrientation(e) ? ve.DOWN_MIRRORED : this.isLeftOrientation(e) ? ve.LEFT : this.isLeftMirroredOrientation(e) ? ve.LEFT_MIRRORED : ve.UP;
  }
  getUniqueTaxonKeys() {
    return Array.from(
      new Set(
        this.application.services.label.getDisplayedLabels().map(({ taxon_key: e }) => e)
      )
    );
  }
  getDisplayedLabelsStructure() {
    const e = this.getUniqueTaxonKeys(), t = {};
    return e.forEach((i) => {
      const r = this.application.services.structure.findByTaxonKey(i);
      t[r.ta_id] || (t[r.ta_id] = []), t[r.ta_id].push(r.taxon_id);
    }), t;
  }
  init(e) {
    super.init(e), e.setBehavior("share-link", () => this.getShareLink(e)), this.parameters = ca(window.location.search), this.checkOldParameters(), this.parseParameters(), this.loadInterface(), le([
      {
        from: e,
        name: k.EVENT.READY
      }
    ]).then(() => {
      this.loadSeriesAndSlice(), this.loadContrast(), this.loadPanZoom(), this.loadFiltersAndPoints(), this.loadTaxon(), this.loadFlip(), this.loadLanguage(), this.loadRotation(), this.loadIsolate(), this.toggleFeatures();
    });
    const t = [{
      from: e,
      name: k.EVENT.READY
    }];
    (this.parameters.point || this.parameters.taxon) && t.push({
      from: e,
      name: _t.POINTS_LOADED
    }), (this.parameters.pan || this.parameters.zoom) && t.push({
      from: e,
      name: _t.PAN_ZOOM_LOADED
    }), le(t).then(() => {
      e.publish(_t.LOADED), this.clearSubscriptions();
    });
  }
  parseParameters() {
    if (delete this.parameters.mic, this.parameters.afi && (this.parameters.slice = parseInt(this.parameters.afi, 10), delete this.parameters.afi), this.parameters.cic && (this.parameters.contrast = this.parameters.cic, delete this.parameters.cic), this.parameters.o) {
      switch (this.parameters.flip = {}, this.parameters.o) {
        case ve.UP_MIRRORED:
          this.parameters.flip.horizontal = !0;
          break;
        // It's wanted to do not have a break here
        case ve.DOWN_MIRRORED:
          this.parameters.flip.horizontal = !0;
        case ve.DOWN:
          this.parameters.rotation = 180;
          break;
        // It's wanted to do not have a break here
        case ve.LEFT_MIRRORED:
          this.parameters.flip.vertical = !0;
        case ve.LEFT:
          this.parameters.rotation = 270;
          break;
        // It's wanted to do not have a break here
        case ve.RIGHT_MIRRORED:
          this.parameters.flip.vertical = !0;
        case ve.RIGHT:
          this.parameters.rotation = 90;
          break;
      }
      delete this.parameters.o;
    }
    if (this.parameters.f && (this.parameters.filters = ni(this.parameters.f), delete this.parameters.f), this.parameters.is && (this.parameters.structureId = this.parameters.is, delete this.parameters.is), this.parameters.isf && (this.parameters.isolatedStructureFilters = this.parameters.isf, delete this.parameters.isf), this.parameters.t) {
      try {
        this.parameters.taxon = JSON.parse(ni(this.parameters.t));
      } catch (e) {
        h.sendCoreError(e);
      }
      delete this.parameters.t;
    }
    if (this.parameters.i) {
      const e = ni(this.parameters.i);
      this.parameters.interface = {}, e.mo && (this.parameters.interface.menu_open = e.mo), e.co && (this.parameters.interface.cr_open = e.co), delete this.parameters.i;
    }
    this.parameters.l && (this.parameters.language = Z[this.parameters.l.toLowerCase()], delete this.parameters.l), delete this.parameters.il;
  }
  loadSeriesAndSlice() {
    if (this.parameters.series) {
      const e = this.parameters.series, t = Object.values(this.application.services.series.getResources()).find((i) => i.id === e);
      if (typeof t < "u") {
        let i = 1;
        this.parameters.slice && this.parameters.slice > 0 && (i = this.parameters.slice), this.parameters["mode-full-series"] !== null && this.parameters["mode-full-series"] === !1 ? (i > t.number_of_images && (i = 1), this.application.selectDisplaySeriesMode(e, i)) : this.application.services.slice.isInRange(i) && this.application.moveToSlice(i);
      }
    } else this.parameters.slice && this.parameters.slice > 0 && this.application.services.slice.isInRange(this.parameters.slice) && this.application.moveToSlice(this.parameters.slice);
  }
  loadContrast() {
    if (this.parameters.contrast) {
      const e = this.application.services.contrast.findOne({ imaios_code: this.parameters.contrast });
      e !== null && e.id !== -1 && this.application.selectContrast(e.id);
    }
  }
  loadLanguage() {
    this.parameters.language && this.application.services.language.isAvailable(this.parameters.language) && this.application.setLanguage(this.parameters.language);
  }
  loadFlip() {
    this.parameters.flip && le([
      {
        name: k.EVENT.RENDERING_FIRST_FRAME,
        from: this.application
      }
    ]).then(() => {
      this.parameters.flip.horizontal && this.application.horizontalFlip(), this.parameters.flip.vertical && this.application.verticalFlip();
    });
  }
  loadRotation() {
    this.parameters.rotation && le([
      {
        name: k.EVENT.RENDERING_FIRST_FRAME,
        from: this.application
      }
    ]).then(() => {
      this.application.rotate(this.parameters.rotation);
    });
  }
  loadTranslation() {
    const {
      x: e,
      y: t,
      w: i,
      h: r
    } = this.parameters;
    this.application.loadRoi(i, r, e, t);
  }
  hasTranslation() {
    return typeof this.parameters.x < "u" && typeof this.parameters.y < "u" && typeof this.parameters.w < "u" && typeof this.parameters.h < "u";
  }
  loadPanZoom() {
    (this.parameters.pan || this.parameters.zoom || this.hasTranslation()) && le([
      {
        name: k.EVENT.RENDERING_FIRST_FRAME,
        from: this.application
      }
    ]).then(() => {
      const e = this.application.components.imageCanvas, { SCALE: t, MULTIPLIER: i } = this.application.services.renderingContext.get();
      let r = 0, n = 0;
      this.parameters.pan && (r = (this.parameters.pan[0] + 1) * (e.getWidth() / 2) - e.getTx(), n = (this.parameters.pan[1] + 1) * (e.getHeight() / 2) - e.getTy());
      let a = 0, o = 1;
      this.parameters.zoom && (a = this.parameters.zoom - i * t, o = -(this.parameters.zoom / i) + t), this.application.zoomOnCoords(r / o, n / o, a), this.hasTranslation() && this.loadTranslation(), this.parameters.canvasSize && (this.parameters.canvasSize.width !== this.application.ui.container.offsetWidth || this.parameters.canvasSize.height !== this.application.ui.container.offsetHeight) && (this.application.data.lastContainerWidth = this.parameters.canvasSize.width, this.application.data.lastContainerHeight = this.parameters.canvasSize.height, this.application.resize(!0)), this.application.publish(_t.PAN_ZOOM_LOADED);
    });
  }
  loadFiltersAndPoints() {
    if (this.parameters.structureId && this.parameters.isolatedStructureFilters) {
      const e = this.application.getStructureById(this.parameters.structureId), t = this.application.services.point.findByTaxonKey(e.getTaxonKey()).map((r) => r.filter_id), i = Array.from(new Set(t));
      this.application.services.filter.focus(i, !0);
    } else if (this.parameters.filters) {
      const e = this.parameters.filters.split(","), i = this.application.services.filter.find({ category: { $in: e } }).map((r) => r.id.toString());
      this.application.services.filter.focus(i, !0);
    }
    (this.parameters.filters || this.parameters.structureId) && this.parameters.points && this.agent.subscribe(
      this.application.services.point,
      q.EVENT.UPDATE_ACTIVE,
      (e) => this.loadPoints(
        e,
        this.parameters.points.toString().split(",").map((t) => parseInt(t, 10))
      )
    );
  }
  loadTaxon() {
    if (!this.parameters.taxon)
      return;
    const t = Object.keys(this.parameters.taxon).flatMap((i) => this.parameters.taxon[i].map((r) => `${i}-${r}`)).flatMap((i) => this.application.services.point.findByTaxonKey(i)).map((i) => parseInt(i.id, 10));
    this.agent.subscribe(
      this.application.services.point,
      q.EVENT.UPDATE_ACTIVE,
      (i) => {
        this.loadPoints(i, t);
      }
    );
  }
  /**
   * @param {Point[]} activePoints
   * @param {number[]} pointIds
   */
  loadPoints(e, t) {
    const i = this.application.features["priority-point-select"];
    t.every((n) => e.findIndex((a) => a.id === n) !== -1) && e.forEach((n) => {
      t.includes(n.id) ? i.selectPoint(this.application, n) : i.unselectPoint(this.application, n);
    }), this.clearSubscriptions(), clearTimeout(this.timeoutLoadPoints), this.application.publish(_t.POINTS_LOADED);
  }
  loadIsolate() {
    typeof this.parameters.structureId < "u" && this.parameters.structureId !== null && this.application.services.structure.exists(this.parameters.structureId) && this.application.isolateStructure(null, this.parameters.structureId, this.parameters.taxonKey || null);
  }
  checkOldParameters() {
    ["taxonId", "taId", "structureID", "frame"].some((t) => Object.keys(this.parameters).includes(t)) && (this.parameters.frame && (this.parameters.slice = this.parameters.frame), this.parameters.structureID && (this.parameters.isolate = !0, this.parameters.structureId = this.parameters.structureID, typeof this.parameters.taId < "u" && typeof this.parameters.taxonId && (this.parameters.taxonKey = `${this.parameters.taId}-${this.parameters.taxonId}`)));
  }
  loadInterface() {
    this.parameters.interface && (typeof this.parameters.interface.menu_open < "u" && le([
      {
        name: z.ui.VIEWER.MENU_INITIALIZED,
        from: this.application
      }
    ]).then(() => {
      (this.parameters.interface.menu_open && !h.store.getters["menu/menuIsOpen"] || !this.parameters.interface.menu_open && h.store.getters["menu/menuIsOpen"]) && h.store.dispatch("menu/menu:toggle");
    }), typeof this.parameters.interface.cr_open < "u" && le([
      {
        name: z.ui.VIEWER.CROSS_REFERENCES_INITIALIZED,
        from: this.application
      }
    ]).then(() => {
      (this.parameters.interface.cr_open && !h.store.getters["menu/displayCrossReferencesPanel"].display || !this.parameters.interface.cr_open && h.store.getters["menu/displayCrossReferencesPanel"].display) && h.store.dispatch("menu/cross-references:toggle");
    }));
  }
  toggleFeatures() {
    this.parameters.hidePointWithoutLabel && this.application.toggleFeatureHidePointWithoutLabel();
  }
}
const cv = (s, e) => {
  const t = new lv(s);
  return t.init(s, e), t;
};
let uv = class extends it {
  constructor() {
    super({
      subscriber_id: "image-auto-load-feature"
    });
  }
  redrawFullSliceThumbs(e) {
    e.services.image.getCurrent() !== null ? e.redrawImageCanvas() : e.redrawImageCanvas(e.services.image.latestImageThatShouldBeDrawnId), e.clearOverlays(), e.redrawSliceMetadata(), e.redrawOverlays(), e.showMetaCanvas();
  }
  subscribe(e) {
    return [
      {
        from: e.services.image,
        name: He.EVENT.IMAGE_AVAILABLE,
        action: (t) => {
          t.image_id === e.services.image.getCurrentId() && (e.services.image.latestImageThatShouldBeDrawnId = t.image_id, e.animations.redrawFullSlice.trigger());
        }
      },
      {
        from: e.services.image,
        name: jt.EVENT.QUALITY_CHANGE,
        action: () => {
          e.loadFrame();
        }
      },
      {
        from: e.services.image,
        name: He.EVENT.IMAGE_CHANGE,
        action: async (t) => {
          e.services.image.getCurrentId() === t && !e.services.image.canBeRendered(t) && (await e.services.image.loadFallbackImage(), e.services.image.latestImageThatShouldBeDrawnId = t, this.redrawFullSliceThumbs(e)), e.services.image.getImage({ image_id: t }, B.PRIORITY.MAX).then((i) => {
            e.services.image.publish(He.EVENT.IMAGE_AVAILABLE, i);
          });
        }
      }
    ];
  }
};
const dv = (s, e) => {
  const t = new uv(s);
  return t.init(s, e), t;
}, oi = 100;
class hv extends ne {
  constructor() {
    super(), this.pointHasBeenUpdated = !1, this.pointsPriority = {}, this.priority = oi;
  }
  subscribe(e) {
    const t = e.services.point, i = (r) => {
      this.pointHasBeenUpdated === !1 && this.updatePointSelected(e), this.toggleSelection.call(e, r);
    };
    return [
      {
        from: e.services.slice,
        name: fe.EVENT.SLICE_CHANGE,
        action: () => this.pointHasBeenUpdated = !1
      },
      { from: e, name: q.EVENT.CLICK, action: i },
      {
        from: t,
        name: q.EVENT.UNSELECTED,
        action: (r) => this.unselectPoint(e, r)
      },
      {
        from: t,
        name: q.EVENT.SELECTED,
        action: (r) => this.selectPoint(e, r)
      },
      {
        from: e,
        name: q.EVENT.RESET_ALL_PRIORITY,
        action: () => this.resetPriority(e)
      }
    ];
  }
  unselectPoint(e, t) {
    e.services.point.findByTaxonKey(t.taxon_key).forEach((r) => {
      this.pointsPriority[r.id] = r.priority, e.services.point.setPriority(r.id, oi);
    });
  }
  selectPoint(e, t) {
    e.services.point.findByTaxonKey(t.taxon_key).forEach((r) => {
      typeof this.pointsPriority[r.id] > "u" && (this.pointsPriority[r.id] = r.priority), e.services.point.setPriority(r.id, -this.priority);
    }), this.priority++;
  }
  toggleSelection(e) {
    e.isSelected === !0 && typeof this.pointsWithLabel && this.pointsWithLabel.has(e.id) ? this.services.point.unselect(e) : this.services.point.select(e), this.redrawLabels();
  }
  resetPriority(e) {
    Object.keys(this.pointsPriority).forEach((t) => {
      e.services.point.setPriority(t, this.pointsPriority[t]);
    }), this.pointsPriority = {}, this.priority = oi, e.redrawLabels();
  }
  updatePointSelected(e) {
    const t = e.services.point;
    Object.keys(t.leftLinkedPointsById).concat(
      Object.keys(t.rightLinkedPointsById)
    ).forEach((r) => {
      const n = t.findById(r);
      n.isSelected = !0;
    }), this.pointHasBeenUpdated = !0;
  }
}
const mv = (s, e) => {
  const t = new hv(e);
  return t.init(s, e), t;
};
class fv extends it {
  constructor() {
    super({ subscriber_id: "increase-image-quality-on-zoom" }), this.lastQuality = null;
  }
  getQuality(e) {
    const { SCALE: t, MULTIPLIER: i } = e.services.renderingContext.get(), r = t * i;
    let n = null;
    return h.isZipMode() ? n = Pt.HIGH : r > ys.HIGH ? n = dt.HIGH : Object.values(ys).forEach((a, o) => {
      r <= a && n === null && (n = dt[Object.keys(ys)[o]]);
    }), n;
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: k.EVENT.ZOOM,
        action: () => {
          const t = this.getQuality(e), i = e.services.image.getQuality(e);
          i < t && (this.lastQuality = i, e.services.image.switchQuality(t));
        }
      },
      {
        from: e.services.slice,
        name: fe.EVENT.SLICE_CHANGE,
        action: () => {
          this.lastQuality !== e.services.image.getQuality(e) && e.services.image.switchQuality(this.lastQuality);
        }
      },
      {
        from: e,
        name: k.EVENT.RENDERING_FIRST_FRAME,
        action: async () => {
          const t = this.getQuality(e);
          await e.services.image.switchQuality(t), this.lastQuality = t;
        }
      }
    ];
  }
}
const pv = (s, e) => {
  const t = new fv(e);
  return t.init(s, e), t;
};
class gv extends ne {
  constructor() {
    super({
      subscriber_id: "image-auto-compute-multiplier"
    });
  }
  refreshMultiplier(e) {
    const t = e.services.series.getCurrent();
    let i = e.services.modality.is2XOverSampling(t.modality_id) ? Mi.DPX_2 : Mi.DPX_1;
    e.services.renderingContext.update(
      H.ATTRIBUTE.MULTIPLIER,
      i
    );
  }
  subscribe(e) {
    return [
      {
        from: e.services.series,
        name: vt.EVENT.SERIES_CHANGE,
        action: () => {
          this.refreshMultiplier(e);
        }
      },
      {
        from: e,
        name: k.EVENT.READY,
        action: () => {
          this.refreshMultiplier(e);
        }
      }
    ];
  }
}
const vv = (s, e) => {
  const t = new gv(s);
  return t.init(s, e), t;
};
typeof window.requestIdleCallback != "function" && (window.requestIdleCallback = (s) => {
  let e = Date.now();
  return setTimeout(() => {
    s({
      didTimeout: !1,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - e))
    });
  }, 1);
}), typeof window.cancelIdleCallback != "function" && (window.cancelIdleCallback = (s) => clearTimeout(s));
const ns = 10;
class yv extends it {
  constructor() {
    super({
      subscriber_id: "load-image-on-idle-feature"
    }), this.currentIndex = 0, this.loadingContrast = pe, this.loadingSeriesId = null, this.state = {}, this.lastProcess = null, this.tick = this.loadingLoop.bind(this), this.taskKilledById = /* @__PURE__ */ new Map(), this.task_id = 0, this.hasRenderFirstFrame = !1;
  }
  loadSlice(e) {
    const t = this.task_id++;
    if (this.taskKilledById.set(t, !1), this.taskKilledById.get(t) === !0) {
      this.taskKilledById.delete(t);
      return;
    }
    let i, r = pe;
    if (typeof this.state[e.series_id][this.loadingContrast] < "u" ? i = this.state[e.series_id][this.loadingContrast] : i = this.state[e.series_id][pe], i.sliceIds[e.id] === !1) {
      const n = this.application.services.overlay.getValidOverlays(e.id);
      this.application.services.image.getImage({
        slice_id: e.id,
        code: r,
        type: Y.SLICE
      }, B.PRIORITY.LOW), n.forEach((a) => {
        this.application.services.image.getImage({
          slice_id: e.id,
          format: "png",
          type: Y.OVERLAY,
          code: a
        }, B.PRIORITY.LOW);
      }), i.nbLoaded++, i.sliceIds[e.id] = !0;
    }
  }
  async loadingLoop() {
    const e = this.state[this.loadingSeriesId][this.loadingContrast], t = Object.keys(e.sliceIds), i = this.getLoadingSeries(), r = this.task_id++;
    for (this.taskKilledById.set(r, !1); this.currentIndex < i.number_of_images; ) {
      if (this.taskKilledById.get(r) === !0) {
        this.taskKilledById.delete(r);
        return;
      }
      const n = t[this.currentIndex];
      if (this.currentIndex++, e.sliceIds[n] === !1) {
        const a = this.application.services.overlay.getValidOverlays(n);
        await Promise.all([
          // Load image
          this.application.services.image.getImage({
            slice_id: n,
            code: this.loadingContrast,
            type: Y.SLICE
          }, B.PRIORITY.LOW)
        ]), a.forEach((o) => {
          this.application.services.image.getImage({
            slice_id: n,
            format: "png",
            type: Y.OVERLAY,
            code: o
          }, B.PRIORITY.LOW);
        }), e.nbLoaded++, e.sliceIds[n] = !0;
      }
    }
    this.currentIndex !== i.number_of_images ? this.prepareNextTick() : this.agent.publish(li.END_LOOP);
  }
  prepareNextTick() {
    this.lastProcess = window.requestIdleCallback(this.tick);
  }
  getLoadingSeries() {
    return this.application.services.series.findById(this.loadingSeriesId);
  }
  startLoadingLoop() {
    try {
      if (this.loadingSeriesId !== null) {
        const e = this.state[this.loadingSeriesId][this.loadingContrast];
        if (typeof e < "u" && e !== null) {
          const t = this.getLoadingSeries();
          e.nbLoaded === t.number_of_images ? this.agent.publish(li.END_LOOP) : (this.agent.publish(B.EVENT.ASK_SHOW_PROGRESS), this.prepareNextTick());
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  killLoadingLoop() {
    this.taskKilledById.forEach((e, t) => this.taskKilledById.set(t, !0)), window.cancelIdleCallback(this.lastProcess), this.lastProcess = null;
  }
  initializeState(e) {
    this.application = e, [
      B.EVENT.LOADING_END,
      B.EVENT.ASK_SHOW_PROGRESS,
      B.EVENT.ASK_HIDE_PROGRESS
    ].forEach((i) => {
      e.subscribe(
        this.agent,
        i,
        (r) => {
          e.emit(i, { detail: r });
        }
      );
    }), Object.values(e.services.series.getResources()).forEach((i) => {
      this.state[i.id] = {};
      const r = e.services.contrast.find({ series_id: { $or: [i.id, -1] } }), n = e.services.slice.find({ series_id: i.id }).reduce((a, o) => (a[o.id] = !1, a), {});
      r.forEach((a) => {
        this.state[i.id][a.imaios_code] = { nbLoaded: 0, sliceIds: { ...n } };
      });
    }), this.loadingSeriesId = e.services.series.getCurrentId(), this.loadingContrast = e.services.contrast.getCurrentCode(), this.currentIndex = e.getRelativeSliceIndexById(e.services.slice.getCurrentId(), this.loadingSeriesId) - 1;
  }
  needToKillLoopOnSliceChange(e, t) {
    const i = this.currentIndex - 1;
    if (!this.checkIfSliceIsLoaded(e))
      return !0;
    const r = this.application.services.slice.getTotalSlices();
    if (e.sort_order < r)
      for (let n = 1; n < ns; n++) {
        if (e.sort_order + n <= r) {
          const a = this.application.services.slice.getSliceBySliceIndex(e.sort_order + n);
          if (!this.checkIfSliceIsLoaded(a))
            return !0;
        }
        if (e.sort_order - n > 1) {
          const a = this.application.services.slice.getSliceBySliceIndex(e.sort_order - n);
          if (!this.checkIfSliceIsLoaded(a))
            return !0;
        }
      }
    if (this.loadingSeriesId === e.series_id) {
      if (i < t)
        return !0;
      {
        const n = Object.values(this.state[e.series_id][this.loadingContrast].sliceIds);
        for (let a = t; a < i; a++)
          if (n[a] === !1)
            return !0;
        return !1;
      }
    } else if (typeof this.state[e.series_id][this.loadingContrast] < "u" && this.state[e.series_id][this.loadingContrast].nbLoaded === this.application.services.series.findById(e.series_id).number_of_images)
      return !1;
    return !0;
  }
  checkIfSliceIsLoaded(e) {
    let t;
    return typeof this.state[e.series_id][this.loadingContrast] < "u" ? t = this.state[e.series_id][this.loadingContrast].sliceIds : t = this.state[e.series_id][pe].sliceIds, t[e.id];
  }
  getNextSeriesAndContrastToLoad(e) {
    let t = null, i = pe;
    const r = this.application.services.series.findById(e);
    return typeof this.state[e][this.loadingContrast] < "u" ? this.state[e][this.loadingContrast].nbLoaded < r.number_of_images && (t = e, i = this.loadingContrast) : this.state[e][pe].nbLoaded < r.number_of_images && (t = e), { nextSeriesToLoad: t, nextContrast: i };
  }
  loadNeighboursSlice(e) {
    this.checkIfSliceIsLoaded(e) || this.loadSlice(e);
    const t = this.application.services.slice.getTotalSlices();
    for (let i = 1; i < ns + 1; i++) {
      if (e.sort_order + i <= t) {
        const r = this.application.services.slice.getSliceBySliceIndex(e.sort_order + i);
        this.checkIfSliceIsLoaded(r) || this.loadSlice(r);
      }
      if (e.sort_order - i > 1) {
        const r = this.application.services.slice.getSliceBySliceIndex(e.sort_order - i);
        this.checkIfSliceIsLoaded(r) || this.loadSlice(r);
      }
    }
  }
  subscribe(e) {
    return this.initializeState(e), this.startLoadingLoop(e), [
      {
        from: e.services.slice,
        name: fe.EVENT.SLICE_CHANGE,
        action: async (t) => {
          if (this.hasRenderFirstFrame) {
            const i = e.services.slice.findById(t), r = e.getRelativeSliceIndexById(t, i.series_id);
            if (this.needToKillLoopOnSliceChange(i, r)) {
              this.killLoadingLoop(), this.loadNeighboursSlice(i);
              let n = i.sort_order + ns;
              i.sort_order + ns > this.application.services.slice.getTotalSlices() && (n = this.application.services.slice.getTotalSlices());
              const a = this.application.services.slice.getSliceBySliceIndex(n);
              this.loadingSeriesId = a.series_id, this.currentIndex = e.getRelativeSliceIndexById(a.id, a.series_id) - 1, this.startLoadingLoop(e);
            }
          }
        }
      },
      {
        from: e,
        name: k.EVENT.RENDERING_FIRST_FRAME,
        action: () => {
          this.hasRenderFirstFrame = !0;
        }
      },
      {
        from: e.services.contrast,
        name: Ce.EVENT.SELECTED,
        action: (t) => {
          const i = e.services.slice.getCurrent(), r = e.getRelativeSliceIndexById(i.id, i.series_id) - 1;
          this.killLoadingLoop(), this.loadingContrast = e.services.contrast.findById(t).imaios_code, this.loadingSeriesId = i.series_id, this.currentIndex = r, this.startLoadingLoop(e);
        }
      },
      {
        from: this.agent,
        name: li.END_LOOP,
        action: () => {
          this.killLoadingLoop(), this.currentIndex = 0;
          let t = null, i = pe;
          const r = Object.keys(this.state);
          let n = r.findIndex((o) => parseInt(o) === this.loadingSeriesId), a = n + 1 < r.length ? n + 1 : 0;
          for (; a < r.length; a++) {
            const o = parseInt(r[a]);
            if (t === null) {
              const l = this.getNextSeriesAndContrastToLoad(o);
              l.nextSeriesToLoad !== null && (t = l.nextSeriesToLoad, i = l.nextContrast);
            }
          }
          if (t === null) {
            const o = n + 1;
            for (let l = 0; l < o; l++) {
              const c = parseInt(r[l]);
              if (t === null) {
                const u = this.getNextSeriesAndContrastToLoad(c);
                u.nextSeriesToLoad !== null && (t = u.nextSeriesToLoad, i = u.nextContrast);
              }
            }
          }
          t !== null ? (this.loadingSeriesId = t, this.loadingContrast = i, this.startLoadingLoop(e)) : this.agent.publish(B.EVENT.ASK_HIDE_PROGRESS);
        }
      }
    ];
  }
}
const li = {
  END_LOOP: "end"
}, Ev = (s, e) => {
  const t = new yv(s);
  return t.init(s, e), t;
};
class Iv extends ne {
  constructor(e) {
    super({ subscriber_id: "double-click-zoom" }), this.application = e;
  }
  shouldPerform(e) {
    return !e.services.point.hasHover() && !e.services.structure.hasHover();
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.DOUBLE_CLICK,
        action: (t) => {
          this.shouldPerform(e) && t.button === wt.LEFT_CLICK && e.behave("toggleFullScreen");
        }
      }
    ];
  }
}
const Cv = (s, e) => {
  const t = new Iv(s);
  return t.init(s, e), t;
}, or = {
  EANATOMY: 300,
  VETANATOMY: 418052
}, P = {
  ENABLED: !1,
  SILENT: !0,
  STATUS: {
    BLOCKED: "blocked",
    STAY_TUNED: "staytuned"
  },
  STATE: {
    DETERMINED: "determined",
    STOP: "stop",
    HELLO: "hello",
    PING: "ping",
    STAY_TUNED: "staytuned"
  },
  CONFIG: {
    url: "/c",
    timeout: 1e4,
    togglePopinFunction: (s, e) => {
      if (!P.SILENT)
        if (s.length > 0) {
          let t = P.STATUS.BLOCKED;
          s === "Already_using_on_another_device" && (t = P.STATUS.STAY_TUNED), e.$modal.innerHTML = `
                    <iframe
                        src="${F.baseURL}/${h.getSiteAccess()}/capping/${P.CONFIG.cappingProduictId}/${t}"
                        style="height: 100%; width: 100%;min-height: 695px"
                        frameBorder="0"
                        height="100%"
                        width="100%"
                    ><iframe>
                `;
        } else
          e.$modal.hide(), e.$modal.innerHTML = "";
    }
  }
};
class _v extends it {
  constructor() {
    super(), this.lastAction = "", this.state = P.STATE.STOP, this.$modal = null, this.instanceHasInitializedCapping = !1;
  }
  onInit(e) {
    window.IMAIOS_CAPPING_EXIST || (window.IMAIOS_CAPPING_EXIST = !0, this.instanceHasInitializedCapping = !0, P.CONFIG.brand = e.application_id === Pe.EANATOMY ? or.EANATOMY : or.VETANATOMY, P.CONFIG.cappingProduictId = e.application_id, P.CONFIG.userId = F.APIUserId ?? F.APIClientId ?? h.getUserId(), P.CONFIG.tolerance = "", h.isEmbed() && (P.CONFIG.url = F.baseURL + P.CONFIG.url), h.user_id === null && h.pubSub.subscribe(h.pubSub, zr.USER_ID_UPDATED, (t) => {
      P.CONFIG.userId = t, this.tryActivatingCapping();
    }), imaios.pubsub?.publish("capping-ready", P), this.tryActivatingCapping());
  }
  tryActivatingCapping() {
    !P.ENABLED || P.CONFIG.userId === fs || (this.deviceId = Ne.getDeviceId(), this.start(), window.restartCapping = () => {
      this.determined();
    }, window.stopCapping = () => {
      this.stop();
    });
  }
  hello() {
    this.$modal === null && !P.SILENT && this.createModal(), this.state !== P.STATE.HELLO && (this.state = P.STATE.HELLO, this.lastAction = P.STATE.HELLO, F.fetch(`${P.CONFIG.url}/hello?user=${this.userId}&brand=${this.brand}&device=${this.deviceId}&tolerance=${this.tolerance}`).then((e) => e.json()).then(() => {
      this.state === P.STATE.HELLO && this.ping();
    }).catch(() => {
      this.state = P.STATE.STOP;
    }));
  }
  bye() {
    F.fetch(`${P.CONFIG.url}/bye?user=${this.userId}&brand=${this.brand}&device=${this.deviceId}&tolerance=${this.tolerance}`).catch((e) => console.error(e));
  }
  determined() {
    this.state !== P.STATE.DETERMINED && (this.state = P.STATE.DETERMINED, this.lastAction = P.STATE.DETERMINED, P.CONFIG.togglePopinFunction("", this), F.fetch(`${P.CONFIG.url}/hello?user=${this.userId}&brand=${this.brand}&device=${this.deviceId}&tolerance=${this.tolerance}&determined=1`).then((e) => e.json()).then(() => {
      this.state === P.STATE.DETERMINED && this.ping();
    }).catch(() => {
      this.state = P.STATE.STOP;
    }));
  }
  ping() {
    this.state !== P.STATE.PING && (this.state = P.STATE.PING, this.lastAction = P.STATE.PING, setTimeout(this.doPing.bind(this), P.CONFIG.timeout));
  }
  doPing() {
    document[this.hidden] || this.state !== P.STATE.PING || F.fetch(`${P.CONFIG.url}/ping?user=${this.userId}&brand=${this.brand}&device=${this.deviceId}&tolerance=${this.tolerance}`).then((e) => e.json()).then((e) => {
      if (this.state === P.STATE.PING)
        if (e.pause === !0)
          e.block === !0 ? (P.CONFIG.togglePopinFunction(e.message, this), this.staytuned()) : (this.state = P.STATE.STOP, this.lastAction = "");
        else {
          if (document[this.hidden]) {
            this.state = P.STATE.STOP;
            return;
          }
          this.state = P.STATE.STOP, this.ping();
        }
    }).catch(() => {
      this.state = P.STATE.STOP;
    });
  }
  staytuned() {
    this.state !== P.STATE.STAY_TUNED && (this.state = P.STATE.STAY_TUNED, this.lastAction = P.STATE.STAY_TUNED, setTimeout(this.doStaytuned.bind(this), P.CONFIG.timeout));
  }
  doStaytuned() {
    document[this.hidden] || this.state !== P.STATE.STAY_TUNED || F.fetch(`${P.CONFIG.url}/stayTuned?user=${this.userId}&brand=${this.brand}&device=${this.deviceId}&tolerance=${this.tolerance}`).then((e) => e.json()).then((e) => {
      if (this.state === P.STATE.STAY_TUNED)
        if (e.block === !0)
          document[this.hidden] ? this.state = P.STATE.STOP : (this.state = P.STATE.STOP, this.staytuned());
        else {
          if (document[this.hidden]) {
            this.state = P.STATE.STOP;
            return;
          }
          P.CONFIG.togglePopinFunction("", this), this.state === P.STATE.STAY_TUNED && this.hello();
        }
    }).catch(() => {
      this.state = P.STATE.STOP;
    });
  }
  start() {
    typeof document.hidden < "u" ? (this.hidden = "hidden", this.visibilityChange = "visibilitychange") : typeof document.msHidden < "u" ? (this.hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : typeof document.webkitHidden < "u" && (this.hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange"), this.initializeData(), this.hello();
    const e = () => {
      if (document[this.hidden])
        this.state === P.STATE.PING && (this.state = P.STATE.STOP, this.bye()), this.state === P.STATE.HELLO && (this.state = P.STATE.STOP, setTimeout(this.bye.bind(this), P.CONFIG.timeout));
      else {
        if (this.lastAction === P.STATE.STAY_TUNED) {
          this.staytuned();
          return;
        }
        (this.lastAction === P.STATE.PING || this.lastAction === P.STATE.HELLO) && this.hello();
      }
    };
    typeof document.addEventListener > "u" || typeof document[this.hidden] > "u" || document.addEventListener(this.visibilityChange, e, !1);
  }
  stop() {
    this.state = P.STATE.STOP;
  }
  initializeData() {
    this.userId = P.CONFIG.userId, this.brand = P.CONFIG.brand, this.tolerance = P.CONFIG.tolerance;
  }
  createModal() {
    const e = document.createElement("div");
    e.classList.add("imaios-capping-modal"), e.innerHTML = '<div class="imaios-capping-modal-content"></div>', window.addEventListener("message", (t) => {
      if (t.data === "cappingContinueAction" && (this.determined(), t.preventDefault()), t.data === "cappingContentLoaded" && this.$modal.show(), t.data.message === "imaios-capping-update-height") {
        const i = this.$modal.querySelector("iframe");
        typeof i < "u" && (i.style.height = `${t.data.height}px`);
      }
    }), document.body.appendChild(e), this.$modal = e.children[0], this.$modal.hide = () => {
      document.body.style.overflowY = "", e.style.display = "";
    }, this.$modal.show = () => {
      e.style.display = "flex", document.body.style.overflowY = "hidden";
    }, this.$modal.destroy = () => {
      document.body.removeChild(e);
    };
  }
  destroy() {
    super.destroy(), this.instanceHasInitializedCapping && (window.IMAIOS_CAPPING_EXIST = !1, this.$modal.destroy());
  }
}
const Tv = (s, e) => {
  const t = new _v(s);
  return t.init(s, e), t;
};
class Sv extends ne {
  constructor(e) {
    super(e), this.needToRestoreLastInteraction = !1;
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_DOWN,
        action: (t) => {
          t.preventDefault();
          const i = e.services.interaction, r = i.getCurrent();
          if (t.button === wt.MIDDLE_CLICK && r.name !== ft.interactionName) {
            i.setCurrent(ft.interactionName, !1);
            const n = i.getCurrent();
            this.needToRestoreLastInteraction = !0, n.start();
          }
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_UP,
        action: () => {
          this.needToRestoreLastInteraction && (e.services.interaction.restorePreviousInteraction(), this.needToRestoreLastInteraction = !1);
        }
      }
    ];
  }
}
const bv = (s, e) => {
  const t = new Sv(s);
  return t.init(s, e), t;
};
class Av extends ne {
  constructor(e) {
    super(e), this.needToRestoreLastInteraction = !1;
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_DOWN,
        action: (t) => {
          const i = e.services.interaction, r = i.getCurrent();
          if (t.button === wt.RIGHT_CLICK && r.name !== pt.interactionName) {
            i.setCurrent(pt.interactionName, !1);
            const n = i.getCurrent();
            this.needToRestoreLastInteraction = !0, n.start();
          }
        }
      },
      {
        from: e.handlers.pointer,
        name: $.EVENT.POINTER_UP,
        action: () => {
          this.needToRestoreLastInteraction && (e.services.interaction.restorePreviousInteraction(), this.needToRestoreLastInteraction = !1);
        }
      }
    ];
  }
}
const wv = (s, e) => {
  const t = new Av(s);
  return t.init(s, e), t;
}, Lv = 150;
class Ov extends ne {
  constructor(e) {
    super(e), this.accumulatedWheelScroll = 0;
  }
  subscribe(e) {
    return [
      {
        from: e.handlers.pointer,
        name: $.EVENT.MOUSE_WHEEL,
        action: (t) => {
          if (t.preventDefault(), !e.state.pointer.isDown) {
            e.publish(Ii.SET_PLACEMENT_IMAGE_VIEW, { placement: ie.SCROLL });
            const i = -t.deltaY || t.wheelDeltaY || -t.detail;
            this.accumulatedWheelScroll += i, oe.isFirefox() && Math.abs(i) < 150 && (this.accumulatedWheelScroll += i / Math.abs(i) * 150), Math.abs(this.accumulatedWheelScroll) >= Lv && (this.accumulatedWheelScroll < 0 ? e.goToNextSlice() : e.goToPreviousSlice(), this.accumulatedWheelScroll = 0);
          }
        }
      }
    ];
  }
}
const Mv = (s, e) => {
  const t = new Ov(s);
  return t.init(s, e), t;
};
class Nv extends it {
  constructor(e) {
    super(e), this.loop = 0, this.lastRender = Date.now(), this.FRAME_RATE = 10;
  }
  onInit(e) {
    super.onInit(e), e.setBehavior("loop-through-slices", () => {
      this.toggleLoop(e);
    });
  }
  toggleLoop(e) {
    this.loop === 0 ? this.animation(e) : this.stopLoop();
  }
  stopLoop() {
    cancelAnimationFrame(this.loop), this.loop = 0;
  }
  animation(e) {
    const t = Date.now();
    if (this.FRAME_RATE === 0 || t - this.lastRender >= 1e3 / this.FRAME_RATE) {
      const i = e.getRelativeIndexCurrentSlice(), r = e.getNumberOfSlice();
      let n = i + 1;
      n > r && (n = 0), e.moveToSlice(n, !0), this.lastRender = Date.now();
    }
    this.loop = requestAnimationFrame(() => this.animation(e));
  }
}
const Rv = (s, e) => {
  const t = new Nv(s);
  return t.init(s, e), t;
};
class xv extends ne {
  constructor(e) {
    super(e), this.hoveredPointId = null;
  }
  updateLabelAlpha(e, t) {
    if (this.hoveredPointId !== null) {
      let i = L.ATTRIBUTE.LABELS_WEAK_ALPHA;
      const r = t.services.point.findById(this.hoveredPointId);
      e.id === r.id && (i = L.ATTRIBUTE.LABELS_FULL_ALPHA), e.alpha = t.services.style.get(i);
    }
  }
  subscribe(e) {
    return [
      {
        from: e.services.slice,
        name: fe.EVENT.SLICE_CHANGE,
        action: () => {
          this.hoveredPointId = null;
        }
      },
      {
        from: e.services.structure,
        name: ae.EVENT.HOVER,
        action: ({ point_id: t }) => {
          this.hoveredPointId = t;
        }
      },
      {
        from: e.services.structure,
        name: ae.EVENT.LOOSE_HOVER,
        action: () => {
          this.hoveredPointId = null;
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.HOVER,
        action: ({ resource_id: t }) => {
          e.services.point.isLinked(t) && (this.hoveredPointId = t, e.animations.redrawOnlySliceMeta.trigger());
        }
      },
      {
        from: e.services.point,
        name: q.EVENT.LOOSE_HOVER,
        action: () => {
          this.hoveredPointId = null, e.animations.redrawOnlySliceMeta.trigger();
        }
      },
      {
        from: e.services.labelsDrawer,
        name: X.EVENT.UPDATE_COLOR,
        action: (t) => {
          this.updateLabelAlpha(t, e);
        }
      },
      {
        from: e,
        name: X.EVENT.CHANGE,
        action: () => {
          this.bindSubscriptions(e);
        }
      }
    ];
  }
}
const Dv = (s, e) => {
  const t = new xv(e);
  return t.init(s, e), t;
}, Pv = (s, e) => ({
  onPointClick(t) {
    const i = t.id;
    if (s.isBlacklisted(i)) {
      s.whitelist(i), e.animations.redrawOnlySliceMeta.trigger();
      return;
    }
    s.isLastPointClicked(i) !== !0 ? s.setLastPointClicked(i) : s.timeBetweenTwoClickIsValid() ? (s.increaseCounter(), s.clickThresholdIsReached() && (s.blacklist(i), e.animations.redrawOnlySliceMeta.trigger())) : s.resetCounter(), s.updateLastClickTimestamp();
  },
  clearBlackList() {
    s.clear();
  }
});
class kv extends ne {
  constructor() {
    super({
      subscriber_id: "point-multi-click-feature"
    }), this.pointsHidden = /* @__PURE__ */ new Set(), this.lastClickTimestamp = Date.now(), this.lastClickPoint = null, this.counterClick = 0, this.application = null;
  }
  init(e) {
    super.init(e), e.haveHiddenPoints = () => this.pointsHidden.size > 0, this.application = e;
  }
  updateLastClickTimestamp() {
    this.lastClickTimestamp = Date.now();
  }
  setLastPointClicked(e) {
    this.lastClickPoint = e, this.resetCounter();
  }
  isLastPointClicked(e) {
    return this.lastClickPoint === e;
  }
  isBlacklisted(e) {
    return this.pointsHidden.has(e);
  }
  resetCounter() {
    this.counterClick = 1;
  }
  clickThresholdIsReached() {
    return this.counterClick >= 2;
  }
  increaseCounter() {
    this.counterClick++;
  }
  timeBetweenTwoClickIsValid() {
    return Date.now() - this.lastClickTimestamp < 1e3;
  }
  whitelist(e) {
    this.pointsHidden.delete(e), this.lastClickPoint = null;
  }
  blacklist(e) {
    this.pointsHidden.add(e), this.application.publish(ms.BLACKLIST_POINT);
  }
  clear() {
    this.pointsHidden.clear(), this.application.publish(ms.WHITELIST_POINT);
  }
  subscribe(e) {
    const t = e.services.point, i = e.services.slice, r = e.services.filter, { onPointClick: n, clearBlackList: a } = Pv(this, e);
    return [
      {
        from: e,
        name: q.EVENT.CLICK,
        action: n
      },
      {
        from: i,
        name: fe.EVENT.SLICE_CHANGE,
        action: a
      },
      {
        from: r,
        name: [se.EVENT.SELECTED, se.EVENT.UNSELECTED],
        action: a
      },
      {
        from: e,
        name: St.CLEAR_BLACKLIST,
        action: a
      },
      {
        from: e.services.point,
        name: q.EVENT.CHECK_VISIBILITY,
        action: (o) => {
          this.isBlacklisted(o.id) && (o.isSelected = !1);
        }
      },
      {
        from: t,
        name: q.EVENT.UPDATE_ACTIVE,
        action: (o) => {
          this.pointsHidden.forEach((l) => {
            o.push(t.findById(l));
          });
        }
      },
      {
        from: e,
        name: zt.EVENT.STATUS_CHANGE,
        action: () => {
          a();
        }
      }
    ];
  }
}
const Hv = (s, e) => {
  const t = new kv(e);
  return t.init(s, e), t;
};
class Fv extends ne {
  constructor(e) {
    super(e), this.saveLastSeenSlice = h.debounce((t) => {
      G.add(this.getKeyLastSliceSeen(e), t);
    }, 200);
  }
  setFirstSliceWithPoint(e) {
    const t = e.services.filter.getCurrent();
    if (e.services.filter.getCurrent() !== []) {
      const i = Object.values(e.services.point.getResources()).filter((r) => t.includes(r.filter_id));
      if (i.length > 0) {
        const r = i[0].slice_id;
        try {
          e.moveToSlice(e.getRelativeSliceIndexById(r));
        } catch (n) {
          console.error(n);
        }
      }
    }
  }
  getKeyLastSliceSeen(e) {
    return `${Q.LAST_SLICE_SEEN}-${e.state.module.name}`;
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: k.EVENT.READY,
        action: () => {
          const t = G.get(this.getKeyLastSliceSeen(e));
          t === null ? this.setFirstSliceWithPoint(e) : e.moveToSlice(t);
        }
      },
      {
        from: e,
        name: k.EVENT.IMAGE_VIEW,
        action: ({ sliceIndex: t }) => {
          this.saveLastSeenSlice(t);
        }
      }
    ];
  }
}
const zv = (s, e) => {
  const t = new Fv(s);
  return t.init(s, e), t;
};
class Bv extends ne {
  constructor() {
    super(), this.canvasAreHidden = !1, this.application = null;
  }
  init(e) {
    super.init(e), this.application = e, e.toggleOverlays = () => this.toggle();
  }
  toggle() {
    this.canvasAreHidden ? (this.application.components.overlaysCanvas.show(), this.application.data.overlaysCanvasIsHidden = !1) : (this.application.components.overlaysCanvas.hide(), this.application.data.overlaysCanvasIsHidden = !0), this.canvasAreHidden = !this.canvasAreHidden, this.application.publish(Fr.TOGGLE, this.canvasAreHidden);
  }
  subscribe(e) {
    return [
      {
        from: e,
        name: k.EVENT.SHOW_META_CANVAS,
        action: () => {
          const t = e.components.overlaysCanvas.getCanvas();
          this.canvasAreHidden && t.style.getPropertyValue("display") !== "none" && e.components.overlaysCanvas.hide();
        }
      }
    ];
  }
}
const $v = (s, e) => {
  const t = new Bv(e);
  return t.init(s, e), t;
}, Uv = (s) => ({
  "emit-public-event": (e) => R2(e, s),
  "redraw-labels-on-language-change": S2,
  "redraw-data-on-filters-change": A2,
  "redraw-data-on-contrasts-change": k2,
  // 'convert-cached-image-to-base64-on-idle': ConvertCachedImageToBase64OnIdleFeature,
  "image-auto-compute-multiplier": vv,
  "image-auto-load": dv,
  "load-image-on-idle": Ev,
  "auto-compute-image-quality": pv,
  "request-fullscreen": (e) => ([
    us.ON_FULLSCREEN,
    us.ON_EXIT_FULLSCREEN
  ].forEach((t) => {
    e.subscribe(
      e,
      t,
      () => {
        const i = setInterval(() => {
          (e.ui.container.offsetHeight !== e.data.lastContainerHeight || e.ui.container.offsetWidth !== e.data.lastContainerWidth) && (clearInterval(i), e.onResize());
        });
      }
    );
  }), En(
    e,
    {
      element: document.getElementById(s.parentContainer_id),
      ...s
    }
  )),
  "double-click-fullscreen": Cv,
  "hover-label-point": Dv,
  "clickable-label": L2,
  "clickable-point": M2,
  "toggle-labels": D2,
  "toggle-overlays": $v,
  "reverse-scroll-direction": ro,
  viewzone: Ga,
  "quiz-mode": j2,
  "show-point-according-to-filter-selection": W2,
  // structure
  "blacklist-structure": X2,
  "isolate-structure": Xa,
  "structure-title": B2,
  // point
  "point-multi-click": Hv,
  "point-selection": V2,
  "hide-point-without-label": ao,
  "priority-point-select": mv,
  // special illustrations
  "increase-text-opacity-for-illustration": K2,
  "update-orientation-on-slice-change": J2,
  // series features
  "update-viewer-style-on-series-change": tv,
  "save-image": co,
  // Reset points on select/unselect filter
  "reset-points-on-filter-change": iv,
  context: rv,
  // Export data
  "export-data": av,
  "pin-mode": so,
  "switch-image-provider": Ra,
  // Interaction
  "pan-interaction": bv,
  "zoom-interaction": wv,
  "scroll-interaction": Mv,
  "loop-through-all-slices": Rv,
  // Capping
  capping: Tv,
  // 'generate-iframe-embed-link': IframeEmbedLinkFeature
  "set-first-slice": zv,
  "share-link": cv
}), Vv = {
  [Pe.EANATOMY]: {
    application_id: Pe.EANATOMY,
    defaultLanguageId: Z.la,
    languagesAllowed: [
      Z.la,
      Z.en,
      Z.fr,
      Z.es,
      Z.de,
      Z.cn,
      Z.jp,
      Z.br,
      Z.ru,
      Z.pl,
      Z.it,
      Z.ko
    ]
  },
  [Pe.VETANATOMY]: {
    application_id: Pe.VETANATOMY,
    defaultLanguageId: Z.la,
    languagesAllowed: [
      Z.la,
      Z.en,
      Z.fr,
      Z.es,
      Z.de,
      Z.cn,
      Z.jp,
      Z.br,
      Z.ru,
      Z.it,
      Z.ko
    ]
  }
};
let K = null;
class Gv {
  constructor(e) {
    this.context = e;
    const t = Vv[e.application_id];
    if (t)
      this.context.defaultLanguageId = t.defaultLanguageId, this.context.languagesAllowed = t.languagesAllowed;
    else
      throw new I2(e.application_id);
    this.bindProviderWithApplicationId();
  }
  bindProviderWithApplicationId() {
    Object.values(this.context.providers).forEach((e) => {
      typeof e.setApplicationId == "function" && e.setApplicationId(this.context.application_id);
    });
  }
  start() {
    try {
      const e = Uv(this.context);
      K = Object.freeze(new k({
        // inject context into features factory in order to make container available for some overrides
        features: e,
        ...this.context
      })), K.publish(k.EVENT.VIEWER_LAUNCH), le([
        {
          name: He.EVENT.CONTENT_AVAILABLE,
          from: K.services.image
        },
        {
          name: k.EVENT.READY,
          from: K
        }
      ]).then(() => {
        this.performFirstRendering(K);
      }), le([
        {
          name: "loadPoints-end",
          from: K
        },
        {
          name: "loadSlices-end",
          from: K
        }
      ]).then(() => {
        const r = K.services.slice, n = K.services.point;
        Object.values(n.getResources()).forEach((o, l) => {
          const c = r.findById(o.slice_id);
          if (c === null) {
            console.log(`unable to find slice ${o.slice_id} related to point ${o.id} and index ${l}`);
            return;
          }
          c.points.push(o.id);
        });
      }), K.subscribe(
        K.services.image,
        He.EVENT.CONTENT_AVAILABLE,
        () => {
          K.components.overlaysCanvas.enable();
        }
      );
      const t = Date.now(), i = this.initializeLoadingSequence(C2);
      Promise.all(i).then(() => {
        this.checkSeriesWithNoSlices(K), K.services.series.updateSeriesAndRemoveSeriesWithNoSlices(), K.publish(k.EVENT.MODULE_LOADED, { downloadTime: Date.now() - t }), this.initializeStates(K), E2.recordCoreSubscriptions(K), new re({ name: "initializer-of-features-who-required-application-ready" }).subscribe(
          K,
          k.EVENT.READY,
          () => {
            K.features["request-fullscreen"].initialize(K), K.features["point-selection"].init(K), K.features["redraw-data-on-filters-change"].redraw(K), K.services.roi.setApplication(K), K.services.debug.setApplication(K);
          }
        ), K.publish(k.EVENT.STATE_HAS_BEEN_INITIALIZED);
      });
    } catch (e) {
      console.error(e);
    }
    return K;
  }
  checkSeriesWithNoSlices(e) {
    Object.keys(e.services.series.getResources()).forEach((t) => {
      if (e.services.slice.getNbSlicesBySeriesId(t) === 0) {
        const r = new _2(t);
        e.publish(k.EVENT.ERROR, {
          from: "series-doesnt-have-slices",
          error: r
        }), console.error(r);
      }
    });
  }
  initializeLoadingSequence(e) {
    const t = [];
    return Object.keys(e).forEach((i) => {
      !Array.isArray(e[i]) || typeof this[i] != "function" || t.push(new Promise((r, n) => {
        const a = e[i].map((o) => ({
          name: `${o}-end`,
          from: K
        }));
        le(a).then(() => {
          this[i](K).then(() => {
            K.publish(`${i}-end`), r();
          }).catch(n);
        });
      }));
    }), t;
  }
  performFirstRendering(e) {
    e.allowsDrawing(), e.moveToSlice(e.services.slice.getCurrentRelativeIndex()), e.showMetaCanvas(), e.enablePointerListener();
    const t = e.services.interaction.getCurrent();
    t.isPerforming === !0 && t.pause();
  }
  async loadModule(e) {
    try {
      const t = await this.load(this.context.providers.module);
      this.context.module_id = t.id, e.state.module.set(t), e.publish(k.EVENT.MODULE_DATA_LOADED, { moduleName: t.name });
    } catch (t) {
      throw e.publish(k.EVENT.ERROR, {
        from: "module",
        error: t
      }), t;
    }
  }
  async loadThumbs(e) {
    try {
      const t = e.state.module;
      await this.context.providers.imageThumb.loadZipUrls(this.context.application_id, t), await this.context.providers.imageThumb.setZipSrc(pe);
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "thumbs",
        error: t
      }), console.error(t);
    }
  }
  /**
   * @param provider
   * @param options
   * @returns {Promise<unknown>}
   */
  load(e, t = {}) {
    return e.getData({
      ...this.context,
      ...t
    });
  }
  async loadPoints(e) {
    try {
      const t = await this.load(this.context.providers.points);
      let i = 0;
      t.forEach((r) => {
        if (typeof r.id > "u") {
          i++;
          return;
        }
        const n = new J(r);
        e.services.point.addResource(n, r.id), e.services.structure.addStructureWithAPoint(e.services.structure.findByTaxonKey(n.taxon_key));
      });
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "points",
        error: t
      }), console.error(t);
    }
  }
  async loadSeries(e) {
    try {
      const t = await this.load(this.context.providers.series);
      let i = !1;
      const r = {};
      t.forEach((n) => {
        if ((n.slices_width === 0 || n.slices_height === 0) && (i = !0), n.cross_references_titles.length === 1) {
          const a = n.cross_references_titles[0];
          typeof r[a.name_id] > "u" && (r[a.name_id] = []), r[a.name_id].push(n.id);
        }
        e.services.series.addResource(new Kt(n));
      }), e.services.series.seriesIdByCr = r, i && import.meta.VITE_APP_DEBUG === "true" && console.log("%cCAREFUL, there is at least one series which doesn't have a valid slices size, you need to run the command to update them", "color:white;background-color:red;font-size:24px");
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "series",
        error: t
      }), console.error(t);
    }
  }
  async loadContrasts(e) {
    try {
      const t = await this.load(this.context.providers.contrasts);
      t.forEach((n) => {
        e.services.contrast.addResource(n);
      }), e.getSeries().some((n) => t.findIndex((a) => a.series_id === n.id) === -1) && e.services.contrast.addResource(Er), e.services.contrast.publish(Ce.EVENT.LOADED);
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "contrast",
        error: t
      }), console.error(t);
    }
  }
  async loadIcons(e) {
    try {
      (await this.load(this.context.providers.icon)).forEach((i) => e.services.icon.addResource(i));
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "icons",
        error: t
      }), console.error(t);
    }
  }
  async loadOrientation(e) {
    try {
      const t = await this.load(this.context.providers.orientation);
      t.iconsNameByOrientationId.forEach((i) => {
        e.services.orientation.addResource(i);
      }), t.translationIdByOrientationId.forEach((i) => {
        e.services.orientation.storeTranslationID(i);
      });
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "orientation",
        error: t
      }), console.error(t);
    }
  }
  async loadImages(e) {
    try {
      const t = await this.load(this.context.providers.image);
      await e.services.image.loadImages(t);
    } catch (t) {
      throw e.publish(k.EVENT.ERROR, {
        from: "images",
        error: t
      }), t;
    }
  }
  async loadFilters(e) {
    e.services.filter.setStorageName(e.state.module.name);
    try {
      const t = await this.load(this.context.providers.filters);
      e.services.filter.parse(t);
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "filters",
        error: t
      }), console.error(t);
    }
  }
  "record:ui-translations"(e, t) {
    try {
      Object.keys(t).forEach((i) => {
        try {
          t[i].forEach((r) => {
            e.services.translator.addTranslation(
              r.translation_key,
              r.value,
              i,
              V.NAMESPACE.UI
            );
          });
        } catch (r) {
          console.error(r);
        }
      }), e.services.translator.publish(V.EVENT.LOADED);
    } catch (i) {
      console.error(i);
    }
  }
  "record:translations"(e, t) {
    try {
      if (e.data.hasAccess = t.granted ?? !0, t.granted === !1) {
        const i = e.services.translator.getTranslation.bind(e.services.translator);
        e.services.translator.getTranslation = function(r, n, a) {
          return n === V.NAMESPACE.CONTENT ? t.data : i(r, n, a);
        };
      } else
        Object.keys(t).forEach((i) => {
          try {
            t[i].forEach((r) => {
              e.services.translator.addTranslation(
                r.translation_key,
                r.value,
                i,
                V.NAMESPACE.CONTENT
              );
            });
          } catch (r) {
            console.error(r);
          }
        }), e.services.translator.publish(V.EVENT.LOADED);
    } catch (i) {
      console.error(i);
    }
  }
  loadResource(e, t) {
    return new Promise(async (i) => {
      const r = this.context.providers[t];
      le([
        {
          name: Bt.EVENT.CONTENT_AVAILABLE,
          from: r
        }
      ]).then((n) => {
        const a = n[0];
        this[`record:${t}`](e, a), e.subscribe(
          r,
          Bt.EVENT.CONTENT_AVAILABLE,
          (o) => this[`record:${t}`](e, o)
        ), i();
      });
      try {
        await this.load(r);
      } catch (n) {
        console.error(n), e.publish(k.EVENT.ERROR, {
          from: t,
          error: n
        });
      }
    });
  }
  async loadTranslations(e) {
    await this.loadResource(e, "translations");
  }
  async loadUITranslations(e) {
    await this.loadResource(e, "ui-translations");
  }
  async loadTextOverlays(e) {
    const t = e.services.textOverlay;
    try {
      (await this.load(this.context.providers.textOverlays)).forEach((r) => t.addResource(r));
    } catch (i) {
      console.error(i);
    }
  }
  async loadOverlays(e) {
    const t = e.services.overlay, i = e.services.textOverlay;
    try {
      const r = await this.load(this.context.providers.overlays), n = r.map((l) => l.layer), a = i.getResources();
      Object.values(a).map((l) => l.layer).filter((l) => l).filter((l) => !n.includes(l)).forEach((l) => t.addResource(new fn({ layer: l }))), r.forEach((l) => t.addResource(l));
    } catch (r) {
      console.error(r);
    }
  }
  async loadSlices(e) {
    const t = e.services.slice;
    try {
      (await this.load(this.context.providers.slices)).forEach((a) => {
        t.addResource(a);
      }), t.setRelativeSliceIndex({ ...t.getIndex() });
      const r = 1, n = t.getIdBySliceIndex(r);
      t.setDefault(n), t.setCurrent(n), t.setCurrentRelativeIndex(r), t.publish(fe.EVENT.SLICE_LOADED);
    } catch (i) {
      e.publish(k.EVENT.ERROR, {
        from: "slices",
        error: i
      }), console.error(i);
    }
  }
  async loadStructures(e) {
    e.services.structure.setTranslatorService(e.services.translator);
    try {
      (await this.load(this.context.providers.structures)).forEach((i) => {
        e.services.structure.addResource(i);
      });
    } catch (t) {
      e.publish(k.EVENT.ERROR, {
        from: "structures",
        error: t
      }), console.error(t);
    }
  }
  initializeStates(e) {
    const t = this.context.services, i = t.slice, r = t.series, n = t.renderingContext, o = i.getCurrent().series_id;
    r.setDefault(o), r.setCurrent(o);
    const l = e.services.contrast, c = l.find({ series_id: o }).sort((m, g) => m - g);
    let u;
    c.length > 0 ? u = c.find((m) => m.imaios_code === pe).id : u = -1, l.setDefault(u), l.select(u), n.setContainer(e.ui.container), n.updateRenderingContext(), this.context.interactions.forEach((m) => {
      const g = new m({
        component: e,
        ...this.context
      });
      t.interaction.addResource(g, g.name);
    }), t.interaction.setCurrent(Zt.interactionName);
    try {
      const m = t.language;
      h.languagesAllowed = this.context.languagesAllowed, h.defaultLanguageId = this.context.defaultLanguageId, this.context.languagesAllowed.forEach((C) => {
        m.addResource(C);
      }), m.setDefault(this.context.defaultLanguageId), m.setCurrent(h.getAllowedLanguage(this.context.currentLanguageId)), m.publish(Re.EVENT.LOADED);
      const g = this.context.services.style;
      Object.keys(this.context.style).forEach((C) => {
        g.update(C, this.context.style[C]);
      }), e.services.renderingContext.setZoomSettings(this.context.zoom);
    } catch (m) {
      console.error(m);
    }
  }
}
gs.startFactories();
class jv extends Gv {
  constructor(e = {}) {
    super({
      ...e,
      ...gs.getContent()
    });
  }
}
const lr = {
  1: "Latina",
  2: "English",
  3: "Français",
  4: "Deutsch",
  5: "Español",
  6: "中文 (简体)",
  7: "日本語",
  8: "Italiano",
  9: "Português",
  10: "Русский",
  12: "العربية",
  15: "Polski",
  17: "한국어"
}, Yv = {
  namespaced: !0,
  state: () => ({
    /** @type {Application} **/
    application: null,
    applicationName: null,
    module_id: null,
    moduleName: "",
    container_id: null,
    isReady: !1,
    filters: [],
    contrasts: [],
    currentSeries: null,
    currentSlice: null,
    offsetSizeContainer: 0,
    languages: [],
    indexCurrentSlice: 0,
    numberOfSlices: 0,
    galleryThumbnails: [],
    previewThumbnail: {},
    thumbnailSliceIndex: 0,
    listSeriesImage: [],
    listSeries: [],
    seriesGallery: [],
    slicesGallery: [],
    transformations: {},
    imageAllSeries: [],
    isQuizMode: !1,
    viewZoneEnabled: !1,
    pinModeEnabled: !1,
    orientation: null,
    imageQuality: !1,
    coverImage: null,
    backgroundColor: null,
    currentLanguage: null,
    currentStructureName: null,
    isScrollInverse: !1,
    isModeFullSeries: !0,
    interfaceLanguage: null,
    otherSeriesHaveMoreThanOneContrast: !1,
    parentContainerId: null,
    defaultStructureLanguage: null,
    fontSize: null
  }),
  getters: {
    /** @return {Application} **/
    application: (s) => s.application,
    container_id: (s) => s.container_id,
    application_id: (s) => s.application?.application_id,
    module_id: (s) => s.module_id,
    filters: (s) => s.filters,
    isFilterSelected: (s) => (e) => {
      try {
        return e === -1 ? s.filters.every((t) => s.application.isFilterSelected(t.id)) : s.application.isFilterSelected(e);
      } catch (t) {
        return console.error(t), !1;
      }
    },
    getFilterIcon: (s) => (e) => s.application.getFilterIcon(e),
    contrasts: (s) => s.contrasts,
    currentSeries: (s) => s.currentSeries,
    currentSlice: (s) => s.currentSlice,
    languages: (s) => s.languages,
    currentLanguage: (s) => s.currentLanguage,
    currentLanguageId: (s) => () => s.application.getCurrentLanguage(),
    indexCurrentSlice: (s) => s.indexCurrentSlice,
    numberOfSlices: (s) => s.numberOfSlices,
    slices: (s) => s.application.getSlices(),
    sliceIndexById: (s) => (e) => s.application.getSliceIndexById(e),
    relativeSliceIndexById: (s) => (e, t = null) => s.application.getRelativeSliceIndexById(e, t),
    sliceByRelativeIndex: (s) => (e) => s.application.getSliceByRelativeIndex(e),
    getGalleryThumbnails: (s) => s.galleryThumbnails,
    getPreviewThumbnail: (s) => s.previewThumbnail,
    numberMaxSlices: (s) => s.application.getNumberMaxSlices(),
    listSeries: (s) => s.listSeries,
    listSeriesImage: (s) => s.listSeriesImage,
    seriesGallery: (s) => s.seriesGallery,
    imageAllSeries: (s) => s.imageAllSeries,
    slicesGallery: (s) => s.slicesGallery,
    getDefaultOverlayOpacity: (s) => s.application.getDefaultOverlayOpacity(),
    isModeFullSeries: (s) => s.isModeFullSeries,
    isQuizMode: (s) => s.isQuizMode,
    viewZoneEnabled: (s) => s.viewZoneEnabled,
    moduleName: (s) => s.moduleName,
    seriesIdByIndex: (s) => (e) => s.application.getSeriesIdByIndex(e),
    rotation: (s) => s.transformations ? s.transformations.ROTATION_ANGLE : 0,
    flipX: (s) => s.transformations ? s.transformations.VERTICAL_FLIP : !1,
    flipY: (s) => s.transformations ? s.transformations.HORIZONTAL_FLIP : !1,
    "orientation-image": (s) => s.orientation ? s.orientation.currentImageSrc : "",
    getCurrentStructureName: (s) => s.currentStructureName,
    imageQuality: (s) => s.imageQuality,
    hasModuleAccess: (s) => () => s.application.hasModuleAccess(),
    hasSubscriberAccess: (s) => () => s.application.hasSubscriberAccess(),
    featureHidePointWithoutLabelIsActive: (s) => s.application.featureHidePointWithoutLabelIsActive(),
    searchStructure: (s) => (e) => s.application.searchStructure(e),
    coverImage: (s) => s.coverImage,
    backgroundColor: (s) => s.backgroundColor,
    "get-series-background-color": (s) => () => s.application?.getCurrentSeriesBackground() ?? "",
    "contrast:get-current-code": (s) => () => s.application.getCurrentContrastCode(),
    isCurrentContrast: (s) => (e) => s.application.isCurrentContrast(e),
    isScrollInverse: (s) => s.isScrollInverse,
    minFontSize: (s) => () => s.application.getMinSizeFont(),
    pinModeEnabled: (s) => s.pinModeEnabled,
    structureByTaxonKey: (s) => (e) => s.application.getStructureByTaxonKey(e),
    structureById: (s) => (e, t = null) => s.application.getStructureById(e, t),
    structureWithPointsByTaxonKey: (s) => (e) => s.application.getStructureWidthPointsByTaxonKey(e),
    structureWithPointsByStructureId: (s) => (e) => s.application.getStructureWidthPointsByStructureId(e),
    "thumbnail-slice-index": (s) => s.thumbnailSliceIndex,
    interfaceLanguage: (s) => s.interfaceLanguage,
    isOnlyOneFilterSelected: (s) => (e) => s.application.isOnlyOneFilterSelected(e),
    filterById: (s) => (e) => s.application.getFilters(s.interfaceLanguage).find((t) => t.id === e),
    isBlacklistedStructure: (s) => (e) => s.application.isBlacklisted(e),
    getIsolateStructureId: (s) => () => s.application?.getIsolatedStructureID(),
    getPaddingRightLabel: (s) => () => s.application.services.renderingContext.get("RIGHT_PADDING"),
    getModuleShortName: (s) => () => s.application.getModuleShortName(),
    getAlternativeModality: (s) => () => s.application.getAlternativeModality(),
    otherSeriesHaveMoreThanOneContrast: (s) => s.otherSeriesHaveMoreThanOneContrast,
    getSlicesIndexFromRelativeIndex: (s) => () => s.application.getSlicesIndexFromRelativeIndex(),
    getParentContainerId: (s) => s.parentContainerId,
    getFontSize: (s) => s.fontSize,
    "series:have-same-cr": (s) => () => s.application.getSeriesHaveSameCR(),
    "series:get-list-series-with-same-cr": (s) => (e) => s.application.getSeriesIdByCR(e),
    getShareLink: (s) => () => s.application.behave("share-link"),
    getStructureIcon: (s) => (e) => s.application.getIcon(e.icon_id),
    moduleHasCrossReferences: (s) => () => s.application.moduleHasCrossReferences(),
    crossRefExists: (s) => {
      const e = s.currentSeries;
      return e !== null && typeof e.cross_references_titles < "u" && e.cross_references_titles.length > 0;
    },
    seriesAndImagesList: (s) => {
      const e = s.listSeries, t = s.listSeriesImage, i = [...e, ...t];
      return Object.values(i.reduce((r, n) => (r[n.id] = {
        ...r[n.id] || {},
        ...n
      }, r), {}));
    },
    haveBlacklistedStructures: (s) => () => s.application?.haveBlacklistedStructures() ?? !1,
    haveHiddenPoints: (s) => () => s.application?.haveHiddenPoints() ?? !1,
    overlaysCanvasIsHidden: (s) => () => s.application?.data?.overlaysCanvasIsHidden ?? !1
  },
  mutations: {
    /**
     * @param state
     * @param {string} container_id
     * @param {string} parentContainer_id
     * @param {string} fontFamily
     */
    create(s, {
      container_id: e,
      parentContainer_id: t,
      fontFamily: i
    }) {
      s.container_id = e;
      const r = G.get(Q.LANGUAGE) ?? h.transformSiteAccessToStructureLanguage(s.defaultStructureLanguage), a = Object.freeze(
        new jv({
          application_id: s.applicationName,
          moduleName: s.module_id,
          containerId: e,
          parentContainer_id: t,
          // Get default language from site access
          // or check localstorage
          currentLanguageId: r,
          interfaceLanguageId: s.interfaceLanguage,
          fontFamily: i
        })
      ).start();
      s.application = a, s.transformations = a.services.renderingContext.state.data, s.orientation = a.services.orientation.data.resources;
    },
    setReady(s) {
      s.isReady = !0;
    },
    unselectFilter(s, e) {
      s.application.unselectFilter(e);
    },
    unselectAllFilter(s) {
      s.application.unselectAllFilters();
    },
    selectFilter(s, e) {
      s.application.selectFilter(e);
    },
    selectAllFilter(s) {
      s.application.selectAllFilters();
    },
    "filter:update"(s) {
      const e = s.application.getFilters(s.interfaceLanguage).reduce((i, r) => (i[r.id] = r, i), {}), t = [];
      s.application.getMainsFiltersId().forEach((i) => {
        const r = { ...e[i] };
        r.children = r.children.map((n) => {
          const a = { ...n };
          return a.id = a.id.toString(), a.name = e[a.id].name, a;
        }).filter((n) => n), t.push(r);
      }), s.filters = t;
    },
    "contrast:update"(s, e) {
      s.contrasts = e;
    },
    "contrast:select"(s, e) {
      s.application.selectContrast(e);
    },
    viewerResize(s) {
      s.application.onResize();
    },
    updateCurrentSeries(s, e) {
      s.currentSeries = e;
    },
    updateCurrentSlice(s, e) {
      s.currentSlice = e;
    },
    toggleFullscreen(s) {
      s.application.behave("toggleFullScreen");
    },
    getLanguages(s) {
      const e = s.application.getLanguages();
      s.languages = e.map((t) => ({
        id: t,
        name: lr[t]
      }));
    },
    setLanguage(s, e) {
      s.application.setLanguage(e);
    },
    refreshRelativeIndexCurrentSlice(s, e) {
      s.indexCurrentSlice = e;
    },
    refreshNumberOfSlices(s, e) {
      s.numberOfSlices = e;
    },
    setSlice(s, e) {
      s.application.moveToSlice(e);
    },
    setSeries(s, {
      series_id: e,
      relativeSliceIndex: t,
      keepMode: i
    }) {
      s.application.moveToSeries(e, t, i);
    },
    rotateImage(s, e) {
      s.application.rotate(e);
    },
    flipHorizontalImage(s) {
      s.application.horizontalFlip();
    },
    flipVerticalImage(s) {
      s.application.verticalFlip();
    },
    resetImage(s) {
      s.application.reset();
    },
    refreshGalleryThumbs(s, e) {
      s.galleryThumbnails = e;
    },
    "thumbnails:set-slice-index"(s, e) {
      s.thumbnailSliceIndex = e;
    },
    updatePreviewThumbnail(s, e) {
      s.previewThumbnail = e;
    },
    refreshSeriesGallery(s, e) {
      s.seriesGallery = e;
    },
    refreshImageAllSeries(s, e) {
      s.imageAllSeries = e;
    },
    refreshSlicesGallery(s, e) {
      s.slicesGallery = e;
    },
    enableQuizMode(s) {
      s.isQuizMode = !0;
    },
    disableQuizMode(s) {
      s.isQuizMode = !1;
    },
    disableViewZone(s) {
      s.viewZoneEnabled = !1;
    },
    enableViewZone(s) {
      s.viewZoneEnabled = !0;
    },
    refreshImageQualityState(s) {
      s.imageQuality = s.application.getImageQuality();
    },
    "application:set-application-name"(s, e) {
      s.applicationName = e;
    },
    "application:set-module-id"(s, e) {
      s.module_id = e;
    },
    "application:set-module-name"(s, e) {
      s.moduleName = e;
    },
    "inverse-scroll:toggle"(s) {
      s.application.inverseScroll(ie.RIGHT_MENU);
    },
    enablePinMode(s) {
      s.pinModeEnabled = !0;
    },
    disablePinMode(s) {
      s.pinModeEnabled = !1;
    },
    "application:set-cover-image"(s, e) {
      s.coverImage = e;
    },
    "application:set-background-color"(s, e) {
      s.backgroundColor = e;
    },
    "list-series:update"(s, e) {
      s.listSeries = e;
    },
    "list-series:update-images"(s, e) {
      s.listSeriesImage = e;
    },
    "language:update-current"(s, e) {
      s.currentLanguage = e;
    },
    "application:reverse-scroll-update"(s, e) {
      s.isScrollInverse = e;
    },
    "application:set-mode-series"(s, e) {
      s.isModeFullSeries = e;
    },
    "application:set-interface-language"(s, e) {
      s.interfaceLanguage = e;
    },
    "contrast:set-other-series-have-more-than-one-contrast"(s, e) {
      s.otherSeriesHaveMoreThanOneContrast = e;
    },
    "set-parent-container-id"(s, e) {
      s.parentContainerId = e;
    },
    "application:set-default-structure-language"(s, e) {
      s.defaultStructureLanguage = e;
    },
    "font-size:update"(s, e) {
      s.fontSize = e;
    }
  },
  actions: {
    /**
           * @param commit object
           * @param dispatch
           * @param {string} container_id
           * @param {string} parentContainer_id
           * @param {string} fontFamily
           */
    create({ commit: s }, {
      container_id: e,
      parentContainer_id: t,
      fontFamily: i
    }) {
      s("create", {
        container_id: e,
        parentContainer_id: t,
        fontFamily: i
      }), s("setReady");
    },
    "set-parent-id"({ commit: s }, e) {
      s("set-parent-container-id", e);
    },
    toggleFilter({
      commit: s,
      state: e,
      getters: t
    }, i) {
      const r = e.filters.find((n) => {
        if (typeof n.children.find((a) => a.id === i) < "u")
          return n;
      });
      t.isFilterSelected(i) ? (typeof r < "u" && t.isFilterSelected(r.id) && s("unselectFilter", r.id), s("unselectFilter", i)) : (s("selectFilter", i), typeof r < "u" && r.children.every((n) => t.isFilterSelected(n.id)) && s("selectFilter", r.id));
    },
    toggleAllFilters({
      commit: s,
      state: e,
      getters: t
    }) {
      const r = e.filters.every((n) => t.isFilterSelected(n.id));
      s(r ? "unselectAllFilter" : "selectAllFilter");
    },
    "contrast:select"({ commit: s, getters: e }, t) {
      s("contrast:select", t);
      const i = e.application.services.contrast.getCurrentCode();
      e.application.publish(z.ui.VIEWER.CONTRAST, { oldContrastCode: i });
    },
    "application:initialize": ({ commit: s }, {
      application: e,
      moduleId: t,
      language: i
    }) => {
      s("application:set-application-name", e), s("application:set-module-id", t), s("application:set-default-structure-language", i);
    },
    "application:set-module-name"({ commit: s }, e) {
      s("application:set-module-name", e);
    },
    "contrast:reset": ({ getters: s }) => {
      s.application.resetContrast();
    },
    "viewer:resize": ({ commit: s }) => {
      s("viewerResize");
    },
    "viewer:toggleFullscreen": ({ commit: s }) => {
      s("toggleFullscreen");
    },
    "image:rotate": ({ commit: s }, e) => {
      s("rotateImage", e);
    },
    "image:reset": ({ commit: s }) => {
      s("resetImage");
    },
    "image:flip": ({ commit: s }, e) => {
      e === Je.HORIZONTAL ? s("flipHorizontalImage") : e === Je.VERTICAL && s("flipVerticalImage");
    },
    "image:get-one": ({ getters: s }) => s.application.getOneImage(),
    "image:quality-refresh"({ commit: s }) {
      s("refreshImageQualityState");
    },
    "image:toggleQuality"({ getters: s }) {
      s.application.toggleImageQuality();
    },
    "series:update": ({ commit: s, getters: e }) => {
      s("updateCurrentSeries", e.application.getCurrentSeries()), s("refreshNumberOfSlices", e.application.getNumberOfSlice());
    },
    "series:set": ({ commit: s, getters: e }, {
      seriesIndex: t,
      relativeSliceIndex: i = 1,
      keepMode: r = !0,
      placement: n = null
    }) => {
      const a = e.application.getSeries(e.interfaceLanguage), o = t === -1 ? t : a.find((l) => l.sort_order === t).id;
      s("setSeries", {
        series_id: o,
        relativeSliceIndex: i,
        keepMode: r
      }), n !== null && e.application.publish(z.series.SELECT_SERIES, { placement: n });
    },
    "filter:toggleAllChild": ({ commit: s, getters: e }, t) => {
      e.isFilterSelected(t.id) ? (s("unselectFilter", t.id), t.children.forEach((r) => {
        s("unselectFilter", r.id);
      })) : (t.children.forEach((r) => {
        s("selectFilter", r.id);
      }), s("selectFilter", t.id));
    },
    "filter:reset": ({ getters: s }) => {
      s.application !== null && s.application.resetFilters();
    },
    "language:get": ({ commit: s }) => {
      s("getLanguages");
    },
    "language:set": ({ commit: s }, e) => {
      s("setLanguage", e);
    },
    "slice:set": ({ commit: s, dispatch: e }, { sliceIndex: t, placement: i = null }) => {
      i !== null && e("slice:notification", i), s("setSlice", t);
    },
    "slice:next": ({ getters: s, dispatch: e }) => {
      e("slice:notification", ie.ARROW), s.application.triggerGoToNextSlice();
    },
    "slice:update": ({ commit: s, getters: e }) => {
      s("updateCurrentSlice", e.application.getCurrentSlice(e.interfaceLanguage)), s("refreshRelativeIndexCurrentSlice", e.application.getRelativeIndexCurrentSlice());
    },
    "slice:previous": ({ getters: s, dispatch: e }) => {
      e("slice:notification", ie.ARROW), s.application.triggerGoToPreviousSlice();
    },
    "slice:updateRelativeIndex": ({ commit: s, getters: e }) => {
      s("refreshNumberOfSlices", e.application.getNumberOfSlice()), s("refreshRelativeIndexCurrentSlice", e.application.getRelativeIndexCurrentSlice());
    },
    "slice:notification"({ getters: s }, e) {
      s.application.publish(Ii.SET_PLACEMENT_IMAGE_VIEW, { placement: e });
    },
    "fullscreen:get": ({ getters: s }) => s.application.isFullscreen(),
    "thumbnails:refresh": ({ commit: s, getters: e }, { sizeThumbs: t, sizeAvailable: i }) => new Promise(async (r) => {
      if (e.application !== null)
        try {
          await e.application.getGalleryThumbnails(t, i).then((n) => {
            s("refreshGalleryThumbs", n), r();
          });
        } catch (n) {
          r(), console.warn(n);
        }
    }),
    "thumbnails:preview": ({ commit: s, getters: e }, t) => {
      s("thumbnails:set-slice-index", t), e.application.getPreviewSlice(t).then((i) => {
        e["thumbnail-slice-index"] === t && s("updatePreviewThumbnail", i);
      });
    },
    "list-series:update"({ commit: s, getters: e }) {
      s("list-series:update", e.application.getSeries(e.interfaceLanguage));
    },
    "list-series:update-images"({ commit: s, getters: e }) {
      e.application.getImageAllSeries().then((t) => s("refreshImageAllSeries", t)), e.application.getSeriesImage().then((t) => s("list-series:update-images", t));
    },
    "gallery:series-update": ({ commit: s, getters: e }) => new Promise((t) => {
      e.application.getSeriesGallery(e.interfaceLanguage).then((i) => {
        s("refreshSeriesGallery", i), t();
      });
    }),
    "gallery:slice-update": ({ commit: s, getters: e }) => new Promise((t) => {
      e.application.getSlicesGallery(e.interfaceLanguage).then((i) => {
        s("refreshSlicesGallery", i), t();
      });
    }),
    "overlay:set-opacity": ({ getters: s }, e) => {
      s.application.setImageOverlaysOpacity(e);
    },
    "quiz:refreshState": ({ commit: s, getters: e }) => {
      e.isQuizMode ? s("disableQuizMode") : s("enableQuizMode");
    },
    "quiz:toggle": ({ getters: s }) => {
      s.application.toggleQuizMode(ie.RIGHT_MENU);
    },
    "viewZone:centered-toggle": ({ getters: s }, e) => {
      s.application.toggleViewzone(
        s.application.getCenter(),
        e
      );
    },
    "viewZone:toggle": ({ getters: s }, e) => {
      s.application.toggleViewzone(e);
    },
    "viewZone:show": ({ getters: s }, { coords: e, placement: t }) => {
      s.viewZoneEnabled || s.application.toggleViewzone(e, t);
    },
    "viewZone:refreshState": ({ commit: s, getters: e }) => {
      e.viewZoneEnabled ? s("disableViewZone") : s("enableViewZone");
    },
    "hide-point-feature:toggle": ({ getters: s }) => {
      s.application.toggleFeatureHidePointWithoutLabel();
    },
    "contrast:update"({ commit: s, getters: e }) {
      s("contrast:update", e.application.getContrasts(e.interfaceLanguage));
    },
    "filter:update"({ commit: s }) {
      s("filter:update");
    },
    "min-font-size:change"({ getters: s }, e) {
      s.application.setMinFontSize(e);
    },
    "inverse-scroll:toggle"({ commit: s }) {
      s("inverse-scroll:toggle");
    },
    "pin:toggle"({ getters: s }) {
      s.application.togglePinMode();
    },
    "pin:refreshState"({ commit: s, getters: e }) {
      e.pinModeEnabled ? s("disablePinMode") : s("enablePinMode");
    },
    "application:set-cover-image"({ commit: s, getters: e }) {
      s("application:set-cover-image", e.application.getCoverImage());
    },
    "application:set-background-color"({ commit: s, getters: e }) {
      s("application:set-background-color", e.application.backgroundColor());
    },
    "language:update-current"({ commit: s, getters: e }) {
      const t = e.application.getCurrentLanguage();
      s("language:update-current", lr[t]);
    },
    "application:reverse-scroll-update"({ commit: s, getters: e }) {
      s("application:reverse-scroll-update", e.application.isScrollInverse());
    },
    "application:update-mode-series"({ commit: s, getters: e }) {
      s("application:set-mode-series", e.application.isModeFullSeries());
    },
    "application:set-interface-language"({ commit: s }, e) {
      s("application:set-interface-language", e);
    },
    "structure:blacklist"({ getters: s }, { structure_id: e, source: t }) {
      s.application.blacklist(e, t);
    },
    "structure:whitelist"({ getters: s }, e) {
      s.application.whitelist(e);
    },
    "structure:clear"({ getters: s }) {
      s.application.clearAllHiddenStructures();
    },
    "redirect:to"(s, e) {
      typeof e < "u" && (h.isEmbed() ? window.top.location.href = `${window.top.location.origin}/${h.getSiteAccess()}/${e}` : window.location.href = `${window.location.origin}/${h.getSiteAccess()}/${e}`);
    },
    "gallery:click-image"({ getters: s, dispatch: e }, t) {
      e("slice:notification", ie.MODULE_GALLERY), s.application.publish(z.ui.MODULE_GALLERY.CLICK_IMAGE, { sliceIndex: t });
    },
    "gallery-bottom:image-click"({ getters: s, dispatch: e }, t) {
      e("slice:notification", ie.BOTTOM_GALLERY), s.application.publish(z.ui.BOTTOM_GALLERY.CLICK_IMAGE, { relativeSliceIndex: t });
    },
    "gallery-structure:image-click"({ getters: s, dispatch: e }, { sliceIndex: t, moduleName: i }) {
      e("slice:notification", ie.STRUCTURE_GALLERY), s.application.publish(z.ui.PANEL_STRUCTURE.CLICK_IMAGE_STRUCTURE_GALLERY, {
        sliceIndex: t,
        moduleName: i
      });
    },
    "application:panel-structure-open"({ getters: s }, e) {
      s.application.publish(z.ui.PANEL_STRUCTURE.OPEN, e);
    },
    "application:search-click"({ getters: s }, { searchText: e }) {
      s.application.publish(z.ui.VIEWER.SEARCH, { searchText: e });
    },
    "contrast:update-other-series-have-more-than-one-contrast"({ getters: s, commit: e }) {
      e(
        "contrast:set-other-series-have-more-than-one-contrast",
        s.application.otherSeriesHaveMoreThanOneContrast()
      );
    },
    "send-notification"({ getters: s }, e) {
      typeof e == "string" ? s.application.publish(e) : typeof e == "object" && typeof e.notification == "string" && (typeof e.args == "object" ? s.application.publish(e.notification, e.args) : s.application.publish(e.notification));
    },
    saveImage({ getters: s }) {
      s.application.behave("saveImage");
    },
    "font-size:update"({ getters: s, commit: e }) {
      e("font-size:update", s.application.getFontSize());
    },
    "font-size:manual"({ getters: s }) {
      s.application.setFontSizeManual();
    },
    "font-size:auto"({ getters: s, dispatch: e }) {
      s.application.setFontSizeAuto(), e("font-size:notification", s.getFontSize);
    },
    "font-size:set"({ getters: s }, e) {
      s.application.setFontSize(e);
    },
    "font-size:notification"({ getters: s }, e) {
      s.application.publish(z.ui.VIEWER.MIN_FONT_UPDATE, {
        auto: s.application.data.fontSizeAuto,
        fontSize: e
      });
    },
    "theme-switch-notification"({ getters: s }, e) {
      s.application.publish(z.ui.SETTINGS.CHANGE_THEME, { isDarkMode: e });
    },
    reset({ dispatch: s }) {
      const { ui: e } = z;
      s("send-notification", e.SETTINGS.RESET);
    }
  }
}, Wv = {
  namespaced: !0,
  state: () => ({
    currentInteraction: null
  }),
  getters: {
    currentInteraction: (s) => s.currentInteraction
  },
  mutations: {
    changeInteraction(s, e) {
      this.getters["anatomy/application"].selectInteraction(e);
    },
    updateInteraction(s) {
      const e = this.getters["anatomy/application"];
      s.currentInteraction = e.getCurrentInteraction();
    }
  },
  actions: {
    "interaction:change"({ commit: s }, e) {
      s("changeInteraction", e);
    },
    // 'interaction:change': {
    //     root: true,
    //     handler: ({ commit }, interaction) => {
    //         commit('changeInteraction', interaction);
    //     }
    // },
    "interaction:update": ({ commit: s }) => {
      s("updateInteraction");
    }
  }
}, Zv = {
  namespaced: !0,
  state: () => ({
    crossReferences: [],
    crossReferencesIndicators: []
  }),
  getters: {
    "cross-references": (s) => s.crossReferences,
    "cross-references-indicators": (s) => s.crossReferencesIndicators,
    application: (s, e, t, i) => i["anatomy/application"]
  },
  mutations: {
    setCrossReferences(s, e) {
      s.crossReferences = e;
    },
    setDrawIndicators(s, e) {
      s.crossReferencesIndicators = e;
    }
  },
  actions: {
    "cross-references:get": ({ commit: s, getters: e, rootGetters: t }) => new Promise((i) => {
      e.application.getCrossReferences(t["anatomy/interfaceLanguage"]).then((r) => {
        if (r === null)
          return;
        const n = t["anatomy/currentSeries"];
        r.series_id === n.id ? (s("setCrossReferences", r.crossReferences), i(r.crossReferences)) : i([]);
      });
    }),
    "cross-references:draw-indicators": ({ commit: s, getters: e }) => {
      const t = e.application.getCrossReferencesIndicators();
      s("setDrawIndicators", t);
    }
  }
}, we = {
  default: {
    createScrollOption() {
      return {
        iconType: "svg",
        iconSrc: "ScrollSVG",
        translationKey: "context-menu.scroll",
        id: "select-scroll",
        uuid: crypto.randomUUID(),
        position: 0,
        shortcutName: "scroll"
      };
    },
    createPanOption() {
      return {
        iconType: "svg",
        iconSrc: "PanSVG",
        translationKey: "context-menu.pan",
        id: "select-pan",
        uuid: crypto.randomUUID(),
        position: 1,
        shortcutName: "pan"
      };
    },
    createZoomOption() {
      return {
        iconType: "svg",
        iconSrc: "ZoomSVG",
        translationKey: "context-menu.zoom",
        id: "select-zoom",
        uuid: crypto.randomUUID(),
        position: 2,
        shortcutName: "zoom"
      };
    },
    rotateLeftOption() {
      return {
        iconType: "svg",
        iconSrc: "RotationLeftSVG",
        translationKey: "context-menu.rotate-left",
        id: "select-rotation-left",
        uuid: crypto.randomUUID(),
        position: 3
      };
    },
    rotateRightOption() {
      return {
        iconType: "svg",
        iconSrc: "RotationRightSVG",
        translationKey: "context-menu.rotate-right",
        id: "select-rotation-right",
        uuid: crypto.randomUUID(),
        position: 4
      };
    },
    flipHorizontalOption() {
      return {
        iconType: "svg",
        iconSrc: "VerticalFlipSVG",
        translationKey: "context-menu.flip-horizontal",
        id: "select-flip-vertical",
        uuid: crypto.randomUUID(),
        position: 5
      };
    },
    flipVerticalOption() {
      return {
        iconType: "svg",
        iconSrc: "HorizontalFlipSVG",
        translationKey: "context-menu.flip-vertical",
        id: "select-flip-horizontal",
        uuid: crypto.randomUUID(),
        position: 6
      };
    },
    toggleHiddenStructures() {
      return {
        iconType: "svg",
        iconSrc: "ShowSVG",
        translationKey: "context-menu.toggleVisibility",
        id: "select-show-hide-structure",
        uuid: crypto.randomUUID(),
        position: 7,
        subMenu: !0
      };
    },
    divider() {
      return {
        id: "divider",
        uuid: crypto.randomUUID(),
        position: -2,
        type: "divider"
      };
    },
    resetOption() {
      return {
        iconType: "svg",
        iconSrc: "ResetSettingsSVG",
        translationKey: "context-menu.reset",
        id: "select-reset",
        uuid: crypto.randomUUID(),
        position: -1,
        shortcutName: "reset"
      };
    }
  },
  viewzoneOption(s = null) {
    return {
      iconType: "svg",
      iconSrc: "ViewZoneSVG",
      translationKey: "context-menu.viewzone",
      id: "select-viewzone",
      uuid: crypto.randomUUID(),
      parameter: s === null ? "mousePosition" : s,
      position: -4,
      shortcutName: "viewzone"
    };
  },
  createHideStructureOption(s, e) {
    return {
      iconType: "svg",
      iconSrc: "HideSVG",
      translationKey: "context-menu.hide",
      id: "hide-structure",
      uuid: crypto.randomUUID(),
      parameter: s,
      position: 8,
      disabled: e
    };
  },
  createShowStructureOption(s, e) {
    return {
      iconType: "svg",
      iconSrc: "ShowSVG",
      translationKey: "context-menu.show",
      id: "show-structure",
      uuid: crypto.randomUUID(),
      parameter: s,
      position: 8,
      disabled: e
    };
  },
  createIsolateStructureOption(s, e) {
    const t = e.services.structure.findByTaxonKey(s.taxon_key), i = e.standardGetLabelText(s.taxon_key);
    return {
      iconType: "img",
      promiseSrc: () => e.getIcon(t.icon_id),
      translationKey: "context-menu.isolate-structure",
      translationParam: i,
      id: "isolate-structure",
      uuid: crypto.randomUUID(),
      parameter: {
        structure_id: t.id,
        preferredTaxonKey: s.taxon_key,
        source: Ke.RIGHT_CLICK
      },
      position: 9
    };
  },
  createClearIsolateStructureOption(s, e) {
    const t = e.standardGetLabelText(s.taxon_key), i = e.services.structure.findByTaxonKey(s.taxon_key);
    return {
      iconType: "img",
      promiseSrc: () => e.getIcon(i.icon_id),
      translationKey: "context-menu.unselect",
      translationParam: t,
      uuid: crypto.randomUUID(),
      id: "clear-isolate-structure",
      position: 9
    };
  },
  createFocusOnFilterOptions(s, e, t) {
    const i = t.services.filter.findById(s), r = t.services.translator.getTranslation(i.name_id, V.NAMESPACE.UI);
    return {
      iconType: "img",
      promiseSrc: () => t.getFilterIcon(s),
      translationKey: "context-menu.select",
      translationParam: r,
      id: "focus-filter",
      uuid: crypto.randomUUID(),
      parameter: {
        filter_id: s,
        taxonKey: e,
        source: Ke.RIGHT_CLICK
      },
      position: 10
    };
  },
  createBlurFilterOptions(s, e) {
    const t = e.services.filter.findById(s), i = e.services.translator.getTranslation(t.name_id, V.NAMESPACE.UI);
    return {
      iconType: "img",
      promiseSrc: () => e.getFilterIcon(s),
      translationKey: "context-menu.unselect",
      translationParam: i,
      uuid: crypto.randomUUID(),
      id: "blur-filter",
      position: 10
    };
  },
  createStructurePageLinkOption(s, e, t) {
    return {
      iconType: "svg",
      iconSrc: "tree-structureSVG",
      translationKey: "context-menu.show-structure-information",
      id: "structure-page-link",
      uuid: crypto.randomUUID(),
      parameter: `${F.baseURL}/${h.getSiteAccess()}/api/${e}/redirect/structure-page/${s.ta_id}/${s.taxon_id}/${t}`,
      position: -3
    };
  }
};
function Xv(s, e, t) {
  const i = s.getIsolatedStructureID();
  return i !== null && s.services.structure.find({ id: i }).some((n) => n.getTaxonKey() === e) || t;
}
const Qv = {
  namespaced: !0,
  state: () => ({
    options: [],
    visibility: !1
  }),
  getters: {
    options: (s) => s.options,
    visibility: (s) => s.visibility
  },
  mutations: {
    "set-options"(s, e = []) {
      s.options = e;
    },
    "set-visibility"(s, e = !1) {
      s.visibility = e;
    }
  },
  actions: {
    "perform:select-zoom"({ dispatch: s }) {
      s("action/interaction:change", ke.ZOOM, { root: !0 });
    },
    "perform:select-pan"({ dispatch: s }) {
      s("action/interaction:change", ke.PAN, { root: !0 });
    },
    "perform:select-scroll"({ dispatch: s }) {
      s("action/interaction:change", ke.SCROLL, { root: !0 });
    },
    "perform:select-rotation-left"({ dispatch: s }) {
      s("anatomy/image:rotate", -90, { root: !0 });
    },
    "perform:select-rotation-right"({ dispatch: s }) {
      s("anatomy/image:rotate", 90, { root: !0 });
    },
    "perform:select-flip-vertical"({ dispatch: s }) {
      s("anatomy/image:flip", Je.VERTICAL, { root: !0 });
    },
    "perform:select-flip-horizontal"({ dispatch: s }) {
      s("anatomy/image:flip", Je.HORIZONTAL, { root: !0 });
    },
    "perform:select-reset"({ dispatch: s }) {
      s("anatomy/reset", {}, { root: !0 });
    },
    "perform:select-viewzone"({ dispatch: s }, e) {
      s("anatomy/viewZone:show", {
        coords: e,
        placement: ie.RIGHT_CLICK
      }, { root: !0 });
    },
    "perform:hide-structure"({ rootGetters: s, dispatch: e }, t) {
      s["anatomy/application"].hasFeature("blacklist-structure") && e("anatomy/structure:blacklist", {
        structure_id: t,
        source: Ke.RIGHT_CLICK
      }, { root: !0 });
    },
    "perform:show-structure"({ rootGetters: s, dispatch: e }, t) {
      s["anatomy/application"].hasFeature("blacklist-structure") && e("anatomy/structure:whitelist", t, { root: !0 });
    },
    "perform:isolate-structure"({ rootGetters: s }, {
      structure_id: e,
      preferredTaxonKey: t,
      source: i
    }) {
      s["anatomy/application"].isolateStructure(i, e, t);
    },
    "perform:clear-isolate-structure"({ rootGetters: s }) {
      s["anatomy/application"].cleanIsolate();
    },
    "perform:focus-filter"({ rootGetters: s }, {
      filter_id: e,
      taxonKey: t,
      source: i
    }) {
      const r = s["anatomy/application"];
      r.services.filter.focus([e]), r.publish(z.structure.FILTER, {
        taxonKey: t,
        source: i
      });
    },
    "perform:blur-filter"({ rootGetters: s }) {
      s["anatomy/application"].services.filter.blur();
    },
    "perform:structure-page-link"(s, e) {
      window.open(e, "_blank");
    },
    async refresh({ dispatch: s, commit: e }) {
      const t = [].concat(
        await s("get-default"),
        await s("get-structure-hover-options"),
        await s("get-point-hover-options")
      );
      t.sort((r, n) => r?.position - n?.position);
      const i = t.findLastIndex((r) => r?.position < 0);
      t.push(...t.splice(0, i + 1)), e("set-options", t);
    },
    async "get-default"({ rootGetters: s, dispatch: e }) {
      const t = s["anatomy/application"], i = t.getPointsStructureHovered(), r = t.getPointHovered();
      return i.length < 1 && r === null ? Promise.all(Object.values(we.default).map(async (n) => (typeof n == "function" && (n = await n()), n))) : [
        await e("load-viewzone", i.length > 0 ? i[0] : null),
        we.default.divider(),
        we.default.resetOption()
      ];
    },
    "get-point-hover-blacklist-options"({ rootGetters: s }, e) {
      const t = s["anatomy/application"], i = t.services.structure.findByTaxonKey(e.taxon_key), r = Xv(t, e.taxon_key, s["anatomy/viewZoneEnabled"]);
      return t.hasFeature("blacklist-structure") ? s["anatomy/isBlacklistedStructure"](i.id) ? [we.createShowStructureOption(i.id, r)] : [we.createHideStructureOption(i.id, r)] : [];
    },
    "get-taxon-hover-structure-page"({ rootGetters: s }, e) {
      const t = [], i = s["anatomy/application"];
      return t.push(we.createStructurePageLinkOption(e, i.application_id, s["anatomy/currentLanguageId"]())), t;
    },
    "get-point-hover-isolate-structure-option"({ rootGetters: s }, e) {
      const t = [], i = s["anatomy/application"], r = i.getIsolatedStructureID();
      let n = !1;
      return r !== null && i.services.structure.find({ id: r }).forEach((o) => {
        o.getTaxonKey() === e.taxon_key && (n = !0);
      }), n || t.push(we.createIsolateStructureOption(e, i)), r !== null && t.push(we.createClearIsolateStructureOption(e, i)), t;
    },
    "get-point-hover-filter-option"({ rootGetters: s }, e) {
      const t = [], i = s["anatomy/application"], r = e.filter_id, n = i.services.filter.getCurrent();
      return n.includes(r) && n.length === 1 ? t.push(we.createBlurFilterOptions(r, i)) : t.push(we.createFocusOnFilterOptions(r, e.taxon_key, i)), t;
    },
    async "get-point-hover-options"({ dispatch: s, rootGetters: e }) {
      const i = e["anatomy/application"].getPointHovered();
      let r = [];
      return i !== null && (r = r.concat(
        await s("get-point-hover-isolate-structure-option", i),
        await s("get-point-hover-filter-option", i),
        await s("get-taxon-hover-structure-page", i),
        await s("get-point-hover-blacklist-options", i)
      )), r;
    },
    async "get-structure-hover-options"({ dispatch: s, rootGetters: e }) {
      const i = e["anatomy/application"].getPointsStructureHovered();
      let r = [];
      if (i.length > 0) {
        const n = i[0];
        r = r.concat(
          await s("get-point-hover-isolate-structure-option", n),
          await s("get-point-hover-filter-option", n),
          await s("get-taxon-hover-structure-page", n),
          await s("get-point-hover-blacklist-options", n)
        );
      }
      return r;
    },
    "load-viewzone"({ rootGetters: s }, e) {
      const t = s["anatomy/application"];
      let i = we.viewzoneOption();
      if (e !== null) {
        const r = J.getOne();
        r.setCoords(e.x, e.y), t.components.pointsCanvas.applyLocalTransformationToPoint(r), i = we.viewzoneOption({
          x: r.x,
          y: r.y
        }), J.recycle(r);
      }
      return i;
    },
    open({ dispatch: s, commit: e }) {
      s("refresh").then(() => {
        e("set-visibility", !0);
      });
    },
    close({ commit: s }) {
      s("set-visibility", !1);
    }
  }
}, Kv = {
  close: {
    iconType: "font",
    iconSrc: "❌",
    translationKey: "context-menu.close",
    id: "close",
    default: !0,
    uuid: crypto.randomUUID()
  }
}, qv = {
  namespaced: !0,
  state: () => ({
    options: [],
    visibility: !1,
    widgetVisibility: !0
  }),
  getters: {
    options: (s) => s.options,
    visibility: (s) => s.visibility,
    widgetVisibility: (s) => s.widgetVisibility
  },
  mutations: {
    "set-options"(s, e = []) {
      s.options = e;
    },
    "set-visibility"(s, e = !1) {
      s.visibility = e;
    },
    "set-widget-visibility"(s, e = !1) {
      s.widgetVisibility = e;
    }
  },
  actions: {
    "perform:close"({ commit: s, dispatch: e }) {
      G.add(Q.ORIENTATION, !1), s("set-widget-visibility", !1), e("orientation:status-change", !1);
    },
    "perform:open"({ commit: s, dispatch: e }) {
      G.add(Q.ORIENTATION, !0), s("set-widget-visibility", !0), e("orientation:status-change", !0);
    },
    async refresh({ dispatch: s, commit: e }) {
      const t = await s("get-default");
      e("set-options", t);
    },
    "get-default"() {
      return Object.values(Kv).filter((s) => s.default === !0);
    },
    open({ dispatch: s, commit: e }) {
      s("refresh").then(() => {
        e("set-visibility", !0);
      });
    },
    close({ commit: s }) {
      s("set-visibility", !1);
    },
    "orientation:status-change"({ rootGetters: s }, e) {
      s["anatomy/application"].publish(z.ui.VIEWER.ORIENTATION, { state: e });
    }
  }
}, Jv = {
  namespaced: !0,
  state: () => ({
    menuIsOpen: !1,
    menuIsPinned: !1,
    displayFeaturePremium: !1,
    shortcutPanelIsOpen: !1,
    displayCrossReferencesPanel: {
      display: !1,
      saveState: !0
    },
    galleryLeftIsOpen: !1,
    canDisplayCrossRefButton: !1,
    structurePanelIsOpen: !1,
    structurePanelActiveTaxonKey: null,
    menuWidth: 0
  }),
  getters: {
    menuIsOpen: (s) => s.menuIsOpen,
    menuIsPinned: (s) => s.menuIsPinned,
    displayFeaturePremium: (s) => s.displayFeaturePremium,
    shortcutPanelIsOpen: (s) => s.shortcutPanelIsOpen,
    displayCrossReferencesPanel: (s) => s.displayCrossReferencesPanel,
    galleryLeftIsOpen: (s) => s.galleryLeftIsOpen,
    canDisplayCrossRefButton: (s) => s.canDisplayCrossRefButton,
    structurePanelIsOpen: (s) => s.structurePanelIsOpen,
    structurePanelActiveTaxonKey: (s) => s.structurePanelActiveTaxonKey,
    "menu-width": (s) => s.menuWidth,
    activeLeftPanel: (s) => s.structurePanelIsOpen ? "structure-panel" : s.displayCrossReferencesPanel.display ? "cross-references" : "none"
  },
  mutations: {
    "menu:pin"(s, e) {
      s.menuIsPinned = e;
    },
    "menu:open"(s, e) {
      s.menuIsOpen = e;
    },
    "feature-premium:display"(s) {
      s.displayFeaturePremium = !0;
    },
    "feature-premium:hide"(s) {
      s.displayFeaturePremium = !1;
    },
    "shortcut-panel:display"(s) {
      s.shortcutPanelIsOpen = !0;
    },
    "shortcut-panel:hide"(s) {
      s.shortcutPanelIsOpen = !1;
    },
    "cross-references-panel:hide"(s, e) {
      s.displayCrossReferencesPanel = {
        display: !1,
        saveState: e
      };
    },
    "cross-references-panel:show"(s, e) {
      s.displayCrossReferencesPanel = {
        display: !0,
        saveState: e
      };
    },
    "gallery-left:show"(s) {
      s.galleryLeftIsOpen = !0;
    },
    "gallery-left:hide"(s) {
      s.galleryLeftIsOpen = !1;
    },
    "cross-references-button:display"(s) {
      s.canDisplayCrossRefButton = !0;
    },
    "cross-references-button:hide"(s) {
      s.canDisplayCrossRefButton = !1;
    },
    "structure-panel:hide"(s) {
      s.structurePanelIsOpen = !1, s.structurePanelActiveTaxonKey = null;
    },
    "structure-panel:display"(s, e) {
      s.structurePanelIsOpen = !0, s.structurePanelActiveTaxonKey = e;
    },
    "set-width"(s, e) {
      s.menuWidth = e;
    }
  },
  actions: {
    /**
     *
     * @param context vuex
     * @param [override] {boolean} a value to set the pin state of the menu, toggles the current state if absent
     */
    "menu-pin:toggle"({
      commit: s,
      getters: e,
      rootGetters: t
    }, i) {
      const r = i ?? !e.menuIsPinned;
      s("menu:pin", r);
      const n = t["anatomy/application"];
      n && (n.data.menuIsPinned = r, n.publish(z.ui.VIEWER.MENU_STATE_CHANGED, { isPinned: r }));
    },
    /**
    *
    * @param context vuex
    * @param [override] {boolean} a value to set the menu's open state, toggles the current state if absent
    */
    "menu:toggle"({ commit: s, getters: e }, t) {
      const i = t ?? !e.menuIsOpen;
      s("menu:open", i);
    },
    "feature-premium:display"({ commit: s }) {
      s("feature-premium:display");
    },
    "feature-premium:hide"({ commit: s }) {
      s("feature-premium:hide");
    },
    "shortcut-panel:display"({ commit: s, rootGetters: e }) {
      s("shortcut-panel:display"), e["anatomy/application"].publish(z.ui.SETTINGS.DISPLAY_SHORTCUTS);
    },
    "shortcut-panel:hide"({ commit: s }) {
      s("shortcut-panel:hide");
    },
    "cross-references:toggle"({ commit: s, getters: e }, t = !0) {
      e.displayCrossReferencesPanel.display ? s("cross-references-panel:hide", t) : s("cross-references-panel:show", t);
    },
    "cross-references:notification"({ getters: s, rootGetters: e }, t) {
      e["anatomy/application"].publish(z.ui.VIEWER.CROSS_REFERENCES, {
        placement: t,
        state: s.displayCrossReferencesPanel.display
      });
    },
    "gallery-left:show"({ commit: s }) {
      s("gallery-left:show");
    },
    "gallery-left:hide"({ commit: s }) {
      s("gallery-left:hide");
    },
    "cross-references-button:authorize-to-display"({ commit: s }, e) {
      s(e ? "cross-references-button:display" : "cross-references-button:hide");
    },
    "structure-panel:toggle"({ commit: s, getters: e }, t) {
      e.structurePanelIsOpen ? s("structure-panel:hide") : s("structure-panel:display", t);
    },
    "set-width"({ commit: s }, e) {
      s("set-width", e);
    }
  }
}, e0 = {
  namespaced: !0,
  state: () => ({
    shortcutsList: []
  }),
  getters: {
    shortcutsList: (s) => s.shortcutsList,
    getShortcutKeyByName: (s) => (e) => {
      const t = s.shortcutsList.find((i) => i.name === e);
      return typeof t > "u" ? null : typeof t.specificKey < "u" ? t.specificKey : t.key;
    }
  },
  mutations: {
    "set-shortcuts"(s, e) {
      s.shortcutsList = e;
    },
    "add-shortcut"(s, e) {
      s.shortcutsList.push(e);
    }
  },
  actions: {
    "refresh-shortcuts"({ commit: s }) {
      const e = xr.flatMap((t) => typeof t.shortcutKey.components < "u" && t.shortcutKey.components.length > 0 ? t.shortcutKey.components.map((i) => ({
        name: t.name,
        translationKey: t.translationKey,
        component: i
      })) : t.shortcutKey.specificKey ? {
        name: t.name,
        translationKey: t.translationKey,
        key: t.shortcutKey.specificKey
      } : t.shortcutKey.keys.split(Rr).map((i) => ({
        name: t.name,
        translationKey: t.translationKey,
        key: i
      })));
      s("set-shortcuts", Object.freeze(e));
    },
    "add-shortcut"({ commit: s }, e) {
      s("add-shortcut", e);
    }
  }
}, t0 = {
  namespaced: !0,
  state: () => ({
    viewer: {
      height: null,
      width: null,
      top: 0,
      left: 0
    },
    container: {
      height: null,
      width: null,
      marginLeft: 0
    },
    offsetSizeContainer: 0
  }),
  getters: {
    "viewer-height": (s) => s.viewer.height,
    "viewer-width": (s) => s.viewer.width,
    "container-margin-left": (s) => s.container.marginLeft,
    "viewer-top": (s) => s.viewer.top,
    "viewer-left": (s) => s.viewer.left,
    "viewer-offset-size": (s) => s.offsetSizeContainer,
    "container-width": (s) => s.container.width,
    "container-height": (s) => s.container.height
  },
  mutations: {
    "viewer:set-width"(s, e) {
      s.viewer.width = e;
    },
    "viewer:set-height"(s, e) {
      s.viewer.height = e;
    },
    "container:set-margin-left"(s, e) {
      s.container.marginLeft = e;
    },
    "viewer:set-top"(s, e) {
      s.viewer.top = e;
    },
    "viewer:set-left"(s, e) {
      s.viewer.left = e;
    },
    "viewer:set-offset-size"(s, e) {
      s.offsetSizeContainer = e;
    },
    "container:set-width"(s, e) {
      s.container.width = e;
    },
    "container:set-height"(s, e) {
      s.container.height = e;
    }
  },
  actions: {
    "viewer:set-size"({ commit: s }, { width: e, height: t }) {
      s("viewer:set-width", e), s("viewer:set-height", t);
    },
    "container:set-margin"({ commit: s }, { marginLeft: e }) {
      s("container:set-margin-left", e), h.viewerContainer.marginLeft = e;
    },
    "viewer:set-top"({ commit: s }, e) {
      s("viewer:set-top", e);
    },
    "viewer:set-left"({ commit: s }, e) {
      s("viewer:set-left", e);
    },
    "viewer:set-offset-size"({ commit: s }, e) {
      s("viewer:set-offset-size", e);
    },
    "container:set-size"({ commit: s }, { width: e, height: t }) {
      typeof e < "u" && (s("container:set-width", e), h.viewerContainer.width = e), typeof t < "u" && (h.viewerContainer.height = t, s("container:set-height", t));
    }
  }
}, s0 = {
  namespaced: !0,
  state: () => ({
    displayDialog: !1,
    title: "",
    message: "",
    displayCancelButton: !1,
    confirmCallback: null,
    cancelCallback: null,
    input: "",
    inputDialog: !1,
    displayInputError: !1
  }),
  getters: {
    "display-dialog": (s) => s.displayDialog,
    title: (s) => s.title,
    message: (s) => s.message,
    "display-cancel-button": (s) => s.displayCancelButton,
    input: (s) => s.input,
    "display-input": (s) => s.inputDialog,
    "display-input-error": (s) => s.displayInputError
  },
  mutations: {
    "title:set"(s, e) {
      s.title = e;
    },
    "message:set"(s, e) {
      s.message = e;
    },
    "cancel-button:display"(s) {
      s.displayCancelButton = !0;
    },
    "dialog:display"(s) {
      s.displayDialog = !0;
    },
    "dialog:hide"(s) {
      s.displayDialog = !1;
    },
    "inputDialog:set"(s, e) {
      s.inputDialog = e;
    },
    reset(s) {
      s.title = "", s.message = "", s.displayCancelButton = !1, s.cancelCallback = null, s.confirmCallback = null, s.input = "", s.inputDialog = !1, s.displayInputError = !1;
    },
    "cancel:set-callback"(s, e) {
      s.cancelCallback = e;
    },
    "confirm:set-callback"(s, e) {
      s.confirmCallback = e;
    },
    "input:set"(s, e) {
      s.input = e;
    },
    "inputError:display"(s) {
      s.displayInputError = !0;
    }
  },
  actions: {
    display({ commit: s }, {
      title: e,
      message: t,
      displayCancelButton: i = !1,
      confirmCallback: r = null,
      cancelCallback: n = null,
      inputDialog: a = !1
    }) {
      s("title:set", e), s("message:set", t), s("inputDialog:set", a), i && s("cancel-button:display"), s("dialog:display"), r !== null && s("confirm:set-callback", r), n !== null && s("cancel:set-callback", n);
    },
    hide({ commit: s }) {
      s("dialog:hide"), s("reset");
    },
    confirm({ dispatch: s, state: e }) {
      e.confirmCallback !== null && typeof e.confirmCallback == "function" && e.confirmCallback(), s("hide");
    },
    cancel({ dispatch: s, state: e }) {
      e.cancelCallback !== null && typeof e.cancelCallback == "function" && e.cancelCallback(), s("hide");
    },
    displayError({ commit: s }) {
      s("inputError:display");
    }
  }
}, i0 = {
  namespaced: !0,
  state: () => ({
    images: /* @__PURE__ */ new Map()
  }),
  mutations: {
    "image:loaded"(s, e) {
      s.images.set(e, !0);
    },
    "image:unload"(s, e) {
      s.images.set(e, !1);
    },
    "update-list-images"(s, e) {
      for (let t = 0; t < e; t++)
        s.images.set(t, !1);
    }
  },
  actions: {
    "image:clear-all"({ commit: s, state: e, rootGetters: t }) {
      const i = t["anatomy/application"];
      e.images.forEach((r, n) => {
        const a = i.isSliceLoaded(n + 1);
        s(a ? "image:loaded" : "image:unload", n);
      });
    },
    "image:loaded"({ commit: s }, e) {
      s("image:loaded", e);
    },
    "set-images"({ commit: s }, e) {
      s("update-list-images", e);
    }
  }
};
class r0 {
  application = "";
  icon = "";
  taId = null;
  taxonId = null;
  structureId = null;
  label = {
    current: "",
    latin: ""
  };
  hierarchy = null;
  structuresLocations = [];
  description = {
    content: "",
    sources: ""
  };
  translationPicture = "";
  structurePageLink = "";
  latinSynonym = null;
  synonym = null;
  frAnc = null;
  latinEponym = null;
  eponym = null;
  acronym = null;
  relatedTerms = null;
  appLinks = [];
  constructor(e) {
    this.application = e.application, this.icon = e.icon, this.taId = e.ta_id, this.taxonId = e.taxon_id, this.structureId = e.structure_id, this.label = e.label, this.hierarchy = e.hierarchy, this.structuresLocations = e.structures_locations, this.description = e.description, this.translationPicture = e.translation_picture, this.structurePageLink = e.structure_page_link, this.latinSynonym = e.latin_synonym, this.synonym = e.synonym, this.frAnc = e.fr_anc, this.latinEponym = e.latin_eponym, this.eponym = e.eponym, this.acronym = e.acronym, this.relatedTerms = e.related_terms, this.appLinks = e.app_links;
  }
}
const n0 = {
  namespaced: !0,
  state: () => ({
    application: "",
    icon: "",
    taId: null,
    taxonId: null,
    structureId: null,
    label: {
      current: "",
      latin: ""
    },
    hierarchy: null,
    structuresLocations: [],
    description: {
      content: "",
      sources: ""
    },
    translationPicture: "",
    structurePageLink: "",
    latinSynonym: null,
    synonym: null,
    frAnc: null,
    latinEponym: null,
    eponym: null,
    acronym: null,
    relatedTerms: null,
    appLinks: []
  }),
  getters: {
    isLoaded: (s) => s.structureId !== null
  },
  mutations: {
    /**
     * @param state
     * @param structure {StructureDetailsModel}
     **/
    "fill-structure"(s, e) {
      for (let t in e)
        s.hasOwnProperty(t) && tt.set(s, t, e[t]);
    }
  },
  actions: {
    "fill-structure"({ commit: s, rootGetters: e }, t) {
      const i = h.getSiteAccess(), r = e["anatomy/application_id"], n = e["anatomy/currentLanguageId"](), a = h.isDarkMode() ? 1 : 0;
      return F.fetch(`${F.baseURL}/${i}/api/${r}/anatomical-parts/web/${t}/${n}/${a}`).then((o) => o.json()).then((o) => {
        s("fill-structure", new r0(o));
      });
    }
  }
}, cr = 15, a0 = {
  namespaced: !0,
  /** @return {StructureGalleryState} **/
  state: () => ({
    structuresLocations: [],
    hasRequestedData: !1,
    display: !1,
    isLoading: !1,
    structureId: null,
    imaiosCode: "",
    langId: null,
    moduleName: "",
    nbLoadedImages: 0,
    selectedSeries: -1,
    galleryOpened: !1,
    previewImagesLoaded: !1
  }),
  getters: {
    nbImages: (s) => s.structuresLocations.reduce((e, t) => e + t.nb_images, 0),
    isSameStructure: (s) => (e, t, i) => s.structureId === e && s.imaiosCode === t && s.langId === i,
    previewImages: (s) => s.structuresLocations.flatMap((e) => e.slices.map((t) => ({
      index: t.index,
      url: t.url,
      background: e.background
    }))).slice(0, cr),
    allImagesLoaded: (s) => s.nbLoadedImages === s.structuresLocations.reduce((e, t) => e + t.nb_images, 0),
    allPreviewImagesLoaded: (s, e) => s.hasRequestedData && (s.previewImagesLoaded || e.previewImages.length === 0),
    canSeeMoreImages: (s, e) => e.nbImages >= cr
  },
  mutations: {
    "structuresLocations:reset"(s) {
      s.structuresLocations = [], s.hasRequestedData = !1;
    },
    "fill-structures-locations"(s, { structuresLocations: e, imaiosCode: t, langId: i, structureId: r, moduleName: n }) {
      s.galleryOpened = !1, s.nbLoadedImages = 0, s.structuresLocations = e, s.imaiosCode = t, s.langId = i, s.structureId = r, s.moduleName = n, s.hasRequestedData = !0;
    },
    "imaiosCode:set"(s, e) {
      s.imaiosCode = e;
    },
    "moduleName:set"(s, e) {
      s.moduleName = e;
    },
    "langId:set"(s, e) {
      s.langId = e;
    },
    "structureId:set"(s, e) {
      s.structureId = e;
    },
    "selectedSeries:set"(s, e) {
      s.selectedSeries = e;
    },
    startLoading(s) {
      s.isLoading = !0;
    },
    stopLoading(s) {
      s.isLoading = !1;
    },
    display(s) {
      s.display = !0;
    },
    hide(s) {
      s.display = !1;
    },
    "nbLoadedImages:rest"(s) {
      s.nbLoadedImages = 0;
    },
    "nbLoadedImages:increment"(s) {
      s.nbLoadedImages += 1;
    },
    "gallery-opened"(s) {
      s.galleryOpened = !0;
    },
    "previewImagesLoaded:set"(s, e) {
      s.previewImagesLoaded = e;
    },
    reset(s) {
      s.structuresLocations = [], s.isLoading = !1, s.structureId = null, s.imaiosCode = "", s.langId = null, s.moduleName = "", s.selectedSeries = -1, s.galleryOpened = !1, s.nbLoadedImages = 0, s.hasRequestedData = !1;
    }
  },
  actions: {
    startLoading({ commit: s }) {
      s("startLoading");
    },
    stopLoading({ commit: s }) {
      s("stopLoading");
    },
    openGallery({ commit: s, dispatch: e }) {
      e("structure-in-other-modules-gallery/closeGallery", null, { root: !0 }), s("display");
    },
    fillStructuresLocations({ commit: s, rootGetters: e, state: t, getters: i }, { imaiosCode: r, structureId: n, limited: a = !1 }) {
      const o = e["anatomy/currentLanguageId"](), l = h.getSiteAccess(), c = e["anatomy/application_id"];
      if (i.isSameStructure(n, r, o) && t.galleryOpened || !i.canSeeMoreImages && t.display)
        return;
      const u = `${F.baseURL}/${l}/api/${c}/anatomical-parts/web/gallery/${r}/${n}/${o}`;
      return a && (s("structuresLocations:reset"), s("previewImagesLoaded:set", !1)), F.fetch(u + (a ? "/limited" : "")).then((m) => m.json()).then((m) => {
        const g = m.structures_locations.map((C) => (C.id = crypto.randomUUID(), C));
        s("fill-structures-locations", {
          structuresLocations: g,
          imaiosCode: m.imaios_code,
          langId: m.lang_id,
          structureId: m.structure_id,
          moduleName: m.module_name
        }), a || s("gallery-opened");
      });
    },
    selectSeries({ commit: s }, e) {
      s("selectedSeries:set", e);
    },
    closeGallery({ commit: s }) {
      s("hide");
    },
    imageLoaded({ commit: s }) {
      s("nbLoadedImages:increment");
    },
    setPreviewImagesLoaded({ commit: s }, e) {
      s("previewImagesLoaded:set", e);
    },
    reset({ commit: s }) {
      s("reset");
    }
  }
}, o0 = {
  namespaced: !0,
  /** @return {StructureInThisModuleGalleryState} **/
  state: () => ({
    structuresLocations: [],
    display: !1,
    structureId: null,
    imaiosCode: "",
    langId: null,
    moduleName: "",
    nbLoadedImages: 0
  }),
  getters: {
    nbImages: (s) => s.structuresLocations.length,
    structuresNotInCurrentModule(s, e, t) {
      const i = t.anatomy.module_id;
      return s.structuresLocations.filter((r) => r.imaios_code !== i);
    },
    getModulesExcludingCurrent: (s, e) => {
      const t = [], i = /* @__PURE__ */ new Set();
      for (const r of e.structuresNotInCurrentModule)
        i.has(r.imaios_code) || (t.push(r), i.add(r.imaios_code));
      return t;
    }
  },
  mutations: {
    "fill-structures-locations"(s, e) {
      s.structuresLocations = e;
    },
    "moduleName:set"(s, e) {
      s.moduleName = e;
    },
    display(s, { imaiosCode: e, langId: t, structureId: i }) {
      s.display = !0, s.imaiosCode = e, s.langId = t, s.structureId = i;
    },
    hide(s) {
      s.display = !1;
    },
    reset(s) {
      s.structuresLocations = [], s.nbLoadedImages = 0;
    }
  },
  actions: {
    openGallery({ commit: s, dispatch: e }, { imaiosCode: t, langId: i = null, structureId: r = null }) {
      e("structure-in-this-module-gallery/closeGallery", null, { root: !0 }), s("display", { imaiosCode: t, langId: i, structureId: r });
    },
    displayInOtherModuleGallery({ commit: s, dispatch: e, rootState: t }) {
      const i = t["structure-details"].structuresLocations, r = t.anatomy.module_id;
      i.length !== 0 && (s("reset"), e("openGallery", { imaiosCode: r }), s("fill-structures-locations", i.map((n) => (n.id = crypto.randomUUID(), n))));
    },
    closeGallery({ commit: s }) {
      s("hide"), s("reset");
    }
  }
};
tt.use(hr);
const pn = new hr.Store({
  state: {
    isLoading: !0,
    loadingMessage: ""
  },
  getters: {},
  mutations: {
    /**
     * @param {Object} state
     * @param {string} message
     */
    startLoading(s, e) {
      s.isLoading = !0, s.loadingMessage = e;
    },
    /**
     * @param {Object} state
     */
    stopLoading(s) {
      s.isLoading = !1, s.loadingMessage = "";
    },
    /**
     * @param {Object} state
     * @param {string} message
     */
    setLoadingMessage(s, e) {
      s.loadingMessage = e;
    }
  },
  actions: {
    applicationIsCreated({ commit: s }) {
      s("stopLoading");
    }
  },
  modules: {
    anatomy: Yv,
    action: Wv,
    menu: Jv,
    "cross-references": Zv,
    "core-context-menu": Qv,
    "orientation-context-menu": qv,
    shortcut: e0,
    viewer: t0,
    "dialog-popup": s0,
    image: i0,
    "structure-details": n0,
    "structure-in-this-module-gallery": a0,
    "structure-in-other-modules-gallery": o0
  }
}), l0 = { commons: `Es ist ein Fehler aufgetreten. Wenn der Fehler weiterhin auftritt, kontaktieren Sie uns bitte unter contact@imaios.com.
Fehlercode: {errorCode}`, title: "Fehler" }, c0 = { ok: "OK", cancel: "Abbrechen", "external-link-title": "Externer Link", "external-link-description": "Sie werden zu IMAIOS weitergeleitet.", input: { error: "Bitte geben Sie einen gültigen Wert ein" } }, u0 = { "no-results": "Keine Ergebnisse", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, d0 = { "all-series": "Alle Serien", "n-image-s": "{count} Bild(er)", series: "Serie" }, h0 = { main: { "section-title": "Menü" }, filter: { "show-all-structures": "Alle Strukturen anzeigen", "hide-all-structures": "Alle Strukturen verbergen", "section-title": "Anatomische Strukturen", "select-all": "Alle auswählen", "show-hidden-structures": "Versteckte Strukturen anzeigen", "show-all-overlays": "Alle Überlagerungen anzeigen", "hide-all-overlays": "Alle Überlagerungen verbergen" }, contrast: { no_contrast_for_this_series: "Kein Kontrast für diese Serie" }, favorites: { title: "Lesezeichen", add: "Lesezeichen hinzufügen", "add-message": "Speichern Sie diese Ansicht unter Ihren Lesezeichen" }, transformation: { "section-title": "Transformationen" }, series: { "section-title": "Serie", all: "Alle Serien", more: "Mehr", less: "Weniger" }, legend: { "section-title": "Beschriftungen", practice: "Übungsmodus", pins: "Stecknadeln", viewzone: "Teilweise Kennzeichnung", "min-font-size": "Mindestschriftgröße", "font-size": "Schriftgröße" }, display: { "section-title": "Anzeigemodus", description: "Menü Beschreibung", "dark-mode": "Dunkelmodus", "overlays-opacity": "Überlagerungsopazität", "high-quality": "Hohe Qualität", orientation: "Orientierung", "hide-point-without-label": "Punkte ohne Beschriftung ein-/ausblenden", "cross-references": "Querverweise anzeigen/ausblenden", screenshot: "Machen Sie einen Screenshot" }, language: { "section-title": "Sprache" }, "advanced-settings": { "section-title": "Erweiterte Einstellungen", "reset-settings": "Einstellungen zurücksetzen", "reverseScroll-settings": "In umgekehrter Richtung blättern", "shortcuts-panel": "Shortcuts anzeigen", share: { label: "Teilen", copied: "Erfolg" } } }, m0 = { "not-found": "Es gibt noch keine Beschreibung für dieses anatomischen Teil." }, f0 = { "not-available": "Für Internet Explorer nicht verfügbar", banner: { "upgrade-full-message": 'Verwenden Sie bitte einen anderen Browser, zum Beispiel  <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> oder <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Einige Funktionen werden in Internet Explorer nicht unterstützt", upgrade: "Bitte verwenden Sie einen anderen Browser wie beispielsweise", or: "oder" } }, p0 = { placeholder: "Suchen" }, g0 = { text: "Für diese Funktion ist ein Premium-Abonnement erforderlich", button: { subscribe: "Abonnieren", connect: "Anmelden" } }, v0 = { window: "Fenster", weightings: "Gewichtsfaktoren", default: "Kontrast" }, y0 = { loading: "Bitte warten..." }, E0 = {
  error: l0,
  dialog: c0,
  commons: u0,
  "context-menu": { zoom: "Vergrößern", pan: "Verschieben", scroll: "Scrollen", "rotate-left": "Um 90° gegen den Uhrzeigersinn drehen", "rotate-right": "Um 90° im Uhrzeigersinn drehen", "flip-horizontal": "Horizontal spiegeln", "flip-vertical": "Vertikal spiegeln", reset: "Zurücksetzen", viewzone: "Teilweise Kennzeichnung", hide: "Verbergen", show: "Anzeigen", "isolate-structure": "Isolieren: {param}", unselect: "Abwählen: {param}", select: "Auswählen: {param}", close: "Schließen", "show-structure-information": "Informationen zur Struktur anzeigen" },
  gallery: d0,
  menu: h0,
  description: m0,
  "premium-banner": { "label-required-premium": "Zur Freischaltung aller Funktionen ist ein Abonnement erforderlich", subscribe: "Abonnieren" },
  ie: f0,
  search: p0,
  premium: g0,
  contrast: v0,
  "keyboard-panel": { title: "Shortcuts", "reverse-scroll": "In umgekehrter Richtung blättern", viewzone: "Teilweise Kennzeichnung", practice: "Übungsmodus", "toggle-overlays": "Überlagerungen anzeigen/verbergen", "hide-labels": "Beschriftungen einblenden/ausblenden", "show-hidden-structures": "Versteckte Strukturen anzeigen", weightings: "Modalität", scroll: "Scrollen", zoom: "Vergrößern", pan: "Verschieben", reset: "Zurücksetzen", save: "Screenshot", fullscreen: "Vollbildmodus", "previous-image": "Vorheriges Bild", "next-image": "Nächstes Bild", "previous-series": "Vorherige Serie", "next-series": "Nächste Serie", cine: "Film" },
  loader: y0,
  "panel-structure": { "list-actions": { cancel_isolate: "Isolieren abbrechen", isolate: "Isolieren", hide: "Ausblenden", display: "Einblenden", select: "Auswählen", unselect: "Abwählen" } },
  "anatomical-parts": { gallery: { title: "Galerie", "in-this-module": "In diesem Modul", "in-other-modules": "In anderen Modulen", "image-one": "1 bild", "image-multiple": "{count} bilder", all: "Alle" }, description: { title: "Definition", "no-description": "Es gibt noch keine Beschreibung für dieses anatomischen Teil." }, hierarchy: { title: "Anatomische Hierarchie", eanatomy: { 1: "Anatomie des Menschen 1", 2: "Anatomie des Menschen 2", 3: "Anatomie des Menschen IMAIOS", 5: "Neuroanatomie des Menschen" }, vetanatomy: { 4: "Tieranatomie" }, underlying: { none: "Es gibt keine darunterliegende Struktur", title: "Darunterliegende Strukturen:" } }, translation: { title: "Übersetzung" }, "see-more": "Mehr anzeigen", "see-less": "Weniger anzeigen", "related-terms": { "latin-synonym": "Lateinisches Synonym:", "latin-eponym": "Lateinisches Eponym:", synonym: "Synonym:", eponym: "Namensgeber:", acronym: "Akronym:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Verwandte Bezeichnungen:" }, compare: { animal: "Vergleichende Anatomie bei Tieren", human: "Vergleichende Anatomie bei Menschen" } },
  "proxy-banner": { "update-config": 'Bitte wenden Sie sich an Ihren IT-Administrator, um die Proxy-Konfiguration aktualisieren zu lassen. Sie können auf diesen <a target="_blank" href="%link%">Artikel</a> verweisen, und Ihr IT-Administrator kann bei Bedarf auch Kontakt zu uns aufnehmen.' }
}, I0 = { commons: `An error has occurred, if the error persists please contact us at contact@imaios.com.
Error code: {errorCode}`, title: "Error" }, C0 = { ok: "OK", cancel: "Cancel", "external-link-title": "External link", "external-link-description": "You will be redirected to the IMAIOS website.", input: { error: "Please enter a valid value" } }, _0 = { "no-results": "No results", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, T0 = { "all-series": "All series", "n-image-s": "{count} Images", series: "Series" }, S0 = { main: { "section-title": "Menu" }, filter: { "show-all-structures": "Show all structures", "hide-all-structures": "Hide all structures", "section-title": "Anatomical Parts", "select-all": "Select all", "show-hidden-structures": "Show hidden structures", "show-all-overlays": "Show all overlays", "hide-all-overlays": "Hide all overlays" }, contrast: { no_contrast_for_this_series: "No contrast for this series" }, favorites: { title: "Bookmarks", add: "Add to bookmarks", "add-message": "Save this view to your bookmarks" }, transformation: { "section-title": "Transformations" }, series: { "section-title": "Series", all: "All series", more: "More", less: "Less" }, legend: { "section-title": "Labeling", practice: "Practice", pins: "Pins", viewzone: "Partial labeling", "min-font-size": "Minimum font size", "font-size": "Font size" }, display: { "section-title": "Display mode", description: "Description menu", "dark-mode": "Dark mode", "overlays-opacity": "Overlay opacity", "high-quality": "High quality", orientation: "Orientation", "hide-point-without-label": "Show/hide anatomical points without label", "cross-references": "Show/hide cross references", screenshot: "Take a screenshot" }, language: { "section-title": "Language" }, "advanced-settings": { "section-title": "Advanced settings", "reset-settings": "Reset settings", "reverseScroll-settings": "Reverse scroll", "shortcuts-panel": "Display shortcuts", share: { label: "Share", copied: "Copied!" } } }, b0 = { "not-found": "There is no description for this anatomical part yet." }, A0 = { "not-available": "Not available for Internet Explorer", banner: { "upgrade-full-message": 'Please use another browser such as  <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> or <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Some features are not supported on Internet Explorer", upgrade: "Please use another browser such as", or: "or" } }, w0 = { placeholder: "Search in this module" }, L0 = { text: "This feature requires a premium subscription", button: { subscribe: "Subscribe", connect: "Sign in" } }, O0 = { window: "Window", weightings: "Weightings", default: "Contrast" }, M0 = { loading: "Loading..." }, N0 = {
  error: I0,
  dialog: C0,
  commons: _0,
  "context-menu": { zoom: "Zoom", pan: "Pan", scroll: "Scroll", "rotate-left": "Rotate 90° counter clockwise", "rotate-right": "Rotate 90° clockwise", "flip-horizontal": "Flip horizontal", "flip-vertical": "Flip vertical", reset: "Reset", viewzone: "Partial labeling", hide: "Hide", show: "Show", toggleVisibility: "Show/Hide", "isolate-structure": "Isolate {param}", unselect: "Unselect {param}", select: "Select {param}", close: "Close", "show-cross-reference": "Show cross references", "hide-cross-reference": "Hide cross references", "show-structure-information": "Show structure information" },
  gallery: T0,
  menu: S0,
  description: b0,
  "premium-banner": { "label-required-premium": "A subscription is required to unlock all features", subscribe: "Subscribe" },
  ie: A0,
  search: w0,
  premium: L0,
  contrast: O0,
  "keyboard-panel": { title: "Shortcuts", "reverse-scroll": "Reverse scroll", viewzone: "Partial labelling", practice: "Practice", "toggle-overlays": "Show/hide overlays", "hide-labels": "Show/hide labels", "show-hidden-structures": "Show hidden structures", "show-hidden-cross-references": "Show/hide cross references", weightings: "Modality", scroll: "Scroll", zoom: "Zoom", pan: "Pan", reset: "Reset", save: "Screenshot", fullscreen: "Fullscreen", "previous-image": "Previous image", "next-image": "Next image", "previous-series": "Previous series", "next-series": "Next series", cine: "Cine" },
  loader: M0,
  "panel-structure": { "list-actions": { cancel_isolate: "Cancel isolate", isolate: "Isolate", hide: "Hide", display: "Show", select: "Select", unselect: "Unselect" } },
  "anatomical-parts": { gallery: { title: "Gallery", "in-this-module": "In this module", "in-other-modules": "In other modules", "image-one": "1 image", "image-multiple": "{count} images", all: "All" }, description: { title: "Definition", "no-description": "There is no description for this anatomical part yet." }, hierarchy: { title: "Anatomical hierarchy", eanatomy: { 1: "Human anatomy 1", 2: "Human anatomy 2", 3: "Human anatomy IMAIOS", 5: "Human neuroanatomy" }, vetanatomy: { 4: "Animal anatomy" }, underlying: { none: "There is no underlying structure", title: "Underlying structures:" } }, translation: { title: "Translation" }, "see-more": "See more", "see-less": "See less", "related-terms": { "latin-synonym": "Latin synonym:", "latin-eponym": "Latin eponym:", synonym: "Synonym:", eponym: "Eponym:", acronym: "Acronym:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Related terms:" }, compare: { animal: "Comparative anatomy in animals", human: "Comparative anatomy in humans" } },
  "proxy-banner": { "update-config": 'Please contact your IT administrator to update the proxy configuration. You can provide them with this <a target="_blank" href="%link%">article</a> and tell them to contact us if necessary.' }
}, R0 = { commons: `Se ha producido un error, si el error persiste por favor contáctenos en contact@imaios.com.
Código de error: {errorCode}`, title: "Error" }, x0 = { ok: "OK", cancel: "Cancelar", "external-link-title": "Enlace externo", "external-link-description": "Será redirigido a la página web de imaios.", input: { error: "Por favor ingrese un valor válido" } }, D0 = { "no-results": "Ningún resultado", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, P0 = { "all-series": "Todas las series", "n-image-s": "{count} Imágenes", series: "Series" }, k0 = { main: { "section-title": "Menú" }, filter: { "show-all-structures": "Mostrar todas las estructuras", "hide-all-structures": "Ocultar todas las estructuras", "section-title": "Estructuras anatómicas", "select-all": "Seleccionar todo", "show-hidden-structures": "Mostrar estructuras ocultas", "show-all-overlays": "Mostrar todas las superposiciones", "hide-all-overlays": "Ocultar todas las superposiciones" }, contrast: { no_contrast_for_this_series: "No hay contraste para esta série" }, favorites: { title: "Favoritos", add: "Agregar a favoritos", "add-message": "Guardar esta vista en favoritos" }, transformation: { "section-title": "Transformaciones" }, series: { "section-title": "Series", all: "Todas las series", more: "Más", less: "Menos" }, legend: { "section-title": "Etiquetas", practice: "Modo quiz", pins: "Marcadores", viewzone: "Etiquetado limitado", "min-font-size": "Tamaño mínimo del texto", "font-size": "Tamaño de fuente" }, display: { "section-title": "Modo de visualización", description: "Menú de descripción", "dark-mode": "Tema oscuro", "overlays-opacity": "Opacidad de las superposiciones", "high-quality": "Alta calidad", orientation: "Orientación", "hide-point-without-label": "Mostrar/ocultar puntos anatómicos sin etiqueta", "cross-references": "Mostrar/ocultar las referencias cruzadas", screenshot: "Tomar una captura de pantalla" }, language: { "section-title": "Idioma" }, "advanced-settings": { "section-title": "Ajustes avanzados", "reset-settings": "Restablecer configuración", "reverseScroll-settings": "Desplazamiento reverso", "shortcuts-panel": "Mostrar atajos", share: { label: "Compartir", copied: "Éxito" } } }, H0 = { "not-found": "Aún no hay descripción para esta estructura anatómica." }, F0 = { "not-available": "No disponible para Internet Explorer", banner: { "upgrade-full-message": 'Utilice otro navegador como <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>,<a href="https://google.com/chrome/" target="_blank">Google Chrome</a>o<a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Algunas funciones no son compatibles con Internet Explorer", upgrade: "Por favor utilice otro navegador como", or: "o" } }, z0 = { placeholder: "Buscar" }, B0 = { text: "Esta funcionalidad requiere una suscripción premium", button: { subscribe: "Suscribirse", connect: "Iniciar sesión" } }, $0 = { window: "Ventana", weightings: "Ponderación", default: "Contraste" }, U0 = { loading: "Cargando..." }, V0 = {
  error: R0,
  dialog: x0,
  commons: D0,
  "context-menu": { zoom: "Zoom", pan: "Mover", scroll: "Desplazar", "rotate-left": "Girar 90° en sentido antihorario", "rotate-right": "Girar 90° en sentido horario", "flip-horizontal": "Girar horizontalmente", "flip-vertical": "Girar verticalmente", reset: "Restablecer", viewzone: "Etiquetado limitado", hide: "Ocultar", show: "Mostrar", "isolate-structure": "Aislar {param}", unselect: "Deseleccionar {param}", select: "Seleccionar {param}", close: "Cerrar", "show-structure-information": "Mostrar información de la estructura" },
  gallery: P0,
  menu: k0,
  description: H0,
  "premium-banner": { "label-required-premium": "Se necesita una suscripción para desbloquear todas las funciones", subscribe: "Suscribirse" },
  ie: F0,
  search: z0,
  premium: B0,
  contrast: $0,
  "keyboard-panel": { title: "Atajos", "reverse-scroll": "Desplazamiento reverso", viewzone: "Etiquetado limitado", practice: "Modo quiz", "toggle-overlays": "Mostrar/ocultar superposiciones", "hide-labels": "Mostrar/ocultar etiquetas anatómicas", "show-hidden-structures": "Mostrar estructuras ocultas", weightings: "Modalidad", scroll: "Desplazar", zoom: "Zoom", pan: "Mover", reset: "Restablecer", save: "Captura de pantalla", fullscreen: "Pantalla completa", "previous-image": "Imagen anterior", "next-image": "Imagen siguiente", "previous-series": "Serie anterior", "next-series": "Serie siguiente", cine: "Animación" },
  loader: U0,
  "panel-structure": { "list-actions": { cancel_isolate: 'Cancelar modo "Aislar"', isolate: "Aislar", hide: "Ocultar", display: "Mostrar", select: "Seleccionar", unselect: "Deseleccionar" } },
  "anatomical-parts": { gallery: { title: "Galería", "in-this-module": "En este módulo", "in-other-modules": "En otros módulos", "image-one": "1 imagen", "image-multiple": "{count} imágenes", all: "Todo" }, description: { title: "Definición", "no-description": "Todavía no hay descripción para esta estructura anatómica." }, hierarchy: { title: "Jerarquía anatómica", eanatomy: { 1: "Anatomía humana 1", 2: "Anatomía humana 2", 3: "Anatomía humana en IMAIOS", 5: "Neuroanatomía humana" }, vetanatomy: { 4: "Anatomía animal" }, underlying: { none: "No hay estructuras subyacentes", title: "Estructuras subyacentes:" } }, translation: { title: "Traducción" }, "see-more": "Ver más", "see-less": "Ver menos", "related-terms": { "latin-synonym": "Sinónimo en latín:", "latin-eponym": "Epónimo en latín:", synonym: "Sinónimo:", eponym: "Epónimo:", acronym: "Acrónimo:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Términos relacionados:" }, compare: { animal: "Anatomía comparada en animales", human: "Anatomía comparada en humanos" } },
  "proxy-banner": { "update-config": 'Por favor, póngase en contacto con su responsable IT para actualizar la configuración del proxy. Puede facilitarle este <a target="_blank" href="%link%">artículo</a> y decirle que entre en contacto con nosotros si lo requiere.' }
}, G0 = { commons: `Une erreur est survenue, si l'erreur persiste veuillez nous contacter à l'adresse contact@imaios.com. 
Code d'erreur : {errorCode}`, title: "Erreur" }, j0 = { ok: "OK", cancel: "Annuler", "external-link-title": "Lien externe", "external-link-description": "Vous allez être redirigé vers le site internet d'IMAIOS.", input: { error: "Veuillez renseigner une valeur valide" } }, Y0 = { "no-results": "Aucun résultat", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, W0 = { "all-series": "Toutes les séries", "n-image-s": "{count} Images", series: "Séries" }, Z0 = { main: { "section-title": "Menu" }, filter: { "show-all-structures": "Afficher toutes les structures", "hide-all-structures": "Masquer toutes les structures", "section-title": "Structures anatomiques", "select-all": "Tout sélectionner", "show-hidden-structures": "Afficher les structures masquées", "show-all-overlays": "Afficher toutes les superpositions", "hide-all-overlays": "Masquer toutes les superpositions" }, contrast: { no_contrast_for_this_series: "Pas de contraste pour cette série" }, favorites: { title: "Favoris", add: "Ajouter aux favoris", "add-message": "Enregistrez cette vue dans vos favoris" }, transformation: { "section-title": "Transformations" }, series: { "section-title": "Séries", all: "Toutes les séries", more: "Plus", less: "Moins" }, legend: { "section-title": "Légendages", practice: "Entraînement", pins: "Épingles", viewzone: "Légendage limité", "min-font-size": "Taille de police minimum", "font-size": "Taille de police" }, display: { "section-title": "Mode d'affichage", description: "Panel description", "dark-mode": "Mode sombre", "overlays-opacity": "Opacité des superpositions", "high-quality": "Haute qualité", orientation: "Orientation", "hide-point-without-label": "Afficher/Masquer les points sans légende", "cross-references": "Afficher/Masquer les références croisées", screenshot: "Faire une capture d'écran" }, language: { "section-title": "Langue" }, "advanced-settings": { "section-title": "Paramètres avancés", "reset-settings": "Réinitialiser", "reverseScroll-settings": "Défilement inversé", "shortcuts-panel": "Afficher les raccourcis", share: { label: "Partager", copied: "Succès" } } }, X0 = { "not-found": "Il n'y a pas encore de description pour cette structure anatomique." }, Q0 = { "not-available": "Non disponible pour Internet Explorer", banner: { "upgrade-full-message": 'Veuillez utiliser un autre navigateur tel que <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> ou <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Certaines fonctionnalités ne sont pas supportées sur Internet Explorer", upgrade: "Veuillez utiliser un autre navigateur tel que", or: "ou" } }, K0 = { placeholder: "Rechercher dans ce module" }, q0 = { text: "Cette fonctionnalité nécessite un abonnement premium", button: { subscribe: "S'abonner", connect: "Se connecter" } }, J0 = { window: "Fenêtre", weightings: "Pondérations", default: "Contraste" }, ey = { loading: "Chargement..." }, ty = {
  error: G0,
  dialog: j0,
  commons: Y0,
  "context-menu": { zoom: "Zoom", pan: "Déplacer", scroll: "Défiler", "rotate-left": "Rotation antihoraire de 90°", "rotate-right": "Rotation horaire de 90°", "flip-horizontal": "Symétrie horizontale", "flip-vertical": "Symétrie verticale", reset: "Réinitialiser", viewzone: "Légendage limité", hide: "Masquer", show: "Afficher", toggleVisibility: "Afficher/masquer", "isolate-structure": "Isoler {param}", unselect: "Désélectionner {param}", select: "Sélectionner {param}", close: "Fermer", "show-cross-reference": "Afficher les références croisées", "hide-cross-reference": "Masquer les références croisées", "show-structure-information": "Afficher les informations sur la structure" },
  gallery: W0,
  menu: Z0,
  description: X0,
  "premium-banner": { "label-required-premium": "Un abonnement est requis pour débloquer toutes les fonctionnalités", subscribe: "S'abonner" },
  ie: Q0,
  search: K0,
  premium: q0,
  contrast: J0,
  "keyboard-panel": { title: "Raccourcis", "reverse-scroll": "Défilement inversé", viewzone: "Légendage limité", practice: "Entraînement", "toggle-overlays": "Afficher/masquer les superpositions", "hide-labels": "Afficher/Masquer labels", "show-hidden-structures": "Afficher les structures masquées", weightings: "Modalité", scroll: "Défiler", zoom: "Zoom", pan: "Déplacer", reset: "Réinitialiser", save: "Faire une capture d'écran", fullscreen: "Plein écran", "previous-image": "Image précédente", "next-image": "Image suivante", "previous-series": "Série précédente", "next-series": "Série suivante", cine: "Mode Cinéma" },
  loader: ey,
  "panel-structure": { "list-actions": { cancel_isolate: "Annuler isoler", isolate: "Isoler", hide: "Masquer", display: "Afficher", select: "Sélectionner", unselect: "Désélectionner" } },
  "anatomical-parts": { gallery: { title: "Galerie", "in-this-module": "Dans ce module", "in-other-modules": "Dans d'autres modules", "image-one": "1 image", "image-multiple": "{count} images", all: "Tous" }, description: { title: "Définition", "no-description": "Il n'y a pas encore de description pour cette structure anatomique." }, hierarchy: { title: "Hiérarchie anatomique", eanatomy: { 1: "Anatomie humaine 1", 2: "Anatomie humaine 2", 3: "Anatomie humaine IMAIOS", 5: "Neuroanatomie humaine" }, vetanatomy: { 4: "Anatomie animale" }, underlying: { none: "Aucune structure sous-jacente", title: "Structures sous-jacentes :" } }, translation: { title: "Traduction" }, "see-more": "Voir plus", "see-less": "Voir moins", "related-terms": { "latin-synonym": "Synonyme latin :", "latin-eponym": "Éponyme latin :", synonym: "Synonyme :", eponym: "Éponyme :", acronym: "Acronyme :", old_fr_nomenclature: "Ancienne nomenclature :", "related-term": "Terme associé :" }, compare: { animal: "Anatomie comparée chez l’animal", human: "Anatomie comparée chez l’homme" } },
  "proxy-banner": { "update-config": 'Vous devez contacter votre administrateur informatique pour mettre à jour la configuration du proxy. Vous pouvez leur fournir cet <a target="_blank" href="%link%">article</a> et leur dire de nous contacter si besoin.' }
}, sy = { commons: `Si è verificato un errore. Se il problema persiste, contattaci all'indirizzo contact@imaios.com. 
Codice errore: {errorCode}`, title: "Errore" }, iy = { ok: "OK", cancel: "Cancellare", "external-link-title": "Link esterno", "external-link-description": "Sarai reindirizzato al sito web di IMAIOS.", input: { error: "Immettere un valore valido" } }, ry = { "no-results": "Nessun risultato", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, ny = { "all-series": "Tutte le serie", "n-image-s": "{count} Immagini", series: "Serie" }, ay = { main: { "section-title": "Menu" }, filter: { "show-all-structures": "Mostra tutte le strutture", "hide-all-structures": "Nascondi tutte le strutture", "section-title": "Strutture anatomiche", "select-all": "Seleziona tutto", "show-hidden-structures": "Mostra le strutture nascoste", "show-all-overlays": "Mostra tutte le sovrapposizioni", "hide-all-overlays": "Nascondi tutte le sovrapposizioni" }, contrast: { no_contrast_for_this_series: "Nessun contrasto per questa serie" }, favorites: { title: "Preferiti", add: "Aggiungi ai preferiti", "add-message": "Salva questa vista nei preferiti" }, transformation: { "section-title": "Trasformazioni" }, series: { "section-title": "Serie", all: "Tutte le serie", more: "Più", less: "Meno" }, legend: { "section-title": "Didascalie", practice: "Esercitazione", pins: "Spille", viewzone: "Delimita le didascalie", "min-font-size": "Dimensione carattere minima", "font-size": "Dimensione carattere" }, display: { "section-title": "Modalità di visualizzazione", description: "Menù descrizione", "dark-mode": "Sfondo nero", "overlays-opacity": "Opacità delle sovrapposizioni", "high-quality": "Alta qualità", orientation: "Orientamento", "hide-point-without-label": "Mostra/nascondi i punti anatomici senza didascalia", "cross-references": "Mostra/nascondi i riferimenti incrociati", screenshot: "Acquisisci schermata" }, language: { "section-title": "Lingua" }, "advanced-settings": { "section-title": "Impostazioni avanzate", "reset-settings": "Ripristina impostazioni", "reverseScroll-settings": "Scorrimento inverso", "shortcuts-panel": "Mostra scorciatoie", share: { label: "Condividi", copied: "Copiato!" } } }, oy = { "not-found": "Non ci sono ancora descrizioni per questa struttura anatomica." }, ly = { "not-available": "Non disponibile per Internet Explorer", banner: { "upgrade-full-message": 'Si prega di usare un altro navigatore come  <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> or <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Alcune funzionalità non sono supportate su Internet Explorer", upgrade: "Si prega di usare un altro navigatore come", or: "o" } }, cy = { placeholder: "Cerca in questo modulo" }, uy = { text: "Questa funzionalità richiede abbonamento premium", button: { subscribe: "Abbonati", connect: "Accedi" } }, dy = { window: "Finestra", weightings: "Ponderazioni", default: "Contrasto" }, hy = { loading: "Caricamento in corso..." }, my = {
  error: sy,
  dialog: iy,
  commons: ry,
  "context-menu": { zoom: "Zoom", pan: "Muovere", scroll: "Scorrere", "rotate-left": "Ruota di 90° in senso antiorario", "rotate-right": "Ruota di 90° in senso orario", "flip-horizontal": "Capovolgi orizzontalmente", "flip-vertical": "Capovolgi verticalmente", reset: "Ripristina", viewzone: "Delimita le didascalie", hide: "Nascondere", show: "Esibire", "isolate-structure": "Isolare: {param}", unselect: "Deseleziona {param}", select: "Selezionare: {param}", close: "Chiudere", "show-structure-information": "Mostra informazioni struttura" },
  gallery: ny,
  menu: ay,
  description: oy,
  "premium-banner": { "label-required-premium": "L'abbonamento è richiesto per accedere a tutte le funzionalità", subscribe: "Abbonati" },
  ie: ly,
  search: cy,
  premium: uy,
  contrast: dy,
  "keyboard-panel": { title: "Scorciatoie", "reverse-scroll": "Scorrimento inverso", viewzone: "Delimita le didascalie", practice: "Esercitazione", "toggle-overlays": "Mostra/nascondi le sovrapposizioni", "hide-labels": "Mostra/nascondi didascalie", "show-hidden-structures": "Mostra le strutture nascoste", weightings: "Modalità", scroll: "Scorri", zoom: "Zoom", pan: "Sposta", reset: "Ripristina", save: "Screenshot", fullscreen: "Schermo intero", "previous-image": "Immagine precedente", "next-image": "Immagine successiva", "previous-series": "Serie precedente", "next-series": "Serie successiva", cine: "Lettura automatica" },
  loader: hy,
  "panel-structure": { "list-actions": { cancel_isolate: "Annulla isolamento", isolate: "Isola", hide: "Nascondi", display: "Mostra", select: "Seleziona", unselect: "Deseleziona" } },
  "anatomical-parts": { gallery: { title: "Galleria", "in-this-module": "In questo modulo", "in-other-modules": "In altri moduli", "image-one": "1 immagine", "image-multiple": "{count} immagini", all: "Tutti" }, description: { title: "Definizione", "no-description": "Non ci sono ancora descrizioni per questa struttura anatomica." }, hierarchy: { title: "Gerarchia anatomica", eanatomy: { 1: "Anatomia umana 1", 2: "Anatomia umana 2", 3: "Anatomia umana IMAIOS", 5: "Neuroanatomia umana" }, vetanatomy: { 4: "Anatomia animale" }, underlying: { none: "Non ci sono strutture sottostanti", title: "Strutture sottostanti:" } }, translation: { title: "Traduzione" }, "see-more": "Mostra altro", "see-less": "Mostra meno", "related-terms": { "latin-synonym": "Sinonimo latino:", "latin-eponym": "Eponimo latino:", synonym: "Sinonimo:", eponym: "Eponimo:", acronym: "Acronimo:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Termini correlati:" }, compare: { animal: "Anatomia comparata negli animali", human: "Anatomia comparata negli umani" } },
  "proxy-banner": { "update-config": 'Per favore, contatta il tuo amministratore IT per aggiornare la configurazione di proxy. Puoi fornire questo <a target="_blank" href="%link%">articolo</a> e chiedere di contattarci se necessario.' }
}, fy = { commons: `エラーが発生しました。問題が継続して発生する場合は、contact@imaios.comにお問い合わせください。
エラーコード：{errorCode}`, title: "エラー" }, py = { ok: "OK", cancel: "キャンセル", "external-link-title": "外部リンク", "external-link-description": "IMAIOSのウェブサイトへリダイレクトされます。", input: { error: "有効な値を入力してください" } }, gy = { "no-results": "結果なし", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, vy = { "all-series": "全シリーズ", "n-image-s": "{count}枚の画像", series: "シリーズ" }, yy = { main: { "section-title": "メニュー" }, filter: { "show-all-structures": "すべての構造を表示", "hide-all-structures": "すべての構造を非表示", "section-title": "解剖学的構造", "select-all": "全て選択", "show-hidden-structures": "非表示にした構造を表示", "show-all-overlays": "すべてのオーバーレイを表示", "hide-all-overlays": "すべてのオーバーレイを非表示" }, contrast: { no_contrast_for_this_series: "このシリーズでは造影画像はありません" }, favorites: { title: "お気に入り", add: "お気に入りに追加", "add-message": "この画像をお気に入りに保存します" }, transformation: { "section-title": "回転・反転" }, series: { "section-title": "シリーズ", all: "全シリーズ", more: "さらに表示", less: "非表示にする" }, legend: { "section-title": "ラベリング", practice: "クイズ", pins: "ピン", viewzone: "一部のみラベリング", "min-font-size": "最小フォントサイズ", "font-size": "フォントサイズ" }, display: { "section-title": "表示モード", description: "説明パネル", "dark-mode": "ダークモード", "overlays-opacity": "レイヤーの不透明度", "high-quality": "高画質", orientation: "方向", "hide-point-without-label": "ラベルなしで点のみ表示／非表示", "cross-references": "クロスレファレンスを表示／非表示", screenshot: "スクリーンショットを撮る" }, language: { "section-title": "言語" }, "advanced-settings": { "section-title": "詳細設定", "reset-settings": "設定をリセット", "reverseScroll-settings": "逆方向にスクロール", "shortcuts-panel": "ショートカットを表示", share: { label: "共有", copied: "成功" } } }, Ey = { "not-found": "この解剖学的構造にはまだ説明がありません。" }, Iy = { "not-available": "Internet Explorerではご利用いただけません", banner: { "upgrade-full-message": '<a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>や<a href="https://google.com/chrome/" target="_blank">Google Chrome</a>、<a href="https://getfirefox.com/" target="_blank">Firefox</a>など他のブラウザをご利用ください。', "features-not-available": "Internet Explorerではサポートされていない機能があります", upgrade: "以下の他のブラウザをご利用ください：", or: "または" } }, Cy = { placeholder: "検索" }, _y = { text: "この機能を利用するにはプレミアムサブスクリプションが必要です", button: { subscribe: "サブスクリプション", connect: "ログイン" } }, Ty = { window: "ウィンドウ", weightings: "強調画像", default: "造影画像" }, Sy = { loading: "ロード中..." }, by = {
  error: fy,
  dialog: py,
  commons: gy,
  "context-menu": { zoom: "ズーム", pan: "移動", scroll: "スクロール", "rotate-left": "反時計回りに90度回転", "rotate-right": "時計回りに90度回転", "flip-horizontal": "左右反転", "flip-vertical": "上下反転", reset: "リセット", viewzone: "一部のみラベリング", hide: "隠す", show: "表示", "isolate-structure": "{param}のみ表示", unselect: "{param}の選択を解除", select: "{param}を選択", close: "閉じる", "show-structure-information": "構造の情報を表示" },
  gallery: vy,
  menu: yy,
  description: Ey,
  "premium-banner": { "label-required-premium": "全ての機能を利用するにはサブスクリプションが必要です", subscribe: "サブスクリプション" },
  ie: Iy,
  search: Cy,
  premium: _y,
  contrast: Ty,
  "keyboard-panel": { title: "ショートカット", "reverse-scroll": "逆方向にスクロール", viewzone: "一部のみラベリング", practice: "クイズ", "toggle-overlays": "オーバーレイを表示/非表示", "hide-labels": "ラベルを表示／非表示", "show-hidden-structures": "非表示にした構造を表示", weightings: "モダリティ", scroll: "スクロール", zoom: "ズーム", pan: "移動", reset: "オリジナルビューにリセット", save: "スクリーンショット", fullscreen: "フルスクリーン", "previous-image": "前の画像", "next-image": "次の画像", "previous-series": "前のシリーズ", "next-series": "次のシリーズ", cine: "シネビュー" },
  loader: Sy,
  "panel-structure": { "list-actions": { cancel_isolate: "全ての構造を再表示", isolate: "この構造のみ表示", hide: "隠す", display: "表示", select: "選択", unselect: "選択を解除" } },
  "anatomical-parts": { gallery: { title: "ギャラリー", "in-this-module": "このモジュール内", "in-other-modules": "他のモジュール内", "image-one": "1枚の画像", "image-multiple": "{count}枚の画像", all: "全て" }, description: { title: "定義", "no-description": "この解剖学的構造にはまだ説明がありません。" }, hierarchy: { title: "解剖学的階層", eanatomy: { 1: "人体解剖学1", 2: "人体解剖学2", 3: "人体解剖学IMAIOS", 5: "人体神経解剖学" }, vetanatomy: { 4: "動物解剖学" }, underlying: { none: "下位構造はありません", title: "下位構造：" } }, translation: { title: "翻訳" }, "see-more": "詳細を見る", "see-less": "非表示にする", "related-terms": { "latin-synonym": "ラテン語での同義語：", "latin-eponym": "ラテン語でのエポニム：", synonym: "同義語:", eponym: "エポニム：", acronym: "頭字語：", old_fr_nomenclature: "Former nomenclature:", "related-term": "関連用語：" }, compare: { animal: "動物の比較解剖学", human: "人間の比較解剖学" } },
  "proxy-banner": { "update-config": 'IT管理者に連絡し、プロキシの設定を更新してください。IT管理者にはこの<a target="_blank" href="%link%">記事</a>を送信し、必要があれば弊社に問い合わせるようお伝えください。' }
}, Ay = { commons: `오류가 발생했습니다. 오류가 지속되면 contact@imaios.com으로 문의해 주세요.
오류 코드: {errorCode}`, title: "오류" }, wy = { ok: "확인", cancel: "취소", "external-link-title": "외부 링크", "external-link-description": "IMAIOS 웹사이트로 리디렉션됩니다.", input: { error: "유효한 값을 입력하십시오" } }, Ly = { "no-results": "결과 없음", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, Oy = { "all-series": "모든 시리즈", "n-image-s": "이미지 {count}개", series: "시리즈" }, My = { main: { "section-title": "메뉴" }, filter: { "show-all-structures": "모든 구조 보기", "hide-all-structures": "모든 구조 숨기기", "section-title": "해부학적 부위", "select-all": "모두 선택", "show-hidden-structures": "숨긴 구조 표시", "show-all-overlays": "모든 오버레이 표시", "hide-all-overlays": "모든 오버레이 숨기기" }, contrast: { no_contrast_for_this_series: "이 시리즈에는 조영상 없음" }, favorites: { title: "북마크", add: "북마크에 추가", "add-message": "이 보기를 즐겨찾기에 저장" }, transformation: { "section-title": "변환" }, series: { "section-title": "시리즈", all: "모든 시리즈", more: "더 보기", less: "덜 보기" }, legend: { "section-title": "라벨링", practice: "연습", pins: "핀", viewzone: "부분 라벨링", "min-font-size": "최소 글꼴 크기", "font-size": "글꼴 크기" }, display: { "section-title": "표시 모드", description: "설명 메뉴", "dark-mode": "다크 모드", "overlays-opacity": "오버레이 불투명도", "high-quality": "고품질", orientation: "방향", "hide-point-without-label": "라벨 없는 점 표시 및 숨기기", "cross-references": "상호 참조 표시/숨기기", screenshot: "스크린샷 촬영" }, language: { "section-title": "언어" }, "advanced-settings": { "section-title": "고급 설정", "reset-settings": "설정 초기화", "reverseScroll-settings": "스크롤 반전", "shortcuts-panel": "단축키 표시", share: { label: "공유", copied: "성공" } } }, Ny = { "not-found": "아직 이 해부학적 부위에 관한 설명이 없습니다." }, Ry = { "not-available": "Internet Explorer 미지원", banner: { "upgrade-full-message": '권장 브라우저: <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a>, <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Internet Explorer에서는 일부 기능이 지원되지 않습니다", upgrade: "권장 브라우저:", or: "또는" } }, xy = { placeholder: "검색" }, Dy = { text: "이 기능을 이용하려면 프리미엄 구독이 필요합니다", button: { subscribe: "구독하기", connect: "로그인" } }, Py = { window: "윈도우", weightings: "강조", default: "조영" }, ky = { loading: "불러오는 중..." }, Hy = {
  error: Ay,
  dialog: wy,
  commons: Ly,
  "context-menu": { zoom: "확대", pan: "팬", scroll: "스크롤", "rotate-left": "반시계 방향으로 90° 회전", "rotate-right": "시계 방향으로 90° 회전", "flip-horizontal": "수평으로 뒤집기", "flip-vertical": "수직으로 뒤집기", reset: "초기화", viewzone: "부분 표지", hide: "숨기기", show: "보기", "isolate-structure": "{param} 분리", unselect: "{param} 선택 해제", select: "{param} 선택", close: "닫기", "show-structure-information": "구조 정보 보기" },
  gallery: Oy,
  menu: My,
  description: Ny,
  "premium-banner": { "label-required-premium": "모든 기능을 잠금 해제하려면 구독이 필요합니다", subscribe: "구독하기" },
  ie: Ry,
  search: xy,
  premium: Dy,
  contrast: Py,
  "keyboard-panel": { title: "단축키", "reverse-scroll": "스크롤 반전", viewzone: "부분 표지", practice: "연습", "toggle-overlays": "오버레이 표시하기/숨기기", "hide-labels": "라벨 표시/숨김", "show-hidden-structures": "숨겨진 구조 표시하기", weightings: "모달리티", scroll: "스크롤", zoom: "확대", pan: "팬", reset: "재설정", save: "스크린샷", fullscreen: "전체 화면", "previous-image": "이전 이미지", "next-image": "다음 이미지", "previous-series": "이전 시리즈", "next-series": "다음 시리즈", cine: "cine" },
  loader: ky,
  "panel-structure": { "list-actions": { cancel_isolate: "분리 취소", isolate: "분리", hide: "숨기기", display: "표시하기", select: "선택", unselect: "선택 해제" } },
  "anatomical-parts": { gallery: { title: "갤러리", "in-this-module": "이 모듈에서", "in-other-modules": "다른 모듈에서", "image-one": "이미지 1개", "image-multiple": "이미지 {count}개", all: "모두" }, description: { title: "정의", "no-description": "아직 이 해부학적 부분에 관한 설명이 없습니다." }, hierarchy: { title: "해부학적 계층", eanatomy: { 1: "인체 해부학 1", 2: "인체 해부학 2", 3: "인체 해부학 IMAIOS", 5: "인체 신경 해부학" }, vetanatomy: { 4: "동물 해부학" }, underlying: { none: "기저 구조가 없습니다", title: "기저 구조:" } }, translation: { title: "번역" }, "see-more": "더 보기", "see-less": "덜 보기", "related-terms": { "latin-synonym": "라틴어 동의어:", "latin-eponym": "라틴어 시조:", synonym: "동의어:", eponym: "시조:", acronym: "약어", old_fr_nomenclature: "Former nomenclature:", "related-term": "관련 용어:" }, compare: { animal: "동물의 비교 해부학", human: "인간의 비교 해부학" } },
  "proxy-banner": { "update-config": '프록시 구성을 업데이트하려면 고객님의 IT 관리자에게 문의하세요. IT 관리자에게 <a target="_blank" href="%link%"> 이 글</a>을 보여주고, 도음이 필요하다면 저희 고객지원팀에 문의하라고 전해주시기 바랍니다.' }
}, Fy = { commons: `Wystąpił błąd, jeśli błąd będzie się powtarzał, prosimy o kontakt z nami pod adresem: contact@imaios.com.
Kod błędu: {errorCode}`, title: "Błąd" }, zy = { ok: "OK", cancel: "Anuluj", "external-link-title": "Link zewnętrzny", "external-link-description": "Nastąpi przekierowanie na stronę IMAIOS.", input: { error: "Wprowadź prawidłową wartość" } }, By = { "no-results": "Brak wyników", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, $y = { "all-series": "Wszystkie serie", "n-image-s": "{count} obrazy / obrazów", series: "Serie" }, Uy = { main: { "section-title": "Menu" }, filter: { "show-all-structures": "Pokaż wszystkie struktury", "hide-all-structures": "Ukryj wszystkie struktury", "section-title": "Części anatomiczne", "select-all": "Zaznacz wszystko", "show-hidden-structures": "Pokaż ukryte struktury", "show-all-overlays": "Pokaż wszystkie nakładki", "hide-all-overlays": "Ukryj wszystkie nakładki" }, contrast: { no_contrast_for_this_series: "Brak kontrastu dla tej serii" }, favorites: { title: "Zakładki", add: "Dodaj do zakładek", "add-message": "Zapisz ten widok w swoich zakładkach" }, transformation: { "section-title": "Zmiany" }, series: { "section-title": "Serie", all: "Wszystkie serie", more: "Więcej", less: "Mniej" }, legend: { "section-title": "Opisy", practice: "Ćwiczenia", pins: "Pinezki", viewzone: "Częściowe oznakowanie", "min-font-size": "Najmniejsza czcionka", "font-size": "Wielkość czcionki" }, display: { "section-title": "Tryb wyświetlania", description: "Menu opisowe", "dark-mode": "Motyw ciemny", "overlays-opacity": "Przezroczystość nakładki", "high-quality": "W wysokiej jakości", orientation: "Orientacja", "hide-point-without-label": "Pokaż/ukryj punkty anatomiczne bez etykiety", "cross-references": "Pokaż/ukryj odwołania zewnętrzne", screenshot: "Wykonaj zrzut ekranu" }, language: { "section-title": "Język" }, "advanced-settings": { "section-title": "Zaawansowane ustawienia", "reset-settings": "Zresetuj ustawienia", "reverseScroll-settings": "Zmiana kierunku przewijania", "shortcuts-panel": "Wyświetl skróty", share: { label: "Udostępnij", copied: "Operacja powiodła się" } } }, Vy = { "not-found": "Jeszcze brak opisu dla tej części anatomicznej." }, Gy = { "not-available": "Niedostępne w przeglądarce Internet Explorer", banner: { "upgrade-full-message": 'Skorzystaj z innej przeglądarki, np.: <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> lub <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Niektóre funkcje nie są dostępne w przeglądarce Internet Explorer", upgrade: "Użyj innej przeglądarki, np.", or: "lub" } }, jy = { placeholder: "Szukaj" }, Yy = { text: "Ta funkcja jest dostępna jedynie w subskrypcji premium", button: { subscribe: "Subskrybuj", connect: "Zarejestruj się" } }, Wy = { window: "Okno", weightings: "Pomiary", default: "Kontrast" }, Zy = { loading: "Ładowanie..." }, Xy = {
  error: Fy,
  dialog: zy,
  commons: By,
  "context-menu": { zoom: "Zoom", pan: "Przesuń obraz", scroll: "Przewinąć", "rotate-left": "Obrót o 90° przeciwnie do ruchu wskazówek zegara", "rotate-right": "Obrót o 90° zgodnie z ruchem wskazówek zegara", "flip-horizontal": "Obrót w poziomie", "flip-vertical": "Obrót w pionie", reset: "Zresetować", viewzone: "Częściowe oznakowanie", hide: "Ukryj", show: "Pokaż", "isolate-structure": "Wyizoluj: {param}", unselect: "Usuń zaznaczenie {param}", select: "Zaznacz: {param}", close: "Zamknij", "show-structure-information": "Pokaż informacje o strukturze" },
  gallery: $y,
  menu: Uy,
  description: Vy,
  "premium-banner": { "label-required-premium": "Do odblokowania niektórych funkcji niezbędna jest subskrypcja", subscribe: "Subskrybuj" },
  ie: Gy,
  search: jy,
  premium: Yy,
  contrast: Wy,
  "keyboard-panel": { title: "Skróty", "reverse-scroll": "Zmiana kierunku przewijania", viewzone: "Częściowe oznakowanie", practice: "Ćwiczenia", "toggle-overlays": "Pokaż/ukryj nakładki", "hide-labels": "Pokaż/ukryj etykiety", "show-hidden-structures": "Pokaż ukryte struktury", weightings: "Sposoby", scroll: "Przewinąć", zoom: "Zoom", pan: "Przesuń obraz", reset: "Zresetuj", save: "Zrzut ekranu", fullscreen: "Tryb pełnoekranowy", "previous-image": "Poprzedni obraz", "next-image": "Następny obraz", "previous-series": "Poprzednia seria", "next-series": "Następna seria", cine: "Tryb CINE" },
  loader: Zy,
  "panel-structure": { "list-actions": { cancel_isolate: "Anuluj wyodrębnienie", isolate: "Wyodrębnij", hide: "Ukryj", display: "Wyświetl", select: "Zaznacz", unselect: "Usuń zaznaczenie" } },
  "anatomical-parts": { gallery: { title: "Galeria", "in-this-module": "W tym module", "in-other-modules": "W innych modułach", "image-one": "1 zdjęcie", "image-multiple": "{count} zdjęć", all: "Wszystko" }, description: { title: "Definicja", "no-description": "Jeszcze brak opisu dla tej części anatomicznej." }, hierarchy: { title: "Hierarchia anatomiczna", eanatomy: { 1: "Anatomia człowieka 1", 2: "Anatomia człowieka 2", 3: "Anatomia człowieka IMAIOS", 5: "Neuroanatomia człowieka" }, vetanatomy: { 4: "Anatomia zwierząt" }, underlying: { none: "Brak powiązanej struktury", title: "Powiązane struktury:" } }, translation: { title: "Tłumaczenie" }, "see-more": "Pokaż więcej", "see-less": "Pokaż mniej", "related-terms": { "latin-synonym": "Synonim w języku łacińskim:", "latin-eponym": "Eponim łaciński:", synonym: "Synonim:", eponym: "Eponim:", acronym: "Akronim:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Powiązane terminy:" }, compare: { animal: "Porównawcza anatomia zwierząt", human: "Porównawcza anatomia człowieka" } },
  "proxy-banner": { "update-config": 'Skontaktuj się ze swoim administratorem IT, by zaktualizować konfigurację serwera proxy. Możesz przesłać mu ten <a target="_blank" href="%link%">artykuł</a> i zalecić, aby skontaktował się z nami w razie potrzeby.' }
}, Qy = { commons: `Um erro ocorreu, caso persista por favor entre em contato conosco em contact@imaios.com.
Código do erro: {errorCode}`, title: "Erro" }, Ky = { ok: "OK", cancel: "Cancelar", "external-link-title": "Link externo", "external-link-description": "Você será redirecionado para o site IMAIOS.", input: { error: "Por favor insira um valor válido" } }, qy = { "no-results": "Nenhum resultado encontrado", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, Jy = { "all-series": "Todas as séries", "n-image-s": "{count} Imagens", series: "Séries" }, eE = { main: { "section-title": "Menu" }, filter: { "show-all-structures": "Mostrar todas as estruturas", "hide-all-structures": "Ocultar todas as estruturas", "section-title": "Estruturas anatômicas", "select-all": "Selecionar tudo", "show-hidden-structures": "Mostrar estruturas ocultas", "show-all-overlays": "Mostrar todas as sobreposições", "hide-all-overlays": "Ocultar todas as sobreposições" }, contrast: { no_contrast_for_this_series: "Não há contraste para esta série" }, favorites: { title: "Favoritos", add: "Adicionar aos favoritos", "add-message": "Salvar esta visualização nos favoritos" }, transformation: { "section-title": "Transformações" }, series: { "section-title": "Séries", all: "Todas as séries", more: "Mais", less: "Menos" }, legend: { "section-title": "Legendas", practice: "Modo quiz", pins: "Marcadores", viewzone: "Legendas parciais", "min-font-size": "Tamanho mínimo da fonte", "font-size": "Tamanho da fonte" }, display: { "section-title": "Modo de exibição", description: "Menu descrição", "dark-mode": "Tema escuro", "overlays-opacity": "Opacidade dos calcos", "high-quality": "Alta resolução", orientation: "Orientação", "hide-point-without-label": "Mostrar/ocultar pontos anatômicos sem legenda", "cross-references": "Mostrar/ocultar referências cruzadas", screenshot: "Tirar um screenshot" }, language: { "section-title": "Idioma" }, "advanced-settings": { "section-title": "Configurações avançadas", "reset-settings": "Reiniciar configurações", "reverseScroll-settings": "Modo invertido", "shortcuts-panel": "Mostrar atalhos", share: { label: "Compartilhar", copied: "Sucesso" } } }, tE = { "not-found": "Ainda não há descrição para esta estrutura anatômica." }, sE = { "not-available": "Indisponível para Internet Explorer", banner: { "upgrade-full-message": 'Por favor use outro navegador internet como <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>,<a href="https://google.com/chrome/" target="_blank">Google Chrome</a>ou<a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Alguns recursos são incompatíveis com Internet Explorer", upgrade: "Por favor utilize outro navegador como", or: "ou" } }, iE = { placeholder: "Buscar" }, rE = { text: "Este recurso requer uma assinatura premium", button: { subscribe: "Assinar", connect: "Conectar-se" } }, nE = { window: "Janela", weightings: "Ponderações", default: "Contraste" }, aE = { loading: "Carregando..." }, oE = {
  error: Qy,
  dialog: Ky,
  commons: qy,
  "context-menu": { zoom: "Zoom", pan: "Deslocar", scroll: "Percorrer", "rotate-left": "Girar 90° no sentido anti-horário", "rotate-right": "Girar 90° no sentido horário", "flip-horizontal": "Girar na horizontal", "flip-vertical": "Girar na vertical", reset: "Reiniciar", viewzone: "Legendas parciais", hide: "Ocultar", show: "Exibir", "isolate-structure": "Isolar {param}", unselect: "Anular selecção {param}", select: "Selecionar {param}", close: "Fechar", "show-structure-information": "Mostrar as informações da estrutura" },
  gallery: Jy,
  menu: eE,
  description: tE,
  "premium-banner": { "label-required-premium": "Uma assinatura é necessária para desbloquear todos os recursos", subscribe: "Assinar" },
  ie: sE,
  search: iE,
  premium: rE,
  contrast: nE,
  "keyboard-panel": { title: "Atalhos", "reverse-scroll": "Modo invertido", viewzone: "Legendas parciais", practice: "Modo quiz", "toggle-overlays": "Mostrar/ocultar sobreposições", "hide-labels": "Mostrar/ocultar legendas", "show-hidden-structures": "Mostrar estruturas ocultas", weightings: "Modalidade", scroll: "Percorrer", zoom: "Zoom", pan: "Deslocar", reset: "Reiniciar", save: "Captura de tela", fullscreen: "Tela cheia", "previous-image": "Imagem anterior", "next-image": "Próxima imagem", "previous-series": "Série anterior", "next-series": "Próxima série", cine: "Filme" },
  loader: aE,
  "panel-structure": { "list-actions": { cancel_isolate: 'Cancelar função "Isolar"', isolate: "Isolar", hide: "Ocultar", display: "Mostrar", select: "Selecionar", unselect: "Anular selecção" } },
  "anatomical-parts": { gallery: { title: "Galeria", "in-this-module": "Neste módulo", "in-other-modules": "Em outros módulos", "image-one": "1 imagem", "image-multiple": "{count} imagens", all: "Todos" }, description: { title: "Definição", "no-description": "Ainda não há descrição para esta parte anatômica." }, hierarchy: { title: "Hierarquia anatômica", eanatomy: { 1: "Anatomia humana 1", 2: "Anatomia humana 2", 3: "Anatomia humana IMAIOS", 5: "Neuroanatomia humana" }, vetanatomy: { 4: "Anatomia animal" }, underlying: { none: "Não há nenhuma estrutura subjacente", title: "Estruturas subjacentes:" } }, translation: { title: "Tradução" }, "see-more": "Ver mais", "see-less": "Ver menos", "related-terms": { "latin-synonym": "Sinônimo em latim:", "latin-eponym": "Epônimo em latim:", synonym: "Sinônimo:", eponym: "Epônimo:", acronym: "Acrônimo:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Termos relacionados:" }, compare: { animal: "Anatomia comparativa em animais", human: "Anatomia comparativa em humanos" } },
  "proxy-banner": { "update-config": 'Entre em contato com seu gerente de TI para atualizar as configurações do proxy. Pode compartilhar este <a target="_blank" href="%link%">artigo</a> e sugerir que entre em contato conosco, se precisar.' }
}, lE = { commons: `Произошла ошибка. Если проблему решить не удалось, свяжитесь с нами по электронной почте contact@imaios.com.
Код ошибки: {errorCode}`, title: "Ошибка" }, cE = { ok: "OK", cancel: "Отменить", "external-link-title": "Внешняя ссылка", "external-link-description": "Вы будете перенаправлены на веб-сайт IMAIOS.", input: { error: "Пожалуйста, введите корректное значение" } }, uE = { "no-results": "Результатов не найдено", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, dE = { "all-series": "Все серии", "n-image-s": "Количество изображений: {count}", series: "Серии" }, hE = { main: { "section-title": "Меню" }, filter: { "show-all-structures": "Показать все структуры", "hide-all-structures": "Скрыть все структуры", "section-title": "Анатомические структуры", "select-all": "Выбрать все", "show-hidden-structures": "Показать скрытые структуры", "show-all-overlays": "Показать все оверлеи", "hide-all-overlays": "Скрыть все оверлеи" }, contrast: { no_contrast_for_this_series: "Серия без применения контрастного вещества" }, favorites: { title: "Закладки", add: "Добавить в избранное", "add-message": "Сохраните этот вид в своих закладках" }, transformation: { "section-title": "Преобразования" }, series: { "section-title": "Серии", all: "Все серии", more: "Больше", less: "Меньше" }, legend: { "section-title": "Обозначение анатомических структур", practice: "Проверка знаний", pins: "Маркеры", viewzone: "Анатомические структуры в ограниченной области", "min-font-size": "Минимальный размер шрифта", "font-size": "Размер шрифта" }, display: { "section-title": "Режим просмотра", description: "Показать описание", "dark-mode": "Темная тема", "overlays-opacity": "Прозрачность цветных наложений", "high-quality": "Высокое качество", orientation: "Ориентация", "hide-point-without-label": "Показать/cкрыть точки, обозначающие анатомические структуры", "cross-references": "Показать/скрыть перекрестные ссылки", screenshot: "Сделать скриншот" }, language: { "section-title": "Язык" }, "advanced-settings": { "section-title": "Дополнительные настройки", "reset-settings": "Сброс настроек", "reverseScroll-settings": "Обратная прокрутка", "shortcuts-panel": "Показать горячие клавиши", share: { label: "Поделиться", copied: "Успешно" } } }, mE = { "not-found": "Пока еще нет описания к этой анатомической структуре." }, fE = { "not-available": "Недоступно в Internet Explorer", banner: { "upgrade-full-message": 'Пожалуйста, используйте другой браузер, например  <a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> или <a href="https://getfirefox.com/" target="_blank">Firefox</a>.', "features-not-available": "Некоторые функции не поддерживаются в Internet Explorer", upgrade: "Пожалуйста, используйте другой браузер, например", or: "или" } }, pE = { placeholder: "Поиск" }, gE = { text: "Для этой функции требуется премиум-подписка", button: { subscribe: "Подписаться", connect: "Войти" } }, vE = { window: "Окно", weightings: "Режимы", default: "Контраст" }, yE = { loading: "Загрузка..." }, EE = {
  error: lE,
  dialog: cE,
  commons: uE,
  "context-menu": { zoom: "Масштаб", pan: "Переместить", scroll: "Прокрутка", "rotate-left": "Поворот на 90° против часовой стрелки", "rotate-right": "Поворот на 90° по часовой стрелке", "flip-horizontal": "Отразить горизонтально", "flip-vertical": "Отразить вертикально", reset: "Перезагрузить", viewzone: "Анатомические структуры в ограниченной области", hide: "Скрыть", show: "Показать", "isolate-structure": "Выделить: {param}", unselect: "Снять выделение {param}", select: "Выбрать: {param}", close: "Закрыть", "show-structure-information": "Показать информацию о структуре" },
  gallery: dE,
  menu: hE,
  description: mE,
  "premium-banner": { "label-required-premium": "Требуется подписка", subscribe: "Подписаться" },
  ie: fE,
  search: pE,
  premium: gE,
  contrast: vE,
  "keyboard-panel": { title: "Горячие клавиши", "reverse-scroll": "Обратная прокрутка", viewzone: "Ограничить область просмотра", practice: "Проверка знаний", "toggle-overlays": "Показать/скрыть оверлеи", "hide-labels": "Показать/скрыть выноски", "show-hidden-structures": "Показать скрытые структуры", weightings: "Метод", scroll: "Cвиток", zoom: "Масштаб", pan: "Переехать", reset: "Cбросить настройки", save: "Скриншот", fullscreen: "Полноэкранный режим", "previous-image": "Предыдущее изображение", "next-image": "Следующее изображение", "previous-series": "Предыдущая серия", "next-series": "Следующая серия", cine: "Видео-режим" },
  loader: yE,
  "panel-structure": { "list-actions": { cancel_isolate: "Отменить режим изоляции", isolate: "Изолировать", hide: "Скрыть", display: "Отобразить", select: "Выбрать", unselect: "Отменить выделение" } },
  "anatomical-parts": { gallery: { title: "Галерея", "in-this-module": "В этом модуле", "in-other-modules": "В других модулях", "image-one": "Изображение: 1", "image-multiple": "количество изображений: {count}", all: "Все" }, description: { title: "Определение", "no-description": "Пока еще нет описания к этой анатомической структуре." }, hierarchy: { title: "Анатомическая иерархия", eanatomy: { 1: "Анатомия человека 1", 2: "Анатомия человека 2", 3: "Анатомия человека IMAIOS", 5: "Нейроанатомия человека" }, vetanatomy: { 4: "Анатомия животных" }, underlying: { none: "Нет никакой основной структуры", title: "Основные структуры:" } }, translation: { title: "Перевод" }, "see-more": "Показать больше", "see-less": "Показать меньше", "related-terms": { "latin-synonym": "Синоним на латинском языке:", "latin-eponym": "Эпоним на латинском языке:", synonym: "Синоним:", eponym: "Эпоним:", acronym: "Аббревиатура:", old_fr_nomenclature: "Former nomenclature:", "related-term": "Связанные термины:" }, compare: { animal: "Сравнительная анатомия животных", human: "Сравнительная анатомия человека" } },
  "proxy-banner": { "update-config": 'Обратитесь к своему ИТ-администратору для обновления конфигурации прокси-сервера. Вы можете предоставить ему эту <a target="_blank" href="%link%">статью</a> и сообщить, что можно связаться с нами при необходимости.' }
}, IE = { commons: `发生错误，如果错误仍然存在，请透过contact@imaios.com联系我们。
错误代码：{errorCode}`, title: "错误" }, CE = { ok: "好", cancel: "取消", "external-link-title": "外部链接", "external-link-description": "您将被重定向到IMAIOS网站。", input: { error: "请输入有效值" } }, _E = { "no-results": "没有结果", "e-anatomy": "e-Anatomy", "vet-anatomy": "vet-Anatomy" }, TE = { "all-series": "所有系列", "n-image-s": "{count} 图片", series: "系列" }, SE = { main: { "section-title": "目录" }, filter: { "show-all-structures": " 显示所有结构", "hide-all-structures": "隐藏所有结构", "section-title": "解剖结构", "select-all": "选择所有", "show-hidden-structures": "显示已隐藏结构", "show-all-overlays": "显示所有叠加", "hide-all-overlays": "隐藏所有叠加" }, contrast: { no_contrast_for_this_series: "此系列没有对比选项" }, favorites: { title: "书签", add: "加入书签", "add-message": "将此图片保存到您的书签" }, transformation: { "section-title": "转换" }, series: { "section-title": "系列", all: "所有系列", more: "更多", less: "更少" }, legend: { "section-title": "标记", practice: "测验", pins: "大头针", viewzone: "局部标签", "min-font-size": "最小字体", "font-size": "字体大小" }, display: { "section-title": "显示模式", description: "菜单描述", "dark-mode": "夜间模式", "overlays-opacity": "覆盖不透明度", "high-quality": "高画质", orientation: "方向", "hide-point-without-label": "显示/隐藏标记点", "cross-references": "显示/隐藏交叉参考", screenshot: "屏幕截图" }, language: { "section-title": "语言" }, "advanced-settings": { "section-title": "进阶设定", "reset-settings": "重新设置", "reverseScroll-settings": "反向滚动", "shortcuts-panel": "显示快捷方式", share: { label: "分享", copied: "成功" } } }, bE = { "not-found": "暂没关于此解剖部分的描述" }, AE = { "not-available": "不适用于 Internet Explorer", banner: { "upgrade-full-message": '请使用其他浏览器，例如<a href="https://www.microsoft.com/edge" target="_blank">Microsoft Edge</a>, <a href="https://google.com/chrome/" target="_blank">Google Chrome</a> 或 <a href="https://getfirefox.com/" target="_blank">Firefox</a>', "features-not-available": "Internet Explorer 不支持某些功能", upgrade: "请使用其他浏览器，例如", or: "或" } }, wE = { placeholder: "搜寻" }, LE = { text: "此功能需要付费订阅", button: { subscribe: "订购", connect: "登录" } }, OE = { window: "窗口", weightings: "加权", default: "对比" }, ME = { loading: "下载中..." }, NE = {
  error: IE,
  dialog: CE,
  commons: _E,
  "context-menu": { zoom: "放大", pan: "拖动", scroll: "滚动", "rotate-left": "逆时针旋转 90°", "rotate-right": "顺时针旋转 90°", "flip-horizontal": "水平翻转", "flip-vertical": "垂直翻转", reset: "重设", viewzone: "局部标签", hide: "隐藏", show: "显示", "isolate-structure": "隐藏{param}", unselect: "取消选择{param}", select: "选择: {param}", close: "关闭", "show-structure-information": "显示结构信息" },
  gallery: TE,
  menu: SE,
  description: bE,
  "premium-banner": { "label-required-premium": "需要订阅才能解锁所有功能", subscribe: "订购" },
  ie: AE,
  search: wE,
  premium: LE,
  contrast: OE,
  "keyboard-panel": { title: "快捷方式", "reverse-scroll": "反向滚动", viewzone: "局部标签", practice: "测验", "toggle-overlays": "显示/隐藏叠加", "hide-labels": "显示/隐藏标签", "show-hidden-structures": "显示已隐藏结构", weightings: "模式", scroll: "滚动", zoom: "放大", pan: "拖动", reset: "重设", save: "截图", fullscreen: "全屏幕", "previous-image": "上一张图片", "next-image": "下一张图片", "previous-series": "上一个系列", "next-series": "下一个系列", cine: "连续播放" },
  loader: ME,
  "panel-structure": { "list-actions": { cancel_isolate: "取消隐藏", isolate: "隐藏", hide: "隐藏", display: "显示", select: "选取", unselect: "取消选取" } },
  "anatomical-parts": { gallery: { title: "图片集", "in-this-module": "在这个单元", "in-other-modules": "在其他单元", "image-one": "1 图像", "image-multiple": "{count} 图片", all: "全部" }, description: { title: "定义", "no-description": "暂没关于此解剖部分的描述" }, hierarchy: { title: "解剖层次", eanatomy: { 1: "人体解剖学1", 2: "人体解剖学2", 3: "人体解剖学IMAIOS", 5: "人体神经解剖学" }, vetanatomy: { 4: "动物解剖" }, underlying: { none: "没有底层结构", title: "底层结构：" } }, translation: { title: "翻译" }, "see-more": "查看更多", "see-less": "查看更少", "related-terms": { "latin-synonym": "拉丁语近义词：", "latin-eponym": "拉丁名祖：", synonym: "同义词：", eponym: "命名学:", acronym: "首字母缩略词：", old_fr_nomenclature: "Former nomenclature:", "related-term": "相关用语:" }, compare: { animal: "动物的比较解剖学", human: "人類的比较解剖学" } },
  "proxy-banner": { "update-config": '请联系您的 IT 管理员更新代理配置。您可以向他们提供此<a target="_blank" href="%link%">文章</a>，并告诉他们在必要时跟我们联系。' }
};
tt.use(mr);
const RE = new mr({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    de: E0,
    en: N0,
    es: V0,
    fr: ty,
    it: my,
    ja: by,
    ko: Hy,
    pl: Xy,
    pt: oE,
    ru: EE,
    zh: NE
  }
}), xE = {
  inserted: (s) => {
    function e() {
      const r = Array.from(s.children).find(
        (n) => n.nodeName === "IMG"
      );
      r && (r.addEventListener(
        "load",
        () => s.classList.add("loaded")
      ), r.src = r.dataset.url);
    }
    function t(r, n) {
      r.forEach((a) => {
        a.isIntersecting && (e(), n.unobserve(s));
      });
    }
    function i() {
      new IntersectionObserver(
        t,
        {
          root: null,
          threshold: 0
        }
      ).observe(s);
    }
    window.IntersectionObserver ? i() : e();
  }
}, DE = "2.15.3";
class lt {
  static getImaiosCodeV2(e) {
    return Object.keys(Gi).includes(e) ? Gi[e] : e;
  }
  static parseUserAgent() {
    return Cn(navigator.userAgent);
  }
  static buildErrorData(e, t, i, r, n, a, o, l = !1) {
    const c = {
      // Common parameters
      timestamp: Date.now(),
      error_message: i,
      stack_trace: r,
      user_id: h.getUserId() !== fs ? h.getUserId() : null,
      application_info: {
        "user-agent": navigator.userAgent,
        "application-version": DE,
        "application-id": a,
        "site-access": h.getSiteAccess(),
        "package-name": "viewer-anatomy"
        // TODO: do a difference if it's china or world ???
      },
      // Parameters specific for web
      component_name: o,
      error_from: e,
      module: n,
      error_type: t
    }, u = lt.parseUserAgent();
    return typeof u.browser.major < "u" && delete u.browser.major, l ? (c.browser_name = u.browser?.name ?? null, c.browser_version = u.browser?.version ?? null, c.os_name = u.os?.name ?? null, c.os_version = u.os?.version ?? null) : (c.application_info.browser = u.browser, c.application_info.os = u.os, c.application_info.page_url = window.location?.href ?? null), c;
  }
  static sendError(e, t, i, r, n, a, o) {
    const l = lt.buildErrorData(e, t, i, r, n, a, o);
    F.fetch("https://ohbdukzg7jje4gelvm6zkprom40qzqey.lambda-url.eu-west-3.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": window.location.origin
      },
      mode: "cors",
      body: JSON.stringify(l)
    }).catch(() => {
    });
  }
}
class ot {
  constructor(e, t) {
    this.data = {
      application_id: e,
      moduleName: t
    };
  }
  /**
   * Get newrelic agent if exist
   * @returns {NewRelicAgent|null}
   */
  get newrelicAgent() {
    return typeof window.NREUM < "u" ? window.NREUM : typeof window.newrelic < "u" ? window.newrelic : null;
  }
  static parseStackTrace(e) {
    let t = e.split(`
`);
    t = t.map((a) => a.trim()).filter((a) => a);
    const i = t.shift().split(":"), r = i[0].trim(), n = i.length > 1 ? i[1].trim() : "";
    return {
      errorType: r,
      errorMessage: n
    };
  }
  sendError(e, t, i, r, n, a = null) {
    const o = lt.buildErrorData(
      t,
      null,
      null,
      null,
      lt.getImaiosCodeV2(this.data.moduleName),
      this.data.application_id,
      a,
      !0
    );
    ot.isUnwantedError(o) || (lt.sendError(
      t,
      i,
      r,
      n,
      lt.getImaiosCodeV2(this.data.moduleName),
      this.data.application_id,
      a
    ), this.newrelicAgent?.noticeError?.(e, o));
  }
  static isUnwantedError(e) {
    return ot.isAbortError(e) || ot.isBot(e);
  }
  static isBot(e) {
    return e.application_info["user-agent"].includes("bot") || e.application_info["user-agent"].includes("Baiduspider");
  }
  static isAbortError(e) {
    return e.error_type?.includes("AbortError") || /The operation was aborted/i.test(e.error_message);
  }
  /**
   * @param {{error: Error, vm: Vue<Record<string, any>, Record<string, any>, never, never, (event: string, ...args: any[]) => Vue>}} vueError
   */
  sendVueError(e) {
    if (!e?.error?.stack)
      return;
    const { errorType: t, errorMessage: i } = ot.parseStackTrace(e.error.stack), r = e.vm.$vnode.componentOptions.tag;
    this.sendError(
      e.error,
      z.errors.VUE_ERROR,
      t,
      i,
      e.error.stack,
      r
    );
  }
  /**
   *
   * @param {Error|CoreError} error
   */
  sendCoreError(e) {
    if (e === void 0 || e.from === void 0 && e.stack === void 0 || e.from !== void 0 && e.error === null)
      return;
    const t = e.from ? e.error : e, { errorType: i, errorMessage: r } = ot.parseStackTrace(t.stack);
    this.sendError(
      t,
      e?.from ?? z.errors.CORE_ERROR,
      i,
      r,
      t.stack
    );
  }
  sendApplicationError(e, t) {
    this.sendError(
      e,
      `${k.EVENT.ERROR}--code-${t}`,
      e.name,
      e.message,
      e.stack
    );
  }
}
window.addEventListener("pageshow", (s) => {
  (s.persisted || typeof window.performance < "u" && window.performance.getEntriesByType("navigation").some((e) => e.type === jn)) && window.location.reload();
});
typeof window.imaios.pubsub < "u" && window.imaios.pubsub.subscribe(window.imaios.pubsub, Yn, (s) => {
  h.setUserId(s);
});
h.store = pn;
tt.config.productionTip = !1;
tt.use(De);
tt.directive("lazy-load-image", xE);
function PE(s) {
  return typeof s == "string" && s.length > 0;
}
function kE(s) {
  return typeof s == "string" && s.length > 0;
}
function HE(s, e) {
  if (!h.isEmbed()) {
    const t = new ot(s, e);
    h.errorHandler = t, tt.config.errorHandler = (i, r) => {
      const n = {
        error: i,
        vm: r
      };
      t.sendVueError(n), console.error(i);
    }, window.addEventListener("error", ({ error: i }) => {
      i instanceof DOMException || (t.sendCoreError(i, !1), console.error(i));
    });
  }
}
window.IMAIOS_ANATOMY = {
  async startViewer({
    containerSelector: s,
    moduleName: e = null,
    language: t = null,
    apiKey: i = null,
    userId: r = null,
    token: n = null,
    timestamp: a = null,
    application: o = null,
    baseURL: l = "",
    imageBaseURL: c = null,
    key: u = "",
    keyIV: m = "",
    applicationHomepageUrl: g = "",
    subscribeUrl: C = "",
    loginUrl: I = ""
  }) {
    h.isIMAIOSDomain() || (F.baseURL = l), c !== null && (F.imageBaseURL = c), h.url.subscribe = C !== "" ? C : window.imaios.get("subscribe_url"), h.url.login = I !== "" ? I : window.imaios.get("login_url"), h.url.applicationHomepage = g !== "" ? g : window.imaios.get("application_homepage_url"), u !== "" && m !== "" ? (h.key = u, h.keyIV = m) : (h.key = window.imaios.get(window.imaios.sha256("key_encryption")), h.keyIV = window.imaios.get(window.imaios.sha256("key_encryption_iv"))), h.siteAccess = t !== null ? h.transformLocalToSiteAccess(t) : h.getSiteAccess(), F.apiKey = i, h.isEmbedded = i !== null;
    const p = document.querySelector(s);
    if (p === null)
      throw new dn(s);
    e === null && (e = p.getAttribute("data-module-name")), e = e.replace(/_v\d+/, ""), o === null && (o = p.getAttribute("data-application"));
    let T = p.getAttribute("data-title");
    if (!(PE(o) && kE(T)) || !h.isIMAIOSDomain())
      try {
        const d = await F.getDataModule(e, o, h.siteAccess);
        o = d.application, T = d.title;
      } catch (d) {
        console.error(d);
      }
    F.apiKey !== null && (await F.setAPIClientInfo(r, n, a), F.scholarlyiq_id !== null && window.imaios.pubsub.publish("anatomy-institution", {
      module: e,
      scholarlyiq_id: F.scholarlyiqId,
      application: o,
      client_id: F.APIClientId
    })), HE(o, e);
    const v = Ut(s);
    try {
      h.id = v, new tt({
        store: pn,
        i18n: RE,
        render: (d) => d(ng, {
          props: {
            moduleId: e,
            application: o,
            title: T,
            id: v,
            language: h.siteAccess
          }
        })
      }).$mount(s);
    } catch (d) {
      h.errorHandler.sendCoreError(d), console.error(d);
    }
  }
};
//# sourceMappingURL=anatomy-china.js.map
